// This is an auto-generated file. Do not edit!

// Path: model/attributes/address.json

/**
 * The destination hostname or IP address for a TCP connection. `address`
 *
 * Attribute Value Type: `string` {@link ADDRESS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SERVER_ADDRESS} `server.address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link NET_HOST_NAME} `net.host.name`, {@link HTTP_HOST} `http.host`, {@link SERVER_NAME} `server_name`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead - Old namespace-less attribute, to be replaced with server.address for span-first future
 * @example "example.com"
 */
export const ADDRESS = 'address';

/**
 * Type for {@link ADDRESS} address
 */
export type ADDRESS_TYPE = string;

// Path: model/attributes/ai/ai__citations.json

/**
 * References or sources cited by the AI model in its response. `ai.citations`
 *
 * Attribute Value Type: `Array<string>` {@link AI_CITATIONS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example ["Citation 1","Citation 2"]
 */
export const AI_CITATIONS = 'ai.citations';

/**
 * Type for {@link AI_CITATIONS} ai.citations
 */
export type AI_CITATIONS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__completion_tokens__used.json

/**
 * The number of tokens used to respond to the message. `ai.completion_tokens.used`
 *
 * Attribute Value Type: `number` {@link AI_COMPLETION_TOKENS_USED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_OUTPUT_TOKENS} `gen_ai.usage.output_tokens`, {@link GEN_AI_USAGE_COMPLETION_TOKENS} `gen_ai.usage.completion_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_OUTPUT_TOKENS} (gen_ai.usage.output_tokens) instead
 * @example 10
 */
export const AI_COMPLETION_TOKENS_USED = 'ai.completion_tokens.used';

/**
 * Type for {@link AI_COMPLETION_TOKENS_USED} ai.completion_tokens.used
 */
export type AI_COMPLETION_TOKENS_USED_TYPE = number;

// Path: model/attributes/ai/ai__documents.json

/**
 * Documents or content chunks used as context for the AI model. `ai.documents`
 *
 * Attribute Value Type: `Array<string>` {@link AI_DOCUMENTS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example ["document1.txt","document2.pdf"]
 */
export const AI_DOCUMENTS = 'ai.documents';

/**
 * Type for {@link AI_DOCUMENTS} ai.documents
 */
export type AI_DOCUMENTS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__finish_reason.json

/**
 * The reason why the model stopped generating. `ai.finish_reason`
 *
 * Attribute Value Type: `string` {@link AI_FINISH_REASON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_FINISH_REASONS} `gen_ai.response.finish_reasons`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_FINISH_REASONS} (gen_ai.response.finish_reasons) instead
 * @example "COMPLETE"
 */
export const AI_FINISH_REASON = 'ai.finish_reason';

/**
 * Type for {@link AI_FINISH_REASON} ai.finish_reason
 */
export type AI_FINISH_REASON_TYPE = string;

// Path: model/attributes/ai/ai__frequency_penalty.json

/**
 * Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation. `ai.frequency_penalty`
 *
 * Attribute Value Type: `number` {@link AI_FREQUENCY_PENALTY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_FREQUENCY_PENALTY} `gen_ai.request.frequency_penalty`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_FREQUENCY_PENALTY} (gen_ai.request.frequency_penalty) instead
 * @example 0.5
 */
export const AI_FREQUENCY_PENALTY = 'ai.frequency_penalty';

/**
 * Type for {@link AI_FREQUENCY_PENALTY} ai.frequency_penalty
 */
export type AI_FREQUENCY_PENALTY_TYPE = number;

// Path: model/attributes/ai/ai__function_call.json

/**
 * For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls `ai.function_call`
 *
 * Attribute Value Type: `string` {@link AI_FUNCTION_CALL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_NAME} `gen_ai.tool.name`, {@link MCP_TOOL_NAME} `mcp.tool.name`
 *
 * @deprecated Use {@link GEN_AI_TOOL_NAME} (gen_ai.tool.name) instead
 * @example "function_name"
 */
export const AI_FUNCTION_CALL = 'ai.function_call';

/**
 * Type for {@link AI_FUNCTION_CALL} ai.function_call
 */
export type AI_FUNCTION_CALL_TYPE = string;

// Path: model/attributes/ai/ai__generation_id.json

/**
 * Unique identifier for the completion. `ai.generation_id`
 *
 * Attribute Value Type: `string` {@link AI_GENERATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_ID} `gen_ai.response.id`, {@link AI_RESPONSE_ID} `ai.response.id`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_ID} (gen_ai.response.id) instead
 * @example "gen_123abc"
 */
export const AI_GENERATION_ID = 'ai.generation_id';

/**
 * Type for {@link AI_GENERATION_ID} ai.generation_id
 */
export type AI_GENERATION_ID_TYPE = string;

// Path: model/attributes/ai/ai__input_messages.json

/**
 * The input messages sent to the model `ai.input_messages`
 *
 * Attribute Value Type: `string` {@link AI_INPUT_MESSAGES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_MESSAGES} `gen_ai.request.messages`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead
 * @example "[{\"role\": \"user\", \"message\": \"hello\"}]"
 */
export const AI_INPUT_MESSAGES = 'ai.input_messages';

/**
 * Type for {@link AI_INPUT_MESSAGES} ai.input_messages
 */
export type AI_INPUT_MESSAGES_TYPE = string;

// Path: model/attributes/ai/ai__is_search_required.json

/**
 * Boolean indicating if the model needs to perform a search. `ai.is_search_required`
 *
 * Attribute Value Type: `boolean` {@link AI_IS_SEARCH_REQUIRED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example false
 */
export const AI_IS_SEARCH_REQUIRED = 'ai.is_search_required';

/**
 * Type for {@link AI_IS_SEARCH_REQUIRED} ai.is_search_required
 */
export type AI_IS_SEARCH_REQUIRED_TYPE = boolean;

// Path: model/attributes/ai/ai__metadata.json

/**
 * Extra metadata passed to an AI pipeline step. `ai.metadata`
 *
 * Attribute Value Type: `string` {@link AI_METADATA_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example "{\"user_id\": 123, \"session_id\": \"abc123\"}"
 */
export const AI_METADATA = 'ai.metadata';

/**
 * Type for {@link AI_METADATA} ai.metadata
 */
export type AI_METADATA_TYPE = string;

// Path: model/attributes/ai/ai__model__id.json

/**
 * The id of the model used by the Vercel AI SDK. `ai.model.id`
 *
 * Attribute Value Type: `string` {@link AI_MODEL_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_MODEL} `gen_ai.request.model`, {@link _AI_MODEL_ID} `ai.model_id`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_MODEL} (gen_ai.request.model) instead - This attribute is being deprecated in favor of gen_ai.request.model.
 * @example "gpt-4o"
 */
export const AI_MODEL_ID = 'ai.model.id';

/**
 * Type for {@link AI_MODEL_ID} ai.model.id
 */
export type AI_MODEL_ID_TYPE = string;

// Path: model/attributes/ai/ai__model_id.json

/**
 * The vendor-specific ID of the model used. `ai.model_id`
 *
 * Attribute Value Type: `string` {@link _AI_MODEL_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_MODEL} `gen_ai.request.model`, {@link AI_MODEL_ID} `ai.model.id`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_MODEL} (gen_ai.request.model) instead
 * @example "gpt-4"
 */
export const _AI_MODEL_ID = 'ai.model_id';

/**
 * Type for {@link _AI_MODEL_ID} ai.model_id
 */
export type _AI_MODEL_ID_TYPE = string;

// Path: model/attributes/ai/ai__model__provider.json

/**
 * The provider of the model. `ai.model.provider`
 *
 * Attribute Value Type: `string` {@link AI_MODEL_PROVIDER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_PROVIDER_NAME} `gen_ai.provider.name`, {@link GEN_AI_SYSTEM} `gen_ai.system`
 *
 * @deprecated Use {@link GEN_AI_PROVIDER_NAME} (gen_ai.provider.name) instead
 * @example "openai"
 */
export const AI_MODEL_PROVIDER = 'ai.model.provider';

/**
 * Type for {@link AI_MODEL_PROVIDER} ai.model.provider
 */
export type AI_MODEL_PROVIDER_TYPE = string;

// Path: model/attributes/ai/ai__pipeline__name.json

/**
 * The name of the AI pipeline. `ai.pipeline.name`
 *
 * Attribute Value Type: `string` {@link AI_PIPELINE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_PIPELINE_NAME} `gen_ai.pipeline.name`, {@link LANGCHAIN_CHAIN_NAME} `langchain.chain.name`
 *
 * @deprecated Use {@link GEN_AI_PIPELINE_NAME} (gen_ai.pipeline.name) instead
 * @example "Autofix Pipeline"
 */
export const AI_PIPELINE_NAME = 'ai.pipeline.name';

/**
 * Type for {@link AI_PIPELINE_NAME} ai.pipeline.name
 */
export type AI_PIPELINE_NAME_TYPE = string;

// Path: model/attributes/ai/ai__preamble.json

/**
 * For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style. `ai.preamble`
 *
 * Attribute Value Type: `string` {@link AI_PREAMBLE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_SYSTEM_INSTRUCTIONS} `gen_ai.system_instructions`
 *
 * @deprecated Use {@link GEN_AI_SYSTEM_INSTRUCTIONS} (gen_ai.system_instructions) instead
 * @example "You are now a clown."
 */
export const AI_PREAMBLE = 'ai.preamble';

/**
 * Type for {@link AI_PREAMBLE} ai.preamble
 */
export type AI_PREAMBLE_TYPE = string;

// Path: model/attributes/ai/ai__presence_penalty.json

/**
 * Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies. `ai.presence_penalty`
 *
 * Attribute Value Type: `number` {@link AI_PRESENCE_PENALTY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_PRESENCE_PENALTY} `gen_ai.request.presence_penalty`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_PRESENCE_PENALTY} (gen_ai.request.presence_penalty) instead
 * @example 0.5
 */
export const AI_PRESENCE_PENALTY = 'ai.presence_penalty';

/**
 * Type for {@link AI_PRESENCE_PENALTY} ai.presence_penalty
 */
export type AI_PRESENCE_PENALTY_TYPE = number;

// Path: model/attributes/ai/ai__prompt.json

/**
 * The prompt passed to the Vercel AI SDK, as a stringified object. `ai.prompt`
 *
 * Attribute Value Type: `string` {@link AI_PROMPT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_INPUT_MESSAGES} `gen_ai.input.messages`, {@link AI_TEXTS} `ai.texts`, {@link AI_PROMPT_MESSAGES} `ai.prompt.messages`, {@link GEN_AI_PROMPT} `gen_ai.prompt`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead - This attribute is being deprecated in favor of gen_ai.input.messages.
 * @example "{\"prompt\":\"What is the weather in Paris?\"}"
 */
export const AI_PROMPT = 'ai.prompt';

/**
 * Type for {@link AI_PROMPT} ai.prompt
 */
export type AI_PROMPT_TYPE = string;

// Path: model/attributes/ai/ai__prompt__messages.json

/**
 * The input messages sent to the AI model. `ai.prompt.messages`
 *
 * Attribute Value Type: `string` {@link AI_PROMPT_MESSAGES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_INPUT_MESSAGES} `gen_ai.input.messages`, {@link AI_TEXTS} `ai.texts`, {@link GEN_AI_PROMPT} `gen_ai.prompt`, {@link AI_PROMPT} `ai.prompt`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead
 * @example "[{\"role\": \"user\", \"message\": \"hello\"}]"
 */
export const AI_PROMPT_MESSAGES = 'ai.prompt.messages';

/**
 * Type for {@link AI_PROMPT_MESSAGES} ai.prompt.messages
 */
export type AI_PROMPT_MESSAGES_TYPE = string;

// Path: model/attributes/ai/ai__prompt_tokens__used.json

/**
 * The number of tokens used to process just the prompt. `ai.prompt_tokens.used`
 *
 * Attribute Value Type: `number` {@link AI_PROMPT_TOKENS_USED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_PROMPT_TOKENS} `gen_ai.usage.prompt_tokens`, {@link GEN_AI_USAGE_INPUT_TOKENS} `gen_ai.usage.input_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_INPUT_TOKENS} (gen_ai.usage.input_tokens) instead
 * @example 20
 */
export const AI_PROMPT_TOKENS_USED = 'ai.prompt_tokens.used';

/**
 * Type for {@link AI_PROMPT_TOKENS_USED} ai.prompt_tokens.used
 */
export type AI_PROMPT_TOKENS_USED_TYPE = number;

// Path: model/attributes/ai/ai__prompt__tools.json

/**
 * The tools made available to the model, as an array of stringified tool definitions. `ai.prompt.tools`
 *
 * Attribute Value Type: `Array<string>` {@link AI_PROMPT_TOOLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_TOOL_DEFINITIONS} (gen_ai.tool.definitions) instead - This attribute is being deprecated in favor of gen_ai.tool.definitions.
 * @example ["{\"type\":\"function\",\"name\":\"get_weather\"}"]
 */
export const AI_PROMPT_TOOLS = 'ai.prompt.tools';

/**
 * Type for {@link AI_PROMPT_TOOLS} ai.prompt.tools
 */
export type AI_PROMPT_TOOLS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__raw_prompting.json

/**
 * When enabled, the user’s prompt will be sent to the model without any pre-processing. `ai.raw_prompting`
 *
 * Attribute Value Type: `boolean` {@link AI_RAW_PROMPTING_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example true
 */
export const AI_RAW_PROMPTING = 'ai.raw_prompting';

/**
 * Type for {@link AI_RAW_PROMPTING} ai.raw_prompting
 */
export type AI_RAW_PROMPTING_TYPE = boolean;

// Path: model/attributes/ai/ai__responses.json

/**
 * The response messages sent back by the AI model. `ai.responses`
 *
 * Attribute Value Type: `Array<string>` {@link AI_RESPONSES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example ["hello","world"]
 */
export const AI_RESPONSES = 'ai.responses';

/**
 * Type for {@link AI_RESPONSES} ai.responses
 */
export type AI_RESPONSES_TYPE = Array<string>;

// Path: model/attributes/ai/ai__response_format.json

/**
 * For an AI model call, the format of the response `ai.response_format`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_FORMAT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example "json_object"
 */
export const AI_RESPONSE_FORMAT = 'ai.response_format';

/**
 * Type for {@link AI_RESPONSE_FORMAT} ai.response_format
 */
export type AI_RESPONSE_FORMAT_TYPE = string;

// Path: model/attributes/ai/ai__response__id.json

/**
 * The id of the response returned by the model. `ai.response.id`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_ID} `gen_ai.response.id`, {@link AI_GENERATION_ID} `ai.generation_id`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_ID} (gen_ai.response.id) instead - This attribute is being deprecated in favor of gen_ai.response.id.
 * @example "chatcmpl-BuKJgVSKAMTUYbBSjHTMUuNGKzOPY"
 */
export const AI_RESPONSE_ID = 'ai.response.id';

/**
 * Type for {@link AI_RESPONSE_ID} ai.response.id
 */
export type AI_RESPONSE_ID_TYPE = string;

// Path: model/attributes/ai/ai__response__model.json

/**
 * The id of the model that produced the response. `ai.response.model`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_MODEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_MODEL} `gen_ai.response.model`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_MODEL} (gen_ai.response.model) instead - This attribute is being deprecated in favor of gen_ai.response.model.
 * @example "gpt-4o-2024-08-06"
 */
export const AI_RESPONSE_MODEL = 'ai.response.model';

/**
 * Type for {@link AI_RESPONSE_MODEL} ai.response.model
 */
export type AI_RESPONSE_MODEL_TYPE = string;

// Path: model/attributes/ai/ai__response__object.json

/**
 * The type of the object returned by the model. `ai.response.object`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_OBJECT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The Sentry conventions have no replacement for the raw Vercel AI response object type.
 * @example "chat.completion"
 */
export const AI_RESPONSE_OBJECT = 'ai.response.object';

/**
 * Type for {@link AI_RESPONSE_OBJECT} ai.response.object
 */
export type AI_RESPONSE_OBJECT_TYPE = string;

// Path: model/attributes/ai/ai__response__text.json

/**
 * The text response from the AI model. `ai.response.text`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_TEXT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_OUTPUT_MESSAGES} `gen_ai.output.messages`, {@link AI_RESPONSE_TOOLCALLS} `ai.response.toolCalls`
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example "The weather in Paris is currently rainy."
 */
export const AI_RESPONSE_TEXT = 'ai.response.text';

/**
 * Type for {@link AI_RESPONSE_TEXT} ai.response.text
 */
export type AI_RESPONSE_TEXT_TYPE = string;

// Path: model/attributes/ai/ai__response__timestamp.json

/**
 * The ISO 8601 timestamp at which the response was produced. `ai.response.timestamp`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_TIMESTAMP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The span start and end timestamps carry the same information.
 * @example "2026-02-19T15:32:11.000Z"
 */
export const AI_RESPONSE_TIMESTAMP = 'ai.response.timestamp';

/**
 * Type for {@link AI_RESPONSE_TIMESTAMP} ai.response.timestamp
 */
export type AI_RESPONSE_TIMESTAMP_TYPE = string;

// Path: model/attributes/ai/ai__response__toolCalls.json

/**
 * The tool calls in the AI model response. `ai.response.toolCalls`
 *
 * Attribute Value Type: `string` {@link AI_RESPONSE_TOOLCALLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_OUTPUT_MESSAGES} `gen_ai.output.messages`, {@link AI_RESPONSE_TEXT} `ai.response.text`
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example "[{\"name\": \"get_weather\", \"arguments\": {\"location\": \"Paris\"}}]"
 */
export const AI_RESPONSE_TOOLCALLS = 'ai.response.toolCalls';

/**
 * Type for {@link AI_RESPONSE_TOOLCALLS} ai.response.toolCalls
 */
export type AI_RESPONSE_TOOLCALLS_TYPE = string;

// Path: model/attributes/ai/ai__schema.json

/**
 * The stringified JSON schema the model output must conform to. `ai.schema`
 *
 * Attribute Value Type: `string` {@link AI_SCHEMA_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema.
 * @example "{\"type\":\"object\",\"properties\":{\"city\":{\"type\":\"string\"}}}"
 */
export const AI_SCHEMA = 'ai.schema';

/**
 * Type for {@link AI_SCHEMA} ai.schema
 */
export type AI_SCHEMA_TYPE = string;

// Path: model/attributes/ai/ai__search_queries.json

/**
 * Queries used to search for relevant context or documents. `ai.search_queries`
 *
 * Attribute Value Type: `Array<string>` {@link AI_SEARCH_QUERIES_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example ["climate change effects","renewable energy"]
 */
export const AI_SEARCH_QUERIES = 'ai.search_queries';

/**
 * Type for {@link AI_SEARCH_QUERIES} ai.search_queries
 */
export type AI_SEARCH_QUERIES_TYPE = Array<string>;

// Path: model/attributes/ai/ai__search_results.json

/**
 * Results returned from search queries for context. `ai.search_results`
 *
 * Attribute Value Type: `Array<string>` {@link AI_SEARCH_RESULTS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example ["search_result_1, search_result_2"]
 */
export const AI_SEARCH_RESULTS = 'ai.search_results';

/**
 * Type for {@link AI_SEARCH_RESULTS} ai.search_results
 */
export type AI_SEARCH_RESULTS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__seed.json

/**
 * The seed, ideally models given the same seed and same other parameters will produce the exact same output. `ai.seed`
 *
 * Attribute Value Type: `string` {@link AI_SEED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_SEED} `gen_ai.request.seed`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_SEED} (gen_ai.request.seed) instead
 * @example "1234567890"
 */
export const AI_SEED = 'ai.seed';

/**
 * Type for {@link AI_SEED} ai.seed
 */
export type AI_SEED_TYPE = string;

// Path: model/attributes/ai/ai__streaming.json

/**
 * Whether the request was streamed back. `ai.streaming`
 *
 * Attribute Value Type: `boolean` {@link AI_STREAMING_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_STREAMING} `gen_ai.response.streaming`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_STREAMING} (gen_ai.response.streaming) instead
 * @example true
 */
export const AI_STREAMING = 'ai.streaming';

/**
 * Type for {@link AI_STREAMING} ai.streaming
 */
export type AI_STREAMING_TYPE = boolean;

// Path: model/attributes/ai/ai__tags.json

/**
 * Tags that describe an AI pipeline step. `ai.tags`
 *
 * Attribute Value Type: `string` {@link AI_TAGS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example "{\"executed_function\": \"add_integers\"}"
 */
export const AI_TAGS = 'ai.tags';

/**
 * Type for {@link AI_TAGS} ai.tags
 */
export type AI_TAGS_TYPE = string;

// Path: model/attributes/ai/ai__temperature.json

/**
 * For an AI model call, the temperature parameter. Temperature essentially means how random the output will be. `ai.temperature`
 *
 * Attribute Value Type: `number` {@link AI_TEMPERATURE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_TEMPERATURE} `gen_ai.request.temperature`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_TEMPERATURE} (gen_ai.request.temperature) instead
 * @example 0.1
 */
export const AI_TEMPERATURE = 'ai.temperature';

/**
 * Type for {@link AI_TEMPERATURE} ai.temperature
 */
export type AI_TEMPERATURE_TYPE = number;

// Path: model/attributes/ai/ai__texts.json

/**
 * Raw text inputs provided to the model. `ai.texts`
 *
 * Attribute Value Type: `Array<string>` {@link AI_TEXTS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_INPUT_MESSAGES} `gen_ai.input.messages`, {@link AI_PROMPT_MESSAGES} `ai.prompt.messages`, {@link GEN_AI_PROMPT} `gen_ai.prompt`, {@link AI_PROMPT} `ai.prompt`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead
 * @example ["Hello, how are you?","What is the capital of France?"]
 */
export const AI_TEXTS = 'ai.texts';

/**
 * Type for {@link AI_TEXTS} ai.texts
 */
export type AI_TEXTS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__toolCall__args.json

/**
 * The arguments of the tool call. `ai.toolCall.args`
 *
 * Attribute Value Type: `string` {@link AI_TOOLCALL_ARGS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_ARGUMENTS} `gen_ai.tool.call.arguments`, {@link GEN_AI_TOOL_INPUT} `gen_ai.tool.input`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_ARGUMENTS} (gen_ai.tool.call.arguments) instead
 * @example "{\"location\": \"Paris\"}"
 */
export const AI_TOOLCALL_ARGS = 'ai.toolCall.args';

/**
 * Type for {@link AI_TOOLCALL_ARGS} ai.toolCall.args
 */
export type AI_TOOLCALL_ARGS_TYPE = string;

// Path: model/attributes/ai/ai__toolCall__result.json

/**
 * The result of the tool call. `ai.toolCall.result`
 *
 * Attribute Value Type: `string` {@link AI_TOOLCALL_RESULT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_RESULT} `gen_ai.tool.call.result`, {@link GEN_AI_TOOL_OUTPUT} `gen_ai.tool.output`, {@link GEN_AI_TOOL_MESSAGE} `gen_ai.tool.message`, {@link MCP_TOOL_RESULT_CONTENT} `mcp.tool.result.content`, {@link ANTHROPIC_TOOL_RESULT_CONTENT} `anthropic.tool_result.content`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_RESULT} (gen_ai.tool.call.result) instead
 * @example "rainy, 57°F"
 */
export const AI_TOOLCALL_RESULT = 'ai.toolCall.result';

/**
 * Type for {@link AI_TOOLCALL_RESULT} ai.toolCall.result
 */
export type AI_TOOLCALL_RESULT_TYPE = string;

// Path: model/attributes/ai/ai__tools.json

/**
 * For an AI model call, the functions that are available `ai.tools`
 *
 * Attribute Value Type: `Array<string>` {@link AI_TOOLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_TOOL_DEFINITIONS} (gen_ai.tool.definitions) instead
 * @example ["function_1","function_2"]
 */
export const AI_TOOLS = 'ai.tools';

/**
 * Type for {@link AI_TOOLS} ai.tools
 */
export type AI_TOOLS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__tool_calls.json

/**
 * For an AI model call, the tool calls that were made. `ai.tool_calls`
 *
 * Attribute Value Type: `Array<string>` {@link AI_TOOL_CALLS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example ["tool_call_1","tool_call_2"]
 */
export const AI_TOOL_CALLS = 'ai.tool_calls';

/**
 * Type for {@link AI_TOOL_CALLS} ai.tool_calls
 */
export type AI_TOOL_CALLS_TYPE = Array<string>;

// Path: model/attributes/ai/ai__top_k.json

/**
 * Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered). `ai.top_k`
 *
 * Attribute Value Type: `number` {@link AI_TOP_K_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_TOP_K} `gen_ai.request.top_k`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_TOP_K} (gen_ai.request.top_k) instead
 * @example 35
 */
export const AI_TOP_K = 'ai.top_k';

/**
 * Type for {@link AI_TOP_K} ai.top_k
 */
export type AI_TOP_K_TYPE = number;

// Path: model/attributes/ai/ai__top_p.json

/**
 * Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered). `ai.top_p`
 *
 * Attribute Value Type: `number` {@link AI_TOP_P_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_TOP_P} `gen_ai.request.top_p`
 *
 * @deprecated Use {@link GEN_AI_REQUEST_TOP_P} (gen_ai.request.top_p) instead
 * @example 0.7
 */
export const AI_TOP_P = 'ai.top_p';

/**
 * Type for {@link AI_TOP_P} ai.top_p
 */
export type AI_TOP_P_TYPE = number;

// Path: model/attributes/ai/ai__total_cost.json

/**
 * The total cost for the tokens used. `ai.total_cost`
 *
 * Attribute Value Type: `number` {@link AI_TOTAL_COST_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_COST_TOTAL_TOKENS} `gen_ai.cost.total_tokens`
 *
 * @deprecated Use {@link GEN_AI_COST_TOTAL_TOKENS} (gen_ai.cost.total_tokens) instead
 * @example 12.34
 */
export const AI_TOTAL_COST = 'ai.total_cost';

/**
 * Type for {@link AI_TOTAL_COST} ai.total_cost
 */
export type AI_TOTAL_COST_TYPE = number;

// Path: model/attributes/ai/ai__total_tokens__used.json

/**
 * The total number of tokens used to process the prompt. `ai.total_tokens.used`
 *
 * Attribute Value Type: `number` {@link AI_TOTAL_TOKENS_USED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_TOTAL_TOKENS} `gen_ai.usage.total_tokens`, {@link AI_USAGE_TOKENS} `ai.usage.tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_TOTAL_TOKENS} (gen_ai.usage.total_tokens) instead
 * @example 30
 */
export const AI_TOTAL_TOKENS_USED = 'ai.total_tokens.used';

/**
 * Type for {@link AI_TOTAL_TOKENS_USED} ai.total_tokens.used
 */
export type AI_TOTAL_TOKENS_USED_TYPE = number;

// Path: model/attributes/ai/ai__usage__tokens.json

/**
 * The total number of tokens used for the request and the response. `ai.usage.tokens`
 *
 * Attribute Value Type: `number` {@link AI_USAGE_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_TOTAL_TOKENS} `gen_ai.usage.total_tokens`, {@link AI_TOTAL_TOKENS_USED} `ai.total_tokens.used`
 *
 * @deprecated Use {@link GEN_AI_USAGE_TOTAL_TOKENS} (gen_ai.usage.total_tokens) instead - This attribute is being deprecated in favor of gen_ai.usage.total_tokens.
 * @example 150
 */
export const AI_USAGE_TOKENS = 'ai.usage.tokens';

/**
 * Type for {@link AI_USAGE_TOKENS} ai.usage.tokens
 */
export type AI_USAGE_TOKENS_TYPE = number;

// Path: model/attributes/ai/ai__values.json

/**
 * The stringified values produced by a Vercel AI SDK object or array generation. `ai.values`
 *
 * Attribute Value Type: `string` {@link AI_VALUES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. Use gen_ai.output.messages for model output instead.
 * @example "[{\"city\":\"Paris\"}]"
 */
export const AI_VALUES = 'ai.values';

/**
 * Type for {@link AI_VALUES} ai.values
 */
export type AI_VALUES_TYPE = string;

// Path: model/attributes/ai/ai__warnings.json

/**
 * Warning messages generated during model execution. `ai.warnings`
 *
 * Attribute Value Type: `Array<string>` {@link AI_WARNINGS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example ["Token limit exceeded"]
 */
export const AI_WARNINGS = 'ai.warnings';

/**
 * Type for {@link AI_WARNINGS} ai.warnings
 */
export type AI_WARNINGS_TYPE = Array<string>;

// Path: model/attributes/angular/angular__version.json

/**
 * The version of the Angular framework `angular.version`
 *
 * Attribute Value Type: `string` {@link ANGULAR_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "17.1.0"
 */
export const ANGULAR_VERSION = 'angular.version';

/**
 * Type for {@link ANGULAR_VERSION} angular.version
 */
export type ANGULAR_VERSION_TYPE = string;

// Path: model/attributes/anthropic/anthropic__tool_result__content.json

/**
 * The content of the tool result. `anthropic.tool_result.content`
 *
 * Attribute Value Type: `string` {@link ANTHROPIC_TOOL_RESULT_CONTENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_RESULT} `gen_ai.tool.call.result`, {@link GEN_AI_TOOL_OUTPUT} `gen_ai.tool.output`, {@link GEN_AI_TOOL_MESSAGE} `gen_ai.tool.message`, {@link MCP_TOOL_RESULT_CONTENT} `mcp.tool.result.content`, {@link AI_TOOLCALL_RESULT} `ai.toolCall.result`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_RESULT} (gen_ai.tool.call.result) instead - Use gen_ai.tool.call.result for tool results.
 * @example "rainy, 57°F"
 */
export const ANTHROPIC_TOOL_RESULT_CONTENT = 'anthropic.tool_result.content';

/**
 * Type for {@link ANTHROPIC_TOOL_RESULT_CONTENT} anthropic.tool_result.content
 */
export type ANTHROPIC_TOOL_RESULT_CONTENT_TYPE = string;

// Path: model/attributes/app/app__app_build.json

/**
 * Internal build identifier, as it appears on the platform. `app.app_build`
 *
 * Attribute Value Type: `string` {@link APP_APP_BUILD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_BUILD} `app.build`
 *
 * @deprecated Use {@link APP_BUILD} (app.build) instead - Deprecated in favor of app.build
 * @example "1"
 */
export const APP_APP_BUILD = 'app.app_build';

/**
 * Type for {@link APP_APP_BUILD} app.app_build
 */
export type APP_APP_BUILD_TYPE = string;

// Path: model/attributes/app/app__app_identifier.json

/**
 * Version-independent application identifier, often a dotted bundle ID. `app.app_identifier`
 *
 * Attribute Value Type: `string` {@link APP_APP_IDENTIFIER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_IDENTIFIER} `app.identifier`
 *
 * @deprecated Use {@link APP_IDENTIFIER} (app.identifier) instead - Deprecated in favor of app.identifier
 * @example "com.example.myapp"
 */
export const APP_APP_IDENTIFIER = 'app.app_identifier';

/**
 * Type for {@link APP_APP_IDENTIFIER} app.app_identifier
 */
export type APP_APP_IDENTIFIER_TYPE = string;

// Path: model/attributes/app/app__app_name.json

/**
 * Human readable application name, as it appears on the platform. `app.app_name`
 *
 * Attribute Value Type: `string` {@link APP_APP_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_NAME} `app.name`
 *
 * @deprecated Use {@link APP_NAME} (app.name) instead - Deprecated in favor of app.name
 * @example "My App"
 */
export const APP_APP_NAME = 'app.app_name';

/**
 * Type for {@link APP_APP_NAME} app.app_name
 */
export type APP_APP_NAME_TYPE = string;

// Path: model/attributes/app/app__app_start_time.json

/**
 * Formatted UTC timestamp when the user started the application. `app.app_start_time`
 *
 * Attribute Value Type: `string` {@link APP_APP_START_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_START_TIME} `app.start_time`
 *
 * @deprecated Use {@link APP_START_TIME} (app.start_time) instead - Deprecated in favor of app.start_time
 * @example "2025-01-01T00:00:00.000Z"
 */
export const APP_APP_START_TIME = 'app.app_start_time';

/**
 * Type for {@link APP_APP_START_TIME} app.app_start_time
 */
export type APP_APP_START_TIME_TYPE = string;

// Path: model/attributes/app/app__app_version.json

/**
 * Human readable application version, as it appears on the platform. `app.app_version`
 *
 * Attribute Value Type: `string` {@link APP_APP_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VERSION} `app.version`
 *
 * @deprecated Use {@link APP_VERSION} (app.version) instead - Deprecated in favor of app.version
 * @example "1.0.0"
 */
export const APP_APP_VERSION = 'app.app_version';

/**
 * Type for {@link APP_APP_VERSION} app.app_version
 */
export type APP_APP_VERSION_TYPE = string;

// Path: model/attributes/app/app__build.json

/**
 * Internal build identifier, as it appears on the platform. `app.build`
 *
 * Attribute Value Type: `string` {@link APP_BUILD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_APP_BUILD} `app.app_build`
 *
 * @example "1"
 */
export const APP_BUILD = 'app.build';

/**
 * Type for {@link APP_BUILD} app.build
 */
export type APP_BUILD_TYPE = string;

// Path: model/attributes/app/app__identifier.json

/**
 * Version-independent application identifier, often a dotted bundle ID. `app.identifier`
 *
 * Attribute Value Type: `string` {@link APP_IDENTIFIER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_APP_IDENTIFIER} `app.app_identifier`
 *
 * @example "com.example.myapp"
 */
export const APP_IDENTIFIER = 'app.identifier';

/**
 * Type for {@link APP_IDENTIFIER} app.identifier
 */
export type APP_IDENTIFIER_TYPE = string;

// Path: model/attributes/app/app__in_foreground.json

/**
 * Whether the application is currently in the foreground. `app.in_foreground`
 *
 * Attribute Value Type: `boolean` {@link APP_IN_FOREGROUND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const APP_IN_FOREGROUND = 'app.in_foreground';

/**
 * Type for {@link APP_IN_FOREGROUND} app.in_foreground
 */
export type APP_IN_FOREGROUND_TYPE = boolean;

// Path: model/attributes/app/app__name.json

/**
 * Human readable application name, as it appears on the platform. `app.name`
 *
 * Attribute Value Type: `string` {@link APP_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_APP_NAME} `app.app_name`
 *
 * @example "My App"
 */
export const APP_NAME = 'app.name';

/**
 * Type for {@link APP_NAME} app.name
 */
export type APP_NAME_TYPE = string;

// Path: model/attributes/app_start_cold.json

/**
 * The duration of a cold app start in milliseconds `app_start_cold`
 *
 * Attribute Value Type: `number` {@link APP_START_COLD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_START_COLD_VALUE} `app.vitals.start.cold.value`
 *
 * @deprecated Use {@link APP_VITALS_START_COLD_VALUE} (app.vitals.start.cold.value) instead - Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1234.56
 */
export const APP_START_COLD = 'app_start_cold';

/**
 * Type for {@link APP_START_COLD} app_start_cold
 */
export type APP_START_COLD_TYPE = number;

// Path: model/attributes/app/app__start_time.json

/**
 * Formatted UTC timestamp when the user started the application. `app.start_time`
 *
 * Attribute Value Type: `string` {@link APP_START_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_APP_START_TIME} `app.app_start_time`
 *
 * @example "2025-01-01T00:00:00.000Z"
 */
export const APP_START_TIME = 'app.start_time';

/**
 * Type for {@link APP_START_TIME} app.start_time
 */
export type APP_START_TIME_TYPE = string;

// Path: model/attributes/app_start_type.json

/**
 * Mobile app start variant. Either cold or warm. `app_start_type`
 *
 * Attribute Value Type: `string` {@link APP_START_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_START_TYPE} `app.vitals.start.type`
 *
 * @deprecated Use {@link APP_VITALS_START_TYPE} (app.vitals.start.type) instead - Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes
 * @example "cold"
 */
export const APP_START_TYPE = 'app_start_type';

/**
 * Type for {@link APP_START_TYPE} app_start_type
 */
export type APP_START_TYPE_TYPE = string;

// Path: model/attributes/app_start_warm.json

/**
 * The duration of a warm app start in milliseconds `app_start_warm`
 *
 * Attribute Value Type: `number` {@link APP_START_WARM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_START_WARM_VALUE} `app.vitals.start.warm.value`
 *
 * @deprecated Use {@link APP_VITALS_START_WARM_VALUE} (app.vitals.start.warm.value) instead - Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1234.56
 */
export const APP_START_WARM = 'app_start_warm';

/**
 * Type for {@link APP_START_WARM} app_start_warm
 */
export type APP_START_WARM_TYPE = number;

// Path: model/attributes/app/app__version.json

/**
 * Human readable application version, as it appears on the platform. `app.version`
 *
 * Attribute Value Type: `string` {@link APP_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_APP_VERSION} `app.app_version`
 *
 * @example "1.0.0"
 */
export const APP_VERSION = 'app.version';

/**
 * Type for {@link APP_VERSION} app.version
 */
export type APP_VERSION_TYPE = string;

// Path: model/attributes/app/app__vitals__frames__delay__value.json

/**
 * The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/). `app.vitals.frames.delay.value`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_DELAY_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_DELAY} `frames.delay`
 *
 * @example 5
 */
export const APP_VITALS_FRAMES_DELAY_VALUE = 'app.vitals.frames.delay.value';

/**
 * Type for {@link APP_VITALS_FRAMES_DELAY_VALUE} app.vitals.frames.delay.value
 */
export type APP_VITALS_FRAMES_DELAY_VALUE_TYPE = number;

// Path: model/attributes/app/app__vitals__frames__frozen__count.json

/**
 * The number of frozen frames rendered during the lifetime of the span. `app.vitals.frames.frozen.count`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_FROZEN_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_FROZEN} `frames.frozen`, {@link SENTRY_FRAMES_FROZEN} `sentry.frames.frozen`
 *
 * @example 3
 */
export const APP_VITALS_FRAMES_FROZEN_COUNT = 'app.vitals.frames.frozen.count';

/**
 * Type for {@link APP_VITALS_FRAMES_FROZEN_COUNT} app.vitals.frames.frozen.count
 */
export type APP_VITALS_FRAMES_FROZEN_COUNT_TYPE = number;

// Path: model/attributes/app/app__vitals__frames__frozen__rate.json

/**
 * The fraction of rendered frames that were frozen, calculated as `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay. `app.vitals.frames.frozen.rate`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_FROZEN_RATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_FROZEN_RATE} `frames_frozen_rate`
 *
 * @example 0.5
 */
export const APP_VITALS_FRAMES_FROZEN_RATE = 'app.vitals.frames.frozen.rate';

/**
 * Type for {@link APP_VITALS_FRAMES_FROZEN_RATE} app.vitals.frames.frozen.rate
 */
export type APP_VITALS_FRAMES_FROZEN_RATE_TYPE = number;

// Path: model/attributes/app/app__vitals__frames__slow__count.json

/**
 * The number of slow frames rendered during the lifetime of the span. `app.vitals.frames.slow.count`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_SLOW_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_SLOW} `frames.slow`, {@link SENTRY_FRAMES_SLOW} `sentry.frames.slow`
 *
 * @example 1
 */
export const APP_VITALS_FRAMES_SLOW_COUNT = 'app.vitals.frames.slow.count';

/**
 * Type for {@link APP_VITALS_FRAMES_SLOW_COUNT} app.vitals.frames.slow.count
 */
export type APP_VITALS_FRAMES_SLOW_COUNT_TYPE = number;

// Path: model/attributes/app/app__vitals__frames__slow__rate.json

/**
 * The fraction of rendered frames that were slow, calculated as `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay. `app.vitals.frames.slow.rate`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_SLOW_RATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_SLOW_RATE} `frames_slow_rate`
 *
 * @example 0.25
 */
export const APP_VITALS_FRAMES_SLOW_RATE = 'app.vitals.frames.slow.rate';

/**
 * Type for {@link APP_VITALS_FRAMES_SLOW_RATE} app.vitals.frames.slow.rate
 */
export type APP_VITALS_FRAMES_SLOW_RATE_TYPE = number;

// Path: model/attributes/app/app__vitals__frames__total__count.json

/**
 * The number of total frames rendered during the lifetime of the span. `app.vitals.frames.total.count`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_FRAMES_TOTAL_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FRAMES_TOTAL} `frames.total`, {@link SENTRY_FRAMES_TOTAL} `sentry.frames.total`
 *
 * @example 60
 */
export const APP_VITALS_FRAMES_TOTAL_COUNT = 'app.vitals.frames.total.count';

/**
 * Type for {@link APP_VITALS_FRAMES_TOTAL_COUNT} app.vitals.frames.total.count
 */
export type APP_VITALS_FRAMES_TOTAL_COUNT_TYPE = number;

// Path: model/attributes/app/app__vitals__stall__duration.json

/**
 * The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay. `app.vitals.stall.duration`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_STALL_DURATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link STALL_TOTAL_TIME} `stall_total_time`
 *
 * @example 4000
 */
export const APP_VITALS_STALL_DURATION = 'app.vitals.stall.duration';

/**
 * Type for {@link APP_VITALS_STALL_DURATION} app.vitals.stall.duration
 */
export type APP_VITALS_STALL_DURATION_TYPE = number;

// Path: model/attributes/app/app__vitals__stall__percentage.json

/**
 * The fraction of transaction duration during which the app was stalled, between 0.0 and 1.0. For example, 0.8 represents 80%. Only applies to React Native. This is computed by Relay. `app.vitals.stall.percentage`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_STALL_PERCENTAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link STALL_PERCENTAGE} `stall_percentage`
 *
 * @example 0.8
 */
export const APP_VITALS_STALL_PERCENTAGE = 'app.vitals.stall.percentage';

/**
 * Type for {@link APP_VITALS_STALL_PERCENTAGE} app.vitals.stall.percentage
 */
export type APP_VITALS_STALL_PERCENTAGE_TYPE = number;

// Path: model/attributes/app/app__vitals__start__cold__value.json

/**
 * The duration of a cold app start in milliseconds `app.vitals.start.cold.value`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_START_COLD_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_START_COLD} `app_start_cold`
 *
 * @example 1234.56
 */
export const APP_VITALS_START_COLD_VALUE = 'app.vitals.start.cold.value';

/**
 * Type for {@link APP_VITALS_START_COLD_VALUE} app.vitals.start.cold.value
 */
export type APP_VITALS_START_COLD_VALUE_TYPE = number;

// Path: model/attributes/app/app__vitals__start__prewarmed.json

/**
 * Whether the app start was prewarmed. `app.vitals.start.prewarmed`
 *
 * Attribute Value Type: `boolean` {@link APP_VITALS_START_PREWARMED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const APP_VITALS_START_PREWARMED = 'app.vitals.start.prewarmed';

/**
 * Type for {@link APP_VITALS_START_PREWARMED} app.vitals.start.prewarmed
 */
export type APP_VITALS_START_PREWARMED_TYPE = boolean;

// Path: model/attributes/app/app__vitals__start__reason.json

/**
 * The reason that triggered the app start. `app.vitals.start.reason`
 *
 * Attribute Value Type: `string` {@link APP_VITALS_START_REASON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "push"
 */
export const APP_VITALS_START_REASON = 'app.vitals.start.reason';

/**
 * Type for {@link APP_VITALS_START_REASON} app.vitals.start.reason
 */
export type APP_VITALS_START_REASON_TYPE = string;

// Path: model/attributes/app/app__vitals__start__screen.json

/**
 * The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered. `app.vitals.start.screen`
 *
 * Attribute Value Type: `string` {@link APP_VITALS_START_SCREEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "MainActivity"
 */
export const APP_VITALS_START_SCREEN = 'app.vitals.start.screen';

/**
 * Type for {@link APP_VITALS_START_SCREEN} app.vitals.start.screen
 */
export type APP_VITALS_START_SCREEN_TYPE = string;

// Path: model/attributes/app/app__vitals__start__type.json

/**
 * The type of app start, for example `cold` or `warm` `app.vitals.start.type`
 *
 * Attribute Value Type: `string` {@link APP_VITALS_START_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_START_TYPE} `app_start_type`
 *
 * @example "cold"
 */
export const APP_VITALS_START_TYPE = 'app.vitals.start.type';

/**
 * Type for {@link APP_VITALS_START_TYPE} app.vitals.start.type
 */
export type APP_VITALS_START_TYPE_TYPE = string;

// Path: model/attributes/app/app__vitals__start__warm__value.json

/**
 * The duration of a warm app start in milliseconds `app.vitals.start.warm.value`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_START_WARM_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_START_WARM} `app_start_warm`
 *
 * @example 1234.56
 */
export const APP_VITALS_START_WARM_VALUE = 'app.vitals.start.warm.value';

/**
 * Type for {@link APP_VITALS_START_WARM_VALUE} app.vitals.start.warm.value
 */
export type APP_VITALS_START_WARM_VALUE_TYPE = number;

// Path: model/attributes/app/app__vitals__ttfd__value.json

/**
 * The duration of time to full display in milliseconds `app.vitals.ttfd.value`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_TTFD_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TIME_TO_FULL_DISPLAY} `time_to_full_display`
 *
 * @example 1234.56
 */
export const APP_VITALS_TTFD_VALUE = 'app.vitals.ttfd.value';

/**
 * Type for {@link APP_VITALS_TTFD_VALUE} app.vitals.ttfd.value
 */
export type APP_VITALS_TTFD_VALUE_TYPE = number;

// Path: model/attributes/app/app__vitals__ttid__value.json

/**
 * The duration of time to initial display in milliseconds `app.vitals.ttid.value`
 *
 * Attribute Value Type: `number` {@link APP_VITALS_TTID_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TIME_TO_INITIAL_DISPLAY} `time_to_initial_display`
 *
 * @example 1234.56
 */
export const APP_VITALS_TTID_VALUE = 'app.vitals.ttid.value';

/**
 * Type for {@link APP_VITALS_TTID_VALUE} app.vitals.ttid.value
 */
export type APP_VITALS_TTID_VALUE_TYPE = number;

// Path: model/attributes/art/art__gc__blocking_count.json

/**
 * Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime `art.gc.blocking_count`
 *
 * Attribute Value Type: `number` {@link ART_GC_BLOCKING_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const ART_GC_BLOCKING_COUNT = 'art.gc.blocking_count';

/**
 * Type for {@link ART_GC_BLOCKING_COUNT} art.gc.blocking_count
 */
export type ART_GC_BLOCKING_COUNT_TYPE = number;

// Path: model/attributes/art/art__gc__blocking_time.json

/**
 * Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds `art.gc.blocking_time`
 *
 * Attribute Value Type: `number` {@link ART_GC_BLOCKING_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 11.873
 */
export const ART_GC_BLOCKING_TIME = 'art.gc.blocking_time';

/**
 * Type for {@link ART_GC_BLOCKING_TIME} art.gc.blocking_time
 */
export type ART_GC_BLOCKING_TIME_TYPE = number;

// Path: model/attributes/art/art__gc__pre_oome_count.json

/**
 * Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime `art.gc.pre_oome_count`
 *
 * Attribute Value Type: `number` {@link ART_GC_PRE_OOME_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0
 */
export const ART_GC_PRE_OOME_COUNT = 'art.gc.pre_oome_count';

/**
 * Type for {@link ART_GC_PRE_OOME_COUNT} art.gc.pre_oome_count
 */
export type ART_GC_PRE_OOME_COUNT_TYPE = number;

// Path: model/attributes/art/art__gc__total_count.json

/**
 * Total number of garbage collections performed by the Android Runtime `art.gc.total_count`
 *
 * Attribute Value Type: `number` {@link ART_GC_TOTAL_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const ART_GC_TOTAL_COUNT = 'art.gc.total_count';

/**
 * Type for {@link ART_GC_TOTAL_COUNT} art.gc.total_count
 */
export type ART_GC_TOTAL_COUNT_TYPE = number;

// Path: model/attributes/art/art__gc__total_time.json

/**
 * Total time spent in garbage collection by the Android Runtime, in milliseconds `art.gc.total_time`
 *
 * Attribute Value Type: `number` {@link ART_GC_TOTAL_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 11.807
 */
export const ART_GC_TOTAL_TIME = 'art.gc.total_time';

/**
 * Type for {@link ART_GC_TOTAL_TIME} art.gc.total_time
 */
export type ART_GC_TOTAL_TIME_TYPE = number;

// Path: model/attributes/art/art__gc__waiting_time.json

/**
 * Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds `art.gc.waiting_time`
 *
 * Attribute Value Type: `number` {@link ART_GC_WAITING_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 8.054
 */
export const ART_GC_WAITING_TIME = 'art.gc.waiting_time';

/**
 * Type for {@link ART_GC_WAITING_TIME} art.gc.waiting_time
 */
export type ART_GC_WAITING_TIME_TYPE = number;

// Path: model/attributes/art/art__memory__free.json

/**
 * Free memory available to the process as reported by the Android Runtime, in bytes `art.memory.free`
 *
 * Attribute Value Type: `number` {@link ART_MEMORY_FREE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 3181568
 */
export const ART_MEMORY_FREE = 'art.memory.free';

/**
 * Type for {@link ART_MEMORY_FREE} art.memory.free
 */
export type ART_MEMORY_FREE_TYPE = number;

// Path: model/attributes/art/art__memory__free_until_gc.json

/**
 * Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes `art.memory.free_until_gc`
 *
 * Attribute Value Type: `number` {@link ART_MEMORY_FREE_UNTIL_GC_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 3181568
 */
export const ART_MEMORY_FREE_UNTIL_GC = 'art.memory.free_until_gc';

/**
 * Type for {@link ART_MEMORY_FREE_UNTIL_GC} art.memory.free_until_gc
 */
export type ART_MEMORY_FREE_UNTIL_GC_TYPE = number;

// Path: model/attributes/art/art__memory__free_until_oome.json

/**
 * Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes `art.memory.free_until_oome`
 *
 * Attribute Value Type: `number` {@link ART_MEMORY_FREE_UNTIL_OOME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 196083712
 */
export const ART_MEMORY_FREE_UNTIL_OOME = 'art.memory.free_until_oome';

/**
 * Type for {@link ART_MEMORY_FREE_UNTIL_OOME} art.memory.free_until_oome
 */
export type ART_MEMORY_FREE_UNTIL_OOME_TYPE = number;

// Path: model/attributes/art/art__memory__max.json

/**
 * Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes `art.memory.max`
 *
 * Attribute Value Type: `number` {@link ART_MEMORY_MAX_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 201326592
 */
export const ART_MEMORY_MAX = 'art.memory.max';

/**
 * Type for {@link ART_MEMORY_MAX} art.memory.max
 */
export type ART_MEMORY_MAX_TYPE = number;

// Path: model/attributes/art/art__memory__total.json

/**
 * Total memory currently allocated to the process by the Android Runtime, in bytes `art.memory.total`
 *
 * Attribute Value Type: `number` {@link ART_MEMORY_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 7774208
 */
export const ART_MEMORY_TOTAL = 'art.memory.total';

/**
 * Type for {@link ART_MEMORY_TOTAL} art.memory.total
 */
export type ART_MEMORY_TOTAL_TYPE = number;

// Path: model/attributes/aws/aws__cloudwatch__logs__log_group.json

/**
 * The name of the CloudWatch Logs log group `aws.cloudwatch.logs.log_group`
 *
 * Attribute Value Type: `string` {@link AWS_CLOUDWATCH_LOGS_LOG_GROUP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "/aws/lambda/my-function"
 */
export const AWS_CLOUDWATCH_LOGS_LOG_GROUP = 'aws.cloudwatch.logs.log_group';

/**
 * Type for {@link AWS_CLOUDWATCH_LOGS_LOG_GROUP} aws.cloudwatch.logs.log_group
 */
export type AWS_CLOUDWATCH_LOGS_LOG_GROUP_TYPE = string;

// Path: model/attributes/aws/aws__cloudwatch__logs__log_stream.json

/**
 * The name of the CloudWatch Logs log stream `aws.cloudwatch.logs.log_stream`
 *
 * Attribute Value Type: `string` {@link AWS_CLOUDWATCH_LOGS_LOG_STREAM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "2024/01/01/[$LATEST]abcdef1234567890"
 */
export const AWS_CLOUDWATCH_LOGS_LOG_STREAM = 'aws.cloudwatch.logs.log_stream';

/**
 * Type for {@link AWS_CLOUDWATCH_LOGS_LOG_STREAM} aws.cloudwatch.logs.log_stream
 */
export type AWS_CLOUDWATCH_LOGS_LOG_STREAM_TYPE = string;

// Path: model/attributes/aws/aws__cloudwatch__logs__url.json

/**
 * The URL to the CloudWatch Logs log group `aws.cloudwatch.logs.url`
 *
 * Attribute Value Type: `string` {@link AWS_CLOUDWATCH_LOGS_URL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group"
 */
export const AWS_CLOUDWATCH_LOGS_URL = 'aws.cloudwatch.logs.url';

/**
 * Type for {@link AWS_CLOUDWATCH_LOGS_URL} aws.cloudwatch.logs.url
 */
export type AWS_CLOUDWATCH_LOGS_URL_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__attributes_to_get.json

/**
 * The value of the `AttributesToGet` request parameter. `aws.dynamodb.attributes_to_get`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_ATTRIBUTES_TO_GET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["lives","id"]
 */
export const AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';

/**
 * Type for {@link AWS_DYNAMODB_ATTRIBUTES_TO_GET} aws.dynamodb.attributes_to_get
 */
export type AWS_DYNAMODB_ATTRIBUTES_TO_GET_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__attribute_definitions.json

/**
 * The JSON-serialized value of each item in the `AttributeDefinitions` request field. `aws.dynamodb.attribute_definitions`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["{ \"AttributeName\": \"string\", \"AttributeType\": \"string\" }"]
 */
export const AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';

/**
 * Type for {@link AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS} aws.dynamodb.attribute_definitions
 */
export type AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__consistent_read.json

/**
 * The value of the `ConsistentRead` request parameter. `aws.dynamodb.consistent_read`
 *
 * Attribute Value Type: `boolean` {@link AWS_DYNAMODB_CONSISTENT_READ_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';

/**
 * Type for {@link AWS_DYNAMODB_CONSISTENT_READ} aws.dynamodb.consistent_read
 */
export type AWS_DYNAMODB_CONSISTENT_READ_TYPE = boolean;

// Path: model/attributes/aws/aws__dynamodb__consumed_capacity.json

/**
 * The JSON-serialized value of each item in the `ConsumedCapacity` response field. `aws.dynamodb.consumed_capacity`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_CONSUMED_CAPACITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["{ \"CapacityUnits\": number, \"GlobalSecondaryIndexes\": { \"string\" : { \"CapacityUnits\": number, \"ReadCapacityUnits\": number, \"WriteCapacityUnits\": number } }, \"LocalSecondaryIndexes\": { \"string\" : { \"CapacityUnits\": number, \"ReadCapacityUnits\": number, \"WriteCapacityUnits\": number } }, \"ReadCapacityUnits\": number, \"Table\": { \"CapacityUnits\": number, \"ReadCapacityUnits\": number, \"WriteCapacityUnits\": number }, \"TableName\": \"string\", \"WriteCapacityUnits\": number }"]
 */
export const AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';

/**
 * Type for {@link AWS_DYNAMODB_CONSUMED_CAPACITY} aws.dynamodb.consumed_capacity
 */
export type AWS_DYNAMODB_CONSUMED_CAPACITY_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__count.json

/**
 * The value of the `Count` response parameter. `aws.dynamodb.count`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 10
 */
export const AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';

/**
 * Type for {@link AWS_DYNAMODB_COUNT} aws.dynamodb.count
 */
export type AWS_DYNAMODB_COUNT_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__exclusive_start_table.json

/**
 * The value of the `ExclusiveStartTableName` request parameter. `aws.dynamodb.exclusive_start_table`
 *
 * Attribute Value Type: `string` {@link AWS_DYNAMODB_EXCLUSIVE_START_TABLE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Users"
 */
export const AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';

/**
 * Type for {@link AWS_DYNAMODB_EXCLUSIVE_START_TABLE} aws.dynamodb.exclusive_start_table
 */
export type AWS_DYNAMODB_EXCLUSIVE_START_TABLE_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__global_secondary_indexes.json

/**
 * The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field. `aws.dynamodb.global_secondary_indexes`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["{ \"IndexName\": \"string\", \"KeySchema\": [ { \"AttributeName\": \"string\", \"KeyType\": \"string\" } ], \"Projection\": { \"NonKeyAttributes\": [ \"string\" ], \"ProjectionType\": \"string\" }, \"ProvisionedThroughput\": { \"ReadCapacityUnits\": number, \"WriteCapacityUnits\": number } }"]
 */
export const AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';

/**
 * Type for {@link AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES} aws.dynamodb.global_secondary_indexes
 */
export type AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__global_secondary_index_updates.json

/**
 * The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field. `aws.dynamodb.global_secondary_index_updates`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["{ \"Create\": { \"IndexName\": \"string\", \"KeySchema\": [ { \"AttributeName\": \"string\", \"KeyType\": \"string\" } ], \"Projection\": { \"NonKeyAttributes\": [ \"string\" ], \"ProjectionType\": \"string\" }, \"ProvisionedThroughput\": { \"ReadCapacityUnits\": number, \"WriteCapacityUnits\": number } }"]
 */
export const AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';

/**
 * Type for {@link AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES} aws.dynamodb.global_secondary_index_updates
 */
export type AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__index_name.json

/**
 * The value of the `IndexName` request parameter. `aws.dynamodb.index_name`
 *
 * Attribute Value Type: `string` {@link AWS_DYNAMODB_INDEX_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "name_to_group"
 */
export const AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';

/**
 * Type for {@link AWS_DYNAMODB_INDEX_NAME} aws.dynamodb.index_name
 */
export type AWS_DYNAMODB_INDEX_NAME_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__item_collection_metrics.json

/**
 * The JSON-serialized value of the `ItemCollectionMetrics` response field. `aws.dynamodb.item_collection_metrics`
 *
 * Attribute Value Type: `string` {@link AWS_DYNAMODB_ITEM_COLLECTION_METRICS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "{ \"string\" : [ { \"ItemCollectionKey\": { \"string\" : { \"B\": blob, \"BOOL\": boolean, \"BS\": [ blob ], \"L\": [ \"AttributeValue\" ], \"M\": { \"string\" : \"AttributeValue\" }, \"N\": \"string\", \"NS\": [ \"string\" ], \"NULL\": boolean, \"S\": \"string\", \"SS\": [ \"string\" ] } }, \"SizeEstimateRangeGB\": [ number ] } ] }"
 */
export const AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';

/**
 * Type for {@link AWS_DYNAMODB_ITEM_COLLECTION_METRICS} aws.dynamodb.item_collection_metrics
 */
export type AWS_DYNAMODB_ITEM_COLLECTION_METRICS_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__limit.json

/**
 * The value of the `Limit` request parameter. `aws.dynamodb.limit`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_LIMIT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 10
 */
export const AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';

/**
 * Type for {@link AWS_DYNAMODB_LIMIT} aws.dynamodb.limit
 */
export type AWS_DYNAMODB_LIMIT_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__local_secondary_indexes.json

/**
 * The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field. `aws.dynamodb.local_secondary_indexes`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["{ \"IndexArn\": \"string\", \"IndexName\": \"string\", \"IndexSizeBytes\": number, \"ItemCount\": number, \"KeySchema\": [ { \"AttributeName\": \"string\", \"KeyType\": \"string\" } ], \"Projection\": { \"NonKeyAttributes\": [ \"string\" ], \"ProjectionType\": \"string\" } }"]
 */
export const AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';

/**
 * Type for {@link AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES} aws.dynamodb.local_secondary_indexes
 */
export type AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__projection.json

/**
 * The value of the `ProjectionExpression` request parameter. `aws.dynamodb.projection`
 *
 * Attribute Value Type: `string` {@link AWS_DYNAMODB_PROJECTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Title, Price, Color"
 */
export const AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';

/**
 * Type for {@link AWS_DYNAMODB_PROJECTION} aws.dynamodb.projection
 */
export type AWS_DYNAMODB_PROJECTION_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__provisioned_read_capacity.json

/**
 * The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter. `aws.dynamodb.provisioned_read_capacity`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_PROVISIONED_READ_CAPACITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 1
 */
export const AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';

/**
 * Type for {@link AWS_DYNAMODB_PROVISIONED_READ_CAPACITY} aws.dynamodb.provisioned_read_capacity
 */
export type AWS_DYNAMODB_PROVISIONED_READ_CAPACITY_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__provisioned_write_capacity.json

/**
 * The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter. `aws.dynamodb.provisioned_write_capacity`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 2
 */
export const AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';

/**
 * Type for {@link AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY} aws.dynamodb.provisioned_write_capacity
 */
export type AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__scanned_count.json

/**
 * The value of the `ScannedCount` response parameter. `aws.dynamodb.scanned_count`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_SCANNED_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 50
 */
export const AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';

/**
 * Type for {@link AWS_DYNAMODB_SCANNED_COUNT} aws.dynamodb.scanned_count
 */
export type AWS_DYNAMODB_SCANNED_COUNT_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__scan_forward.json

/**
 * The value of the `ScanIndexForward` request parameter. `aws.dynamodb.scan_forward`
 *
 * Attribute Value Type: `boolean` {@link AWS_DYNAMODB_SCAN_FORWARD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';

/**
 * Type for {@link AWS_DYNAMODB_SCAN_FORWARD} aws.dynamodb.scan_forward
 */
export type AWS_DYNAMODB_SCAN_FORWARD_TYPE = boolean;

// Path: model/attributes/aws/aws__dynamodb__segment.json

/**
 * The value of the `Segment` request parameter. `aws.dynamodb.segment`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_SEGMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 10
 */
export const AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';

/**
 * Type for {@link AWS_DYNAMODB_SEGMENT} aws.dynamodb.segment
 */
export type AWS_DYNAMODB_SEGMENT_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__select.json

/**
 * The value of the `Select` request parameter. `aws.dynamodb.select`
 *
 * Attribute Value Type: `string` {@link AWS_DYNAMODB_SELECT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ALL_ATTRIBUTES"
 */
export const AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';

/**
 * Type for {@link AWS_DYNAMODB_SELECT} aws.dynamodb.select
 */
export type AWS_DYNAMODB_SELECT_TYPE = string;

// Path: model/attributes/aws/aws__dynamodb__table_count.json

/**
 * The number of items in the `TableNames` response parameter. `aws.dynamodb.table_count`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_TABLE_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 20
 */
export const AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';

/**
 * Type for {@link AWS_DYNAMODB_TABLE_COUNT} aws.dynamodb.table_count
 */
export type AWS_DYNAMODB_TABLE_COUNT_TYPE = number;

// Path: model/attributes/aws/aws__dynamodb__table_names.json

/**
 * The keys in the `RequestItems` object field. `aws.dynamodb.table_names`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_DYNAMODB_TABLE_NAMES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["Users","Cats"]
 */
export const AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';

/**
 * Type for {@link AWS_DYNAMODB_TABLE_NAMES} aws.dynamodb.table_names
 */
export type AWS_DYNAMODB_TABLE_NAMES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__dynamodb__total_segments.json

/**
 * The value of the `TotalSegments` request parameter. `aws.dynamodb.total_segments`
 *
 * Attribute Value Type: `number` {@link AWS_DYNAMODB_TOTAL_SEGMENTS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 100
 */
export const AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';

/**
 * Type for {@link AWS_DYNAMODB_TOTAL_SEGMENTS} aws.dynamodb.total_segments
 */
export type AWS_DYNAMODB_TOTAL_SEGMENTS_TYPE = number;

// Path: model/attributes/aws/aws__extended_request_id.json

/**
 * The AWS extended request ID as returned in the response headers. `aws.extended_request_id`
 *
 * Attribute Value Type: `string` {@link AWS_EXTENDED_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_REQUEST_EXTENDED_ID} `aws.request.extended_id`
 *
 * @example "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ="
 */
export const AWS_EXTENDED_REQUEST_ID = 'aws.extended_request_id';

/**
 * Type for {@link AWS_EXTENDED_REQUEST_ID} aws.extended_request_id
 */
export type AWS_EXTENDED_REQUEST_ID_TYPE = string;

// Path: model/attributes/aws/aws__kinesis__stream_name.json

/**
 * The name of the AWS Kinesis stream the request refers to. `aws.kinesis.stream_name`
 *
 * Attribute Value Type: `string` {@link AWS_KINESIS_STREAM_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link _AWS_KINESIS_STREAM_NAME} `aws.kinesis.stream.name`
 *
 * @example "some-stream-name"
 */
export const AWS_KINESIS_STREAM_NAME = 'aws.kinesis.stream_name';

/**
 * Type for {@link AWS_KINESIS_STREAM_NAME} aws.kinesis.stream_name
 */
export type AWS_KINESIS_STREAM_NAME_TYPE = string;

// Path: model/attributes/aws/aws__kinesis__stream__name.json

/**
 * The name of the AWS Kinesis stream the request refers to. `aws.kinesis.stream.name`
 *
 * Attribute Value Type: `string` {@link _AWS_KINESIS_STREAM_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AWS_KINESIS_STREAM_NAME} `aws.kinesis.stream_name`
 *
 * @deprecated Use {@link AWS_KINESIS_STREAM_NAME} (aws.kinesis.stream_name) instead - This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement.
 * @example "some-stream-name"
 */
export const _AWS_KINESIS_STREAM_NAME = 'aws.kinesis.stream.name';

/**
 * Type for {@link _AWS_KINESIS_STREAM_NAME} aws.kinesis.stream.name
 */
export type _AWS_KINESIS_STREAM_NAME_TYPE = string;

// Path: model/attributes/aws/aws__lambda__aws_request_id.json

/**
 * The AWS request ID as received by the Lambda function runtime `aws.lambda.aws_request_id`
 *
 * Attribute Value Type: `string` {@link AWS_LAMBDA_AWS_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FAAS_INVOCATION_ID} `faas.invocation_id`, {@link FAAS_EXECUTION} `faas.execution`
 *
 * @deprecated Use {@link FAAS_INVOCATION_ID} (faas.invocation_id) instead - This attribute is being deprecated in favor of faas.invocation_id
 * @example "8476a536-e9f4-11e8-9739-2dfe598c3fcd"
 */
export const AWS_LAMBDA_AWS_REQUEST_ID = 'aws.lambda.aws_request_id';

/**
 * Type for {@link AWS_LAMBDA_AWS_REQUEST_ID} aws.lambda.aws_request_id
 */
export type AWS_LAMBDA_AWS_REQUEST_ID_TYPE = string;

// Path: model/attributes/aws/aws__lambda__execution_duration_in_millis.json

/**
 * The execution duration of the Lambda function invocation in milliseconds `aws.lambda.execution_duration_in_millis`
 *
 * Attribute Value Type: `number` {@link AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1234.56
 */
export const AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS = 'aws.lambda.execution_duration_in_millis';

/**
 * Type for {@link AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS} aws.lambda.execution_duration_in_millis
 */
export type AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS_TYPE = number;

// Path: model/attributes/aws/aws__lambda__function_name.json

/**
 * The name of the Lambda function `aws.lambda.function_name`
 *
 * Attribute Value Type: `string` {@link AWS_LAMBDA_FUNCTION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FAAS_NAME} `faas.name`
 *
 * @deprecated Use {@link FAAS_NAME} (faas.name) instead - Use the OTel-aligned faas.name attribute instead
 * @example "my-function"
 */
export const AWS_LAMBDA_FUNCTION_NAME = 'aws.lambda.function_name';

/**
 * Type for {@link AWS_LAMBDA_FUNCTION_NAME} aws.lambda.function_name
 */
export type AWS_LAMBDA_FUNCTION_NAME_TYPE = string;

// Path: model/attributes/aws/aws__lambda__function_version.json

/**
 * The version of the Lambda function `aws.lambda.function_version`
 *
 * Attribute Value Type: `string` {@link AWS_LAMBDA_FUNCTION_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FAAS_VERSION} `faas.version`
 *
 * @deprecated Use {@link FAAS_VERSION} (faas.version) instead - Use the OTel-aligned faas.version attribute instead
 * @example "$LATEST"
 */
export const AWS_LAMBDA_FUNCTION_VERSION = 'aws.lambda.function_version';

/**
 * Type for {@link AWS_LAMBDA_FUNCTION_VERSION} aws.lambda.function_version
 */
export type AWS_LAMBDA_FUNCTION_VERSION_TYPE = string;

// Path: model/attributes/aws/aws__lambda__invoked_arn.json

/**
 * The full ARN of the Lambda function that was invoked `aws.lambda.invoked_arn`
 *
 * Attribute Value Type: `string` {@link AWS_LAMBDA_INVOKED_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_LAMBDA_INVOKED_FUNCTION_ARN} `aws.lambda.invoked_function_arn`
 *
 * @example "arn:aws:lambda:us-east-1:123456789012:function:my-function"
 */
export const AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';

/**
 * Type for {@link AWS_LAMBDA_INVOKED_ARN} aws.lambda.invoked_arn
 */
export type AWS_LAMBDA_INVOKED_ARN_TYPE = string;

// Path: model/attributes/aws/aws__lambda__invoked_function_arn.json

/**
 * The full ARN of the Lambda function that was invoked `aws.lambda.invoked_function_arn`
 *
 * Attribute Value Type: `string` {@link AWS_LAMBDA_INVOKED_FUNCTION_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AWS_LAMBDA_INVOKED_ARN} `aws.lambda.invoked_arn`
 *
 * @deprecated Use {@link AWS_LAMBDA_INVOKED_ARN} (aws.lambda.invoked_arn) instead - This attribute is being deprecated in favor of aws.lambda.invoked_arn
 * @example "arn:aws:lambda:us-east-1:123456789012:function:my-function"
 */
export const AWS_LAMBDA_INVOKED_FUNCTION_ARN = 'aws.lambda.invoked_function_arn';

/**
 * Type for {@link AWS_LAMBDA_INVOKED_FUNCTION_ARN} aws.lambda.invoked_function_arn
 */
export type AWS_LAMBDA_INVOKED_FUNCTION_ARN_TYPE = string;

// Path: model/attributes/aws/aws__lambda__remaining_time_in_millis.json

/**
 * The remaining time in milliseconds before the Lambda function times out `aws.lambda.remaining_time_in_millis`
 *
 * Attribute Value Type: `number` {@link AWS_LAMBDA_REMAINING_TIME_IN_MILLIS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 5000
 */
export const AWS_LAMBDA_REMAINING_TIME_IN_MILLIS = 'aws.lambda.remaining_time_in_millis';

/**
 * Type for {@link AWS_LAMBDA_REMAINING_TIME_IN_MILLIS} aws.lambda.remaining_time_in_millis
 */
export type AWS_LAMBDA_REMAINING_TIME_IN_MILLIS_TYPE = number;

// Path: model/attributes/aws/aws__log__group__names.json

/**
 * The name(s) of the AWS log group(s) an application is writing to. `aws.log.group.names`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_LOG_GROUP_NAMES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["/aws/lambda/my-function","opentelemetry-service"]
 */
export const AWS_LOG_GROUP_NAMES = 'aws.log.group.names';

/**
 * Type for {@link AWS_LOG_GROUP_NAMES} aws.log.group.names
 */
export type AWS_LOG_GROUP_NAMES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__log__stream__names.json

/**
 * The name(s) of the AWS log stream(s) an application is writing to. `aws.log.stream.names`
 *
 * Attribute Value Type: `Array<string>` {@link AWS_LOG_STREAM_NAMES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["logs/main/10838bed-421f-43ef-870a-f43feacbbb5b"]
 */
export const AWS_LOG_STREAM_NAMES = 'aws.log.stream.names';

/**
 * Type for {@link AWS_LOG_STREAM_NAMES} aws.log.stream.names
 */
export type AWS_LOG_STREAM_NAMES_TYPE = Array<string>;

// Path: model/attributes/aws/aws__operation_name.json

/**
 * The name of the API operation invoked on an AWS service. `aws.operation_name`
 *
 * Attribute Value Type: `string` {@link AWS_OPERATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link RPC_METHOD} `rpc.method`
 *
 * @deprecated Use {@link RPC_METHOD} (rpc.method) instead - This attribute is being deprecated in favor of rpc.method, which is the framework-agnostic replacement.
 * @example "PutObject"
 */
export const AWS_OPERATION_NAME = 'aws.operation_name';

/**
 * Type for {@link AWS_OPERATION_NAME} aws.operation_name
 */
export type AWS_OPERATION_NAME_TYPE = string;

// Path: model/attributes/aws_region.json

/**
 * The geographical region the AWS resource is running `aws_region`
 *
 * Attribute Value Type: `string` {@link AWS_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CLOUD_REGION} `cloud.region`, {@link GCP_REGION} `gcp_region`
 *
 * @deprecated Use {@link CLOUD_REGION} (cloud.region) instead
 * @example "us-east-1"
 */
export const AWS_REGION = 'aws_region';

/**
 * Type for {@link AWS_REGION} aws_region
 */
export type AWS_REGION_TYPE = string;

// Path: model/attributes/aws/aws__request__extended_id.json

/**
 * The AWS extended request ID as returned in the response headers. `aws.request.extended_id`
 *
 * Attribute Value Type: `string` {@link AWS_REQUEST_EXTENDED_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AWS_EXTENDED_REQUEST_ID} `aws.extended_request_id`
 *
 * @deprecated Use {@link AWS_EXTENDED_REQUEST_ID} (aws.extended_request_id) instead - This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement.
 * @example "wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ="
 */
export const AWS_REQUEST_EXTENDED_ID = 'aws.request.extended_id';

/**
 * Type for {@link AWS_REQUEST_EXTENDED_ID} aws.request.extended_id
 */
export type AWS_REQUEST_EXTENDED_ID_TYPE = string;

// Path: model/attributes/aws/aws__request_id.json

/**
 * The AWS request ID as returned in the response headers. `aws.request_id`
 *
 * Attribute Value Type: `string` {@link AWS_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link _AWS_REQUEST_ID} `aws.request.id`
 *
 * @example "79b9da39-b7ae-508a-a6bc-864b2829c622"
 */
export const AWS_REQUEST_ID = 'aws.request_id';

/**
 * Type for {@link AWS_REQUEST_ID} aws.request_id
 */
export type AWS_REQUEST_ID_TYPE = string;

// Path: model/attributes/aws/aws__request__id.json

/**
 * The AWS request ID as returned in the response headers. `aws.request.id`
 *
 * Attribute Value Type: `string` {@link _AWS_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AWS_REQUEST_ID} `aws.request_id`
 *
 * @deprecated Use {@link AWS_REQUEST_ID} (aws.request_id) instead - This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement.
 * @example "79b9da39-b7ae-508a-a6bc-864b2829c622"
 */
export const _AWS_REQUEST_ID = 'aws.request.id';

/**
 * Type for {@link _AWS_REQUEST_ID} aws.request.id
 */
export type _AWS_REQUEST_ID_TYPE = string;

// Path: model/attributes/aws/aws__request__url.json

/**
 * The URL of the AWS API request. `aws.request.url`
 *
 * Attribute Value Type: `string` {@link AWS_REQUEST_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link URL_FULL} `url.full`, {@link HTTP_URL} `http.url`, {@link URL} `url`, {@link MESSAGING_URL} `messaging.url`
 *
 * @deprecated Use {@link URL_FULL} (url.full) instead - This attribute is being deprecated in favor of url.full, which is the OTel-aligned replacement.
 * @example "https://sqs.us-east-1.amazonaws.com/123456789/my-queue"
 */
export const AWS_REQUEST_URL = 'aws.request.url';

/**
 * Type for {@link AWS_REQUEST_URL} aws.request.url
 */
export type AWS_REQUEST_URL_TYPE = string;

// Path: model/attributes/aws/aws__s3__bucket.json

/**
 * The S3 bucket name the request refers to. `aws.s3.bucket`
 *
 * Attribute Value Type: `string` {@link AWS_S3_BUCKET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ot-demo-test"
 */
export const AWS_S3_BUCKET = 'aws.s3.bucket';

/**
 * Type for {@link AWS_S3_BUCKET} aws.s3.bucket
 */
export type AWS_S3_BUCKET_TYPE = string;

// Path: model/attributes/aws/aws__s3__copy_source.json

/**
 * The source object (in the form bucket/key) for the copy operation. `aws.s3.copy_source`
 *
 * Attribute Value Type: `string` {@link AWS_S3_COPY_SOURCE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "someFile.yml"
 */
export const AWS_S3_COPY_SOURCE = 'aws.s3.copy_source';

/**
 * Type for {@link AWS_S3_COPY_SOURCE} aws.s3.copy_source
 */
export type AWS_S3_COPY_SOURCE_TYPE = string;

// Path: model/attributes/aws/aws__s3__delete.json

/**
 * The delete request container that specifies the objects to be deleted. `aws.s3.delete`
 *
 * Attribute Value Type: `string` {@link AWS_S3_DELETE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Objects=[{Key=string,VersionId=string},{Key=string,VersionId=string}],Quiet=boolean"
 */
export const AWS_S3_DELETE = 'aws.s3.delete';

/**
 * Type for {@link AWS_S3_DELETE} aws.s3.delete
 */
export type AWS_S3_DELETE_TYPE = string;

// Path: model/attributes/aws/aws__s3__key.json

/**
 * The S3 object key the request refers to. Corresponds to the --key parameter of the S3 API operations. `aws.s3.key`
 *
 * Attribute Value Type: `string` {@link AWS_S3_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "someFile.yml"
 */
export const AWS_S3_KEY = 'aws.s3.key';

/**
 * Type for {@link AWS_S3_KEY} aws.s3.key
 */
export type AWS_S3_KEY_TYPE = string;

// Path: model/attributes/aws/aws__s3__part_number.json

/**
 * The part number of the part being uploaded in a multipart-upload operation. This is a positive integer between 1 and 10,000. `aws.s3.part_number`
 *
 * Attribute Value Type: `number` {@link AWS_S3_PART_NUMBER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 3456
 */
export const AWS_S3_PART_NUMBER = 'aws.s3.part_number';

/**
 * Type for {@link AWS_S3_PART_NUMBER} aws.s3.part_number
 */
export type AWS_S3_PART_NUMBER_TYPE = number;

// Path: model/attributes/aws/aws__s3__upload_id.json

/**
 * Upload ID that identifies the multipart upload. `aws.s3.upload_id`
 *
 * Attribute Value Type: `string` {@link AWS_S3_UPLOAD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "dfRtDYWFbkRONycy.Yxwh66Yjlx.cph0gtNBtJ"
 */
export const AWS_S3_UPLOAD_ID = 'aws.s3.upload_id';

/**
 * Type for {@link AWS_S3_UPLOAD_ID} aws.s3.upload_id
 */
export type AWS_S3_UPLOAD_ID_TYPE = string;

// Path: model/attributes/aws/aws__secretsmanager__secret__arn.json

/**
 * The ARN of the Secret stored in Secrets Manager. `aws.secretsmanager.secret.arn`
 *
 * Attribute Value Type: `string` {@link AWS_SECRETSMANAGER_SECRET_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters"
 */
export const AWS_SECRETSMANAGER_SECRET_ARN = 'aws.secretsmanager.secret.arn';

/**
 * Type for {@link AWS_SECRETSMANAGER_SECRET_ARN} aws.secretsmanager.secret.arn
 */
export type AWS_SECRETSMANAGER_SECRET_ARN_TYPE = string;

// Path: model/attributes/aws/aws__sns__topic__arn.json

/**
 * The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel. `aws.sns.topic.arn`
 *
 * Attribute Value Type: `string` {@link AWS_SNS_TOPIC_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE"
 */
export const AWS_SNS_TOPIC_ARN = 'aws.sns.topic.arn';

/**
 * Type for {@link AWS_SNS_TOPIC_ARN} aws.sns.topic.arn
 */
export type AWS_SNS_TOPIC_ARN_TYPE = string;

// Path: model/attributes/aws/aws__sqs__queue__url.json

/**
 * The URL of the AWS SQS Queue. It’s a unique identifier for a queue in Amazon Simple Queue Service (SQS) and is used to access the queue and perform actions on it. `aws.sqs.queue.url`
 *
 * Attribute Value Type: `string` {@link AWS_SQS_QUEUE_URL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "https://sqs.us-east-1.amazonaws.com/123456789012/MyQueue"
 */
export const AWS_SQS_QUEUE_URL = 'aws.sqs.queue.url';

/**
 * Type for {@link AWS_SQS_QUEUE_URL} aws.sqs.queue.url
 */
export type AWS_SQS_QUEUE_URL_TYPE = string;

// Path: model/attributes/aws/aws__step_functions__activity__arn.json

/**
 * The ARN of the AWS Step Functions Activity. `aws.step_functions.activity.arn`
 *
 * Attribute Value Type: `string` {@link AWS_STEP_FUNCTIONS_ACTIVITY_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "arn:aws:states:us-east-1:123456789012:activity:get-greeting"
 */
export const AWS_STEP_FUNCTIONS_ACTIVITY_ARN = 'aws.step_functions.activity.arn';

/**
 * Type for {@link AWS_STEP_FUNCTIONS_ACTIVITY_ARN} aws.step_functions.activity.arn
 */
export type AWS_STEP_FUNCTIONS_ACTIVITY_ARN_TYPE = string;

// Path: model/attributes/aws/aws__step_functions__execution__arn.json

/**
 * The ARN of the AWS Step Functions Execution. `aws.step_functions.execution.arn`
 *
 * Attribute Value Type: `string` {@link AWS_STEP_FUNCTIONS_EXECUTION_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "arn:aws:states:us-east-1:123456789012:execution:myStateMachine:myExecution"
 */
export const AWS_STEP_FUNCTIONS_EXECUTION_ARN = 'aws.step_functions.execution.arn';

/**
 * Type for {@link AWS_STEP_FUNCTIONS_EXECUTION_ARN} aws.step_functions.execution.arn
 */
export type AWS_STEP_FUNCTIONS_EXECUTION_ARN_TYPE = string;

// Path: model/attributes/aws/aws__step_functions__state_machine__arn.json

/**
 * The ARN of the AWS Step Functions State Machine. `aws.step_functions.state_machine.arn`
 *
 * Attribute Value Type: `string` {@link AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1"
 */
export const AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN = 'aws.step_functions.state_machine.arn';

/**
 * Type for {@link AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN} aws.step_functions.state_machine.arn
 */
export type AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN_TYPE = string;

// Path: model/attributes/blocked_main_thread.json

/**
 * Whether the main thread was blocked by the span. `blocked_main_thread`
 *
 * Attribute Value Type: `boolean` {@link BLOCKED_MAIN_THREAD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const BLOCKED_MAIN_THREAD = 'blocked_main_thread';

/**
 * Type for {@link BLOCKED_MAIN_THREAD} blocked_main_thread
 */
export type BLOCKED_MAIN_THREAD_TYPE = boolean;

// Path: model/attributes/browser/browser__bfcache__frame.json

/**
 * Which frame in the page's frame tree a back/forward cache not-restored reason originated from: the top document or a child frame. `browser.bfcache.frame`
 *
 * Attribute Value Type: `string` {@link BROWSER_BFCACHE_FRAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "top"
 * @example "child"
 */
export const BROWSER_BFCACHE_FRAME = 'browser.bfcache.frame';

/**
 * Type for {@link BROWSER_BFCACHE_FRAME} browser.bfcache.frame
 */
export type BROWSER_BFCACHE_FRAME_TYPE = string;

// Path: model/attributes/browser/browser__bfcache__not_restored_reason_count.json

/**
 * The number of reported reasons a page was not restored from the back/forward cache on a back/forward navigation. 0 when the browser reported no reasons (e.g. non-Chromium browsers). `browser.bfcache.not_restored_reason_count`
 *
 * Attribute Value Type: `number` {@link BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2
 */
export const BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT = 'browser.bfcache.not_restored_reason_count';

/**
 * Type for {@link BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT} browser.bfcache.not_restored_reason_count
 */
export type BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT_TYPE = number;

// Path: model/attributes/browser/browser__bfcache__outcome.json

/**
 * Whether a back/forward navigation was restored from the browser's back/forward cache (bfcache). 'hit' means the page was restored; 'miss' means it was reloaded. `browser.bfcache.outcome`
 *
 * Attribute Value Type: `string` {@link BROWSER_BFCACHE_OUTCOME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "hit"
 * @example "miss"
 */
export const BROWSER_BFCACHE_OUTCOME = 'browser.bfcache.outcome';

/**
 * Type for {@link BROWSER_BFCACHE_OUTCOME} browser.bfcache.outcome
 */
export type BROWSER_BFCACHE_OUTCOME_TYPE = string;

// Path: model/attributes/browser/browser__bfcache__reason.json

/**
 * A browser-reported reason a page was not restored from the back/forward cache on a back/forward navigation, taken from the notRestoredReasons API. Reported per reason (a single miss can have several). Currently Chromium-only. `browser.bfcache.reason`
 *
 * Attribute Value Type: `string` {@link BROWSER_BFCACHE_REASON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "unload-listener"
 * @example "websocket"
 * @example "idbversionchangeevent"
 * @example "response-cache-control-no-store"
 */
export const BROWSER_BFCACHE_REASON = 'browser.bfcache.reason';

/**
 * Type for {@link BROWSER_BFCACHE_REASON} browser.bfcache.reason
 */
export type BROWSER_BFCACHE_REASON_TYPE = string;

// Path: model/attributes/browser/browser__name.json

/**
 * The name of the browser. `browser.name`
 *
 * Attribute Value Type: `string` {@link BROWSER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_BROWSER_NAME} `sentry.browser.name`
 *
 * @example "Chrome"
 */
export const BROWSER_NAME = 'browser.name';

/**
 * Type for {@link BROWSER_NAME} browser.name
 */
export type BROWSER_NAME_TYPE = string;

// Path: model/attributes/browser/browser__navigation__id.json

/**
 * The identifier of the navigation the measurement belongs to, incremented by the browser for each navigation within a page's lifetime. `browser.navigation.id`
 *
 * Attribute Value Type: `number` {@link BROWSER_NAVIGATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 * @example 3
 * @example 0
 */
export const BROWSER_NAVIGATION_ID = 'browser.navigation.id';

/**
 * Type for {@link BROWSER_NAVIGATION_ID} browser.navigation.id
 */
export type BROWSER_NAVIGATION_ID_TYPE = number;

// Path: model/attributes/browser/browser__navigation__type.json

/**
 * The type of navigation the browser performed to arrive at the page the metrics were measured on. `browser.navigation.type`
 *
 * Attribute Value Type: `string` {@link BROWSER_NAVIGATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "navigate"
 * @example "reload"
 * @example "back-forward"
 * @example "back-forward-cache"
 * @example "prerender"
 * @example "restore"
 * @example "soft-navigation"
 */
export const BROWSER_NAVIGATION_TYPE = 'browser.navigation.type';

/**
 * Type for {@link BROWSER_NAVIGATION_TYPE} browser.navigation.type
 */
export type BROWSER_NAVIGATION_TYPE_TYPE = string;

// Path: model/attributes/browser/browser__paint__type.json

/**
 * The type of paint timing entry reported by the browser. `browser.paint.type`
 *
 * Attribute Value Type: `string` {@link BROWSER_PAINT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "first-paint"
 * @example "first-contentful-paint"
 */
export const BROWSER_PAINT_TYPE = 'browser.paint.type';

/**
 * Type for {@link BROWSER_PAINT_TYPE} browser.paint.type
 */
export type BROWSER_PAINT_TYPE_TYPE = string;

// Path: model/attributes/browser/browser__performance__navigation__activation_start.json

/**
 * The time between initiating a navigation to a page and the browser activating the page `browser.performance.navigation.activation_start`
 *
 * Attribute Value Type: `number` {@link BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PERFORMANCE_ACTIVATIONSTART} `performance.activationStart`
 *
 * @example 1.983
 */
export const BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START = 'browser.performance.navigation.activation_start';

/**
 * Type for {@link BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START} browser.performance.navigation.activation_start
 */
export type BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START_TYPE = number;

// Path: model/attributes/browser/browser__performance__time_origin.json

/**
 * The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated `browser.performance.time_origin`
 *
 * Attribute Value Type: `number` {@link BROWSER_PERFORMANCE_TIME_ORIGIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PERFORMANCE_TIMEORIGIN} `performance.timeOrigin`
 *
 * @example 1776185678.886
 */
export const BROWSER_PERFORMANCE_TIME_ORIGIN = 'browser.performance.time_origin';

/**
 * Type for {@link BROWSER_PERFORMANCE_TIME_ORIGIN} browser.performance.time_origin
 */
export type BROWSER_PERFORMANCE_TIME_ORIGIN_TYPE = number;

// Path: model/attributes/browser/browser__report__type.json

/**
 * A browser report sent via reporting API.. `browser.report.type`
 *
 * Attribute Value Type: `string` {@link BROWSER_REPORT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "network-error"
 */
export const BROWSER_REPORT_TYPE = 'browser.report.type';

/**
 * Type for {@link BROWSER_REPORT_TYPE} browser.report.type
 */
export type BROWSER_REPORT_TYPE_TYPE = string;

// Path: model/attributes/browser/browser__script__invoker.json

/**
 * How a script was called in the browser. `browser.script.invoker`
 *
 * Attribute Value Type: `string` {@link BROWSER_SCRIPT_INVOKER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Window.requestAnimationFrame"
 */
export const BROWSER_SCRIPT_INVOKER = 'browser.script.invoker';

/**
 * Type for {@link BROWSER_SCRIPT_INVOKER} browser.script.invoker
 */
export type BROWSER_SCRIPT_INVOKER_TYPE = string;

// Path: model/attributes/browser/browser__script__invoker_type.json

/**
 * Browser script entry point type. `browser.script.invoker_type`
 *
 * Attribute Value Type: `string` {@link BROWSER_SCRIPT_INVOKER_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "event-listener"
 */
export const BROWSER_SCRIPT_INVOKER_TYPE = 'browser.script.invoker_type';

/**
 * Type for {@link BROWSER_SCRIPT_INVOKER_TYPE} browser.script.invoker_type
 */
export type BROWSER_SCRIPT_INVOKER_TYPE_TYPE = string;

// Path: model/attributes/browser/browser__script__source_char_position.json

/**
 * A number representing the script character position of the script. `browser.script.source_char_position`
 *
 * Attribute Value Type: `number` {@link BROWSER_SCRIPT_SOURCE_CHAR_POSITION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 678
 */
export const BROWSER_SCRIPT_SOURCE_CHAR_POSITION = 'browser.script.source_char_position';

/**
 * Type for {@link BROWSER_SCRIPT_SOURCE_CHAR_POSITION} browser.script.source_char_position
 */
export type BROWSER_SCRIPT_SOURCE_CHAR_POSITION_TYPE = number;

// Path: model/attributes/browser/browser__version.json

/**
 * The version of the browser. `browser.version`
 *
 * Attribute Value Type: `string` {@link BROWSER_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_BROWSER_VERSION} `sentry.browser.version`
 *
 * @example "120.0.6099.130"
 */
export const BROWSER_VERSION = 'browser.version';

/**
 * Type for {@link BROWSER_VERSION} browser.version
 */
export type BROWSER_VERSION_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__cls__report_event.json

/**
 * The event that caused the SDK to report CLS (pagehide or navigation) `browser.web_vital.cls.report_event`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_CLS_REPORT_EVENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the CLS value is final, so there is no report event to record. No replacement.
 * @example "navigation"
 */
export const BROWSER_WEB_VITAL_CLS_REPORT_EVENT = 'browser.web_vital.cls.report_event';

/**
 * Type for {@link BROWSER_WEB_VITAL_CLS_REPORT_EVENT} browser.web_vital.cls.report_event
 */
export type BROWSER_WEB_VITAL_CLS_REPORT_EVENT_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__cls__source__[key].json

/**
 * The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N `browser.web_vital.cls.source.<key>`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * Aliases: {@link CLS_SOURCE_KEY} `cls.source.<key>`
 *
 * @example "body > div#app"
 */
export const BROWSER_WEB_VITAL_CLS_SOURCE_KEY = 'browser.web_vital.cls.source.<key>';

/**
 * Base key for {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY}. Use with a dynamic suffix, e.g. `${BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE}.${key}`.
 */
export const BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE = 'browser.web_vital.cls.source';

/**
 * Type for {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY} browser.web_vital.cls.source.<key>
 */
export type BROWSER_WEB_VITAL_CLS_SOURCE_KEY_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__cls__value.json

/**
 * The value of the recorded Cumulative Layout Shift (CLS) web vital `browser.web_vital.cls.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_CLS_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CLS} `cls`
 *
 * @example 0.2361
 */
export const BROWSER_WEB_VITAL_CLS_VALUE = 'browser.web_vital.cls.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_CLS_VALUE} browser.web_vital.cls.value
 */
export type BROWSER_WEB_VITAL_CLS_VALUE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__fcp__value.json

/**
 * The time it takes for the browser to render the first piece of meaningful content on the screen `browser.web_vital.fcp.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_FCP_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FCP} `fcp`
 *
 * @example 547.6951
 */
export const BROWSER_WEB_VITAL_FCP_VALUE = 'browser.web_vital.fcp.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_FCP_VALUE} browser.web_vital.fcp.value
 */
export type BROWSER_WEB_VITAL_FCP_VALUE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__fp__value.json

/**
 * The time in milliseconds it takes for the browser to render the first pixel on the screen `browser.web_vital.fp.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_FP_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FP} `fp`
 *
 * @example 477.1926
 */
export const BROWSER_WEB_VITAL_FP_VALUE = 'browser.web_vital.fp.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_FP_VALUE} browser.web_vital.fp.value
 */
export type BROWSER_WEB_VITAL_FP_VALUE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__inp__interaction_type.json

/**
 * The kind of user interaction INP was reported on `browser.web_vital.inp.interaction_type`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_INP_INTERACTION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "click"
 * @example "hover"
 * @example "drag"
 * @example "press"
 */
export const BROWSER_WEB_VITAL_INP_INTERACTION_TYPE = 'browser.web_vital.inp.interaction_type';

/**
 * Type for {@link BROWSER_WEB_VITAL_INP_INTERACTION_TYPE} browser.web_vital.inp.interaction_type
 */
export type BROWSER_WEB_VITAL_INP_INTERACTION_TYPE_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__inp__target.json

/**
 * The HTML element selector or component name of the element the user interacted with, for the interaction INP was reported on `browser.web_vital.inp.target`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_INP_TARGET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "body > div#app > button.submit"
 * @example "SubmitButton"
 */
export const BROWSER_WEB_VITAL_INP_TARGET = 'browser.web_vital.inp.target';

/**
 * Type for {@link BROWSER_WEB_VITAL_INP_TARGET} browser.web_vital.inp.target
 */
export type BROWSER_WEB_VITAL_INP_TARGET_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__inp__value.json

/**
 * The value of the recorded Interaction to Next Paint (INP) web vital `browser.web_vital.inp.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_INP_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link INP} `inp`
 *
 * @example 200
 */
export const BROWSER_WEB_VITAL_INP_VALUE = 'browser.web_vital.inp.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_INP_VALUE} browser.web_vital.inp.value
 */
export type BROWSER_WEB_VITAL_INP_VALUE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__lcp__element.json

/**
 * The HTML element selector or component name for which LCP was reported `browser.web_vital.lcp.element`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_LCP_ELEMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_ELEMENT} `lcp.element`
 *
 * @example "body > div#app > div#container > div"
 */
export const BROWSER_WEB_VITAL_LCP_ELEMENT = 'browser.web_vital.lcp.element';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_ELEMENT} browser.web_vital.lcp.element
 */
export type BROWSER_WEB_VITAL_LCP_ELEMENT_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__lcp__id.json

/**
 * The id of the dom element responsible for the largest contentful paint `browser.web_vital.lcp.id`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_LCP_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_ID} `lcp.id`
 *
 * @example "#gero"
 */
export const BROWSER_WEB_VITAL_LCP_ID = 'browser.web_vital.lcp.id';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_ID} browser.web_vital.lcp.id
 */
export type BROWSER_WEB_VITAL_LCP_ID_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__lcp__load_time.json

/**
 * The time it took for the LCP element to be loaded `browser.web_vital.lcp.load_time`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_LCP_LOAD_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_LOADTIME} `lcp.loadTime`
 *
 * @example 1402
 */
export const BROWSER_WEB_VITAL_LCP_LOAD_TIME = 'browser.web_vital.lcp.load_time';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_LOAD_TIME} browser.web_vital.lcp.load_time
 */
export type BROWSER_WEB_VITAL_LCP_LOAD_TIME_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__lcp__render_time.json

/**
 * The time it took for the LCP element to be rendered `browser.web_vital.lcp.render_time`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_LCP_RENDER_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_RENDERTIME} `lcp.renderTime`
 *
 * @example 1685
 */
export const BROWSER_WEB_VITAL_LCP_RENDER_TIME = 'browser.web_vital.lcp.render_time';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_RENDER_TIME} browser.web_vital.lcp.render_time
 */
export type BROWSER_WEB_VITAL_LCP_RENDER_TIME_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__lcp__report_event.json

/**
 * The event that caused the SDK to report LCP (pagehide or navigation) `browser.web_vital.lcp.report_event`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_LCP_REPORT_EVENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the LCP value is final, so there is no report event to record. No replacement.
 * @example "pagehide"
 */
export const BROWSER_WEB_VITAL_LCP_REPORT_EVENT = 'browser.web_vital.lcp.report_event';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_REPORT_EVENT} browser.web_vital.lcp.report_event
 */
export type BROWSER_WEB_VITAL_LCP_REPORT_EVENT_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__lcp__size.json

/**
 * The size of the largest contentful paint element `browser.web_vital.lcp.size`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_LCP_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_SIZE} `lcp.size`
 *
 * @example 1024
 */
export const BROWSER_WEB_VITAL_LCP_SIZE = 'browser.web_vital.lcp.size';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_SIZE} browser.web_vital.lcp.size
 */
export type BROWSER_WEB_VITAL_LCP_SIZE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__lcp__url.json

/**
 * The url of the dom element responsible for the largest contentful paint `browser.web_vital.lcp.url`
 *
 * Attribute Value Type: `string` {@link BROWSER_WEB_VITAL_LCP_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP_URL} `lcp.url`
 *
 * @example "https://example.com/static/img.png"
 */
export const BROWSER_WEB_VITAL_LCP_URL = 'browser.web_vital.lcp.url';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_URL} browser.web_vital.lcp.url
 */
export type BROWSER_WEB_VITAL_LCP_URL_TYPE = string;

// Path: model/attributes/browser/browser__web_vital__lcp__value.json

/**
 * The value of the recorded Largest Contentful Paint (LCP) web vital `browser.web_vital.lcp.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_LCP_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link LCP} `lcp`
 *
 * @example 2500
 */
export const BROWSER_WEB_VITAL_LCP_VALUE = 'browser.web_vital.lcp.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_LCP_VALUE} browser.web_vital.lcp.value
 */
export type BROWSER_WEB_VITAL_LCP_VALUE_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__ttfb__request_time.json

/**
 * The time it takes for the server to process the initial request and send the first byte of a response to the user's browser `browser.web_vital.ttfb.request_time`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_TTFB_REQUEST_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TTFB_REQUESTTIME} `ttfb.requestTime`
 *
 * @example 1554.5814
 */
export const BROWSER_WEB_VITAL_TTFB_REQUEST_TIME = 'browser.web_vital.ttfb.request_time';

/**
 * Type for {@link BROWSER_WEB_VITAL_TTFB_REQUEST_TIME} browser.web_vital.ttfb.request_time
 */
export type BROWSER_WEB_VITAL_TTFB_REQUEST_TIME_TYPE = number;

// Path: model/attributes/browser/browser__web_vital__ttfb__value.json

/**
 * The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds `browser.web_vital.ttfb.value`
 *
 * Attribute Value Type: `number` {@link BROWSER_WEB_VITAL_TTFB_VALUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TTFB} `ttfb`
 *
 * @example 194.3322
 */
export const BROWSER_WEB_VITAL_TTFB_VALUE = 'browser.web_vital.ttfb.value';

/**
 * Type for {@link BROWSER_WEB_VITAL_TTFB_VALUE} browser.web_vital.ttfb.value
 */
export type BROWSER_WEB_VITAL_TTFB_VALUE_TYPE = number;

// Path: model/attributes/cache/cache__hit.json

/**
 * If the cache was hit during this span. `cache.hit`
 *
 * Attribute Value Type: `boolean` {@link CACHE_HIT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const CACHE_HIT = 'cache.hit';

/**
 * Type for {@link CACHE_HIT} cache.hit
 */
export type CACHE_HIT_TYPE = boolean;

// Path: model/attributes/cache/cache__item_age.json

/**
 * The age of the cache entry in seconds, measured at read time. `cache.item_age`
 *
 * Attribute Value Type: `number` {@link CACHE_ITEM_AGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 5
 * @example 3600
 */
export const CACHE_ITEM_AGE = 'cache.item_age';

/**
 * Type for {@link CACHE_ITEM_AGE} cache.item_age
 */
export type CACHE_ITEM_AGE_TYPE = number;

// Path: model/attributes/cache/cache__item_size.json

/**
 * The size of the requested item in the cache. In bytes. `cache.item_size`
 *
 * Attribute Value Type: `number` {@link CACHE_ITEM_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 58
 */
export const CACHE_ITEM_SIZE = 'cache.item_size';

/**
 * Type for {@link CACHE_ITEM_SIZE} cache.item_size
 */
export type CACHE_ITEM_SIZE_TYPE = number;

// Path: model/attributes/cache/cache__key.json

/**
 * The key of the cache accessed. `cache.key`
 *
 * Attribute Value Type: `Array<string>` {@link CACHE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["my-cache-key","my-other-cache-key"]
 */
export const CACHE_KEY = 'cache.key';

/**
 * Type for {@link CACHE_KEY} cache.key
 */
export type CACHE_KEY_TYPE = Array<string>;

// Path: model/attributes/cache/cache__operation.json

/**
 * The operation being performed on the cache. `cache.operation`
 *
 * Attribute Value Type: `string` {@link CACHE_OPERATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "get"
 * @example "put"
 * @example "remove"
 */
export const CACHE_OPERATION = 'cache.operation';

/**
 * Type for {@link CACHE_OPERATION} cache.operation
 */
export type CACHE_OPERATION_TYPE = string;

// Path: model/attributes/cache/cache__tags.json

/**
 * The tags attached to the cache entry. Tags group entries so a cache can invalidate them together. `cache.tags`
 *
 * Attribute Value Type: `Array<string>` {@link CACHE_TAGS_TYPE}
 *
 * Apply Scrubbing: auto - Applications pick tag values freely and often build them from record identifiers such as a user id.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["blog-posts","post-42"]
 * @example ["products"]
 */
export const CACHE_TAGS = 'cache.tags';

/**
 * Type for {@link CACHE_TAGS} cache.tags
 */
export type CACHE_TAGS_TYPE = Array<string>;

// Path: model/attributes/cache/cache__ttl.json

/**
 * The ttl (maximum lifetime) of the cache in seconds `cache.ttl`
 *
 * Attribute Value Type: `number` {@link CACHE_TTL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 120
 */
export const CACHE_TTL = 'cache.ttl';

/**
 * Type for {@link CACHE_TTL} cache.ttl
 */
export type CACHE_TTL_TYPE = number;

// Path: model/attributes/cache/cache__write.json

/**
 * If the cache operation resulted in a write to the cache. `cache.write`
 *
 * Attribute Value Type: `boolean` {@link CACHE_WRITE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const CACHE_WRITE = 'cache.write';

/**
 * Type for {@link CACHE_WRITE} cache.write
 */
export type CACHE_WRITE_TYPE = boolean;

// Path: model/attributes/channel.json

/**
 * The channel name that is being used. `channel`
 *
 * Attribute Value Type: `string` {@link CHANNEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "mail"
 */
export const CHANNEL = 'channel';

/**
 * Type for {@link CHANNEL} channel
 */
export type CHANNEL_TYPE = string;

// Path: model/attributes/client/client__address.json

/**
 * Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name. `client.address`
 *
 * Attribute Value Type: `string` {@link CLIENT_ADDRESS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_CLIENT_IP} `http.client_ip`
 *
 * @example "example.com"
 */
export const CLIENT_ADDRESS = 'client.address';

/**
 * Type for {@link CLIENT_ADDRESS} client.address
 */
export type CLIENT_ADDRESS_TYPE = string;

// Path: model/attributes/client/client__port.json

/**
 * Client port number. `client.port`
 *
 * Attribute Value Type: `number` {@link CLIENT_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 5432
 */
export const CLIENT_PORT = 'client.port';

/**
 * Type for {@link CLIENT_PORT} client.port
 */
export type CLIENT_PORT_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__d1__duration.json

/**
 * The duration of a Cloudflare D1 operation. `cloudflare.d1.duration`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_D1_DURATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 543
 */
export const CLOUDFLARE_D1_DURATION = 'cloudflare.d1.duration';

/**
 * Type for {@link CLOUDFLARE_D1_DURATION} cloudflare.d1.duration
 */
export type CLOUDFLARE_D1_DURATION_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__d1__query_type.json

/**
 * The type of query executed in a Cloudflare D1 operation `cloudflare.d1.query_type`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_D1_QUERY_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DB_OPERATION_NAME} `db.operation.name`, {@link DB_OPERATION} `db.operation`, {@link REDIS_COMMAND} `redis.command`
 *
 * @deprecated Use {@link DB_OPERATION_NAME} (db.operation.name) instead
 * @example "run"
 */
export const CLOUDFLARE_D1_QUERY_TYPE = 'cloudflare.d1.query_type';

/**
 * Type for {@link CLOUDFLARE_D1_QUERY_TYPE} cloudflare.d1.query_type
 */
export type CLOUDFLARE_D1_QUERY_TYPE_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__d1__rows_read.json

/**
 * The number of rows read in a Cloudflare D1 operation. `cloudflare.d1.rows_read`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_D1_ROWS_READ_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12
 */
export const CLOUDFLARE_D1_ROWS_READ = 'cloudflare.d1.rows_read';

/**
 * Type for {@link CLOUDFLARE_D1_ROWS_READ} cloudflare.d1.rows_read
 */
export type CLOUDFLARE_D1_ROWS_READ_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__d1__rows_written.json

/**
 * The number of rows written in a Cloudflare D1 operation. `cloudflare.d1.rows_written`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_D1_ROWS_WRITTEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12
 */
export const CLOUDFLARE_D1_ROWS_WRITTEN = 'cloudflare.d1.rows_written';

/**
 * Type for {@link CLOUDFLARE_D1_ROWS_WRITTEN} cloudflare.d1.rows_written
 */
export type CLOUDFLARE_D1_ROWS_WRITTEN_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__durable_object__query__bindings.json

/**
 * The number of bound parameters passed to the SQL exec call. `cloudflare.durable_object.query.bindings`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2
 */
export const CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS = 'cloudflare.durable_object.query.bindings';

/**
 * Type for {@link CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS} cloudflare.durable_object.query.bindings
 */
export type CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__durable_object__response__rows_read.json

/**
 * The number of rows read by a Cloudflare Durable Object SQL operation. `cloudflare.durable_object.response.rows_read`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12
 */
export const CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ = 'cloudflare.durable_object.response.rows_read';

/**
 * Type for {@link CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ} cloudflare.durable_object.response.rows_read
 */
export type CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__durable_object__response__rows_written.json

/**
 * The number of rows written by a Cloudflare Durable Object SQL operation. `cloudflare.durable_object.response.rows_written`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN = 'cloudflare.durable_object.response.rows_written';

/**
 * Type for {@link CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN} cloudflare.durable_object.response.rows_written
 */
export type CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__r2__bucket.json

/**
 * The name of the Cloudflare R2 bucket binding `cloudflare.r2.bucket`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_R2_BUCKET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "MY_BUCKET"
 */
export const CLOUDFLARE_R2_BUCKET = 'cloudflare.r2.bucket';

/**
 * Type for {@link CLOUDFLARE_R2_BUCKET} cloudflare.r2.bucket
 */
export type CLOUDFLARE_R2_BUCKET_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__r2__operation.json

/**
 * The R2 API operation being performed `cloudflare.r2.operation`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_R2_OPERATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "GetObject"
 */
export const CLOUDFLARE_R2_OPERATION = 'cloudflare.r2.operation';

/**
 * Type for {@link CLOUDFLARE_R2_OPERATION} cloudflare.r2.operation
 */
export type CLOUDFLARE_R2_OPERATION_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__r2__request__delimiter.json

/**
 * The delimiter used to group objects in an R2 list operation `cloudflare.r2.request.delimiter`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_R2_REQUEST_DELIMITER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "/"
 */
export const CLOUDFLARE_R2_REQUEST_DELIMITER = 'cloudflare.r2.request.delimiter';

/**
 * Type for {@link CLOUDFLARE_R2_REQUEST_DELIMITER} cloudflare.r2.request.delimiter
 */
export type CLOUDFLARE_R2_REQUEST_DELIMITER_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__r2__request__key.json

/**
 * The object key used in the R2 operation `cloudflare.r2.request.key`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_R2_REQUEST_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my-file.txt"
 */
export const CLOUDFLARE_R2_REQUEST_KEY = 'cloudflare.r2.request.key';

/**
 * Type for {@link CLOUDFLARE_R2_REQUEST_KEY} cloudflare.r2.request.key
 */
export type CLOUDFLARE_R2_REQUEST_KEY_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__r2__request__part_number.json

/**
 * The part number in a multipart upload operation `cloudflare.r2.request.part_number`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_R2_REQUEST_PART_NUMBER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const CLOUDFLARE_R2_REQUEST_PART_NUMBER = 'cloudflare.r2.request.part_number';

/**
 * Type for {@link CLOUDFLARE_R2_REQUEST_PART_NUMBER} cloudflare.r2.request.part_number
 */
export type CLOUDFLARE_R2_REQUEST_PART_NUMBER_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__r2__request__prefix.json

/**
 * The prefix used to filter objects in an R2 list operation `cloudflare.r2.request.prefix`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_R2_REQUEST_PREFIX_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "images/"
 */
export const CLOUDFLARE_R2_REQUEST_PREFIX = 'cloudflare.r2.request.prefix';

/**
 * Type for {@link CLOUDFLARE_R2_REQUEST_PREFIX} cloudflare.r2.request.prefix
 */
export type CLOUDFLARE_R2_REQUEST_PREFIX_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__workflow__attempt.json

/**
 * The current attempt number for a Cloudflare Workflow step `cloudflare.workflow.attempt`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_WORKFLOW_ATTEMPT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const CLOUDFLARE_WORKFLOW_ATTEMPT = 'cloudflare.workflow.attempt';

/**
 * Type for {@link CLOUDFLARE_WORKFLOW_ATTEMPT} cloudflare.workflow.attempt
 */
export type CLOUDFLARE_WORKFLOW_ATTEMPT_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__workflow__retries__backoff.json

/**
 * The backoff strategy for Cloudflare Workflow step retries `cloudflare.workflow.retries.backoff`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "exponential"
 */
export const CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF = 'cloudflare.workflow.retries.backoff';

/**
 * Type for {@link CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF} cloudflare.workflow.retries.backoff
 */
export type CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__workflow__retries__delay.json

/**
 * The delay between Cloudflare Workflow step retries `cloudflare.workflow.retries.delay`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_WORKFLOW_RETRIES_DELAY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "5 seconds"
 */
export const CLOUDFLARE_WORKFLOW_RETRIES_DELAY = 'cloudflare.workflow.retries.delay';

/**
 * Type for {@link CLOUDFLARE_WORKFLOW_RETRIES_DELAY} cloudflare.workflow.retries.delay
 */
export type CLOUDFLARE_WORKFLOW_RETRIES_DELAY_TYPE = string;

// Path: model/attributes/cloudflare/cloudflare__workflow__retries__limit.json

/**
 * The maximum number of retries for a Cloudflare Workflow step `cloudflare.workflow.retries.limit`
 *
 * Attribute Value Type: `number` {@link CLOUDFLARE_WORKFLOW_RETRIES_LIMIT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 3
 */
export const CLOUDFLARE_WORKFLOW_RETRIES_LIMIT = 'cloudflare.workflow.retries.limit';

/**
 * Type for {@link CLOUDFLARE_WORKFLOW_RETRIES_LIMIT} cloudflare.workflow.retries.limit
 */
export type CLOUDFLARE_WORKFLOW_RETRIES_LIMIT_TYPE = number;

// Path: model/attributes/cloudflare/cloudflare__workflow__timeout.json

/**
 * The timeout duration for a Cloudflare Workflow step `cloudflare.workflow.timeout`
 *
 * Attribute Value Type: `string` {@link CLOUDFLARE_WORKFLOW_TIMEOUT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1 minute"
 */
export const CLOUDFLARE_WORKFLOW_TIMEOUT = 'cloudflare.workflow.timeout';

/**
 * Type for {@link CLOUDFLARE_WORKFLOW_TIMEOUT} cloudflare.workflow.timeout
 */
export type CLOUDFLARE_WORKFLOW_TIMEOUT_TYPE = string;

// Path: model/attributes/cloud/cloud__account__id.json

/**
 * The cloud account ID the resource is assigned to `cloud.account.id`
 *
 * Attribute Value Type: `string` {@link CLOUD_ACCOUNT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "123456789012"
 */
export const CLOUD_ACCOUNT_ID = 'cloud.account.id';

/**
 * Type for {@link CLOUD_ACCOUNT_ID} cloud.account.id
 */
export type CLOUD_ACCOUNT_ID_TYPE = string;

// Path: model/attributes/cloud/cloud__availability_zone.json

/**
 * Cloud regions often have multiple, isolated locations known as zones to increase availability `cloud.availability_zone`
 *
 * Attribute Value Type: `string` {@link CLOUD_AVAILABILITY_ZONE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "us-east-1c"
 */
export const CLOUD_AVAILABILITY_ZONE = 'cloud.availability_zone';

/**
 * Type for {@link CLOUD_AVAILABILITY_ZONE} cloud.availability_zone
 */
export type CLOUD_AVAILABILITY_ZONE_TYPE = string;

// Path: model/attributes/cloud/cloud__platform.json

/**
 * The cloud platform in use `cloud.platform`
 *
 * Attribute Value Type: `string` {@link CLOUD_PLATFORM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "aws_lambda"
 */
export const CLOUD_PLATFORM = 'cloud.platform';

/**
 * Type for {@link CLOUD_PLATFORM} cloud.platform
 */
export type CLOUD_PLATFORM_TYPE = string;

// Path: model/attributes/cloud/cloud__provider.json

/**
 * Name of the cloud provider `cloud.provider`
 *
 * Attribute Value Type: `string` {@link CLOUD_PROVIDER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "aws"
 */
export const CLOUD_PROVIDER = 'cloud.provider';

/**
 * Type for {@link CLOUD_PROVIDER} cloud.provider
 */
export type CLOUD_PROVIDER_TYPE = string;

// Path: model/attributes/cloud/cloud__region.json

/**
 * The geographical region the resource is running `cloud.region`
 *
 * Attribute Value Type: `string` {@link CLOUD_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_REGION} `aws_region`, {@link GCP_REGION} `gcp_region`
 *
 * @example "us-east-1"
 */
export const CLOUD_REGION = 'cloud.region';

/**
 * Type for {@link CLOUD_REGION} cloud.region
 */
export type CLOUD_REGION_TYPE = string;

// Path: model/attributes/cloud/cloud__resource_id.json

/**
 * Cloud provider-specific native identifier of the monitored cloud resource `cloud.resource_id`
 *
 * Attribute Value Type: `string` {@link CLOUD_RESOURCE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link FAAS_ID} `faas.id`
 *
 * @example "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function"
 */
export const CLOUD_RESOURCE_ID = 'cloud.resource_id';

/**
 * Type for {@link CLOUD_RESOURCE_ID} cloud.resource_id
 */
export type CLOUD_RESOURCE_ID_TYPE = string;

// Path: model/attributes/cls.json

/**
 * The value of the recorded Cumulative Layout Shift (CLS) web vital `cls`
 *
 * Attribute Value Type: `number` {@link CLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_CLS_VALUE} `browser.web_vital.cls.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_CLS_VALUE} (browser.web_vital.cls.value) instead - The CLS web vital is now recorded as a browser.web_vital.cls.value attribute.
 * @example 0.2361
 */
export const CLS = 'cls';

/**
 * Type for {@link CLS} cls
 */
export type CLS_TYPE = number;

// Path: model/attributes/cls/cls__source__[key].json

/**
 * The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N `cls.source.<key>`
 *
 * Attribute Value Type: `string` {@link CLS_SOURCE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * Aliases: {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY} `browser.web_vital.cls.source.<key>`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY} (browser.web_vital.cls.source.<key>) instead - The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute.
 * @example "body > div#app"
 */
export const CLS_SOURCE_KEY = 'cls.source.<key>';

/**
 * Base key for {@link CLS_SOURCE_KEY}. Use with a dynamic suffix, e.g. `${CLS_SOURCE_KEY_BASE}.${key}`.
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_CLS_SOURCE_KEY_BASE} (browser.web_vital.cls.source) instead - The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute.
 */
export const CLS_SOURCE_KEY_BASE = 'cls.source';

/**
 * Type for {@link CLS_SOURCE_KEY} cls.source.<key>
 */
export type CLS_SOURCE_KEY_TYPE = string;

// Path: model/attributes/code.json

/**
 * Status code of the RPC returned by the RPC server or generated by the client. `code`
 *
 * Attribute Value Type: `string` {@link CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link RPC_GRPC_STATUS_CODE} `rpc.grpc.status_code`, {@link RPC_RESPONSE_STATUS_CODE} `rpc.response.status_code`
 *
 * @deprecated Use {@link RPC_RESPONSE_STATUS_CODE} (rpc.response.status_code) instead
 * @example "DEADLINE_EXCEEDED"
 */
export const CODE = 'code';

/**
 * Type for {@link CODE} code
 */
export type CODE_TYPE = string;

// Path: model/attributes/code/code__filepath.json

/**
 * The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path). `code.filepath`
 *
 * Attribute Value Type: `string` {@link CODE_FILEPATH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_FILE_PATH} `code.file.path`, {@link SVELTEKIT_LOAD_NODE_ID} `sveltekit.load.node_id`
 *
 * @deprecated Use {@link CODE_FILE_PATH} (code.file.path) instead
 * @example "/app/myapplication/http/handler/server.py"
 */
export const CODE_FILEPATH = 'code.filepath';

/**
 * Type for {@link CODE_FILEPATH} code.filepath
 */
export type CODE_FILEPATH_TYPE = string;

// Path: model/attributes/code/code__file__path.json

/**
 * The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path). `code.file.path`
 *
 * Attribute Value Type: `string` {@link CODE_FILE_PATH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_FILEPATH} `code.filepath`, {@link SVELTEKIT_LOAD_NODE_ID} `sveltekit.load.node_id`
 *
 * @example "/app/myapplication/http/handler/server.py"
 */
export const CODE_FILE_PATH = 'code.file.path';

/**
 * Type for {@link CODE_FILE_PATH} code.file.path
 */
export type CODE_FILE_PATH_TYPE = string;

// Path: model/attributes/code/code__function.json

/**
 * The method or function name, or equivalent (usually rightmost part of the code unit's name). `code.function`
 *
 * Attribute Value Type: `string` {@link CODE_FUNCTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_FUNCTION_NAME} `code.function.name`, {@link DJANGO_FUNCTION_NAME} `django.function_name`
 *
 * @example "server_request"
 */
export const CODE_FUNCTION = 'code.function';

/**
 * Type for {@link CODE_FUNCTION} code.function
 */
export type CODE_FUNCTION_TYPE = string;

// Path: model/attributes/code/code__function__name.json

/**
 * The method or function fully-qualified name without arguments. `code.function.name`
 *
 * Attribute Value Type: `string` {@link CODE_FUNCTION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_FUNCTION} `code.function`, {@link DJANGO_FUNCTION_NAME} `django.function_name`
 *
 * @example "server_request"
 */
export const CODE_FUNCTION_NAME = 'code.function.name';

/**
 * Type for {@link CODE_FUNCTION_NAME} code.function.name
 */
export type CODE_FUNCTION_NAME_TYPE = string;

// Path: model/attributes/code/code__lineno.json

/**
 * The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function `code.lineno`
 *
 * Attribute Value Type: `number` {@link CODE_LINENO_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_LINE_NUMBER} `code.line.number`
 *
 * @deprecated Use {@link CODE_LINE_NUMBER} (code.line.number) instead
 * @example 42
 */
export const CODE_LINENO = 'code.lineno';

/**
 * Type for {@link CODE_LINENO} code.lineno
 */
export type CODE_LINENO_TYPE = number;

// Path: model/attributes/code/code__line__number.json

/**
 * The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function `code.line.number`
 *
 * Attribute Value Type: `number` {@link CODE_LINE_NUMBER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE_LINENO} `code.lineno`
 *
 * @example 42
 */
export const CODE_LINE_NUMBER = 'code.line.number';

/**
 * Type for {@link CODE_LINE_NUMBER} code.line.number
 */
export type CODE_LINE_NUMBER_TYPE = number;

// Path: model/attributes/code/code__namespace.json

/**
 * The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit. `code.namespace`
 *
 * Attribute Value Type: `string` {@link CODE_NAMESPACE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "http.handler"
 */
export const CODE_NAMESPACE = 'code.namespace';

/**
 * Type for {@link CODE_NAMESPACE} code.namespace
 */
export type CODE_NAMESPACE_TYPE = string;

// Path: model/attributes/connectionType.json

/**
 * Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc). `connectionType`
 *
 * Attribute Value Type: `string` {@link CONNECTIONTYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_CONNECTION_TYPE} `network.connection.type`, {@link DEVICE_CONNECTION_TYPE} `device.connection_type`
 *
 * @deprecated Use {@link NETWORK_CONNECTION_TYPE} (network.connection.type) instead - Old namespace-less attribute, to be replaced with network.connection.type for span-first future
 * @example "wifi"
 */
export const CONNECTIONTYPE = 'connectionType';

/**
 * Type for {@link CONNECTIONTYPE} connectionType
 */
export type CONNECTIONTYPE_TYPE = string;

// Path: model/attributes/connection/connection__rtt.json

/**
 * Specifies the estimated effective round-trip time of the current connection, in milliseconds. `connection.rtt`
 *
 * Attribute Value Type: `number` {@link CONNECTION_RTT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_CONNECTION_RTT} `network.connection.rtt`
 *
 * @deprecated Use {@link NETWORK_CONNECTION_RTT} (network.connection.rtt) instead - Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future
 * @example 100
 */
export const CONNECTION_RTT = 'connection.rtt';

/**
 * Type for {@link CONNECTION_RTT} connection.rtt
 */
export type CONNECTION_RTT_TYPE = number;

// Path: model/attributes/culture/culture__calendar.json

/**
 * The calendar system used by the culture. `culture.calendar`
 *
 * Attribute Value Type: `string` {@link CULTURE_CALENDAR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "GregorianCalendar"
 */
export const CULTURE_CALENDAR = 'culture.calendar';

/**
 * Type for {@link CULTURE_CALENDAR} culture.calendar
 */
export type CULTURE_CALENDAR_TYPE = string;

// Path: model/attributes/culture/culture__display_name.json

/**
 * Human readable name of the culture. `culture.display_name`
 *
 * Attribute Value Type: `string` {@link CULTURE_DISPLAY_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "English (United States)"
 */
export const CULTURE_DISPLAY_NAME = 'culture.display_name';

/**
 * Type for {@link CULTURE_DISPLAY_NAME} culture.display_name
 */
export type CULTURE_DISPLAY_NAME_TYPE = string;

// Path: model/attributes/culture/culture__is_24_hour_format.json

/**
 * Whether the culture uses 24-hour time format. `culture.is_24_hour_format`
 *
 * Attribute Value Type: `boolean` {@link CULTURE_IS_24_HOUR_FORMAT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const CULTURE_IS_24_HOUR_FORMAT = 'culture.is_24_hour_format';

/**
 * Type for {@link CULTURE_IS_24_HOUR_FORMAT} culture.is_24_hour_format
 */
export type CULTURE_IS_24_HOUR_FORMAT_TYPE = boolean;

// Path: model/attributes/culture/culture__locale.json

/**
 * The locale identifier following RFC 4646. `culture.locale`
 *
 * Attribute Value Type: `string` {@link CULTURE_LOCALE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "en-US"
 */
export const CULTURE_LOCALE = 'culture.locale';

/**
 * Type for {@link CULTURE_LOCALE} culture.locale
 */
export type CULTURE_LOCALE_TYPE = string;

// Path: model/attributes/culture/culture__timezone.json

/**
 * The timezone of the culture, as a geographic timezone identifier. `culture.timezone`
 *
 * Attribute Value Type: `string` {@link CULTURE_TIMEZONE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Europe/Vienna"
 */
export const CULTURE_TIMEZONE = 'culture.timezone';

/**
 * Type for {@link CULTURE_TIMEZONE} culture.timezone
 */
export type CULTURE_TIMEZONE_TYPE = string;

// Path: model/attributes/db/db__collection__name.json

/**
 * The name of a collection (table, container) within the database. `db.collection.name`
 *
 * Attribute Value Type: `string` {@link DB_COLLECTION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_MONGODB_COLLECTION} `db.mongodb.collection`
 *
 * @example "users"
 */
export const DB_COLLECTION_NAME = 'db.collection.name';

/**
 * Type for {@link DB_COLLECTION_NAME} db.collection.name
 */
export type DB_COLLECTION_NAME_TYPE = string;

// Path: model/attributes/db/db__connection_string.json

/**
 * The connection string used to connect to the database. `db.connection_string`
 *
 * Attribute Value Type: `string` {@link DB_CONNECTION_STRING_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The connection is described by server.address and server.port instead, so the value cannot be copied to a single replacement attribute.
 * @example "redis://localhost:6379"
 */
export const DB_CONNECTION_STRING = 'db.connection_string';

/**
 * Type for {@link DB_CONNECTION_STRING} db.connection_string
 */
export type DB_CONNECTION_STRING_TYPE = string;

// Path: model/attributes/db/db__driver__name.json

/**
 * The name of the driver used for the database connection. `db.driver.name`
 *
 * Attribute Value Type: `string` {@link DB_DRIVER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "psycopg2"
 */
export const DB_DRIVER_NAME = 'db.driver.name';

/**
 * Type for {@link DB_DRIVER_NAME} db.driver.name
 */
export type DB_DRIVER_NAME_TYPE = string;

// Path: model/attributes/db/db__mongodb__collection.json

/**
 * The MongoDB collection being accessed. `db.mongodb.collection`
 *
 * Attribute Value Type: `string` {@link DB_MONGODB_COLLECTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DB_COLLECTION_NAME} `db.collection.name`
 *
 * @deprecated Use {@link DB_COLLECTION_NAME} (db.collection.name) instead - This attribute is being deprecated in favor of db.collection.name, which is the OTel-aligned replacement.
 * @example "users"
 */
export const DB_MONGODB_COLLECTION = 'db.mongodb.collection';

/**
 * Type for {@link DB_MONGODB_COLLECTION} db.mongodb.collection
 */
export type DB_MONGODB_COLLECTION_TYPE = string;

// Path: model/attributes/db/db__name.json

/**
 * The name of the database being accessed. `db.name`
 *
 * Attribute Value Type: `string` {@link DB_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_NAMESPACE} `db.namespace`
 *
 * @deprecated Use {@link DB_NAMESPACE} (db.namespace) instead
 * @example "customers"
 */
export const DB_NAME = 'db.name';

/**
 * Type for {@link DB_NAME} db.name
 */
export type DB_NAME_TYPE = string;

// Path: model/attributes/db/db__namespace.json

/**
 * The name of the database being accessed. `db.namespace`
 *
 * Attribute Value Type: `string` {@link DB_NAMESPACE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_NAME} `db.name`
 *
 * @example "customers"
 */
export const DB_NAMESPACE = 'db.namespace';

/**
 * Type for {@link DB_NAMESPACE} db.namespace
 */
export type DB_NAMESPACE_TYPE = string;

// Path: model/attributes/db/db__operation.json

/**
 * The name of the operation being executed. `db.operation`
 *
 * Attribute Value Type: `string` {@link DB_OPERATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_OPERATION_NAME} `db.operation.name`, {@link CLOUDFLARE_D1_QUERY_TYPE} `cloudflare.d1.query_type`, {@link REDIS_COMMAND} `redis.command`
 *
 * @deprecated Use {@link DB_OPERATION_NAME} (db.operation.name) instead
 * @example "SELECT"
 */
export const DB_OPERATION = 'db.operation';

/**
 * Type for {@link DB_OPERATION} db.operation
 */
export type DB_OPERATION_TYPE = string;

// Path: model/attributes/db/db__operation__batch__size.json

/**
 * The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1. `db.operation.batch.size`
 *
 * Attribute Value Type: `number` {@link DB_OPERATION_BATCH_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 3
 */
export const DB_OPERATION_BATCH_SIZE = 'db.operation.batch.size';

/**
 * Type for {@link DB_OPERATION_BATCH_SIZE} db.operation.batch.size
 */
export type DB_OPERATION_BATCH_SIZE_TYPE = number;

// Path: model/attributes/db/db__operation__name.json

/**
 * The name of the operation being executed. `db.operation.name`
 *
 * Attribute Value Type: `string` {@link DB_OPERATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_OPERATION} `db.operation`, {@link CLOUDFLARE_D1_QUERY_TYPE} `cloudflare.d1.query_type`, {@link REDIS_COMMAND} `redis.command`
 *
 * @example "SELECT"
 */
export const DB_OPERATION_NAME = 'db.operation.name';

/**
 * Type for {@link DB_OPERATION_NAME} db.operation.name
 */
export type DB_OPERATION_NAME_TYPE = string;

// Path: model/attributes/db/db__params.json

/**
 * The query bindings for a database request. `db.params`
 *
 * Attribute Value Type: `string` {@link DB_PARAMS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link DB_QUERY_PARAMETER_KEY} (db.query.parameter.<key>) instead - Instead of adding every binding in the db.params attribute, add them as individual entries with db.query.parameter.<key>.
 * @example "[{\"x\": 100}]"
 */
export const DB_PARAMS = 'db.params';

/**
 * Type for {@link DB_PARAMS} db.params
 */
export type DB_PARAMS_TYPE = string;

// Path: model/attributes/db/db__query__parameter__[key].json

/**
 * A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value. `db.query.parameter.<key>`
 *
 * Attribute Value Type: `string` {@link DB_QUERY_PARAMETER_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "db.query.parameter.foo='123'"
 */
export const DB_QUERY_PARAMETER_KEY = 'db.query.parameter.<key>';

/**
 * Base key for {@link DB_QUERY_PARAMETER_KEY}. Use with a dynamic suffix, e.g. `${DB_QUERY_PARAMETER_KEY_BASE}.${key}`.
 */
export const DB_QUERY_PARAMETER_KEY_BASE = 'db.query.parameter';

/**
 * Type for {@link DB_QUERY_PARAMETER_KEY} db.query.parameter.<key>
 */
export type DB_QUERY_PARAMETER_KEY_TYPE = string;

// Path: model/attributes/db/db__query__summary.json

/**
 * A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names. `db.query.summary`
 *
 * Attribute Value Type: `string` {@link DB_QUERY_SUMMARY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "SELECT users"
 * @example "INSERT products; UPDATE orders"
 */
export const DB_QUERY_SUMMARY = 'db.query.summary';

/**
 * Type for {@link DB_QUERY_SUMMARY} db.query.summary
 */
export type DB_QUERY_SUMMARY_TYPE = string;

// Path: model/attributes/db/db__query__text.json

/**
 * The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value. `db.query.text`
 *
 * Attribute Value Type: `string` {@link DB_QUERY_TEXT_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_STATEMENT} `db.statement`, {@link QUERY} `query`
 *
 * @example "SELECT * FROM users WHERE id = $1"
 */
export const DB_QUERY_TEXT = 'db.query.text';

/**
 * Type for {@link DB_QUERY_TEXT} db.query.text
 */
export type DB_QUERY_TEXT_TYPE = string;

// Path: model/attributes/db/db__redis__connection.json

/**
 * The redis connection name. `db.redis.connection`
 *
 * Attribute Value Type: `string` {@link DB_REDIS_CONNECTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my-redis-instance"
 */
export const DB_REDIS_CONNECTION = 'db.redis.connection';

/**
 * Type for {@link DB_REDIS_CONNECTION} db.redis.connection
 */
export type DB_REDIS_CONNECTION_TYPE = string;

// Path: model/attributes/db/db__redis__key.json

/**
 * The key the Redis command is operating on. `db.redis.key`
 *
 * Attribute Value Type: `string` {@link DB_REDIS_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REDIS_KEY} `redis.key`
 *
 * @example "user:2047:city"
 */
export const DB_REDIS_KEY = 'db.redis.key';

/**
 * Type for {@link DB_REDIS_KEY} db.redis.key
 */
export type DB_REDIS_KEY_TYPE = string;

// Path: model/attributes/db/db__redis__parameters.json

/**
 * The array of command parameters given to a redis command. `db.redis.parameters`
 *
 * Attribute Value Type: `Array<string>` {@link DB_REDIS_PARAMETERS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["test","*"]
 */
export const DB_REDIS_PARAMETERS = 'db.redis.parameters';

/**
 * Type for {@link DB_REDIS_PARAMETERS} db.redis.parameters
 */
export type DB_REDIS_PARAMETERS_TYPE = Array<string>;

// Path: model/attributes/db/db__response__status_code.json

/**
 * Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes. `db.response.status_code`
 *
 * Attribute Value Type: `string` {@link DB_RESPONSE_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ORA-17002"
 */
export const DB_RESPONSE_STATUS_CODE = 'db.response.status_code';

/**
 * Type for {@link DB_RESPONSE_STATUS_CODE} db.response.status_code
 */
export type DB_RESPONSE_STATUS_CODE_TYPE = string;

// Path: model/attributes/db/db__sql__bindings.json

/**
 * The array of query bindings. `db.sql.bindings`
 *
 * Attribute Value Type: `Array<string>` {@link DB_SQL_BINDINGS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link DB_QUERY_PARAMETER_KEY} (db.query.parameter.<key>) instead - Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>.
 * @example ["1","foo"]
 */
export const DB_SQL_BINDINGS = 'db.sql.bindings';

/**
 * Type for {@link DB_SQL_BINDINGS} db.sql.bindings
 */
export type DB_SQL_BINDINGS_TYPE = Array<string>;

// Path: model/attributes/db/db__statement.json

/**
 * The database statement being executed. `db.statement`
 *
 * Attribute Value Type: `string` {@link DB_STATEMENT_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_QUERY_TEXT} `db.query.text`, {@link QUERY} `query`
 *
 * @deprecated Use {@link DB_QUERY_TEXT} (db.query.text) instead - While this attribute never specifically required parameterization, the replacement, db.query.text, does.
 * @example "SELECT * FROM users WHERE id = $1"
 */
export const DB_STATEMENT = 'db.statement';

/**
 * Type for {@link DB_STATEMENT} db.statement
 */
export type DB_STATEMENT_TYPE = string;

// Path: model/attributes/db/db__stored_procedure__name.json

/**
 * The name of a stored procedure being called. `db.stored_procedure.name`
 *
 * Attribute Value Type: `string` {@link DB_STORED_PROCEDURE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "GetUserById"
 */
export const DB_STORED_PROCEDURE_NAME = 'db.stored_procedure.name';

/**
 * Type for {@link DB_STORED_PROCEDURE_NAME} db.stored_procedure.name
 */
export type DB_STORED_PROCEDURE_NAME_TYPE = string;

// Path: model/attributes/db/db__system.json

/**
 * An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers. `db.system`
 *
 * Attribute Value Type: `string` {@link DB_SYSTEM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_SYSTEM_NAME} `db.system.name`
 *
 * @deprecated Use {@link DB_SYSTEM_NAME} (db.system.name) instead
 * @example "postgresql"
 */
export const DB_SYSTEM = 'db.system';

/**
 * Type for {@link DB_SYSTEM} db.system
 */
export type DB_SYSTEM_TYPE = string;

// Path: model/attributes/db/db__system__name.json

/**
 * An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers. `db.system.name`
 *
 * Attribute Value Type: `string` {@link DB_SYSTEM_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DB_SYSTEM} `db.system`
 *
 * @example "postgresql"
 */
export const DB_SYSTEM_NAME = 'db.system.name';

/**
 * Type for {@link DB_SYSTEM_NAME} db.system.name
 */
export type DB_SYSTEM_NAME_TYPE = string;

// Path: model/attributes/db/db__user.json

/**
 * The database user. `db.user`
 *
 * Attribute Value Type: `string` {@link DB_USER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "fancy_user"
 */
export const DB_USER = 'db.user';

/**
 * Type for {@link DB_USER} db.user
 */
export type DB_USER_TYPE = string;

// Path: model/attributes/deviceMemory.json

/**
 * The estimated total memory capacity of the device, only a rough estimation in gigabytes. `deviceMemory`
 *
 * Attribute Value Type: `string` {@link DEVICEMEMORY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DEVICE_MEMORY_ESTIMATED_CAPACITY} `device.memory.estimated_capacity`
 *
 * @deprecated Use {@link DEVICE_MEMORY_ESTIMATED_CAPACITY} (device.memory.estimated_capacity) instead - Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future
 * @example "8 GB"
 */
export const DEVICEMEMORY = 'deviceMemory';

/**
 * Type for {@link DEVICEMEMORY} deviceMemory
 */
export type DEVICEMEMORY_TYPE = string;

// Path: model/attributes/device/device__archs.json

/**
 * The CPU architectures of the device. `device.archs`
 *
 * Attribute Value Type: `Array<string>` {@link DEVICE_ARCHS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["arm64-v8a","armeabi-v7a","armeabi"]
 */
export const DEVICE_ARCHS = 'device.archs';

/**
 * Type for {@link DEVICE_ARCHS} device.archs
 */
export type DEVICE_ARCHS_TYPE = Array<string>;

// Path: model/attributes/device/device__battery_level.json

/**
 * The battery level of the device as a percentage (0-100). `device.battery_level`
 *
 * Attribute Value Type: `number` {@link DEVICE_BATTERY_LEVEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 100
 */
export const DEVICE_BATTERY_LEVEL = 'device.battery_level';

/**
 * Type for {@link DEVICE_BATTERY_LEVEL} device.battery_level
 */
export type DEVICE_BATTERY_LEVEL_TYPE = number;

// Path: model/attributes/device/device__battery_temperature.json

/**
 * The battery temperature of the device in Celsius. `device.battery_temperature`
 *
 * Attribute Value Type: `number` {@link DEVICE_BATTERY_TEMPERATURE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 25
 */
export const DEVICE_BATTERY_TEMPERATURE = 'device.battery_temperature';

/**
 * Type for {@link DEVICE_BATTERY_TEMPERATURE} device.battery_temperature
 */
export type DEVICE_BATTERY_TEMPERATURE_TYPE = number;

// Path: model/attributes/device/device__boot_time.json

/**
 * A formatted UTC timestamp when the system was booted. `device.boot_time`
 *
 * Attribute Value Type: `string` {@link DEVICE_BOOT_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "2018-02-08T12:52:12Z"
 */
export const DEVICE_BOOT_TIME = 'device.boot_time';

/**
 * Type for {@link DEVICE_BOOT_TIME} device.boot_time
 */
export type DEVICE_BOOT_TIME_TYPE = string;

// Path: model/attributes/device/device__brand.json

/**
 * The brand of the device. `device.brand`
 *
 * Attribute Value Type: `string` {@link DEVICE_BRAND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Apple"
 */
export const DEVICE_BRAND = 'device.brand';

/**
 * Type for {@link DEVICE_BRAND} device.brand
 */
export type DEVICE_BRAND_TYPE = string;

// Path: model/attributes/device/device__charging.json

/**
 * Whether the device was charging or not. `device.charging`
 *
 * Attribute Value Type: `boolean` {@link DEVICE_CHARGING_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example false
 */
export const DEVICE_CHARGING = 'device.charging';

/**
 * Type for {@link DEVICE_CHARGING} device.charging
 */
export type DEVICE_CHARGING_TYPE = boolean;

// Path: model/attributes/device/device__chipset.json

/**
 * The chipset of the device. `device.chipset`
 *
 * Attribute Value Type: `string` {@link DEVICE_CHIPSET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Qualcomm SM8550"
 */
export const DEVICE_CHIPSET = 'device.chipset';

/**
 * Type for {@link DEVICE_CHIPSET} device.chipset
 */
export type DEVICE_CHIPSET_TYPE = string;

// Path: model/attributes/device/device__class.json

/**
 * The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly. `device.class`
 *
 * Attribute Value Type: `string` {@link DEVICE_CLASS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "medium"
 */
export const DEVICE_CLASS = 'device.class';

/**
 * Type for {@link DEVICE_CLASS} device.class
 */
export type DEVICE_CLASS_TYPE = string;

// Path: model/attributes/device/device__connection_type.json

/**
 * The internet connection type currently being used by the device. `device.connection_type`
 *
 * Attribute Value Type: `string` {@link DEVICE_CONNECTION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_CONNECTION_TYPE} `network.connection.type`, {@link CONNECTIONTYPE} `connectionType`
 *
 * @deprecated Use {@link NETWORK_CONNECTION_TYPE} (network.connection.type) instead - This attribute is being deprecated in favor of network.connection.type
 * @example "wifi"
 */
export const DEVICE_CONNECTION_TYPE = 'device.connection_type';

/**
 * Type for {@link DEVICE_CONNECTION_TYPE} device.connection_type
 */
export type DEVICE_CONNECTION_TYPE_TYPE = string;

// Path: model/attributes/device/device__cpu_description.json

/**
 * A description of the CPU of the device. `device.cpu_description`
 *
 * Attribute Value Type: `string` {@link DEVICE_CPU_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz"
 */
export const DEVICE_CPU_DESCRIPTION = 'device.cpu_description';

/**
 * Type for {@link DEVICE_CPU_DESCRIPTION} device.cpu_description
 */
export type DEVICE_CPU_DESCRIPTION_TYPE = string;

// Path: model/attributes/device/device__external_free_storage.json

/**
 * External storage free size in bytes. `device.external_free_storage`
 *
 * Attribute Value Type: `number` {@link DEVICE_EXTERNAL_FREE_STORAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 67108864000
 */
export const DEVICE_EXTERNAL_FREE_STORAGE = 'device.external_free_storage';

/**
 * Type for {@link DEVICE_EXTERNAL_FREE_STORAGE} device.external_free_storage
 */
export type DEVICE_EXTERNAL_FREE_STORAGE_TYPE = number;

// Path: model/attributes/device/device__external_storage_size.json

/**
 * External storage total size in bytes. `device.external_storage_size`
 *
 * Attribute Value Type: `number` {@link DEVICE_EXTERNAL_STORAGE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 134217728000
 */
export const DEVICE_EXTERNAL_STORAGE_SIZE = 'device.external_storage_size';

/**
 * Type for {@link DEVICE_EXTERNAL_STORAGE_SIZE} device.external_storage_size
 */
export type DEVICE_EXTERNAL_STORAGE_SIZE_TYPE = number;

// Path: model/attributes/device/device__family.json

/**
 * The family of the device. `device.family`
 *
 * Attribute Value Type: `string` {@link DEVICE_FAMILY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "iPhone"
 */
export const DEVICE_FAMILY = 'device.family';

/**
 * Type for {@link DEVICE_FAMILY} device.family
 */
export type DEVICE_FAMILY_TYPE = string;

// Path: model/attributes/device/device__free_memory.json

/**
 * Free system memory in bytes. `device.free_memory`
 *
 * Attribute Value Type: `number` {@link DEVICE_FREE_MEMORY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2147483648
 */
export const DEVICE_FREE_MEMORY = 'device.free_memory';

/**
 * Type for {@link DEVICE_FREE_MEMORY} device.free_memory
 */
export type DEVICE_FREE_MEMORY_TYPE = number;

// Path: model/attributes/device/device__free_storage.json

/**
 * Free device storage in bytes. `device.free_storage`
 *
 * Attribute Value Type: `number` {@link DEVICE_FREE_STORAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 107374182400
 */
export const DEVICE_FREE_STORAGE = 'device.free_storage';

/**
 * Type for {@link DEVICE_FREE_STORAGE} device.free_storage
 */
export type DEVICE_FREE_STORAGE_TYPE = number;

// Path: model/attributes/device/device__id.json

/**
 * Unique device identifier. `device.id`
 *
 * Attribute Value Type: `string` {@link DEVICE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
 */
export const DEVICE_ID = 'device.id';

/**
 * Type for {@link DEVICE_ID} device.id
 */
export type DEVICE_ID_TYPE = string;

// Path: model/attributes/device/device__locale.json

/**
 * The locale of the device. `device.locale`
 *
 * Attribute Value Type: `string` {@link DEVICE_LOCALE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "en-US"
 */
export const DEVICE_LOCALE = 'device.locale';

/**
 * Type for {@link DEVICE_LOCALE} device.locale
 */
export type DEVICE_LOCALE_TYPE = string;

// Path: model/attributes/device/device__low_memory.json

/**
 * Whether the device was low on memory. `device.low_memory`
 *
 * Attribute Value Type: `boolean` {@link DEVICE_LOW_MEMORY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example false
 */
export const DEVICE_LOW_MEMORY = 'device.low_memory';

/**
 * Type for {@link DEVICE_LOW_MEMORY} device.low_memory
 */
export type DEVICE_LOW_MEMORY_TYPE = boolean;

// Path: model/attributes/device/device__low_power_mode.json

/**
 * Whether the device is in Low Power Mode. `device.low_power_mode`
 *
 * Attribute Value Type: `boolean` {@link DEVICE_LOW_POWER_MODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const DEVICE_LOW_POWER_MODE = 'device.low_power_mode';

/**
 * Type for {@link DEVICE_LOW_POWER_MODE} device.low_power_mode
 */
export type DEVICE_LOW_POWER_MODE_TYPE = boolean;

// Path: model/attributes/device/device__manufacturer.json

/**
 * The manufacturer of the device. `device.manufacturer`
 *
 * Attribute Value Type: `string` {@link DEVICE_MANUFACTURER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Google"
 */
export const DEVICE_MANUFACTURER = 'device.manufacturer';

/**
 * Type for {@link DEVICE_MANUFACTURER} device.manufacturer
 */
export type DEVICE_MANUFACTURER_TYPE = string;

// Path: model/attributes/device/device__memory__estimated_capacity.json

/**
 * The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB `device.memory.estimated_capacity`
 *
 * Attribute Value Type: `number` {@link DEVICE_MEMORY_ESTIMATED_CAPACITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DEVICEMEMORY} `deviceMemory`
 *
 * @example 8
 */
export const DEVICE_MEMORY_ESTIMATED_CAPACITY = 'device.memory.estimated_capacity';

/**
 * Type for {@link DEVICE_MEMORY_ESTIMATED_CAPACITY} device.memory.estimated_capacity
 */
export type DEVICE_MEMORY_ESTIMATED_CAPACITY_TYPE = number;

// Path: model/attributes/device/device__memory_size.json

/**
 * Total system memory available in bytes. `device.memory_size`
 *
 * Attribute Value Type: `number` {@link DEVICE_MEMORY_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 17179869184
 */
export const DEVICE_MEMORY_SIZE = 'device.memory_size';

/**
 * Type for {@link DEVICE_MEMORY_SIZE} device.memory_size
 */
export type DEVICE_MEMORY_SIZE_TYPE = number;

// Path: model/attributes/device/device__model.json

/**
 * The model of the device. `device.model`
 *
 * Attribute Value Type: `string` {@link DEVICE_MODEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "iPhone 15 Pro Max"
 */
export const DEVICE_MODEL = 'device.model';

/**
 * Type for {@link DEVICE_MODEL} device.model
 */
export type DEVICE_MODEL_TYPE = string;

// Path: model/attributes/device/device__model_id.json

/**
 * An internal hardware revision to identify the device exactly. `device.model_id`
 *
 * Attribute Value Type: `string` {@link DEVICE_MODEL_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "N861AP"
 */
export const DEVICE_MODEL_ID = 'device.model_id';

/**
 * Type for {@link DEVICE_MODEL_ID} device.model_id
 */
export type DEVICE_MODEL_ID_TYPE = string;

// Path: model/attributes/device/device__name.json

/**
 * The user-assigned name of the mobile device. `device.name`
 *
 * Attribute Value Type: `string` {@link DEVICE_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "localhost"
 */
export const DEVICE_NAME = 'device.name';

/**
 * Type for {@link DEVICE_NAME} device.name
 */
export type DEVICE_NAME_TYPE = string;

// Path: model/attributes/device/device__online.json

/**
 * Whether the device was online or not. `device.online`
 *
 * Attribute Value Type: `boolean` {@link DEVICE_ONLINE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const DEVICE_ONLINE = 'device.online';

/**
 * Type for {@link DEVICE_ONLINE} device.online
 */
export type DEVICE_ONLINE_TYPE = boolean;

// Path: model/attributes/device/device__orientation.json

/**
 * The orientation of the device, either "portrait" or "landscape". `device.orientation`
 *
 * Attribute Value Type: `string` {@link DEVICE_ORIENTATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "portrait"
 */
export const DEVICE_ORIENTATION = 'device.orientation';

/**
 * Type for {@link DEVICE_ORIENTATION} device.orientation
 */
export type DEVICE_ORIENTATION_TYPE = string;

// Path: model/attributes/device/device__processor_count.json

/**
 * Number of "logical processors". `device.processor_count`
 *
 * Attribute Value Type: `number` {@link DEVICE_PROCESSOR_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HARDWARECONCURRENCY} `hardwareConcurrency`
 *
 * @example 8
 */
export const DEVICE_PROCESSOR_COUNT = 'device.processor_count';

/**
 * Type for {@link DEVICE_PROCESSOR_COUNT} device.processor_count
 */
export type DEVICE_PROCESSOR_COUNT_TYPE = number;

// Path: model/attributes/device/device__processor_frequency.json

/**
 * Processor frequency in MHz. `device.processor_frequency`
 *
 * Attribute Value Type: `number` {@link DEVICE_PROCESSOR_FREQUENCY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2400
 */
export const DEVICE_PROCESSOR_FREQUENCY = 'device.processor_frequency';

/**
 * Type for {@link DEVICE_PROCESSOR_FREQUENCY} device.processor_frequency
 */
export type DEVICE_PROCESSOR_FREQUENCY_TYPE = number;

// Path: model/attributes/device/device__screen_density.json

/**
 * The screen density of the device. `device.screen_density`
 *
 * Attribute Value Type: `number` {@link DEVICE_SCREEN_DENSITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2.625
 */
export const DEVICE_SCREEN_DENSITY = 'device.screen_density';

/**
 * Type for {@link DEVICE_SCREEN_DENSITY} device.screen_density
 */
export type DEVICE_SCREEN_DENSITY_TYPE = number;

// Path: model/attributes/device/device__screen_dpi.json

/**
 * The screen density in dots-per-inch (DPI) of the device. `device.screen_dpi`
 *
 * Attribute Value Type: `number` {@link DEVICE_SCREEN_DPI_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 420
 */
export const DEVICE_SCREEN_DPI = 'device.screen_dpi';

/**
 * Type for {@link DEVICE_SCREEN_DPI} device.screen_dpi
 */
export type DEVICE_SCREEN_DPI_TYPE = number;

// Path: model/attributes/device/device__screen_height_pixels.json

/**
 * The height of the device screen in pixels. `device.screen_height_pixels`
 *
 * Attribute Value Type: `number` {@link DEVICE_SCREEN_HEIGHT_PIXELS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2400
 */
export const DEVICE_SCREEN_HEIGHT_PIXELS = 'device.screen_height_pixels';

/**
 * Type for {@link DEVICE_SCREEN_HEIGHT_PIXELS} device.screen_height_pixels
 */
export type DEVICE_SCREEN_HEIGHT_PIXELS_TYPE = number;

// Path: model/attributes/device/device__screen_width_pixels.json

/**
 * The width of the device screen in pixels. `device.screen_width_pixels`
 *
 * Attribute Value Type: `number` {@link DEVICE_SCREEN_WIDTH_PIXELS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1080
 */
export const DEVICE_SCREEN_WIDTH_PIXELS = 'device.screen_width_pixels';

/**
 * Type for {@link DEVICE_SCREEN_WIDTH_PIXELS} device.screen_width_pixels
 */
export type DEVICE_SCREEN_WIDTH_PIXELS_TYPE = number;

// Path: model/attributes/device/device__simulator.json

/**
 * Whether the device is a simulator or an actual device. `device.simulator`
 *
 * Attribute Value Type: `boolean` {@link DEVICE_SIMULATOR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example false
 */
export const DEVICE_SIMULATOR = 'device.simulator';

/**
 * Type for {@link DEVICE_SIMULATOR} device.simulator
 */
export type DEVICE_SIMULATOR_TYPE = boolean;

// Path: model/attributes/device/device__storage_size.json

/**
 * Total device storage in bytes. `device.storage_size`
 *
 * Attribute Value Type: `number` {@link DEVICE_STORAGE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 274877906944
 */
export const DEVICE_STORAGE_SIZE = 'device.storage_size';

/**
 * Type for {@link DEVICE_STORAGE_SIZE} device.storage_size
 */
export type DEVICE_STORAGE_SIZE_TYPE = number;

// Path: model/attributes/device/device__thermal_state.json

/**
 * The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum. `device.thermal_state`
 *
 * Attribute Value Type: `string` {@link DEVICE_THERMAL_STATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Well-defined Values:
 * - `nominal`
 * - `fair`
 * - `serious`
 * - `critical`
 *
 * @example "nominal"
 */
export const DEVICE_THERMAL_STATE = 'device.thermal_state';

/**
 * Type for {@link DEVICE_THERMAL_STATE} device.thermal_state
 */
export type DEVICE_THERMAL_STATE_TYPE = string;

// Path: model/attributes/device/device__timezone.json

/**
 * The timezone of the device. `device.timezone`
 *
 * Attribute Value Type: `string` {@link DEVICE_TIMEZONE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Europe/Vienna"
 */
export const DEVICE_TIMEZONE = 'device.timezone';

/**
 * Type for {@link DEVICE_TIMEZONE} device.timezone
 */
export type DEVICE_TIMEZONE_TYPE = string;

// Path: model/attributes/device/device__usable_memory.json

/**
 * Memory usable for the app in bytes. `device.usable_memory`
 *
 * Attribute Value Type: `number` {@link DEVICE_USABLE_MEMORY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2147483648
 */
export const DEVICE_USABLE_MEMORY = 'device.usable_memory';

/**
 * Type for {@link DEVICE_USABLE_MEMORY} device.usable_memory
 */
export type DEVICE_USABLE_MEMORY_TYPE = number;

// Path: model/attributes/dist.json

/**
 * The sentry dist. `dist`
 *
 * Attribute Value Type: `string` {@link DIST_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_DIST} `sentry.dist`
 *
 * @deprecated Use {@link SENTRY_DIST} (sentry.dist) instead - This attribute is being deprecated in favor of sentry.dist.
 * @example "1.0"
 */
export const DIST = 'dist';

/**
 * Type for {@link DIST} dist
 */
export type DIST_TYPE = string;

// Path: model/attributes/django/django__function_name.json

/**
 * The fully qualified name of a function used in a Django context. `django.function_name`
 *
 * Attribute Value Type: `string` {@link DJANGO_FUNCTION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CODE_FUNCTION_NAME} `code.function.name`, {@link CODE_FUNCTION} `code.function`
 *
 * @deprecated Use {@link CODE_FUNCTION_NAME} (code.function.name) instead - This attribute is being deprecated in favor of code.function.name, which is the framework-agnostic replacement.
 * @example "django.contrib.sessions.middleware.SessionMiddleware"
 */
export const DJANGO_FUNCTION_NAME = 'django.function_name';

/**
 * Type for {@link DJANGO_FUNCTION_NAME} django.function_name
 */
export type DJANGO_FUNCTION_NAME_TYPE = string;

// Path: model/attributes/django/django__middleware_name.json

/**
 * The name of the Django middleware. `django.middleware_name`
 *
 * Attribute Value Type: `string` {@link DJANGO_MIDDLEWARE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MIDDLEWARE_NAME} `middleware.name`
 *
 * @deprecated Use {@link MIDDLEWARE_NAME} (middleware.name) instead - This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.
 * @example "AuthenticationMiddleware"
 */
export const DJANGO_MIDDLEWARE_NAME = 'django.middleware_name';

/**
 * Type for {@link DJANGO_MIDDLEWARE_NAME} django.middleware_name
 */
export type DJANGO_MIDDLEWARE_NAME_TYPE = string;

// Path: model/attributes/effectiveConnectionType.json

/**
 * Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g). `effectiveConnectionType`
 *
 * Attribute Value Type: `string` {@link EFFECTIVECONNECTIONTYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_CONNECTION_EFFECTIVE_TYPE} `network.connection.effective_type`
 *
 * @deprecated Use {@link NETWORK_CONNECTION_EFFECTIVE_TYPE} (network.connection.effective_type) instead - Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future
 * @example "4g"
 */
export const EFFECTIVECONNECTIONTYPE = 'effectiveConnectionType';

/**
 * Type for {@link EFFECTIVECONNECTIONTYPE} effectiveConnectionType
 */
export type EFFECTIVECONNECTIONTYPE_TYPE = string;

// Path: model/attributes/environment.json

/**
 * The sentry environment. `environment`
 *
 * Attribute Value Type: `string` {@link ENVIRONMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_ENVIRONMENT} `sentry.environment`
 *
 * @deprecated Use {@link SENTRY_ENVIRONMENT} (sentry.environment) instead
 * @example "production"
 */
export const ENVIRONMENT = 'environment';

/**
 * Type for {@link ENVIRONMENT} environment
 */
export type ENVIRONMENT_TYPE = string;

// Path: model/attributes/error/error__type.json

/**
 * Describes a class of error the operation ended with. `error.type`
 *
 * Attribute Value Type: `string` {@link ERROR_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "timeout"
 */
export const ERROR_TYPE = 'error.type';

/**
 * Type for {@link ERROR_TYPE} error.type
 */
export type ERROR_TYPE_TYPE = string;

// Path: model/attributes/event/event__id.json

/**
 * The unique identifier for this event (log record) `event.id`
 *
 * Attribute Value Type: `number` {@link EVENT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1234567890
 */
export const EVENT_ID = 'event.id';

/**
 * Type for {@link EVENT_ID} event.id
 */
export type EVENT_ID_TYPE = number;

// Path: model/attributes/event/event__name.json

/**
 * The name that uniquely identifies this event (log record) `event.name`
 *
 * Attribute Value Type: `string` {@link EVENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Process Payload"
 */
export const EVENT_NAME = 'event.name';

/**
 * Type for {@link EVENT_NAME} event.name
 */
export type EVENT_NAME_TYPE = string;

// Path: model/attributes/exception/exception__escaped.json

/**
 * SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span. `exception.escaped`
 *
 * Attribute Value Type: `boolean` {@link EXCEPTION_ESCAPED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const EXCEPTION_ESCAPED = 'exception.escaped';

/**
 * Type for {@link EXCEPTION_ESCAPED} exception.escaped
 */
export type EXCEPTION_ESCAPED_TYPE = boolean;

// Path: model/attributes/exception/exception__message.json

/**
 * The error message. `exception.message`
 *
 * Attribute Value Type: `string` {@link EXCEPTION_MESSAGE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ENOENT: no such file or directory"
 */
export const EXCEPTION_MESSAGE = 'exception.message';

/**
 * Type for {@link EXCEPTION_MESSAGE} exception.message
 */
export type EXCEPTION_MESSAGE_TYPE = string;

// Path: model/attributes/exception/exception__stacktrace.json

/**
 * A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG. `exception.stacktrace`
 *
 * Attribute Value Type: `string` {@link EXCEPTION_STACKTRACE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Exception in thread \"main\" java.lang.RuntimeException: Test exception\n at com.example.GenerateTrace.methodB(GenerateTrace.java:13)\n at com.example.GenerateTrace.methodA(GenerateTrace.java:9)\n at com.example.GenerateTrace.main(GenerateTrace.java:5)"
 */
export const EXCEPTION_STACKTRACE = 'exception.stacktrace';

/**
 * Type for {@link EXCEPTION_STACKTRACE} exception.stacktrace
 */
export type EXCEPTION_STACKTRACE_TYPE = string;

// Path: model/attributes/exception/exception__type.json

/**
 * The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it. `exception.type`
 *
 * Attribute Value Type: `string` {@link EXCEPTION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "OSError"
 */
export const EXCEPTION_TYPE = 'exception.type';

/**
 * Type for {@link EXCEPTION_TYPE} exception.type
 */
export type EXCEPTION_TYPE_TYPE = string;

// Path: model/attributes/faas/faas__coldstart.json

/**
 * A boolean that is true if the serverless function is executed for the first time (aka cold-start). `faas.coldstart`
 *
 * Attribute Value Type: `boolean` {@link FAAS_COLDSTART_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const FAAS_COLDSTART = 'faas.coldstart';

/**
 * Type for {@link FAAS_COLDSTART} faas.coldstart
 */
export type FAAS_COLDSTART_TYPE = boolean;

// Path: model/attributes/faas/faas__cron.json

/**
 * A string containing the schedule period as Cron Expression. `faas.cron`
 *
 * Attribute Value Type: `string` {@link FAAS_CRON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "0/5 * * * ? *"
 */
export const FAAS_CRON = 'faas.cron';

/**
 * Type for {@link FAAS_CRON} faas.cron
 */
export type FAAS_CRON_TYPE = string;

// Path: model/attributes/faas/faas__duration_in_ms.json

/**
 * The duration a function took to run, in milliseconds. `faas.duration_in_ms`
 *
 * Attribute Value Type: `number` {@link FAAS_DURATION_IN_MS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 120
 */
export const FAAS_DURATION_IN_MS = 'faas.duration_in_ms';

/**
 * Type for {@link FAAS_DURATION_IN_MS} faas.duration_in_ms
 */
export type FAAS_DURATION_IN_MS_TYPE = number;

// Path: model/attributes/faas/faas__entry_point.json

/**
 * The code that's run when the cloud provider invokes your function. `faas.entry_point`
 *
 * Attribute Value Type: `string` {@link FAAS_ENTRY_POINT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my_main_function"
 */
export const FAAS_ENTRY_POINT = 'faas.entry_point';

/**
 * Type for {@link FAAS_ENTRY_POINT} faas.entry_point
 */
export type FAAS_ENTRY_POINT_TYPE = string;

// Path: model/attributes/faas/faas__execution.json

/**
 * The execution ID of the current function execution. `faas.execution`
 *
 * Attribute Value Type: `string` {@link FAAS_EXECUTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link FAAS_INVOCATION_ID} `faas.invocation_id`, {@link AWS_LAMBDA_AWS_REQUEST_ID} `aws.lambda.aws_request_id`
 *
 * @deprecated Use {@link FAAS_INVOCATION_ID} (faas.invocation_id) instead - This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement.
 * @example "af9d5aa4-a685-4c5f-a22b-444f80b3cc28"
 */
export const FAAS_EXECUTION = 'faas.execution';

/**
 * Type for {@link FAAS_EXECUTION} faas.execution
 */
export type FAAS_EXECUTION_TYPE = string;

// Path: model/attributes/faas/faas__id.json

/**
 * The unique ID of the single function that this runtime instance executes. `faas.id`
 *
 * Attribute Value Type: `string` {@link FAAS_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CLOUD_RESOURCE_ID} `cloud.resource_id`
 *
 * @deprecated Use {@link CLOUD_RESOURCE_ID} (cloud.resource_id) instead - This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0).
 * @example "arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function"
 */
export const FAAS_ID = 'faas.id';

/**
 * Type for {@link FAAS_ID} faas.id
 */
export type FAAS_ID_TYPE = string;

// Path: model/attributes/faas/faas__identity.json

/**
 * The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services `faas.identity`
 *
 * Attribute Value Type: `string` {@link FAAS_IDENTITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)"
 */
export const FAAS_IDENTITY = 'faas.identity';

/**
 * Type for {@link FAAS_IDENTITY} faas.identity
 */
export type FAAS_IDENTITY_TYPE = string;

// Path: model/attributes/faas/faas__invocation_id.json

/**
 * The invocation ID of the current function invocation. `faas.invocation_id`
 *
 * Attribute Value Type: `string` {@link FAAS_INVOCATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_LAMBDA_AWS_REQUEST_ID} `aws.lambda.aws_request_id`, {@link FAAS_EXECUTION} `faas.execution`
 *
 * @example "af9d5aa4-a685-4c5f-a22b-444f80b3cc28"
 */
export const FAAS_INVOCATION_ID = 'faas.invocation_id';

/**
 * Type for {@link FAAS_INVOCATION_ID} faas.invocation_id
 */
export type FAAS_INVOCATION_ID_TYPE = string;

// Path: model/attributes/faas/faas__invoked_name.json

/**
 * The name of the invoked function. `faas.invoked_name`
 *
 * Attribute Value Type: `string` {@link FAAS_INVOKED_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "my-function"
 */
export const FAAS_INVOKED_NAME = 'faas.invoked_name';

/**
 * Type for {@link FAAS_INVOKED_NAME} faas.invoked_name
 */
export type FAAS_INVOKED_NAME_TYPE = string;

// Path: model/attributes/faas/faas__invoked_provider.json

/**
 * The cloud provider of the invoked function. `faas.invoked_provider`
 *
 * Attribute Value Type: `string` {@link FAAS_INVOKED_PROVIDER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "aws"
 */
export const FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';

/**
 * Type for {@link FAAS_INVOKED_PROVIDER} faas.invoked_provider
 */
export type FAAS_INVOKED_PROVIDER_TYPE = string;

// Path: model/attributes/faas/faas__invoked_region.json

/**
 * The cloud region of the invoked function. `faas.invoked_region`
 *
 * Attribute Value Type: `string` {@link FAAS_INVOKED_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "eu-central-1"
 */
export const FAAS_INVOKED_REGION = 'faas.invoked_region';

/**
 * Type for {@link FAAS_INVOKED_REGION} faas.invoked_region
 */
export type FAAS_INVOKED_REGION_TYPE = string;

// Path: model/attributes/faas/faas__name.json

/**
 * The name of the serverless function `faas.name`
 *
 * Attribute Value Type: `string` {@link FAAS_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_LAMBDA_FUNCTION_NAME} `aws.lambda.function_name`
 *
 * @example "my_function"
 */
export const FAAS_NAME = 'faas.name';

/**
 * Type for {@link FAAS_NAME} faas.name
 */
export type FAAS_NAME_TYPE = string;

// Path: model/attributes/faas/faas__time.json

/**
 * A string containing the function invocation time in the ISO 8601 format expressed in UTC. `faas.time`
 *
 * Attribute Value Type: `string` {@link FAAS_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "2020-01-23T13:47:06Z"
 */
export const FAAS_TIME = 'faas.time';

/**
 * Type for {@link FAAS_TIME} faas.time
 */
export type FAAS_TIME_TYPE = string;

// Path: model/attributes/faas/faas__trigger.json

/**
 * Type of the trigger which caused this function invocation. `faas.trigger`
 *
 * Attribute Value Type: `string` {@link FAAS_TRIGGER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "timer"
 */
export const FAAS_TRIGGER = 'faas.trigger';

/**
 * Type for {@link FAAS_TRIGGER} faas.trigger
 */
export type FAAS_TRIGGER_TYPE = string;

// Path: model/attributes/faas/faas__version.json

/**
 * The version of the function that was invoked `faas.version`
 *
 * Attribute Value Type: `string` {@link FAAS_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_LAMBDA_FUNCTION_VERSION} `aws.lambda.function_version`
 *
 * @example "$LATEST"
 */
export const FAAS_VERSION = 'faas.version';

/**
 * Type for {@link FAAS_VERSION} faas.version
 */
export type FAAS_VERSION_TYPE = string;

// Path: model/attributes/fcp.json

/**
 * The time it takes for the browser to render the first piece of meaningful content on the screen `fcp`
 *
 * Attribute Value Type: `number` {@link FCP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_FCP_VALUE} `browser.web_vital.fcp.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_FCP_VALUE} (browser.web_vital.fcp.value) instead - This attribute is being deprecated in favor of browser.web_vital.fcp.value
 * @example 547.6951
 */
export const FCP = 'fcp';

/**
 * Type for {@link FCP} fcp
 */
export type FCP_TYPE = number;

// Path: model/attributes/file/file__path.json

/**
 * Path to the file. `file.path`
 *
 * Attribute Value Type: `string` {@link FILE_PATH_TYPE}
 *
 * Apply Scrubbing: auto - File paths can contain end-user paths (e.g. from stack traces) that may be sensitive.
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "/home/user/example.txt"
 */
export const FILE_PATH = 'file.path';

/**
 * Type for {@link FILE_PATH} file.path
 */
export type FILE_PATH_TYPE = string;

// Path: model/attributes/file/file__size.json

/**
 * File size in bytes. `file.size`
 *
 * Attribute Value Type: `number` {@link FILE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 1024
 */
export const FILE_SIZE = 'file.size';

/**
 * Type for {@link FILE_SIZE} file.size
 */
export type FILE_SIZE_TYPE = number;

// Path: model/attributes/flag/flag__evaluation__[key].json

/**
 * An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag. `flag.evaluation.<key>`
 *
 * Attribute Value Type: `boolean` {@link FLAG_EVALUATION_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "flag.evaluation.is_new_ui=true"
 */
export const FLAG_EVALUATION_KEY = 'flag.evaluation.<key>';

/**
 * Base key for {@link FLAG_EVALUATION_KEY}. Use with a dynamic suffix, e.g. `${FLAG_EVALUATION_KEY_BASE}.${key}`.
 */
export const FLAG_EVALUATION_KEY_BASE = 'flag.evaluation';

/**
 * Type for {@link FLAG_EVALUATION_KEY} flag.evaluation.<key>
 */
export type FLAG_EVALUATION_KEY_TYPE = boolean;

// Path: model/attributes/fp.json

/**
 * The time it takes for the browser to render the first pixel on the screen `fp`
 *
 * Attribute Value Type: `number` {@link FP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_FP_VALUE} `browser.web_vital.fp.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_FP_VALUE} (browser.web_vital.fp.value) instead - This attribute is being deprecated in favor of browser.web_vital.fp.value
 * @example 477.1926
 */
export const FP = 'fp';

/**
 * Type for {@link FP} fp
 */
export type FP_TYPE = number;

// Path: model/attributes/frames/frames__delay.json

/**
 * The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/). `frames.delay`
 *
 * Attribute Value Type: `number` {@link FRAMES_DELAY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_DELAY_VALUE} `app.vitals.frames.delay.value`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_DELAY_VALUE} (app.vitals.frames.delay.value) instead - Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes
 * @example 5
 */
export const FRAMES_DELAY = 'frames.delay';

/**
 * Type for {@link FRAMES_DELAY} frames.delay
 */
export type FRAMES_DELAY_TYPE = number;

// Path: model/attributes/frames/frames__frozen.json

/**
 * The number of frozen frames rendered during the lifetime of the span. `frames.frozen`
 *
 * Attribute Value Type: `number` {@link FRAMES_FROZEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_FROZEN_COUNT} `app.vitals.frames.frozen.count`, {@link SENTRY_FRAMES_FROZEN} `sentry.frames.frozen`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_FROZEN_COUNT} (app.vitals.frames.frozen.count) instead - Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 3
 */
export const FRAMES_FROZEN = 'frames.frozen';

/**
 * Type for {@link FRAMES_FROZEN} frames.frozen
 */
export type FRAMES_FROZEN_TYPE = number;

// Path: model/attributes/frames_frozen_rate.json

/**
 * The rate of frozen frames, or `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay. `frames_frozen_rate`
 *
 * Attribute Value Type: `number` {@link FRAMES_FROZEN_RATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_FROZEN_RATE} `app.vitals.frames.frozen.rate`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_FROZEN_RATE} (app.vitals.frames.frozen.rate) instead - Replaced by app.vitals.frames.frozen.rate to align with the app.vitals.* namespace for mobile performance attributes
 */
export const FRAMES_FROZEN_RATE = 'frames_frozen_rate';

/**
 * Type for {@link FRAMES_FROZEN_RATE} frames_frozen_rate
 */
export type FRAMES_FROZEN_RATE_TYPE = number;

// Path: model/attributes/frames/frames__slow.json

/**
 * The number of slow frames rendered during the lifetime of the span. `frames.slow`
 *
 * Attribute Value Type: `number` {@link FRAMES_SLOW_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_SLOW_COUNT} `app.vitals.frames.slow.count`, {@link SENTRY_FRAMES_SLOW} `sentry.frames.slow`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_SLOW_COUNT} (app.vitals.frames.slow.count) instead - Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1
 */
export const FRAMES_SLOW = 'frames.slow';

/**
 * Type for {@link FRAMES_SLOW} frames.slow
 */
export type FRAMES_SLOW_TYPE = number;

// Path: model/attributes/frames_slow_rate.json

/**
 * The rate of slow frames, or `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay. `frames_slow_rate`
 *
 * Attribute Value Type: `number` {@link FRAMES_SLOW_RATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_SLOW_RATE} `app.vitals.frames.slow.rate`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_SLOW_RATE} (app.vitals.frames.slow.rate) instead - Replaced by app.vitals.frames.slow.rate to align with the app.vitals.* namespace for mobile performance attributes
 */
export const FRAMES_SLOW_RATE = 'frames_slow_rate';

/**
 * Type for {@link FRAMES_SLOW_RATE} frames_slow_rate
 */
export type FRAMES_SLOW_RATE_TYPE = number;

// Path: model/attributes/frames/frames__total.json

/**
 * The number of total frames rendered during the lifetime of the span. `frames.total`
 *
 * Attribute Value Type: `number` {@link FRAMES_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_TOTAL_COUNT} `app.vitals.frames.total.count`, {@link SENTRY_FRAMES_TOTAL} `sentry.frames.total`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_TOTAL_COUNT} (app.vitals.frames.total.count) instead - Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 60
 */
export const FRAMES_TOTAL = 'frames.total';

/**
 * Type for {@link FRAMES_TOTAL} frames.total
 */
export type FRAMES_TOTAL_TYPE = number;

// Path: model/attributes/fs_error.json

/**
 * The error message of a file system error. `fs_error`
 *
 * Attribute Value Type: `string` {@link FS_ERROR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link ERROR_TYPE} (error.type) instead - This attribute is not part of the OpenTelemetry specification and error.type fits much better. The value changes from the full error message to the syscall error code, so the old value cannot be copied over.
 * @example "ENOENT: no such file or directory"
 */
export const FS_ERROR = 'fs_error';

/**
 * Type for {@link FS_ERROR} fs_error
 */
export type FS_ERROR_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__event_id.json

/**
 * The event ID from the legacy GCP Cloud Function context (1st gen) `gcp.function.context.event_id`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_EVENT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1234567890"
 */
export const GCP_FUNCTION_CONTEXT_EVENT_ID = 'gcp.function.context.event_id';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_EVENT_ID} gcp.function.context.event_id
 */
export type GCP_FUNCTION_CONTEXT_EVENT_ID_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__event_type.json

/**
 * The type of the GCP Cloud Function event `gcp.function.context.event_type`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_EVENT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "google.pubsub.topic.publish"
 */
export const GCP_FUNCTION_CONTEXT_EVENT_TYPE = 'gcp.function.context.event_type';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_EVENT_TYPE} gcp.function.context.event_type
 */
export type GCP_FUNCTION_CONTEXT_EVENT_TYPE_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__id.json

/**
 * The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions) `gcp.function.context.id`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1234567890"
 */
export const GCP_FUNCTION_CONTEXT_ID = 'gcp.function.context.id';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_ID} gcp.function.context.id
 */
export type GCP_FUNCTION_CONTEXT_ID_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__resource.json

/**
 * The resource that triggered the GCP Cloud Function event `gcp.function.context.resource`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_RESOURCE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "projects/my-project/topics/my-topic"
 */
export const GCP_FUNCTION_CONTEXT_RESOURCE = 'gcp.function.context.resource';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_RESOURCE} gcp.function.context.resource
 */
export type GCP_FUNCTION_CONTEXT_RESOURCE_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__source.json

/**
 * The source of the GCP Cloud Function event `gcp.function.context.source`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_SOURCE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "//pubsub.googleapis.com/projects/my-project/topics/my-topic"
 */
export const GCP_FUNCTION_CONTEXT_SOURCE = 'gcp.function.context.source';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_SOURCE} gcp.function.context.source
 */
export type GCP_FUNCTION_CONTEXT_SOURCE_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__specversion.json

/**
 * The CloudEvents specification version of the GCP Cloud Function event `gcp.function.context.specversion`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_SPECVERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1.0"
 */
export const GCP_FUNCTION_CONTEXT_SPECVERSION = 'gcp.function.context.specversion';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_SPECVERSION} gcp.function.context.specversion
 */
export type GCP_FUNCTION_CONTEXT_SPECVERSION_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__time.json

/**
 * The timestamp of the GCP Cloud Function event `gcp.function.context.time`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "2024-01-01T00:00:00.000Z"
 */
export const GCP_FUNCTION_CONTEXT_TIME = 'gcp.function.context.time';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_TIME} gcp.function.context.time
 */
export type GCP_FUNCTION_CONTEXT_TIME_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__timestamp.json

/**
 * The legacy timestamp of the GCP Cloud Function event `gcp.function.context.timestamp`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_TIMESTAMP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "2024-01-01T00:00:00.000Z"
 */
export const GCP_FUNCTION_CONTEXT_TIMESTAMP = 'gcp.function.context.timestamp';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_TIMESTAMP} gcp.function.context.timestamp
 */
export type GCP_FUNCTION_CONTEXT_TIMESTAMP_TYPE = string;

// Path: model/attributes/gcp/gcp__function__context__type.json

/**
 * The type of the GCP Cloud Function event context `gcp.function.context.type`
 *
 * Attribute Value Type: `string` {@link GCP_FUNCTION_CONTEXT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "cloud_functions.context"
 */
export const GCP_FUNCTION_CONTEXT_TYPE = 'gcp.function.context.type';

/**
 * Type for {@link GCP_FUNCTION_CONTEXT_TYPE} gcp.function.context.type
 */
export type GCP_FUNCTION_CONTEXT_TYPE_TYPE = string;

// Path: model/attributes/gcp/gcp__project__id.json

/**
 * The ID of the project in GCP that this resource is associated with `gcp.project.id`
 *
 * Attribute Value Type: `string` {@link GCP_PROJECT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my-project-123"
 */
export const GCP_PROJECT_ID = 'gcp.project.id';

/**
 * Type for {@link GCP_PROJECT_ID} gcp.project.id
 */
export type GCP_PROJECT_ID_TYPE = string;

// Path: model/attributes/gcp_region.json

/**
 * The geographical region the GCP resource is running `gcp_region`
 *
 * Attribute Value Type: `string` {@link GCP_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CLOUD_REGION} `cloud.region`, {@link AWS_REGION} `aws_region`
 *
 * @deprecated Use {@link CLOUD_REGION} (cloud.region) instead
 * @example "us-east-1"
 */
export const GCP_REGION = 'gcp_region';

/**
 * Type for {@link GCP_REGION} gcp_region
 */
export type GCP_REGION_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__agent__name.json

/**
 * The name of the agent being used. `gen_ai.agent.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_AGENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ResearchAssistant"
 */
export const GEN_AI_AGENT_NAME = 'gen_ai.agent.name';

/**
 * Type for {@link GEN_AI_AGENT_NAME} gen_ai.agent.name
 */
export type GEN_AI_AGENT_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__context__utilization.json

/**
 * The fraction of the model context window utilized by this generation. `gen_ai.context.utilization`
 *
 * Attribute Value Type: `number` {@link GEN_AI_CONTEXT_UTILIZATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0.75
 */
export const GEN_AI_CONTEXT_UTILIZATION = 'gen_ai.context.utilization';

/**
 * Type for {@link GEN_AI_CONTEXT_UTILIZATION} gen_ai.context.utilization
 */
export type GEN_AI_CONTEXT_UTILIZATION_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__context__window_size.json

/**
 * The maximum context window size supported by the model for this generation. `gen_ai.context.window_size`
 *
 * Attribute Value Type: `number` {@link GEN_AI_CONTEXT_WINDOW_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 128000
 */
export const GEN_AI_CONTEXT_WINDOW_SIZE = 'gen_ai.context.window_size';

/**
 * Type for {@link GEN_AI_CONTEXT_WINDOW_SIZE} gen_ai.context.window_size
 */
export type GEN_AI_CONTEXT_WINDOW_SIZE_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__conversation__id.json

/**
 * The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation. `gen_ai.conversation.id`
 *
 * Attribute Value Type: `string` {@link GEN_AI_CONVERSATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "conv_5j66UpCpwteGg4YSxUnt7lPY"
 */
export const GEN_AI_CONVERSATION_ID = 'gen_ai.conversation.id';

/**
 * Type for {@link GEN_AI_CONVERSATION_ID} gen_ai.conversation.id
 */
export type GEN_AI_CONVERSATION_ID_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__cost__cache_creation__input_tokens.json

/**
 * The cost of input tokens written to cache in USD. `gen_ai.cost.cache_creation.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12.34
 */
export const GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS = 'gen_ai.cost.cache_creation.input_tokens';

/**
 * Type for {@link GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS} gen_ai.cost.cache_creation.input_tokens
 */
export type GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__cost__cache_read__input_tokens.json

/**
 * The cost of cached input tokens in USD. `gen_ai.cost.cache_read.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_CACHE_READ_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12.34
 */
export const GEN_AI_COST_CACHE_READ_INPUT_TOKENS = 'gen_ai.cost.cache_read.input_tokens';

/**
 * Type for {@link GEN_AI_COST_CACHE_READ_INPUT_TOKENS} gen_ai.cost.cache_read.input_tokens
 */
export type GEN_AI_COST_CACHE_READ_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__cost__input_tokens.json

/**
 * The total cost of all input tokens in USD (includes cached and cache creation tokens). `gen_ai.cost.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 123.45
 */
export const GEN_AI_COST_INPUT_TOKENS = 'gen_ai.cost.input_tokens';

/**
 * Type for {@link GEN_AI_COST_INPUT_TOKENS} gen_ai.cost.input_tokens
 */
export type GEN_AI_COST_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__cost__output_tokens.json

/**
 * The total cost of all output tokens in USD (includes reasoning tokens). `gen_ai.cost.output_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_OUTPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 123.45
 */
export const GEN_AI_COST_OUTPUT_TOKENS = 'gen_ai.cost.output_tokens';

/**
 * Type for {@link GEN_AI_COST_OUTPUT_TOKENS} gen_ai.cost.output_tokens
 */
export type GEN_AI_COST_OUTPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__cost__reasoning__output_tokens.json

/**
 * The cost of reasoning output tokens in USD. `gen_ai.cost.reasoning.output_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_REASONING_OUTPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12.34
 */
export const GEN_AI_COST_REASONING_OUTPUT_TOKENS = 'gen_ai.cost.reasoning.output_tokens';

/**
 * Type for {@link GEN_AI_COST_REASONING_OUTPUT_TOKENS} gen_ai.cost.reasoning.output_tokens
 */
export type GEN_AI_COST_REASONING_OUTPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__cost__total_tokens.json

/**
 * The total cost for the tokens used. `gen_ai.cost.total_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_COST_TOTAL_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AI_TOTAL_COST} `ai.total_cost`
 *
 * @example 12.34
 */
export const GEN_AI_COST_TOTAL_TOKENS = 'gen_ai.cost.total_tokens';

/**
 * Type for {@link GEN_AI_COST_TOTAL_TOKENS} gen_ai.cost.total_tokens
 */
export type GEN_AI_COST_TOTAL_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__embeddings__input.json

/**
 * The input to the embeddings model. `gen_ai.embeddings.input`
 *
 * Attribute Value Type: `string` {@link GEN_AI_EMBEDDINGS_INPUT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "What's the weather in Paris?"
 */
export const GEN_AI_EMBEDDINGS_INPUT = 'gen_ai.embeddings.input';

/**
 * Type for {@link GEN_AI_EMBEDDINGS_INPUT} gen_ai.embeddings.input
 */
export type GEN_AI_EMBEDDINGS_INPUT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__function_id.json

/**
 * Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system. `gen_ai.function_id`
 *
 * Attribute Value Type: `string` {@link GEN_AI_FUNCTION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my-awesome-function"
 */
export const GEN_AI_FUNCTION_ID = 'gen_ai.function_id';

/**
 * Type for {@link GEN_AI_FUNCTION_ID} gen_ai.function_id
 */
export type GEN_AI_FUNCTION_ID_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__input__messages.json

/**
 * The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`. For `gen_ai.decide` operations, the array holds one object `{type: "evaluation", state: ..., questions: {...}}` with the evaluated state and the questions keyed by name, as the caller passed them. `gen_ai.input.messages`
 *
 * Attribute Value Type: `string` {@link GEN_AI_INPUT_MESSAGES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_TEXTS} `ai.texts`, {@link AI_PROMPT_MESSAGES} `ai.prompt.messages`, {@link GEN_AI_PROMPT} `gen_ai.prompt`, {@link AI_PROMPT} `ai.prompt`
 *
 * @example "[{\"role\": \"user\", \"parts\": [{\"type\": \"text\", \"content\": \"Weather in Paris?\"}]}, {\"role\": \"assistant\", \"parts\": [{\"type\": \"tool_call\", \"id\": \"call_VSPygqKTWdrhaFErNvMV18Yl\", \"name\": \"get_weather\", \"arguments\": {\"location\": \"Paris\"}}]}, {\"role\": \"tool\", \"parts\": [{\"type\": \"tool_call_response\", \"id\": \"call_VSPygqKTWdrhaFErNvMV18Yl\", \"result\": \"rainy, 57°F\"}]}]"
 */
export const GEN_AI_INPUT_MESSAGES = 'gen_ai.input.messages';

/**
 * Type for {@link GEN_AI_INPUT_MESSAGES} gen_ai.input.messages
 */
export type GEN_AI_INPUT_MESSAGES_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__memory__query__text.json

/**
 * The search query used to retrieve memories. Only applicable to 'search_memory'. Opt-in: instrumentations SHOULD NOT capture this by default and SHOULD gate it behind explicit user opt-in, as it may contain sensitive information. `gen_ai.memory.query.text`
 *
 * Attribute Value Type: `string` {@link GEN_AI_MEMORY_QUERY_TEXT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "user dietary preferences"
 * @example "past flight bookings"
 */
export const GEN_AI_MEMORY_QUERY_TEXT = 'gen_ai.memory.query.text';

/**
 * Type for {@link GEN_AI_MEMORY_QUERY_TEXT} gen_ai.memory.query.text
 */
export type GEN_AI_MEMORY_QUERY_TEXT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__memory__records.json

/**
 * The memory records stored or retrieved in a memory operation. Stringified JSON array; each element follows the OTel MemoryRecord schema: {content (required), id, metadata, score}. Opt-in: instrumentations SHOULD NOT capture this by default and SHOULD gate it behind explicit user opt-in, as it may contain sensitive information including user/PII data. `gen_ai.memory.records`
 *
 * Attribute Value Type: `string` {@link GEN_AI_MEMORY_RECORDS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "[{\"content\": \"User prefers dark mode\", \"id\": \"mem_123\", \"score\": 0.95}, {\"content\": {\"preference\": \"vegetarian meals\", \"confidence\": 0.9}, \"metadata\": {\"source\": \"profile\"}}]"
 */
export const GEN_AI_MEMORY_RECORDS = 'gen_ai.memory.records';

/**
 * Type for {@link GEN_AI_MEMORY_RECORDS} gen_ai.memory.records
 */
export type GEN_AI_MEMORY_RECORDS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__memory__record__count.json

/**
 * The number of memory records relevant to the operation. For 'search_memory' this is the number returned; for 'create_memory', 'update_memory', 'upsert_memory' and 'delete_memory' it is the number the operation attempted to create, modify, create-or-update, or delete respectively. `gen_ai.memory.record.count`
 *
 * Attribute Value Type: `number` {@link GEN_AI_MEMORY_RECORD_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 3
 */
export const GEN_AI_MEMORY_RECORD_COUNT = 'gen_ai.memory.record.count';

/**
 * Type for {@link GEN_AI_MEMORY_RECORD_COUNT} gen_ai.memory.record.count
 */
export type GEN_AI_MEMORY_RECORD_COUNT_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__memory__record__id.json

/**
 * The unique identifier of the memory record. Set when the operation applies to a specific memory record. For 'delete_memory', its absence may indicate the operation intends to delete all memory records in the store. `gen_ai.memory.record.id`
 *
 * Attribute Value Type: `string` {@link GEN_AI_MEMORY_RECORD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "mem_5j66UpCpwteGg4YSxUnt7lPY"
 */
export const GEN_AI_MEMORY_RECORD_ID = 'gen_ai.memory.record.id';

/**
 * Type for {@link GEN_AI_MEMORY_RECORD_ID} gen_ai.memory.record.id
 */
export type GEN_AI_MEMORY_RECORD_ID_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__memory__store__id.json

/**
 * The unique identifier of the memory store the operation targets. What this maps to is implementation-specific (e.g. a collection, namespace, or vector index) and SHOULD be documented per integration. `gen_ai.memory.store.id`
 *
 * Attribute Value Type: `string` {@link GEN_AI_MEMORY_STORE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ms_abc123"
 * @example "user-preferences-store"
 * @example "seer-knowledge"
 */
export const GEN_AI_MEMORY_STORE_ID = 'gen_ai.memory.store.id';

/**
 * Type for {@link GEN_AI_MEMORY_STORE_ID} gen_ai.memory.store.id
 */
export type GEN_AI_MEMORY_STORE_ID_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__operation__name.json

/**
 * The name of the operation being performed. `gen_ai.operation.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_OPERATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Well-defined Values:
 * - `chat`
 * - `create_agent`
 * - `create_memory`
 * - `create_memory_store`
 * - `decide`
 * - `delete_memory`
 * - `delete_memory_store`
 * - `embeddings`
 * - `evaluate`
 * - `execute_tool`
 * - `generate_content`
 * - `invoke_agent`
 * - `search_memory`
 * - `text_completion`
 * - `update_memory`
 * - `upsert_memory`
 *
 * @example "chat"
 */
export const GEN_AI_OPERATION_NAME = 'gen_ai.operation.name';

/**
 * Type for {@link GEN_AI_OPERATION_NAME} gen_ai.operation.name
 */
export type GEN_AI_OPERATION_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__operation__type.json

/**
 * The type of AI operation. Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI `gen_ai.operation.type`
 *
 * Attribute Value Type: `string` {@link GEN_AI_OPERATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Well-defined Values:
 * - `agent` - invoke_agent and create_agent spans
 * - `ai_client` - any LLM call
 * - `tool` - execute_tool spans
 * - `handoff` - handoff spans
 * - `memory` - gen_ai.memory.client spans
 * - `other` - input and output processors, skill loading, guardrails etc.
 *
 * @example "tool"
 */
export const GEN_AI_OPERATION_TYPE = 'gen_ai.operation.type';

/**
 * Type for {@link GEN_AI_OPERATION_TYPE} gen_ai.operation.type
 */
export type GEN_AI_OPERATION_TYPE_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__output__messages.json

/**
 * The model's response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls. For `gen_ai.decide` operations, the array holds one object `{type: "evaluation", answers: {...}}` with the answers keyed by question name, as the provider returned them. `gen_ai.output.messages`
 *
 * Attribute Value Type: `string` {@link GEN_AI_OUTPUT_MESSAGES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_RESPONSE_TOOLCALLS} `ai.response.toolCalls`, {@link AI_RESPONSE_TEXT} `ai.response.text`
 *
 * @example "[{\"role\": \"assistant\", \"parts\": [{\"type\": \"text\", \"content\": \"The weather in Paris is currently rainy with a temperature of 57°F.\"}], \"finish_reason\": \"stop\"}]"
 */
export const GEN_AI_OUTPUT_MESSAGES = 'gen_ai.output.messages';

/**
 * Type for {@link GEN_AI_OUTPUT_MESSAGES} gen_ai.output.messages
 */
export type GEN_AI_OUTPUT_MESSAGES_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__pipeline__name.json

/**
 * Name of the AI pipeline or chain being executed. `gen_ai.pipeline.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_PIPELINE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AI_PIPELINE_NAME} `ai.pipeline.name`, {@link LANGCHAIN_CHAIN_NAME} `langchain.chain.name`
 *
 * @example "Autofix Pipeline"
 */
export const GEN_AI_PIPELINE_NAME = 'gen_ai.pipeline.name';

/**
 * Type for {@link GEN_AI_PIPELINE_NAME} gen_ai.pipeline.name
 */
export type GEN_AI_PIPELINE_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__prompt.json

/**
 * The input messages sent to the model `gen_ai.prompt`
 *
 * Attribute Value Type: `string` {@link GEN_AI_PROMPT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_INPUT_MESSAGES} `gen_ai.input.messages`, {@link AI_TEXTS} `ai.texts`, {@link AI_PROMPT_MESSAGES} `ai.prompt.messages`, {@link AI_PROMPT} `ai.prompt`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead - Deprecated from OTEL, use gen_ai.input.messages with the new format instead.
 * @example "[{\"role\": \"user\", \"message\": \"hello\"}]"
 */
export const GEN_AI_PROMPT = 'gen_ai.prompt';

/**
 * Type for {@link GEN_AI_PROMPT} gen_ai.prompt
 */
export type GEN_AI_PROMPT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__prompt__name.json

/**
 * The name of the prompt that uniquely identifies it. `gen_ai.prompt.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_PROMPT_NAME_TYPE}
 *
 * Apply Scrubbing: manual - Prompt names may reveal user behavior patterns or sensitive operations
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MCP_PROMPT_NAME} `mcp.prompt.name`
 *
 * @example "summarize_text"
 */
export const GEN_AI_PROMPT_NAME = 'gen_ai.prompt.name';

/**
 * Type for {@link GEN_AI_PROMPT_NAME} gen_ai.prompt.name
 */
export type GEN_AI_PROMPT_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__prompt__variable__[key].json

/**
 * Variables supplied to the prompt template. The <key> is the variable name, and the value is the variable value serialized as a string. `gen_ai.prompt.variable.<key>`
 *
 * Attribute Value Type: `string` {@link GEN_AI_PROMPT_VARIABLE_KEY_TYPE}
 *
 * Apply Scrubbing: auto - Prompt variables contain user input and may include sensitive information
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "gen_ai.prompt.variable.language='French'"
 * @example "gen_ai.prompt.variable.topic='weather'"
 */
export const GEN_AI_PROMPT_VARIABLE_KEY = 'gen_ai.prompt.variable.<key>';

/**
 * Base key for {@link GEN_AI_PROMPT_VARIABLE_KEY}. Use with a dynamic suffix, e.g. `${GEN_AI_PROMPT_VARIABLE_KEY_BASE}.${key}`.
 */
export const GEN_AI_PROMPT_VARIABLE_KEY_BASE = 'gen_ai.prompt.variable';

/**
 * Type for {@link GEN_AI_PROMPT_VARIABLE_KEY} gen_ai.prompt.variable.<key>
 */
export type GEN_AI_PROMPT_VARIABLE_KEY_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__provider__name.json

/**
 * The Generative AI provider as identified by the client or server instrumentation. `gen_ai.provider.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_PROVIDER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_MODEL_PROVIDER} `ai.model.provider`, {@link GEN_AI_SYSTEM} `gen_ai.system`
 *
 * @example "openai"
 */
export const GEN_AI_PROVIDER_NAME = 'gen_ai.provider.name';

/**
 * Type for {@link GEN_AI_PROVIDER_NAME} gen_ai.provider.name
 */
export type GEN_AI_PROVIDER_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__available_tools.json

/**
 * The available tools for the model. It has to be a stringified version of an array of objects. `gen_ai.request.available_tools`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_AVAILABLE_TOOLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_DEFINITIONS} `gen_ai.tool.definitions`
 *
 * @deprecated Use {@link GEN_AI_TOOL_DEFINITIONS} (gen_ai.tool.definitions) instead
 * @example "[{\"name\": \"get_weather\", \"description\": \"Get the weather for a given location\"}, {\"name\": \"get_news\", \"description\": \"Get the news for a given topic\"}]"
 */
export const GEN_AI_REQUEST_AVAILABLE_TOOLS = 'gen_ai.request.available_tools';

/**
 * Type for {@link GEN_AI_REQUEST_AVAILABLE_TOOLS} gen_ai.request.available_tools
 */
export type GEN_AI_REQUEST_AVAILABLE_TOOLS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__frequency_penalty.json

/**
 * Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation. `gen_ai.request.frequency_penalty`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_FREQUENCY_PENALTY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_FREQUENCY_PENALTY} `ai.frequency_penalty`
 *
 * @example 0.5
 */
export const GEN_AI_REQUEST_FREQUENCY_PENALTY = 'gen_ai.request.frequency_penalty';

/**
 * Type for {@link GEN_AI_REQUEST_FREQUENCY_PENALTY} gen_ai.request.frequency_penalty
 */
export type GEN_AI_REQUEST_FREQUENCY_PENALTY_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__request__max_tokens.json

/**
 * The maximum number of tokens to generate in the response. `gen_ai.request.max_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_MAX_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 2048
 */
export const GEN_AI_REQUEST_MAX_TOKENS = 'gen_ai.request.max_tokens';

/**
 * Type for {@link GEN_AI_REQUEST_MAX_TOKENS} gen_ai.request.max_tokens
 */
export type GEN_AI_REQUEST_MAX_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__request__messages.json

/**
 * The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`. `gen_ai.request.messages`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_MESSAGES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AI_INPUT_MESSAGES} `ai.input_messages`
 *
 * @deprecated Use {@link GEN_AI_INPUT_MESSAGES} (gen_ai.input.messages) instead
 * @example "[{\"role\": \"system\", \"content\": \"Generate a random number.\"}, {\"role\": \"user\", \"content\": [{\"text\": \"Generate a random number between 0 and 10.\", \"type\": \"text\"}]}, {\"role\": \"tool\", \"content\": {\"toolCallId\": \"1\", \"toolName\": \"Weather\", \"output\": \"rainy\"}}]"
 */
export const GEN_AI_REQUEST_MESSAGES = 'gen_ai.request.messages';

/**
 * Type for {@link GEN_AI_REQUEST_MESSAGES} gen_ai.request.messages
 */
export type GEN_AI_REQUEST_MESSAGES_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__model.json

/**
 * The model identifier being used for the request. `gen_ai.request.model`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_MODEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link _AI_MODEL_ID} `ai.model_id`, {@link AI_MODEL_ID} `ai.model.id`
 *
 * @example "gpt-4-turbo-preview"
 */
export const GEN_AI_REQUEST_MODEL = 'gen_ai.request.model';

/**
 * Type for {@link GEN_AI_REQUEST_MODEL} gen_ai.request.model
 */
export type GEN_AI_REQUEST_MODEL_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__presence_penalty.json

/**
 * Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies. `gen_ai.request.presence_penalty`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_PRESENCE_PENALTY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_PRESENCE_PENALTY} `ai.presence_penalty`
 *
 * @example 0.5
 */
export const GEN_AI_REQUEST_PRESENCE_PENALTY = 'gen_ai.request.presence_penalty';

/**
 * Type for {@link GEN_AI_REQUEST_PRESENCE_PENALTY} gen_ai.request.presence_penalty
 */
export type GEN_AI_REQUEST_PRESENCE_PENALTY_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__request__reasoning__level.json

/**
 * The reasoning or thinking effort level requested for a GenAI model. `gen_ai.request.reasoning.level`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_REASONING_LEVEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "high"
 */
export const GEN_AI_REQUEST_REASONING_LEVEL = 'gen_ai.request.reasoning.level';

/**
 * Type for {@link GEN_AI_REQUEST_REASONING_LEVEL} gen_ai.request.reasoning.level
 */
export type GEN_AI_REQUEST_REASONING_LEVEL_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__schema.json

/**
 * The stringified JSON schema the model output must conform to. `gen_ai.request.schema`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_SCHEMA_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema.
 * @example "{\"type\":\"object\",\"properties\":{\"city\":{\"type\":\"string\"}}}"
 */
export const GEN_AI_REQUEST_SCHEMA = 'gen_ai.request.schema';

/**
 * Type for {@link GEN_AI_REQUEST_SCHEMA} gen_ai.request.schema
 */
export type GEN_AI_REQUEST_SCHEMA_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__seed.json

/**
 * The seed, ideally models given the same seed and same other parameters will produce the exact same output. `gen_ai.request.seed`
 *
 * Attribute Value Type: `string` {@link GEN_AI_REQUEST_SEED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_SEED} `ai.seed`
 *
 * @example "1234567890"
 */
export const GEN_AI_REQUEST_SEED = 'gen_ai.request.seed';

/**
 * Type for {@link GEN_AI_REQUEST_SEED} gen_ai.request.seed
 */
export type GEN_AI_REQUEST_SEED_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__request__stop_sequences.json

/**
 * List of sequences that the model will use to stop generating further tokens. `gen_ai.request.stop_sequences`
 *
 * Attribute Value Type: `Array<string>` {@link GEN_AI_REQUEST_STOP_SEQUENCES_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["forest","lived"]
 */
export const GEN_AI_REQUEST_STOP_SEQUENCES = 'gen_ai.request.stop_sequences';

/**
 * Type for {@link GEN_AI_REQUEST_STOP_SEQUENCES} gen_ai.request.stop_sequences
 */
export type GEN_AI_REQUEST_STOP_SEQUENCES_TYPE = Array<string>;

// Path: model/attributes/gen_ai/gen_ai__request__temperature.json

/**
 * For an AI model call, the temperature parameter. Temperature essentially means how random the output will be. `gen_ai.request.temperature`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_TEMPERATURE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_TEMPERATURE} `ai.temperature`
 *
 * @example 0.1
 */
export const GEN_AI_REQUEST_TEMPERATURE = 'gen_ai.request.temperature';

/**
 * Type for {@link GEN_AI_REQUEST_TEMPERATURE} gen_ai.request.temperature
 */
export type GEN_AI_REQUEST_TEMPERATURE_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__request__top_k.json

/**
 * Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered). `gen_ai.request.top_k`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_TOP_K_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_TOP_K} `ai.top_k`
 *
 * @example 35
 */
export const GEN_AI_REQUEST_TOP_K = 'gen_ai.request.top_k';

/**
 * Type for {@link GEN_AI_REQUEST_TOP_K} gen_ai.request.top_k
 */
export type GEN_AI_REQUEST_TOP_K_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__request__top_p.json

/**
 * Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered). `gen_ai.request.top_p`
 *
 * Attribute Value Type: `number` {@link GEN_AI_REQUEST_TOP_P_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_TOP_P} `ai.top_p`
 *
 * @example 0.7
 */
export const GEN_AI_REQUEST_TOP_P = 'gen_ai.request.top_p';

/**
 * Type for {@link GEN_AI_REQUEST_TOP_P} gen_ai.request.top_p
 */
export type GEN_AI_REQUEST_TOP_P_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__response__finish_reason.json

/**
 * The reason why the model stopped generating (singular form). `gen_ai.response.finish_reason`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_FINISH_REASON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_FINISH_REASONS} `gen_ai.response.finish_reasons`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_FINISH_REASONS} (gen_ai.response.finish_reasons) instead
 * @example "COMPLETE"
 */
export const GEN_AI_RESPONSE_FINISH_REASON = 'gen_ai.response.finish_reason';

/**
 * Type for {@link GEN_AI_RESPONSE_FINISH_REASON} gen_ai.response.finish_reason
 */
export type GEN_AI_RESPONSE_FINISH_REASON_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__finish_reasons.json

/**
 * The reason why the model stopped generating. `gen_ai.response.finish_reasons`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_FINISH_REASONS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_FINISH_REASON} `ai.finish_reason`, {@link GEN_AI_RESPONSE_FINISH_REASON} `gen_ai.response.finish_reason`
 *
 * @example "COMPLETE"
 */
export const GEN_AI_RESPONSE_FINISH_REASONS = 'gen_ai.response.finish_reasons';

/**
 * Type for {@link GEN_AI_RESPONSE_FINISH_REASONS} gen_ai.response.finish_reasons
 */
export type GEN_AI_RESPONSE_FINISH_REASONS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__id.json

/**
 * Unique identifier for the completion. `gen_ai.response.id`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_GENERATION_ID} `ai.generation_id`, {@link AI_RESPONSE_ID} `ai.response.id`
 *
 * @example "gen_123abc"
 */
export const GEN_AI_RESPONSE_ID = 'gen_ai.response.id';

/**
 * Type for {@link GEN_AI_RESPONSE_ID} gen_ai.response.id
 */
export type GEN_AI_RESPONSE_ID_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__model.json

/**
 * The vendor-specific ID of the model used. `gen_ai.response.model`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_MODEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_RESPONSE_MODEL} `ai.response.model`
 *
 * @example "gpt-4"
 */
export const GEN_AI_RESPONSE_MODEL = 'gen_ai.response.model';

/**
 * Type for {@link GEN_AI_RESPONSE_MODEL} gen_ai.response.model
 */
export type GEN_AI_RESPONSE_MODEL_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__object.json

/**
 * The type of the object returned by the model. `gen_ai.response.object`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_OBJECT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - This attribute is deprecated. The Sentry conventions have no replacement for the raw response object type.
 * @example "chat.completion"
 */
export const GEN_AI_RESPONSE_OBJECT = 'gen_ai.response.object';

/**
 * Type for {@link GEN_AI_RESPONSE_OBJECT} gen_ai.response.object
 */
export type GEN_AI_RESPONSE_OBJECT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__streaming.json

/**
 * Whether or not the AI model call's response was streamed back asynchronously `gen_ai.response.streaming`
 *
 * Attribute Value Type: `boolean` {@link GEN_AI_RESPONSE_STREAMING_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AI_STREAMING} `ai.streaming`
 *
 * @example true
 */
export const GEN_AI_RESPONSE_STREAMING = 'gen_ai.response.streaming';

/**
 * Type for {@link GEN_AI_RESPONSE_STREAMING} gen_ai.response.streaming
 */
export type GEN_AI_RESPONSE_STREAMING_TYPE = boolean;

// Path: model/attributes/gen_ai/gen_ai__response__text.json

/**
 * The model's response text messages. It has to be a stringified version of an array of response text messages. `gen_ai.response.text`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_TEXT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example "[\"The weather in Paris is rainy and overcast, with temperatures around 57°F\", \"The weather in London is sunny and warm, with temperatures around 65°F\"]"
 */
export const GEN_AI_RESPONSE_TEXT = 'gen_ai.response.text';

/**
 * Type for {@link GEN_AI_RESPONSE_TEXT} gen_ai.response.text
 */
export type GEN_AI_RESPONSE_TEXT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__response__time_to_first_chunk.json

/**
 * Time in seconds when the first response content chunk arrived in streaming responses. `gen_ai.response.time_to_first_chunk`
 *
 * Attribute Value Type: `number` {@link GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN} `gen_ai.response.time_to_first_token`
 *
 * @example 0.6853435
 */
export const GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK = 'gen_ai.response.time_to_first_chunk';

/**
 * Type for {@link GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK} gen_ai.response.time_to_first_chunk
 */
export type GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__response__time_to_first_token.json

/**
 * Time in seconds when the first response content chunk arrived in streaming responses. `gen_ai.response.time_to_first_token`
 *
 * Attribute Value Type: `number` {@link GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK} `gen_ai.response.time_to_first_chunk`
 *
 * @deprecated Use {@link GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK} (gen_ai.response.time_to_first_chunk) instead
 * @example 0.6853435
 */
export const GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN = 'gen_ai.response.time_to_first_token';

/**
 * Type for {@link GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN} gen_ai.response.time_to_first_token
 */
export type GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__response__tokens_per_second.json

/**
 * The total output tokens per seconds throughput `gen_ai.response.tokens_per_second`
 *
 * Attribute Value Type: `number` {@link GEN_AI_RESPONSE_TOKENS_PER_SECOND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 12345.67
 */
export const GEN_AI_RESPONSE_TOKENS_PER_SECOND = 'gen_ai.response.tokens_per_second';

/**
 * Type for {@link GEN_AI_RESPONSE_TOKENS_PER_SECOND} gen_ai.response.tokens_per_second
 */
export type GEN_AI_RESPONSE_TOKENS_PER_SECOND_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__response__tool_calls.json

/**
 * The tool calls in the model's response. It has to be a stringified version of an array of objects. `gen_ai.response.tool_calls`
 *
 * Attribute Value Type: `string` {@link GEN_AI_RESPONSE_TOOL_CALLS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_OUTPUT_MESSAGES} (gen_ai.output.messages) instead
 * @example "[{\"name\": \"get_weather\", \"arguments\": {\"location\": \"Paris\"}}]"
 */
export const GEN_AI_RESPONSE_TOOL_CALLS = 'gen_ai.response.tool_calls';

/**
 * Type for {@link GEN_AI_RESPONSE_TOOL_CALLS} gen_ai.response.tool_calls
 */
export type GEN_AI_RESPONSE_TOOL_CALLS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__system.json

/**
 * The provider of the model. `gen_ai.system`
 *
 * Attribute Value Type: `string` {@link GEN_AI_SYSTEM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_MODEL_PROVIDER} `ai.model.provider`, {@link GEN_AI_PROVIDER_NAME} `gen_ai.provider.name`
 *
 * @deprecated Use {@link GEN_AI_PROVIDER_NAME} (gen_ai.provider.name) instead
 * @example "openai"
 */
export const GEN_AI_SYSTEM = 'gen_ai.system';

/**
 * Type for {@link GEN_AI_SYSTEM} gen_ai.system
 */
export type GEN_AI_SYSTEM_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__system_instructions.json

/**
 * The system instructions passed to the model. `gen_ai.system_instructions`
 *
 * Attribute Value Type: `string` {@link GEN_AI_SYSTEM_INSTRUCTIONS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_PREAMBLE} `ai.preamble`
 *
 * @example "You are a helpful assistant"
 */
export const GEN_AI_SYSTEM_INSTRUCTIONS = 'gen_ai.system_instructions';

/**
 * Type for {@link GEN_AI_SYSTEM_INSTRUCTIONS} gen_ai.system_instructions
 */
export type GEN_AI_SYSTEM_INSTRUCTIONS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__system__message.json

/**
 * The system instructions passed to the model. `gen_ai.system.message`
 *
 * Attribute Value Type: `string` {@link GEN_AI_SYSTEM_MESSAGE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link GEN_AI_SYSTEM_INSTRUCTIONS} (gen_ai.system_instructions) instead
 * @example "You are a helpful assistant"
 */
export const GEN_AI_SYSTEM_MESSAGE = 'gen_ai.system.message';

/**
 * Type for {@link GEN_AI_SYSTEM_MESSAGE} gen_ai.system.message
 */
export type GEN_AI_SYSTEM_MESSAGE_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__call__arguments.json

/**
 * The arguments of the tool call. It has to be a stringified version of the arguments to the tool. `gen_ai.tool.call.arguments`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_CALL_ARGUMENTS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_INPUT} `gen_ai.tool.input`, {@link AI_TOOLCALL_ARGS} `ai.toolCall.args`
 *
 * @example "{\"location\": \"Paris\"}"
 */
export const GEN_AI_TOOL_CALL_ARGUMENTS = 'gen_ai.tool.call.arguments';

/**
 * Type for {@link GEN_AI_TOOL_CALL_ARGUMENTS} gen_ai.tool.call.arguments
 */
export type GEN_AI_TOOL_CALL_ARGUMENTS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__call__result.json

/**
 * The result of the tool call. It has to be a stringified version of the result of the tool. `gen_ai.tool.call.result`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_CALL_RESULT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_OUTPUT} `gen_ai.tool.output`, {@link GEN_AI_TOOL_MESSAGE} `gen_ai.tool.message`, {@link MCP_TOOL_RESULT_CONTENT} `mcp.tool.result.content`, {@link AI_TOOLCALL_RESULT} `ai.toolCall.result`, {@link ANTHROPIC_TOOL_RESULT_CONTENT} `anthropic.tool_result.content`
 *
 * @example "rainy, 57°F"
 */
export const GEN_AI_TOOL_CALL_RESULT = 'gen_ai.tool.call.result';

/**
 * Type for {@link GEN_AI_TOOL_CALL_RESULT} gen_ai.tool.call.result
 */
export type GEN_AI_TOOL_CALL_RESULT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__definitions.json

/**
 * The list of source system tool definitions available to the GenAI agent or model. `gen_ai.tool.definitions`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_DEFINITIONS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_REQUEST_AVAILABLE_TOOLS} `gen_ai.request.available_tools`
 *
 * @example "[{\"type\": \"function\", \"name\": \"get_current_weather\", \"description\": \"Get the current weather in a given location\", \"parameters\": {\"type\": \"object\", \"properties\": {\"location\": {\"type\": \"string\", \"description\": \"The city and state, e.g. San Francisco, CA\"}, \"unit\": {\"type\": \"string\", \"enum\": [\"celsius\", \"fahrenheit\"]}}, \"required\": [\"location\", \"unit\"]}}]"
 */
export const GEN_AI_TOOL_DEFINITIONS = 'gen_ai.tool.definitions';

/**
 * Type for {@link GEN_AI_TOOL_DEFINITIONS} gen_ai.tool.definitions
 */
export type GEN_AI_TOOL_DEFINITIONS_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__description.json

/**
 * The description of the tool being used. `gen_ai.tool.description`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Searches the web for current information about a topic"
 */
export const GEN_AI_TOOL_DESCRIPTION = 'gen_ai.tool.description';

/**
 * Type for {@link GEN_AI_TOOL_DESCRIPTION} gen_ai.tool.description
 */
export type GEN_AI_TOOL_DESCRIPTION_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__input.json

/**
 * The input of the tool being used. It has to be a stringified version of the input to the tool. `gen_ai.tool.input`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_INPUT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_ARGUMENTS} `gen_ai.tool.call.arguments`, {@link AI_TOOLCALL_ARGS} `ai.toolCall.args`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_ARGUMENTS} (gen_ai.tool.call.arguments) instead
 * @example "{\"location\": \"Paris\"}"
 */
export const GEN_AI_TOOL_INPUT = 'gen_ai.tool.input';

/**
 * Type for {@link GEN_AI_TOOL_INPUT} gen_ai.tool.input
 */
export type GEN_AI_TOOL_INPUT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__message.json

/**
 * The response from a tool or function call passed to the model. `gen_ai.tool.message`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_MESSAGE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_RESULT} `gen_ai.tool.call.result`, {@link GEN_AI_TOOL_OUTPUT} `gen_ai.tool.output`, {@link MCP_TOOL_RESULT_CONTENT} `mcp.tool.result.content`, {@link AI_TOOLCALL_RESULT} `ai.toolCall.result`, {@link ANTHROPIC_TOOL_RESULT_CONTENT} `anthropic.tool_result.content`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_RESULT} (gen_ai.tool.call.result) instead
 * @example "rainy, 57°F"
 */
export const GEN_AI_TOOL_MESSAGE = 'gen_ai.tool.message';

/**
 * Type for {@link GEN_AI_TOOL_MESSAGE} gen_ai.tool.message
 */
export type GEN_AI_TOOL_MESSAGE_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__name.json

/**
 * Name of the tool utilized by the agent. `gen_ai.tool.name`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_FUNCTION_CALL} `ai.function_call`, {@link MCP_TOOL_NAME} `mcp.tool.name`
 *
 * @example "Flights"
 */
export const GEN_AI_TOOL_NAME = 'gen_ai.tool.name';

/**
 * Type for {@link GEN_AI_TOOL_NAME} gen_ai.tool.name
 */
export type GEN_AI_TOOL_NAME_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__output.json

/**
 * The output of the tool being used. It has to be a stringified version of the output of the tool. `gen_ai.tool.output`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_OUTPUT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_RESULT} `gen_ai.tool.call.result`, {@link GEN_AI_TOOL_MESSAGE} `gen_ai.tool.message`, {@link MCP_TOOL_RESULT_CONTENT} `mcp.tool.result.content`, {@link AI_TOOLCALL_RESULT} `ai.toolCall.result`, {@link ANTHROPIC_TOOL_RESULT_CONTENT} `anthropic.tool_result.content`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_RESULT} (gen_ai.tool.call.result) instead
 * @example "rainy, 57°F"
 */
export const GEN_AI_TOOL_OUTPUT = 'gen_ai.tool.output';

/**
 * Type for {@link GEN_AI_TOOL_OUTPUT} gen_ai.tool.output
 */
export type GEN_AI_TOOL_OUTPUT_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__tool__type.json

/**
 * The type of tool being used. `gen_ai.tool.type`
 *
 * Attribute Value Type: `string` {@link GEN_AI_TOOL_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated  - The gen_ai.tool.type attribute is deprecated and should no longer be set.
 * @example "function"
 */
export const GEN_AI_TOOL_TYPE = 'gen_ai.tool.type';

/**
 * Type for {@link GEN_AI_TOOL_TYPE} gen_ai.tool.type
 */
export type GEN_AI_TOOL_TYPE_TYPE = string;

// Path: model/attributes/gen_ai/gen_ai__usage__cache_creation__input_tokens.json

/**
 * The number of tokens written to the cache when processing the AI input (prompt). `gen_ai.usage.cache_creation.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE} `gen_ai.usage.input_tokens.cache_write`, {@link _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} `gen_ai.usage.cache_creation_input_tokens`
 *
 * @example 100
 */
export const GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = 'gen_ai.usage.cache_creation.input_tokens';

/**
 * Type for {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} gen_ai.usage.cache_creation.input_tokens
 */
export type GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__cache_creation_input_tokens.json

/**
 * The number of tokens written to the cache when processing the AI input (prompt). `gen_ai.usage.cache_creation_input_tokens`
 *
 * Attribute Value Type: `number` {@link _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} `gen_ai.usage.cache_creation.input_tokens`, {@link GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE} `gen_ai.usage.input_tokens.cache_write`
 *
 * @deprecated Use {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} (gen_ai.usage.cache_creation.input_tokens) instead - This attribute is being deprecated in favor of gen_ai.usage.cache_creation.input_tokens.
 * @example 100
 */
export const _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS = 'gen_ai.usage.cache_creation_input_tokens';

/**
 * Type for {@link _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} gen_ai.usage.cache_creation_input_tokens
 */
export type _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__cache_read__input_tokens.json

/**
 * The number of cached tokens used to process the AI input (prompt). `gen_ai.usage.cache_read.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_INPUT_TOKENS_CACHED} `gen_ai.usage.input_tokens.cached`, {@link _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} `gen_ai.usage.cache_read_input_tokens`
 *
 * @example 50
 */
export const GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = 'gen_ai.usage.cache_read.input_tokens';

/**
 * Type for {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} gen_ai.usage.cache_read.input_tokens
 */
export type GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__cache_read_input_tokens.json

/**
 * The number of cached tokens used to process the AI input (prompt). `gen_ai.usage.cache_read_input_tokens`
 *
 * Attribute Value Type: `number` {@link _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} `gen_ai.usage.cache_read.input_tokens`, {@link GEN_AI_USAGE_INPUT_TOKENS_CACHED} `gen_ai.usage.input_tokens.cached`
 *
 * @deprecated Use {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} (gen_ai.usage.cache_read.input_tokens) instead - This attribute is being deprecated in favor of gen_ai.usage.cache_read.input_tokens.
 * @example 50
 */
export const _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS = 'gen_ai.usage.cache_read_input_tokens';

/**
 * Type for {@link _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} gen_ai.usage.cache_read_input_tokens
 */
export type _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__completion_tokens.json

/**
 * The number of tokens used in the GenAI response (completion). `gen_ai.usage.completion_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_COMPLETION_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_COMPLETION_TOKENS_USED} `ai.completion_tokens.used`, {@link GEN_AI_USAGE_OUTPUT_TOKENS} `gen_ai.usage.output_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_OUTPUT_TOKENS} (gen_ai.usage.output_tokens) instead
 * @example 10
 */
export const GEN_AI_USAGE_COMPLETION_TOKENS = 'gen_ai.usage.completion_tokens';

/**
 * Type for {@link GEN_AI_USAGE_COMPLETION_TOKENS} gen_ai.usage.completion_tokens
 */
export type GEN_AI_USAGE_COMPLETION_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__input_tokens.json

/**
 * The number of tokens used to process the AI input (prompt) including cached input tokens. `gen_ai.usage.input_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_INPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_PROMPT_TOKENS_USED} `ai.prompt_tokens.used`, {@link GEN_AI_USAGE_PROMPT_TOKENS} `gen_ai.usage.prompt_tokens`
 *
 * @example 10
 */
export const GEN_AI_USAGE_INPUT_TOKENS = 'gen_ai.usage.input_tokens';

/**
 * Type for {@link GEN_AI_USAGE_INPUT_TOKENS} gen_ai.usage.input_tokens
 */
export type GEN_AI_USAGE_INPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__input_tokens__cached.json

/**
 * The number of cached tokens used to process the AI input (prompt). `gen_ai.usage.input_tokens.cached`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_INPUT_TOKENS_CACHED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} `gen_ai.usage.cache_read.input_tokens`, {@link _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} `gen_ai.usage.cache_read_input_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS} (gen_ai.usage.cache_read.input_tokens) instead
 * @example 50
 */
export const GEN_AI_USAGE_INPUT_TOKENS_CACHED = 'gen_ai.usage.input_tokens.cached';

/**
 * Type for {@link GEN_AI_USAGE_INPUT_TOKENS_CACHED} gen_ai.usage.input_tokens.cached
 */
export type GEN_AI_USAGE_INPUT_TOKENS_CACHED_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__input_tokens__cache_write.json

/**
 * The number of tokens written to the cache when processing the AI input (prompt). `gen_ai.usage.input_tokens.cache_write`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} `gen_ai.usage.cache_creation.input_tokens`, {@link _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} `gen_ai.usage.cache_creation_input_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS} (gen_ai.usage.cache_creation.input_tokens) instead
 * @example 100
 */
export const GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE = 'gen_ai.usage.input_tokens.cache_write';

/**
 * Type for {@link GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE} gen_ai.usage.input_tokens.cache_write
 */
export type GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__output_tokens.json

/**
 * The number of tokens used for creating the AI output (including reasoning tokens). `gen_ai.usage.output_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_OUTPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_COMPLETION_TOKENS_USED} `ai.completion_tokens.used`, {@link GEN_AI_USAGE_COMPLETION_TOKENS} `gen_ai.usage.completion_tokens`
 *
 * @example 10
 */
export const GEN_AI_USAGE_OUTPUT_TOKENS = 'gen_ai.usage.output_tokens';

/**
 * Type for {@link GEN_AI_USAGE_OUTPUT_TOKENS} gen_ai.usage.output_tokens
 */
export type GEN_AI_USAGE_OUTPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__output_tokens__reasoning.json

/**
 * The number of tokens used for reasoning to create the AI output. `gen_ai.usage.output_tokens.reasoning`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_OUTPUT_TOKENS_REASONING_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_REASONING_OUTPUT_TOKENS} `gen_ai.usage.reasoning.output_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_REASONING_OUTPUT_TOKENS} (gen_ai.usage.reasoning.output_tokens) instead
 * @example 75
 */
export const GEN_AI_USAGE_OUTPUT_TOKENS_REASONING = 'gen_ai.usage.output_tokens.reasoning';

/**
 * Type for {@link GEN_AI_USAGE_OUTPUT_TOKENS_REASONING} gen_ai.usage.output_tokens.reasoning
 */
export type GEN_AI_USAGE_OUTPUT_TOKENS_REASONING_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__prompt_tokens.json

/**
 * The number of tokens used in the GenAI input (prompt). `gen_ai.usage.prompt_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_PROMPT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AI_PROMPT_TOKENS_USED} `ai.prompt_tokens.used`, {@link GEN_AI_USAGE_INPUT_TOKENS} `gen_ai.usage.input_tokens`
 *
 * @deprecated Use {@link GEN_AI_USAGE_INPUT_TOKENS} (gen_ai.usage.input_tokens) instead
 * @example 20
 */
export const GEN_AI_USAGE_PROMPT_TOKENS = 'gen_ai.usage.prompt_tokens';

/**
 * Type for {@link GEN_AI_USAGE_PROMPT_TOKENS} gen_ai.usage.prompt_tokens
 */
export type GEN_AI_USAGE_PROMPT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__reasoning__output_tokens.json

/**
 * The number of tokens used for reasoning to create the AI output. `gen_ai.usage.reasoning.output_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_REASONING_OUTPUT_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_USAGE_OUTPUT_TOKENS_REASONING} `gen_ai.usage.output_tokens.reasoning`
 *
 * @example 75
 */
export const GEN_AI_USAGE_REASONING_OUTPUT_TOKENS = 'gen_ai.usage.reasoning.output_tokens';

/**
 * Type for {@link GEN_AI_USAGE_REASONING_OUTPUT_TOKENS} gen_ai.usage.reasoning.output_tokens
 */
export type GEN_AI_USAGE_REASONING_OUTPUT_TOKENS_TYPE = number;

// Path: model/attributes/gen_ai/gen_ai__usage__total_tokens.json

/**
 * The total number of tokens used to process the prompt. (input tokens plus output todkens) `gen_ai.usage.total_tokens`
 *
 * Attribute Value Type: `number` {@link GEN_AI_USAGE_TOTAL_TOKENS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link AI_TOTAL_TOKENS_USED} `ai.total_tokens.used`, {@link AI_USAGE_TOKENS} `ai.usage.tokens`
 *
 * @example 20
 */
export const GEN_AI_USAGE_TOTAL_TOKENS = 'gen_ai.usage.total_tokens';

/**
 * Type for {@link GEN_AI_USAGE_TOTAL_TOKENS} gen_ai.usage.total_tokens
 */
export type GEN_AI_USAGE_TOTAL_TOKENS_TYPE = number;

// Path: model/attributes/graphql/graphql__document.json

/**
 * The GraphQL document being executed. `graphql.document`
 *
 * Attribute Value Type: `string` {@link GRAPHQL_DOCUMENT_TYPE}
 *
 * Apply Scrubbing: auto - The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible.
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link GRAPHQL_SOURCE} `graphql.source`
 *
 * @example "query findBookById { bookById(id: ?) { name } }"
 */
export const GRAPHQL_DOCUMENT = 'graphql.document';

/**
 * Type for {@link GRAPHQL_DOCUMENT} graphql.document
 */
export type GRAPHQL_DOCUMENT_TYPE = string;

// Path: model/attributes/graphql/graphql__operation__name.json

/**
 * The name of the operation being executed. `graphql.operation.name`
 *
 * Attribute Value Type: `string` {@link GRAPHQL_OPERATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "findBookById"
 */
export const GRAPHQL_OPERATION_NAME = 'graphql.operation.name';

/**
 * Type for {@link GRAPHQL_OPERATION_NAME} graphql.operation.name
 */
export type GRAPHQL_OPERATION_NAME_TYPE = string;

// Path: model/attributes/graphql/graphql__operation__type.json

/**
 * The type of the operation being executed. `graphql.operation.type`
 *
 * Attribute Value Type: `string` {@link GRAPHQL_OPERATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "query"
 */
export const GRAPHQL_OPERATION_TYPE = 'graphql.operation.type';

/**
 * Type for {@link GRAPHQL_OPERATION_TYPE} graphql.operation.type
 */
export type GRAPHQL_OPERATION_TYPE_TYPE = string;

// Path: model/attributes/graphql/graphql__processing__type.json

/**
 * The type of processing represented by this span. `graphql.processing.type`
 *
 * Attribute Value Type: `string` {@link GRAPHQL_PROCESSING_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "parse"
 * @example "validate"
 * @example "execute"
 * @example "resolve"
 */
export const GRAPHQL_PROCESSING_TYPE = 'graphql.processing.type';

/**
 * Type for {@link GRAPHQL_PROCESSING_TYPE} graphql.processing.type
 */
export type GRAPHQL_PROCESSING_TYPE_TYPE = string;

// Path: model/attributes/graphql/graphql__source.json

/**
 * The GraphQL document being executed. `graphql.source`
 *
 * Attribute Value Type: `string` {@link GRAPHQL_SOURCE_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GRAPHQL_DOCUMENT} `graphql.document`
 *
 * @deprecated Use {@link GRAPHQL_DOCUMENT} (graphql.document) instead - This attribute is being deprecated in favor of graphql.document, which is the OpenTelemetry name for the same value.
 * @example "query findBookById { bookById(id: ?) { name } }"
 */
export const GRAPHQL_SOURCE = 'graphql.source';

/**
 * Type for {@link GRAPHQL_SOURCE} graphql.source
 */
export type GRAPHQL_SOURCE_TYPE = string;

// Path: model/attributes/grpc/grpc__error__bad_request__field_violations.json

/**
 * The individual field violations from a google.rpc.BadRequest error detail. Each entry is a JSON-encoded object with field, description, reason, and (optional) localized_message keys, mirroring google.rpc.BadRequest.FieldViolation. `grpc.error.bad_request.field_violations`
 *
 * Attribute Value Type: `Array<string>` {@link GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["{\"field\":\"email\",\"description\":\"must be a valid email address\",\"reason\":\"FIELD_INVALID\",\"localized_message\":{\"locale\":\"en-US\",\"message\":\"Must be a valid email address\"}}"]
 */
export const GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS = 'grpc.error.bad_request.field_violations';

/**
 * Type for {@link GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS} grpc.error.bad_request.field_violations
 */
export type GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS_TYPE = Array<string>;

// Path: model/attributes/grpc/grpc__error__debug_info__detail.json

/**
 * Additional debugging information, such as a server-side stack trace, from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly. `grpc.error.debug_info.detail`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_DEBUG_INFO_DETAIL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "at com.example.Service.method(Service.java:42)"
 */
export const GRPC_ERROR_DEBUG_INFO_DETAIL = 'grpc.error.debug_info.detail';

/**
 * Type for {@link GRPC_ERROR_DEBUG_INFO_DETAIL} grpc.error.debug_info.detail
 */
export type GRPC_ERROR_DEBUG_INFO_DETAIL_TYPE = string;

// Path: model/attributes/grpc/grpc__error__debug_info__stack_entries.json

/**
 * The server-side stack trace entries from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly. `grpc.error.debug_info.stack_entries`
 *
 * Attribute Value Type: `Array<string>` {@link GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["com.example.Service.method(Service.java:42)","com.example.Server.handle(Server.java:100)"]
 */
export const GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES = 'grpc.error.debug_info.stack_entries';

/**
 * Type for {@link GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES} grpc.error.debug_info.stack_entries
 */
export type GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES_TYPE = Array<string>;

// Path: model/attributes/grpc/grpc__error__error_info__domain.json

/**
 * The logical grouping to which the gRPC error reason belongs, from the google.rpc.ErrorInfo error detail. `grpc.error.error_info.domain`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_ERROR_INFO_DOMAIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "example.sentry.io"
 */
export const GRPC_ERROR_ERROR_INFO_DOMAIN = 'grpc.error.error_info.domain';

/**
 * Type for {@link GRPC_ERROR_ERROR_INFO_DOMAIN} grpc.error.error_info.domain
 */
export type GRPC_ERROR_ERROR_INFO_DOMAIN_TYPE = string;

// Path: model/attributes/grpc/grpc__error__error_info__metadata__[key].json

/**
 * Additional structured metadata attached to a google.rpc.ErrorInfo error detail, with <key> being the metadata key name. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly. `grpc.error.error_info.metadata.<key>`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_ERROR_INFO_METADATA_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "grpc.error.error_info.metadata.user_id='123'"
 */
export const GRPC_ERROR_ERROR_INFO_METADATA_KEY = 'grpc.error.error_info.metadata.<key>';

/**
 * Base key for {@link GRPC_ERROR_ERROR_INFO_METADATA_KEY}. Use with a dynamic suffix, e.g. `${GRPC_ERROR_ERROR_INFO_METADATA_KEY_BASE}.${key}`.
 */
export const GRPC_ERROR_ERROR_INFO_METADATA_KEY_BASE = 'grpc.error.error_info.metadata';

/**
 * Type for {@link GRPC_ERROR_ERROR_INFO_METADATA_KEY} grpc.error.error_info.metadata.<key>
 */
export type GRPC_ERROR_ERROR_INFO_METADATA_KEY_TYPE = string;

// Path: model/attributes/grpc/grpc__error__error_info__reason.json

/**
 * The reason for the gRPC error, as defined by the service that generated it, from the google.rpc.ErrorInfo error detail. `grpc.error.error_info.reason`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_ERROR_INFO_REASON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "FIELD_INVALID"
 */
export const GRPC_ERROR_ERROR_INFO_REASON = 'grpc.error.error_info.reason';

/**
 * Type for {@link GRPC_ERROR_ERROR_INFO_REASON} grpc.error.error_info.reason
 */
export type GRPC_ERROR_ERROR_INFO_REASON_TYPE = string;

// Path: model/attributes/grpc/grpc__error__precondition_failure__violations.json

/**
 * The individual precondition violations from a google.rpc.PreconditionFailure error detail. Each entry is a JSON-encoded object with type, subject, and description keys. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users. `grpc.error.precondition_failure.violations`
 *
 * Attribute Value Type: `Array<string>` {@link GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["{\"type\":\"TOS\",\"subject\":\"example.com/user/123\",\"description\":\"User must accept the terms of service\"}"]
 */
export const GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS = 'grpc.error.precondition_failure.violations';

/**
 * Type for {@link GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS} grpc.error.precondition_failure.violations
 */
export type GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS_TYPE = Array<string>;

// Path: model/attributes/grpc/grpc__error__quota_failure__violations.json

/**
 * The individual quota violations from a google.rpc.QuotaFailure error detail. Each entry is a JSON-encoded object with subject, description, api_service, quota_metric, quota_id, quota_dimensions, quota_value, and (optional) future_quota_value keys, mirroring google.rpc.QuotaFailure.Violation. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users. `grpc.error.quota_failure.violations`
 *
 * Attribute Value Type: `Array<string>` {@link GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["{\"subject\":\"clientip:127.0.0.1\",\"description\":\"Limit checks failed.\",\"api_service\":\"example.googleapis.com\",\"quota_metric\":\"example.googleapis.com/read_requests\",\"quota_id\":\"ReadRequestsPerMinutePerProject\",\"quota_dimensions\":{\"region\":\"us-central1\"},\"quota_value\":1000}"]
 */
export const GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS = 'grpc.error.quota_failure.violations';

/**
 * Type for {@link GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS} grpc.error.quota_failure.violations
 */
export type GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS_TYPE = Array<string>;

// Path: model/attributes/grpc/grpc__error__resource_info__description.json

/**
 * A description of the error that occurred while accessing the resource, from a google.rpc.ResourceInfo error detail. `grpc.error.resource_info.description`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_RESOURCE_INFO_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Instance is not ready for the request."
 */
export const GRPC_ERROR_RESOURCE_INFO_DESCRIPTION = 'grpc.error.resource_info.description';

/**
 * Type for {@link GRPC_ERROR_RESOURCE_INFO_DESCRIPTION} grpc.error.resource_info.description
 */
export type GRPC_ERROR_RESOURCE_INFO_DESCRIPTION_TYPE = string;

// Path: model/attributes/grpc/grpc__error__resource_info__owner.json

/**
 * The owner of the resource being accessed (e.g. project or account owning it), from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly. `grpc.error.resource_info.owner`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_RESOURCE_INFO_OWNER_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "user@example.com"
 */
export const GRPC_ERROR_RESOURCE_INFO_OWNER = 'grpc.error.resource_info.owner';

/**
 * Type for {@link GRPC_ERROR_RESOURCE_INFO_OWNER} grpc.error.resource_info.owner
 */
export type GRPC_ERROR_RESOURCE_INFO_OWNER_TYPE = string;

// Path: model/attributes/grpc/grpc__error__resource_info__resource_name.json

/**
 * The name of the resource being accessed, from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly. `grpc.error.resource_info.resource_name`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "projects/example/instances/example-instance"
 */
export const GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME = 'grpc.error.resource_info.resource_name';

/**
 * Type for {@link GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME} grpc.error.resource_info.resource_name
 */
export type GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME_TYPE = string;

// Path: model/attributes/grpc/grpc__error__resource_info__resource_type.json

/**
 * The type of resource being accessed, from a google.rpc.ResourceInfo error detail. `grpc.error.resource_info.resource_type`
 *
 * Attribute Value Type: `string` {@link GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "database"
 */
export const GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE = 'grpc.error.resource_info.resource_type';

/**
 * Type for {@link GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE} grpc.error.resource_info.resource_type
 */
export type GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE_TYPE = string;

// Path: model/attributes/grpc/grpc__error__retry_info__retry_delay_ms.json

/**
 * How long the client should wait before retrying the gRPC call, in milliseconds, from the google.rpc.RetryInfo error detail. `grpc.error.retry_info.retry_delay_ms`
 *
 * Attribute Value Type: `number` {@link GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 5000
 */
export const GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS = 'grpc.error.retry_info.retry_delay_ms';

/**
 * Type for {@link GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS} grpc.error.retry_info.retry_delay_ms
 */
export type GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS_TYPE = number;

// Path: model/attributes/hardwareConcurrency.json

/**
 * The number of logical CPU cores available. `hardwareConcurrency`
 *
 * Attribute Value Type: `string` {@link HARDWARECONCURRENCY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DEVICE_PROCESSOR_COUNT} `device.processor_count`
 *
 * @deprecated Use {@link DEVICE_PROCESSOR_COUNT} (device.processor_count) instead - Old namespace-less attribute, to be replaced with device.processor_count for span-first future
 * @example "14"
 */
export const HARDWARECONCURRENCY = 'hardwareConcurrency';

/**
 * Type for {@link HARDWARECONCURRENCY} hardwareConcurrency
 */
export type HARDWARECONCURRENCY_TYPE = string;

// Path: model/attributes/http/http__client_ip.json

/**
 * Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name. `http.client_ip`
 *
 * Attribute Value Type: `string` {@link HTTP_CLIENT_IP_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CLIENT_ADDRESS} `client.address`
 *
 * @deprecated Use {@link CLIENT_ADDRESS} (client.address) instead
 * @example "example.com"
 */
export const HTTP_CLIENT_IP = 'http.client_ip';

/**
 * Type for {@link HTTP_CLIENT_IP} http.client_ip
 */
export type HTTP_CLIENT_IP_TYPE = string;

// Path: model/attributes/http/http__decoded_response_content_length.json

/**
 * The decoded body size of the response (in bytes). `http.decoded_response_content_length`
 *
 * Attribute Value Type: `number` {@link HTTP_DECODED_RESPONSE_CONTENT_LENGTH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_BODY_DECODED_SIZE} `http.response.body.decoded_size`, {@link HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED} `http.response_content_length_uncompressed`
 *
 * @deprecated Use {@link HTTP_RESPONSE_BODY_DECODED_SIZE} (http.response.body.decoded_size) instead
 * @example 456
 */
export const HTTP_DECODED_RESPONSE_CONTENT_LENGTH = 'http.decoded_response_content_length';

/**
 * Type for {@link HTTP_DECODED_RESPONSE_CONTENT_LENGTH} http.decoded_response_content_length
 */
export type HTTP_DECODED_RESPONSE_CONTENT_LENGTH_TYPE = number;

// Path: model/attributes/http/http__flavor.json

/**
 * The actual version of the protocol used for network communication. `http.flavor`
 *
 * Attribute Value Type: `string` {@link HTTP_FLAVOR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PROTOCOL_VERSION} `network.protocol.version`, {@link NET_PROTOCOL_VERSION} `net.protocol.version`, {@link MESSAGING_PROTOCOL_VERSION} `messaging.protocol_version`
 *
 * @deprecated Use {@link NETWORK_PROTOCOL_VERSION} (network.protocol.version) instead
 * @example "1.1"
 */
export const HTTP_FLAVOR = 'http.flavor';

/**
 * Type for {@link HTTP_FLAVOR} http.flavor
 */
export type HTTP_FLAVOR_TYPE = string;

// Path: model/attributes/http/http__fragment.json

/**
 * The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not. `http.fragment`
 *
 * Attribute Value Type: `string` {@link HTTP_FRAGMENT_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "#details"
 */
export const HTTP_FRAGMENT = 'http.fragment';

/**
 * Type for {@link HTTP_FRAGMENT} http.fragment
 */
export type HTTP_FRAGMENT_TYPE = string;

// Path: model/attributes/http/http__host.json

/**
 * The domain name. `http.host`
 *
 * Attribute Value Type: `string` {@link HTTP_HOST_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link SERVER_ADDRESS} `server.address`, {@link CLIENT_ADDRESS} `client.address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link NET_HOST_NAME} `net.host.name`, {@link SERVER_NAME} `server_name`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead - Deprecated, use one of `server.address` or `client.address`, depending on the usage
 * @example "example.com"
 */
export const HTTP_HOST = 'http.host';

/**
 * Type for {@link HTTP_HOST} http.host
 */
export type HTTP_HOST_TYPE = string;

// Path: model/attributes/http/http__method.json

/**
 * The HTTP method used. `http.method`
 *
 * Attribute Value Type: `string` {@link HTTP_METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_METHOD} `http.request.method`, {@link _HTTP_REQUEST_METHOD} `http.request_method`, {@link METHOD} `method`
 *
 * @deprecated Use {@link HTTP_REQUEST_METHOD} (http.request.method) instead
 * @example "GET"
 */
export const HTTP_METHOD = 'http.method';

/**
 * Type for {@link HTTP_METHOD} http.method
 */
export type HTTP_METHOD_TYPE = string;

// Path: model/attributes/http/http__query.json

/**
 * The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not. `http.query`
 *
 * Attribute Value Type: `string` {@link HTTP_QUERY_TYPE}
 *
 * Apply Scrubbing: auto - Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "?foo=bar&bar=baz"
 */
export const HTTP_QUERY = 'http.query';

/**
 * Type for {@link HTTP_QUERY} http.query
 */
export type HTTP_QUERY_TYPE = string;

// Path: model/attributes/http/http__request__body__data.json

/**
 * HTTP request body data. Can be given as string or structural data of any format. `http.request.body.data`
 *
 * Attribute Value Type: `string` {@link HTTP_REQUEST_BODY_DATA_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "[{\"role\": \"user\", \"message\": \"hello\"}]"
 */
export const HTTP_REQUEST_BODY_DATA = 'http.request.body.data';

/**
 * Type for {@link HTTP_REQUEST_BODY_DATA} http.request.body.data
 */
export type HTTP_REQUEST_BODY_DATA_TYPE = string;

// Path: model/attributes/http/http__request__body__decoded_size.json

/**
 * The decoded body size of the request (in bytes). `http.request.body.decoded_size`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_BODY_DECODED_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED} `http.request_content_length_uncompressed`
 *
 * @example 456
 */
export const HTTP_REQUEST_BODY_DECODED_SIZE = 'http.request.body.decoded_size';

/**
 * Type for {@link HTTP_REQUEST_BODY_DECODED_SIZE} http.request.body.decoded_size
 */
export type HTTP_REQUEST_BODY_DECODED_SIZE_TYPE = number;

// Path: model/attributes/http/http__request__body__size.json

/**
 * The encoded body size of the request (in bytes). `http.request.body.size`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_BODY_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_CONTENT_LENGTH} `http.request_content_length`
 *
 * @example 123
 */
export const HTTP_REQUEST_BODY_SIZE = 'http.request.body.size';

/**
 * Type for {@link HTTP_REQUEST_BODY_SIZE} http.request.body.size
 */
export type HTTP_REQUEST_BODY_SIZE_TYPE = number;

// Path: model/attributes/http/http__request__connection_end.json

/**
 * The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication. `http.request.connection_end`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_CONNECTION_END_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.15
 */
export const HTTP_REQUEST_CONNECTION_END = 'http.request.connection_end';

/**
 * Type for {@link HTTP_REQUEST_CONNECTION_END} http.request.connection_end
 */
export type HTTP_REQUEST_CONNECTION_END_TYPE = number;

// Path: model/attributes/http/http__request__connect_start.json

/**
 * The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource. `http.request.connect_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_CONNECT_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.111
 */
export const HTTP_REQUEST_CONNECT_START = 'http.request.connect_start';

/**
 * Type for {@link HTTP_REQUEST_CONNECT_START} http.request.connect_start
 */
export type HTTP_REQUEST_CONNECT_START_TYPE = number;

// Path: model/attributes/http/http__request_content_length.json

/**
 * The encoded body size of the request (in bytes). `http.request_content_length`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_CONTENT_LENGTH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_BODY_SIZE} `http.request.body.size`
 *
 * @deprecated Use {@link HTTP_REQUEST_BODY_SIZE} (http.request.body.size) instead
 * @example 123
 */
export const HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';

/**
 * Type for {@link HTTP_REQUEST_CONTENT_LENGTH} http.request_content_length
 */
export type HTTP_REQUEST_CONTENT_LENGTH_TYPE = number;

// Path: model/attributes/http/http__request_content_length_uncompressed.json

/**
 * The decoded body size of the request (in bytes). `http.request_content_length_uncompressed`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_BODY_DECODED_SIZE} `http.request.body.decoded_size`
 *
 * @deprecated Use {@link HTTP_REQUEST_BODY_DECODED_SIZE} (http.request.body.decoded_size) instead
 * @example 456
 */
export const HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';

/**
 * Type for {@link HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED} http.request_content_length_uncompressed
 */
export type HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED_TYPE = number;

// Path: model/attributes/http/http__request__domain_lookup_end.json

/**
 * The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource. `http.request.domain_lookup_end`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_DOMAIN_LOOKUP_END_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.201
 */
export const HTTP_REQUEST_DOMAIN_LOOKUP_END = 'http.request.domain_lookup_end';

/**
 * Type for {@link HTTP_REQUEST_DOMAIN_LOOKUP_END} http.request.domain_lookup_end
 */
export type HTTP_REQUEST_DOMAIN_LOOKUP_END_TYPE = number;

// Path: model/attributes/http/http__request__domain_lookup_start.json

/**
 * The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource. `http.request.domain_lookup_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_DOMAIN_LOOKUP_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.322
 */
export const HTTP_REQUEST_DOMAIN_LOOKUP_START = 'http.request.domain_lookup_start';

/**
 * Type for {@link HTTP_REQUEST_DOMAIN_LOOKUP_START} http.request.domain_lookup_start
 */
export type HTTP_REQUEST_DOMAIN_LOOKUP_START_TYPE = number;

// Path: model/attributes/http/http__request__fetch_start.json

/**
 * The UNIX timestamp representing the time immediately before the browser starts to fetch the resource. `http.request.fetch_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_FETCH_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.389
 */
export const HTTP_REQUEST_FETCH_START = 'http.request.fetch_start';

/**
 * Type for {@link HTTP_REQUEST_FETCH_START} http.request.fetch_start
 */
export type HTTP_REQUEST_FETCH_START_TYPE = number;

// Path: model/attributes/http/http__request__header__[key].json

/**
 * HTTP request headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values. `http.request.header.<key>`
 *
 * Attribute Value Type: `Array<string>` {@link HTTP_REQUEST_HEADER_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "http.request.header.custom-header=['foo', 'bar']"
 * @example "http.request.header.content-length=['123']"
 */
export const HTTP_REQUEST_HEADER_KEY = 'http.request.header.<key>';

/**
 * Base key for {@link HTTP_REQUEST_HEADER_KEY}. Use with a dynamic suffix, e.g. `${HTTP_REQUEST_HEADER_KEY_BASE}.${key}`.
 */
export const HTTP_REQUEST_HEADER_KEY_BASE = 'http.request.header';

/**
 * Type for {@link HTTP_REQUEST_HEADER_KEY} http.request.header.<key>
 */
export type HTTP_REQUEST_HEADER_KEY_TYPE = Array<string>;

// Path: model/attributes/http/http__request__method.json

/**
 * The HTTP method used. `http.request.method`
 *
 * Attribute Value Type: `string` {@link HTTP_REQUEST_METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link METHOD} `method`, {@link HTTP_METHOD} `http.method`, {@link _HTTP_REQUEST_METHOD} `http.request_method`
 *
 * @example "GET"
 */
export const HTTP_REQUEST_METHOD = 'http.request.method';

/**
 * Type for {@link HTTP_REQUEST_METHOD} http.request.method
 */
export type HTTP_REQUEST_METHOD_TYPE = string;

// Path: model/attributes/http/http__request_method.json

/**
 * The HTTP method used. `http.request_method`
 *
 * Attribute Value Type: `string` {@link _HTTP_REQUEST_METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link METHOD} `method`, {@link HTTP_METHOD} `http.method`, {@link HTTP_REQUEST_METHOD} `http.request.method`
 *
 * @deprecated Use {@link HTTP_REQUEST_METHOD} (http.request.method) instead
 * @example "GET"
 */
export const _HTTP_REQUEST_METHOD = 'http.request_method';

/**
 * Type for {@link _HTTP_REQUEST_METHOD} http.request_method
 */
export type _HTTP_REQUEST_METHOD_TYPE = string;

// Path: model/attributes/http/http__request__redirect_end.json

/**
 * The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect `http.request.redirect_end`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_REDIRECT_END_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829558.502
 */
export const HTTP_REQUEST_REDIRECT_END = 'http.request.redirect_end';

/**
 * Type for {@link HTTP_REQUEST_REDIRECT_END} http.request.redirect_end
 */
export type HTTP_REQUEST_REDIRECT_END_TYPE = number;

// Path: model/attributes/http/http__request__redirect_start.json

/**
 * The UNIX timestamp representing the start time of the fetch which that initiates the redirect. `http.request.redirect_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_REDIRECT_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.495
 */
export const HTTP_REQUEST_REDIRECT_START = 'http.request.redirect_start';

/**
 * Type for {@link HTTP_REQUEST_REDIRECT_START} http.request.redirect_start
 */
export type HTTP_REQUEST_REDIRECT_START_TYPE = number;

// Path: model/attributes/http/http__request__request_start.json

/**
 * The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request. `http.request.request_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_REQUEST_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.51
 */
export const HTTP_REQUEST_REQUEST_START = 'http.request.request_start';

/**
 * Type for {@link HTTP_REQUEST_REQUEST_START} http.request.request_start
 */
export type HTTP_REQUEST_REQUEST_START_TYPE = number;

// Path: model/attributes/http/http__request__resend_count.json

/**
 * The ordinal number of request resending attempt (for any reason, including redirects). `http.request.resend_count`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_RESEND_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2
 */
export const HTTP_REQUEST_RESEND_COUNT = 'http.request.resend_count';

/**
 * Type for {@link HTTP_REQUEST_RESEND_COUNT} http.request.resend_count
 */
export type HTTP_REQUEST_RESEND_COUNT_TYPE = number;

// Path: model/attributes/http/http__request__response_end.json

/**
 * The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first. `http.request.response_end`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_RESPONSE_END_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.89
 */
export const HTTP_REQUEST_RESPONSE_END = 'http.request.response_end';

/**
 * Type for {@link HTTP_REQUEST_RESPONSE_END} http.request.response_end
 */
export type HTTP_REQUEST_RESPONSE_END_TYPE = number;

// Path: model/attributes/http/http__request__response_start.json

/**
 * The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request. `http.request.response_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_RESPONSE_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.7
 */
export const HTTP_REQUEST_RESPONSE_START = 'http.request.response_start';

/**
 * Type for {@link HTTP_REQUEST_RESPONSE_START} http.request.response_start
 */
export type HTTP_REQUEST_RESPONSE_START_TYPE = number;

// Path: model/attributes/http/http__request__same_origin.json

/**
 * Indicates that a URL has the same origin as the current page's origin in the browser. `http.request.same_origin`
 *
 * Attribute Value Type: `boolean` {@link HTTP_REQUEST_SAME_ORIGIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link URL_SAME_ORIGIN} `url.same_origin`
 *
 * @example true
 */
export const HTTP_REQUEST_SAME_ORIGIN = 'http.request.same_origin';

/**
 * Type for {@link HTTP_REQUEST_SAME_ORIGIN} http.request.same_origin
 */
export type HTTP_REQUEST_SAME_ORIGIN_TYPE = boolean;

// Path: model/attributes/http/http__request__secure_connection_start.json

/**
 * The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero. `http.request.secure_connection_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_SECURE_CONNECTION_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829555.73
 */
export const HTTP_REQUEST_SECURE_CONNECTION_START = 'http.request.secure_connection_start';

/**
 * Type for {@link HTTP_REQUEST_SECURE_CONNECTION_START} http.request.secure_connection_start
 */
export type HTTP_REQUEST_SECURE_CONNECTION_START_TYPE = number;

// Path: model/attributes/http/http__request__time_to_first_byte.json

/**
 * The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests `http.request.time_to_first_byte`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_TIME_TO_FIRST_BYTE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1.032
 */
export const HTTP_REQUEST_TIME_TO_FIRST_BYTE = 'http.request.time_to_first_byte';

/**
 * Type for {@link HTTP_REQUEST_TIME_TO_FIRST_BYTE} http.request.time_to_first_byte
 */
export type HTTP_REQUEST_TIME_TO_FIRST_BYTE_TYPE = number;

// Path: model/attributes/http/http__request__worker_start.json

/**
 * The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running. `http.request.worker_start`
 *
 * Attribute Value Type: `number` {@link HTTP_REQUEST_WORKER_START_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732829553.68
 */
export const HTTP_REQUEST_WORKER_START = 'http.request.worker_start';

/**
 * Type for {@link HTTP_REQUEST_WORKER_START} http.request.worker_start
 */
export type HTTP_REQUEST_WORKER_START_TYPE = number;

// Path: model/attributes/http/http__response__body__decoded_size.json

/**
 * The decoded body size of the response (in bytes). `http.response.body.decoded_size`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_BODY_DECODED_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_DECODED_RESPONSE_CONTENT_LENGTH} `http.decoded_response_content_length`, {@link HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED} `http.response_content_length_uncompressed`
 *
 * @example 456
 */
export const HTTP_RESPONSE_BODY_DECODED_SIZE = 'http.response.body.decoded_size';

/**
 * Type for {@link HTTP_RESPONSE_BODY_DECODED_SIZE} http.response.body.decoded_size
 */
export type HTTP_RESPONSE_BODY_DECODED_SIZE_TYPE = number;

// Path: model/attributes/http/http__response__body__size.json

/**
 * The encoded body size of the response (in bytes). `http.response.body.size`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_BODY_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_CONTENT_LENGTH} `http.response_content_length`, {@link HTTP_RESPONSE_HEADER_CONTENT_LENGTH} `http.response.header.content-length`
 *
 * @example 123
 */
export const HTTP_RESPONSE_BODY_SIZE = 'http.response.body.size';

/**
 * Type for {@link HTTP_RESPONSE_BODY_SIZE} http.response.body.size
 */
export type HTTP_RESPONSE_BODY_SIZE_TYPE = number;

// Path: model/attributes/http/http__response_content_length.json

/**
 * The encoded body size of the response (in bytes). `http.response_content_length`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_CONTENT_LENGTH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_BODY_SIZE} `http.response.body.size`, {@link HTTP_RESPONSE_HEADER_CONTENT_LENGTH} `http.response.header.content-length`
 *
 * @deprecated Use {@link HTTP_RESPONSE_BODY_SIZE} (http.response.body.size) instead
 * @example 123
 */
export const HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';

/**
 * Type for {@link HTTP_RESPONSE_CONTENT_LENGTH} http.response_content_length
 */
export type HTTP_RESPONSE_CONTENT_LENGTH_TYPE = number;

// Path: model/attributes/http/http__response_content_length_uncompressed.json

/**
 * The decoded body size of the response (in bytes). `http.response_content_length_uncompressed`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_BODY_DECODED_SIZE} `http.response.body.decoded_size`, {@link HTTP_DECODED_RESPONSE_CONTENT_LENGTH} `http.decoded_response_content_length`
 *
 * @deprecated Use {@link HTTP_RESPONSE_BODY_DECODED_SIZE} (http.response.body.decoded_size) instead
 * @example 456
 */
export const HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';

/**
 * Type for {@link HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED} http.response_content_length_uncompressed
 */
export type HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED_TYPE = number;

// Path: model/attributes/http/http__response__header__content-length.json

/**
 * The size of the message body sent to the recipient (in bytes) `http.response.header.content-length`
 *
 * Attribute Value Type: `string` {@link HTTP_RESPONSE_HEADER_CONTENT_LENGTH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_CONTENT_LENGTH} `http.response_content_length`, {@link HTTP_RESPONSE_BODY_SIZE} `http.response.body.size`
 *
 * @example "http.response.header.custom-header=['foo', 'bar']"
 */
export const HTTP_RESPONSE_HEADER_CONTENT_LENGTH = 'http.response.header.content-length';

/**
 * Type for {@link HTTP_RESPONSE_HEADER_CONTENT_LENGTH} http.response.header.content-length
 */
export type HTTP_RESPONSE_HEADER_CONTENT_LENGTH_TYPE = string;

// Path: model/attributes/http/http__response__header__[key].json

/**
 * HTTP response headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values. `http.response.header.<key>`
 *
 * Attribute Value Type: `Array<string>` {@link HTTP_RESPONSE_HEADER_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "http.response.header.custom-header=['foo', 'bar']"
 * @example "http.response.header.content-length=['123']"
 */
export const HTTP_RESPONSE_HEADER_KEY = 'http.response.header.<key>';

/**
 * Base key for {@link HTTP_RESPONSE_HEADER_KEY}. Use with a dynamic suffix, e.g. `${HTTP_RESPONSE_HEADER_KEY_BASE}.${key}`.
 */
export const HTTP_RESPONSE_HEADER_KEY_BASE = 'http.response.header';

/**
 * Type for {@link HTTP_RESPONSE_HEADER_KEY} http.response.header.<key>
 */
export type HTTP_RESPONSE_HEADER_KEY_TYPE = Array<string>;

// Path: model/attributes/http/http__response__size.json

/**
 * The transfer size of the response (in bytes). `http.response.size`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_TRANSFER_SIZE} `http.response_transfer_size`
 *
 * @example 456
 */
export const HTTP_RESPONSE_SIZE = 'http.response.size';

/**
 * Type for {@link HTTP_RESPONSE_SIZE} http.response.size
 */
export type HTTP_RESPONSE_SIZE_TYPE = number;

// Path: model/attributes/http/http__response__status_code.json

/**
 * The status code of the HTTP response. `http.response.status_code`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_STATUS_CODE} `http.status_code`
 *
 * @example 404
 */
export const HTTP_RESPONSE_STATUS_CODE = 'http.response.status_code';

/**
 * Type for {@link HTTP_RESPONSE_STATUS_CODE} http.response.status_code
 */
export type HTTP_RESPONSE_STATUS_CODE_TYPE = number;

// Path: model/attributes/http/http__response__status_text.json

/**
 * The reason phrase of the HTTP response. `http.response.status_text`
 *
 * Attribute Value Type: `string` {@link HTTP_RESPONSE_STATUS_TEXT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_STATUS_TEXT} `http.status_text`
 *
 * @example "NOT FOUND"
 */
export const HTTP_RESPONSE_STATUS_TEXT = 'http.response.status_text';

/**
 * Type for {@link HTTP_RESPONSE_STATUS_TEXT} http.response.status_text
 */
export type HTTP_RESPONSE_STATUS_TEXT_TYPE = string;

// Path: model/attributes/http/http__response_transfer_size.json

/**
 * The transfer size of the response (in bytes). `http.response_transfer_size`
 *
 * Attribute Value Type: `number` {@link HTTP_RESPONSE_TRANSFER_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_SIZE} `http.response.size`
 *
 * @deprecated Use {@link HTTP_RESPONSE_SIZE} (http.response.size) instead
 * @example 456
 */
export const HTTP_RESPONSE_TRANSFER_SIZE = 'http.response_transfer_size';

/**
 * Type for {@link HTTP_RESPONSE_TRANSFER_SIZE} http.response_transfer_size
 */
export type HTTP_RESPONSE_TRANSFER_SIZE_TYPE = number;

// Path: model/attributes/http/http__route.json

/**
 * The matched route, that is, the path template in the format used by the respective server framework. `http.route`
 *
 * Attribute Value Type: `string` {@link HTTP_ROUTE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ROUTE} `route`
 *
 * @example "/users/:id"
 * @example "my-controller/my-action/{id}"
 * @example "/posts"
 */
export const HTTP_ROUTE = 'http.route';

/**
 * Type for {@link HTTP_ROUTE} http.route
 */
export type HTTP_ROUTE_TYPE = string;

// Path: model/attributes/http/http__scheme.json

/**
 * The URI scheme component identifying the used protocol. `http.scheme`
 *
 * Attribute Value Type: `string` {@link HTTP_SCHEME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link URL_SCHEME} `url.scheme`
 *
 * @deprecated Use {@link URL_SCHEME} (url.scheme) instead
 * @example "https"
 */
export const HTTP_SCHEME = 'http.scheme';

/**
 * Type for {@link HTTP_SCHEME} http.scheme
 */
export type HTTP_SCHEME_TYPE = string;

// Path: model/attributes/http/http__server_name.json

/**
 * The server domain name `http.server_name`
 *
 * Attribute Value Type: `string` {@link HTTP_SERVER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link SERVER_ADDRESS} `server.address`, {@link NET_HOST_NAME} `net.host.name`, {@link HTTP_HOST} `http.host`, {@link SERVER_NAME} `server_name`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead
 * @example "example.com"
 */
export const HTTP_SERVER_NAME = 'http.server_name';

/**
 * Type for {@link HTTP_SERVER_NAME} http.server_name
 */
export type HTTP_SERVER_NAME_TYPE = string;

// Path: model/attributes/http/http__server__request__time_in_queue.json

/**
 * The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request. `http.server.request.time_in_queue`
 *
 * Attribute Value Type: `number` {@link HTTP_SERVER_REQUEST_TIME_IN_QUEUE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 50
 */
export const HTTP_SERVER_REQUEST_TIME_IN_QUEUE = 'http.server.request.time_in_queue';

/**
 * Type for {@link HTTP_SERVER_REQUEST_TIME_IN_QUEUE} http.server.request.time_in_queue
 */
export type HTTP_SERVER_REQUEST_TIME_IN_QUEUE_TYPE = number;

// Path: model/attributes/http/http__status_code.json

/**
 * The status code of the HTTP response. `http.status_code`
 *
 * Attribute Value Type: `number` {@link HTTP_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_STATUS_CODE} `http.response.status_code`
 *
 * @deprecated Use {@link HTTP_RESPONSE_STATUS_CODE} (http.response.status_code) instead
 * @example 404
 */
export const HTTP_STATUS_CODE = 'http.status_code';

/**
 * Type for {@link HTTP_STATUS_CODE} http.status_code
 */
export type HTTP_STATUS_CODE_TYPE = number;

// Path: model/attributes/http/http__status_text.json

/**
 * The reason phrase of the HTTP response `http.status_text`
 *
 * Attribute Value Type: `string` {@link HTTP_STATUS_TEXT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_RESPONSE_STATUS_TEXT} `http.response.status_text`
 *
 * @deprecated Use {@link HTTP_RESPONSE_STATUS_TEXT} (http.response.status_text) instead
 * @example "NOT FOUND"
 */
export const HTTP_STATUS_TEXT = 'http.status_text';

/**
 * Type for {@link HTTP_STATUS_TEXT} http.status_text
 */
export type HTTP_STATUS_TEXT_TYPE = string;

// Path: model/attributes/http/http__target.json

/**
 * The pathname and query string of the URL. `http.target`
 *
 * Attribute Value Type: `string` {@link HTTP_TARGET_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated  - This attribute is being deprecated in favor of url.path, url.query and url.fragment. The value holds all three parts at once, so it has no single replacement.
 * @example "/test?foo=bar#buzz"
 */
export const HTTP_TARGET = 'http.target';

/**
 * Type for {@link HTTP_TARGET} http.target
 */
export type HTTP_TARGET_TYPE = string;

// Path: model/attributes/http/http__url.json

/**
 * The URL of the resource that was fetched. `http.url`
 *
 * Attribute Value Type: `string` {@link HTTP_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link URL_FULL} `url.full`, {@link URL} `url`, {@link AWS_REQUEST_URL} `aws.request.url`, {@link MESSAGING_URL} `messaging.url`
 *
 * @deprecated Use {@link URL_FULL} (url.full) instead
 * @example "https://example.com/test?foo=bar#buzz"
 */
export const HTTP_URL = 'http.url';

/**
 * Type for {@link HTTP_URL} http.url
 */
export type HTTP_URL_TYPE = string;

// Path: model/attributes/http/http__user_agent.json

/**
 * Value of the HTTP User-Agent header sent by the client. `http.user_agent`
 *
 * Attribute Value Type: `string` {@link HTTP_USER_AGENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link USER_AGENT_ORIGINAL} `user_agent.original`
 *
 * @deprecated Use {@link USER_AGENT_ORIGINAL} (user_agent.original) instead
 * @example "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1"
 */
export const HTTP_USER_AGENT = 'http.user_agent';

/**
 * Type for {@link HTTP_USER_AGENT} http.user_agent
 */
export type HTTP_USER_AGENT_TYPE = string;

// Path: model/attributes/id.json

/**
 * A unique identifier for the span. `id`
 *
 * Attribute Value Type: `string` {@link ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "f47ac10b58cc4372a5670e02b2c3d479"
 */
export const ID = 'id';

/**
 * Type for {@link ID} id
 */
export type ID_TYPE = string;

// Path: model/attributes/inp.json

/**
 * The value of the recorded Interaction to Next Paint (INP) web vital `inp`
 *
 * Attribute Value Type: `number` {@link INP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_INP_VALUE} `browser.web_vital.inp.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_INP_VALUE} (browser.web_vital.inp.value) instead - The INP web vital is now recorded as a browser.web_vital.inp.value attribute.
 * @example 200
 */
export const INP = 'inp';

/**
 * Type for {@link INP} inp
 */
export type INP_TYPE = number;

// Path: model/attributes/integrity/integrity__blocked_url.json

/**
 * The URL of the resource blocked by the integrity policy. `integrity.blocked_url`
 *
 * Attribute Value Type: `string` {@link INTEGRITY_BLOCKED_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://example.com/app.js"
 */
export const INTEGRITY_BLOCKED_URL = 'integrity.blocked_url';

/**
 * Type for {@link INTEGRITY_BLOCKED_URL} integrity.blocked_url
 */
export type INTEGRITY_BLOCKED_URL_TYPE = string;

// Path: model/attributes/integrity/integrity__destination.json

/**
 * The destination type of the resource affected by the integrity policy. `integrity.destination`
 *
 * Attribute Value Type: `string` {@link INTEGRITY_DESTINATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "script"
 */
export const INTEGRITY_DESTINATION = 'integrity.destination';

/**
 * Type for {@link INTEGRITY_DESTINATION} integrity.destination
 */
export type INTEGRITY_DESTINATION_TYPE = string;

// Path: model/attributes/integrity/integrity__document_url.json

/**
 * The URL of the document where the integrity violation occurred. `integrity.document_url`
 *
 * Attribute Value Type: `string` {@link INTEGRITY_DOCUMENT_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://example.com/index.html"
 */
export const INTEGRITY_DOCUMENT_URL = 'integrity.document_url';

/**
 * Type for {@link INTEGRITY_DOCUMENT_URL} integrity.document_url
 */
export type INTEGRITY_DOCUMENT_URL_TYPE = string;

// Path: model/attributes/integrity/integrity__report_only.json

/**
 * Whether the integrity violation was generated by a report-only policy. `integrity.report_only`
 *
 * Attribute Value Type: `boolean` {@link INTEGRITY_REPORT_ONLY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const INTEGRITY_REPORT_ONLY = 'integrity.report_only';

/**
 * Type for {@link INTEGRITY_REPORT_ONLY} integrity.report_only
 */
export type INTEGRITY_REPORT_ONLY_TYPE = boolean;

// Path: model/attributes/jsonrpc/jsonrpc__protocol__version.json

/**
 * The version of the JSON-RPC protocol used. `jsonrpc.protocol.version`
 *
 * Attribute Value Type: `string` {@link JSONRPC_PROTOCOL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "2.0"
 */
export const JSONRPC_PROTOCOL_VERSION = 'jsonrpc.protocol.version';

/**
 * Type for {@link JSONRPC_PROTOCOL_VERSION} jsonrpc.protocol.version
 */
export type JSONRPC_PROTOCOL_VERSION_TYPE = string;

// Path: model/attributes/jsonrpc/jsonrpc__request__id.json

/**
 * The JSON-RPC request identifier, used to correlate a request with its response. `jsonrpc.request.id`
 *
 * Attribute Value Type: `string` {@link JSONRPC_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MCP_REQUEST_ID} `mcp.request.id`
 *
 * @example "1"
 */
export const JSONRPC_REQUEST_ID = 'jsonrpc.request.id';

/**
 * Type for {@link JSONRPC_REQUEST_ID} jsonrpc.request.id
 */
export type JSONRPC_REQUEST_ID_TYPE = string;

// Path: model/attributes/jvm/jvm__gc__action.json

/**
 * Name of the garbage collector action. `jvm.gc.action`
 *
 * Attribute Value Type: `string` {@link JVM_GC_ACTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "end of minor GC"
 */
export const JVM_GC_ACTION = 'jvm.gc.action';

/**
 * Type for {@link JVM_GC_ACTION} jvm.gc.action
 */
export type JVM_GC_ACTION_TYPE = string;

// Path: model/attributes/jvm/jvm__gc__name.json

/**
 * Name of the garbage collector. `jvm.gc.name`
 *
 * Attribute Value Type: `string` {@link JVM_GC_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "G1 Young Generation"
 */
export const JVM_GC_NAME = 'jvm.gc.name';

/**
 * Type for {@link JVM_GC_NAME} jvm.gc.name
 */
export type JVM_GC_NAME_TYPE = string;

// Path: model/attributes/jvm/jvm__memory__pool__name.json

/**
 * Name of the memory pool. `jvm.memory.pool.name`
 *
 * Attribute Value Type: `string` {@link JVM_MEMORY_POOL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "G1 Old Gen"
 */
export const JVM_MEMORY_POOL_NAME = 'jvm.memory.pool.name';

/**
 * Type for {@link JVM_MEMORY_POOL_NAME} jvm.memory.pool.name
 */
export type JVM_MEMORY_POOL_NAME_TYPE = string;

// Path: model/attributes/jvm/jvm__memory__type.json

/**
 * Name of the memory pool. `jvm.memory.type`
 *
 * Attribute Value Type: `string` {@link JVM_MEMORY_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "G1 Old Gen"
 */
export const JVM_MEMORY_TYPE = 'jvm.memory.type';

/**
 * Type for {@link JVM_MEMORY_TYPE} jvm.memory.type
 */
export type JVM_MEMORY_TYPE_TYPE = string;

// Path: model/attributes/jvm/jvm__thread__daemon.json

/**
 * Whether the thread is daemon or not. `jvm.thread.daemon`
 *
 * Attribute Value Type: `boolean` {@link JVM_THREAD_DAEMON_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const JVM_THREAD_DAEMON = 'jvm.thread.daemon';

/**
 * Type for {@link JVM_THREAD_DAEMON} jvm.thread.daemon
 */
export type JVM_THREAD_DAEMON_TYPE = boolean;

// Path: model/attributes/jvm/jvm__thread__state.json

/**
 * State of the thread. `jvm.thread.state`
 *
 * Attribute Value Type: `string` {@link JVM_THREAD_STATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "blocked"
 */
export const JVM_THREAD_STATE = 'jvm.thread.state';

/**
 * Type for {@link JVM_THREAD_STATE} jvm.thread.state
 */
export type JVM_THREAD_STATE_TYPE = string;

// Path: model/attributes/koa/koa__name.json

/**
 * The name of the Koa middleware or matched route that handled the request. `koa.name`
 *
 * Attribute Value Type: `string` {@link KOA_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead.
 * @example "/users/:id"
 */
export const KOA_NAME = 'koa.name';

/**
 * Type for {@link KOA_NAME} koa.name
 */
export type KOA_NAME_TYPE = string;

// Path: model/attributes/koa/koa__type.json

/**
 * The type of the Koa layer that handled the request. `koa.type`
 *
 * Attribute Value Type: `string` {@link KOA_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "router"
 */
export const KOA_TYPE = 'koa.type';

/**
 * Type for {@link KOA_TYPE} koa.type
 */
export type KOA_TYPE_TYPE = string;

// Path: model/attributes/langchain/langchain__chain__name.json

/**
 * The name of the LangChain chain being executed. `langchain.chain.name`
 *
 * Attribute Value Type: `string` {@link LANGCHAIN_CHAIN_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_PIPELINE_NAME} `gen_ai.pipeline.name`, {@link AI_PIPELINE_NAME} `ai.pipeline.name`
 *
 * @deprecated Use {@link GEN_AI_PIPELINE_NAME} (gen_ai.pipeline.name) instead - This attribute is being deprecated in favor of gen_ai.pipeline.name, which is the SDK-agnostic replacement for the name of the AI pipeline or chain being executed.
 * @example "format_prompt"
 * @example "RunnableSequence"
 */
export const LANGCHAIN_CHAIN_NAME = 'langchain.chain.name';

/**
 * Type for {@link LANGCHAIN_CHAIN_NAME} langchain.chain.name
 */
export type LANGCHAIN_CHAIN_NAME_TYPE = string;

// Path: model/attributes/lcp.json

/**
 * The value of the recorded Largest Contentful Paint (LCP) web vital `lcp`
 *
 * Attribute Value Type: `number` {@link LCP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_VALUE} `browser.web_vital.lcp.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_VALUE} (browser.web_vital.lcp.value) instead - The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute.
 * @example 2500
 */
export const LCP = 'lcp';

/**
 * Type for {@link LCP} lcp
 */
export type LCP_TYPE = number;

// Path: model/attributes/lcp/lcp__element.json

/**
 * The dom element responsible for the largest contentful paint. `lcp.element`
 *
 * Attribute Value Type: `string` {@link LCP_ELEMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_ELEMENT} `browser.web_vital.lcp.element`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_ELEMENT} (browser.web_vital.lcp.element) instead - The LCP element is now recorded as a browser.web_vital.lcp.element attribute.
 * @example "img"
 */
export const LCP_ELEMENT = 'lcp.element';

/**
 * Type for {@link LCP_ELEMENT} lcp.element
 */
export type LCP_ELEMENT_TYPE = string;

// Path: model/attributes/lcp/lcp__id.json

/**
 * The id of the dom element responsible for the largest contentful paint. `lcp.id`
 *
 * Attribute Value Type: `string` {@link LCP_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_ID} `browser.web_vital.lcp.id`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_ID} (browser.web_vital.lcp.id) instead - The LCP id is now recorded as a browser.web_vital.lcp.id attribute.
 * @example "#hero"
 */
export const LCP_ID = 'lcp.id';

/**
 * Type for {@link LCP_ID} lcp.id
 */
export type LCP_ID_TYPE = string;

// Path: model/attributes/lcp/lcp__loadTime.json

/**
 * The time it took for the LCP element to be loaded `lcp.loadTime`
 *
 * Attribute Value Type: `number` {@link LCP_LOADTIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_LOAD_TIME} `browser.web_vital.lcp.load_time`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_LOAD_TIME} (browser.web_vital.lcp.load_time) instead - The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute.
 * @example 1402
 */
export const LCP_LOADTIME = 'lcp.loadTime';

/**
 * Type for {@link LCP_LOADTIME} lcp.loadTime
 */
export type LCP_LOADTIME_TYPE = number;

// Path: model/attributes/lcp/lcp__renderTime.json

/**
 * The time it took for the LCP element to be rendered `lcp.renderTime`
 *
 * Attribute Value Type: `number` {@link LCP_RENDERTIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_RENDER_TIME} `browser.web_vital.lcp.render_time`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_RENDER_TIME} (browser.web_vital.lcp.render_time) instead - The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute.
 * @example 1685
 */
export const LCP_RENDERTIME = 'lcp.renderTime';

/**
 * Type for {@link LCP_RENDERTIME} lcp.renderTime
 */
export type LCP_RENDERTIME_TYPE = number;

// Path: model/attributes/lcp/lcp__size.json

/**
 * The size of the largest contentful paint element. `lcp.size`
 *
 * Attribute Value Type: `number` {@link LCP_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_SIZE} `browser.web_vital.lcp.size`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_SIZE} (browser.web_vital.lcp.size) instead - The LCP size is now recorded as a browser.web_vital.lcp.size attribute.
 * @example 1234
 */
export const LCP_SIZE = 'lcp.size';

/**
 * Type for {@link LCP_SIZE} lcp.size
 */
export type LCP_SIZE_TYPE = number;

// Path: model/attributes/lcp/lcp__url.json

/**
 * The url of the dom element responsible for the largest contentful paint. `lcp.url`
 *
 * Attribute Value Type: `string` {@link LCP_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_LCP_URL} `browser.web_vital.lcp.url`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_LCP_URL} (browser.web_vital.lcp.url) instead - The LCP url is now recorded as a browser.web_vital.lcp.url attribute.
 * @example "https://example.com"
 */
export const LCP_URL = 'lcp.url';

/**
 * Type for {@link LCP_URL} lcp.url
 */
export type LCP_URL_TYPE = string;

// Path: model/attributes/litestar/litestar__middleware_name.json

/**
 * The name of the Litestar middleware. `litestar.middleware_name`
 *
 * Attribute Value Type: `string` {@link LITESTAR_MIDDLEWARE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MIDDLEWARE_NAME} `middleware.name`
 *
 * @deprecated Use {@link MIDDLEWARE_NAME} (middleware.name) instead - This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.
 * @example "AuthenticationMiddleware"
 */
export const LITESTAR_MIDDLEWARE_NAME = 'litestar.middleware_name';

/**
 * Type for {@link LITESTAR_MIDDLEWARE_NAME} litestar.middleware_name
 */
export type LITESTAR_MIDDLEWARE_NAME_TYPE = string;

// Path: model/attributes/logger/logger__name.json

/**
 * The name of the logger that generated this event. `logger.name`
 *
 * Attribute Value Type: `string` {@link LOGGER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "myLogger"
 */
export const LOGGER_NAME = 'logger.name';

/**
 * Type for {@link LOGGER_NAME} logger.name
 */
export type LOGGER_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__auth__client__name.json

/**
 * Registered OAuth client application name associated with the authenticated MCP request. Taken from OAuth client registration metadata (client_name) made available by the authentication layer. This is distinct from the MCP implementation name in mcp.client.name; omit it when the OAuth client name is unavailable. `mcp.auth.client.name`
 *
 * Attribute Value Type: `string` {@link MCP_AUTH_CLIENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Example Desktop"
 * @example "Example CLI"
 */
export const MCP_AUTH_CLIENT_NAME = 'mcp.auth.client.name';

/**
 * Type for {@link MCP_AUTH_CLIENT_NAME} mcp.auth.client.name
 */
export type MCP_AUTH_CLIENT_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__cancelled__reason.json

/**
 * Reason for the cancellation of an MCP operation. `mcp.cancelled.reason`
 *
 * Attribute Value Type: `string` {@link MCP_CANCELLED_REASON_TYPE}
 *
 * Apply Scrubbing: manual - Cancellation reasons may contain user-specific or sensitive information
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "User cancelled the request"
 */
export const MCP_CANCELLED_REASON = 'mcp.cancelled.reason';

/**
 * Type for {@link MCP_CANCELLED_REASON} mcp.cancelled.reason
 */
export type MCP_CANCELLED_REASON_TYPE = string;

// Path: model/attributes/mcp/mcp__cancelled__request_id.json

/**
 * Request ID of the cancelled MCP operation. `mcp.cancelled.request_id`
 *
 * Attribute Value Type: `string` {@link MCP_CANCELLED_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "123"
 */
export const MCP_CANCELLED_REQUEST_ID = 'mcp.cancelled.request_id';

/**
 * Type for {@link MCP_CANCELLED_REQUEST_ID} mcp.cancelled.request_id
 */
export type MCP_CANCELLED_REQUEST_ID_TYPE = string;

// Path: model/attributes/mcp/mcp__client__name.json

/**
 * Name of the MCP client implementation, as declared in clientInfo. This is distinct from the registered OAuth application name in mcp.auth.client.name. `mcp.client.name`
 *
 * Attribute Value Type: `string` {@link MCP_CLIENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "example-mcp-client"
 */
export const MCP_CLIENT_NAME = 'mcp.client.name';

/**
 * Type for {@link MCP_CLIENT_NAME} mcp.client.name
 */
export type MCP_CLIENT_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__client__title.json

/**
 * Display title of the MCP client implementation, as declared in clientInfo. `mcp.client.title`
 *
 * Attribute Value Type: `string` {@link MCP_CLIENT_TITLE_TYPE}
 *
 * Apply Scrubbing: manual - Client titles may reveal user-specific application configurations or custom setups
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Example MCP Client"
 */
export const MCP_CLIENT_TITLE = 'mcp.client.title';

/**
 * Type for {@link MCP_CLIENT_TITLE} mcp.client.title
 */
export type MCP_CLIENT_TITLE_TYPE = string;

// Path: model/attributes/mcp/mcp__client__version.json

/**
 * Version of the MCP client implementation, as declared in clientInfo. `mcp.client.version`
 *
 * Attribute Value Type: `string` {@link MCP_CLIENT_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1.0.0"
 */
export const MCP_CLIENT_VERSION = 'mcp.client.version';

/**
 * Type for {@link MCP_CLIENT_VERSION} mcp.client.version
 */
export type MCP_CLIENT_VERSION_TYPE = string;

// Path: model/attributes/mcp/mcp__lifecycle__phase.json

/**
 * Lifecycle phase indicator for MCP operations. `mcp.lifecycle.phase`
 *
 * Attribute Value Type: `string` {@link MCP_LIFECYCLE_PHASE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "initialization_complete"
 */
export const MCP_LIFECYCLE_PHASE = 'mcp.lifecycle.phase';

/**
 * Type for {@link MCP_LIFECYCLE_PHASE} mcp.lifecycle.phase
 */
export type MCP_LIFECYCLE_PHASE_TYPE = string;

// Path: model/attributes/mcp/mcp__logging__data_type.json

/**
 * Data type of the logged message content. `mcp.logging.data_type`
 *
 * Attribute Value Type: `string` {@link MCP_LOGGING_DATA_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "string"
 */
export const MCP_LOGGING_DATA_TYPE = 'mcp.logging.data_type';

/**
 * Type for {@link MCP_LOGGING_DATA_TYPE} mcp.logging.data_type
 */
export type MCP_LOGGING_DATA_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__logging__level.json

/**
 * Log level for MCP logging operations. `mcp.logging.level`
 *
 * Attribute Value Type: `string` {@link MCP_LOGGING_LEVEL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "info"
 */
export const MCP_LOGGING_LEVEL = 'mcp.logging.level';

/**
 * Type for {@link MCP_LOGGING_LEVEL} mcp.logging.level
 */
export type MCP_LOGGING_LEVEL_TYPE = string;

// Path: model/attributes/mcp/mcp__logging__logger.json

/**
 * Logger name for MCP logging operations. `mcp.logging.logger`
 *
 * Attribute Value Type: `string` {@link MCP_LOGGING_LOGGER_TYPE}
 *
 * Apply Scrubbing: manual - Logger names may be user-defined and could contain sensitive information
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "mcp_server"
 */
export const MCP_LOGGING_LOGGER = 'mcp.logging.logger';

/**
 * Type for {@link MCP_LOGGING_LOGGER} mcp.logging.logger
 */
export type MCP_LOGGING_LOGGER_TYPE = string;

// Path: model/attributes/mcp/mcp__logging__message.json

/**
 * Log message content from MCP logging operations. `mcp.logging.message`
 *
 * Attribute Value Type: `string` {@link MCP_LOGGING_MESSAGE_TYPE}
 *
 * Apply Scrubbing: auto - Log messages can contain user data
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Tool execution completed successfully"
 */
export const MCP_LOGGING_MESSAGE = 'mcp.logging.message';

/**
 * Type for {@link MCP_LOGGING_MESSAGE} mcp.logging.message
 */
export type MCP_LOGGING_MESSAGE_TYPE = string;

// Path: model/attributes/mcp/mcp__method__name.json

/**
 * The name of the MCP request or notification method being called. `mcp.method.name`
 *
 * Attribute Value Type: `string` {@link MCP_METHOD_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "tools/call"
 */
export const MCP_METHOD_NAME = 'mcp.method.name';

/**
 * Type for {@link MCP_METHOD_NAME} mcp.method.name
 */
export type MCP_METHOD_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__progress__current.json

/**
 * Current progress value of an MCP operation. `mcp.progress.current`
 *
 * Attribute Value Type: `number` {@link MCP_PROGRESS_CURRENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0.2
 * @example 50
 */
export const MCP_PROGRESS_CURRENT = 'mcp.progress.current';

/**
 * Type for {@link MCP_PROGRESS_CURRENT} mcp.progress.current
 */
export type MCP_PROGRESS_CURRENT_TYPE = number;

// Path: model/attributes/mcp/mcp__progress__message.json

/**
 * Progress message describing the current state of an MCP operation. `mcp.progress.message`
 *
 * Attribute Value Type: `string` {@link MCP_PROGRESS_MESSAGE_TYPE}
 *
 * Apply Scrubbing: manual - Progress messages may contain user-specific or sensitive information
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Processing 50 of 100 items"
 */
export const MCP_PROGRESS_MESSAGE = 'mcp.progress.message';

/**
 * Type for {@link MCP_PROGRESS_MESSAGE} mcp.progress.message
 */
export type MCP_PROGRESS_MESSAGE_TYPE = string;

// Path: model/attributes/mcp/mcp__progress__percentage.json

/**
 * Calculated progress percentage of an MCP operation. Computed from current/total * 100. `mcp.progress.percentage`
 *
 * Attribute Value Type: `number` {@link MCP_PROGRESS_PERCENTAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 50
 */
export const MCP_PROGRESS_PERCENTAGE = 'mcp.progress.percentage';

/**
 * Type for {@link MCP_PROGRESS_PERCENTAGE} mcp.progress.percentage
 */
export type MCP_PROGRESS_PERCENTAGE_TYPE = number;

// Path: model/attributes/mcp/mcp__progress__token.json

/**
 * Token for tracking progress of an MCP operation. `mcp.progress.token`
 *
 * Attribute Value Type: `string` {@link MCP_PROGRESS_TOKEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "progress-token-123"
 */
export const MCP_PROGRESS_TOKEN = 'mcp.progress.token';

/**
 * Type for {@link MCP_PROGRESS_TOKEN} mcp.progress.token
 */
export type MCP_PROGRESS_TOKEN_TYPE = string;

// Path: model/attributes/mcp/mcp__progress__total.json

/**
 * Total progress target value of an MCP operation. `mcp.progress.total`
 *
 * Attribute Value Type: `number` {@link MCP_PROGRESS_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 * @example 100
 */
export const MCP_PROGRESS_TOTAL = 'mcp.progress.total';

/**
 * Type for {@link MCP_PROGRESS_TOTAL} mcp.progress.total
 */
export type MCP_PROGRESS_TOTAL_TYPE = number;

// Path: model/attributes/mcp/mcp__prompt__name.json

/**
 * Name of the MCP prompt template being used. `mcp.prompt.name`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_NAME_TYPE}
 *
 * Apply Scrubbing: manual - Prompt names may reveal user behavior patterns or sensitive operations
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_PROMPT_NAME} `gen_ai.prompt.name`
 *
 * @deprecated Use {@link GEN_AI_PROMPT_NAME} (gen_ai.prompt.name) instead - OTel uses gen_ai.prompt.name for MCP prompt names
 * @example "summarize"
 */
export const MCP_PROMPT_NAME = 'mcp.prompt.name';

/**
 * Type for {@link MCP_PROMPT_NAME} mcp.prompt.name
 */
export type MCP_PROMPT_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__prompt__result__description.json

/**
 * Description of the prompt result. `mcp.prompt.result.description`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_RESULT_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "A summary of the requested information"
 */
export const MCP_PROMPT_RESULT_DESCRIPTION = 'mcp.prompt.result.description';

/**
 * Type for {@link MCP_PROMPT_RESULT_DESCRIPTION} mcp.prompt.result.description
 */
export type MCP_PROMPT_RESULT_DESCRIPTION_TYPE = string;

// Path: model/attributes/mcp/mcp__prompt__result__[key]__content.json

/**
 * Legacy text content of an indexed message in a multi-message MCP prompt result. `mcp.prompt.result.<key>.content`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_RESULT_KEY_CONTENT_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Summarize the document."
 */
export const MCP_PROMPT_RESULT_KEY_CONTENT = 'mcp.prompt.result.<key>.content';

/**
 * Type for {@link MCP_PROMPT_RESULT_KEY_CONTENT} mcp.prompt.result.<key>.content
 */
export type MCP_PROMPT_RESULT_KEY_CONTENT_TYPE = string;

// Path: model/attributes/mcp/mcp__prompt__result__[key]__role.json

/**
 * Legacy role of an indexed message in a multi-message MCP prompt result. `mcp.prompt.result.<key>.role`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_RESULT_KEY_ROLE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "user"
 * @example "assistant"
 */
export const MCP_PROMPT_RESULT_KEY_ROLE = 'mcp.prompt.result.<key>.role';

/**
 * Type for {@link MCP_PROMPT_RESULT_KEY_ROLE} mcp.prompt.result.<key>.role
 */
export type MCP_PROMPT_RESULT_KEY_ROLE_TYPE = string;

// Path: model/attributes/mcp/mcp__prompt__result__message_content.json

/**
 * Content of the message in the prompt result. Used for single message results only. `mcp.prompt.result.message_content`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_RESULT_MESSAGE_CONTENT_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Please provide a summary of the document"
 */
export const MCP_PROMPT_RESULT_MESSAGE_CONTENT = 'mcp.prompt.result.message_content';

/**
 * Type for {@link MCP_PROMPT_RESULT_MESSAGE_CONTENT} mcp.prompt.result.message_content
 */
export type MCP_PROMPT_RESULT_MESSAGE_CONTENT_TYPE = string;

// Path: model/attributes/mcp/mcp__prompt__result__message_count.json

/**
 * Number of messages in the prompt result. `mcp.prompt.result.message_count`
 *
 * Attribute Value Type: `number` {@link MCP_PROMPT_RESULT_MESSAGE_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 3
 */
export const MCP_PROMPT_RESULT_MESSAGE_COUNT = 'mcp.prompt.result.message_count';

/**
 * Type for {@link MCP_PROMPT_RESULT_MESSAGE_COUNT} mcp.prompt.result.message_count
 */
export type MCP_PROMPT_RESULT_MESSAGE_COUNT_TYPE = number;

// Path: model/attributes/mcp/mcp__prompt__result__message_role.json

/**
 * Role of the message in the prompt result. Used for single message results only. `mcp.prompt.result.message_role`
 *
 * Attribute Value Type: `string` {@link MCP_PROMPT_RESULT_MESSAGE_ROLE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "user"
 */
export const MCP_PROMPT_RESULT_MESSAGE_ROLE = 'mcp.prompt.result.message_role';

/**
 * Type for {@link MCP_PROMPT_RESULT_MESSAGE_ROLE} mcp.prompt.result.message_role
 */
export type MCP_PROMPT_RESULT_MESSAGE_ROLE_TYPE = string;

// Path: model/attributes/mcp/mcp__protocol__ready.json

/**
 * Readiness indicator for the legacy MCP initialization handshake. A non-zero value indicates that notifications/initialized has completed initialization. Omit for protocol versions without this handshake. `mcp.protocol.ready`
 *
 * Attribute Value Type: `number` {@link MCP_PROTOCOL_READY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1
 */
export const MCP_PROTOCOL_READY = 'mcp.protocol.ready';

/**
 * Type for {@link MCP_PROTOCOL_READY} mcp.protocol.ready
 */
export type MCP_PROTOCOL_READY_TYPE = number;

// Path: model/attributes/mcp/mcp__protocol__version.json

/**
 * Version of the Model Context Protocol used for the operation. `mcp.protocol.version`
 *
 * Attribute Value Type: `string` {@link MCP_PROTOCOL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "2024-11-05"
 */
export const MCP_PROTOCOL_VERSION = 'mcp.protocol.version';

/**
 * Type for {@link MCP_PROTOCOL_VERSION} mcp.protocol.version
 */
export type MCP_PROTOCOL_VERSION_TYPE = string;

// Path: model/attributes/mcp/mcp__request__argument__[key].json

/**
 * MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value. `mcp.request.argument.<key>`
 *
 * Attribute Value Type: `string` {@link MCP_REQUEST_ARGUMENT_KEY_TYPE}
 *
 * Apply Scrubbing: auto - Arguments contain user input
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "mcp.request.argument.query='weather in Paris'"
 */
export const MCP_REQUEST_ARGUMENT_KEY = 'mcp.request.argument.<key>';

/**
 * Base key for {@link MCP_REQUEST_ARGUMENT_KEY}. Use with a dynamic suffix, e.g. `${MCP_REQUEST_ARGUMENT_KEY_BASE}.${key}`.
 */
export const MCP_REQUEST_ARGUMENT_KEY_BASE = 'mcp.request.argument';

/**
 * Type for {@link MCP_REQUEST_ARGUMENT_KEY} mcp.request.argument.<key>
 */
export type MCP_REQUEST_ARGUMENT_KEY_TYPE = string;

// Path: model/attributes/mcp/mcp__request__argument__name.json

/**
 * Name argument from prompts/get MCP request. `mcp.request.argument.name`
 *
 * Attribute Value Type: `string` {@link MCP_REQUEST_ARGUMENT_NAME_TYPE}
 *
 * Apply Scrubbing: auto - Prompt names can contain user input
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "summarize"
 */
export const MCP_REQUEST_ARGUMENT_NAME = 'mcp.request.argument.name';

/**
 * Type for {@link MCP_REQUEST_ARGUMENT_NAME} mcp.request.argument.name
 */
export type MCP_REQUEST_ARGUMENT_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__request__argument__uri.json

/**
 * URI argument from resources/read MCP request. `mcp.request.argument.uri`
 *
 * Attribute Value Type: `string` {@link MCP_REQUEST_ARGUMENT_URI_TYPE}
 *
 * Apply Scrubbing: auto - URIs can contain user file paths
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "file:///path/to/resource"
 */
export const MCP_REQUEST_ARGUMENT_URI = 'mcp.request.argument.uri';

/**
 * Type for {@link MCP_REQUEST_ARGUMENT_URI} mcp.request.argument.uri
 */
export type MCP_REQUEST_ARGUMENT_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__request__id.json

/**
 * JSON-RPC request identifier for the MCP request, used to correlate the request with its response. `mcp.request.id`
 *
 * Attribute Value Type: `string` {@link MCP_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link JSONRPC_REQUEST_ID} `jsonrpc.request.id`
 *
 * @deprecated Use {@link JSONRPC_REQUEST_ID} (jsonrpc.request.id) instead - OTel models MCP as JSON-RPC, uses jsonrpc.request.id
 * @example "1"
 */
export const MCP_REQUEST_ID = 'mcp.request.id';

/**
 * Type for {@link MCP_REQUEST_ID} mcp.request.id
 */
export type MCP_REQUEST_ID_TYPE = string;

// Path: model/attributes/mcp/mcp__resource__protocol.json

/**
 * URI scheme of the MCP resource being accessed, extracted from its URI. This is distinct from the network protocol used to communicate with the MCP server. `mcp.resource.protocol`
 *
 * Attribute Value Type: `string` {@link MCP_RESOURCE_PROTOCOL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "file"
 * @example "postgres"
 */
export const MCP_RESOURCE_PROTOCOL = 'mcp.resource.protocol';

/**
 * Type for {@link MCP_RESOURCE_PROTOCOL} mcp.resource.protocol
 */
export type MCP_RESOURCE_PROTOCOL_TYPE = string;

// Path: model/attributes/mcp/mcp__resource__uri.json

/**
 * The resource URI being accessed in an MCP operation. `mcp.resource.uri`
 *
 * Attribute Value Type: `string` {@link MCP_RESOURCE_URI_TYPE}
 *
 * Apply Scrubbing: auto - URIs can contain sensitive file paths
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "file:///path/to/file.txt"
 */
export const MCP_RESOURCE_URI = 'mcp.resource.uri';

/**
 * Type for {@link MCP_RESOURCE_URI} mcp.resource.uri
 */
export type MCP_RESOURCE_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__server__name.json

/**
 * Name of the MCP server implementation, as declared in serverInfo. `mcp.server.name`
 *
 * Attribute Value Type: `string` {@link MCP_SERVER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "example-mcp-server"
 */
export const MCP_SERVER_NAME = 'mcp.server.name';

/**
 * Type for {@link MCP_SERVER_NAME} mcp.server.name
 */
export type MCP_SERVER_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__server__title.json

/**
 * Display title of the MCP server implementation, as declared in serverInfo. `mcp.server.title`
 *
 * Attribute Value Type: `string` {@link MCP_SERVER_TITLE_TYPE}
 *
 * Apply Scrubbing: manual - Server titles may reveal user-specific application configurations or custom setups
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Example MCP Server"
 */
export const MCP_SERVER_TITLE = 'mcp.server.title';

/**
 * Type for {@link MCP_SERVER_TITLE} mcp.server.title
 */
export type MCP_SERVER_TITLE_TYPE = string;

// Path: model/attributes/mcp/mcp__server__version.json

/**
 * Version of the MCP server implementation, as declared in serverInfo. `mcp.server.version`
 *
 * Attribute Value Type: `string` {@link MCP_SERVER_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "0.1.0"
 */
export const MCP_SERVER_VERSION = 'mcp.server.version';

/**
 * Type for {@link MCP_SERVER_VERSION} mcp.server.version
 */
export type MCP_SERVER_VERSION_TYPE = string;

// Path: model/attributes/mcp/mcp__session__id.json

/**
 * Identifier for an MCP protocol session, when the operation belongs to a session. `mcp.session.id`
 *
 * Attribute Value Type: `string` {@link MCP_SESSION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "550e8400-e29b-41d4-a716-446655440000"
 */
export const MCP_SESSION_ID = 'mcp.session.id';

/**
 * Type for {@link MCP_SESSION_ID} mcp.session.id
 */
export type MCP_SESSION_ID_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__name.json

/**
 * Name of the MCP tool being called. `mcp.tool.name`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_NAME} `gen_ai.tool.name`, {@link AI_FUNCTION_CALL} `ai.function_call`
 *
 * @deprecated Use {@link GEN_AI_TOOL_NAME} (gen_ai.tool.name) instead - OTel uses gen_ai.tool.name for MCP tool names
 * @example "calculator"
 */
export const MCP_TOOL_NAME = 'mcp.tool.name';

/**
 * Type for {@link MCP_TOOL_NAME} mcp.tool.name
 */
export type MCP_TOOL_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__content.json

/**
 * The content of the tool result. `mcp.tool.result.content`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_CONTENT_TYPE}
 *
 * Apply Scrubbing: auto - Tool results can contain user data
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link GEN_AI_TOOL_CALL_RESULT} `gen_ai.tool.call.result`, {@link GEN_AI_TOOL_MESSAGE} `gen_ai.tool.message`, {@link GEN_AI_TOOL_OUTPUT} `gen_ai.tool.output`, {@link AI_TOOLCALL_RESULT} `ai.toolCall.result`, {@link ANTHROPIC_TOOL_RESULT_CONTENT} `anthropic.tool_result.content`
 *
 * @deprecated Use {@link GEN_AI_TOOL_CALL_RESULT} (gen_ai.tool.call.result) instead - OTel uses gen_ai.tool.call.result for MCP tool results
 * @example "{\"output\": \"rainy\", \"toolCallId\": \"1\"}"
 */
export const MCP_TOOL_RESULT_CONTENT = 'mcp.tool.result.content';

/**
 * Type for {@link MCP_TOOL_RESULT_CONTENT} mcp.tool.result.content
 */
export type MCP_TOOL_RESULT_CONTENT_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__content_count.json

/**
 * Number of content items in the tool result. `mcp.tool.result.content_count`
 *
 * Attribute Value Type: `number` {@link MCP_TOOL_RESULT_CONTENT_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - A count can be calculcated from the value of the gen_ai.tool.call.result attribute.
 * @example 1
 */
export const MCP_TOOL_RESULT_CONTENT_COUNT = 'mcp.tool.result.content_count';

/**
 * Type for {@link MCP_TOOL_RESULT_CONTENT_COUNT} mcp.tool.result.content_count
 */
export type MCP_TOOL_RESULT_CONTENT_COUNT_TYPE = number;

// Path: model/attributes/mcp/mcp__tool__result__content_type.json

/**
 * Legacy content type of the content item in a single-item MCP tool result. `mcp.tool.result.content_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_CONTENT_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "text"
 * @example "image"
 */
export const MCP_TOOL_RESULT_CONTENT_TYPE = 'mcp.tool.result.content_type';

/**
 * Type for {@link MCP_TOOL_RESULT_CONTENT_TYPE} mcp.tool.result.content_type
 */
export type MCP_TOOL_RESULT_CONTENT_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__data_size.json

/**
 * Legacy length of the data string in UTF-16 code units of the content item in a single-item MCP tool result. `mcp.tool.result.data_size`
 *
 * Attribute Value Type: `number` {@link MCP_TOOL_RESULT_DATA_SIZE_TYPE}
 *
 * Apply Scrubbing: manual - The length contains no result content.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example 4
 * @example 1024
 */
export const MCP_TOOL_RESULT_DATA_SIZE = 'mcp.tool.result.data_size';

/**
 * Type for {@link MCP_TOOL_RESULT_DATA_SIZE} mcp.tool.result.data_size
 */
export type MCP_TOOL_RESULT_DATA_SIZE_TYPE = number;

// Path: model/attributes/mcp/mcp__tool__result__is_error.json

/**
 * Whether a tool execution resulted in an error. `mcp.tool.result.is_error`
 *
 * Attribute Value Type: `boolean` {@link MCP_TOOL_RESULT_IS_ERROR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link ERROR_TYPE} (error.type) instead - OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string).
 * @example false
 */
export const MCP_TOOL_RESULT_IS_ERROR = 'mcp.tool.result.is_error';

/**
 * Type for {@link MCP_TOOL_RESULT_IS_ERROR} mcp.tool.result.is_error
 */
export type MCP_TOOL_RESULT_IS_ERROR_TYPE = boolean;

// Path: model/attributes/mcp/mcp__tool__result__[key]__content.json

/**
 * Legacy text content of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.content`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_CONTENT_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "The operation completed."
 */
export const MCP_TOOL_RESULT_KEY_CONTENT = 'mcp.tool.result.<key>.content';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_CONTENT} mcp.tool.result.<key>.content
 */
export type MCP_TOOL_RESULT_KEY_CONTENT_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__content_type.json

/**
 * Legacy content type of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.content_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_CONTENT_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "text"
 * @example "image"
 */
export const MCP_TOOL_RESULT_KEY_CONTENT_TYPE = 'mcp.tool.result.<key>.content_type';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_CONTENT_TYPE} mcp.tool.result.<key>.content_type
 */
export type MCP_TOOL_RESULT_KEY_CONTENT_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__data_size.json

/**
 * Legacy length of the data string in UTF-16 code units of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.data_size`
 *
 * Attribute Value Type: `number` {@link MCP_TOOL_RESULT_KEY_DATA_SIZE_TYPE}
 *
 * Apply Scrubbing: manual - The length contains no result content.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example 4
 * @example 1024
 */
export const MCP_TOOL_RESULT_KEY_DATA_SIZE = 'mcp.tool.result.<key>.data_size';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_DATA_SIZE} mcp.tool.result.<key>.data_size
 */
export type MCP_TOOL_RESULT_KEY_DATA_SIZE_TYPE = number;

// Path: model/attributes/mcp/mcp__tool__result__[key]__mime_type.json

/**
 * Legacy MIME type of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.mime_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_MIME_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "image/png"
 * @example "audio/wav"
 */
export const MCP_TOOL_RESULT_KEY_MIME_TYPE = 'mcp.tool.result.<key>.mime_type';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_MIME_TYPE} mcp.tool.result.<key>.mime_type
 */
export type MCP_TOOL_RESULT_KEY_MIME_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__name.json

/**
 * Legacy resource link name of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.name`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_NAME_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "report.txt"
 */
export const MCP_TOOL_RESULT_KEY_NAME = 'mcp.tool.result.<key>.name';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_NAME} mcp.tool.result.<key>.name
 */
export type MCP_TOOL_RESULT_KEY_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__resource_mime_type.json

/**
 * Legacy embedded resource MIME type of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.resource_mime_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "text/plain"
 */
export const MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE = 'mcp.tool.result.<key>.resource_mime_type';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE} mcp.tool.result.<key>.resource_mime_type
 */
export type MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__resource_uri.json

/**
 * Legacy embedded resource URI of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.resource_uri`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_RESOURCE_URI_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "file:///project/report.txt"
 */
export const MCP_TOOL_RESULT_KEY_RESOURCE_URI = 'mcp.tool.result.<key>.resource_uri';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_RESOURCE_URI} mcp.tool.result.<key>.resource_uri
 */
export type MCP_TOOL_RESULT_KEY_RESOURCE_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__[key]__uri.json

/**
 * Legacy resource link URI of an indexed content item in a multi-item MCP tool result. `mcp.tool.result.<key>.uri`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_KEY_URI_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "file:///project/report.txt"
 */
export const MCP_TOOL_RESULT_KEY_URI = 'mcp.tool.result.<key>.uri';

/**
 * Type for {@link MCP_TOOL_RESULT_KEY_URI} mcp.tool.result.<key>.uri
 */
export type MCP_TOOL_RESULT_KEY_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__mime_type.json

/**
 * Legacy MIME type of the content item in a single-item MCP tool result. `mcp.tool.result.mime_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_MIME_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "image/png"
 * @example "audio/wav"
 */
export const MCP_TOOL_RESULT_MIME_TYPE = 'mcp.tool.result.mime_type';

/**
 * Type for {@link MCP_TOOL_RESULT_MIME_TYPE} mcp.tool.result.mime_type
 */
export type MCP_TOOL_RESULT_MIME_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__name.json

/**
 * Legacy resource link name of the content item in a single-item MCP tool result. `mcp.tool.result.name`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_NAME_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "report.txt"
 */
export const MCP_TOOL_RESULT_NAME = 'mcp.tool.result.name';

/**
 * Type for {@link MCP_TOOL_RESULT_NAME} mcp.tool.result.name
 */
export type MCP_TOOL_RESULT_NAME_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__resource_mime_type.json

/**
 * Legacy embedded resource MIME type of the content item in a single-item MCP tool result. `mcp.tool.result.resource_mime_type`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_RESOURCE_MIME_TYPE_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "text/plain"
 */
export const MCP_TOOL_RESULT_RESOURCE_MIME_TYPE = 'mcp.tool.result.resource_mime_type';

/**
 * Type for {@link MCP_TOOL_RESULT_RESOURCE_MIME_TYPE} mcp.tool.result.resource_mime_type
 */
export type MCP_TOOL_RESULT_RESOURCE_MIME_TYPE_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__resource_uri.json

/**
 * Legacy embedded resource URI of the content item in a single-item MCP tool result. `mcp.tool.result.resource_uri`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_RESOURCE_URI_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "file:///project/report.txt"
 */
export const MCP_TOOL_RESULT_RESOURCE_URI = 'mcp.tool.result.resource_uri';

/**
 * Type for {@link MCP_TOOL_RESULT_RESOURCE_URI} mcp.tool.result.resource_uri
 */
export type MCP_TOOL_RESULT_RESOURCE_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__tool__result__uri.json

/**
 * Legacy resource link URI of the content item in a single-item MCP tool result. `mcp.tool.result.uri`
 *
 * Attribute Value Type: `string` {@link MCP_TOOL_RESULT_URI_TYPE}
 *
 * Apply Scrubbing: auto - Preserve automatic scrubbing of server-provided result fields.
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.
 * @example "file:///project/report.txt"
 */
export const MCP_TOOL_RESULT_URI = 'mcp.tool.result.uri';

/**
 * Type for {@link MCP_TOOL_RESULT_URI} mcp.tool.result.uri
 */
export type MCP_TOOL_RESULT_URI_TYPE = string;

// Path: model/attributes/mcp/mcp__transport.json

/**
 * MCP transport implementation name, such as the transport class name. This identifies the implementation, not the network transport or application protocol. `mcp.transport`
 *
 * Attribute Value Type: `string` {@link MCP_TRANSPORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "StdioServerTransport"
 * @example "CustomHTTPTransport"
 */
export const MCP_TRANSPORT = 'mcp.transport';

/**
 * Type for {@link MCP_TRANSPORT} mcp.transport
 */
export type MCP_TRANSPORT_TYPE = string;

// Path: model/attributes/mdc/mdc__[key].json

/**
 * Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request. `mdc.<key>`
 *
 * Attribute Value Type: `string` {@link MDC_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "mdc.some_key='some_value'"
 */
export const MDC_KEY = 'mdc.<key>';

/**
 * Base key for {@link MDC_KEY}. Use with a dynamic suffix, e.g. `${MDC_KEY_BASE}.${key}`.
 */
export const MDC_KEY_BASE = 'mdc';

/**
 * Type for {@link MDC_KEY} mdc.<key>
 */
export type MDC_KEY_TYPE = string;

// Path: model/attributes/messaging/messaging__batch__message_count.json

/**
 * The number of messages sent, received, or processed in the scope of the batching operation. `messaging.batch.message_count`
 *
 * Attribute Value Type: `number` {@link MESSAGING_BATCH_MESSAGE_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 10
 */
export const MESSAGING_BATCH_MESSAGE_COUNT = 'messaging.batch.message_count';

/**
 * Type for {@link MESSAGING_BATCH_MESSAGE_COUNT} messaging.batch.message_count
 */
export type MESSAGING_BATCH_MESSAGE_COUNT_TYPE = number;

// Path: model/attributes/messaging/messaging__conversation_id.json

/**
 * The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID". `messaging.conversation_id`
 *
 * Attribute Value Type: `string` {@link MESSAGING_CONVERSATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_MESSAGE_CONVERSATION_ID} `messaging.message.conversation_id`
 *
 * @deprecated Use {@link MESSAGING_MESSAGE_CONVERSATION_ID} (messaging.message.conversation_id) instead - This attribute is being deprecated in favor of messaging.message.conversation_id.
 * @example "MyConversationId"
 */
export const MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';

/**
 * Type for {@link MESSAGING_CONVERSATION_ID} messaging.conversation_id
 */
export type MESSAGING_CONVERSATION_ID_TYPE = string;

// Path: model/attributes/messaging/messaging__destination.json

/**
 * The message destination name. `messaging.destination`
 *
 * Attribute Value Type: `string` {@link MESSAGING_DESTINATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_DESTINATION_NAME} `messaging.destination.name`
 *
 * @deprecated Use {@link MESSAGING_DESTINATION_NAME} (messaging.destination.name) instead - This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement.
 * @example "BestTopic"
 */
export const MESSAGING_DESTINATION = 'messaging.destination';

/**
 * Type for {@link MESSAGING_DESTINATION} messaging.destination
 */
export type MESSAGING_DESTINATION_TYPE = string;

// Path: model/attributes/messaging/messaging__destination__connection.json

/**
 * The message destination connection. `messaging.destination.connection`
 *
 * Attribute Value Type: `string` {@link MESSAGING_DESTINATION_CONNECTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "BestTopic"
 */
export const MESSAGING_DESTINATION_CONNECTION = 'messaging.destination.connection';

/**
 * Type for {@link MESSAGING_DESTINATION_CONNECTION} messaging.destination.connection
 */
export type MESSAGING_DESTINATION_CONNECTION_TYPE = string;

// Path: model/attributes/messaging/messaging__destination_kind.json

/**
 * The kind of message destination. `messaging.destination_kind`
 *
 * Attribute Value Type: `string` {@link MESSAGING_DESTINATION_KIND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - Deprecated from OTEL, which now models the destination kind via messaging.operation.type and messaging.destination.name.
 * @example "topic"
 */
export const MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';

/**
 * Type for {@link MESSAGING_DESTINATION_KIND} messaging.destination_kind
 */
export type MESSAGING_DESTINATION_KIND_TYPE = string;

// Path: model/attributes/messaging/messaging__destination__name.json

/**
 * The message destination name. `messaging.destination.name`
 *
 * Attribute Value Type: `string` {@link MESSAGING_DESTINATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_DESTINATION} `messaging.destination`
 *
 * @example "BestTopic"
 */
export const MESSAGING_DESTINATION_NAME = 'messaging.destination.name';

/**
 * Type for {@link MESSAGING_DESTINATION_NAME} messaging.destination.name
 */
export type MESSAGING_DESTINATION_NAME_TYPE = string;

// Path: model/attributes/messaging/messaging__destination__partition__id.json

/**
 * The identifier of the partition messages are sent to or received from, unique within the messaging.destination.name. `messaging.destination.partition.id`
 *
 * Attribute Value Type: `string` {@link MESSAGING_DESTINATION_PARTITION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "1"
 */
export const MESSAGING_DESTINATION_PARTITION_ID = 'messaging.destination.partition.id';

/**
 * Type for {@link MESSAGING_DESTINATION_PARTITION_ID} messaging.destination.partition.id
 */
export type MESSAGING_DESTINATION_PARTITION_ID_TYPE = string;

// Path: model/attributes/messaging/messaging__kafka__message__key.json

/**
 * Message keys in Kafka are used for grouping alike messages to ensure they're processed on the same partition. They differ from messaging.message.id in that they're not unique. If the key is null, the attribute MUST NOT be set. `messaging.kafka.message.key`
 *
 * Attribute Value Type: `string` {@link MESSAGING_KAFKA_MESSAGE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "myKey"
 */
export const MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message.key';

/**
 * Type for {@link MESSAGING_KAFKA_MESSAGE_KEY} messaging.kafka.message.key
 */
export type MESSAGING_KAFKA_MESSAGE_KEY_TYPE = string;

// Path: model/attributes/messaging/messaging__kafka__message__tombstone.json

/**
 * A boolean that is true if the message is a tombstone. `messaging.kafka.message.tombstone`
 *
 * Attribute Value Type: `boolean` {@link MESSAGING_KAFKA_MESSAGE_TOMBSTONE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example true
 */
export const MESSAGING_KAFKA_MESSAGE_TOMBSTONE = 'messaging.kafka.message.tombstone';

/**
 * Type for {@link MESSAGING_KAFKA_MESSAGE_TOMBSTONE} messaging.kafka.message.tombstone
 */
export type MESSAGING_KAFKA_MESSAGE_TOMBSTONE_TYPE = boolean;

// Path: model/attributes/messaging/messaging__kafka__offset.json

/**
 * The offset of a record in the corresponding Kafka partition. `messaging.kafka.offset`
 *
 * Attribute Value Type: `number` {@link MESSAGING_KAFKA_OFFSET_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 42
 */
export const MESSAGING_KAFKA_OFFSET = 'messaging.kafka.offset';

/**
 * Type for {@link MESSAGING_KAFKA_OFFSET} messaging.kafka.offset
 */
export type MESSAGING_KAFKA_OFFSET_TYPE = number;

// Path: model/attributes/messaging/messaging__message__body__size.json

/**
 * The size of the message body in bytes. `messaging.message.body.size`
 *
 * Attribute Value Type: `number` {@link MESSAGING_MESSAGE_BODY_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 839
 */
export const MESSAGING_MESSAGE_BODY_SIZE = 'messaging.message.body.size';

/**
 * Type for {@link MESSAGING_MESSAGE_BODY_SIZE} messaging.message.body.size
 */
export type MESSAGING_MESSAGE_BODY_SIZE_TYPE = number;

// Path: model/attributes/messaging/messaging__message__conversation_id.json

/**
 * The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID". `messaging.message.conversation_id`
 *
 * Attribute Value Type: `string` {@link MESSAGING_MESSAGE_CONVERSATION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_CONVERSATION_ID} `messaging.conversation_id`
 *
 * @example "MyConversationId"
 */
export const MESSAGING_MESSAGE_CONVERSATION_ID = 'messaging.message.conversation_id';

/**
 * Type for {@link MESSAGING_MESSAGE_CONVERSATION_ID} messaging.message.conversation_id
 */
export type MESSAGING_MESSAGE_CONVERSATION_ID_TYPE = string;

// Path: model/attributes/messaging/messaging__message__envelope__size.json

/**
 * The size of the message body and metadata in bytes. `messaging.message.envelope.size`
 *
 * Attribute Value Type: `number` {@link MESSAGING_MESSAGE_ENVELOPE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 1045
 */
export const MESSAGING_MESSAGE_ENVELOPE_SIZE = 'messaging.message.envelope.size';

/**
 * Type for {@link MESSAGING_MESSAGE_ENVELOPE_SIZE} messaging.message.envelope.size
 */
export type MESSAGING_MESSAGE_ENVELOPE_SIZE_TYPE = number;

// Path: model/attributes/messaging/messaging__message__id.json

/**
 * A value used by the messaging system as an identifier for the message, represented as a string. `messaging.message.id`
 *
 * Attribute Value Type: `string` {@link MESSAGING_MESSAGE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link _MESSAGING_MESSAGE_ID} `messaging.message_id`
 *
 * @example "f47ac10b58cc4372a5670e02b2c3d479"
 */
export const MESSAGING_MESSAGE_ID = 'messaging.message.id';

/**
 * Type for {@link MESSAGING_MESSAGE_ID} messaging.message.id
 */
export type MESSAGING_MESSAGE_ID_TYPE = string;

// Path: model/attributes/messaging/messaging__message_id.json

/**
 * A value used by the messaging system as an identifier for the message, represented as a string. `messaging.message_id`
 *
 * Attribute Value Type: `string` {@link _MESSAGING_MESSAGE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_MESSAGE_ID} `messaging.message.id`
 *
 * @deprecated Use {@link MESSAGING_MESSAGE_ID} (messaging.message.id) instead - This attribute is being deprecated in favor of messaging.message.id.
 * @example "452a7c7c7c7048c2f887f0e7"
 */
export const _MESSAGING_MESSAGE_ID = 'messaging.message_id';

/**
 * Type for {@link _MESSAGING_MESSAGE_ID} messaging.message_id
 */
export type _MESSAGING_MESSAGE_ID_TYPE = string;

// Path: model/attributes/messaging/messaging__message__receive__latency.json

/**
 * The latency between when the message was published and received. `messaging.message.receive.latency`
 *
 * Attribute Value Type: `number` {@link MESSAGING_MESSAGE_RECEIVE_LATENCY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1732847252
 */
export const MESSAGING_MESSAGE_RECEIVE_LATENCY = 'messaging.message.receive.latency';

/**
 * Type for {@link MESSAGING_MESSAGE_RECEIVE_LATENCY} messaging.message.receive.latency
 */
export type MESSAGING_MESSAGE_RECEIVE_LATENCY_TYPE = number;

// Path: model/attributes/messaging/messaging__message__retry__count.json

/**
 * The amount of attempts to send the message. `messaging.message.retry.count`
 *
 * Attribute Value Type: `number` {@link MESSAGING_MESSAGE_RETRY_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 2
 */
export const MESSAGING_MESSAGE_RETRY_COUNT = 'messaging.message.retry.count';

/**
 * Type for {@link MESSAGING_MESSAGE_RETRY_COUNT} messaging.message.retry.count
 */
export type MESSAGING_MESSAGE_RETRY_COUNT_TYPE = number;

// Path: model/attributes/messaging/messaging__operation.json

/**
 * The name of the messaging operation being performed. `messaging.operation`
 *
 * Attribute Value Type: `string` {@link MESSAGING_OPERATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_OPERATION_NAME} `messaging.operation.name`
 *
 * @deprecated Use {@link MESSAGING_OPERATION_NAME} (messaging.operation.name) instead - This attribute is being deprecated in favor of messaging.operation.name.
 * @example "publish"
 */
export const MESSAGING_OPERATION = 'messaging.operation';

/**
 * Type for {@link MESSAGING_OPERATION} messaging.operation
 */
export type MESSAGING_OPERATION_TYPE = string;

// Path: model/attributes/messaging/messaging__operation__name.json

/**
 * The name of the messaging operation being performed `messaging.operation.name`
 *
 * Attribute Value Type: `string` {@link MESSAGING_OPERATION_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_OPERATION} `messaging.operation`
 *
 * @example "send"
 */
export const MESSAGING_OPERATION_NAME = 'messaging.operation.name';

/**
 * Type for {@link MESSAGING_OPERATION_NAME} messaging.operation.name
 */
export type MESSAGING_OPERATION_NAME_TYPE = string;

// Path: model/attributes/messaging/messaging__operation__type.json

/**
 * A string identifying the type of the messaging operation `messaging.operation.type`
 *
 * Attribute Value Type: `string` {@link MESSAGING_OPERATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "create"
 */
export const MESSAGING_OPERATION_TYPE = 'messaging.operation.type';

/**
 * Type for {@link MESSAGING_OPERATION_TYPE} messaging.operation.type
 */
export type MESSAGING_OPERATION_TYPE_TYPE = string;

// Path: model/attributes/messaging/messaging__protocol.json

/**
 * OSI application layer or non-OSI equivalent. `messaging.protocol`
 *
 * Attribute Value Type: `string` {@link MESSAGING_PROTOCOL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PROTOCOL_NAME} `network.protocol.name`, {@link NET_PROTOCOL_NAME} `net.protocol.name`
 *
 * @deprecated Use {@link NETWORK_PROTOCOL_NAME} (network.protocol.name) instead - This attribute is being deprecated in favor of network.protocol.name.
 * @example "AMQP"
 */
export const MESSAGING_PROTOCOL = 'messaging.protocol';

/**
 * Type for {@link MESSAGING_PROTOCOL} messaging.protocol
 */
export type MESSAGING_PROTOCOL_TYPE = string;

// Path: model/attributes/messaging/messaging__protocol_version.json

/**
 * The actual version of the protocol used for network communication. `messaging.protocol_version`
 *
 * Attribute Value Type: `string` {@link MESSAGING_PROTOCOL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PROTOCOL_VERSION} `network.protocol.version`, {@link HTTP_FLAVOR} `http.flavor`, {@link NET_PROTOCOL_VERSION} `net.protocol.version`
 *
 * @deprecated Use {@link NETWORK_PROTOCOL_VERSION} (network.protocol.version) instead - This attribute is being deprecated in favor of network.protocol.version.
 * @example "0.9.1"
 */
export const MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';

/**
 * Type for {@link MESSAGING_PROTOCOL_VERSION} messaging.protocol_version
 */
export type MESSAGING_PROTOCOL_VERSION_TYPE = string;

// Path: model/attributes/messaging/messaging__rabbitmq__destination__routing_key.json

/**
 * RabbitMQ message routing key. `messaging.rabbitmq.destination.routing_key`
 *
 * Attribute Value Type: `string` {@link MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_RABBITMQ_ROUTING_KEY} `messaging.rabbitmq.routing_key`
 *
 * @example "myKey"
 */
export const MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY = 'messaging.rabbitmq.destination.routing_key';

/**
 * Type for {@link MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY} messaging.rabbitmq.destination.routing_key
 */
export type MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY_TYPE = string;

// Path: model/attributes/messaging/messaging__rabbitmq__routing_key.json

/**
 * RabbitMQ message routing key. `messaging.rabbitmq.routing_key`
 *
 * Attribute Value Type: `string` {@link MESSAGING_RABBITMQ_ROUTING_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY} `messaging.rabbitmq.destination.routing_key`
 *
 * @deprecated Use {@link MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY} (messaging.rabbitmq.destination.routing_key) instead - This attribute is being deprecated in favor of messaging.rabbitmq.destination.routing_key.
 * @example "myKey"
 */
export const MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';

/**
 * Type for {@link MESSAGING_RABBITMQ_ROUTING_KEY} messaging.rabbitmq.routing_key
 */
export type MESSAGING_RABBITMQ_ROUTING_KEY_TYPE = string;

// Path: model/attributes/messaging/messaging__system.json

/**
 * The messaging system as identified by the client instrumentation. `messaging.system`
 *
 * Attribute Value Type: `string` {@link MESSAGING_SYSTEM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "activemq"
 */
export const MESSAGING_SYSTEM = 'messaging.system';

/**
 * Type for {@link MESSAGING_SYSTEM} messaging.system
 */
export type MESSAGING_SYSTEM_TYPE = string;

// Path: model/attributes/messaging/messaging__url.json

/**
 * The connection string of the messaging broker. `messaging.url`
 *
 * Attribute Value Type: `string` {@link MESSAGING_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link URL_FULL} `url.full`, {@link HTTP_URL} `http.url`, {@link URL} `url`, {@link AWS_REQUEST_URL} `aws.request.url`
 *
 * @deprecated Use {@link URL_FULL} (url.full) instead - This attribute is being deprecated in favor of url.full.
 * @example "amqp://guest:guest@localhost:5672"
 */
export const MESSAGING_URL = 'messaging.url';

/**
 * Type for {@link MESSAGING_URL} messaging.url
 */
export type MESSAGING_URL_TYPE = string;

// Path: model/attributes/method.json

/**
 * The HTTP method used. `method`
 *
 * Attribute Value Type: `string` {@link METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_METHOD} `http.request.method`, {@link _HTTP_REQUEST_METHOD} `http.request_method`, {@link HTTP_METHOD} `http.method`
 *
 * @deprecated Use {@link HTTP_REQUEST_METHOD} (http.request.method) instead
 * @example "GET"
 */
export const METHOD = 'method';

/**
 * Type for {@link METHOD} method
 */
export type METHOD_TYPE = string;

// Path: model/attributes/middleware/middleware__name.json

/**
 * The name of the middleware. `middleware.name`
 *
 * Attribute Value Type: `string` {@link MIDDLEWARE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DJANGO_MIDDLEWARE_NAME} `django.middleware_name`, {@link STARLITE_MIDDLEWARE_NAME} `starlite.middleware_name`, {@link LITESTAR_MIDDLEWARE_NAME} `litestar.middleware_name`, {@link STARLETTE_MIDDLEWARE_NAME} `starlette.middleware_name`
 *
 * @example "AuthenticationMiddleware"
 */
export const MIDDLEWARE_NAME = 'middleware.name';

/**
 * Type for {@link MIDDLEWARE_NAME} middleware.name
 */
export type MIDDLEWARE_NAME_TYPE = string;

// Path: model/attributes/navigation/navigation__origin.json

/**
 * The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise. `navigation.origin`
 *
 * Attribute Value Type: `string` {@link NAVIGATION_ORIGIN_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link ROUTER_NAVIGATION_ORIGIN} `router.navigation.origin`, {@link SENTRY_SVELTEKIT_NAVIGATION_FROM} `sentry.sveltekit.navigation.from`
 *
 * @deprecated Use {@link ROUTER_NAVIGATION_ORIGIN} (router.navigation.origin) instead - Moved to the router.* namespace to separate client-side router navigations from browser navigations.
 * @example "/users/:id"
 */
export const NAVIGATION_ORIGIN = 'navigation.origin';

/**
 * Type for {@link NAVIGATION_ORIGIN} navigation.origin
 */
export type NAVIGATION_ORIGIN_TYPE = string;

// Path: model/attributes/navigation/navigation__route__id.json

/**
 * The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id). `navigation.route.id`
 *
 * Attribute Value Type: `string` {@link NAVIGATION_ROUTE_ID_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link ROUTER_NAVIGATION_ROUTE_ID} `router.navigation.route.id`
 *
 * @deprecated Use {@link ROUTER_NAVIGATION_ROUTE_ID} (router.navigation.route.id) instead - Moved to the router.* namespace to separate client-side router navigations from browser navigations.
 * @example "AboutView"
 */
export const NAVIGATION_ROUTE_ID = 'navigation.route.id';

/**
 * Type for {@link NAVIGATION_ROUTE_ID} navigation.route.id
 */
export type NAVIGATION_ROUTE_ID_TYPE = string;

// Path: model/attributes/navigation/navigation__type.json

/**
 * The type of navigation done by a client-side router. `navigation.type`
 *
 * Attribute Value Type: `string` {@link NAVIGATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link ROUTER_NAVIGATION_TYPE} `router.navigation.type`, {@link SENTRY_SVELTEKIT_NAVIGATION_TYPE} `sentry.sveltekit.navigation.type`
 *
 * @deprecated Use {@link ROUTER_NAVIGATION_TYPE} (router.navigation.type) instead - Moved to the router.* namespace to separate client-side router navigations from browser navigations.
 * @example "router.push"
 */
export const NAVIGATION_TYPE = 'navigation.type';

/**
 * Type for {@link NAVIGATION_TYPE} navigation.type
 */
export type NAVIGATION_TYPE_TYPE = string;

// Path: model/attributes/nel/nel__elapsed_time.json

/**
 * The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent. `nel.elapsed_time`
 *
 * Attribute Value Type: `number` {@link NEL_ELAPSED_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 100
 */
export const NEL_ELAPSED_TIME = 'nel.elapsed_time';

/**
 * Type for {@link NEL_ELAPSED_TIME} nel.elapsed_time
 */
export type NEL_ELAPSED_TIME_TYPE = number;

// Path: model/attributes/nel/nel__phase.json

/**
 * If request failed, the phase of its network error. If request succeeded, "application". `nel.phase`
 *
 * Attribute Value Type: `string` {@link NEL_PHASE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "application"
 */
export const NEL_PHASE = 'nel.phase';

/**
 * Type for {@link NEL_PHASE} nel.phase
 */
export type NEL_PHASE_TYPE = string;

// Path: model/attributes/nel/nel__referrer.json

/**
 * request's referrer, as determined by the referrer policy associated with its client. `nel.referrer`
 *
 * Attribute Value Type: `string` {@link NEL_REFERRER_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://example.com/foo?bar=baz"
 */
export const NEL_REFERRER = 'nel.referrer';

/**
 * Type for {@link NEL_REFERRER} nel.referrer
 */
export type NEL_REFERRER_TYPE = string;

// Path: model/attributes/nel/nel__sampling_fraction.json

/**
 * The sampling fraction used to determine if the request should be sampled. `nel.sampling_fraction`
 *
 * Attribute Value Type: `number` {@link NEL_SAMPLING_FRACTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NEL_SAMPLING_FUNCTION} `nel.sampling_function`
 *
 * @example 0.5
 */
export const NEL_SAMPLING_FRACTION = 'nel.sampling_fraction';

/**
 * Type for {@link NEL_SAMPLING_FRACTION} nel.sampling_fraction
 */
export type NEL_SAMPLING_FRACTION_TYPE = number;

// Path: model/attributes/nel/nel__sampling_function.json

/**
 * The sampling function used to determine if the request should be sampled. `nel.sampling_function`
 *
 * Attribute Value Type: `number` {@link NEL_SAMPLING_FUNCTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NEL_SAMPLING_FRACTION} `nel.sampling_fraction`
 *
 * @deprecated Use {@link NEL_SAMPLING_FRACTION} (nel.sampling_fraction) instead - The correct name of this attribute is nel.sampling_fraction
 * @example 0.5
 */
export const NEL_SAMPLING_FUNCTION = 'nel.sampling_function';

/**
 * Type for {@link NEL_SAMPLING_FUNCTION} nel.sampling_function
 */
export type NEL_SAMPLING_FUNCTION_TYPE = number;

// Path: model/attributes/nel/nel__type.json

/**
 * If request failed, the type of its network error. If request succeeded, "ok". `nel.type`
 *
 * Attribute Value Type: `string` {@link NEL_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "dns.unreachable"
 */
export const NEL_TYPE = 'nel.type';

/**
 * Type for {@link NEL_TYPE} nel.type
 */
export type NEL_TYPE_TYPE = string;

// Path: model/attributes/network/network__connection__effective_type.json

/**
 * Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g). `network.connection.effective_type`
 *
 * Attribute Value Type: `string` {@link NETWORK_CONNECTION_EFFECTIVE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link EFFECTIVECONNECTIONTYPE} `effectiveConnectionType`
 *
 * @example "4g"
 */
export const NETWORK_CONNECTION_EFFECTIVE_TYPE = 'network.connection.effective_type';

/**
 * Type for {@link NETWORK_CONNECTION_EFFECTIVE_TYPE} network.connection.effective_type
 */
export type NETWORK_CONNECTION_EFFECTIVE_TYPE_TYPE = string;

// Path: model/attributes/network/network__connection__rtt.json

/**
 * Specifies the estimated effective round-trip time of the current connection, in milliseconds. `network.connection.rtt`
 *
 * Attribute Value Type: `number` {@link NETWORK_CONNECTION_RTT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CONNECTION_RTT} `connection.rtt`
 *
 * @example 100
 */
export const NETWORK_CONNECTION_RTT = 'network.connection.rtt';

/**
 * Type for {@link NETWORK_CONNECTION_RTT} network.connection.rtt
 */
export type NETWORK_CONNECTION_RTT_TYPE = number;

// Path: model/attributes/network/network__connection__type.json

/**
 * Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc). `network.connection.type`
 *
 * Attribute Value Type: `string` {@link NETWORK_CONNECTION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link DEVICE_CONNECTION_TYPE} `device.connection_type`, {@link CONNECTIONTYPE} `connectionType`
 *
 * @example "wifi"
 */
export const NETWORK_CONNECTION_TYPE = 'network.connection.type';

/**
 * Type for {@link NETWORK_CONNECTION_TYPE} network.connection.type
 */
export type NETWORK_CONNECTION_TYPE_TYPE = string;

// Path: model/attributes/network/network__local__address.json

/**
 * Local address of the network connection - IP address or Unix domain socket name. `network.local.address`
 *
 * Attribute Value Type: `string` {@link NETWORK_LOCAL_ADDRESS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_HOST_IP} `net.host.ip`, {@link NET_SOCK_HOST_ADDR} `net.sock.host.addr`
 *
 * @example "10.1.2.80"
 * @example "/var/run/my.sock"
 */
export const NETWORK_LOCAL_ADDRESS = 'network.local.address';

/**
 * Type for {@link NETWORK_LOCAL_ADDRESS} network.local.address
 */
export type NETWORK_LOCAL_ADDRESS_TYPE = string;

// Path: model/attributes/network/network__local__port.json

/**
 * Local port number of the network connection. `network.local.port`
 *
 * Attribute Value Type: `number` {@link NETWORK_LOCAL_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_SOCK_HOST_PORT} `net.sock.host.port`
 *
 * @example 65400
 */
export const NETWORK_LOCAL_PORT = 'network.local.port';

/**
 * Type for {@link NETWORK_LOCAL_PORT} network.local.port
 */
export type NETWORK_LOCAL_PORT_TYPE = number;

// Path: model/attributes/network/network__peer__address.json

/**
 * Peer address of the network connection - IP address or Unix domain socket name. `network.peer.address`
 *
 * Attribute Value Type: `string` {@link NETWORK_PEER_ADDRESS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_PEER_IP} `net.peer.ip`, {@link NET_SOCK_PEER_ADDR} `net.sock.peer.addr`
 *
 * @example "10.1.2.80"
 */
export const NETWORK_PEER_ADDRESS = 'network.peer.address';

/**
 * Type for {@link NETWORK_PEER_ADDRESS} network.peer.address
 */
export type NETWORK_PEER_ADDRESS_TYPE = string;

// Path: model/attributes/network/network__peer__port.json

/**
 * Peer port number of the network connection. `network.peer.port`
 *
 * Attribute Value Type: `number` {@link NETWORK_PEER_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_SOCK_PEER_PORT} `net.sock.peer.port`
 *
 * @example 65400
 */
export const NETWORK_PEER_PORT = 'network.peer.port';

/**
 * Type for {@link NETWORK_PEER_PORT} network.peer.port
 */
export type NETWORK_PEER_PORT_TYPE = number;

// Path: model/attributes/network/network__protocol__name.json

/**
 * OSI application layer or non-OSI equivalent. `network.protocol.name`
 *
 * Attribute Value Type: `string` {@link NETWORK_PROTOCOL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_PROTOCOL_NAME} `net.protocol.name`, {@link MESSAGING_PROTOCOL} `messaging.protocol`
 *
 * @example "http"
 */
export const NETWORK_PROTOCOL_NAME = 'network.protocol.name';

/**
 * Type for {@link NETWORK_PROTOCOL_NAME} network.protocol.name
 */
export type NETWORK_PROTOCOL_NAME_TYPE = string;

// Path: model/attributes/network/network__protocol__version.json

/**
 * The actual version of the protocol used for network communication. `network.protocol.version`
 *
 * Attribute Value Type: `string` {@link NETWORK_PROTOCOL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_FLAVOR} `http.flavor`, {@link NET_PROTOCOL_VERSION} `net.protocol.version`, {@link MESSAGING_PROTOCOL_VERSION} `messaging.protocol_version`
 *
 * @example "1.1"
 */
export const NETWORK_PROTOCOL_VERSION = 'network.protocol.version';

/**
 * Type for {@link NETWORK_PROTOCOL_VERSION} network.protocol.version
 */
export type NETWORK_PROTOCOL_VERSION_TYPE = string;

// Path: model/attributes/network/network__transport.json

/**
 * OSI transport layer or inter-process communication method. `network.transport`
 *
 * Attribute Value Type: `string` {@link NETWORK_TRANSPORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_TRANSPORT} `net.transport`
 *
 * @example "tcp"
 */
export const NETWORK_TRANSPORT = 'network.transport';

/**
 * Type for {@link NETWORK_TRANSPORT} network.transport
 */
export type NETWORK_TRANSPORT_TYPE = string;

// Path: model/attributes/network/network__type.json

/**
 * OSI network layer or non-OSI equivalent. `network.type`
 *
 * Attribute Value Type: `string` {@link NETWORK_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "ipv4"
 */
export const NETWORK_TYPE = 'network.type';

/**
 * Type for {@link NETWORK_TYPE} network.type
 */
export type NETWORK_TYPE_TYPE = string;

// Path: model/attributes/net/net__host__ip.json

/**
 * Local address of the network connection - IP address or Unix domain socket name. `net.host.ip`
 *
 * Attribute Value Type: `string` {@link NET_HOST_IP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_LOCAL_ADDRESS} `network.local.address`, {@link NET_SOCK_HOST_ADDR} `net.sock.host.addr`
 *
 * @deprecated Use {@link NETWORK_LOCAL_ADDRESS} (network.local.address) instead
 * @example "192.168.0.1"
 */
export const NET_HOST_IP = 'net.host.ip';

/**
 * Type for {@link NET_HOST_IP} net.host.ip
 */
export type NET_HOST_IP_TYPE = string;

// Path: model/attributes/net/net__host__name.json

/**
 * Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name. `net.host.name`
 *
 * Attribute Value Type: `string` {@link NET_HOST_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link SERVER_ADDRESS} `server.address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link HTTP_HOST} `http.host`, {@link SERVER_NAME} `server_name`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead
 * @example "example.com"
 */
export const NET_HOST_NAME = 'net.host.name';

/**
 * Type for {@link NET_HOST_NAME} net.host.name
 */
export type NET_HOST_NAME_TYPE = string;

// Path: model/attributes/net/net__host__port.json

/**
 * Server port number. `net.host.port`
 *
 * Attribute Value Type: `number` {@link NET_HOST_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SERVER_PORT} `server.port`, {@link PORT} `port`
 *
 * @deprecated Use {@link SERVER_PORT} (server.port) instead
 * @example 1337
 */
export const NET_HOST_PORT = 'net.host.port';

/**
 * Type for {@link NET_HOST_PORT} net.host.port
 */
export type NET_HOST_PORT_TYPE = number;

// Path: model/attributes/net/net__peer__ip.json

/**
 * Peer address of the network connection - IP address or Unix domain socket name. `net.peer.ip`
 *
 * Attribute Value Type: `string` {@link NET_PEER_IP_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PEER_ADDRESS} `network.peer.address`, {@link NET_SOCK_PEER_ADDR} `net.sock.peer.addr`
 *
 * @deprecated Use {@link NETWORK_PEER_ADDRESS} (network.peer.address) instead
 * @example "192.168.0.1"
 */
export const NET_PEER_IP = 'net.peer.ip';

/**
 * Type for {@link NET_PEER_IP} net.peer.ip
 */
export type NET_PEER_IP_TYPE = string;

// Path: model/attributes/net/net__peer__name.json

/**
 * Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name. `net.peer.name`
 *
 * Attribute Value Type: `string` {@link NET_PEER_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link SERVER_ADDRESS} `server.address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link NET_HOST_NAME} `net.host.name`, {@link HTTP_HOST} `http.host`, {@link SERVER_NAME} `server_name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead - Deprecated, use server.address on client spans and client.address on server spans.
 * @example "example.com"
 */
export const NET_PEER_NAME = 'net.peer.name';

/**
 * Type for {@link NET_PEER_NAME} net.peer.name
 */
export type NET_PEER_NAME_TYPE = string;

// Path: model/attributes/net/net__peer__port.json

/**
 * Peer port number. `net.peer.port`
 *
 * Attribute Value Type: `number` {@link NET_PEER_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated Use {@link SERVER_PORT} (server.port) instead - Deprecated, use server.port on client spans and client.port on server spans.
 * @example 1337
 */
export const NET_PEER_PORT = 'net.peer.port';

/**
 * Type for {@link NET_PEER_PORT} net.peer.port
 */
export type NET_PEER_PORT_TYPE = number;

// Path: model/attributes/net/net__protocol__name.json

/**
 * OSI application layer or non-OSI equivalent. `net.protocol.name`
 *
 * Attribute Value Type: `string` {@link NET_PROTOCOL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PROTOCOL_NAME} `network.protocol.name`, {@link MESSAGING_PROTOCOL} `messaging.protocol`
 *
 * @deprecated Use {@link NETWORK_PROTOCOL_NAME} (network.protocol.name) instead
 * @example "http"
 */
export const NET_PROTOCOL_NAME = 'net.protocol.name';

/**
 * Type for {@link NET_PROTOCOL_NAME} net.protocol.name
 */
export type NET_PROTOCOL_NAME_TYPE = string;

// Path: model/attributes/net/net__protocol__version.json

/**
 * The actual version of the protocol used for network communication. `net.protocol.version`
 *
 * Attribute Value Type: `string` {@link NET_PROTOCOL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PROTOCOL_VERSION} `network.protocol.version`, {@link HTTP_FLAVOR} `http.flavor`, {@link MESSAGING_PROTOCOL_VERSION} `messaging.protocol_version`
 *
 * @deprecated Use {@link NETWORK_PROTOCOL_VERSION} (network.protocol.version) instead
 * @example "1.1"
 */
export const NET_PROTOCOL_VERSION = 'net.protocol.version';

/**
 * Type for {@link NET_PROTOCOL_VERSION} net.protocol.version
 */
export type NET_PROTOCOL_VERSION_TYPE = string;

// Path: model/attributes/net/net__sock__family.json

/**
 * OSI transport and network layer `net.sock.family`
 *
 * Attribute Value Type: `string` {@link NET_SOCK_FAMILY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated Use {@link NETWORK_TRANSPORT} (network.transport) instead - Deprecated, use network.transport and network.type.
 * @example "inet"
 */
export const NET_SOCK_FAMILY = 'net.sock.family';

/**
 * Type for {@link NET_SOCK_FAMILY} net.sock.family
 */
export type NET_SOCK_FAMILY_TYPE = string;

// Path: model/attributes/net/net__sock__host__addr.json

/**
 * Local address of the network connection mapping to Unix domain socket name. `net.sock.host.addr`
 *
 * Attribute Value Type: `string` {@link NET_SOCK_HOST_ADDR_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_LOCAL_ADDRESS} `network.local.address`, {@link NET_HOST_IP} `net.host.ip`
 *
 * @deprecated Use {@link NETWORK_LOCAL_ADDRESS} (network.local.address) instead
 * @example "/var/my.sock"
 */
export const NET_SOCK_HOST_ADDR = 'net.sock.host.addr';

/**
 * Type for {@link NET_SOCK_HOST_ADDR} net.sock.host.addr
 */
export type NET_SOCK_HOST_ADDR_TYPE = string;

// Path: model/attributes/net/net__sock__host__port.json

/**
 * Local port number of the network connection. `net.sock.host.port`
 *
 * Attribute Value Type: `number` {@link NET_SOCK_HOST_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_LOCAL_PORT} `network.local.port`
 *
 * @deprecated Use {@link NETWORK_LOCAL_PORT} (network.local.port) instead
 * @example 8080
 */
export const NET_SOCK_HOST_PORT = 'net.sock.host.port';

/**
 * Type for {@link NET_SOCK_HOST_PORT} net.sock.host.port
 */
export type NET_SOCK_HOST_PORT_TYPE = number;

// Path: model/attributes/net/net__sock__peer__addr.json

/**
 * Peer address of the network connection - IP address `net.sock.peer.addr`
 *
 * Attribute Value Type: `string` {@link NET_SOCK_PEER_ADDR_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PEER_ADDRESS} `network.peer.address`, {@link NET_PEER_IP} `net.peer.ip`
 *
 * @deprecated Use {@link NETWORK_PEER_ADDRESS} (network.peer.address) instead
 * @example "192.168.0.1"
 */
export const NET_SOCK_PEER_ADDR = 'net.sock.peer.addr';

/**
 * Type for {@link NET_SOCK_PEER_ADDR} net.sock.peer.addr
 */
export type NET_SOCK_PEER_ADDR_TYPE = string;

// Path: model/attributes/net/net__sock__peer__name.json

/**
 * Peer address of the network connection - Unix domain socket name `net.sock.peer.name`
 *
 * Attribute Value Type: `string` {@link NET_SOCK_PEER_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated  - Deprecated from OTEL, no replacement at this time
 * @example "/var/my.sock"
 */
export const NET_SOCK_PEER_NAME = 'net.sock.peer.name';

/**
 * Type for {@link NET_SOCK_PEER_NAME} net.sock.peer.name
 */
export type NET_SOCK_PEER_NAME_TYPE = string;

// Path: model/attributes/net/net__sock__peer__port.json

/**
 * Peer port number of the network connection. `net.sock.peer.port`
 *
 * Attribute Value Type: `number` {@link NET_SOCK_PEER_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_PEER_PORT} `network.peer.port`
 *
 * @deprecated Use {@link NETWORK_PEER_PORT} (network.peer.port) instead
 * @example 8080
 */
export const NET_SOCK_PEER_PORT = 'net.sock.peer.port';

/**
 * Type for {@link NET_SOCK_PEER_PORT} net.sock.peer.port
 */
export type NET_SOCK_PEER_PORT_TYPE = number;

// Path: model/attributes/net/net__transport.json

/**
 * OSI transport layer or inter-process communication method. `net.transport`
 *
 * Attribute Value Type: `string` {@link NET_TRANSPORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NETWORK_TRANSPORT} `network.transport`
 *
 * @deprecated Use {@link NETWORK_TRANSPORT} (network.transport) instead - This attribute is being deprecated in favor of network.transport. The values change from ip_tcp and ip_udp to tcp and udp, so the old value cannot be copied over.
 * @example "tcp"
 */
export const NET_TRANSPORT = 'net.transport';

/**
 * Type for {@link NET_TRANSPORT} net.transport
 */
export type NET_TRANSPORT_TYPE = string;

// Path: model/attributes/os/os__build.json

/**
 * The build ID of the operating system. `os.build`
 *
 * Attribute Value Type: `string` {@link OS_BUILD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link OS_BUILD_ID} `os.build_id`
 *
 * @deprecated Use {@link OS_BUILD_ID} (os.build_id) instead
 * @example "1234567890"
 */
export const OS_BUILD = 'os.build';

/**
 * Type for {@link OS_BUILD} os.build
 */
export type OS_BUILD_TYPE = string;

// Path: model/attributes/os/os__build_id.json

/**
 * The build ID of the operating system. `os.build_id`
 *
 * Attribute Value Type: `string` {@link OS_BUILD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link OS_BUILD} `os.build`
 *
 * @example "1234567890"
 */
export const OS_BUILD_ID = 'os.build_id';

/**
 * Type for {@link OS_BUILD_ID} os.build_id
 */
export type OS_BUILD_ID_TYPE = string;

// Path: model/attributes/os/os__description.json

/**
 * Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands. `os.description`
 *
 * Attribute Value Type: `string` {@link OS_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Ubuntu 18.04.1 LTS"
 */
export const OS_DESCRIPTION = 'os.description';

/**
 * Type for {@link OS_DESCRIPTION} os.description
 */
export type OS_DESCRIPTION_TYPE = string;

// Path: model/attributes/os/os__kernel_version.json

/**
 * An independent kernel version string. Typically the entire output of the `uname` syscall. `os.kernel_version`
 *
 * Attribute Value Type: `string` {@link OS_KERNEL_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "20.2.0"
 */
export const OS_KERNEL_VERSION = 'os.kernel_version';

/**
 * Type for {@link OS_KERNEL_VERSION} os.kernel_version
 */
export type OS_KERNEL_VERSION_TYPE = string;

// Path: model/attributes/os/os__name.json

/**
 * Human readable operating system name. `os.name`
 *
 * Attribute Value Type: `string` {@link OS_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "Ubuntu"
 */
export const OS_NAME = 'os.name';

/**
 * Type for {@link OS_NAME} os.name
 */
export type OS_NAME_TYPE = string;

// Path: model/attributes/os/os__raw_description.json

/**
 * An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given. `os.raw_description`
 *
 * Attribute Value Type: `string` {@link OS_RAW_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Ubuntu 22.04.4 LTS (Jammy Jellyfish)"
 */
export const OS_RAW_DESCRIPTION = 'os.raw_description';

/**
 * Type for {@link OS_RAW_DESCRIPTION} os.raw_description
 */
export type OS_RAW_DESCRIPTION_TYPE = string;

// Path: model/attributes/os/os__rooted.json

/**
 * Whether the operating system has been jailbroken or rooted. `os.rooted`
 *
 * Attribute Value Type: `boolean` {@link OS_ROOTED_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const OS_ROOTED = 'os.rooted';

/**
 * Type for {@link OS_ROOTED} os.rooted
 */
export type OS_ROOTED_TYPE = boolean;

// Path: model/attributes/os/os__theme.json

/**
 * Whether the OS runs in dark mode or light mode. `os.theme`
 *
 * Attribute Value Type: `string` {@link OS_THEME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "dark"
 */
export const OS_THEME = 'os.theme';

/**
 * Type for {@link OS_THEME} os.theme
 */
export type OS_THEME_TYPE = string;

// Path: model/attributes/os/os__type.json

/**
 * The operating system type. `os.type`
 *
 * Attribute Value Type: `string` {@link OS_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "linux"
 */
export const OS_TYPE = 'os.type';

/**
 * Type for {@link OS_TYPE} os.type
 */
export type OS_TYPE_TYPE = string;

// Path: model/attributes/os/os__version.json

/**
 * The version of the operating system. `os.version`
 *
 * Attribute Value Type: `string` {@link OS_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "18.04.2"
 */
export const OS_VERSION = 'os.version';

/**
 * Type for {@link OS_VERSION} os.version
 */
export type OS_VERSION_TYPE = string;

// Path: model/attributes/otel/otel__kind.json

/**
 * The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead. `otel.kind`
 *
 * Attribute Value Type: `string` {@link OTEL_KIND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_KIND} `sentry.kind`
 *
 * @deprecated Use {@link SENTRY_KIND} (sentry.kind) instead - Deprecated in favor of sentry.kind
 * @example "SERVER"
 */
export const OTEL_KIND = 'otel.kind';

/**
 * Type for {@link OTEL_KIND} otel.kind
 */
export type OTEL_KIND_TYPE = string;

// Path: model/attributes/otel/otel__scope__name.json

/**
 * The name of the instrumentation scope - (InstrumentationScope.Name in OTLP). `otel.scope.name`
 *
 * Attribute Value Type: `string` {@link OTEL_SCOPE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "io.opentelemetry.contrib.mongodb"
 */
export const OTEL_SCOPE_NAME = 'otel.scope.name';

/**
 * Type for {@link OTEL_SCOPE_NAME} otel.scope.name
 */
export type OTEL_SCOPE_NAME_TYPE = string;

// Path: model/attributes/otel/otel__scope__version.json

/**
 * The version of the instrumentation scope - (InstrumentationScope.Version in OTLP). `otel.scope.version`
 *
 * Attribute Value Type: `string` {@link OTEL_SCOPE_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "2.4.5"
 */
export const OTEL_SCOPE_VERSION = 'otel.scope.version';

/**
 * Type for {@link OTEL_SCOPE_VERSION} otel.scope.version
 */
export type OTEL_SCOPE_VERSION_TYPE = string;

// Path: model/attributes/otel/otel__status_code.json

/**
 * Name of the code, either “OK” or “ERROR”. MUST NOT be set if the status code is UNSET. `otel.status_code`
 *
 * Attribute Value Type: `string` {@link OTEL_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "OK"
 */
export const OTEL_STATUS_CODE = 'otel.status_code';

/**
 * Type for {@link OTEL_STATUS_CODE} otel.status_code
 */
export type OTEL_STATUS_CODE_TYPE = string;

// Path: model/attributes/otel/otel__status_description.json

/**
 * Description of the Status if it has a value, otherwise not set. `otel.status_description`
 *
 * Attribute Value Type: `string` {@link OTEL_STATUS_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "resource not found"
 */
export const OTEL_STATUS_DESCRIPTION = 'otel.status_description';

/**
 * Type for {@link OTEL_STATUS_DESCRIPTION} otel.status_description
 */
export type OTEL_STATUS_DESCRIPTION_TYPE = string;

// Path: model/attributes/params/params__[key].json

/**
 * Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router. `params.<key>`
 *
 * Attribute Value Type: `string` {@link PARAMS_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * Aliases: {@link URL_PATH_PARAMETER_KEY} `url.path.parameter.<key>`, {@link URL_PATH_PARAMS_KEY} `url.path.params.<key>`
 *
 * @example "params.id='123'"
 */
export const PARAMS_KEY = 'params.<key>';

/**
 * Base key for {@link PARAMS_KEY}. Use with a dynamic suffix, e.g. `${PARAMS_KEY_BASE}.${key}`.
 */
export const PARAMS_KEY_BASE = 'params';

/**
 * Type for {@link PARAMS_KEY} params.<key>
 */
export type PARAMS_KEY_TYPE = string;

// Path: model/attributes/performance/performance__activationStart.json

/**
 * The time between initiating a navigation to a page and the browser activating the page `performance.activationStart`
 *
 * Attribute Value Type: `number` {@link PERFORMANCE_ACTIVATIONSTART_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START} `browser.performance.navigation.activation_start`
 *
 * @deprecated Use {@link BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START} (browser.performance.navigation.activation_start) instead - The activationStart is now recorded as the browser.performance.navigation.activation_start attribute.
 * @example 1.983
 */
export const PERFORMANCE_ACTIVATIONSTART = 'performance.activationStart';

/**
 * Type for {@link PERFORMANCE_ACTIVATIONSTART} performance.activationStart
 */
export type PERFORMANCE_ACTIVATIONSTART_TYPE = number;

// Path: model/attributes/performance/performance__timeOrigin.json

/**
 * The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated `performance.timeOrigin`
 *
 * Attribute Value Type: `number` {@link PERFORMANCE_TIMEORIGIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_PERFORMANCE_TIME_ORIGIN} `browser.performance.time_origin`
 *
 * @deprecated Use {@link BROWSER_PERFORMANCE_TIME_ORIGIN} (browser.performance.time_origin) instead - The timeOrigin is now recorded as the browser.performance.time_origin attribute.
 * @example 1776185678.886
 */
export const PERFORMANCE_TIMEORIGIN = 'performance.timeOrigin';

/**
 * Type for {@link PERFORMANCE_TIMEORIGIN} performance.timeOrigin
 */
export type PERFORMANCE_TIMEORIGIN_TYPE = number;

// Path: model/attributes/port.json

/**
 * The destination port for a TCP connection. `port`
 *
 * Attribute Value Type: `number` {@link PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SERVER_PORT} `server.port`, {@link NET_HOST_PORT} `net.host.port`
 *
 * @deprecated Use {@link SERVER_PORT} (server.port) instead - Old namespace-less attribute, to be replaced with server.port for span-first future
 * @example 1337
 */
export const PORT = 'port';

/**
 * Type for {@link PORT} port
 */
export type PORT_TYPE = number;

// Path: model/attributes/previous_route.json

/**
 * Also used by mobile SDKs to indicate the previous route in the application. `previous_route`
 *
 * Attribute Value Type: `string` {@link PREVIOUS_ROUTE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "HomeScreen"
 */
export const PREVIOUS_ROUTE = 'previous_route';

/**
 * Type for {@link PREVIOUS_ROUTE} previous_route
 */
export type PREVIOUS_ROUTE_TYPE = string;

// Path: model/attributes/process/process__command_args.json

/**
 * All the command arguments (including the command/executable itself) as received by the process. `process.command_args`
 *
 * Attribute Value Type: `Array<string>` {@link PROCESS_COMMAND_ARGS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["cmd/otecol","--config=config.yaml"]
 */
export const PROCESS_COMMAND_ARGS = 'process.command_args';

/**
 * Type for {@link PROCESS_COMMAND_ARGS} process.command_args
 */
export type PROCESS_COMMAND_ARGS_TYPE = Array<string>;

// Path: model/attributes/process/process__executable__name.json

/**
 * The name of the executable that started the process. `process.executable.name`
 *
 * Attribute Value Type: `string` {@link PROCESS_EXECUTABLE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "getsentry"
 */
export const PROCESS_EXECUTABLE_NAME = 'process.executable.name';

/**
 * Type for {@link PROCESS_EXECUTABLE_NAME} process.executable.name
 */
export type PROCESS_EXECUTABLE_NAME_TYPE = string;

// Path: model/attributes/process/process__pid.json

/**
 * The process ID of the running process. `process.pid`
 *
 * Attribute Value Type: `number` {@link PROCESS_PID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SUBPROCESS_PID} `subprocess.pid`
 *
 * @example 12345
 */
export const PROCESS_PID = 'process.pid';

/**
 * Type for {@link PROCESS_PID} process.pid
 */
export type PROCESS_PID_TYPE = number;

// Path: model/attributes/process/process__runtime__description.json

/**
 * An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context. `process.runtime.description`
 *
 * Attribute Value Type: `string` {@link PROCESS_RUNTIME_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link RUNTIME_RAW_DESCRIPTION} `runtime.raw_description`
 *
 * @example "Eclipse OpenJ9 VM openj9-0.21.0"
 */
export const PROCESS_RUNTIME_DESCRIPTION = 'process.runtime.description';

/**
 * Type for {@link PROCESS_RUNTIME_DESCRIPTION} process.runtime.description
 */
export type PROCESS_RUNTIME_DESCRIPTION_TYPE = string;

// Path: model/attributes/process/process__runtime__engine__name.json

/**
 * The name of the runtime engine. `process.runtime.engine.name`
 *
 * Attribute Value Type: `string` {@link PROCESS_RUNTIME_ENGINE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "v8"
 */
export const PROCESS_RUNTIME_ENGINE_NAME = 'process.runtime.engine.name';

/**
 * Type for {@link PROCESS_RUNTIME_ENGINE_NAME} process.runtime.engine.name
 */
export type PROCESS_RUNTIME_ENGINE_NAME_TYPE = string;

// Path: model/attributes/process/process__runtime__engine__version.json

/**
 * The version of the runtime engine. `process.runtime.engine.version`
 *
 * Attribute Value Type: `string` {@link PROCESS_RUNTIME_ENGINE_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "12.9.202.13-rusty"
 */
export const PROCESS_RUNTIME_ENGINE_VERSION = 'process.runtime.engine.version';

/**
 * Type for {@link PROCESS_RUNTIME_ENGINE_VERSION} process.runtime.engine.version
 */
export type PROCESS_RUNTIME_ENGINE_VERSION_TYPE = string;

// Path: model/attributes/process/process__runtime__name.json

/**
 * The name of the runtime. Equivalent to `name` in the Sentry runtime context. `process.runtime.name`
 *
 * Attribute Value Type: `string` {@link PROCESS_RUNTIME_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link RUNTIME_NAME} `runtime.name`
 *
 * @example "node"
 */
export const PROCESS_RUNTIME_NAME = 'process.runtime.name';

/**
 * Type for {@link PROCESS_RUNTIME_NAME} process.runtime.name
 */
export type PROCESS_RUNTIME_NAME_TYPE = string;

// Path: model/attributes/process/process__runtime__version.json

/**
 * The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context. `process.runtime.version`
 *
 * Attribute Value Type: `string` {@link PROCESS_RUNTIME_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link RUNTIME_VERSION} `runtime.version`
 *
 * @example "18.04.2"
 */
export const PROCESS_RUNTIME_VERSION = 'process.runtime.version';

/**
 * Type for {@link PROCESS_RUNTIME_VERSION} process.runtime.version
 */
export type PROCESS_RUNTIME_VERSION_TYPE = string;

// Path: model/attributes/profile_id.json

/**
 * The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling. `profile_id`
 *
 * Attribute Value Type: `string` {@link PROFILE_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_PROFILE_ID} `sentry.profile_id`
 *
 * @deprecated Use {@link SENTRY_PROFILE_ID} (sentry.profile_id) instead
 * @example "123e4567e89b12d3a456426614174000"
 */
export const PROFILE_ID = 'profile_id';

/**
 * Type for {@link PROFILE_ID} profile_id
 */
export type PROFILE_ID_TYPE = string;

// Path: model/attributes/query.json

/**
 * The database query being executed. `query`
 *
 * Attribute Value Type: `string` {@link QUERY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DB_QUERY_TEXT} `db.query.text`, {@link DB_STATEMENT} `db.statement`
 *
 * @deprecated Use {@link DB_QUERY_TEXT} (db.query.text) instead - While this attribute never specifically required parameterization, the replacement, db.query.text, does.
 * @example "SELECT * FROM users WHERE id = $1"
 */
export const QUERY = 'query';

/**
 * Type for {@link QUERY} query
 */
export type QUERY_TYPE = string;

// Path: model/attributes/query/query__[key].json

/**
 * An item in a query string. Usually added by client-side routing frameworks like vue-router. `query.<key>`
 *
 * Attribute Value Type: `string` {@link QUERY_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @deprecated Use {@link URL_QUERY} (url.query) instead - Instead of sending items individually in query.<key>, they should be sent all together with url.query.
 * @example "query.id='123'"
 */
export const QUERY_KEY = 'query.<key>';

/**
 * Base key for {@link QUERY_KEY}. Use with a dynamic suffix, e.g. `${QUERY_KEY_BASE}.${key}`.
 *
 * @deprecated Use {@link URL_QUERY} (url.query) instead - Instead of sending items individually in query.<key>, they should be sent all together with url.query.
 */
export const QUERY_KEY_BASE = 'query';

/**
 * Type for {@link QUERY_KEY} query.<key>
 */
export type QUERY_KEY_TYPE = string;

// Path: model/attributes/react_native/react_native__architecture.json

/**
 * The React Native architecture the app is running on. `new` for the New Architecture, where native modules are resolved as TurboModules through `TurboModuleRegistry`, `legacy` for the Old Architecture bridge. `react_native.architecture`
 *
 * Attribute Value Type: `string` {@link REACT_NATIVE_ARCHITECTURE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_ARCH} `turbo_module.arch`
 *
 * @example "new"
 * @example "legacy"
 */
export const REACT_NATIVE_ARCHITECTURE = 'react_native.architecture';

/**
 * Type for {@link REACT_NATIVE_ARCHITECTURE} react_native.architecture
 */
export type REACT_NATIVE_ARCHITECTURE_TYPE = string;

// Path: model/attributes/react_native/react_native__module__call__count.json

/**
 * The number of native module calls observed during the lifetime of the span. `react_native.module.call.count`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_CALL_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_TOTAL_CALL_COUNT} `turbo_module.total_call_count`, {@link TURBO_MODULES_TOTAL_CALL_COUNT} `turbo_modules.total_call_count`
 *
 * @example 42
 */
export const REACT_NATIVE_MODULE_CALL_COUNT = 'react_native.module.call.count';

/**
 * Type for {@link REACT_NATIVE_MODULE_CALL_COUNT} react_native.module.call.count
 */
export type REACT_NATIVE_MODULE_CALL_COUNT_TYPE = number;

// Path: model/attributes/react_native/react_native__module__call__distinct_count.json

/**
 * The number of distinct native module and method pairs called during the lifetime of the span. Useful as a cardinality signal when the per-method breakdown has been truncated. `react_native.module.call.distinct_count`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_UNIQUE_METHODS} `turbo_module.unique_methods`, {@link TURBO_MODULES_UNIQUE_METHODS} `turbo_modules.unique_methods`
 *
 * @example 7
 */
export const REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT = 'react_native.module.call.distinct_count';

/**
 * Type for {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT} react_native.module.call.distinct_count
 */
export type REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT_TYPE = number;

// Path: model/attributes/react_native/react_native__module__duration__max.json

/**
 * The duration of the slowest single native module call observed during the lifetime of the span, in milliseconds. `react_native.module.duration.max`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_DURATION_MAX_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 512.5
 */
export const REACT_NATIVE_MODULE_DURATION_MAX = 'react_native.module.duration.max';

/**
 * Type for {@link REACT_NATIVE_MODULE_DURATION_MAX} react_native.module.duration.max
 */
export type REACT_NATIVE_MODULE_DURATION_MAX_TYPE = number;

// Path: model/attributes/react_native/react_native__module__duration__total.json

/**
 * The combined wall-clock duration of all native module calls observed during the lifetime of the span, in milliseconds. Calls overlap, so this can exceed the span duration. `react_native.module.duration.total`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_DURATION_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_TOTAL_DURATION_MS} `turbo_module.total_duration_ms`, {@link TURBO_MODULES_TOTAL_DURATION_MS} `turbo_modules.total_duration_ms`
 *
 * @example 128.45
 */
export const REACT_NATIVE_MODULE_DURATION_TOTAL = 'react_native.module.duration.total';

/**
 * Type for {@link REACT_NATIVE_MODULE_DURATION_TOTAL} react_native.module.duration.total
 */
export type REACT_NATIVE_MODULE_DURATION_TOTAL_TYPE = number;

// Path: model/attributes/react_native/react_native__module__error__count.json

/**
 * The number of native module calls that failed during the lifetime of the span. A call counts as failed when it threw, rejected, or — on the Old Architecture bridge only — invoked its failure callback. `react_native.module.error.count`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_ERROR_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_TOTAL_ERROR_COUNT} `turbo_module.total_error_count`, {@link TURBO_MODULES_TOTAL_ERROR_COUNT} `turbo_modules.total_error_count`
 *
 * @example 2
 */
export const REACT_NATIVE_MODULE_ERROR_COUNT = 'react_native.module.error.count';

/**
 * Type for {@link REACT_NATIVE_MODULE_ERROR_COUNT} react_native.module.error.count
 */
export type REACT_NATIVE_MODULE_ERROR_COUNT_TYPE = number;

// Path: model/attributes/react_native/react_native__module__kind.json

/**
 * Whether the native module call completed synchronously or reported completion later through a Promise or a callback. One of `sync` or `async`. `react_native.module.kind`
 *
 * Attribute Value Type: `string` {@link REACT_NATIVE_MODULE_KIND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sync"
 * @example "async"
 */
export const REACT_NATIVE_MODULE_KIND = 'react_native.module.kind';

/**
 * Type for {@link REACT_NATIVE_MODULE_KIND} react_native.module.kind
 */
export type REACT_NATIVE_MODULE_KIND_TYPE = string;

// Path: model/attributes/react_native/react_native__module__method.json

/**
 * The name of the native module method that was called. `react_native.module.method`
 *
 * Attribute Value Type: `string` {@link REACT_NATIVE_MODULE_METHOD_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_METHOD} `turbo_module.method`
 *
 * @example "getUniqueId"
 */
export const REACT_NATIVE_MODULE_METHOD = 'react_native.module.method';

/**
 * Type for {@link REACT_NATIVE_MODULE_METHOD} react_native.module.method
 */
export type REACT_NATIVE_MODULE_METHOD_TYPE = string;

// Path: model/attributes/react_native/react_native__module__name.json

/**
 * The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key. `react_native.module.name`
 *
 * Attribute Value Type: `string` {@link REACT_NATIVE_MODULE_NAME_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_NAME} `turbo_module.name`
 *
 * @example "RNDeviceInfo"
 */
export const REACT_NATIVE_MODULE_NAME = 'react_native.module.name';

/**
 * Type for {@link REACT_NATIVE_MODULE_NAME} react_native.module.name
 */
export type REACT_NATIVE_MODULE_NAME_TYPE = string;

// Path: model/attributes/react_native/react_native__module__top__duration.json

/**
 * The total duration attributed to `react_native.module.top.name`, in milliseconds. `react_native.module.top.duration`
 *
 * Attribute Value Type: `number` {@link REACT_NATIVE_MODULE_TOP_DURATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_TOP_MODULE_DURATION_MS} `turbo_module.top_module_duration_ms`
 *
 * @example 87.25
 */
export const REACT_NATIVE_MODULE_TOP_DURATION = 'react_native.module.top.duration';

/**
 * Type for {@link REACT_NATIVE_MODULE_TOP_DURATION} react_native.module.top.duration
 */
export type REACT_NATIVE_MODULE_TOP_DURATION_TYPE = number;

// Path: model/attributes/react_native/react_native__module__top__name.json

/**
 * The native module and method that accounted for the most total duration during the lifetime of the span, formatted as `<module>.<method>`. `react_native.module.top.name`
 *
 * Attribute Value Type: `string` {@link REACT_NATIVE_MODULE_TOP_NAME_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link TURBO_MODULE_TOP_MODULE} `turbo_module.top_module`
 *
 * @example "RNDeviceInfo.getUniqueId"
 */
export const REACT_NATIVE_MODULE_TOP_NAME = 'react_native.module.top.name';

/**
 * Type for {@link REACT_NATIVE_MODULE_TOP_NAME} react_native.module.top.name
 */
export type REACT_NATIVE_MODULE_TOP_NAME_TYPE = string;

// Path: model/attributes/react/react__version.json

/**
 * The version of the React framework `react.version`
 *
 * Attribute Value Type: `string` {@link REACT_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "18.2.0"
 */
export const REACT_VERSION = 'react.version';

/**
 * Type for {@link REACT_VERSION} react.version
 */
export type REACT_VERSION_TYPE = string;

// Path: model/attributes/redis/redis__command.json

/**
 * The name of the Redis operation being executed. `redis.command`
 *
 * Attribute Value Type: `string` {@link REDIS_COMMAND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CLOUDFLARE_D1_QUERY_TYPE} `cloudflare.d1.query_type`, {@link DB_OPERATION_NAME} `db.operation.name`, {@link DB_OPERATION} `db.operation`
 *
 * @deprecated Use {@link DB_OPERATION_NAME} (db.operation.name) instead
 * @example "SELECT"
 */
export const REDIS_COMMAND = 'redis.command';

/**
 * Type for {@link REDIS_COMMAND} redis.command
 */
export type REDIS_COMMAND_TYPE = string;

// Path: model/attributes/redis/redis__key.json

/**
 * The key the Redis command is operating on. `redis.key`
 *
 * Attribute Value Type: `string` {@link REDIS_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DB_REDIS_KEY} `db.redis.key`
 *
 * @deprecated Use {@link DB_REDIS_KEY} (db.redis.key) instead - This attribute is being deprecated in favor of db.redis.key, which is the preferred replacement.
 * @example "user:2047:city"
 */
export const REDIS_KEY = 'redis.key';

/**
 * Type for {@link REDIS_KEY} redis.key
 */
export type REDIS_KEY_TYPE = string;

// Path: model/attributes/release.json

/**
 * The sentry release. `release`
 *
 * Attribute Value Type: `string` {@link RELEASE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_RELEASE} `sentry.release`
 *
 * @deprecated Use {@link SENTRY_RELEASE} (sentry.release) instead
 * @example "production"
 */
export const RELEASE = 'release';

/**
 * Type for {@link RELEASE} release
 */
export type RELEASE_TYPE = string;

// Path: model/attributes/remix/remix__action_form_data__[key].json

/**
 * Remix form data, <key> being the form data key, the value being the form data value. `remix.action_form_data.<key>`
 *
 * Attribute Value Type: `string` {@link REMIX_ACTION_FORM_DATA_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "http.response.header.text='test'"
 */
export const REMIX_ACTION_FORM_DATA_KEY = 'remix.action_form_data.<key>';

/**
 * Base key for {@link REMIX_ACTION_FORM_DATA_KEY}. Use with a dynamic suffix, e.g. `${REMIX_ACTION_FORM_DATA_KEY_BASE}.${key}`.
 */
export const REMIX_ACTION_FORM_DATA_KEY_BASE = 'remix.action_form_data';

/**
 * Type for {@link REMIX_ACTION_FORM_DATA_KEY} remix.action_form_data.<key>
 */
export type REMIX_ACTION_FORM_DATA_KEY_TYPE = string;

// Path: model/attributes/replayId.json

/**
 * The id of the sentry replay. `replayId`
 *
 * Attribute Value Type: `string` {@link REPLAYID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_REPLAY_ID} `sentry.replay_id`
 *
 * @deprecated Use {@link SENTRY_REPLAY_ID} (sentry.replay_id) instead
 * @example "123e4567e89b12d3a456426614174000"
 */
export const REPLAYID = 'replayId';

/**
 * Type for {@link REPLAYID} replayId
 */
export type REPLAYID_TYPE = string;

// Path: model/attributes/replay_id.json

/**
 * The id of the sentry replay. `replay_id`
 *
 * Attribute Value Type: `string` {@link REPLAY_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_REPLAY_ID} `sentry.replay_id`
 *
 * @deprecated Use {@link SENTRY_REPLAY_ID} (sentry.replay_id) instead
 * @example "123e4567e89b12d3a456426614174000"
 */
export const REPLAY_ID = 'replay_id';

/**
 * Type for {@link REPLAY_ID} replay_id
 */
export type REPLAY_ID_TYPE = string;

// Path: model/attributes/resource/resource__deployment__environment.json

/**
 * The software deployment environment name. `resource.deployment.environment`
 *
 * Attribute Value Type: `string` {@link RESOURCE_DEPLOYMENT_ENVIRONMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated Use {@link SENTRY_ENVIRONMENT} (sentry.environment) instead
 * @example "production"
 */
export const RESOURCE_DEPLOYMENT_ENVIRONMENT = 'resource.deployment.environment';

/**
 * Type for {@link RESOURCE_DEPLOYMENT_ENVIRONMENT} resource.deployment.environment
 */
export type RESOURCE_DEPLOYMENT_ENVIRONMENT_TYPE = string;

// Path: model/attributes/resource/resource__deployment__environment__name.json

/**
 * The software deployment environment name. `resource.deployment.environment.name`
 *
 * Attribute Value Type: `string` {@link RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @deprecated Use {@link SENTRY_ENVIRONMENT} (sentry.environment) instead
 * @example "production"
 */
export const RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME = 'resource.deployment.environment.name';

/**
 * Type for {@link RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME} resource.deployment.environment.name
 */
export type RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME_TYPE = string;

// Path: model/attributes/resource/resource__render_blocking_status.json

/**
 * The render blocking status of the resource. `resource.render_blocking_status`
 *
 * Attribute Value Type: `string` {@link RESOURCE_RENDER_BLOCKING_STATUS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "non-blocking"
 */
export const RESOURCE_RENDER_BLOCKING_STATUS = 'resource.render_blocking_status';

/**
 * Type for {@link RESOURCE_RENDER_BLOCKING_STATUS} resource.render_blocking_status
 */
export type RESOURCE_RENDER_BLOCKING_STATUS_TYPE = string;

// Path: model/attributes/route.json

/**
 * The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application. `route`
 *
 * Attribute Value Type: `string` {@link ROUTE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_ROUTE} `http.route`
 *
 * @deprecated Use {@link HTTP_ROUTE} (http.route) instead
 * @example "App\\Controller::indexAction"
 */
export const ROUTE = 'route';

/**
 * Type for {@link ROUTE} route
 */
export type ROUTE_TYPE = string;

// Path: model/attributes/router/router__navigation__origin.json

/**
 * The origin of the navigation (usually client side router navigations). Should preferably be a parameterized template (like url.template) or a URL path otherwise. `router.navigation.origin`
 *
 * Attribute Value Type: `string` {@link ROUTER_NAVIGATION_ORIGIN_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NAVIGATION_ORIGIN} `navigation.origin`, {@link SENTRY_SVELTEKIT_NAVIGATION_FROM} `sentry.sveltekit.navigation.from`
 *
 * @example "/users/:id"
 */
export const ROUTER_NAVIGATION_ORIGIN = 'router.navigation.origin';

/**
 * Type for {@link ROUTER_NAVIGATION_ORIGIN} router.navigation.origin
 */
export type ROUTER_NAVIGATION_ORIGIN_TYPE = string;

// Path: model/attributes/router/router__navigation__route__id.json

/**
 * The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id). `router.navigation.route.id`
 *
 * Attribute Value Type: `string` {@link ROUTER_NAVIGATION_ROUTE_ID_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NAVIGATION_ROUTE_ID} `navigation.route.id`
 *
 * @example "AboutView"
 */
export const ROUTER_NAVIGATION_ROUTE_ID = 'router.navigation.route.id';

/**
 * Type for {@link ROUTER_NAVIGATION_ROUTE_ID} router.navigation.route.id
 */
export type ROUTER_NAVIGATION_ROUTE_ID_TYPE = string;

// Path: model/attributes/router/router__navigation__type.json

/**
 * The type of navigation done by a client-side router. `router.navigation.type`
 *
 * Attribute Value Type: `string` {@link ROUTER_NAVIGATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NAVIGATION_TYPE} `navigation.type`, {@link SENTRY_SVELTEKIT_NAVIGATION_TYPE} `sentry.sveltekit.navigation.type`
 *
 * @example "router.push"
 */
export const ROUTER_NAVIGATION_TYPE = 'router.navigation.type';

/**
 * Type for {@link ROUTER_NAVIGATION_TYPE} router.navigation.type
 */
export type ROUTER_NAVIGATION_TYPE_TYPE = string;

// Path: model/attributes/rpc/rpc__grpc__status_code.json

/**
 * The numeric status code of the gRPC request. `rpc.grpc.status_code`
 *
 * Attribute Value Type: `number` {@link RPC_GRPC_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE} `code`, {@link RPC_RESPONSE_STATUS_CODE} `rpc.response.status_code`
 *
 * @deprecated Use {@link RPC_RESPONSE_STATUS_CODE} (rpc.response.status_code) instead - Cannot be automatically backfilled due to type mismatch (integer vs string); rpc.grpc.status_code is a numeric gRPC status code while rpc.response.status_code is the string status name.
 * @example 2
 */
export const RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';

/**
 * Type for {@link RPC_GRPC_STATUS_CODE} rpc.grpc.status_code
 */
export type RPC_GRPC_STATUS_CODE_TYPE = number;

// Path: model/attributes/rpc/rpc__method.json

/**
 * The fully-qualified logical name of the method from the RPC interface perspective. `rpc.method`
 *
 * Attribute Value Type: `string` {@link RPC_METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link AWS_OPERATION_NAME} `aws.operation_name`
 *
 * @example "com.example.ExampleService/exampleMethod"
 */
export const RPC_METHOD = 'rpc.method';

/**
 * Type for {@link RPC_METHOD} rpc.method
 */
export type RPC_METHOD_TYPE = string;

// Path: model/attributes/rpc/rpc__response__status_code.json

/**
 * Status code of the RPC returned by the RPC server or generated by the client. `rpc.response.status_code`
 *
 * Attribute Value Type: `string` {@link RPC_RESPONSE_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link CODE} `code`, {@link RPC_GRPC_STATUS_CODE} `rpc.grpc.status_code`
 *
 * @example "DEADLINE_EXCEEDED"
 */
export const RPC_RESPONSE_STATUS_CODE = 'rpc.response.status_code';

/**
 * Type for {@link RPC_RESPONSE_STATUS_CODE} rpc.response.status_code
 */
export type RPC_RESPONSE_STATUS_CODE_TYPE = string;

// Path: model/attributes/rpc/rpc__service.json

/**
 * The full (logical) name of the service being called, including its package name, if applicable. `rpc.service`
 *
 * Attribute Value Type: `string` {@link RPC_SERVICE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "myService.BestService"
 */
export const RPC_SERVICE = 'rpc.service';

/**
 * Type for {@link RPC_SERVICE} rpc.service
 */
export type RPC_SERVICE_TYPE = string;

// Path: model/attributes/rpc/rpc__system.json

/**
 * A string identifying the remoting system. `rpc.system`
 *
 * Attribute Value Type: `string` {@link RPC_SYSTEM_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link RPC_SYSTEM_NAME} `rpc.system.name`
 *
 * @deprecated Use {@link RPC_SYSTEM_NAME} (rpc.system.name) instead - This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement.
 * @example "aws-api"
 */
export const RPC_SYSTEM = 'rpc.system';

/**
 * Type for {@link RPC_SYSTEM} rpc.system
 */
export type RPC_SYSTEM_TYPE = string;

// Path: model/attributes/rpc/rpc__system__name.json

/**
 * A string identifying the remoting system. `rpc.system.name`
 *
 * Attribute Value Type: `string` {@link RPC_SYSTEM_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link RPC_SYSTEM} `rpc.system`
 *
 * @example "aws-api"
 */
export const RPC_SYSTEM_NAME = 'rpc.system.name';

/**
 * Type for {@link RPC_SYSTEM_NAME} rpc.system.name
 */
export type RPC_SYSTEM_NAME_TYPE = string;

// Path: model/attributes/runtime/runtime__build.json

/**
 * The application build string, when it is separate from the version. `runtime.build`
 *
 * Attribute Value Type: `string` {@link RUNTIME_BUILD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute.
 * @example "stable"
 */
export const RUNTIME_BUILD = 'runtime.build';

/**
 * Type for {@link RUNTIME_BUILD} runtime.build
 */
export type RUNTIME_BUILD_TYPE = string;

// Path: model/attributes/runtime/runtime__name.json

/**
 * The name of the runtime. For example node, CPython, or rustc. `runtime.name`
 *
 * Attribute Value Type: `string` {@link RUNTIME_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PROCESS_RUNTIME_NAME} `process.runtime.name`
 *
 * @deprecated Use {@link PROCESS_RUNTIME_NAME} (process.runtime.name) instead - Prefer OTel-aligned process.runtime.name
 * @example "node"
 */
export const RUNTIME_NAME = 'runtime.name';

/**
 * Type for {@link RUNTIME_NAME} runtime.name
 */
export type RUNTIME_NAME_TYPE = string;

// Path: model/attributes/runtime/runtime__raw_description.json

/**
 * Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes. `runtime.raw_description`
 *
 * Attribute Value Type: `string` {@link RUNTIME_RAW_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PROCESS_RUNTIME_DESCRIPTION} `process.runtime.description`
 *
 * @deprecated Use {@link PROCESS_RUNTIME_DESCRIPTION} (process.runtime.description) instead - Prefer OTel-aligned process.runtime.description
 * @example "Eclipse OpenJ9 VM openj9-0.21.0"
 */
export const RUNTIME_RAW_DESCRIPTION = 'runtime.raw_description';

/**
 * Type for {@link RUNTIME_RAW_DESCRIPTION} runtime.raw_description
 */
export type RUNTIME_RAW_DESCRIPTION_TYPE = string;

// Path: model/attributes/runtime/runtime__version.json

/**
 * The version of the runtime. `runtime.version`
 *
 * Attribute Value Type: `string` {@link RUNTIME_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PROCESS_RUNTIME_VERSION} `process.runtime.version`
 *
 * @deprecated Use {@link PROCESS_RUNTIME_VERSION} (process.runtime.version) instead - Prefer OTel-aligned process.runtime.version
 * @example "18.04.2"
 */
export const RUNTIME_VERSION = 'runtime.version';

/**
 * Type for {@link RUNTIME_VERSION} runtime.version
 */
export type RUNTIME_VERSION_TYPE = string;

// Path: model/attributes/score/score__[key].json

/**
 * The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`. `score.<key>`
 *
 * Attribute Value Type: `number` {@link SCORE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "score.cls=0.1723"
 */
export const SCORE_KEY = 'score.<key>';

/**
 * Base key for {@link SCORE_KEY}. Use with a dynamic suffix, e.g. `${SCORE_KEY_BASE}.${key}`.
 */
export const SCORE_KEY_BASE = 'score';

/**
 * Type for {@link SCORE_KEY} score.<key>
 */
export type SCORE_KEY_TYPE = number;

// Path: model/attributes/score/score__ratio__[key].json

/**
 * The score for a web vital, normalized to a number between 0 and 1. `score.ratio.<key>`
 *
 * Attribute Value Type: `number` {@link SCORE_RATIO_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "score.ratio.inp=0.7748"
 */
export const SCORE_RATIO_KEY = 'score.ratio.<key>';

/**
 * Base key for {@link SCORE_RATIO_KEY}. Use with a dynamic suffix, e.g. `${SCORE_RATIO_KEY_BASE}.${key}`.
 */
export const SCORE_RATIO_KEY_BASE = 'score.ratio';

/**
 * Type for {@link SCORE_RATIO_KEY} score.ratio.<key>
 */
export type SCORE_RATIO_KEY_TYPE = number;

// Path: model/attributes/score/score__total.json

/**
 * The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`). `score.total`
 *
 * Attribute Value Type: `number` {@link SCORE_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 */
export const SCORE_TOTAL = 'score.total';

/**
 * Type for {@link SCORE_TOTAL} score.total
 */
export type SCORE_TOTAL_TYPE = number;

// Path: model/attributes/score/score__weight__[key].json

/**
 * The relative weight of a web vital in a span's performance score. `score.weight.<key>`
 *
 * Attribute Value Type: `number` {@link SCORE_WEIGHT_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "score.weight.fcp=0.25"
 */
export const SCORE_WEIGHT_KEY = 'score.weight.<key>';

/**
 * Base key for {@link SCORE_WEIGHT_KEY}. Use with a dynamic suffix, e.g. `${SCORE_WEIGHT_KEY_BASE}.${key}`.
 */
export const SCORE_WEIGHT_KEY_BASE = 'score.weight';

/**
 * Type for {@link SCORE_WEIGHT_KEY} score.weight.<key>
 */
export type SCORE_WEIGHT_KEY_TYPE = number;

// Path: model/attributes/sentry/sentry__action.json

/**
 * Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans. `sentry.action`
 *
 * Attribute Value Type: `string` {@link SENTRY_ACTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "SELECT"
 */
export const SENTRY_ACTION = 'sentry.action';

/**
 * Type for {@link SENTRY_ACTION} sentry.action
 */
export type SENTRY_ACTION_TYPE = string;

// Path: model/attributes/sentry/sentry__browser__name.json

/**
 * The name of the browser. `sentry.browser.name`
 *
 * Attribute Value Type: `string` {@link SENTRY_BROWSER_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_NAME} `browser.name`
 *
 * @deprecated Use {@link BROWSER_NAME} (browser.name) instead
 * @example "Chrome"
 */
export const SENTRY_BROWSER_NAME = 'sentry.browser.name';

/**
 * Type for {@link SENTRY_BROWSER_NAME} sentry.browser.name
 */
export type SENTRY_BROWSER_NAME_TYPE = string;

// Path: model/attributes/sentry/sentry__browser__version.json

/**
 * The version of the browser. `sentry.browser.version`
 *
 * Attribute Value Type: `string` {@link SENTRY_BROWSER_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_VERSION} `browser.version`
 *
 * @deprecated Use {@link BROWSER_VERSION} (browser.version) instead
 * @example "120.0.6099.130"
 */
export const SENTRY_BROWSER_VERSION = 'sentry.browser.version';

/**
 * Type for {@link SENTRY_BROWSER_VERSION} sentry.browser.version
 */
export type SENTRY_BROWSER_VERSION_TYPE = string;

// Path: model/attributes/sentry/sentry__cancellation_reason.json

/**
 * The reason why a span ended early. `sentry.cancellation_reason`
 *
 * Attribute Value Type: `string` {@link SENTRY_CANCELLATION_REASON_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "document.hidden"
 */
export const SENTRY_CANCELLATION_REASON = 'sentry.cancellation_reason';

/**
 * Type for {@link SENTRY_CANCELLATION_REASON} sentry.cancellation_reason
 */
export type SENTRY_CANCELLATION_REASON_TYPE = string;

// Path: model/attributes/sentry/sentry__category.json

/**
 * The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI). `sentry.category`
 *
 * Attribute Value Type: `string` {@link SENTRY_CATEGORY_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Well-defined Values:
 * - `ai`
 * - `ai.pipeline`
 * - `app`
 * - `browser`
 * - `cache`
 * - `console`
 * - `db`
 * - `event`
 * - `file`
 * - `function.aws`
 * - `function.azure`
 * - `function.gcp`
 * - `function.nextjs`
 * - `function.remix`
 * - `graphql`
 * - `grpc`
 * - `http`
 * - `measure`
 * - `middleware`
 * - `navigation`
 * - `pageload`
 * - `queue`
 * - `resource`
 * - `rpc`
 * - `serialize`
 * - `subprocess`
 * - `template`
 * - `topic`
 * - `ui`
 * - `ui.angular`
 * - `ui.ember`
 * - `ui.react`
 * - `ui.svelte`
 * - `ui.vue`
 * - `view`
 * - `websocket`
 *
 * @example "db"
 */
export const SENTRY_CATEGORY = 'sentry.category';

/**
 * Type for {@link SENTRY_CATEGORY} sentry.category
 */
export type SENTRY_CATEGORY_TYPE = string;

// Path: model/attributes/sentry/sentry__client_sample_rate.json

/**
 * Rate at which a span was sampled in the SDK. `sentry.client_sample_rate`
 *
 * Attribute Value Type: `number` {@link SENTRY_CLIENT_SAMPLE_RATE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0.5
 */
export const SENTRY_CLIENT_SAMPLE_RATE = 'sentry.client_sample_rate';

/**
 * Type for {@link SENTRY_CLIENT_SAMPLE_RATE} sentry.client_sample_rate
 */
export type SENTRY_CLIENT_SAMPLE_RATE_TYPE = number;

// Path: model/attributes/sentry/sentry__description.json

/**
 * The human-readable description of a span. `sentry.description`
 *
 * Attribute Value Type: `string` {@link SENTRY_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "index view query"
 */
export const SENTRY_DESCRIPTION = 'sentry.description';

/**
 * Type for {@link SENTRY_DESCRIPTION} sentry.description
 */
export type SENTRY_DESCRIPTION_TYPE = string;

// Path: model/attributes/sentry/sentry__dist.json

/**
 * The sentry dist. `sentry.dist`
 *
 * Attribute Value Type: `string` {@link SENTRY_DIST_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link DIST} `dist`
 *
 * @example "1.0"
 */
export const SENTRY_DIST = 'sentry.dist';

/**
 * Type for {@link SENTRY_DIST} sentry.dist
 */
export type SENTRY_DIST_TYPE = string;

// Path: model/attributes/sentry/sentry__domain.json

/**
 * Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans. `sentry.domain`
 *
 * Attribute Value Type: `string` {@link SENTRY_DOMAIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "example.com"
 */
export const SENTRY_DOMAIN = 'sentry.domain';

/**
 * Type for {@link SENTRY_DOMAIN} sentry.domain
 */
export type SENTRY_DOMAIN_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__environment.json

/**
 * The environment from the dynamic sampling context. `sentry.dsc.environment`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_ENVIRONMENT_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "prod"
 */
export const SENTRY_DSC_ENVIRONMENT = 'sentry.dsc.environment';

/**
 * Type for {@link SENTRY_DSC_ENVIRONMENT} sentry.dsc.environment
 */
export type SENTRY_DSC_ENVIRONMENT_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__project_id.json

/**
 * The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion. `sentry.dsc.project_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_PROJECT_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "12345"
 */
export const SENTRY_DSC_PROJECT_ID = 'sentry.dsc.project_id';

/**
 * Type for {@link SENTRY_DSC_PROJECT_ID} sentry.dsc.project_id
 */
export type SENTRY_DSC_PROJECT_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__public_key.json

/**
 * The public key from the dynamic sampling context. `sentry.dsc.public_key`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_PUBLIC_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "c51734c603c4430eb57cb0a5728a479d"
 */
export const SENTRY_DSC_PUBLIC_KEY = 'sentry.dsc.public_key';

/**
 * Type for {@link SENTRY_DSC_PUBLIC_KEY} sentry.dsc.public_key
 */
export type SENTRY_DSC_PUBLIC_KEY_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__release.json

/**
 * The release identifier from the dynamic sampling context. `sentry.dsc.release`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_RELEASE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "frontend@e8211be71b214afab5b85de4b4c54be3714952bb"
 */
export const SENTRY_DSC_RELEASE = 'sentry.dsc.release';

/**
 * Type for {@link SENTRY_DSC_RELEASE} sentry.dsc.release
 */
export type SENTRY_DSC_RELEASE_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__sampled.json

/**
 * Whether the event was sampled according to the dynamic sampling context. `sentry.dsc.sampled`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_DSC_SAMPLED_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example true
 */
export const SENTRY_DSC_SAMPLED = 'sentry.dsc.sampled';

/**
 * Type for {@link SENTRY_DSC_SAMPLED} sentry.dsc.sampled
 */
export type SENTRY_DSC_SAMPLED_TYPE = boolean;

// Path: model/attributes/sentry/sentry__dsc__sample_rate.json

/**
 * The sample rate from the dynamic sampling context. `sentry.dsc.sample_rate`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_SAMPLE_RATE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "1.0"
 */
export const SENTRY_DSC_SAMPLE_RATE = 'sentry.dsc.sample_rate';

/**
 * Type for {@link SENTRY_DSC_SAMPLE_RATE} sentry.dsc.sample_rate
 */
export type SENTRY_DSC_SAMPLE_RATE_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__trace_id.json

/**
 * The trace ID from the dynamic sampling context. `sentry.dsc.trace_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_TRACE_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "047372980460430cbc78d9779df33a46"
 */
export const SENTRY_DSC_TRACE_ID = 'sentry.dsc.trace_id';

/**
 * Type for {@link SENTRY_DSC_TRACE_ID} sentry.dsc.trace_id
 */
export type SENTRY_DSC_TRACE_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__dsc__transaction.json

/**
 * The transaction name from the dynamic sampling context. `sentry.dsc.transaction`
 *
 * Attribute Value Type: `string` {@link SENTRY_DSC_TRANSACTION_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "/issues/errors-outages/"
 */
export const SENTRY_DSC_TRANSACTION = 'sentry.dsc.transaction';

/**
 * Type for {@link SENTRY_DSC_TRANSACTION} sentry.dsc.transaction
 */
export type SENTRY_DSC_TRANSACTION_TYPE = string;

// Path: model/attributes/sentry/sentry__environment.json

/**
 * The sentry environment. `sentry.environment`
 *
 * Attribute Value Type: `string` {@link SENTRY_ENVIRONMENT_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link ENVIRONMENT} `environment`
 *
 * @example "production"
 */
export const SENTRY_ENVIRONMENT = 'sentry.environment';

/**
 * Type for {@link SENTRY_ENVIRONMENT} sentry.environment
 */
export type SENTRY_ENVIRONMENT_TYPE = string;

// Path: model/attributes/sentry/sentry__event__serialized_breadcrumbs.json

/**
 * JSON-serialized `breadcrumbs` property from a Sentry event. `sentry.event.serialized_breadcrumbs`
 *
 * Attribute Value Type: `string` {@link SENTRY_EVENT_SERIALIZED_BREADCRUMBS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 */
export const SENTRY_EVENT_SERIALIZED_BREADCRUMBS = 'sentry.event.serialized_breadcrumbs';

/**
 * Type for {@link SENTRY_EVENT_SERIALIZED_BREADCRUMBS} sentry.event.serialized_breadcrumbs
 */
export type SENTRY_EVENT_SERIALIZED_BREADCRUMBS_TYPE = string;

// Path: model/attributes/sentry/sentry__event__serialized_contexts.json

/**
 * JSON-serialized `contexts` property from a Sentry event. `sentry.event.serialized_contexts`
 *
 * Attribute Value Type: `string` {@link SENTRY_EVENT_SERIALIZED_CONTEXTS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 */
export const SENTRY_EVENT_SERIALIZED_CONTEXTS = 'sentry.event.serialized_contexts';

/**
 * Type for {@link SENTRY_EVENT_SERIALIZED_CONTEXTS} sentry.event.serialized_contexts
 */
export type SENTRY_EVENT_SERIALIZED_CONTEXTS_TYPE = string;

// Path: model/attributes/sentry/sentry__event__serialized_extra.json

/**
 * JSON-serialized `extra` property from a Sentry event. `sentry.event.serialized_extra`
 *
 * Attribute Value Type: `string` {@link SENTRY_EVENT_SERIALIZED_EXTRA_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 */
export const SENTRY_EVENT_SERIALIZED_EXTRA = 'sentry.event.serialized_extra';

/**
 * Type for {@link SENTRY_EVENT_SERIALIZED_EXTRA} sentry.event.serialized_extra
 */
export type SENTRY_EVENT_SERIALIZED_EXTRA_TYPE = string;

// Path: model/attributes/sentry/sentry__event__serialized_meta.json

/**
 * JSON-serialized `_meta` for the `sentry.event.serialized_*` properties from a Sentry event. `sentry.event.serialized_meta`
 *
 * Attribute Value Type: `string` {@link SENTRY_EVENT_SERIALIZED_META_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 */
export const SENTRY_EVENT_SERIALIZED_META = 'sentry.event.serialized_meta';

/**
 * Type for {@link SENTRY_EVENT_SERIALIZED_META} sentry.event.serialized_meta
 */
export type SENTRY_EVENT_SERIALIZED_META_TYPE = string;

// Path: model/attributes/sentry/sentry__exclusive_time.json

/**
 * The exclusive time duration of the span in milliseconds. `sentry.exclusive_time`
 *
 * Attribute Value Type: `number` {@link SENTRY_EXCLUSIVE_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1234
 */
export const SENTRY_EXCLUSIVE_TIME = 'sentry.exclusive_time';

/**
 * Type for {@link SENTRY_EXCLUSIVE_TIME} sentry.exclusive_time
 */
export type SENTRY_EXCLUSIVE_TIME_TYPE = number;

// Path: model/attributes/sentry/sentry__frames__frozen.json

/**
 * The number of frozen frames rendered during the lifetime of the span. `sentry.frames.frozen`
 *
 * Attribute Value Type: `number` {@link SENTRY_FRAMES_FROZEN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_FROZEN_COUNT} `app.vitals.frames.frozen.count`, {@link FRAMES_FROZEN} `frames.frozen`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_FROZEN_COUNT} (app.vitals.frames.frozen.count) instead - Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 3
 */
export const SENTRY_FRAMES_FROZEN = 'sentry.frames.frozen';

/**
 * Type for {@link SENTRY_FRAMES_FROZEN} sentry.frames.frozen
 */
export type SENTRY_FRAMES_FROZEN_TYPE = number;

// Path: model/attributes/sentry/sentry__frames__slow.json

/**
 * The number of slow frames rendered during the lifetime of the span. `sentry.frames.slow`
 *
 * Attribute Value Type: `number` {@link SENTRY_FRAMES_SLOW_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_SLOW_COUNT} `app.vitals.frames.slow.count`, {@link FRAMES_SLOW} `frames.slow`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_SLOW_COUNT} (app.vitals.frames.slow.count) instead - Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1
 */
export const SENTRY_FRAMES_SLOW = 'sentry.frames.slow';

/**
 * Type for {@link SENTRY_FRAMES_SLOW} sentry.frames.slow
 */
export type SENTRY_FRAMES_SLOW_TYPE = number;

// Path: model/attributes/sentry/sentry__frames__total.json

/**
 * The number of total frames rendered during the lifetime of the span. `sentry.frames.total`
 *
 * Attribute Value Type: `number` {@link SENTRY_FRAMES_TOTAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_FRAMES_TOTAL_COUNT} `app.vitals.frames.total.count`, {@link FRAMES_TOTAL} `frames.total`
 *
 * @deprecated Use {@link APP_VITALS_FRAMES_TOTAL_COUNT} (app.vitals.frames.total.count) instead - Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes
 * @example 60
 */
export const SENTRY_FRAMES_TOTAL = 'sentry.frames.total';

/**
 * Type for {@link SENTRY_FRAMES_TOTAL} sentry.frames.total
 */
export type SENTRY_FRAMES_TOTAL_TYPE = number;

// Path: model/attributes/sentry/sentry__graphql__operation.json

/**
 * Indicates the type of graphql operation, emitted by the Javascript SDK. `sentry.graphql.operation`
 *
 * Attribute Value Type: `string` {@link SENTRY_GRAPHQL_OPERATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "getUserById"
 */
export const SENTRY_GRAPHQL_OPERATION = 'sentry.graphql.operation';

/**
 * Type for {@link SENTRY_GRAPHQL_OPERATION} sentry.graphql.operation
 */
export type SENTRY_GRAPHQL_OPERATION_TYPE = string;

// Path: model/attributes/sentry/sentry__group.json

/**
 * Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end. `sentry.group`
 *
 * Attribute Value Type: `string` {@link SENTRY_GROUP_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 */
export const SENTRY_GROUP = 'sentry.group';

/**
 * Type for {@link SENTRY_GROUP} sentry.group
 */
export type SENTRY_GROUP_TYPE = string;

// Path: model/attributes/sentry/sentry__http__prefetch.json

/**
 * If an http request was a prefetch request. `sentry.http.prefetch`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_HTTP_PREFETCH_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const SENTRY_HTTP_PREFETCH = 'sentry.http.prefetch';

/**
 * Type for {@link SENTRY_HTTP_PREFETCH} sentry.http.prefetch
 */
export type SENTRY_HTTP_PREFETCH_TYPE = boolean;

// Path: model/attributes/sentry/sentry__idle_span_finish_reason.json

/**
 * The reason why an idle span ended early. `sentry.idle_span_finish_reason`
 *
 * Attribute Value Type: `string` {@link SENTRY_IDLE_SPAN_FINISH_REASON_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "idleTimeout"
 */
export const SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';

/**
 * Type for {@link SENTRY_IDLE_SPAN_FINISH_REASON} sentry.idle_span_finish_reason
 */
export type SENTRY_IDLE_SPAN_FINISH_REASON_TYPE = string;

// Path: model/attributes/sentry/sentry__is_localhost.json

/**
 * Indicates whether a telemetry item was sent on a host, device or browser on a localhost URL or IP address. `sentry.is_localhost`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_IS_LOCALHOST_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example true
 * @example false
 */
export const SENTRY_IS_LOCALHOST = 'sentry.is_localhost';

/**
 * Type for {@link SENTRY_IS_LOCALHOST} sentry.is_localhost
 */
export type SENTRY_IS_LOCALHOST_TYPE = boolean;

// Path: model/attributes/sentry/sentry__is_remote.json

/**
 * Indicates whether a span's parent is remote. `sentry.is_remote`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_IS_REMOTE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const SENTRY_IS_REMOTE = 'sentry.is_remote';

/**
 * Type for {@link SENTRY_IS_REMOTE} sentry.is_remote
 */
export type SENTRY_IS_REMOTE_TYPE = boolean;

// Path: model/attributes/sentry/sentry__kind.json

/**
 * Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name. `sentry.kind`
 *
 * Attribute Value Type: `string` {@link SENTRY_KIND_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link OTEL_KIND} `otel.kind`
 *
 * @example "client"
 * @example "server"
 * @example "producer"
 * @example "consumer"
 * @example "internal"
 */
export const SENTRY_KIND = 'sentry.kind';

/**
 * Type for {@link SENTRY_KIND} sentry.kind
 */
export type SENTRY_KIND_TYPE = string;

// Path: model/attributes/sentry/sentry__link__type.json

/**
 * Set on a span link. Describes the relationship between the span and the linked span. `sentry.link.type`
 *
 * Attribute Value Type: `string` {@link SENTRY_LINK_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "previous_trace"
 * @example "next_trace"
 * @example "cache_origin"
 */
export const SENTRY_LINK_TYPE = 'sentry.link.type';

/**
 * Type for {@link SENTRY_LINK_TYPE} sentry.link.type
 */
export type SENTRY_LINK_TYPE_TYPE = string;

// Path: model/attributes/sentry/sentry__main_thread.json

/**
 * Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs. `sentry.main_thread`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_MAIN_THREAD_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const SENTRY_MAIN_THREAD = 'sentry.main_thread';

/**
 * Type for {@link SENTRY_MAIN_THREAD} sentry.main_thread
 */
export type SENTRY_MAIN_THREAD_TYPE = boolean;

// Path: model/attributes/sentry/sentry__message__parameter__[key].json

/**
 * A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc) `sentry.message.parameter.<key>`
 *
 * Attribute Value Type: `string` {@link SENTRY_MESSAGE_PARAMETER_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sentry.message.parameter.0='123'"
 */
export const SENTRY_MESSAGE_PARAMETER_KEY = 'sentry.message.parameter.<key>';

/**
 * Type for {@link SENTRY_MESSAGE_PARAMETER_KEY} sentry.message.parameter.<key>
 */
export type SENTRY_MESSAGE_PARAMETER_KEY_TYPE = string;

// Path: model/attributes/sentry/sentry__message__template.json

/**
 * The parameterized template string. `sentry.message.template`
 *
 * Attribute Value Type: `string` {@link SENTRY_MESSAGE_TEMPLATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "Hello, {name}!"
 */
export const SENTRY_MESSAGE_TEMPLATE = 'sentry.message.template';

/**
 * Type for {@link SENTRY_MESSAGE_TEMPLATE} sentry.message.template
 */
export type SENTRY_MESSAGE_TEMPLATE_TYPE = string;

// Path: model/attributes/sentry/sentry__metric__source.json

/**
 * The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span. `sentry.metric.source`
 *
 * Attribute Value Type: `string` {@link SENTRY_METRIC_SOURCE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "span"
 */
export const SENTRY_METRIC_SOURCE = 'sentry.metric.source';

/**
 * Type for {@link SENTRY_METRIC_SOURCE} sentry.metric.source
 */
export type SENTRY_METRIC_SOURCE_TYPE = string;

// Path: model/attributes/sentry/sentry__mobile.json

/**
 * Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs. `sentry.mobile`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_MOBILE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const SENTRY_MOBILE = 'sentry.mobile';

/**
 * Type for {@link SENTRY_MOBILE} sentry.mobile
 */
export type SENTRY_MOBILE_TYPE = boolean;

// Path: model/attributes/sentry/sentry__module__[key].json

/**
 * A module that was loaded in the process. The key is the name of the module. `sentry.module.<key>`
 *
 * Attribute Value Type: `string` {@link SENTRY_MODULE_KEY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "sentry.module.brianium/paratest='v7.7.0'"
 */
export const SENTRY_MODULE_KEY = 'sentry.module.<key>';

/**
 * Base key for {@link SENTRY_MODULE_KEY}. Use with a dynamic suffix, e.g. `${SENTRY_MODULE_KEY_BASE}.${key}`.
 */
export const SENTRY_MODULE_KEY_BASE = 'sentry.module';

/**
 * Type for {@link SENTRY_MODULE_KEY} sentry.module.<key>
 */
export type SENTRY_MODULE_KEY_TYPE = string;

// Path: model/attributes/sentry/sentry__nextjs__ssr__function__route.json

/**
 * A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known. `sentry.nextjs.ssr.function.route`
 *
 * Attribute Value Type: `string` {@link SENTRY_NEXTJS_SSR_FUNCTION_ROUTE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "/posts/[id]/layout"
 */
export const SENTRY_NEXTJS_SSR_FUNCTION_ROUTE = 'sentry.nextjs.ssr.function.route';

/**
 * Type for {@link SENTRY_NEXTJS_SSR_FUNCTION_ROUTE} sentry.nextjs.ssr.function.route
 */
export type SENTRY_NEXTJS_SSR_FUNCTION_ROUTE_TYPE = string;

// Path: model/attributes/sentry/sentry__nextjs__ssr__function__type.json

/**
 * A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions. `sentry.nextjs.ssr.function.type`
 *
 * Attribute Value Type: `string` {@link SENTRY_NEXTJS_SSR_FUNCTION_TYPE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "generateMetadata"
 */
export const SENTRY_NEXTJS_SSR_FUNCTION_TYPE = 'sentry.nextjs.ssr.function.type';

/**
 * Type for {@link SENTRY_NEXTJS_SSR_FUNCTION_TYPE} sentry.nextjs.ssr.function.type
 */
export type SENTRY_NEXTJS_SSR_FUNCTION_TYPE_TYPE = string;

// Path: model/attributes/sentry/sentry__normalized_db_query.json

/**
 * The normalized version of `db.query.text`. `sentry.normalized_db_query`
 *
 * Attribute Value Type: `string` {@link SENTRY_NORMALIZED_DB_QUERY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "SELECT .. FROM sentry_project WHERE (project_id = %s)"
 */
export const SENTRY_NORMALIZED_DB_QUERY = 'sentry.normalized_db_query';

/**
 * Type for {@link SENTRY_NORMALIZED_DB_QUERY} sentry.normalized_db_query
 */
export type SENTRY_NORMALIZED_DB_QUERY_TYPE = string;

// Path: model/attributes/sentry/sentry__normalized_db_query__hash.json

/**
 * The hash of `sentry.normalized_db_query`. `sentry.normalized_db_query.hash`
 *
 * Attribute Value Type: `string` {@link SENTRY_NORMALIZED_DB_QUERY_HASH_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 */
export const SENTRY_NORMALIZED_DB_QUERY_HASH = 'sentry.normalized_db_query.hash';

/**
 * Type for {@link SENTRY_NORMALIZED_DB_QUERY_HASH} sentry.normalized_db_query.hash
 */
export type SENTRY_NORMALIZED_DB_QUERY_HASH_TYPE = string;

// Path: model/attributes/sentry/sentry__normalized_description.json

/**
 * Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc). `sentry.normalized_description`
 *
 * Attribute Value Type: `string` {@link SENTRY_NORMALIZED_DESCRIPTION_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "SELECT .. FROM sentry_project WHERE (project_id = %s)"
 */
export const SENTRY_NORMALIZED_DESCRIPTION = 'sentry.normalized_description';

/**
 * Type for {@link SENTRY_NORMALIZED_DESCRIPTION} sentry.normalized_description
 */
export type SENTRY_NORMALIZED_DESCRIPTION_TYPE = string;

// Path: model/attributes/sentry/sentry__observed_timestamp_nanos.json

/**
 * The timestamp at which an envelope was received by Relay, in nanoseconds. `sentry.observed_timestamp_nanos`
 *
 * Attribute Value Type: `string` {@link SENTRY_OBSERVED_TIMESTAMP_NANOS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1544712660300000000"
 */
export const SENTRY_OBSERVED_TIMESTAMP_NANOS = 'sentry.observed_timestamp_nanos';

/**
 * Type for {@link SENTRY_OBSERVED_TIMESTAMP_NANOS} sentry.observed_timestamp_nanos
 */
export type SENTRY_OBSERVED_TIMESTAMP_NANOS_TYPE = string;

// Path: model/attributes/sentry/sentry__op.json

/**
 * The operation of a span. `sentry.op`
 *
 * Attribute Value Type: `string` {@link SENTRY_OP_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "http.client"
 */
export const SENTRY_OP = 'sentry.op';

/**
 * Type for {@link SENTRY_OP} sentry.op
 */
export type SENTRY_OP_TYPE = string;

// Path: model/attributes/sentry/sentry__origin.json

/**
 * The origin of the instrumentation (e.g. span, log, etc.) `sentry.origin`
 *
 * Attribute Value Type: `string` {@link SENTRY_ORIGIN_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "auto.http.otel.fastify"
 */
export const SENTRY_ORIGIN = 'sentry.origin';

/**
 * Type for {@link SENTRY_ORIGIN} sentry.origin
 */
export type SENTRY_ORIGIN_TYPE = string;

// Path: model/attributes/sentry/sentry__pageload__span_id.json

/**
 * The id of the pageload span, set by web vital spans and metrics `sentry.pageload.span_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_PAGELOAD_SPAN_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "bf2c8d3df84524de"
 */
export const SENTRY_PAGELOAD_SPAN_ID = 'sentry.pageload.span_id';

/**
 * Type for {@link SENTRY_PAGELOAD_SPAN_ID} sentry.pageload.span_id
 */
export type SENTRY_PAGELOAD_SPAN_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__platform.json

/**
 * The sdk platform that generated the event. `sentry.platform`
 *
 * Attribute Value Type: `string` {@link SENTRY_PLATFORM_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "php"
 */
export const SENTRY_PLATFORM = 'sentry.platform';

/**
 * Type for {@link SENTRY_PLATFORM} sentry.platform
 */
export type SENTRY_PLATFORM_TYPE = string;

// Path: model/attributes/sentry/sentry__profiler_id.json

/**
 * The id of the currently running profiler (continuous profiling) `sentry.profiler_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_PROFILER_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "18779b64dd35d1a538e7ce2dd2d3fad3"
 */
export const SENTRY_PROFILER_ID = 'sentry.profiler_id';

/**
 * Type for {@link SENTRY_PROFILER_ID} sentry.profiler_id
 */
export type SENTRY_PROFILER_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__profile_id.json

/**
 * The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling. `sentry.profile_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_PROFILE_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PROFILE_ID} `profile_id`
 *
 * @example "123e4567e89b12d3a456426614174000"
 */
export const SENTRY_PROFILE_ID = 'sentry.profile_id';

/**
 * Type for {@link SENTRY_PROFILE_ID} sentry.profile_id
 */
export type SENTRY_PROFILE_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__relay__ingress.json

/**
 * How an item (span, log, &c.) entered Relay. `sentry.relay.ingress`
 *
 * Attribute Value Type: `string` {@link SENTRY_RELAY_INGRESS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "OTEL"
 */
export const SENTRY_RELAY_INGRESS = 'sentry.relay.ingress';

/**
 * Type for {@link SENTRY_RELAY_INGRESS} sentry.relay.ingress
 */
export type SENTRY_RELAY_INGRESS_TYPE = string;

// Path: model/attributes/sentry/sentry__relay__pipeline.json

/**
 * An internal descriptor of which processing pipeline an item went through in Relay. `sentry.relay.pipeline`
 *
 * Attribute Value Type: `string` {@link SENTRY_RELAY_PIPELINE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * @example "span v2"
 */
export const SENTRY_RELAY_PIPELINE = 'sentry.relay.pipeline';

/**
 * Type for {@link SENTRY_RELAY_PIPELINE} sentry.relay.pipeline
 */
export type SENTRY_RELAY_PIPELINE_TYPE = string;

// Path: model/attributes/sentry/sentry__release.json

/**
 * The sentry release. `sentry.release`
 *
 * Attribute Value Type: `string` {@link SENTRY_RELEASE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SERVICE_VERSION} `service.version`, {@link RELEASE} `release`
 *
 * @example "7.0.0"
 */
export const SENTRY_RELEASE = 'sentry.release';

/**
 * Type for {@link SENTRY_RELEASE} sentry.release
 */
export type SENTRY_RELEASE_TYPE = string;

// Path: model/attributes/sentry/sentry__replay_id.json

/**
 * The id of the sentry replay. `sentry.replay_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_REPLAY_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REPLAY_ID} `replay_id`, {@link REPLAYID} `replayId`
 *
 * @example "123e4567e89b12d3a456426614174000"
 */
export const SENTRY_REPLAY_ID = 'sentry.replay_id';

/**
 * Type for {@link SENTRY_REPLAY_ID} sentry.replay_id
 */
export type SENTRY_REPLAY_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__replay_is_buffering.json

/**
 * A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate). `sentry.replay_is_buffering`
 *
 * Attribute Value Type: `boolean` {@link SENTRY_REPLAY_IS_BUFFERING_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const SENTRY_REPLAY_IS_BUFFERING = 'sentry.replay_is_buffering';

/**
 * Type for {@link SENTRY_REPLAY_IS_BUFFERING} sentry.replay_is_buffering
 */
export type SENTRY_REPLAY_IS_BUFFERING_TYPE = boolean;

// Path: model/attributes/sentry/sentry__report_event.json

/**
 * (Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation) `sentry.report_event`
 *
 * Attribute Value Type: `string` {@link SENTRY_REPORT_EVENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - The report event moved to browser.web_vital.lcp.report_event and browser.web_vital.cls.report_event, which are themselves deprecated without a replacement. No backfill required.
 * @example "pagehide"
 */
export const SENTRY_REPORT_EVENT = 'sentry.report_event';

/**
 * Type for {@link SENTRY_REPORT_EVENT} sentry.report_event
 */
export type SENTRY_REPORT_EVENT_TYPE = string;

// Path: model/attributes/sentry/sentry__sdk__integrations.json

/**
 * A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations. `sentry.sdk.integrations`
 *
 * Attribute Value Type: `Array<string>` {@link SENTRY_SDK_INTEGRATIONS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["InboundFilters","FunctionToString","BrowserApiErrors","Breadcrumbs"]
 */
export const SENTRY_SDK_INTEGRATIONS = 'sentry.sdk.integrations';

/**
 * Type for {@link SENTRY_SDK_INTEGRATIONS} sentry.sdk.integrations
 */
export type SENTRY_SDK_INTEGRATIONS_TYPE = Array<string>;

// Path: model/attributes/sentry/sentry__sdk__name.json

/**
 * The sentry sdk name. `sentry.sdk.name`
 *
 * Attribute Value Type: `string` {@link SENTRY_SDK_NAME_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "@sentry/react"
 */
export const SENTRY_SDK_NAME = 'sentry.sdk.name';

/**
 * Type for {@link SENTRY_SDK_NAME} sentry.sdk.name
 */
export type SENTRY_SDK_NAME_TYPE = string;

// Path: model/attributes/sentry/sentry__sdk__version.json

/**
 * The sentry sdk version. `sentry.sdk.version`
 *
 * Attribute Value Type: `string` {@link SENTRY_SDK_VERSION_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "7.0.0"
 */
export const SENTRY_SDK_VERSION = 'sentry.sdk.version';

/**
 * Type for {@link SENTRY_SDK_VERSION} sentry.sdk.version
 */
export type SENTRY_SDK_VERSION_TYPE = string;

// Path: model/attributes/sentry/sentry__segment__id.json

/**
 * The segment ID of a span `sentry.segment.id`
 *
 * Attribute Value Type: `string` {@link SENTRY_SEGMENT_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link _SENTRY_SEGMENT_ID} `sentry.segment_id`
 *
 * @example "051581bf3cb55c13"
 */
export const SENTRY_SEGMENT_ID = 'sentry.segment.id';

/**
 * Type for {@link SENTRY_SEGMENT_ID} sentry.segment.id
 */
export type SENTRY_SEGMENT_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__segment_id.json

/**
 * The segment ID of a span `sentry.segment_id`
 *
 * Attribute Value Type: `string` {@link _SENTRY_SEGMENT_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_SEGMENT_ID} `sentry.segment.id`
 *
 * @deprecated Use {@link SENTRY_SEGMENT_ID} (sentry.segment.id) instead
 * @example "051581bf3cb55c13"
 */
export const _SENTRY_SEGMENT_ID = 'sentry.segment_id';

/**
 * Type for {@link _SENTRY_SEGMENT_ID} sentry.segment_id
 */
export type _SENTRY_SEGMENT_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__segment__name.json

/**
 * The segment name of a span `sentry.segment.name`
 *
 * Attribute Value Type: `string` {@link SENTRY_SEGMENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_TRANSACTION} `sentry.transaction`, {@link TRANSACTION} `transaction`
 *
 * @example "GET /user"
 */
export const SENTRY_SEGMENT_NAME = 'sentry.segment.name';

/**
 * Type for {@link SENTRY_SEGMENT_NAME} sentry.segment.name
 */
export type SENTRY_SEGMENT_NAME_TYPE = string;

// Path: model/attributes/sentry/sentry__segment__name__source.json

/**
 * The source of the segment span name. Should only be set on segment spans. `sentry.segment.name.source`
 *
 * Attribute Value Type: `string` {@link SENTRY_SEGMENT_NAME_SOURCE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: internal
 *
 * Well-defined Values:
 * - `custom` - Describes a name set by the user, not derived from the URL or a route pattern
 * - `url` - Describes the full URL, potentially containing identifiers
 * - `route` - Describes a parametrized route
 * - `component`
 * - `view`
 * - `task`
 *
 * @example "route"
 * @example "component"
 * @example "view"
 * @example "task"
 * @example "custom"
 * @example "url"
 */
export const SENTRY_SEGMENT_NAME_SOURCE = 'sentry.segment.name.source';

/**
 * Type for {@link SENTRY_SEGMENT_NAME_SOURCE} sentry.segment.name.source
 */
export type SENTRY_SEGMENT_NAME_SOURCE_TYPE = string;

// Path: model/attributes/sentry/sentry__server_sample_rate.json

/**
 * Rate at which a span was sampled in Relay. `sentry.server_sample_rate`
 *
 * Attribute Value Type: `number` {@link SENTRY_SERVER_SAMPLE_RATE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0.5
 */
export const SENTRY_SERVER_SAMPLE_RATE = 'sentry.server_sample_rate';

/**
 * Type for {@link SENTRY_SERVER_SAMPLE_RATE} sentry.server_sample_rate
 */
export type SENTRY_SERVER_SAMPLE_RATE_TYPE = number;

// Path: model/attributes/sentry/sentry__source.json

/**
 * The source of a span, also referred to as transaction source. `sentry.source`
 *
 * Attribute Value Type: `string` {@link SENTRY_SOURCE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Well-defined Values:
 * - `custom`
 * - `url` - Describes the full URL, potentially containing identifiers
 * - `route` - Describes a parametrized route
 * - `component`
 * - `view`
 * - `task`
 *
 * @deprecated  - This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans.
 * @example "route"
 */
export const SENTRY_SOURCE = 'sentry.source';

/**
 * Type for {@link SENTRY_SOURCE} sentry.source
 */
export type SENTRY_SOURCE_TYPE = string;

// Path: model/attributes/sentry/sentry__span__source.json

/**
 * The source of a span, also referred to as transaction source. `sentry.span.source`
 *
 * Attribute Value Type: `string` {@link SENTRY_SPAN_SOURCE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Well-defined Values:
 * - `custom`
 * - `url` - Describes the full URL, potentially containing identifiers
 * - `route` - Describes a parametrized route
 * - `component`
 * - `view`
 * - `task`
 *
 * @deprecated  - This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans.
 * @example "route"
 */
export const SENTRY_SPAN_SOURCE = 'sentry.span.source';

/**
 * Type for {@link SENTRY_SPAN_SOURCE} sentry.span.source
 */
export type SENTRY_SPAN_SOURCE_TYPE = string;

// Path: model/attributes/sentry/sentry__status.json

/**
 * The span's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated. `sentry.status`
 *
 * Attribute Value Type: `string` {@link SENTRY_STATUS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "ok"
 */
export const SENTRY_STATUS = 'sentry.status';

/**
 * Type for {@link SENTRY_STATUS} sentry.status
 */
export type SENTRY_STATUS_TYPE = string;

// Path: model/attributes/sentry/sentry__status_code.json

/**
 * The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients. `sentry.status_code`
 *
 * Attribute Value Type: `number` {@link SENTRY_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 200
 */
export const SENTRY_STATUS_CODE = 'sentry.status_code';

/**
 * Type for {@link SENTRY_STATUS_CODE} sentry.status_code
 */
export type SENTRY_STATUS_CODE_TYPE = number;

// Path: model/attributes/sentry/sentry__status__message.json

/**
 * The from OTLP extracted status message. `sentry.status.message`
 *
 * Attribute Value Type: `string` {@link SENTRY_STATUS_MESSAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "foobar"
 */
export const SENTRY_STATUS_MESSAGE = 'sentry.status.message';

/**
 * Type for {@link SENTRY_STATUS_MESSAGE} sentry.status.message
 */
export type SENTRY_STATUS_MESSAGE_TYPE = string;

// Path: model/attributes/sentry/sentry__sveltekit__navigation__from.json

/**
 * the navigation origin (sveltekit router) `sentry.sveltekit.navigation.from`
 *
 * Attribute Value Type: `string` {@link SENTRY_SVELTEKIT_NAVIGATION_FROM_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NAVIGATION_ORIGIN} `navigation.origin`, {@link ROUTER_NAVIGATION_ORIGIN} `router.navigation.origin`
 *
 * @deprecated Use {@link ROUTER_NAVIGATION_ORIGIN} (router.navigation.origin) instead - Use the more generic attribute instead
 * @example "/home"
 */
export const SENTRY_SVELTEKIT_NAVIGATION_FROM = 'sentry.sveltekit.navigation.from';

/**
 * Type for {@link SENTRY_SVELTEKIT_NAVIGATION_FROM} sentry.sveltekit.navigation.from
 */
export type SENTRY_SVELTEKIT_NAVIGATION_FROM_TYPE = string;

// Path: model/attributes/sentry/sentry__sveltekit__navigation__to.json

/**
 * the navigation destination `sentry.sveltekit.navigation.to`
 *
 * Attribute Value Type: `string` {@link SENTRY_SVELTEKIT_NAVIGATION_TO_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated  - the navigation destination is already covered by url.* attributes
 * @example "/users/:id"
 */
export const SENTRY_SVELTEKIT_NAVIGATION_TO = 'sentry.sveltekit.navigation.to';

/**
 * Type for {@link SENTRY_SVELTEKIT_NAVIGATION_TO} sentry.sveltekit.navigation.to
 */
export type SENTRY_SVELTEKIT_NAVIGATION_TO_TYPE = string;

// Path: model/attributes/sentry/sentry__sveltekit__navigation__type.json

/**
 * The type of navigation event emitted from the sveltekit client router `sentry.sveltekit.navigation.type`
 *
 * Attribute Value Type: `string` {@link SENTRY_SVELTEKIT_NAVIGATION_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link NAVIGATION_TYPE} `navigation.type`, {@link ROUTER_NAVIGATION_TYPE} `router.navigation.type`
 *
 * @deprecated Use {@link ROUTER_NAVIGATION_TYPE} (router.navigation.type) instead - Use the more generic attribute instead
 * @example "link"
 */
export const SENTRY_SVELTEKIT_NAVIGATION_TYPE = 'sentry.sveltekit.navigation.type';

/**
 * Type for {@link SENTRY_SVELTEKIT_NAVIGATION_TYPE} sentry.sveltekit.navigation.type
 */
export type SENTRY_SVELTEKIT_NAVIGATION_TYPE_TYPE = string;

// Path: model/attributes/sentry/sentry__thread__id.json

/**
 * Current "managed" thread ID. `sentry.thread.id`
 *
 * Attribute Value Type: `number` {@link SENTRY_THREAD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated Use {@link THREAD_ID} (thread.id) instead - This attribute is being deprecated in favor of the OTel-standard thread.id
 * @example 56
 */
export const SENTRY_THREAD_ID = 'sentry.thread.id';

/**
 * Type for {@link SENTRY_THREAD_ID} sentry.thread.id
 */
export type SENTRY_THREAD_ID_TYPE = number;

// Path: model/attributes/sentry/sentry__timestamp__sequence.json

/**
 * A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one. `sentry.timestamp.sequence`
 *
 * Attribute Value Type: `number` {@link SENTRY_TIMESTAMP_SEQUENCE_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 0
 */
export const SENTRY_TIMESTAMP_SEQUENCE = 'sentry.timestamp.sequence';

/**
 * Type for {@link SENTRY_TIMESTAMP_SEQUENCE} sentry.timestamp.sequence
 */
export type SENTRY_TIMESTAMP_SEQUENCE_TYPE = number;

// Path: model/attributes/sentry/sentry__trace_lifecycle.json

/**
 * Indicates the chosen trace lifecycle mode of the SDK (stream or static) `sentry.trace_lifecycle`
 *
 * Attribute Value Type: `string` {@link SENTRY_TRACE_LIFECYCLE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "stream"
 */
export const SENTRY_TRACE_LIFECYCLE = 'sentry.trace_lifecycle';

/**
 * Type for {@link SENTRY_TRACE_LIFECYCLE} sentry.trace_lifecycle
 */
export type SENTRY_TRACE_LIFECYCLE_TYPE = string;

// Path: model/attributes/sentry/sentry__trace__parent_span_id.json

/**
 * The span id of the span that was active when the log was collected. This should not be set if there was no active span. `sentry.trace.parent_span_id`
 *
 * Attribute Value Type: `string` {@link SENTRY_TRACE_PARENT_SPAN_ID_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @deprecated
 * @example "b0e6f15b45c36b12"
 */
export const SENTRY_TRACE_PARENT_SPAN_ID = 'sentry.trace.parent_span_id';

/**
 * Type for {@link SENTRY_TRACE_PARENT_SPAN_ID} sentry.trace.parent_span_id
 */
export type SENTRY_TRACE_PARENT_SPAN_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__trace__status.json

/**
 * The segment's status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated. `sentry.trace.status`
 *
 * Attribute Value Type: `string` {@link SENTRY_TRACE_STATUS_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "ok"
 */
export const SENTRY_TRACE_STATUS = 'sentry.trace.status';

/**
 * Type for {@link SENTRY_TRACE_STATUS} sentry.trace.status
 */
export type SENTRY_TRACE_STATUS_TYPE = string;

// Path: model/attributes/sentry/sentry__transaction.json

/**
 * The sentry transaction (segment name). `sentry.transaction`
 *
 * Attribute Value Type: `string` {@link SENTRY_TRANSACTION_TYPE}
 *
 * Apply Scrubbing: never
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_SEGMENT_NAME} `sentry.segment.name`, {@link TRANSACTION} `transaction`
 *
 * @deprecated Use {@link SENTRY_SEGMENT_NAME} (sentry.segment.name) instead - This attribute is being deprecated in favor of sentry.segment.name
 * @example "GET /"
 */
export const SENTRY_TRANSACTION = 'sentry.transaction';

/**
 * Type for {@link SENTRY_TRANSACTION} sentry.transaction
 */
export type SENTRY_TRANSACTION_TYPE = string;

// Path: model/attributes/sentry/sentry__user__email.json

/**
 * User email address. `sentry.user.email`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_EMAIL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_EMAIL} `user.email`
 *
 * @deprecated Use {@link USER_EMAIL} (user.email) instead
 */
export const SENTRY_USER_EMAIL = 'sentry.user.email';

/**
 * Type for {@link SENTRY_USER_EMAIL} sentry.user.email
 */
export type SENTRY_USER_EMAIL_TYPE = string;

// Path: model/attributes/sentry/sentry__user__geo__city.json

/**
 * Human readable city name. `sentry.user.geo.city`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_GEO_CITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_GEO_CITY} `user.geo.city`
 *
 * @deprecated Use {@link USER_GEO_CITY} (user.geo.city) instead
 */
export const SENTRY_USER_GEO_CITY = 'sentry.user.geo.city';

/**
 * Type for {@link SENTRY_USER_GEO_CITY} sentry.user.geo.city
 */
export type SENTRY_USER_GEO_CITY_TYPE = string;

// Path: model/attributes/sentry/sentry__user__geo__country_code.json

/**
 * Two-letter country code (ISO 3166-1 alpha-2). `sentry.user.geo.country_code`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_GEO_COUNTRY_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_GEO_COUNTRY_CODE} `user.geo.country_code`
 *
 * @deprecated Use {@link USER_GEO_COUNTRY_CODE} (user.geo.country_code) instead
 */
export const SENTRY_USER_GEO_COUNTRY_CODE = 'sentry.user.geo.country_code';

/**
 * Type for {@link SENTRY_USER_GEO_COUNTRY_CODE} sentry.user.geo.country_code
 */
export type SENTRY_USER_GEO_COUNTRY_CODE_TYPE = string;

// Path: model/attributes/sentry/sentry__user__geo__region.json

/**
 * Human readable region name or code. `sentry.user.geo.region`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_GEO_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_GEO_REGION} `user.geo.region`
 *
 * @deprecated Use {@link USER_GEO_REGION} (user.geo.region) instead
 */
export const SENTRY_USER_GEO_REGION = 'sentry.user.geo.region';

/**
 * Type for {@link SENTRY_USER_GEO_REGION} sentry.user.geo.region
 */
export type SENTRY_USER_GEO_REGION_TYPE = string;

// Path: model/attributes/sentry/sentry__user__geo__subdivision.json

/**
 * Human readable subdivision name. `sentry.user.geo.subdivision`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_GEO_SUBDIVISION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_GEO_SUBDIVISION} `user.geo.subdivision`
 *
 * @deprecated Use {@link USER_GEO_SUBDIVISION} (user.geo.subdivision) instead
 */
export const SENTRY_USER_GEO_SUBDIVISION = 'sentry.user.geo.subdivision';

/**
 * Type for {@link SENTRY_USER_GEO_SUBDIVISION} sentry.user.geo.subdivision
 */
export type SENTRY_USER_GEO_SUBDIVISION_TYPE = string;

// Path: model/attributes/sentry/sentry__user__id.json

/**
 * Unique identifier of the user. `sentry.user.id`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_ID_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_ID} `user.id`
 *
 * @deprecated Use {@link USER_ID} (user.id) instead
 */
export const SENTRY_USER_ID = 'sentry.user.id';

/**
 * Type for {@link SENTRY_USER_ID} sentry.user.id
 */
export type SENTRY_USER_ID_TYPE = string;

// Path: model/attributes/sentry/sentry__user__ip.json

/**
 * The IP address of the user. `sentry.user.ip`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_IP_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_IP_ADDRESS} `user.ip_address`
 *
 * @deprecated Use {@link USER_IP_ADDRESS} (user.ip_address) instead
 */
export const SENTRY_USER_IP = 'sentry.user.ip';

/**
 * Type for {@link SENTRY_USER_IP} sentry.user.ip
 */
export type SENTRY_USER_IP_TYPE = string;

// Path: model/attributes/sentry/sentry__user__username.json

/**
 * Short name or login/username of the user. `sentry.user.username`
 *
 * Attribute Value Type: `string` {@link SENTRY_USER_USERNAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link USER_NAME} `user.name`
 *
 * @deprecated Use {@link USER_NAME} (user.name) instead
 */
export const SENTRY_USER_USERNAME = 'sentry.user.username';

/**
 * Type for {@link SENTRY_USER_USERNAME} sentry.user.username
 */
export type SENTRY_USER_USERNAME_TYPE = string;

// Path: model/attributes/server/server__address.json

/**
 * Preferably the server domain name if available without reverse DNS lookup, or an IP address or Unix domain socket name. For compatibility, it may contain what the hostname command returns on UNIX systems, the fully qualified hostname, or another name specified by the user. `server.address`
 *
 * Attribute Value Type: `string` {@link SERVER_ADDRESS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link NET_HOST_NAME} `net.host.name`, {@link HTTP_HOST} `http.host`, {@link SERVER_NAME} `server_name`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @example "example.com"
 */
export const SERVER_ADDRESS = 'server.address';

/**
 * Type for {@link SERVER_ADDRESS} server.address
 */
export type SERVER_ADDRESS_TYPE = string;

// Path: model/attributes/server_name.json

/**
 * The name of the device. On servers and desktops, this is typically the hostname. `server_name`
 *
 * Attribute Value Type: `string` {@link SERVER_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link ADDRESS} `address`, {@link SERVER_ADDRESS} `server.address`, {@link HTTP_SERVER_NAME} `http.server_name`, {@link NET_HOST_NAME} `net.host.name`, {@link HTTP_HOST} `http.host`, {@link NET_PEER_NAME} `net.peer.name`
 *
 * @deprecated Use {@link SERVER_ADDRESS} (server.address) instead - This attribute is being deprecated in favor of server.address.
 * @example "example.com"
 */
export const SERVER_NAME = 'server_name';

/**
 * Type for {@link SERVER_NAME} server_name
 */
export type SERVER_NAME_TYPE = string;

// Path: model/attributes/server/server__port.json

/**
 * Server port number. `server.port`
 *
 * Attribute Value Type: `number` {@link SERVER_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link NET_HOST_PORT} `net.host.port`, {@link PORT} `port`
 *
 * @example 1337
 */
export const SERVER_PORT = 'server.port';

/**
 * Type for {@link SERVER_PORT} server.port
 */
export type SERVER_PORT_TYPE = number;

// Path: model/attributes/service/service__name.json

/**
 * Logical name of the service. `service.name`
 *
 * Attribute Value Type: `string` {@link SERVICE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "omegastar"
 */
export const SERVICE_NAME = 'service.name';

/**
 * Type for {@link SERVICE_NAME} service.name
 */
export type SERVICE_NAME_TYPE = string;

// Path: model/attributes/service/service__version.json

/**
 * The version string of the service API or implementation. The format is not defined by these conventions. `service.version`
 *
 * Attribute Value Type: `string` {@link SERVICE_VERSION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SENTRY_RELEASE} `sentry.release`
 *
 * @example "5.0.0"
 */
export const SERVICE_VERSION = 'service.version';

/**
 * Type for {@link SERVICE_VERSION} service.version
 */
export type SERVICE_VERSION_TYPE = string;

// Path: model/attributes/session/session__id.json

/**
 * A unique id identifying the active session at the time of setting this attribute `session.id`
 *
 * Attribute Value Type: `string` {@link SESSION_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "00112233-4455-6677-8899-aabbccddeeff"
 */
export const SESSION_ID = 'session.id';

/**
 * Type for {@link SESSION_ID} session.id
 */
export type SESSION_ID_TYPE = string;

// Path: model/attributes/stall_percentage.json

/**
 * The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay. `stall_percentage`
 *
 * Attribute Value Type: `number` {@link STALL_PERCENTAGE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_STALL_PERCENTAGE} `app.vitals.stall.percentage`
 *
 * @deprecated Use {@link APP_VITALS_STALL_PERCENTAGE} (app.vitals.stall.percentage) instead - Replaced by app.vitals.stall.percentage to align with the app.vitals.* namespace for mobile performance attributes
 */
export const STALL_PERCENTAGE = 'stall_percentage';

/**
 * Type for {@link STALL_PERCENTAGE} stall_percentage
 */
export type STALL_PERCENTAGE_TYPE = number;

// Path: model/attributes/stall_total_time.json

/**
 * The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay. `stall_total_time`
 *
 * Attribute Value Type: `number` {@link STALL_TOTAL_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_STALL_DURATION} `app.vitals.stall.duration`
 *
 * @deprecated Use {@link APP_VITALS_STALL_DURATION} (app.vitals.stall.duration) instead - Replaced by app.vitals.stall.duration to align with the app.vitals.* namespace for mobile performance attributes
 */
export const STALL_TOTAL_TIME = 'stall_total_time';

/**
 * Type for {@link STALL_TOTAL_TIME} stall_total_time
 */
export type STALL_TOTAL_TIME_TYPE = number;

// Path: model/attributes/starlette/starlette__middleware_name.json

/**
 * The name of the Starlette middleware. `starlette.middleware_name`
 *
 * Attribute Value Type: `string` {@link STARLETTE_MIDDLEWARE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MIDDLEWARE_NAME} `middleware.name`
 *
 * @deprecated Use {@link MIDDLEWARE_NAME} (middleware.name) instead - This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.
 * @example "AuthenticationMiddleware"
 */
export const STARLETTE_MIDDLEWARE_NAME = 'starlette.middleware_name';

/**
 * Type for {@link STARLETTE_MIDDLEWARE_NAME} starlette.middleware_name
 */
export type STARLETTE_MIDDLEWARE_NAME_TYPE = string;

// Path: model/attributes/starlite/starlite__middleware_name.json

/**
 * The name of the Starlite middleware. `starlite.middleware_name`
 *
 * Attribute Value Type: `string` {@link STARLITE_MIDDLEWARE_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link MIDDLEWARE_NAME} `middleware.name`
 *
 * @deprecated Use {@link MIDDLEWARE_NAME} (middleware.name) instead - This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.
 * @example "AuthenticationMiddleware"
 */
export const STARLITE_MIDDLEWARE_NAME = 'starlite.middleware_name';

/**
 * Type for {@link STARLITE_MIDDLEWARE_NAME} starlite.middleware_name
 */
export type STARLITE_MIDDLEWARE_NAME_TYPE = string;

// Path: model/attributes/state/state__type.json

/**
 * The type of state management library `state.type`
 *
 * Attribute Value Type: `string` {@link STATE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "redux"
 */
export const STATE_TYPE = 'state.type';

/**
 * Type for {@link STATE_TYPE} state.type
 */
export type STATE_TYPE_TYPE = string;

// Path: model/attributes/subprocess/subprocess__pid.json

/**
 * The process ID of a subprocess. `subprocess.pid`
 *
 * Attribute Value Type: `number` {@link SUBPROCESS_PID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link PROCESS_PID} `process.pid`
 *
 * @deprecated Use {@link PROCESS_PID} (process.pid) instead - This attribute is being deprecated in favor of process.pid, which is the OTel-aligned replacement.
 * @example 12345
 */
export const SUBPROCESS_PID = 'subprocess.pid';

/**
 * Type for {@link SUBPROCESS_PID} subprocess.pid
 */
export type SUBPROCESS_PID_TYPE = number;

// Path: model/attributes/sveltekit/sveltekit__load__environment.json

/**
 * The runtime environment in which the SvelteKit load function was executed. Known values are `'server'` and `'client'`. `sveltekit.load.environment`
 *
 * Attribute Value Type: `string` {@link SVELTEKIT_LOAD_ENVIRONMENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "server"
 * @example "client"
 */
export const SVELTEKIT_LOAD_ENVIRONMENT = 'sveltekit.load.environment';

/**
 * Type for {@link SVELTEKIT_LOAD_ENVIRONMENT} sveltekit.load.environment
 */
export type SVELTEKIT_LOAD_ENVIRONMENT_TYPE = string;

// Path: model/attributes/sveltekit/sveltekit__load__node_id.json

/**
 * The path to the SvelteKit load function. `sveltekit.load.node_id`
 *
 * Attribute Value Type: `string` {@link SVELTEKIT_LOAD_NODE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link CODE_FILE_PATH} `code.file.path`, {@link CODE_FILEPATH} `code.filepath`
 *
 * @example "src/routes/users/:id/+page.server.ts"
 */
export const SVELTEKIT_LOAD_NODE_ID = 'sveltekit.load.node_id';

/**
 * Type for {@link SVELTEKIT_LOAD_NODE_ID} sveltekit.load.node_id
 */
export type SVELTEKIT_LOAD_NODE_ID_TYPE = string;

// Path: model/attributes/sveltekit/sveltekit__load__node_type.json

/**
 * The kind of SvelteKit load function that was executed, distinguishing page from layout and universal from server load functions. `sveltekit.load.node_type`
 *
 * Attribute Value Type: `string` {@link SVELTEKIT_LOAD_NODE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "+page.server"
 * @example "+layout"
 * @example "+layout.server"
 */
export const SVELTEKIT_LOAD_NODE_TYPE = 'sveltekit.load.node_type';

/**
 * Type for {@link SVELTEKIT_LOAD_NODE_TYPE} sveltekit.load.node_type
 */
export type SVELTEKIT_LOAD_NODE_TYPE_TYPE = string;

// Path: model/attributes/sveltekit/sveltekit__tracing__original_name.json

/**
 * The original span name as emitted by SvelteKit. `sveltekit.tracing.original_name`
 *
 * Attribute Value Type: `string` {@link SVELTEKIT_TRACING_ORIGINAL_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sveltekit.handle.root"
 */
export const SVELTEKIT_TRACING_ORIGINAL_NAME = 'sveltekit.tracing.original_name';

/**
 * Type for {@link SVELTEKIT_TRACING_ORIGINAL_NAME} sveltekit.tracing.original_name
 */
export type SVELTEKIT_TRACING_ORIGINAL_NAME_TYPE = string;

// Path: model/attributes/thread/thread__id.json

/**
 * Current “managed” thread ID. `thread.id`
 *
 * Attribute Value Type: `number` {@link THREAD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 56
 */
export const THREAD_ID = 'thread.id';

/**
 * Type for {@link THREAD_ID} thread.id
 */
export type THREAD_ID_TYPE = number;

// Path: model/attributes/thread/thread__name.json

/**
 * Current thread name. `thread.name`
 *
 * Attribute Value Type: `string` {@link THREAD_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "main"
 */
export const THREAD_NAME = 'thread.name';

/**
 * Type for {@link THREAD_NAME} thread.name
 */
export type THREAD_NAME_TYPE = string;

// Path: model/attributes/timber/timber__tag.json

/**
 * The log tag provided by the timber logging framework. `timber.tag`
 *
 * Attribute Value Type: `string` {@link TIMBER_TAG_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "MyTag"
 */
export const TIMBER_TAG = 'timber.tag';

/**
 * Type for {@link TIMBER_TAG} timber.tag
 */
export type TIMBER_TAG_TYPE = string;

// Path: model/attributes/time_to_full_display.json

/**
 * The duration of time to full display in milliseconds `time_to_full_display`
 *
 * Attribute Value Type: `number` {@link TIME_TO_FULL_DISPLAY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_TTFD_VALUE} `app.vitals.ttfd.value`
 *
 * @deprecated Use {@link APP_VITALS_TTFD_VALUE} (app.vitals.ttfd.value) instead - Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1234.56
 */
export const TIME_TO_FULL_DISPLAY = 'time_to_full_display';

/**
 * Type for {@link TIME_TO_FULL_DISPLAY} time_to_full_display
 */
export type TIME_TO_FULL_DISPLAY_TYPE = number;

// Path: model/attributes/time_to_initial_display.json

/**
 * The duration of time to initial display in milliseconds `time_to_initial_display`
 *
 * Attribute Value Type: `number` {@link TIME_TO_INITIAL_DISPLAY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link APP_VITALS_TTID_VALUE} `app.vitals.ttid.value`
 *
 * @deprecated Use {@link APP_VITALS_TTID_VALUE} (app.vitals.ttid.value) instead - Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes
 * @example 1234.56
 */
export const TIME_TO_INITIAL_DISPLAY = 'time_to_initial_display';

/**
 * Type for {@link TIME_TO_INITIAL_DISPLAY} time_to_initial_display
 */
export type TIME_TO_INITIAL_DISPLAY_TYPE = number;

// Path: model/attributes/transaction.json

/**
 * The sentry transaction (segment name). `transaction`
 *
 * Attribute Value Type: `string` {@link TRANSACTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_SEGMENT_NAME} `sentry.segment.name`, {@link SENTRY_TRANSACTION} `sentry.transaction`
 *
 * @deprecated Use {@link SENTRY_SEGMENT_NAME} (sentry.segment.name) instead
 * @example "GET /"
 */
export const TRANSACTION = 'transaction';

/**
 * Type for {@link TRANSACTION} transaction
 */
export type TRANSACTION_TYPE = string;

// Path: model/attributes/trpc/trpc__procedure_path.json

/**
 * The path of the tRPC procedure being called `trpc.procedure_path`
 *
 * Attribute Value Type: `string` {@link TRPC_PROCEDURE_PATH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "user.getById"
 */
export const TRPC_PROCEDURE_PATH = 'trpc.procedure_path';

/**
 * Type for {@link TRPC_PROCEDURE_PATH} trpc.procedure_path
 */
export type TRPC_PROCEDURE_PATH_TYPE = string;

// Path: model/attributes/trpc/trpc__procedure_type.json

/**
 * The type of the tRPC procedure `trpc.procedure_type`
 *
 * Attribute Value Type: `string` {@link TRPC_PROCEDURE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "query"
 */
export const TRPC_PROCEDURE_TYPE = 'trpc.procedure_type';

/**
 * Type for {@link TRPC_PROCEDURE_TYPE} trpc.procedure_type
 */
export type TRPC_PROCEDURE_TYPE_TYPE = string;

// Path: model/attributes/ttfb.json

/**
 * The value of the recorded Time To First Byte (TTFB) web vital in milliseconds `ttfb`
 *
 * Attribute Value Type: `number` {@link TTFB_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_TTFB_VALUE} `browser.web_vital.ttfb.value`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_TTFB_VALUE} (browser.web_vital.ttfb.value) instead - This attribute is being deprecated in favor of browser.web_vital.ttfb.value
 * @example 194
 */
export const TTFB = 'ttfb';

/**
 * Type for {@link TTFB} ttfb
 */
export type TTFB_TYPE = number;

// Path: model/attributes/ttfb/ttfb__requestTime.json

/**
 * The time it takes for the server to process the initial request and send the first byte of a response to the user's browser `ttfb.requestTime`
 *
 * Attribute Value Type: `number` {@link TTFB_REQUESTTIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link BROWSER_WEB_VITAL_TTFB_REQUEST_TIME} `browser.web_vital.ttfb.request_time`
 *
 * @deprecated Use {@link BROWSER_WEB_VITAL_TTFB_REQUEST_TIME} (browser.web_vital.ttfb.request_time) instead - This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time
 * @example 1554.5814
 */
export const TTFB_REQUESTTIME = 'ttfb.requestTime';

/**
 * Type for {@link TTFB_REQUESTTIME} ttfb.requestTime
 */
export type TTFB_REQUESTTIME_TYPE = number;

// Path: model/attributes/turbo_modules/turbo_modules__total_call_count.json

/**
 * The number of native module calls in the flushed call aggregate. Only applies to React Native. `turbo_modules.total_call_count`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULES_TOTAL_CALL_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_CALL_COUNT} `react_native.module.call.count`, {@link TURBO_MODULE_TOTAL_CALL_COUNT} `turbo_module.total_call_count`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_CALL_COUNT} (react_native.module.call.count) instead - Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix
 * @example 42
 */
export const TURBO_MODULES_TOTAL_CALL_COUNT = 'turbo_modules.total_call_count';

/**
 * Type for {@link TURBO_MODULES_TOTAL_CALL_COUNT} turbo_modules.total_call_count
 */
export type TURBO_MODULES_TOTAL_CALL_COUNT_TYPE = number;

// Path: model/attributes/turbo_modules/turbo_modules__total_duration_ms.json

/**
 * The combined duration of all native module calls in the flushed call aggregate, in milliseconds. Only applies to React Native. `turbo_modules.total_duration_ms`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULES_TOTAL_DURATION_MS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_DURATION_TOTAL} `react_native.module.duration.total`, {@link TURBO_MODULE_TOTAL_DURATION_MS} `turbo_module.total_duration_ms`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_DURATION_TOTAL} (react_native.module.duration.total) instead - Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix
 * @example 128.45
 */
export const TURBO_MODULES_TOTAL_DURATION_MS = 'turbo_modules.total_duration_ms';

/**
 * Type for {@link TURBO_MODULES_TOTAL_DURATION_MS} turbo_modules.total_duration_ms
 */
export type TURBO_MODULES_TOTAL_DURATION_MS_TYPE = number;

// Path: model/attributes/turbo_modules/turbo_modules__total_error_count.json

/**
 * The number of failed native module calls in the flushed call aggregate. Only applies to React Native. `turbo_modules.total_error_count`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULES_TOTAL_ERROR_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_ERROR_COUNT} `react_native.module.error.count`, {@link TURBO_MODULE_TOTAL_ERROR_COUNT} `turbo_module.total_error_count`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_ERROR_COUNT} (react_native.module.error.count) instead - Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix
 * @example 2
 */
export const TURBO_MODULES_TOTAL_ERROR_COUNT = 'turbo_modules.total_error_count';

/**
 * Type for {@link TURBO_MODULES_TOTAL_ERROR_COUNT} turbo_modules.total_error_count
 */
export type TURBO_MODULES_TOTAL_ERROR_COUNT_TYPE = number;

// Path: model/attributes/turbo_modules/turbo_modules__unique_methods.json

/**
 * The number of distinct native module and method pairs in the flushed call aggregate. Only applies to React Native. `turbo_modules.unique_methods`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULES_UNIQUE_METHODS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT} `react_native.module.call.distinct_count`, {@link TURBO_MODULE_UNIQUE_METHODS} `turbo_module.unique_methods`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT} (react_native.module.call.distinct_count) instead - Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix
 * @example 7
 */
export const TURBO_MODULES_UNIQUE_METHODS = 'turbo_modules.unique_methods';

/**
 * Type for {@link TURBO_MODULES_UNIQUE_METHODS} turbo_modules.unique_methods
 */
export type TURBO_MODULES_UNIQUE_METHODS_TYPE = number;

// Path: model/attributes/turbo_module/turbo_module__arch.json

/**
 * The React Native architecture the call was observed on. `new` for a TurboModule resolved through `TurboModuleRegistry`, `legacy` for a module reached over the Old Architecture bridge. Only applies to React Native. `turbo_module.arch`
 *
 * Attribute Value Type: `string` {@link TURBO_MODULE_ARCH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_ARCHITECTURE} `react_native.architecture`
 *
 * @deprecated Use {@link REACT_NATIVE_ARCHITECTURE} (react_native.architecture) instead - Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules
 * @example "new"
 * @example "legacy"
 */
export const TURBO_MODULE_ARCH = 'turbo_module.arch';

/**
 * Type for {@link TURBO_MODULE_ARCH} turbo_module.arch
 */
export type TURBO_MODULE_ARCH_TYPE = string;

// Path: model/attributes/turbo_module/turbo_module__method.json

/**
 * The name of the native module method that was called. Only applies to React Native. `turbo_module.method`
 *
 * Attribute Value Type: `string` {@link TURBO_MODULE_METHOD_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_METHOD} `react_native.module.method`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_METHOD} (react_native.module.method) instead - Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules
 * @example "getUniqueId"
 */
export const TURBO_MODULE_METHOD = 'turbo_module.method';

/**
 * Type for {@link TURBO_MODULE_METHOD} turbo_module.method
 */
export type TURBO_MODULE_METHOD_TYPE = string;

// Path: model/attributes/turbo_module/turbo_module__name.json

/**
 * The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key. Only applies to React Native. `turbo_module.name`
 *
 * Attribute Value Type: `string` {@link TURBO_MODULE_NAME_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_NAME} `react_native.module.name`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_NAME} (react_native.module.name) instead - Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules
 * @example "RNDeviceInfo"
 */
export const TURBO_MODULE_NAME = 'turbo_module.name';

/**
 * Type for {@link TURBO_MODULE_NAME} turbo_module.name
 */
export type TURBO_MODULE_NAME_TYPE = string;

// Path: model/attributes/turbo_module/turbo_module__top_module.json

/**
 * The native module and method that accounted for the most total duration during the lifetime of the span. Only applies to React Native. `turbo_module.top_module`
 *
 * Attribute Value Type: `string` {@link TURBO_MODULE_TOP_MODULE_TYPE}
 *
 * Apply Scrubbing: manual - Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_TOP_NAME} `react_native.module.top.name`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_TOP_NAME} (react_native.module.top.name) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example "RNDeviceInfo.getUniqueId"
 */
export const TURBO_MODULE_TOP_MODULE = 'turbo_module.top_module';

/**
 * Type for {@link TURBO_MODULE_TOP_MODULE} turbo_module.top_module
 */
export type TURBO_MODULE_TOP_MODULE_TYPE = string;

// Path: model/attributes/turbo_module/turbo_module__top_module_duration_ms.json

/**
 * The total duration attributed to the top native module method, in milliseconds. Only applies to React Native. `turbo_module.top_module_duration_ms`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULE_TOP_MODULE_DURATION_MS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_TOP_DURATION} `react_native.module.top.duration`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_TOP_DURATION} (react_native.module.top.duration) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example 87.25
 */
export const TURBO_MODULE_TOP_MODULE_DURATION_MS = 'turbo_module.top_module_duration_ms';

/**
 * Type for {@link TURBO_MODULE_TOP_MODULE_DURATION_MS} turbo_module.top_module_duration_ms
 */
export type TURBO_MODULE_TOP_MODULE_DURATION_MS_TYPE = number;

// Path: model/attributes/turbo_module/turbo_module__total_call_count.json

/**
 * The number of native module calls observed during the lifetime of the span. Only applies to React Native. `turbo_module.total_call_count`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULE_TOTAL_CALL_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_CALL_COUNT} `react_native.module.call.count`, {@link TURBO_MODULES_TOTAL_CALL_COUNT} `turbo_modules.total_call_count`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_CALL_COUNT} (react_native.module.call.count) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example 42
 */
export const TURBO_MODULE_TOTAL_CALL_COUNT = 'turbo_module.total_call_count';

/**
 * Type for {@link TURBO_MODULE_TOTAL_CALL_COUNT} turbo_module.total_call_count
 */
export type TURBO_MODULE_TOTAL_CALL_COUNT_TYPE = number;

// Path: model/attributes/turbo_module/turbo_module__total_duration_ms.json

/**
 * The combined duration of all native module calls observed during the lifetime of the span, in milliseconds. Only applies to React Native. `turbo_module.total_duration_ms`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULE_TOTAL_DURATION_MS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_DURATION_TOTAL} `react_native.module.duration.total`, {@link TURBO_MODULES_TOTAL_DURATION_MS} `turbo_modules.total_duration_ms`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_DURATION_TOTAL} (react_native.module.duration.total) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example 128.45
 */
export const TURBO_MODULE_TOTAL_DURATION_MS = 'turbo_module.total_duration_ms';

/**
 * Type for {@link TURBO_MODULE_TOTAL_DURATION_MS} turbo_module.total_duration_ms
 */
export type TURBO_MODULE_TOTAL_DURATION_MS_TYPE = number;

// Path: model/attributes/turbo_module/turbo_module__total_error_count.json

/**
 * The number of native module calls that failed during the lifetime of the span. Only applies to React Native. `turbo_module.total_error_count`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULE_TOTAL_ERROR_COUNT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_ERROR_COUNT} `react_native.module.error.count`, {@link TURBO_MODULES_TOTAL_ERROR_COUNT} `turbo_modules.total_error_count`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_ERROR_COUNT} (react_native.module.error.count) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example 2
 */
export const TURBO_MODULE_TOTAL_ERROR_COUNT = 'turbo_module.total_error_count';

/**
 * Type for {@link TURBO_MODULE_TOTAL_ERROR_COUNT} turbo_module.total_error_count
 */
export type TURBO_MODULE_TOTAL_ERROR_COUNT_TYPE = number;

// Path: model/attributes/turbo_module/turbo_module__unique_methods.json

/**
 * The number of distinct native module and method pairs called during the lifetime of the span. Only applies to React Native. `turbo_module.unique_methods`
 *
 * Attribute Value Type: `number` {@link TURBO_MODULE_UNIQUE_METHODS_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT} `react_native.module.call.distinct_count`, {@link TURBO_MODULES_UNIQUE_METHODS} `turbo_modules.unique_methods`
 *
 * @deprecated Use {@link REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT} (react_native.module.call.distinct_count) instead - Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping
 * @example 7
 */
export const TURBO_MODULE_UNIQUE_METHODS = 'turbo_module.unique_methods';

/**
 * Type for {@link TURBO_MODULE_UNIQUE_METHODS} turbo_module.unique_methods
 */
export type TURBO_MODULE_UNIQUE_METHODS_TYPE = number;

// Path: model/attributes/type.json

/**
 * More granular type of the operation happening. `type`
 *
 * Attribute Value Type: `string` {@link TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "fetch"
 */
export const TYPE = 'type';

/**
 * Type for {@link TYPE} type
 */
export type TYPE_TYPE = string;

// Path: model/attributes/ui/ui__component_name.json

/**
 * The name of the associated component. `ui.component_name`
 *
 * Attribute Value Type: `string` {@link UI_COMPONENT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "HomeButton"
 */
export const UI_COMPONENT_NAME = 'ui.component_name';

/**
 * Type for {@link UI_COMPONENT_NAME} ui.component_name
 */
export type UI_COMPONENT_NAME_TYPE = string;

// Path: model/attributes/ui/ui__contributes_to_ttfd.json

/**
 * Whether the span execution contributed to the TTFD (time to fully drawn) metric. `ui.contributes_to_ttfd`
 *
 * Attribute Value Type: `boolean` {@link UI_CONTRIBUTES_TO_TTFD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const UI_CONTRIBUTES_TO_TTFD = 'ui.contributes_to_ttfd';

/**
 * Type for {@link UI_CONTRIBUTES_TO_TTFD} ui.contributes_to_ttfd
 */
export type UI_CONTRIBUTES_TO_TTFD_TYPE = boolean;

// Path: model/attributes/ui/ui__contributes_to_ttid.json

/**
 * Whether the span execution contributed to the TTID (time to initial display) metric. `ui.contributes_to_ttid`
 *
 * Attribute Value Type: `boolean` {@link UI_CONTRIBUTES_TO_TTID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example true
 */
export const UI_CONTRIBUTES_TO_TTID = 'ui.contributes_to_ttid';

/**
 * Type for {@link UI_CONTRIBUTES_TO_TTID} ui.contributes_to_ttid
 */
export type UI_CONTRIBUTES_TO_TTID_TYPE = boolean;

// Path: model/attributes/ui/ui__element__height.json

/**
 * The height of the UI element (for Html in pixels) `ui.element.height`
 *
 * Attribute Value Type: `number` {@link UI_ELEMENT_HEIGHT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 256
 */
export const UI_ELEMENT_HEIGHT = 'ui.element.height';

/**
 * Type for {@link UI_ELEMENT_HEIGHT} ui.element.height
 */
export type UI_ELEMENT_HEIGHT_TYPE = number;

// Path: model/attributes/ui/ui__element__id.json

/**
 * The id of the UI element `ui.element.id`
 *
 * Attribute Value Type: `string` {@link UI_ELEMENT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "btn-login"
 */
export const UI_ELEMENT_ID = 'ui.element.id';

/**
 * Type for {@link UI_ELEMENT_ID} ui.element.id
 */
export type UI_ELEMENT_ID_TYPE = string;

// Path: model/attributes/ui/ui__element__identifier.json

/**
 * The identifier used to measure the UI element timing `ui.element.identifier`
 *
 * Attribute Value Type: `string` {@link UI_ELEMENT_IDENTIFIER_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "heroImage"
 */
export const UI_ELEMENT_IDENTIFIER = 'ui.element.identifier';

/**
 * Type for {@link UI_ELEMENT_IDENTIFIER} ui.element.identifier
 */
export type UI_ELEMENT_IDENTIFIER_TYPE = string;

// Path: model/attributes/ui/ui__element__load_time.json

/**
 * The loading time of a UI element (from time origin to finished loading) `ui.element.load_time`
 *
 * Attribute Value Type: `number` {@link UI_ELEMENT_LOAD_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 998.2234
 */
export const UI_ELEMENT_LOAD_TIME = 'ui.element.load_time';

/**
 * Type for {@link UI_ELEMENT_LOAD_TIME} ui.element.load_time
 */
export type UI_ELEMENT_LOAD_TIME_TYPE = number;

// Path: model/attributes/ui/ui__element__paint_type.json

/**
 * The type of element paint. Can either be 'image-paint' or 'text-paint' `ui.element.paint_type`
 *
 * Attribute Value Type: `string` {@link UI_ELEMENT_PAINT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "image-paint"
 */
export const UI_ELEMENT_PAINT_TYPE = 'ui.element.paint_type';

/**
 * Type for {@link UI_ELEMENT_PAINT_TYPE} ui.element.paint_type
 */
export type UI_ELEMENT_PAINT_TYPE_TYPE = string;

// Path: model/attributes/ui/ui__element__render_time.json

/**
 * The rendering time of the UI element (from time origin to finished rendering) `ui.element.render_time`
 *
 * Attribute Value Type: `number` {@link UI_ELEMENT_RENDER_TIME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1023.1124
 */
export const UI_ELEMENT_RENDER_TIME = 'ui.element.render_time';

/**
 * Type for {@link UI_ELEMENT_RENDER_TIME} ui.element.render_time
 */
export type UI_ELEMENT_RENDER_TIME_TYPE = number;

// Path: model/attributes/ui/ui__element__type.json

/**
 * type of the UI element `ui.element.type`
 *
 * Attribute Value Type: `string` {@link UI_ELEMENT_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "img"
 */
export const UI_ELEMENT_TYPE = 'ui.element.type';

/**
 * Type for {@link UI_ELEMENT_TYPE} ui.element.type
 */
export type UI_ELEMENT_TYPE_TYPE = string;

// Path: model/attributes/ui/ui__element__url.json

/**
 * The URL of the UI element (e.g. an img src) `ui.element.url`
 *
 * Attribute Value Type: `string` {@link UI_ELEMENT_URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://assets.myapp.com/hero.png"
 */
export const UI_ELEMENT_URL = 'ui.element.url';

/**
 * Type for {@link UI_ELEMENT_URL} ui.element.url
 */
export type UI_ELEMENT_URL_TYPE = string;

// Path: model/attributes/ui/ui__element__width.json

/**
 * The width of the UI element (for HTML in pixels) `ui.element.width`
 *
 * Attribute Value Type: `number` {@link UI_ELEMENT_WIDTH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 512
 */
export const UI_ELEMENT_WIDTH = 'ui.element.width';

/**
 * Type for {@link UI_ELEMENT_WIDTH} ui.element.width
 */
export type UI_ELEMENT_WIDTH_TYPE = number;

// Path: model/attributes/url.json

/**
 * The URL of the resource that was fetched. `url`
 *
 * Attribute Value Type: `string` {@link URL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link URL_FULL} `url.full`, {@link HTTP_URL} `http.url`, {@link AWS_REQUEST_URL} `aws.request.url`, {@link MESSAGING_URL} `messaging.url`
 *
 * @deprecated Use {@link URL_FULL} (url.full) instead
 * @example "https://example.com/test?foo=bar#buzz"
 */
export const URL = 'url';

/**
 * Type for {@link URL} url
 */
export type URL_TYPE = string;

// Path: model/attributes/url/url__domain.json

/**
 * Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name. `url.domain`
 *
 * Attribute Value Type: `string` {@link URL_DOMAIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "example.com"
 */
export const URL_DOMAIN = 'url.domain';

/**
 * Type for {@link URL_DOMAIN} url.domain
 */
export type URL_DOMAIN_TYPE = string;

// Path: model/attributes/url/url__fragment.json

/**
 * The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does. `url.fragment`
 *
 * Attribute Value Type: `string` {@link URL_FRAGMENT_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "details"
 */
export const URL_FRAGMENT = 'url.fragment';

/**
 * Type for {@link URL_FRAGMENT} url.fragment
 */
export type URL_FRAGMENT_TYPE = string;

// Path: model/attributes/url/url__full.json

/**
 * The URL of the resource that was fetched. `url.full`
 *
 * Attribute Value Type: `string` {@link URL_FULL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_URL} `http.url`, {@link URL} `url`, {@link AWS_REQUEST_URL} `aws.request.url`, {@link MESSAGING_URL} `messaging.url`
 *
 * @example "https://example.com/test?foo=bar#buzz"
 */
export const URL_FULL = 'url.full';

/**
 * Type for {@link URL_FULL} url.full
 */
export type URL_FULL_TYPE = string;

// Path: model/attributes/url/url__path.json

/**
 * The URI path component. `url.path`
 *
 * Attribute Value Type: `string` {@link URL_PATH_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "/foo"
 */
export const URL_PATH = 'url.path';

/**
 * Type for {@link URL_PATH} url.path
 */
export type URL_PATH_TYPE = string;

// Path: model/attributes/url/url__path__parameter__[key].json

/**
 * Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router. `url.path.parameter.<key>`
 *
 * Attribute Value Type: `string` {@link URL_PATH_PARAMETER_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * Aliases: {@link PARAMS_KEY} `params.<key>`, {@link URL_PATH_PARAMS_KEY} `url.path.params.<key>`
 *
 * @example "url.path.parameter.id='123'"
 */
export const URL_PATH_PARAMETER_KEY = 'url.path.parameter.<key>';

/**
 * Base key for {@link URL_PATH_PARAMETER_KEY}. Use with a dynamic suffix, e.g. `${URL_PATH_PARAMETER_KEY_BASE}.${key}`.
 */
export const URL_PATH_PARAMETER_KEY_BASE = 'url.path.parameter';

/**
 * Type for {@link URL_PATH_PARAMETER_KEY} url.path.parameter.<key>
 */
export type URL_PATH_PARAMETER_KEY_TYPE = string;

// Path: model/attributes/url/url__path__params__[key].json

/**
 * Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router. `url.path.params.<key>`
 *
 * Attribute Value Type: `string` {@link URL_PATH_PARAMS_KEY_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * Aliases: {@link URL_PATH_PARAMETER_KEY} `url.path.parameter.<key>`, {@link PARAMS_KEY} `params.<key>`
 *
 * @deprecated Use {@link URL_PATH_PARAMETER_KEY} (url.path.parameter.<key>) instead - This attribute is being deprecated in favor of url.path.parameter.<key>.
 * @example "url.path.params.id='123'"
 */
export const URL_PATH_PARAMS_KEY = 'url.path.params.<key>';

/**
 * Base key for {@link URL_PATH_PARAMS_KEY}. Use with a dynamic suffix, e.g. `${URL_PATH_PARAMS_KEY_BASE}.${key}`.
 *
 * @deprecated Use {@link URL_PATH_PARAMETER_KEY_BASE} (url.path.parameter) instead - This attribute is being deprecated in favor of url.path.parameter.<key>.
 */
export const URL_PATH_PARAMS_KEY_BASE = 'url.path.params';

/**
 * Type for {@link URL_PATH_PARAMS_KEY} url.path.params.<key>
 */
export type URL_PATH_PARAMS_KEY_TYPE = string;

// Path: model/attributes/url/url__port.json

/**
 * Server port number. `url.port`
 *
 * Attribute Value Type: `number` {@link URL_PORT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example 1337
 */
export const URL_PORT = 'url.port';

/**
 * Type for {@link URL_PORT} url.port
 */
export type URL_PORT_TYPE = number;

// Path: model/attributes/url/url__query.json

/**
 * The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does. `url.query`
 *
 * Attribute Value Type: `string` {@link URL_QUERY_TYPE}
 *
 * Apply Scrubbing: auto - Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information.
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "foo=bar&bar=baz"
 */
export const URL_QUERY = 'url.query';

/**
 * Type for {@link URL_QUERY} url.query
 */
export type URL_QUERY_TYPE = string;

// Path: model/attributes/url/url__same_origin.json

/**
 * Indicates that a URL has the same origin as the current page's origin in the browser. `url.same_origin`
 *
 * Attribute Value Type: `boolean` {@link URL_SAME_ORIGIN_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link HTTP_REQUEST_SAME_ORIGIN} `http.request.same_origin`
 *
 * @deprecated Use {@link HTTP_REQUEST_SAME_ORIGIN} (http.request.same_origin) instead - This attribute is being deprecated in favor of http.request.same_origin.
 * @example true
 */
export const URL_SAME_ORIGIN = 'url.same_origin';

/**
 * Type for {@link URL_SAME_ORIGIN} url.same_origin
 */
export type URL_SAME_ORIGIN_TYPE = boolean;

// Path: model/attributes/url/url__scheme.json

/**
 * The URI scheme component identifying the used protocol. `url.scheme`
 *
 * Attribute Value Type: `string` {@link URL_SCHEME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_SCHEME} `http.scheme`
 *
 * @example "https"
 */
export const URL_SCHEME = 'url.scheme';

/**
 * Type for {@link URL_SCHEME} url.scheme
 */
export type URL_SCHEME_TYPE = string;

// Path: model/attributes/url/url__template.json

/**
 * The low-cardinality template of an absolute URL path reference. `url.template`
 *
 * Attribute Value Type: `string` {@link URL_TEMPLATE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "/users/{id}"
 * @example "/users/:id"
 * @example "/about"
 */
export const URL_TEMPLATE = 'url.template';

/**
 * Type for {@link URL_TEMPLATE} url.template
 */
export type URL_TEMPLATE_TYPE = string;

// Path: model/attributes/user_agent/user_agent__original.json

/**
 * Value of the HTTP User-Agent header sent by the client. `user_agent.original`
 *
 * Attribute Value Type: `string` {@link USER_AGENT_ORIGINAL_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link HTTP_USER_AGENT} `http.user_agent`
 *
 * @example "Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1"
 */
export const USER_AGENT_ORIGINAL = 'user_agent.original';

/**
 * Type for {@link USER_AGENT_ORIGINAL} user_agent.original
 */
export type USER_AGENT_ORIGINAL_TYPE = string;

// Path: model/attributes/user/user__email.json

/**
 * User email address. `user.email`
 *
 * Attribute Value Type: `string` {@link USER_EMAIL_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_EMAIL} `sentry.user.email`
 *
 * @example "test@example.com"
 */
export const USER_EMAIL = 'user.email';

/**
 * Type for {@link USER_EMAIL} user.email
 */
export type USER_EMAIL_TYPE = string;

// Path: model/attributes/user/user__full_name.json

/**
 * User's full name. `user.full_name`
 *
 * Attribute Value Type: `string` {@link USER_FULL_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "John Smith"
 */
export const USER_FULL_NAME = 'user.full_name';

/**
 * Type for {@link USER_FULL_NAME} user.full_name
 */
export type USER_FULL_NAME_TYPE = string;

// Path: model/attributes/user/user__geo__city.json

/**
 * Human readable city name. `user.geo.city`
 *
 * Attribute Value Type: `string` {@link USER_GEO_CITY_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_GEO_CITY} `sentry.user.geo.city`
 *
 * @example "Toronto"
 */
export const USER_GEO_CITY = 'user.geo.city';

/**
 * Type for {@link USER_GEO_CITY} user.geo.city
 */
export type USER_GEO_CITY_TYPE = string;

// Path: model/attributes/user/user__geo__country_code.json

/**
 * Two-letter country code (ISO 3166-1 alpha-2). `user.geo.country_code`
 *
 * Attribute Value Type: `string` {@link USER_GEO_COUNTRY_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_GEO_COUNTRY_CODE} `sentry.user.geo.country_code`
 *
 * @example "CA"
 */
export const USER_GEO_COUNTRY_CODE = 'user.geo.country_code';

/**
 * Type for {@link USER_GEO_COUNTRY_CODE} user.geo.country_code
 */
export type USER_GEO_COUNTRY_CODE_TYPE = string;

// Path: model/attributes/user/user__geo__region.json

/**
 * Human readable region name or code. `user.geo.region`
 *
 * Attribute Value Type: `string` {@link USER_GEO_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_GEO_REGION} `sentry.user.geo.region`
 *
 * @example "Canada"
 */
export const USER_GEO_REGION = 'user.geo.region';

/**
 * Type for {@link USER_GEO_REGION} user.geo.region
 */
export type USER_GEO_REGION_TYPE = string;

// Path: model/attributes/user/user__geo__subdivision.json

/**
 * Human readable subdivision name. `user.geo.subdivision`
 *
 * Attribute Value Type: `string` {@link USER_GEO_SUBDIVISION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_GEO_SUBDIVISION} `sentry.user.geo.subdivision`
 *
 * @example "Ontario"
 */
export const USER_GEO_SUBDIVISION = 'user.geo.subdivision';

/**
 * Type for {@link USER_GEO_SUBDIVISION} user.geo.subdivision
 */
export type USER_GEO_SUBDIVISION_TYPE = string;

// Path: model/attributes/user/user__hash.json

/**
 * Unique user hash to correlate information for a user in anonymized form. `user.hash`
 *
 * Attribute Value Type: `string` {@link USER_HASH_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example "8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d"
 */
export const USER_HASH = 'user.hash';

/**
 * Type for {@link USER_HASH} user.hash
 */
export type USER_HASH_TYPE = string;

// Path: model/attributes/user/user__id.json

/**
 * Unique identifier of the user. `user.id`
 *
 * Attribute Value Type: `string` {@link USER_ID_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_ID} `sentry.user.id`
 *
 * @example "S-1-5-21-202424912787-2692429404-2351956786-1000"
 */
export const USER_ID = 'user.id';

/**
 * Type for {@link USER_ID} user.id
 */
export type USER_ID_TYPE = string;

// Path: model/attributes/user/user__ip_address.json

/**
 * The IP address of the user. `user.ip_address`
 *
 * Attribute Value Type: `string` {@link USER_IP_ADDRESS_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_IP} `sentry.user.ip`
 *
 * @example "192.168.1.1"
 */
export const USER_IP_ADDRESS = 'user.ip_address';

/**
 * Type for {@link USER_IP_ADDRESS} user.ip_address
 */
export type USER_IP_ADDRESS_TYPE = string;

// Path: model/attributes/user/user__name.json

/**
 * Short name or login/username of the user. `user.name`
 *
 * Attribute Value Type: `string` {@link USER_NAME_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * Aliases: {@link SENTRY_USER_USERNAME} `sentry.user.username`
 *
 * @example "j.smith"
 */
export const USER_NAME = 'user.name';

/**
 * Type for {@link USER_NAME} user.name
 */
export type USER_NAME_TYPE = string;

// Path: model/attributes/user/user__roles.json

/**
 * Array of user roles at the time of the event. `user.roles`
 *
 * Attribute Value Type: `Array<string>` {@link USER_ROLES_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: Yes
 * Visibility: public
 *
 * @example ["admin","editor"]
 */
export const USER_ROLES = 'user.roles';

/**
 * Type for {@link USER_ROLES} user.roles
 */
export type USER_ROLES_TYPE = Array<string>;

// Path: model/attributes/vercel/vercel__ai__telemetry__metadata__[key].json

/**
 * Metadata passed to a Vercel AI SDK call through `experimental_telemetry.metadata`, with <key> being the metadata key name. `vercel.ai.telemetry.metadata.<key>`
 *
 * Attribute Value Type: `string` {@link VERCEL_AI_TELEMETRY_METADATA_KEY_TYPE}
 *
 * Apply Scrubbing: auto - Metadata is user-defined and can contain user data
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * Has Dynamic Suffix: true
 *
 * @example "vercel.ai.telemetry.metadata.tenantId='acme'"
 */
export const VERCEL_AI_TELEMETRY_METADATA_KEY = 'vercel.ai.telemetry.metadata.<key>';

/**
 * Base key for {@link VERCEL_AI_TELEMETRY_METADATA_KEY}. Use with a dynamic suffix, e.g. `${VERCEL_AI_TELEMETRY_METADATA_KEY_BASE}.${key}`.
 */
export const VERCEL_AI_TELEMETRY_METADATA_KEY_BASE = 'vercel.ai.telemetry.metadata';

/**
 * Type for {@link VERCEL_AI_TELEMETRY_METADATA_KEY} vercel.ai.telemetry.metadata.<key>
 */
export type VERCEL_AI_TELEMETRY_METADATA_KEY_TYPE = string;

// Path: model/attributes/vercel/vercel__branch.json

/**
 * Git branch name for Vercel project `vercel.branch`
 *
 * Attribute Value Type: `string` {@link VERCEL_BRANCH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "main"
 */
export const VERCEL_BRANCH = 'vercel.branch';

/**
 * Type for {@link VERCEL_BRANCH} vercel.branch
 */
export type VERCEL_BRANCH_TYPE = string;

// Path: model/attributes/vercel/vercel__build_id.json

/**
 * Identifier for the Vercel build (only present on build logs) `vercel.build_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_BUILD_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "bld_cotnkcr76"
 */
export const VERCEL_BUILD_ID = 'vercel.build_id';

/**
 * Type for {@link VERCEL_BUILD_ID} vercel.build_id
 */
export type VERCEL_BUILD_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__deployment_id.json

/**
 * Identifier for the Vercel deployment `vercel.deployment_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_DEPLOYMENT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "dpl_233NRGRjVZX1caZrXWtz5g1TAksD"
 */
export const VERCEL_DEPLOYMENT_ID = 'vercel.deployment_id';

/**
 * Type for {@link VERCEL_DEPLOYMENT_ID} vercel.deployment_id
 */
export type VERCEL_DEPLOYMENT_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__destination.json

/**
 * Origin of the external content in Vercel (only on external logs) `vercel.destination`
 *
 * Attribute Value Type: `string` {@link VERCEL_DESTINATION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https://vitals.vercel-insights.com/v1"
 */
export const VERCEL_DESTINATION = 'vercel.destination';

/**
 * Type for {@link VERCEL_DESTINATION} vercel.destination
 */
export type VERCEL_DESTINATION_TYPE = string;

// Path: model/attributes/vercel/vercel__edge_type.json

/**
 * Type of edge runtime in Vercel `vercel.edge_type`
 *
 * Attribute Value Type: `string` {@link VERCEL_EDGE_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "edge-function"
 */
export const VERCEL_EDGE_TYPE = 'vercel.edge_type';

/**
 * Type for {@link VERCEL_EDGE_TYPE} vercel.edge_type
 */
export type VERCEL_EDGE_TYPE_TYPE = string;

// Path: model/attributes/vercel/vercel__entrypoint.json

/**
 * Entrypoint for the request in Vercel `vercel.entrypoint`
 *
 * Attribute Value Type: `string` {@link VERCEL_ENTRYPOINT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "api/index.js"
 */
export const VERCEL_ENTRYPOINT = 'vercel.entrypoint';

/**
 * Type for {@link VERCEL_ENTRYPOINT} vercel.entrypoint
 */
export type VERCEL_ENTRYPOINT_TYPE = string;

// Path: model/attributes/vercel/vercel__execution_region.json

/**
 * Region where the request is executed `vercel.execution_region`
 *
 * Attribute Value Type: `string` {@link VERCEL_EXECUTION_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sfo1"
 */
export const VERCEL_EXECUTION_REGION = 'vercel.execution_region';

/**
 * Type for {@link VERCEL_EXECUTION_REGION} vercel.execution_region
 */
export type VERCEL_EXECUTION_REGION_TYPE = string;

// Path: model/attributes/vercel/vercel__id.json

/**
 * Unique identifier for the log entry in Vercel `vercel.id`
 *
 * Attribute Value Type: `string` {@link VERCEL_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "1573817187330377061717300000"
 */
export const VERCEL_ID = 'vercel.id';

/**
 * Type for {@link VERCEL_ID} vercel.id
 */
export type VERCEL_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__ja3_digest.json

/**
 * JA3 fingerprint digest of Vercel request `vercel.ja3_digest`
 *
 * Attribute Value Type: `string` {@link VERCEL_JA3_DIGEST_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0"
 */
export const VERCEL_JA3_DIGEST = 'vercel.ja3_digest';

/**
 * Type for {@link VERCEL_JA3_DIGEST} vercel.ja3_digest
 */
export type VERCEL_JA3_DIGEST_TYPE = string;

// Path: model/attributes/vercel/vercel__ja4_digest.json

/**
 * JA4 fingerprint digest `vercel.ja4_digest`
 *
 * Attribute Value Type: `string` {@link VERCEL_JA4_DIGEST_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "t13d1516h2_8daaf6152771_02713d6af862"
 */
export const VERCEL_JA4_DIGEST = 'vercel.ja4_digest';

/**
 * Type for {@link VERCEL_JA4_DIGEST} vercel.ja4_digest
 */
export type VERCEL_JA4_DIGEST_TYPE = string;

// Path: model/attributes/vercel/vercel__log_type.json

/**
 * Vercel log output type `vercel.log_type`
 *
 * Attribute Value Type: `string` {@link VERCEL_LOG_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "stdout"
 */
export const VERCEL_LOG_TYPE = 'vercel.log_type';

/**
 * Type for {@link VERCEL_LOG_TYPE} vercel.log_type
 */
export type VERCEL_LOG_TYPE_TYPE = string;

// Path: model/attributes/vercel/vercel__path.json

/**
 * Function or dynamic path of the request in Vercel. `vercel.path`
 *
 * Attribute Value Type: `string` {@link VERCEL_PATH_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "/dynamic/[route].json"
 */
export const VERCEL_PATH = 'vercel.path';

/**
 * Type for {@link VERCEL_PATH} vercel.path
 */
export type VERCEL_PATH_TYPE = string;

// Path: model/attributes/vercel/vercel__project_id.json

/**
 * Identifier for the Vercel project `vercel.project_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROJECT_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "gdufoJxB6b9b1fEqr1jUtFkyavUU"
 */
export const VERCEL_PROJECT_ID = 'vercel.project_id';

/**
 * Type for {@link VERCEL_PROJECT_ID} vercel.project_id
 */
export type VERCEL_PROJECT_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__project_name.json

/**
 * Name of the Vercel project `vercel.project_name`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROJECT_NAME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "my-app"
 */
export const VERCEL_PROJECT_NAME = 'vercel.project_name';

/**
 * Type for {@link VERCEL_PROJECT_NAME} vercel.project_name
 */
export type VERCEL_PROJECT_NAME_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__cache_id.json

/**
 * Original request ID when request is served from cache `vercel.proxy.cache_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_CACHE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "pdx1::v8g4b-1744143786684-93dafbc0f70d"
 */
export const VERCEL_PROXY_CACHE_ID = 'vercel.proxy.cache_id';

/**
 * Type for {@link VERCEL_PROXY_CACHE_ID} vercel.proxy.cache_id
 */
export type VERCEL_PROXY_CACHE_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__client_ip.json

/**
 * Client IP address `vercel.proxy.client_ip`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_CLIENT_IP_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "120.75.16.101"
 */
export const VERCEL_PROXY_CLIENT_IP = 'vercel.proxy.client_ip';

/**
 * Type for {@link VERCEL_PROXY_CLIENT_IP} vercel.proxy.client_ip
 */
export type VERCEL_PROXY_CLIENT_IP_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__host.json

/**
 * Hostname of the request `vercel.proxy.host`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_HOST_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "test.vercel.app"
 */
export const VERCEL_PROXY_HOST = 'vercel.proxy.host';

/**
 * Type for {@link VERCEL_PROXY_HOST} vercel.proxy.host
 */
export type VERCEL_PROXY_HOST_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__lambda_region.json

/**
 * Region where lambda function executed `vercel.proxy.lambda_region`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_LAMBDA_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sfo1"
 */
export const VERCEL_PROXY_LAMBDA_REGION = 'vercel.proxy.lambda_region';

/**
 * Type for {@link VERCEL_PROXY_LAMBDA_REGION} vercel.proxy.lambda_region
 */
export type VERCEL_PROXY_LAMBDA_REGION_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__method.json

/**
 * HTTP method of the request `vercel.proxy.method`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_METHOD_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "GET"
 */
export const VERCEL_PROXY_METHOD = 'vercel.proxy.method';

/**
 * Type for {@link VERCEL_PROXY_METHOD} vercel.proxy.method
 */
export type VERCEL_PROXY_METHOD_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__path.json

/**
 * Request path with query parameters `vercel.proxy.path`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_PATH_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "/dynamic/some-value.json?route=some-value"
 */
export const VERCEL_PROXY_PATH = 'vercel.proxy.path';

/**
 * Type for {@link VERCEL_PROXY_PATH} vercel.proxy.path
 */
export type VERCEL_PROXY_PATH_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__path_type.json

/**
 * How the request was served based on its path and project configuration `vercel.proxy.path_type`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_PATH_TYPE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "func"
 */
export const VERCEL_PROXY_PATH_TYPE = 'vercel.proxy.path_type';

/**
 * Type for {@link VERCEL_PROXY_PATH_TYPE} vercel.proxy.path_type
 */
export type VERCEL_PROXY_PATH_TYPE_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__path_type_variant.json

/**
 * Variant of the path type `vercel.proxy.path_type_variant`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_PATH_TYPE_VARIANT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "api"
 */
export const VERCEL_PROXY_PATH_TYPE_VARIANT = 'vercel.proxy.path_type_variant';

/**
 * Type for {@link VERCEL_PROXY_PATH_TYPE_VARIANT} vercel.proxy.path_type_variant
 */
export type VERCEL_PROXY_PATH_TYPE_VARIANT_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__referer.json

/**
 * Referer of the request `vercel.proxy.referer`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_REFERER_TYPE}
 *
 * Apply Scrubbing: auto
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "*.vercel.app"
 */
export const VERCEL_PROXY_REFERER = 'vercel.proxy.referer';

/**
 * Type for {@link VERCEL_PROXY_REFERER} vercel.proxy.referer
 */
export type VERCEL_PROXY_REFERER_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__region.json

/**
 * Region where the request is processed `vercel.proxy.region`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_REGION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sfo1"
 */
export const VERCEL_PROXY_REGION = 'vercel.proxy.region';

/**
 * Type for {@link VERCEL_PROXY_REGION} vercel.proxy.region
 */
export type VERCEL_PROXY_REGION_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__response_byte_size.json

/**
 * Size of the response in bytes `vercel.proxy.response_byte_size`
 *
 * Attribute Value Type: `number` {@link VERCEL_PROXY_RESPONSE_BYTE_SIZE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1024
 */
export const VERCEL_PROXY_RESPONSE_BYTE_SIZE = 'vercel.proxy.response_byte_size';

/**
 * Type for {@link VERCEL_PROXY_RESPONSE_BYTE_SIZE} vercel.proxy.response_byte_size
 */
export type VERCEL_PROXY_RESPONSE_BYTE_SIZE_TYPE = number;

// Path: model/attributes/vercel/vercel__proxy__scheme.json

/**
 * Protocol of the request `vercel.proxy.scheme`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_SCHEME_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "https"
 */
export const VERCEL_PROXY_SCHEME = 'vercel.proxy.scheme';

/**
 * Type for {@link VERCEL_PROXY_SCHEME} vercel.proxy.scheme
 */
export type VERCEL_PROXY_SCHEME_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__status_code.json

/**
 * HTTP status code of the proxy request `vercel.proxy.status_code`
 *
 * Attribute Value Type: `number` {@link VERCEL_PROXY_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 200
 */
export const VERCEL_PROXY_STATUS_CODE = 'vercel.proxy.status_code';

/**
 * Type for {@link VERCEL_PROXY_STATUS_CODE} vercel.proxy.status_code
 */
export type VERCEL_PROXY_STATUS_CODE_TYPE = number;

// Path: model/attributes/vercel/vercel__proxy__timestamp.json

/**
 * Unix timestamp when the proxy request was made `vercel.proxy.timestamp`
 *
 * Attribute Value Type: `number` {@link VERCEL_PROXY_TIMESTAMP_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 1573817250172
 */
export const VERCEL_PROXY_TIMESTAMP = 'vercel.proxy.timestamp';

/**
 * Type for {@link VERCEL_PROXY_TIMESTAMP} vercel.proxy.timestamp
 */
export type VERCEL_PROXY_TIMESTAMP_TYPE = number;

// Path: model/attributes/vercel/vercel__proxy__user_agent.json

/**
 * User agent strings of the request `vercel.proxy.user_agent`
 *
 * Attribute Value Type: `Array<string>` {@link VERCEL_PROXY_USER_AGENT_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example ["Mozilla/5.0..."]
 */
export const VERCEL_PROXY_USER_AGENT = 'vercel.proxy.user_agent';

/**
 * Type for {@link VERCEL_PROXY_USER_AGENT} vercel.proxy.user_agent
 */
export type VERCEL_PROXY_USER_AGENT_TYPE = Array<string>;

// Path: model/attributes/vercel/vercel__proxy__vercel_cache.json

/**
 * Cache status sent to the browser `vercel.proxy.vercel_cache`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_VERCEL_CACHE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "REVALIDATED"
 */
export const VERCEL_PROXY_VERCEL_CACHE = 'vercel.proxy.vercel_cache';

/**
 * Type for {@link VERCEL_PROXY_VERCEL_CACHE} vercel.proxy.vercel_cache
 */
export type VERCEL_PROXY_VERCEL_CACHE_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__vercel_id.json

/**
 * Vercel-specific identifier `vercel.proxy.vercel_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_VERCEL_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "sfo1::abc123"
 */
export const VERCEL_PROXY_VERCEL_ID = 'vercel.proxy.vercel_id';

/**
 * Type for {@link VERCEL_PROXY_VERCEL_ID} vercel.proxy.vercel_id
 */
export type VERCEL_PROXY_VERCEL_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__waf_action.json

/**
 * Action taken by firewall rules `vercel.proxy.waf_action`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_WAF_ACTION_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "deny"
 */
export const VERCEL_PROXY_WAF_ACTION = 'vercel.proxy.waf_action';

/**
 * Type for {@link VERCEL_PROXY_WAF_ACTION} vercel.proxy.waf_action
 */
export type VERCEL_PROXY_WAF_ACTION_TYPE = string;

// Path: model/attributes/vercel/vercel__proxy__waf_rule_id.json

/**
 * ID of the firewall rule that matched `vercel.proxy.waf_rule_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_PROXY_WAF_RULE_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "rule_gAHz8jtSB1Gy"
 */
export const VERCEL_PROXY_WAF_RULE_ID = 'vercel.proxy.waf_rule_id';

/**
 * Type for {@link VERCEL_PROXY_WAF_RULE_ID} vercel.proxy.waf_rule_id
 */
export type VERCEL_PROXY_WAF_RULE_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__request_id.json

/**
 * Identifier of the Vercel request `vercel.request_id`
 *
 * Attribute Value Type: `string` {@link VERCEL_REQUEST_ID_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "643af4e3-975a-4cc7-9e7a-1eda11539d90"
 */
export const VERCEL_REQUEST_ID = 'vercel.request_id';

/**
 * Type for {@link VERCEL_REQUEST_ID} vercel.request_id
 */
export type VERCEL_REQUEST_ID_TYPE = string;

// Path: model/attributes/vercel/vercel__source.json

/**
 * Origin of the Vercel log (build, edge, lambda, static, external, or firewall) `vercel.source`
 *
 * Attribute Value Type: `string` {@link VERCEL_SOURCE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example "build"
 */
export const VERCEL_SOURCE = 'vercel.source';

/**
 * Type for {@link VERCEL_SOURCE} vercel.source
 */
export type VERCEL_SOURCE_TYPE = string;

// Path: model/attributes/vercel/vercel__status_code.json

/**
 * HTTP status code of the request (-1 means no response returned and the lambda crashed) `vercel.status_code`
 *
 * Attribute Value Type: `number` {@link VERCEL_STATUS_CODE_TYPE}
 *
 * Apply Scrubbing: manual
 *
 * Attribute defined in OTEL: No
 * Visibility: public
 *
 * @example 200
 */
export const VERCEL_STATUS_CODE = 'vercel.status_code';

/**
 * Type for {@link VERCEL_STATUS_CODE} vercel.status_code
 */
export type VERCEL_STATUS_CODE_TYPE = number;

export type AttributeType =
  | 'string'
  | 'boolean'
  | 'integer'
  | 'double'
  | 'string[]'
  | 'boolean[]'
  | 'integer[]'
  | 'double[]'
  | 'any';

export type ApplyScrubbing = 'auto' | 'manual' | 'never';

export type AttributeVisibility = 'public' | 'internal';

export interface ApplyScrubbingInfo {
  /** How PII scrubbing should be applied to the attribute value */
  key: ApplyScrubbing;
  /** Reason why this scrubbing mode applies */
  reason?: string;
}

export type DeprecationStatus = 'backfill' | 'normalize' | 'transform';

export interface DeprecationInfo {
  /** What this attribute was replaced with */
  replacement?: string;
  /** Reason for deprecation */
  reason?: string;
  /** How the attribute should be handled in the ingestion pipeline */
  status?: DeprecationStatus;
  /** Attribute transformation id to apply when status is transform */
  transformation?: string;
}

export interface ChangelogEntry {
  /** The sentry-conventions release version */
  version: string;
  /** GitHub PR numbers */
  prs?: number[];
  /** Optional description of what changed */
  description?: string;
}

export type SearchAliasType = 'byte' | 'currency' | 'millisecond' | 'percentage' | 'second';

export interface SearchAlias {
  /** The public name exposed in Sentry search */
  name: string;
  /** The type exposed by Sentry search. Defaults to the attribute's primary type if omitted */
  type?: SearchAliasType;
  /** Deprecated aliases still accepted in search queries */
  deprecatedAliases?: string[];
}

export interface AttributeMetadata {
  /** A description of the attribute */
  brief: string;
  /** The type of the attribute value */
  type: AttributeType;
  /**
   * Every key this attribute's value may be readable under, preferred key first.
   *
   * All members of a family read the same set of keys. Mutually aliased attributes each head their
   * own chain, so those chains agree on membership but differ in which key they prefer. Only
   * `backfill` and `normalize` deprecations join their replacement's chain,
   * because only for those is the value rewritten onto the replacement. An attribute with any other
   * deprecation therefore has a chain of just its own names, and the first key is not guaranteed to
   * be non-deprecated — check `deprecation` if that matters.
   */
  keys: readonly string[];
  /** How PII scrubbing should be applied to the attribute value */
  applyScrubbing: ApplyScrubbingInfo;
  /** Whether the attribute is defined in OpenTelemetry Semantic Conventions */
  isInOtel: boolean;
  /** Whether the attribute is public or internal to Sentry */
  visibility: AttributeVisibility;
  /** If an attribute has a dynamic suffix */
  hasDynamicSuffix?: boolean;
  /** An example value of the attribute */
  example?: AttributeValue;
  /** Example values of the attribute */
  examples?: AttributeValue[];
  /** If an attribute was deprecated, and what it was replaced with */
  deprecation?: DeprecationInfo;
  /** If there are attributes that alias to this attribute */
  aliases?: AttributeName[];
  /** Changelog entries tracking how this attribute has changed across versions */
  changelog?: ChangelogEntry[];
  /** A list of freeform notes providing additional context about how this attribute behaves, common pitfalls, or query-time nuances */
  additionalContext?: string[];
  /** How this attribute is exposed in Sentry search */
  searchAlias?: SearchAlias;
}

export const ATTRIBUTE_TYPE: Record<string, AttributeType> = {
  address: 'string',
  'ai.citations': 'string[]',
  'ai.completion_tokens.used': 'integer',
  'ai.documents': 'string[]',
  'ai.finish_reason': 'string',
  'ai.frequency_penalty': 'double',
  'ai.function_call': 'string',
  'ai.generation_id': 'string',
  'ai.input_messages': 'string',
  'ai.is_search_required': 'boolean',
  'ai.metadata': 'string',
  'ai.model.id': 'string',
  'ai.model_id': 'string',
  'ai.model.provider': 'string',
  'ai.pipeline.name': 'string',
  'ai.preamble': 'string',
  'ai.presence_penalty': 'double',
  'ai.prompt': 'string',
  'ai.prompt.messages': 'string',
  'ai.prompt_tokens.used': 'integer',
  'ai.prompt.tools': 'string[]',
  'ai.raw_prompting': 'boolean',
  'ai.responses': 'string[]',
  'ai.response_format': 'string',
  'ai.response.id': 'string',
  'ai.response.model': 'string',
  'ai.response.object': 'string',
  'ai.response.text': 'string',
  'ai.response.timestamp': 'string',
  'ai.response.toolCalls': 'string',
  'ai.schema': 'string',
  'ai.search_queries': 'string[]',
  'ai.search_results': 'string[]',
  'ai.seed': 'string',
  'ai.streaming': 'boolean',
  'ai.tags': 'string',
  'ai.temperature': 'double',
  'ai.texts': 'string[]',
  'ai.toolCall.args': 'string',
  'ai.toolCall.result': 'string',
  'ai.tools': 'string[]',
  'ai.tool_calls': 'string[]',
  'ai.top_k': 'integer',
  'ai.top_p': 'double',
  'ai.total_cost': 'double',
  'ai.total_tokens.used': 'integer',
  'ai.usage.tokens': 'integer',
  'ai.values': 'string',
  'ai.warnings': 'string[]',
  'angular.version': 'string',
  'anthropic.tool_result.content': 'string',
  'app.app_build': 'string',
  'app.app_identifier': 'string',
  'app.app_name': 'string',
  'app.app_start_time': 'string',
  'app.app_version': 'string',
  'app.build': 'string',
  'app.identifier': 'string',
  'app.in_foreground': 'boolean',
  'app.name': 'string',
  app_start_cold: 'double',
  'app.start_time': 'string',
  app_start_type: 'string',
  app_start_warm: 'double',
  'app.version': 'string',
  'app.vitals.frames.delay.value': 'integer',
  'app.vitals.frames.frozen.count': 'integer',
  'app.vitals.frames.frozen.rate': 'double',
  'app.vitals.frames.slow.count': 'integer',
  'app.vitals.frames.slow.rate': 'double',
  'app.vitals.frames.total.count': 'integer',
  'app.vitals.stall.duration': 'double',
  'app.vitals.stall.percentage': 'double',
  'app.vitals.start.cold.value': 'double',
  'app.vitals.start.prewarmed': 'boolean',
  'app.vitals.start.reason': 'string',
  'app.vitals.start.screen': 'string',
  'app.vitals.start.type': 'string',
  'app.vitals.start.warm.value': 'double',
  'app.vitals.ttfd.value': 'double',
  'app.vitals.ttid.value': 'double',
  'art.gc.blocking_count': 'integer',
  'art.gc.blocking_time': 'double',
  'art.gc.pre_oome_count': 'integer',
  'art.gc.total_count': 'integer',
  'art.gc.total_time': 'double',
  'art.gc.waiting_time': 'double',
  'art.memory.free': 'integer',
  'art.memory.free_until_gc': 'integer',
  'art.memory.free_until_oome': 'integer',
  'art.memory.max': 'integer',
  'art.memory.total': 'integer',
  'aws.cloudwatch.logs.log_group': 'string',
  'aws.cloudwatch.logs.log_stream': 'string',
  'aws.cloudwatch.logs.url': 'string',
  'aws.dynamodb.attributes_to_get': 'string[]',
  'aws.dynamodb.attribute_definitions': 'string[]',
  'aws.dynamodb.consistent_read': 'boolean',
  'aws.dynamodb.consumed_capacity': 'string[]',
  'aws.dynamodb.count': 'integer',
  'aws.dynamodb.exclusive_start_table': 'string',
  'aws.dynamodb.global_secondary_indexes': 'string[]',
  'aws.dynamodb.global_secondary_index_updates': 'string[]',
  'aws.dynamodb.index_name': 'string',
  'aws.dynamodb.item_collection_metrics': 'string',
  'aws.dynamodb.limit': 'integer',
  'aws.dynamodb.local_secondary_indexes': 'string[]',
  'aws.dynamodb.projection': 'string',
  'aws.dynamodb.provisioned_read_capacity': 'double',
  'aws.dynamodb.provisioned_write_capacity': 'double',
  'aws.dynamodb.scanned_count': 'integer',
  'aws.dynamodb.scan_forward': 'boolean',
  'aws.dynamodb.segment': 'integer',
  'aws.dynamodb.select': 'string',
  'aws.dynamodb.table_count': 'integer',
  'aws.dynamodb.table_names': 'string[]',
  'aws.dynamodb.total_segments': 'integer',
  'aws.extended_request_id': 'string',
  'aws.kinesis.stream_name': 'string',
  'aws.kinesis.stream.name': 'string',
  'aws.lambda.aws_request_id': 'string',
  'aws.lambda.execution_duration_in_millis': 'double',
  'aws.lambda.function_name': 'string',
  'aws.lambda.function_version': 'string',
  'aws.lambda.invoked_arn': 'string',
  'aws.lambda.invoked_function_arn': 'string',
  'aws.lambda.remaining_time_in_millis': 'double',
  'aws.log.group.names': 'string[]',
  'aws.log.stream.names': 'string[]',
  'aws.operation_name': 'string',
  aws_region: 'string',
  'aws.request.extended_id': 'string',
  'aws.request_id': 'string',
  'aws.request.id': 'string',
  'aws.request.url': 'string',
  'aws.s3.bucket': 'string',
  'aws.s3.copy_source': 'string',
  'aws.s3.delete': 'string',
  'aws.s3.key': 'string',
  'aws.s3.part_number': 'integer',
  'aws.s3.upload_id': 'string',
  'aws.secretsmanager.secret.arn': 'string',
  'aws.sns.topic.arn': 'string',
  'aws.sqs.queue.url': 'string',
  'aws.step_functions.activity.arn': 'string',
  'aws.step_functions.execution.arn': 'string',
  'aws.step_functions.state_machine.arn': 'string',
  blocked_main_thread: 'boolean',
  'browser.bfcache.frame': 'string',
  'browser.bfcache.not_restored_reason_count': 'integer',
  'browser.bfcache.outcome': 'string',
  'browser.bfcache.reason': 'string',
  'browser.name': 'string',
  'browser.navigation.id': 'integer',
  'browser.navigation.type': 'string',
  'browser.paint.type': 'string',
  'browser.performance.navigation.activation_start': 'double',
  'browser.performance.time_origin': 'double',
  'browser.report.type': 'string',
  'browser.script.invoker': 'string',
  'browser.script.invoker_type': 'string',
  'browser.script.source_char_position': 'integer',
  'browser.version': 'string',
  'browser.web_vital.cls.report_event': 'string',
  'browser.web_vital.cls.source.<key>': 'string',
  'browser.web_vital.cls.value': 'double',
  'browser.web_vital.fcp.value': 'double',
  'browser.web_vital.fp.value': 'double',
  'browser.web_vital.inp.interaction_type': 'string',
  'browser.web_vital.inp.target': 'string',
  'browser.web_vital.inp.value': 'double',
  'browser.web_vital.lcp.element': 'string',
  'browser.web_vital.lcp.id': 'string',
  'browser.web_vital.lcp.load_time': 'integer',
  'browser.web_vital.lcp.render_time': 'integer',
  'browser.web_vital.lcp.report_event': 'string',
  'browser.web_vital.lcp.size': 'integer',
  'browser.web_vital.lcp.url': 'string',
  'browser.web_vital.lcp.value': 'double',
  'browser.web_vital.ttfb.request_time': 'double',
  'browser.web_vital.ttfb.value': 'double',
  'cache.hit': 'boolean',
  'cache.item_age': 'integer',
  'cache.item_size': 'integer',
  'cache.key': 'string[]',
  'cache.operation': 'string',
  'cache.tags': 'string[]',
  'cache.ttl': 'integer',
  'cache.write': 'boolean',
  channel: 'string',
  'client.address': 'string',
  'client.port': 'integer',
  'cloudflare.d1.duration': 'integer',
  'cloudflare.d1.query_type': 'string',
  'cloudflare.d1.rows_read': 'integer',
  'cloudflare.d1.rows_written': 'integer',
  'cloudflare.durable_object.query.bindings': 'integer',
  'cloudflare.durable_object.response.rows_read': 'integer',
  'cloudflare.durable_object.response.rows_written': 'integer',
  'cloudflare.r2.bucket': 'string',
  'cloudflare.r2.operation': 'string',
  'cloudflare.r2.request.delimiter': 'string',
  'cloudflare.r2.request.key': 'string',
  'cloudflare.r2.request.part_number': 'integer',
  'cloudflare.r2.request.prefix': 'string',
  'cloudflare.workflow.attempt': 'integer',
  'cloudflare.workflow.retries.backoff': 'string',
  'cloudflare.workflow.retries.delay': 'string',
  'cloudflare.workflow.retries.limit': 'integer',
  'cloudflare.workflow.timeout': 'string',
  'cloud.account.id': 'string',
  'cloud.availability_zone': 'string',
  'cloud.platform': 'string',
  'cloud.provider': 'string',
  'cloud.region': 'string',
  'cloud.resource_id': 'string',
  cls: 'double',
  'cls.source.<key>': 'string',
  code: 'string',
  'code.filepath': 'string',
  'code.file.path': 'string',
  'code.function': 'string',
  'code.function.name': 'string',
  'code.lineno': 'integer',
  'code.line.number': 'integer',
  'code.namespace': 'string',
  connectionType: 'string',
  'connection.rtt': 'integer',
  'culture.calendar': 'string',
  'culture.display_name': 'string',
  'culture.is_24_hour_format': 'boolean',
  'culture.locale': 'string',
  'culture.timezone': 'string',
  'db.collection.name': 'string',
  'db.connection_string': 'string',
  'db.driver.name': 'string',
  'db.mongodb.collection': 'string',
  'db.name': 'string',
  'db.namespace': 'string',
  'db.operation': 'string',
  'db.operation.batch.size': 'integer',
  'db.operation.name': 'string',
  'db.params': 'string',
  'db.query.parameter.<key>': 'string',
  'db.query.summary': 'string',
  'db.query.text': 'string',
  'db.redis.connection': 'string',
  'db.redis.key': 'string',
  'db.redis.parameters': 'string[]',
  'db.response.status_code': 'string',
  'db.sql.bindings': 'string[]',
  'db.statement': 'string',
  'db.stored_procedure.name': 'string',
  'db.system': 'string',
  'db.system.name': 'string',
  'db.user': 'string',
  deviceMemory: 'string',
  'device.archs': 'string[]',
  'device.battery_level': 'double',
  'device.battery_temperature': 'double',
  'device.boot_time': 'string',
  'device.brand': 'string',
  'device.charging': 'boolean',
  'device.chipset': 'string',
  'device.class': 'string',
  'device.connection_type': 'string',
  'device.cpu_description': 'string',
  'device.external_free_storage': 'integer',
  'device.external_storage_size': 'integer',
  'device.family': 'string',
  'device.free_memory': 'integer',
  'device.free_storage': 'integer',
  'device.id': 'string',
  'device.locale': 'string',
  'device.low_memory': 'boolean',
  'device.low_power_mode': 'boolean',
  'device.manufacturer': 'string',
  'device.memory.estimated_capacity': 'integer',
  'device.memory_size': 'integer',
  'device.model': 'string',
  'device.model_id': 'string',
  'device.name': 'string',
  'device.online': 'boolean',
  'device.orientation': 'string',
  'device.processor_count': 'integer',
  'device.processor_frequency': 'double',
  'device.screen_density': 'double',
  'device.screen_dpi': 'integer',
  'device.screen_height_pixels': 'integer',
  'device.screen_width_pixels': 'integer',
  'device.simulator': 'boolean',
  'device.storage_size': 'integer',
  'device.thermal_state': 'string',
  'device.timezone': 'string',
  'device.usable_memory': 'integer',
  dist: 'string',
  'django.function_name': 'string',
  'django.middleware_name': 'string',
  effectiveConnectionType: 'string',
  environment: 'string',
  'error.type': 'string',
  'event.id': 'integer',
  'event.name': 'string',
  'exception.escaped': 'boolean',
  'exception.message': 'string',
  'exception.stacktrace': 'string',
  'exception.type': 'string',
  'faas.coldstart': 'boolean',
  'faas.cron': 'string',
  'faas.duration_in_ms': 'integer',
  'faas.entry_point': 'string',
  'faas.execution': 'string',
  'faas.id': 'string',
  'faas.identity': 'string',
  'faas.invocation_id': 'string',
  'faas.invoked_name': 'string',
  'faas.invoked_provider': 'string',
  'faas.invoked_region': 'string',
  'faas.name': 'string',
  'faas.time': 'string',
  'faas.trigger': 'string',
  'faas.version': 'string',
  fcp: 'double',
  'file.path': 'string',
  'file.size': 'integer',
  'flag.evaluation.<key>': 'boolean',
  fp: 'double',
  'frames.delay': 'integer',
  'frames.frozen': 'integer',
  frames_frozen_rate: 'double',
  'frames.slow': 'integer',
  frames_slow_rate: 'double',
  'frames.total': 'integer',
  fs_error: 'string',
  'gcp.function.context.event_id': 'string',
  'gcp.function.context.event_type': 'string',
  'gcp.function.context.id': 'string',
  'gcp.function.context.resource': 'string',
  'gcp.function.context.source': 'string',
  'gcp.function.context.specversion': 'string',
  'gcp.function.context.time': 'string',
  'gcp.function.context.timestamp': 'string',
  'gcp.function.context.type': 'string',
  'gcp.project.id': 'string',
  gcp_region: 'string',
  'gen_ai.agent.name': 'string',
  'gen_ai.context.utilization': 'double',
  'gen_ai.context.window_size': 'integer',
  'gen_ai.conversation.id': 'string',
  'gen_ai.cost.cache_creation.input_tokens': 'double',
  'gen_ai.cost.cache_read.input_tokens': 'double',
  'gen_ai.cost.input_tokens': 'double',
  'gen_ai.cost.output_tokens': 'double',
  'gen_ai.cost.reasoning.output_tokens': 'double',
  'gen_ai.cost.total_tokens': 'double',
  'gen_ai.embeddings.input': 'string',
  'gen_ai.function_id': 'string',
  'gen_ai.input.messages': 'string',
  'gen_ai.memory.query.text': 'string',
  'gen_ai.memory.records': 'string',
  'gen_ai.memory.record.count': 'integer',
  'gen_ai.memory.record.id': 'string',
  'gen_ai.memory.store.id': 'string',
  'gen_ai.operation.name': 'string',
  'gen_ai.operation.type': 'string',
  'gen_ai.output.messages': 'string',
  'gen_ai.pipeline.name': 'string',
  'gen_ai.prompt': 'string',
  'gen_ai.prompt.name': 'string',
  'gen_ai.prompt.variable.<key>': 'string',
  'gen_ai.provider.name': 'string',
  'gen_ai.request.available_tools': 'string',
  'gen_ai.request.frequency_penalty': 'double',
  'gen_ai.request.max_tokens': 'integer',
  'gen_ai.request.messages': 'string',
  'gen_ai.request.model': 'string',
  'gen_ai.request.presence_penalty': 'double',
  'gen_ai.request.reasoning.level': 'string',
  'gen_ai.request.schema': 'string',
  'gen_ai.request.seed': 'string',
  'gen_ai.request.stop_sequences': 'string[]',
  'gen_ai.request.temperature': 'double',
  'gen_ai.request.top_k': 'integer',
  'gen_ai.request.top_p': 'double',
  'gen_ai.response.finish_reason': 'string',
  'gen_ai.response.finish_reasons': 'string',
  'gen_ai.response.id': 'string',
  'gen_ai.response.model': 'string',
  'gen_ai.response.object': 'string',
  'gen_ai.response.streaming': 'boolean',
  'gen_ai.response.text': 'string',
  'gen_ai.response.time_to_first_chunk': 'double',
  'gen_ai.response.time_to_first_token': 'double',
  'gen_ai.response.tokens_per_second': 'double',
  'gen_ai.response.tool_calls': 'string',
  'gen_ai.system': 'string',
  'gen_ai.system_instructions': 'string',
  'gen_ai.system.message': 'string',
  'gen_ai.tool.call.arguments': 'string',
  'gen_ai.tool.call.result': 'string',
  'gen_ai.tool.definitions': 'string',
  'gen_ai.tool.description': 'string',
  'gen_ai.tool.input': 'string',
  'gen_ai.tool.message': 'string',
  'gen_ai.tool.name': 'string',
  'gen_ai.tool.output': 'string',
  'gen_ai.tool.type': 'string',
  'gen_ai.usage.cache_creation.input_tokens': 'integer',
  'gen_ai.usage.cache_creation_input_tokens': 'integer',
  'gen_ai.usage.cache_read.input_tokens': 'integer',
  'gen_ai.usage.cache_read_input_tokens': 'integer',
  'gen_ai.usage.completion_tokens': 'integer',
  'gen_ai.usage.input_tokens': 'integer',
  'gen_ai.usage.input_tokens.cached': 'integer',
  'gen_ai.usage.input_tokens.cache_write': 'integer',
  'gen_ai.usage.output_tokens': 'integer',
  'gen_ai.usage.output_tokens.reasoning': 'integer',
  'gen_ai.usage.prompt_tokens': 'integer',
  'gen_ai.usage.reasoning.output_tokens': 'integer',
  'gen_ai.usage.total_tokens': 'integer',
  'graphql.document': 'string',
  'graphql.operation.name': 'string',
  'graphql.operation.type': 'string',
  'graphql.processing.type': 'string',
  'graphql.source': 'string',
  'grpc.error.bad_request.field_violations': 'string[]',
  'grpc.error.debug_info.detail': 'string',
  'grpc.error.debug_info.stack_entries': 'string[]',
  'grpc.error.error_info.domain': 'string',
  'grpc.error.error_info.metadata.<key>': 'string',
  'grpc.error.error_info.reason': 'string',
  'grpc.error.precondition_failure.violations': 'string[]',
  'grpc.error.quota_failure.violations': 'string[]',
  'grpc.error.resource_info.description': 'string',
  'grpc.error.resource_info.owner': 'string',
  'grpc.error.resource_info.resource_name': 'string',
  'grpc.error.resource_info.resource_type': 'string',
  'grpc.error.retry_info.retry_delay_ms': 'integer',
  hardwareConcurrency: 'string',
  'http.client_ip': 'string',
  'http.decoded_response_content_length': 'integer',
  'http.flavor': 'string',
  'http.fragment': 'string',
  'http.host': 'string',
  'http.method': 'string',
  'http.query': 'string',
  'http.request.body.data': 'string',
  'http.request.body.decoded_size': 'integer',
  'http.request.body.size': 'integer',
  'http.request.connection_end': 'double',
  'http.request.connect_start': 'double',
  'http.request_content_length': 'integer',
  'http.request_content_length_uncompressed': 'integer',
  'http.request.domain_lookup_end': 'double',
  'http.request.domain_lookup_start': 'double',
  'http.request.fetch_start': 'double',
  'http.request.header.<key>': 'string[]',
  'http.request.method': 'string',
  'http.request_method': 'string',
  'http.request.redirect_end': 'double',
  'http.request.redirect_start': 'double',
  'http.request.request_start': 'double',
  'http.request.resend_count': 'integer',
  'http.request.response_end': 'double',
  'http.request.response_start': 'double',
  'http.request.same_origin': 'boolean',
  'http.request.secure_connection_start': 'double',
  'http.request.time_to_first_byte': 'double',
  'http.request.worker_start': 'double',
  'http.response.body.decoded_size': 'integer',
  'http.response.body.size': 'integer',
  'http.response_content_length': 'integer',
  'http.response_content_length_uncompressed': 'integer',
  'http.response.header.content-length': 'string',
  'http.response.header.<key>': 'string[]',
  'http.response.size': 'integer',
  'http.response.status_code': 'integer',
  'http.response.status_text': 'string',
  'http.response_transfer_size': 'integer',
  'http.route': 'string',
  'http.scheme': 'string',
  'http.server_name': 'string',
  'http.server.request.time_in_queue': 'double',
  'http.status_code': 'integer',
  'http.status_text': 'string',
  'http.target': 'string',
  'http.url': 'string',
  'http.user_agent': 'string',
  id: 'string',
  inp: 'double',
  'integrity.blocked_url': 'string',
  'integrity.destination': 'string',
  'integrity.document_url': 'string',
  'integrity.report_only': 'boolean',
  'jsonrpc.protocol.version': 'string',
  'jsonrpc.request.id': 'string',
  'jvm.gc.action': 'string',
  'jvm.gc.name': 'string',
  'jvm.memory.pool.name': 'string',
  'jvm.memory.type': 'string',
  'jvm.thread.daemon': 'boolean',
  'jvm.thread.state': 'string',
  'koa.name': 'string',
  'koa.type': 'string',
  'langchain.chain.name': 'string',
  lcp: 'double',
  'lcp.element': 'string',
  'lcp.id': 'string',
  'lcp.loadTime': 'integer',
  'lcp.renderTime': 'integer',
  'lcp.size': 'integer',
  'lcp.url': 'string',
  'litestar.middleware_name': 'string',
  'logger.name': 'string',
  'mcp.auth.client.name': 'string',
  'mcp.cancelled.reason': 'string',
  'mcp.cancelled.request_id': 'string',
  'mcp.client.name': 'string',
  'mcp.client.title': 'string',
  'mcp.client.version': 'string',
  'mcp.lifecycle.phase': 'string',
  'mcp.logging.data_type': 'string',
  'mcp.logging.level': 'string',
  'mcp.logging.logger': 'string',
  'mcp.logging.message': 'string',
  'mcp.method.name': 'string',
  'mcp.progress.current': 'double',
  'mcp.progress.message': 'string',
  'mcp.progress.percentage': 'double',
  'mcp.progress.token': 'string',
  'mcp.progress.total': 'double',
  'mcp.prompt.name': 'string',
  'mcp.prompt.result.description': 'string',
  'mcp.prompt.result.<key>.content': 'string',
  'mcp.prompt.result.<key>.role': 'string',
  'mcp.prompt.result.message_content': 'string',
  'mcp.prompt.result.message_count': 'integer',
  'mcp.prompt.result.message_role': 'string',
  'mcp.protocol.ready': 'integer',
  'mcp.protocol.version': 'string',
  'mcp.request.argument.<key>': 'string',
  'mcp.request.argument.name': 'string',
  'mcp.request.argument.uri': 'string',
  'mcp.request.id': 'string',
  'mcp.resource.protocol': 'string',
  'mcp.resource.uri': 'string',
  'mcp.server.name': 'string',
  'mcp.server.title': 'string',
  'mcp.server.version': 'string',
  'mcp.session.id': 'string',
  'mcp.tool.name': 'string',
  'mcp.tool.result.content': 'string',
  'mcp.tool.result.content_count': 'integer',
  'mcp.tool.result.content_type': 'string',
  'mcp.tool.result.data_size': 'integer',
  'mcp.tool.result.is_error': 'boolean',
  'mcp.tool.result.<key>.content': 'string',
  'mcp.tool.result.<key>.content_type': 'string',
  'mcp.tool.result.<key>.data_size': 'integer',
  'mcp.tool.result.<key>.mime_type': 'string',
  'mcp.tool.result.<key>.name': 'string',
  'mcp.tool.result.<key>.resource_mime_type': 'string',
  'mcp.tool.result.<key>.resource_uri': 'string',
  'mcp.tool.result.<key>.uri': 'string',
  'mcp.tool.result.mime_type': 'string',
  'mcp.tool.result.name': 'string',
  'mcp.tool.result.resource_mime_type': 'string',
  'mcp.tool.result.resource_uri': 'string',
  'mcp.tool.result.uri': 'string',
  'mcp.transport': 'string',
  'mdc.<key>': 'string',
  'messaging.batch.message_count': 'integer',
  'messaging.conversation_id': 'string',
  'messaging.destination': 'string',
  'messaging.destination.connection': 'string',
  'messaging.destination_kind': 'string',
  'messaging.destination.name': 'string',
  'messaging.destination.partition.id': 'string',
  'messaging.kafka.message.key': 'string',
  'messaging.kafka.message.tombstone': 'boolean',
  'messaging.kafka.offset': 'integer',
  'messaging.message.body.size': 'integer',
  'messaging.message.conversation_id': 'string',
  'messaging.message.envelope.size': 'integer',
  'messaging.message.id': 'string',
  'messaging.message_id': 'string',
  'messaging.message.receive.latency': 'integer',
  'messaging.message.retry.count': 'integer',
  'messaging.operation': 'string',
  'messaging.operation.name': 'string',
  'messaging.operation.type': 'string',
  'messaging.protocol': 'string',
  'messaging.protocol_version': 'string',
  'messaging.rabbitmq.destination.routing_key': 'string',
  'messaging.rabbitmq.routing_key': 'string',
  'messaging.system': 'string',
  'messaging.url': 'string',
  method: 'string',
  'middleware.name': 'string',
  'navigation.origin': 'string',
  'navigation.route.id': 'string',
  'navigation.type': 'string',
  'nel.elapsed_time': 'integer',
  'nel.phase': 'string',
  'nel.referrer': 'string',
  'nel.sampling_fraction': 'double',
  'nel.sampling_function': 'double',
  'nel.type': 'string',
  'network.connection.effective_type': 'string',
  'network.connection.rtt': 'integer',
  'network.connection.type': 'string',
  'network.local.address': 'string',
  'network.local.port': 'integer',
  'network.peer.address': 'string',
  'network.peer.port': 'integer',
  'network.protocol.name': 'string',
  'network.protocol.version': 'string',
  'network.transport': 'string',
  'network.type': 'string',
  'net.host.ip': 'string',
  'net.host.name': 'string',
  'net.host.port': 'integer',
  'net.peer.ip': 'string',
  'net.peer.name': 'string',
  'net.peer.port': 'integer',
  'net.protocol.name': 'string',
  'net.protocol.version': 'string',
  'net.sock.family': 'string',
  'net.sock.host.addr': 'string',
  'net.sock.host.port': 'integer',
  'net.sock.peer.addr': 'string',
  'net.sock.peer.name': 'string',
  'net.sock.peer.port': 'integer',
  'net.transport': 'string',
  'os.build': 'string',
  'os.build_id': 'string',
  'os.description': 'string',
  'os.kernel_version': 'string',
  'os.name': 'string',
  'os.raw_description': 'string',
  'os.rooted': 'boolean',
  'os.theme': 'string',
  'os.type': 'string',
  'os.version': 'string',
  'otel.kind': 'string',
  'otel.scope.name': 'string',
  'otel.scope.version': 'string',
  'otel.status_code': 'string',
  'otel.status_description': 'string',
  'params.<key>': 'string',
  'performance.activationStart': 'double',
  'performance.timeOrigin': 'double',
  port: 'integer',
  previous_route: 'string',
  'process.command_args': 'string[]',
  'process.executable.name': 'string',
  'process.pid': 'integer',
  'process.runtime.description': 'string',
  'process.runtime.engine.name': 'string',
  'process.runtime.engine.version': 'string',
  'process.runtime.name': 'string',
  'process.runtime.version': 'string',
  profile_id: 'string',
  query: 'string',
  'query.<key>': 'string',
  'react_native.architecture': 'string',
  'react_native.module.call.count': 'integer',
  'react_native.module.call.distinct_count': 'integer',
  'react_native.module.duration.max': 'double',
  'react_native.module.duration.total': 'double',
  'react_native.module.error.count': 'integer',
  'react_native.module.kind': 'string',
  'react_native.module.method': 'string',
  'react_native.module.name': 'string',
  'react_native.module.top.duration': 'double',
  'react_native.module.top.name': 'string',
  'react.version': 'string',
  'redis.command': 'string',
  'redis.key': 'string',
  release: 'string',
  'remix.action_form_data.<key>': 'string',
  replayId: 'string',
  replay_id: 'string',
  'resource.deployment.environment': 'string',
  'resource.deployment.environment.name': 'string',
  'resource.render_blocking_status': 'string',
  route: 'string',
  'router.navigation.origin': 'string',
  'router.navigation.route.id': 'string',
  'router.navigation.type': 'string',
  'rpc.grpc.status_code': 'integer',
  'rpc.method': 'string',
  'rpc.response.status_code': 'string',
  'rpc.service': 'string',
  'rpc.system': 'string',
  'rpc.system.name': 'string',
  'runtime.build': 'string',
  'runtime.name': 'string',
  'runtime.raw_description': 'string',
  'runtime.version': 'string',
  'score.<key>': 'double',
  'score.ratio.<key>': 'double',
  'score.total': 'double',
  'score.weight.<key>': 'double',
  'sentry.action': 'string',
  'sentry.browser.name': 'string',
  'sentry.browser.version': 'string',
  'sentry.cancellation_reason': 'string',
  'sentry.category': 'string',
  'sentry.client_sample_rate': 'double',
  'sentry.description': 'string',
  'sentry.dist': 'string',
  'sentry.domain': 'string',
  'sentry.dsc.environment': 'string',
  'sentry.dsc.project_id': 'string',
  'sentry.dsc.public_key': 'string',
  'sentry.dsc.release': 'string',
  'sentry.dsc.sampled': 'boolean',
  'sentry.dsc.sample_rate': 'string',
  'sentry.dsc.trace_id': 'string',
  'sentry.dsc.transaction': 'string',
  'sentry.environment': 'string',
  'sentry.event.serialized_breadcrumbs': 'string',
  'sentry.event.serialized_contexts': 'string',
  'sentry.event.serialized_extra': 'string',
  'sentry.event.serialized_meta': 'string',
  'sentry.exclusive_time': 'double',
  'sentry.frames.frozen': 'integer',
  'sentry.frames.slow': 'integer',
  'sentry.frames.total': 'integer',
  'sentry.graphql.operation': 'string',
  'sentry.group': 'string',
  'sentry.http.prefetch': 'boolean',
  'sentry.idle_span_finish_reason': 'string',
  'sentry.is_localhost': 'boolean',
  'sentry.is_remote': 'boolean',
  'sentry.kind': 'string',
  'sentry.link.type': 'string',
  'sentry.main_thread': 'boolean',
  'sentry.message.parameter.<key>': 'string',
  'sentry.message.template': 'string',
  'sentry.metric.source': 'string',
  'sentry.mobile': 'boolean',
  'sentry.module.<key>': 'string',
  'sentry.nextjs.ssr.function.route': 'string',
  'sentry.nextjs.ssr.function.type': 'string',
  'sentry.normalized_db_query': 'string',
  'sentry.normalized_db_query.hash': 'string',
  'sentry.normalized_description': 'string',
  'sentry.observed_timestamp_nanos': 'string',
  'sentry.op': 'string',
  'sentry.origin': 'string',
  'sentry.pageload.span_id': 'string',
  'sentry.platform': 'string',
  'sentry.profiler_id': 'string',
  'sentry.profile_id': 'string',
  'sentry.relay.ingress': 'string',
  'sentry.relay.pipeline': 'string',
  'sentry.release': 'string',
  'sentry.replay_id': 'string',
  'sentry.replay_is_buffering': 'boolean',
  'sentry.report_event': 'string',
  'sentry.sdk.integrations': 'string[]',
  'sentry.sdk.name': 'string',
  'sentry.sdk.version': 'string',
  'sentry.segment.id': 'string',
  'sentry.segment_id': 'string',
  'sentry.segment.name': 'string',
  'sentry.segment.name.source': 'string',
  'sentry.server_sample_rate': 'double',
  'sentry.source': 'string',
  'sentry.span.source': 'string',
  'sentry.status': 'string',
  'sentry.status_code': 'integer',
  'sentry.status.message': 'string',
  'sentry.sveltekit.navigation.from': 'string',
  'sentry.sveltekit.navigation.to': 'string',
  'sentry.sveltekit.navigation.type': 'string',
  'sentry.thread.id': 'integer',
  'sentry.timestamp.sequence': 'integer',
  'sentry.trace_lifecycle': 'string',
  'sentry.trace.parent_span_id': 'string',
  'sentry.trace.status': 'string',
  'sentry.transaction': 'string',
  'sentry.user.email': 'string',
  'sentry.user.geo.city': 'string',
  'sentry.user.geo.country_code': 'string',
  'sentry.user.geo.region': 'string',
  'sentry.user.geo.subdivision': 'string',
  'sentry.user.id': 'string',
  'sentry.user.ip': 'string',
  'sentry.user.username': 'string',
  'server.address': 'string',
  server_name: 'string',
  'server.port': 'integer',
  'service.name': 'string',
  'service.version': 'string',
  'session.id': 'string',
  stall_percentage: 'double',
  stall_total_time: 'double',
  'starlette.middleware_name': 'string',
  'starlite.middleware_name': 'string',
  'state.type': 'string',
  'subprocess.pid': 'integer',
  'sveltekit.load.environment': 'string',
  'sveltekit.load.node_id': 'string',
  'sveltekit.load.node_type': 'string',
  'sveltekit.tracing.original_name': 'string',
  'thread.id': 'integer',
  'thread.name': 'string',
  'timber.tag': 'string',
  time_to_full_display: 'double',
  time_to_initial_display: 'double',
  transaction: 'string',
  'trpc.procedure_path': 'string',
  'trpc.procedure_type': 'string',
  ttfb: 'double',
  'ttfb.requestTime': 'double',
  'turbo_modules.total_call_count': 'integer',
  'turbo_modules.total_duration_ms': 'double',
  'turbo_modules.total_error_count': 'integer',
  'turbo_modules.unique_methods': 'integer',
  'turbo_module.arch': 'string',
  'turbo_module.method': 'string',
  'turbo_module.name': 'string',
  'turbo_module.top_module': 'string',
  'turbo_module.top_module_duration_ms': 'double',
  'turbo_module.total_call_count': 'integer',
  'turbo_module.total_duration_ms': 'double',
  'turbo_module.total_error_count': 'integer',
  'turbo_module.unique_methods': 'integer',
  type: 'string',
  'ui.component_name': 'string',
  'ui.contributes_to_ttfd': 'boolean',
  'ui.contributes_to_ttid': 'boolean',
  'ui.element.height': 'integer',
  'ui.element.id': 'string',
  'ui.element.identifier': 'string',
  'ui.element.load_time': 'double',
  'ui.element.paint_type': 'string',
  'ui.element.render_time': 'double',
  'ui.element.type': 'string',
  'ui.element.url': 'string',
  'ui.element.width': 'integer',
  url: 'string',
  'url.domain': 'string',
  'url.fragment': 'string',
  'url.full': 'string',
  'url.path': 'string',
  'url.path.parameter.<key>': 'string',
  'url.path.params.<key>': 'string',
  'url.port': 'integer',
  'url.query': 'string',
  'url.same_origin': 'boolean',
  'url.scheme': 'string',
  'url.template': 'string',
  'user_agent.original': 'string',
  'user.email': 'string',
  'user.full_name': 'string',
  'user.geo.city': 'string',
  'user.geo.country_code': 'string',
  'user.geo.region': 'string',
  'user.geo.subdivision': 'string',
  'user.hash': 'string',
  'user.id': 'string',
  'user.ip_address': 'string',
  'user.name': 'string',
  'user.roles': 'string[]',
  'vercel.ai.telemetry.metadata.<key>': 'string',
  'vercel.branch': 'string',
  'vercel.build_id': 'string',
  'vercel.deployment_id': 'string',
  'vercel.destination': 'string',
  'vercel.edge_type': 'string',
  'vercel.entrypoint': 'string',
  'vercel.execution_region': 'string',
  'vercel.id': 'string',
  'vercel.ja3_digest': 'string',
  'vercel.ja4_digest': 'string',
  'vercel.log_type': 'string',
  'vercel.path': 'string',
  'vercel.project_id': 'string',
  'vercel.project_name': 'string',
  'vercel.proxy.cache_id': 'string',
  'vercel.proxy.client_ip': 'string',
  'vercel.proxy.host': 'string',
  'vercel.proxy.lambda_region': 'string',
  'vercel.proxy.method': 'string',
  'vercel.proxy.path': 'string',
  'vercel.proxy.path_type': 'string',
  'vercel.proxy.path_type_variant': 'string',
  'vercel.proxy.referer': 'string',
  'vercel.proxy.region': 'string',
  'vercel.proxy.response_byte_size': 'integer',
  'vercel.proxy.scheme': 'string',
  'vercel.proxy.status_code': 'integer',
  'vercel.proxy.timestamp': 'integer',
  'vercel.proxy.user_agent': 'string[]',
  'vercel.proxy.vercel_cache': 'string',
  'vercel.proxy.vercel_id': 'string',
  'vercel.proxy.waf_action': 'string',
  'vercel.proxy.waf_rule_id': 'string',
  'vercel.request_id': 'string',
  'vercel.source': 'string',
  'vercel.status_code': 'integer',
};

export type AttributeName =
  | typeof ADDRESS
  | typeof AI_CITATIONS
  | typeof AI_COMPLETION_TOKENS_USED
  | typeof AI_DOCUMENTS
  | typeof AI_FINISH_REASON
  | typeof AI_FREQUENCY_PENALTY
  | typeof AI_FUNCTION_CALL
  | typeof AI_GENERATION_ID
  | typeof AI_INPUT_MESSAGES
  | typeof AI_IS_SEARCH_REQUIRED
  | typeof AI_METADATA
  | typeof AI_MODEL_ID
  | typeof _AI_MODEL_ID
  | typeof AI_MODEL_PROVIDER
  | typeof AI_PIPELINE_NAME
  | typeof AI_PREAMBLE
  | typeof AI_PRESENCE_PENALTY
  | typeof AI_PROMPT
  | typeof AI_PROMPT_MESSAGES
  | typeof AI_PROMPT_TOKENS_USED
  | typeof AI_PROMPT_TOOLS
  | typeof AI_RAW_PROMPTING
  | typeof AI_RESPONSES
  | typeof AI_RESPONSE_FORMAT
  | typeof AI_RESPONSE_ID
  | typeof AI_RESPONSE_MODEL
  | typeof AI_RESPONSE_OBJECT
  | typeof AI_RESPONSE_TEXT
  | typeof AI_RESPONSE_TIMESTAMP
  | typeof AI_RESPONSE_TOOLCALLS
  | typeof AI_SCHEMA
  | typeof AI_SEARCH_QUERIES
  | typeof AI_SEARCH_RESULTS
  | typeof AI_SEED
  | typeof AI_STREAMING
  | typeof AI_TAGS
  | typeof AI_TEMPERATURE
  | typeof AI_TEXTS
  | typeof AI_TOOLCALL_ARGS
  | typeof AI_TOOLCALL_RESULT
  | typeof AI_TOOLS
  | typeof AI_TOOL_CALLS
  | typeof AI_TOP_K
  | typeof AI_TOP_P
  | typeof AI_TOTAL_COST
  | typeof AI_TOTAL_TOKENS_USED
  | typeof AI_USAGE_TOKENS
  | typeof AI_VALUES
  | typeof AI_WARNINGS
  | typeof ANGULAR_VERSION
  | typeof ANTHROPIC_TOOL_RESULT_CONTENT
  | typeof APP_APP_BUILD
  | typeof APP_APP_IDENTIFIER
  | typeof APP_APP_NAME
  | typeof APP_APP_START_TIME
  | typeof APP_APP_VERSION
  | typeof APP_BUILD
  | typeof APP_IDENTIFIER
  | typeof APP_IN_FOREGROUND
  | typeof APP_NAME
  | typeof APP_START_COLD
  | typeof APP_START_TIME
  | typeof APP_START_TYPE
  | typeof APP_START_WARM
  | typeof APP_VERSION
  | typeof APP_VITALS_FRAMES_DELAY_VALUE
  | typeof APP_VITALS_FRAMES_FROZEN_COUNT
  | typeof APP_VITALS_FRAMES_FROZEN_RATE
  | typeof APP_VITALS_FRAMES_SLOW_COUNT
  | typeof APP_VITALS_FRAMES_SLOW_RATE
  | typeof APP_VITALS_FRAMES_TOTAL_COUNT
  | typeof APP_VITALS_STALL_DURATION
  | typeof APP_VITALS_STALL_PERCENTAGE
  | typeof APP_VITALS_START_COLD_VALUE
  | typeof APP_VITALS_START_PREWARMED
  | typeof APP_VITALS_START_REASON
  | typeof APP_VITALS_START_SCREEN
  | typeof APP_VITALS_START_TYPE
  | typeof APP_VITALS_START_WARM_VALUE
  | typeof APP_VITALS_TTFD_VALUE
  | typeof APP_VITALS_TTID_VALUE
  | typeof ART_GC_BLOCKING_COUNT
  | typeof ART_GC_BLOCKING_TIME
  | typeof ART_GC_PRE_OOME_COUNT
  | typeof ART_GC_TOTAL_COUNT
  | typeof ART_GC_TOTAL_TIME
  | typeof ART_GC_WAITING_TIME
  | typeof ART_MEMORY_FREE
  | typeof ART_MEMORY_FREE_UNTIL_GC
  | typeof ART_MEMORY_FREE_UNTIL_OOME
  | typeof ART_MEMORY_MAX
  | typeof ART_MEMORY_TOTAL
  | typeof AWS_CLOUDWATCH_LOGS_LOG_GROUP
  | typeof AWS_CLOUDWATCH_LOGS_LOG_STREAM
  | typeof AWS_CLOUDWATCH_LOGS_URL
  | typeof AWS_DYNAMODB_ATTRIBUTES_TO_GET
  | typeof AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS
  | typeof AWS_DYNAMODB_CONSISTENT_READ
  | typeof AWS_DYNAMODB_CONSUMED_CAPACITY
  | typeof AWS_DYNAMODB_COUNT
  | typeof AWS_DYNAMODB_EXCLUSIVE_START_TABLE
  | typeof AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES
  | typeof AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES
  | typeof AWS_DYNAMODB_INDEX_NAME
  | typeof AWS_DYNAMODB_ITEM_COLLECTION_METRICS
  | typeof AWS_DYNAMODB_LIMIT
  | typeof AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES
  | typeof AWS_DYNAMODB_PROJECTION
  | typeof AWS_DYNAMODB_PROVISIONED_READ_CAPACITY
  | typeof AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY
  | typeof AWS_DYNAMODB_SCANNED_COUNT
  | typeof AWS_DYNAMODB_SCAN_FORWARD
  | typeof AWS_DYNAMODB_SEGMENT
  | typeof AWS_DYNAMODB_SELECT
  | typeof AWS_DYNAMODB_TABLE_COUNT
  | typeof AWS_DYNAMODB_TABLE_NAMES
  | typeof AWS_DYNAMODB_TOTAL_SEGMENTS
  | typeof AWS_EXTENDED_REQUEST_ID
  | typeof AWS_KINESIS_STREAM_NAME
  | typeof _AWS_KINESIS_STREAM_NAME
  | typeof AWS_LAMBDA_AWS_REQUEST_ID
  | typeof AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS
  | typeof AWS_LAMBDA_FUNCTION_NAME
  | typeof AWS_LAMBDA_FUNCTION_VERSION
  | typeof AWS_LAMBDA_INVOKED_ARN
  | typeof AWS_LAMBDA_INVOKED_FUNCTION_ARN
  | typeof AWS_LAMBDA_REMAINING_TIME_IN_MILLIS
  | typeof AWS_LOG_GROUP_NAMES
  | typeof AWS_LOG_STREAM_NAMES
  | typeof AWS_OPERATION_NAME
  | typeof AWS_REGION
  | typeof AWS_REQUEST_EXTENDED_ID
  | typeof AWS_REQUEST_ID
  | typeof _AWS_REQUEST_ID
  | typeof AWS_REQUEST_URL
  | typeof AWS_S3_BUCKET
  | typeof AWS_S3_COPY_SOURCE
  | typeof AWS_S3_DELETE
  | typeof AWS_S3_KEY
  | typeof AWS_S3_PART_NUMBER
  | typeof AWS_S3_UPLOAD_ID
  | typeof AWS_SECRETSMANAGER_SECRET_ARN
  | typeof AWS_SNS_TOPIC_ARN
  | typeof AWS_SQS_QUEUE_URL
  | typeof AWS_STEP_FUNCTIONS_ACTIVITY_ARN
  | typeof AWS_STEP_FUNCTIONS_EXECUTION_ARN
  | typeof AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN
  | typeof BLOCKED_MAIN_THREAD
  | typeof BROWSER_BFCACHE_FRAME
  | typeof BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT
  | typeof BROWSER_BFCACHE_OUTCOME
  | typeof BROWSER_BFCACHE_REASON
  | typeof BROWSER_NAME
  | typeof BROWSER_NAVIGATION_ID
  | typeof BROWSER_NAVIGATION_TYPE
  | typeof BROWSER_PAINT_TYPE
  | typeof BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START
  | typeof BROWSER_PERFORMANCE_TIME_ORIGIN
  | typeof BROWSER_REPORT_TYPE
  | typeof BROWSER_SCRIPT_INVOKER
  | typeof BROWSER_SCRIPT_INVOKER_TYPE
  | typeof BROWSER_SCRIPT_SOURCE_CHAR_POSITION
  | typeof BROWSER_VERSION
  | typeof BROWSER_WEB_VITAL_CLS_REPORT_EVENT
  | typeof BROWSER_WEB_VITAL_CLS_SOURCE_KEY
  | typeof BROWSER_WEB_VITAL_CLS_VALUE
  | typeof BROWSER_WEB_VITAL_FCP_VALUE
  | typeof BROWSER_WEB_VITAL_FP_VALUE
  | typeof BROWSER_WEB_VITAL_INP_INTERACTION_TYPE
  | typeof BROWSER_WEB_VITAL_INP_TARGET
  | typeof BROWSER_WEB_VITAL_INP_VALUE
  | typeof BROWSER_WEB_VITAL_LCP_ELEMENT
  | typeof BROWSER_WEB_VITAL_LCP_ID
  | typeof BROWSER_WEB_VITAL_LCP_LOAD_TIME
  | typeof BROWSER_WEB_VITAL_LCP_RENDER_TIME
  | typeof BROWSER_WEB_VITAL_LCP_REPORT_EVENT
  | typeof BROWSER_WEB_VITAL_LCP_SIZE
  | typeof BROWSER_WEB_VITAL_LCP_URL
  | typeof BROWSER_WEB_VITAL_LCP_VALUE
  | typeof BROWSER_WEB_VITAL_TTFB_REQUEST_TIME
  | typeof BROWSER_WEB_VITAL_TTFB_VALUE
  | typeof CACHE_HIT
  | typeof CACHE_ITEM_AGE
  | typeof CACHE_ITEM_SIZE
  | typeof CACHE_KEY
  | typeof CACHE_OPERATION
  | typeof CACHE_TAGS
  | typeof CACHE_TTL
  | typeof CACHE_WRITE
  | typeof CHANNEL
  | typeof CLIENT_ADDRESS
  | typeof CLIENT_PORT
  | typeof CLOUDFLARE_D1_DURATION
  | typeof CLOUDFLARE_D1_QUERY_TYPE
  | typeof CLOUDFLARE_D1_ROWS_READ
  | typeof CLOUDFLARE_D1_ROWS_WRITTEN
  | typeof CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS
  | typeof CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ
  | typeof CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN
  | typeof CLOUDFLARE_R2_BUCKET
  | typeof CLOUDFLARE_R2_OPERATION
  | typeof CLOUDFLARE_R2_REQUEST_DELIMITER
  | typeof CLOUDFLARE_R2_REQUEST_KEY
  | typeof CLOUDFLARE_R2_REQUEST_PART_NUMBER
  | typeof CLOUDFLARE_R2_REQUEST_PREFIX
  | typeof CLOUDFLARE_WORKFLOW_ATTEMPT
  | typeof CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF
  | typeof CLOUDFLARE_WORKFLOW_RETRIES_DELAY
  | typeof CLOUDFLARE_WORKFLOW_RETRIES_LIMIT
  | typeof CLOUDFLARE_WORKFLOW_TIMEOUT
  | typeof CLOUD_ACCOUNT_ID
  | typeof CLOUD_AVAILABILITY_ZONE
  | typeof CLOUD_PLATFORM
  | typeof CLOUD_PROVIDER
  | typeof CLOUD_REGION
  | typeof CLOUD_RESOURCE_ID
  | typeof CLS
  | typeof CLS_SOURCE_KEY
  | typeof CODE
  | typeof CODE_FILEPATH
  | typeof CODE_FILE_PATH
  | typeof CODE_FUNCTION
  | typeof CODE_FUNCTION_NAME
  | typeof CODE_LINENO
  | typeof CODE_LINE_NUMBER
  | typeof CODE_NAMESPACE
  | typeof CONNECTIONTYPE
  | typeof CONNECTION_RTT
  | typeof CULTURE_CALENDAR
  | typeof CULTURE_DISPLAY_NAME
  | typeof CULTURE_IS_24_HOUR_FORMAT
  | typeof CULTURE_LOCALE
  | typeof CULTURE_TIMEZONE
  | typeof DB_COLLECTION_NAME
  | typeof DB_CONNECTION_STRING
  | typeof DB_DRIVER_NAME
  | typeof DB_MONGODB_COLLECTION
  | typeof DB_NAME
  | typeof DB_NAMESPACE
  | typeof DB_OPERATION
  | typeof DB_OPERATION_BATCH_SIZE
  | typeof DB_OPERATION_NAME
  | typeof DB_PARAMS
  | typeof DB_QUERY_PARAMETER_KEY
  | typeof DB_QUERY_SUMMARY
  | typeof DB_QUERY_TEXT
  | typeof DB_REDIS_CONNECTION
  | typeof DB_REDIS_KEY
  | typeof DB_REDIS_PARAMETERS
  | typeof DB_RESPONSE_STATUS_CODE
  | typeof DB_SQL_BINDINGS
  | typeof DB_STATEMENT
  | typeof DB_STORED_PROCEDURE_NAME
  | typeof DB_SYSTEM
  | typeof DB_SYSTEM_NAME
  | typeof DB_USER
  | typeof DEVICEMEMORY
  | typeof DEVICE_ARCHS
  | typeof DEVICE_BATTERY_LEVEL
  | typeof DEVICE_BATTERY_TEMPERATURE
  | typeof DEVICE_BOOT_TIME
  | typeof DEVICE_BRAND
  | typeof DEVICE_CHARGING
  | typeof DEVICE_CHIPSET
  | typeof DEVICE_CLASS
  | typeof DEVICE_CONNECTION_TYPE
  | typeof DEVICE_CPU_DESCRIPTION
  | typeof DEVICE_EXTERNAL_FREE_STORAGE
  | typeof DEVICE_EXTERNAL_STORAGE_SIZE
  | typeof DEVICE_FAMILY
  | typeof DEVICE_FREE_MEMORY
  | typeof DEVICE_FREE_STORAGE
  | typeof DEVICE_ID
  | typeof DEVICE_LOCALE
  | typeof DEVICE_LOW_MEMORY
  | typeof DEVICE_LOW_POWER_MODE
  | typeof DEVICE_MANUFACTURER
  | typeof DEVICE_MEMORY_ESTIMATED_CAPACITY
  | typeof DEVICE_MEMORY_SIZE
  | typeof DEVICE_MODEL
  | typeof DEVICE_MODEL_ID
  | typeof DEVICE_NAME
  | typeof DEVICE_ONLINE
  | typeof DEVICE_ORIENTATION
  | typeof DEVICE_PROCESSOR_COUNT
  | typeof DEVICE_PROCESSOR_FREQUENCY
  | typeof DEVICE_SCREEN_DENSITY
  | typeof DEVICE_SCREEN_DPI
  | typeof DEVICE_SCREEN_HEIGHT_PIXELS
  | typeof DEVICE_SCREEN_WIDTH_PIXELS
  | typeof DEVICE_SIMULATOR
  | typeof DEVICE_STORAGE_SIZE
  | typeof DEVICE_THERMAL_STATE
  | typeof DEVICE_TIMEZONE
  | typeof DEVICE_USABLE_MEMORY
  | typeof DIST
  | typeof DJANGO_FUNCTION_NAME
  | typeof DJANGO_MIDDLEWARE_NAME
  | typeof EFFECTIVECONNECTIONTYPE
  | typeof ENVIRONMENT
  | typeof ERROR_TYPE
  | typeof EVENT_ID
  | typeof EVENT_NAME
  | typeof EXCEPTION_ESCAPED
  | typeof EXCEPTION_MESSAGE
  | typeof EXCEPTION_STACKTRACE
  | typeof EXCEPTION_TYPE
  | typeof FAAS_COLDSTART
  | typeof FAAS_CRON
  | typeof FAAS_DURATION_IN_MS
  | typeof FAAS_ENTRY_POINT
  | typeof FAAS_EXECUTION
  | typeof FAAS_ID
  | typeof FAAS_IDENTITY
  | typeof FAAS_INVOCATION_ID
  | typeof FAAS_INVOKED_NAME
  | typeof FAAS_INVOKED_PROVIDER
  | typeof FAAS_INVOKED_REGION
  | typeof FAAS_NAME
  | typeof FAAS_TIME
  | typeof FAAS_TRIGGER
  | typeof FAAS_VERSION
  | typeof FCP
  | typeof FILE_PATH
  | typeof FILE_SIZE
  | typeof FLAG_EVALUATION_KEY
  | typeof FP
  | typeof FRAMES_DELAY
  | typeof FRAMES_FROZEN
  | typeof FRAMES_FROZEN_RATE
  | typeof FRAMES_SLOW
  | typeof FRAMES_SLOW_RATE
  | typeof FRAMES_TOTAL
  | typeof FS_ERROR
  | typeof GCP_FUNCTION_CONTEXT_EVENT_ID
  | typeof GCP_FUNCTION_CONTEXT_EVENT_TYPE
  | typeof GCP_FUNCTION_CONTEXT_ID
  | typeof GCP_FUNCTION_CONTEXT_RESOURCE
  | typeof GCP_FUNCTION_CONTEXT_SOURCE
  | typeof GCP_FUNCTION_CONTEXT_SPECVERSION
  | typeof GCP_FUNCTION_CONTEXT_TIME
  | typeof GCP_FUNCTION_CONTEXT_TIMESTAMP
  | typeof GCP_FUNCTION_CONTEXT_TYPE
  | typeof GCP_PROJECT_ID
  | typeof GCP_REGION
  | typeof GEN_AI_AGENT_NAME
  | typeof GEN_AI_CONTEXT_UTILIZATION
  | typeof GEN_AI_CONTEXT_WINDOW_SIZE
  | typeof GEN_AI_CONVERSATION_ID
  | typeof GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS
  | typeof GEN_AI_COST_CACHE_READ_INPUT_TOKENS
  | typeof GEN_AI_COST_INPUT_TOKENS
  | typeof GEN_AI_COST_OUTPUT_TOKENS
  | typeof GEN_AI_COST_REASONING_OUTPUT_TOKENS
  | typeof GEN_AI_COST_TOTAL_TOKENS
  | typeof GEN_AI_EMBEDDINGS_INPUT
  | typeof GEN_AI_FUNCTION_ID
  | typeof GEN_AI_INPUT_MESSAGES
  | typeof GEN_AI_MEMORY_QUERY_TEXT
  | typeof GEN_AI_MEMORY_RECORDS
  | typeof GEN_AI_MEMORY_RECORD_COUNT
  | typeof GEN_AI_MEMORY_RECORD_ID
  | typeof GEN_AI_MEMORY_STORE_ID
  | typeof GEN_AI_OPERATION_NAME
  | typeof GEN_AI_OPERATION_TYPE
  | typeof GEN_AI_OUTPUT_MESSAGES
  | typeof GEN_AI_PIPELINE_NAME
  | typeof GEN_AI_PROMPT
  | typeof GEN_AI_PROMPT_NAME
  | typeof GEN_AI_PROMPT_VARIABLE_KEY
  | typeof GEN_AI_PROVIDER_NAME
  | typeof GEN_AI_REQUEST_AVAILABLE_TOOLS
  | typeof GEN_AI_REQUEST_FREQUENCY_PENALTY
  | typeof GEN_AI_REQUEST_MAX_TOKENS
  | typeof GEN_AI_REQUEST_MESSAGES
  | typeof GEN_AI_REQUEST_MODEL
  | typeof GEN_AI_REQUEST_PRESENCE_PENALTY
  | typeof GEN_AI_REQUEST_REASONING_LEVEL
  | typeof GEN_AI_REQUEST_SCHEMA
  | typeof GEN_AI_REQUEST_SEED
  | typeof GEN_AI_REQUEST_STOP_SEQUENCES
  | typeof GEN_AI_REQUEST_TEMPERATURE
  | typeof GEN_AI_REQUEST_TOP_K
  | typeof GEN_AI_REQUEST_TOP_P
  | typeof GEN_AI_RESPONSE_FINISH_REASON
  | typeof GEN_AI_RESPONSE_FINISH_REASONS
  | typeof GEN_AI_RESPONSE_ID
  | typeof GEN_AI_RESPONSE_MODEL
  | typeof GEN_AI_RESPONSE_OBJECT
  | typeof GEN_AI_RESPONSE_STREAMING
  | typeof GEN_AI_RESPONSE_TEXT
  | typeof GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK
  | typeof GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN
  | typeof GEN_AI_RESPONSE_TOKENS_PER_SECOND
  | typeof GEN_AI_RESPONSE_TOOL_CALLS
  | typeof GEN_AI_SYSTEM
  | typeof GEN_AI_SYSTEM_INSTRUCTIONS
  | typeof GEN_AI_SYSTEM_MESSAGE
  | typeof GEN_AI_TOOL_CALL_ARGUMENTS
  | typeof GEN_AI_TOOL_CALL_RESULT
  | typeof GEN_AI_TOOL_DEFINITIONS
  | typeof GEN_AI_TOOL_DESCRIPTION
  | typeof GEN_AI_TOOL_INPUT
  | typeof GEN_AI_TOOL_MESSAGE
  | typeof GEN_AI_TOOL_NAME
  | typeof GEN_AI_TOOL_OUTPUT
  | typeof GEN_AI_TOOL_TYPE
  | typeof GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS
  | typeof _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS
  | typeof GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS
  | typeof _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS
  | typeof GEN_AI_USAGE_COMPLETION_TOKENS
  | typeof GEN_AI_USAGE_INPUT_TOKENS
  | typeof GEN_AI_USAGE_INPUT_TOKENS_CACHED
  | typeof GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE
  | typeof GEN_AI_USAGE_OUTPUT_TOKENS
  | typeof GEN_AI_USAGE_OUTPUT_TOKENS_REASONING
  | typeof GEN_AI_USAGE_PROMPT_TOKENS
  | typeof GEN_AI_USAGE_REASONING_OUTPUT_TOKENS
  | typeof GEN_AI_USAGE_TOTAL_TOKENS
  | typeof GRAPHQL_DOCUMENT
  | typeof GRAPHQL_OPERATION_NAME
  | typeof GRAPHQL_OPERATION_TYPE
  | typeof GRAPHQL_PROCESSING_TYPE
  | typeof GRAPHQL_SOURCE
  | typeof GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS
  | typeof GRPC_ERROR_DEBUG_INFO_DETAIL
  | typeof GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES
  | typeof GRPC_ERROR_ERROR_INFO_DOMAIN
  | typeof GRPC_ERROR_ERROR_INFO_METADATA_KEY
  | typeof GRPC_ERROR_ERROR_INFO_REASON
  | typeof GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS
  | typeof GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS
  | typeof GRPC_ERROR_RESOURCE_INFO_DESCRIPTION
  | typeof GRPC_ERROR_RESOURCE_INFO_OWNER
  | typeof GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME
  | typeof GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE
  | typeof GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS
  | typeof HARDWARECONCURRENCY
  | typeof HTTP_CLIENT_IP
  | typeof HTTP_DECODED_RESPONSE_CONTENT_LENGTH
  | typeof HTTP_FLAVOR
  | typeof HTTP_FRAGMENT
  | typeof HTTP_HOST
  | typeof HTTP_METHOD
  | typeof HTTP_QUERY
  | typeof HTTP_REQUEST_BODY_DATA
  | typeof HTTP_REQUEST_BODY_DECODED_SIZE
  | typeof HTTP_REQUEST_BODY_SIZE
  | typeof HTTP_REQUEST_CONNECTION_END
  | typeof HTTP_REQUEST_CONNECT_START
  | typeof HTTP_REQUEST_CONTENT_LENGTH
  | typeof HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED
  | typeof HTTP_REQUEST_DOMAIN_LOOKUP_END
  | typeof HTTP_REQUEST_DOMAIN_LOOKUP_START
  | typeof HTTP_REQUEST_FETCH_START
  | typeof HTTP_REQUEST_HEADER_KEY
  | typeof HTTP_REQUEST_METHOD
  | typeof _HTTP_REQUEST_METHOD
  | typeof HTTP_REQUEST_REDIRECT_END
  | typeof HTTP_REQUEST_REDIRECT_START
  | typeof HTTP_REQUEST_REQUEST_START
  | typeof HTTP_REQUEST_RESEND_COUNT
  | typeof HTTP_REQUEST_RESPONSE_END
  | typeof HTTP_REQUEST_RESPONSE_START
  | typeof HTTP_REQUEST_SAME_ORIGIN
  | typeof HTTP_REQUEST_SECURE_CONNECTION_START
  | typeof HTTP_REQUEST_TIME_TO_FIRST_BYTE
  | typeof HTTP_REQUEST_WORKER_START
  | typeof HTTP_RESPONSE_BODY_DECODED_SIZE
  | typeof HTTP_RESPONSE_BODY_SIZE
  | typeof HTTP_RESPONSE_CONTENT_LENGTH
  | typeof HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED
  | typeof HTTP_RESPONSE_HEADER_CONTENT_LENGTH
  | typeof HTTP_RESPONSE_HEADER_KEY
  | typeof HTTP_RESPONSE_SIZE
  | typeof HTTP_RESPONSE_STATUS_CODE
  | typeof HTTP_RESPONSE_STATUS_TEXT
  | typeof HTTP_RESPONSE_TRANSFER_SIZE
  | typeof HTTP_ROUTE
  | typeof HTTP_SCHEME
  | typeof HTTP_SERVER_NAME
  | typeof HTTP_SERVER_REQUEST_TIME_IN_QUEUE
  | typeof HTTP_STATUS_CODE
  | typeof HTTP_STATUS_TEXT
  | typeof HTTP_TARGET
  | typeof HTTP_URL
  | typeof HTTP_USER_AGENT
  | typeof ID
  | typeof INP
  | typeof INTEGRITY_BLOCKED_URL
  | typeof INTEGRITY_DESTINATION
  | typeof INTEGRITY_DOCUMENT_URL
  | typeof INTEGRITY_REPORT_ONLY
  | typeof JSONRPC_PROTOCOL_VERSION
  | typeof JSONRPC_REQUEST_ID
  | typeof JVM_GC_ACTION
  | typeof JVM_GC_NAME
  | typeof JVM_MEMORY_POOL_NAME
  | typeof JVM_MEMORY_TYPE
  | typeof JVM_THREAD_DAEMON
  | typeof JVM_THREAD_STATE
  | typeof KOA_NAME
  | typeof KOA_TYPE
  | typeof LANGCHAIN_CHAIN_NAME
  | typeof LCP
  | typeof LCP_ELEMENT
  | typeof LCP_ID
  | typeof LCP_LOADTIME
  | typeof LCP_RENDERTIME
  | typeof LCP_SIZE
  | typeof LCP_URL
  | typeof LITESTAR_MIDDLEWARE_NAME
  | typeof LOGGER_NAME
  | typeof MCP_AUTH_CLIENT_NAME
  | typeof MCP_CANCELLED_REASON
  | typeof MCP_CANCELLED_REQUEST_ID
  | typeof MCP_CLIENT_NAME
  | typeof MCP_CLIENT_TITLE
  | typeof MCP_CLIENT_VERSION
  | typeof MCP_LIFECYCLE_PHASE
  | typeof MCP_LOGGING_DATA_TYPE
  | typeof MCP_LOGGING_LEVEL
  | typeof MCP_LOGGING_LOGGER
  | typeof MCP_LOGGING_MESSAGE
  | typeof MCP_METHOD_NAME
  | typeof MCP_PROGRESS_CURRENT
  | typeof MCP_PROGRESS_MESSAGE
  | typeof MCP_PROGRESS_PERCENTAGE
  | typeof MCP_PROGRESS_TOKEN
  | typeof MCP_PROGRESS_TOTAL
  | typeof MCP_PROMPT_NAME
  | typeof MCP_PROMPT_RESULT_DESCRIPTION
  | typeof MCP_PROMPT_RESULT_KEY_CONTENT
  | typeof MCP_PROMPT_RESULT_KEY_ROLE
  | typeof MCP_PROMPT_RESULT_MESSAGE_CONTENT
  | typeof MCP_PROMPT_RESULT_MESSAGE_COUNT
  | typeof MCP_PROMPT_RESULT_MESSAGE_ROLE
  | typeof MCP_PROTOCOL_READY
  | typeof MCP_PROTOCOL_VERSION
  | typeof MCP_REQUEST_ARGUMENT_KEY
  | typeof MCP_REQUEST_ARGUMENT_NAME
  | typeof MCP_REQUEST_ARGUMENT_URI
  | typeof MCP_REQUEST_ID
  | typeof MCP_RESOURCE_PROTOCOL
  | typeof MCP_RESOURCE_URI
  | typeof MCP_SERVER_NAME
  | typeof MCP_SERVER_TITLE
  | typeof MCP_SERVER_VERSION
  | typeof MCP_SESSION_ID
  | typeof MCP_TOOL_NAME
  | typeof MCP_TOOL_RESULT_CONTENT
  | typeof MCP_TOOL_RESULT_CONTENT_COUNT
  | typeof MCP_TOOL_RESULT_CONTENT_TYPE
  | typeof MCP_TOOL_RESULT_DATA_SIZE
  | typeof MCP_TOOL_RESULT_IS_ERROR
  | typeof MCP_TOOL_RESULT_KEY_CONTENT
  | typeof MCP_TOOL_RESULT_KEY_CONTENT_TYPE
  | typeof MCP_TOOL_RESULT_KEY_DATA_SIZE
  | typeof MCP_TOOL_RESULT_KEY_MIME_TYPE
  | typeof MCP_TOOL_RESULT_KEY_NAME
  | typeof MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE
  | typeof MCP_TOOL_RESULT_KEY_RESOURCE_URI
  | typeof MCP_TOOL_RESULT_KEY_URI
  | typeof MCP_TOOL_RESULT_MIME_TYPE
  | typeof MCP_TOOL_RESULT_NAME
  | typeof MCP_TOOL_RESULT_RESOURCE_MIME_TYPE
  | typeof MCP_TOOL_RESULT_RESOURCE_URI
  | typeof MCP_TOOL_RESULT_URI
  | typeof MCP_TRANSPORT
  | typeof MDC_KEY
  | typeof MESSAGING_BATCH_MESSAGE_COUNT
  | typeof MESSAGING_CONVERSATION_ID
  | typeof MESSAGING_DESTINATION
  | typeof MESSAGING_DESTINATION_CONNECTION
  | typeof MESSAGING_DESTINATION_KIND
  | typeof MESSAGING_DESTINATION_NAME
  | typeof MESSAGING_DESTINATION_PARTITION_ID
  | typeof MESSAGING_KAFKA_MESSAGE_KEY
  | typeof MESSAGING_KAFKA_MESSAGE_TOMBSTONE
  | typeof MESSAGING_KAFKA_OFFSET
  | typeof MESSAGING_MESSAGE_BODY_SIZE
  | typeof MESSAGING_MESSAGE_CONVERSATION_ID
  | typeof MESSAGING_MESSAGE_ENVELOPE_SIZE
  | typeof MESSAGING_MESSAGE_ID
  | typeof _MESSAGING_MESSAGE_ID
  | typeof MESSAGING_MESSAGE_RECEIVE_LATENCY
  | typeof MESSAGING_MESSAGE_RETRY_COUNT
  | typeof MESSAGING_OPERATION
  | typeof MESSAGING_OPERATION_NAME
  | typeof MESSAGING_OPERATION_TYPE
  | typeof MESSAGING_PROTOCOL
  | typeof MESSAGING_PROTOCOL_VERSION
  | typeof MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY
  | typeof MESSAGING_RABBITMQ_ROUTING_KEY
  | typeof MESSAGING_SYSTEM
  | typeof MESSAGING_URL
  | typeof METHOD
  | typeof MIDDLEWARE_NAME
  | typeof NAVIGATION_ORIGIN
  | typeof NAVIGATION_ROUTE_ID
  | typeof NAVIGATION_TYPE
  | typeof NEL_ELAPSED_TIME
  | typeof NEL_PHASE
  | typeof NEL_REFERRER
  | typeof NEL_SAMPLING_FRACTION
  | typeof NEL_SAMPLING_FUNCTION
  | typeof NEL_TYPE
  | typeof NETWORK_CONNECTION_EFFECTIVE_TYPE
  | typeof NETWORK_CONNECTION_RTT
  | typeof NETWORK_CONNECTION_TYPE
  | typeof NETWORK_LOCAL_ADDRESS
  | typeof NETWORK_LOCAL_PORT
  | typeof NETWORK_PEER_ADDRESS
  | typeof NETWORK_PEER_PORT
  | typeof NETWORK_PROTOCOL_NAME
  | typeof NETWORK_PROTOCOL_VERSION
  | typeof NETWORK_TRANSPORT
  | typeof NETWORK_TYPE
  | typeof NET_HOST_IP
  | typeof NET_HOST_NAME
  | typeof NET_HOST_PORT
  | typeof NET_PEER_IP
  | typeof NET_PEER_NAME
  | typeof NET_PEER_PORT
  | typeof NET_PROTOCOL_NAME
  | typeof NET_PROTOCOL_VERSION
  | typeof NET_SOCK_FAMILY
  | typeof NET_SOCK_HOST_ADDR
  | typeof NET_SOCK_HOST_PORT
  | typeof NET_SOCK_PEER_ADDR
  | typeof NET_SOCK_PEER_NAME
  | typeof NET_SOCK_PEER_PORT
  | typeof NET_TRANSPORT
  | typeof OS_BUILD
  | typeof OS_BUILD_ID
  | typeof OS_DESCRIPTION
  | typeof OS_KERNEL_VERSION
  | typeof OS_NAME
  | typeof OS_RAW_DESCRIPTION
  | typeof OS_ROOTED
  | typeof OS_THEME
  | typeof OS_TYPE
  | typeof OS_VERSION
  | typeof OTEL_KIND
  | typeof OTEL_SCOPE_NAME
  | typeof OTEL_SCOPE_VERSION
  | typeof OTEL_STATUS_CODE
  | typeof OTEL_STATUS_DESCRIPTION
  | typeof PARAMS_KEY
  | typeof PERFORMANCE_ACTIVATIONSTART
  | typeof PERFORMANCE_TIMEORIGIN
  | typeof PORT
  | typeof PREVIOUS_ROUTE
  | typeof PROCESS_COMMAND_ARGS
  | typeof PROCESS_EXECUTABLE_NAME
  | typeof PROCESS_PID
  | typeof PROCESS_RUNTIME_DESCRIPTION
  | typeof PROCESS_RUNTIME_ENGINE_NAME
  | typeof PROCESS_RUNTIME_ENGINE_VERSION
  | typeof PROCESS_RUNTIME_NAME
  | typeof PROCESS_RUNTIME_VERSION
  | typeof PROFILE_ID
  | typeof QUERY
  | typeof QUERY_KEY
  | typeof REACT_NATIVE_ARCHITECTURE
  | typeof REACT_NATIVE_MODULE_CALL_COUNT
  | typeof REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT
  | typeof REACT_NATIVE_MODULE_DURATION_MAX
  | typeof REACT_NATIVE_MODULE_DURATION_TOTAL
  | typeof REACT_NATIVE_MODULE_ERROR_COUNT
  | typeof REACT_NATIVE_MODULE_KIND
  | typeof REACT_NATIVE_MODULE_METHOD
  | typeof REACT_NATIVE_MODULE_NAME
  | typeof REACT_NATIVE_MODULE_TOP_DURATION
  | typeof REACT_NATIVE_MODULE_TOP_NAME
  | typeof REACT_VERSION
  | typeof REDIS_COMMAND
  | typeof REDIS_KEY
  | typeof RELEASE
  | typeof REMIX_ACTION_FORM_DATA_KEY
  | typeof REPLAYID
  | typeof REPLAY_ID
  | typeof RESOURCE_DEPLOYMENT_ENVIRONMENT
  | typeof RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME
  | typeof RESOURCE_RENDER_BLOCKING_STATUS
  | typeof ROUTE
  | typeof ROUTER_NAVIGATION_ORIGIN
  | typeof ROUTER_NAVIGATION_ROUTE_ID
  | typeof ROUTER_NAVIGATION_TYPE
  | typeof RPC_GRPC_STATUS_CODE
  | typeof RPC_METHOD
  | typeof RPC_RESPONSE_STATUS_CODE
  | typeof RPC_SERVICE
  | typeof RPC_SYSTEM
  | typeof RPC_SYSTEM_NAME
  | typeof RUNTIME_BUILD
  | typeof RUNTIME_NAME
  | typeof RUNTIME_RAW_DESCRIPTION
  | typeof RUNTIME_VERSION
  | typeof SCORE_KEY
  | typeof SCORE_RATIO_KEY
  | typeof SCORE_TOTAL
  | typeof SCORE_WEIGHT_KEY
  | typeof SENTRY_ACTION
  | typeof SENTRY_BROWSER_NAME
  | typeof SENTRY_BROWSER_VERSION
  | typeof SENTRY_CANCELLATION_REASON
  | typeof SENTRY_CATEGORY
  | typeof SENTRY_CLIENT_SAMPLE_RATE
  | typeof SENTRY_DESCRIPTION
  | typeof SENTRY_DIST
  | typeof SENTRY_DOMAIN
  | typeof SENTRY_DSC_ENVIRONMENT
  | typeof SENTRY_DSC_PROJECT_ID
  | typeof SENTRY_DSC_PUBLIC_KEY
  | typeof SENTRY_DSC_RELEASE
  | typeof SENTRY_DSC_SAMPLED
  | typeof SENTRY_DSC_SAMPLE_RATE
  | typeof SENTRY_DSC_TRACE_ID
  | typeof SENTRY_DSC_TRANSACTION
  | typeof SENTRY_ENVIRONMENT
  | typeof SENTRY_EVENT_SERIALIZED_BREADCRUMBS
  | typeof SENTRY_EVENT_SERIALIZED_CONTEXTS
  | typeof SENTRY_EVENT_SERIALIZED_EXTRA
  | typeof SENTRY_EVENT_SERIALIZED_META
  | typeof SENTRY_EXCLUSIVE_TIME
  | typeof SENTRY_FRAMES_FROZEN
  | typeof SENTRY_FRAMES_SLOW
  | typeof SENTRY_FRAMES_TOTAL
  | typeof SENTRY_GRAPHQL_OPERATION
  | typeof SENTRY_GROUP
  | typeof SENTRY_HTTP_PREFETCH
  | typeof SENTRY_IDLE_SPAN_FINISH_REASON
  | typeof SENTRY_IS_LOCALHOST
  | typeof SENTRY_IS_REMOTE
  | typeof SENTRY_KIND
  | typeof SENTRY_LINK_TYPE
  | typeof SENTRY_MAIN_THREAD
  | typeof SENTRY_MESSAGE_PARAMETER_KEY
  | typeof SENTRY_MESSAGE_TEMPLATE
  | typeof SENTRY_METRIC_SOURCE
  | typeof SENTRY_MOBILE
  | typeof SENTRY_MODULE_KEY
  | typeof SENTRY_NEXTJS_SSR_FUNCTION_ROUTE
  | typeof SENTRY_NEXTJS_SSR_FUNCTION_TYPE
  | typeof SENTRY_NORMALIZED_DB_QUERY
  | typeof SENTRY_NORMALIZED_DB_QUERY_HASH
  | typeof SENTRY_NORMALIZED_DESCRIPTION
  | typeof SENTRY_OBSERVED_TIMESTAMP_NANOS
  | typeof SENTRY_OP
  | typeof SENTRY_ORIGIN
  | typeof SENTRY_PAGELOAD_SPAN_ID
  | typeof SENTRY_PLATFORM
  | typeof SENTRY_PROFILER_ID
  | typeof SENTRY_PROFILE_ID
  | typeof SENTRY_RELAY_INGRESS
  | typeof SENTRY_RELAY_PIPELINE
  | typeof SENTRY_RELEASE
  | typeof SENTRY_REPLAY_ID
  | typeof SENTRY_REPLAY_IS_BUFFERING
  | typeof SENTRY_REPORT_EVENT
  | typeof SENTRY_SDK_INTEGRATIONS
  | typeof SENTRY_SDK_NAME
  | typeof SENTRY_SDK_VERSION
  | typeof SENTRY_SEGMENT_ID
  | typeof _SENTRY_SEGMENT_ID
  | typeof SENTRY_SEGMENT_NAME
  | typeof SENTRY_SEGMENT_NAME_SOURCE
  | typeof SENTRY_SERVER_SAMPLE_RATE
  | typeof SENTRY_SOURCE
  | typeof SENTRY_SPAN_SOURCE
  | typeof SENTRY_STATUS
  | typeof SENTRY_STATUS_CODE
  | typeof SENTRY_STATUS_MESSAGE
  | typeof SENTRY_SVELTEKIT_NAVIGATION_FROM
  | typeof SENTRY_SVELTEKIT_NAVIGATION_TO
  | typeof SENTRY_SVELTEKIT_NAVIGATION_TYPE
  | typeof SENTRY_THREAD_ID
  | typeof SENTRY_TIMESTAMP_SEQUENCE
  | typeof SENTRY_TRACE_LIFECYCLE
  | typeof SENTRY_TRACE_PARENT_SPAN_ID
  | typeof SENTRY_TRACE_STATUS
  | typeof SENTRY_TRANSACTION
  | typeof SENTRY_USER_EMAIL
  | typeof SENTRY_USER_GEO_CITY
  | typeof SENTRY_USER_GEO_COUNTRY_CODE
  | typeof SENTRY_USER_GEO_REGION
  | typeof SENTRY_USER_GEO_SUBDIVISION
  | typeof SENTRY_USER_ID
  | typeof SENTRY_USER_IP
  | typeof SENTRY_USER_USERNAME
  | typeof SERVER_ADDRESS
  | typeof SERVER_NAME
  | typeof SERVER_PORT
  | typeof SERVICE_NAME
  | typeof SERVICE_VERSION
  | typeof SESSION_ID
  | typeof STALL_PERCENTAGE
  | typeof STALL_TOTAL_TIME
  | typeof STARLETTE_MIDDLEWARE_NAME
  | typeof STARLITE_MIDDLEWARE_NAME
  | typeof STATE_TYPE
  | typeof SUBPROCESS_PID
  | typeof SVELTEKIT_LOAD_ENVIRONMENT
  | typeof SVELTEKIT_LOAD_NODE_ID
  | typeof SVELTEKIT_LOAD_NODE_TYPE
  | typeof SVELTEKIT_TRACING_ORIGINAL_NAME
  | typeof THREAD_ID
  | typeof THREAD_NAME
  | typeof TIMBER_TAG
  | typeof TIME_TO_FULL_DISPLAY
  | typeof TIME_TO_INITIAL_DISPLAY
  | typeof TRANSACTION
  | typeof TRPC_PROCEDURE_PATH
  | typeof TRPC_PROCEDURE_TYPE
  | typeof TTFB
  | typeof TTFB_REQUESTTIME
  | typeof TURBO_MODULES_TOTAL_CALL_COUNT
  | typeof TURBO_MODULES_TOTAL_DURATION_MS
  | typeof TURBO_MODULES_TOTAL_ERROR_COUNT
  | typeof TURBO_MODULES_UNIQUE_METHODS
  | typeof TURBO_MODULE_ARCH
  | typeof TURBO_MODULE_METHOD
  | typeof TURBO_MODULE_NAME
  | typeof TURBO_MODULE_TOP_MODULE
  | typeof TURBO_MODULE_TOP_MODULE_DURATION_MS
  | typeof TURBO_MODULE_TOTAL_CALL_COUNT
  | typeof TURBO_MODULE_TOTAL_DURATION_MS
  | typeof TURBO_MODULE_TOTAL_ERROR_COUNT
  | typeof TURBO_MODULE_UNIQUE_METHODS
  | typeof TYPE
  | typeof UI_COMPONENT_NAME
  | typeof UI_CONTRIBUTES_TO_TTFD
  | typeof UI_CONTRIBUTES_TO_TTID
  | typeof UI_ELEMENT_HEIGHT
  | typeof UI_ELEMENT_ID
  | typeof UI_ELEMENT_IDENTIFIER
  | typeof UI_ELEMENT_LOAD_TIME
  | typeof UI_ELEMENT_PAINT_TYPE
  | typeof UI_ELEMENT_RENDER_TIME
  | typeof UI_ELEMENT_TYPE
  | typeof UI_ELEMENT_URL
  | typeof UI_ELEMENT_WIDTH
  | typeof URL
  | typeof URL_DOMAIN
  | typeof URL_FRAGMENT
  | typeof URL_FULL
  | typeof URL_PATH
  | typeof URL_PATH_PARAMETER_KEY
  | typeof URL_PATH_PARAMS_KEY
  | typeof URL_PORT
  | typeof URL_QUERY
  | typeof URL_SAME_ORIGIN
  | typeof URL_SCHEME
  | typeof URL_TEMPLATE
  | typeof USER_AGENT_ORIGINAL
  | typeof USER_EMAIL
  | typeof USER_FULL_NAME
  | typeof USER_GEO_CITY
  | typeof USER_GEO_COUNTRY_CODE
  | typeof USER_GEO_REGION
  | typeof USER_GEO_SUBDIVISION
  | typeof USER_HASH
  | typeof USER_ID
  | typeof USER_IP_ADDRESS
  | typeof USER_NAME
  | typeof USER_ROLES
  | typeof VERCEL_AI_TELEMETRY_METADATA_KEY
  | typeof VERCEL_BRANCH
  | typeof VERCEL_BUILD_ID
  | typeof VERCEL_DEPLOYMENT_ID
  | typeof VERCEL_DESTINATION
  | typeof VERCEL_EDGE_TYPE
  | typeof VERCEL_ENTRYPOINT
  | typeof VERCEL_EXECUTION_REGION
  | typeof VERCEL_ID
  | typeof VERCEL_JA3_DIGEST
  | typeof VERCEL_JA4_DIGEST
  | typeof VERCEL_LOG_TYPE
  | typeof VERCEL_PATH
  | typeof VERCEL_PROJECT_ID
  | typeof VERCEL_PROJECT_NAME
  | typeof VERCEL_PROXY_CACHE_ID
  | typeof VERCEL_PROXY_CLIENT_IP
  | typeof VERCEL_PROXY_HOST
  | typeof VERCEL_PROXY_LAMBDA_REGION
  | typeof VERCEL_PROXY_METHOD
  | typeof VERCEL_PROXY_PATH
  | typeof VERCEL_PROXY_PATH_TYPE
  | typeof VERCEL_PROXY_PATH_TYPE_VARIANT
  | typeof VERCEL_PROXY_REFERER
  | typeof VERCEL_PROXY_REGION
  | typeof VERCEL_PROXY_RESPONSE_BYTE_SIZE
  | typeof VERCEL_PROXY_SCHEME
  | typeof VERCEL_PROXY_STATUS_CODE
  | typeof VERCEL_PROXY_TIMESTAMP
  | typeof VERCEL_PROXY_USER_AGENT
  | typeof VERCEL_PROXY_VERCEL_CACHE
  | typeof VERCEL_PROXY_VERCEL_ID
  | typeof VERCEL_PROXY_WAF_ACTION
  | typeof VERCEL_PROXY_WAF_RULE_ID
  | typeof VERCEL_REQUEST_ID
  | typeof VERCEL_SOURCE
  | typeof VERCEL_STATUS_CODE;

export const ATTRIBUTE_METADATA: Record<AttributeName, AttributeMetadata> = {
  address: {
    brief: 'The destination hostname or IP address for a TCP connection.',
    type: 'string',
    keys: ['server.address', 'address', 'http.server_name', 'net.host.name', 'server_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example.com',
    examples: ['example.com'],
    deprecation: {
      replacement: 'server.address',
      reason: 'Old namespace-less attribute, to be replaced with server.address for span-first future',
      status: 'backfill',
    },
    aliases: ['server.address', 'http.server_name', 'net.host.name', 'http.host', 'server_name', 'net.peer.name'],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Added server_name as an alias' },
      { version: '0.21.0', prs: [588, 602], description: 'Added net.peer.name as an alias' },
      { version: '0.19.0', prs: [534], description: 'Added address attribute' },
    ],
  },
  'ai.citations': {
    brief: 'References or sources cited by the AI model in its response.',
    type: 'string[]',
    keys: ['ai.citations'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['Citation 1', 'Citation 2'],
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.completion_tokens.used': {
    brief: 'The number of tokens used to respond to the message.',
    type: 'integer',
    keys: ['gen_ai.usage.output_tokens', 'ai.completion_tokens.used', 'gen_ai.usage.completion_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 10,
    deprecation: {
      replacement: 'gen_ai.usage.output_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.output_tokens', 'gen_ai.usage.completion_tokens'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [57, 61] }, { version: '0.0.0' }],
  },
  'ai.documents': {
    brief: 'Documents or content chunks used as context for the AI model.',
    type: 'string[]',
    keys: ['ai.documents'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['document1.txt', 'document2.pdf'],
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.finish_reason': {
    brief: 'The reason why the model stopped generating.',
    type: 'string',
    keys: ['gen_ai.response.finish_reasons', 'ai.finish_reason', 'gen_ai.response.finish_reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'COMPLETE',
    deprecation: {
      replacement: 'gen_ai.response.finish_reasons',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.finish_reasons'],
    changelog: [{ version: '0.1.0', prs: [55, 57, 61, 108, 127] }],
  },
  'ai.frequency_penalty': {
    brief:
      'Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.',
    type: 'double',
    keys: ['gen_ai.request.frequency_penalty', 'ai.frequency_penalty'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    deprecation: {
      replacement: 'gen_ai.request.frequency_penalty',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.frequency_penalty'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [55, 57, 61, 108] },
    ],
  },
  'ai.function_call': {
    brief:
      'For an AI model call, the function that was called. This is deprecated for OpenAI, and replaced by tool_calls',
    type: 'string',
    keys: ['gen_ai.tool.name', 'ai.function_call', 'mcp.tool.name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'function_name',
    deprecation: {
      replacement: 'gen_ai.tool.name',
      status: 'backfill',
    },
    aliases: ['gen_ai.tool.name', 'mcp.tool.name'],
    changelog: [{ version: '0.1.0', prs: [55, 57, 61, 108] }],
  },
  'ai.generation_id': {
    brief: 'Unique identifier for the completion.',
    type: 'string',
    keys: ['gen_ai.response.id', 'ai.generation_id', 'ai.response.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'gen_123abc',
    deprecation: {
      replacement: 'gen_ai.response.id',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.id', 'ai.response.id'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.response.id as an alias' },
      { version: '0.1.0', prs: [55, 57, 61, 108, 127] },
    ],
  },
  'ai.input_messages': {
    brief: 'The input messages sent to the model',
    type: 'string',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"role": "user", "message": "hello"}]',
    deprecation: {
      replacement: 'gen_ai.input.messages',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.messages'],
    changelog: [{ version: '0.1.0', prs: [65, 119] }, { version: '0.0.0' }],
  },
  'ai.is_search_required': {
    brief: 'Boolean indicating if the model needs to perform a search.',
    type: 'boolean',
    keys: ['ai.is_search_required'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: false,
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.metadata': {
    brief: 'Extra metadata passed to an AI pipeline step.',
    type: 'string',
    keys: ['ai.metadata'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"user_id": 123, "session_id": "abc123"}',
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55, 127] },
    ],
  },
  'ai.model.id': {
    brief: 'The id of the model used by the Vercel AI SDK.',
    type: 'string',
    keys: ['gen_ai.request.model', 'ai.model.id', 'ai.model_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'gpt-4o',
    examples: ['gpt-4o'],
    deprecation: {
      replacement: 'gen_ai.request.model',
      reason: 'This attribute is being deprecated in favor of gen_ai.request.model.',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.model', 'ai.model_id'],
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.model.id attribute' }],
  },
  'ai.model_id': {
    brief: 'The vendor-specific ID of the model used.',
    type: 'string',
    keys: ['gen_ai.request.model', 'ai.model.id', 'ai.model_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'gpt-4',
    deprecation: {
      replacement: 'gen_ai.request.model',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.model', 'ai.model.id'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.model.id as an alias' },
      { version: '0.1.0', prs: [57, 61, 127] },
      { version: '0.0.0' },
    ],
  },
  'ai.model.provider': {
    brief: 'The provider of the model.',
    type: 'string',
    keys: ['gen_ai.provider.name', 'ai.model.provider', 'gen_ai.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'openai',
    deprecation: {
      replacement: 'gen_ai.provider.name',
      status: 'backfill',
    },
    aliases: ['gen_ai.provider.name', 'gen_ai.system'],
    changelog: [
      { version: '0.4.0', prs: [253] },
      { version: '0.1.0', prs: [57, 61, 108, 127] },
    ],
  },
  'ai.pipeline.name': {
    brief: 'The name of the AI pipeline.',
    type: 'string',
    keys: ['gen_ai.pipeline.name', 'ai.pipeline.name', 'langchain.chain.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Autofix Pipeline',
    deprecation: {
      replacement: 'gen_ai.pipeline.name',
      status: 'backfill',
    },
    aliases: ['gen_ai.pipeline.name', 'langchain.chain.name'],
    changelog: [
      { version: '0.22.0', prs: [599], description: 'Added langchain.chain.name as an alias' },
      { version: '0.1.0', prs: [53, 76, 108, 127] },
    ],
  },
  'ai.preamble': {
    brief:
      "For an AI model call, the preamble parameter. Preambles are a part of the prompt used to adjust the model's overall behavior and conversation style.",
    type: 'string',
    keys: ['gen_ai.system_instructions', 'ai.preamble', 'gen_ai.system.message'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'You are now a clown.',
    deprecation: {
      replacement: 'gen_ai.system_instructions',
      status: 'backfill',
    },
    aliases: ['gen_ai.system_instructions'],
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.presence_penalty': {
    brief:
      'Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.',
    type: 'double',
    keys: ['gen_ai.request.presence_penalty', 'ai.presence_penalty'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    deprecation: {
      replacement: 'gen_ai.request.presence_penalty',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.presence_penalty'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [55, 57, 61, 108] },
    ],
  },
  'ai.prompt': {
    brief: 'The prompt passed to the Vercel AI SDK, as a stringified object.',
    type: 'string',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"prompt":"What is the weather in Paris?"}',
    examples: ['{"prompt":"What is the weather in Paris?"}'],
    deprecation: {
      replacement: 'gen_ai.input.messages',
      reason: 'This attribute is being deprecated in favor of gen_ai.input.messages.',
      status: 'backfill',
    },
    aliases: ['gen_ai.input.messages', 'ai.texts', 'ai.prompt.messages', 'gen_ai.prompt'],
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.prompt attribute' }],
  },
  'ai.prompt.messages': {
    brief: 'The input messages sent to the AI model.',
    type: 'string',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"role": "user", "message": "hello"}]',
    deprecation: {
      replacement: 'gen_ai.input.messages',
      status: 'backfill',
    },
    aliases: ['gen_ai.input.messages', 'ai.texts', 'gen_ai.prompt', 'ai.prompt'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.prompt as an alias' },
      { version: '0.19.0', prs: [498], description: 'Added ai.prompt.messages attribute' },
    ],
  },
  'ai.prompt_tokens.used': {
    brief: 'The number of tokens used to process just the prompt.',
    type: 'integer',
    keys: ['gen_ai.usage.input_tokens', 'ai.prompt_tokens.used', 'gen_ai.usage.prompt_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 20,
    deprecation: {
      replacement: 'gen_ai.usage.input_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.prompt_tokens', 'gen_ai.usage.input_tokens'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [57, 61] }, { version: '0.0.0' }],
  },
  'ai.prompt.tools': {
    brief: 'The tools made available to the model, as an array of stringified tool definitions.',
    type: 'string[]',
    keys: ['gen_ai.tool.definitions', 'ai.prompt.tools', 'ai.tools', 'gen_ai.request.available_tools'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['{"type":"function","name":"get_weather"}'],
    examples: [['{"type":"function","name":"get_weather"}']],
    deprecation: {
      replacement: 'gen_ai.tool.definitions',
      reason: 'This attribute is being deprecated in favor of gen_ai.tool.definitions.',
      status: 'backfill',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.prompt.tools attribute' }],
  },
  'ai.raw_prompting': {
    brief: 'When enabled, the user’s prompt will be sent to the model without any pre-processing.',
    type: 'boolean',
    keys: ['ai.raw_prompting'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.responses': {
    brief: 'The response messages sent back by the AI model.',
    type: 'string[]',
    keys: ['gen_ai.output.messages', 'ai.response.text', 'ai.response.toolCalls', 'ai.responses', 'ai.tool_calls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['hello', 'world'],
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'backfill',
    },
    changelog: [{ version: '0.1.0', prs: [65, 127] }, { version: '0.0.0' }],
  },
  'ai.response_format': {
    brief: 'For an AI model call, the format of the response',
    type: 'string',
    keys: ['ai.response_format'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'json_object',
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55, 127] },
    ],
  },
  'ai.response.id': {
    brief: 'The id of the response returned by the model.',
    type: 'string',
    keys: ['gen_ai.response.id', 'ai.generation_id', 'ai.response.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'chatcmpl-BuKJgVSKAMTUYbBSjHTMUuNGKzOPY',
    examples: ['chatcmpl-BuKJgVSKAMTUYbBSjHTMUuNGKzOPY'],
    deprecation: {
      replacement: 'gen_ai.response.id',
      reason: 'This attribute is being deprecated in favor of gen_ai.response.id.',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.id', 'ai.generation_id'],
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.response.id attribute' }],
  },
  'ai.response.model': {
    brief: 'The id of the model that produced the response.',
    type: 'string',
    keys: ['gen_ai.response.model', 'ai.response.model'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'gpt-4o-2024-08-06',
    examples: ['gpt-4o-2024-08-06'],
    deprecation: {
      replacement: 'gen_ai.response.model',
      reason: 'This attribute is being deprecated in favor of gen_ai.response.model.',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.model'],
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.response.model attribute' }],
  },
  'ai.response.object': {
    brief: 'The type of the object returned by the model.',
    type: 'string',
    keys: ['ai.response.object'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'chat.completion',
    examples: ['chat.completion'],
    deprecation: {
      reason:
        'This attribute is deprecated. The Sentry conventions have no replacement for the raw Vercel AI response object type.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.response.object attribute' }],
  },
  'ai.response.text': {
    brief: 'The text response from the AI model.',
    type: 'string',
    keys: ['gen_ai.output.messages', 'ai.response.text', 'ai.response.toolCalls', 'ai.responses', 'ai.tool_calls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'The weather in Paris is currently rainy.',
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'backfill',
    },
    aliases: ['gen_ai.output.messages', 'ai.response.toolCalls'],
    changelog: [{ version: '0.19.0', prs: [498], description: 'Added ai.response.text attribute' }],
  },
  'ai.response.timestamp': {
    brief: 'The ISO 8601 timestamp at which the response was produced.',
    type: 'string',
    keys: ['ai.response.timestamp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2026-02-19T15:32:11.000Z',
    examples: ['2026-02-19T15:32:11.000Z'],
    deprecation: {
      reason: 'This attribute is deprecated. The span start and end timestamps carry the same information.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.response.timestamp attribute' }],
  },
  'ai.response.toolCalls': {
    brief: 'The tool calls in the AI model response.',
    type: 'string',
    keys: ['gen_ai.output.messages', 'ai.response.text', 'ai.response.toolCalls', 'ai.responses', 'ai.tool_calls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'backfill',
    },
    aliases: ['gen_ai.output.messages', 'ai.response.text'],
    changelog: [{ version: '0.19.0', prs: [498], description: 'Added ai.response.toolCalls attribute' }],
  },
  'ai.schema': {
    brief: 'The stringified JSON schema the model output must conform to.',
    type: 'string',
    keys: ['ai.schema'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"type":"object","properties":{"city":{"type":"string"}}}',
    examples: ['{"type":"object","properties":{"city":{"type":"string"}}}'],
    deprecation: {
      reason:
        'This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.schema attribute' }],
  },
  'ai.search_queries': {
    brief: 'Queries used to search for relevant context or documents.',
    type: 'string[]',
    keys: ['ai.search_queries'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['climate change effects', 'renewable energy'],
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.search_results': {
    brief: 'Results returned from search queries for context.',
    type: 'string[]',
    keys: ['ai.search_results'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['search_result_1, search_result_2'],
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.seed': {
    brief: 'The seed, ideally models given the same seed and same other parameters will produce the exact same output.',
    type: 'string',
    keys: ['gen_ai.request.seed', 'ai.seed'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1234567890',
    deprecation: {
      replacement: 'gen_ai.request.seed',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.seed'],
    changelog: [{ version: '0.1.0', prs: [55, 57, 61, 108, 127] }],
  },
  'ai.streaming': {
    brief: 'Whether the request was streamed back.',
    type: 'boolean',
    keys: ['gen_ai.response.streaming', 'ai.streaming'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    deprecation: {
      replacement: 'gen_ai.response.streaming',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.streaming'],
    changelog: [{ version: '0.1.0', prs: [76, 108] }, { version: '0.0.0' }],
  },
  'ai.tags': {
    brief: 'Tags that describe an AI pipeline step.',
    type: 'string',
    keys: ['ai.tags'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"executed_function": "add_integers"}',
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55, 127] },
    ],
  },
  'ai.temperature': {
    brief:
      'For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.',
    type: 'double',
    keys: ['gen_ai.request.temperature', 'ai.temperature'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.1,
    deprecation: {
      replacement: 'gen_ai.request.temperature',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.temperature'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [55, 57, 61, 108] },
    ],
  },
  'ai.texts': {
    brief: 'Raw text inputs provided to the model.',
    type: 'string[]',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['Hello, how are you?', 'What is the capital of France?'],
    deprecation: {
      replacement: 'gen_ai.input.messages',
      status: 'backfill',
    },
    aliases: ['gen_ai.input.messages', 'ai.prompt.messages', 'gen_ai.prompt', 'ai.prompt'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.prompt as an alias' },
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'ai.toolCall.args': {
    brief: 'The arguments of the tool call.',
    type: 'string',
    keys: ['gen_ai.tool.call.arguments', 'ai.toolCall.args', 'gen_ai.tool.input'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"location": "Paris"}',
    deprecation: {
      replacement: 'gen_ai.tool.call.arguments',
      status: 'backfill',
    },
    aliases: ['gen_ai.tool.call.arguments', 'gen_ai.tool.input'],
    changelog: [{ version: '0.19.0', prs: [498], description: 'Added ai.toolCall.args attribute' }],
  },
  'ai.toolCall.result': {
    brief: 'The result of the tool call.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'rainy, 57°F',
    deprecation: {
      replacement: 'gen_ai.tool.call.result',
      status: 'backfill',
    },
    aliases: [
      'gen_ai.tool.call.result',
      'gen_ai.tool.output',
      'gen_ai.tool.message',
      'mcp.tool.result.content',
      'anthropic.tool_result.content',
    ],
    changelog: [{ version: '0.19.0', prs: [498], description: 'Added ai.toolCall.result attribute' }],
  },
  'ai.tools': {
    brief: 'For an AI model call, the functions that are available',
    type: 'string[]',
    keys: ['gen_ai.tool.definitions', 'ai.prompt.tools', 'ai.tools', 'gen_ai.request.available_tools'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['function_1', 'function_2'],
    deprecation: {
      replacement: 'gen_ai.tool.definitions',
      status: 'backfill',
    },
    changelog: [{ version: '0.1.0', prs: [55, 65, 127] }],
  },
  'ai.tool_calls': {
    brief: 'For an AI model call, the tool calls that were made.',
    type: 'string[]',
    keys: ['gen_ai.output.messages', 'ai.response.text', 'ai.response.toolCalls', 'ai.responses', 'ai.tool_calls'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['tool_call_1', 'tool_call_2'],
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'backfill',
    },
    changelog: [{ version: '0.1.0', prs: [55, 65] }],
  },
  'ai.top_k': {
    brief:
      'Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).',
    type: 'integer',
    keys: ['gen_ai.request.top_k', 'ai.top_k'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 35,
    deprecation: {
      replacement: 'gen_ai.request.top_k',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.top_k'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [55, 57, 61, 108] },
    ],
  },
  'ai.top_p': {
    brief:
      'Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).',
    type: 'double',
    keys: ['gen_ai.request.top_p', 'ai.top_p'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.7,
    deprecation: {
      replacement: 'gen_ai.request.top_p',
      status: 'backfill',
    },
    aliases: ['gen_ai.request.top_p'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [55, 57, 61, 108] },
    ],
  },
  'ai.total_cost': {
    brief: 'The total cost for the tokens used.',
    type: 'double',
    keys: ['gen_ai.cost.total_tokens', 'ai.total_cost'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12.34,
    deprecation: {
      replacement: 'gen_ai.cost.total_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.cost.total_tokens'],
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [53] },
    ],
    searchAlias: {
      name: 'ai.total_cost',
      type: 'currency',
    },
  },
  'ai.total_tokens.used': {
    brief: 'The total number of tokens used to process the prompt.',
    type: 'integer',
    keys: ['gen_ai.usage.total_tokens', 'ai.total_tokens.used', 'ai.usage.tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 30,
    deprecation: {
      replacement: 'gen_ai.usage.total_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.total_tokens', 'ai.usage.tokens'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.usage.tokens as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57, 61, 108] },
      { version: '0.0.0' },
    ],
  },
  'ai.usage.tokens': {
    brief: 'The total number of tokens used for the request and the response.',
    type: 'integer',
    keys: ['gen_ai.usage.total_tokens', 'ai.total_tokens.used', 'ai.usage.tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 150,
    examples: [150],
    deprecation: {
      replacement: 'gen_ai.usage.total_tokens',
      reason: 'This attribute is being deprecated in favor of gen_ai.usage.total_tokens.',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.total_tokens', 'ai.total_tokens.used'],
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.usage.tokens attribute' }],
  },
  'ai.values': {
    brief: 'The stringified values produced by a Vercel AI SDK object or array generation.',
    type: 'string',
    keys: ['ai.values'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"city":"Paris"}]',
    examples: ['[{"city":"Paris"}]'],
    deprecation: {
      reason: 'This attribute is deprecated. Use gen_ai.output.messages for model output instead.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added ai.values attribute' }],
  },
  'ai.warnings': {
    brief: 'Warning messages generated during model execution.',
    type: 'string[]',
    keys: ['ai.warnings'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['Token limit exceeded'],
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.1.0', prs: [55] },
    ],
  },
  'angular.version': {
    brief: 'The version of the Angular framework',
    type: 'string',
    keys: ['angular.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '17.1.0',
    changelog: [{ version: '0.7.0', prs: [367], description: 'Added angular.version attribute' }],
  },
  'anthropic.tool_result.content': {
    brief: 'The content of the tool result.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'rainy, 57°F',
    examples: ['rainy, 57°F'],
    deprecation: {
      replacement: 'gen_ai.tool.call.result',
      reason: 'Use gen_ai.tool.call.result for tool results.',
      status: 'backfill',
    },
    aliases: [
      'gen_ai.tool.call.result',
      'gen_ai.tool.output',
      'gen_ai.tool.message',
      'mcp.tool.result.content',
      'ai.toolCall.result',
    ],
    changelog: [
      {
        version: '0.26.0',
        prs: [660],
        description: 'Added anthropic.tool_result.content attribute, deprecated in favor of gen_ai.tool.call.result',
      },
    ],
  },
  'app.app_build': {
    brief: 'Internal build identifier, as it appears on the platform.',
    type: 'string',
    keys: ['app.build', 'app.app_build'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1',
    deprecation: {
      replacement: 'app.build',
      reason: 'Deprecated in favor of app.build',
      status: 'backfill',
    },
    aliases: ['app.build'],
    changelog: [
      { version: '0.5.0', prs: [296], description: 'Added and deprecated app.app_build in favor of app.build' },
    ],
  },
  'app.app_identifier': {
    brief: 'Version-independent application identifier, often a dotted bundle ID.',
    type: 'string',
    keys: ['app.identifier', 'app.app_identifier'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'com.example.myapp',
    deprecation: {
      replacement: 'app.identifier',
      reason: 'Deprecated in favor of app.identifier',
      status: 'backfill',
    },
    aliases: ['app.identifier'],
    changelog: [
      {
        version: '0.5.0',
        prs: [296],
        description: 'Added and deprecated app.app_identifier in favor of app.identifier',
      },
    ],
  },
  'app.app_name': {
    brief: 'Human readable application name, as it appears on the platform.',
    type: 'string',
    keys: ['app.name', 'app.app_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'My App',
    deprecation: {
      replacement: 'app.name',
      reason: 'Deprecated in favor of app.name',
      status: 'backfill',
    },
    aliases: ['app.name'],
    changelog: [
      { version: '0.5.0', prs: [296], description: 'Added and deprecated app.app_name in favor of app.name' },
    ],
  },
  'app.app_start_time': {
    brief: 'Formatted UTC timestamp when the user started the application.',
    type: 'string',
    keys: ['app.start_time', 'app.app_start_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2025-01-01T00:00:00.000Z',
    deprecation: {
      replacement: 'app.start_time',
      reason: 'Deprecated in favor of app.start_time',
      status: 'backfill',
    },
    aliases: ['app.start_time'],
    changelog: [
      {
        version: '0.5.0',
        prs: [296],
        description: 'Added and deprecated app.app_start_time in favor of app.start_time',
      },
    ],
  },
  'app.app_version': {
    brief: 'Human readable application version, as it appears on the platform.',
    type: 'string',
    keys: ['app.version', 'app.app_version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0.0',
    deprecation: {
      replacement: 'app.version',
      reason: 'Deprecated in favor of app.version',
      status: 'backfill',
    },
    aliases: ['app.version'],
    changelog: [
      { version: '0.5.0', prs: [296], description: 'Added and deprecated app.app_version in favor of app.version' },
    ],
  },
  'app.build': {
    brief: 'Internal build identifier, as it appears on the platform.',
    type: 'string',
    keys: ['app.build', 'app.app_build'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1',
    aliases: ['app.app_build'],
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.build attribute' }],
  },
  'app.identifier': {
    brief: 'Version-independent application identifier, often a dotted bundle ID.',
    type: 'string',
    keys: ['app.identifier', 'app.app_identifier'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'com.example.myapp',
    aliases: ['app.app_identifier'],
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.identifier attribute' }],
  },
  'app.in_foreground': {
    brief: 'Whether the application is currently in the foreground.',
    type: 'boolean',
    keys: ['app.in_foreground'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.in_foreground attribute' }],
  },
  'app.name': {
    brief: 'Human readable application name, as it appears on the platform.',
    type: 'string',
    keys: ['app.name', 'app.app_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'My App',
    aliases: ['app.app_name'],
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.name attribute' }],
  },
  app_start_cold: {
    brief: 'The duration of a cold app start in milliseconds',
    type: 'double',
    keys: ['app.vitals.start.cold.value', 'app_start_cold'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    deprecation: {
      replacement: 'app.vitals.start.cold.value',
      reason:
        'Replaced by app.vitals.start.cold.value to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.start.cold.value'],
    changelog: [
      { version: '0.5.0', prs: [323], description: 'Added and deprecated in favor of app.vitals.start.cold.value' },
    ],
  },
  'app.start_time': {
    brief: 'Formatted UTC timestamp when the user started the application.',
    type: 'string',
    keys: ['app.start_time', 'app.app_start_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2025-01-01T00:00:00.000Z',
    aliases: ['app.app_start_time'],
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.start_time attribute' }],
  },
  app_start_type: {
    brief: 'Mobile app start variant. Either cold or warm.',
    type: 'string',
    keys: ['app.vitals.start.type', 'app_start_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'cold',
    deprecation: {
      replacement: 'app.vitals.start.type',
      reason:
        'Replaced by app.vitals.start.type to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.start.type'],
    changelog: [
      { version: '0.5.0', prs: [313], description: 'Deprecated in favor of app.vitals.start.type' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  app_start_warm: {
    brief: 'The duration of a warm app start in milliseconds',
    type: 'double',
    keys: ['app.vitals.start.warm.value', 'app_start_warm'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    deprecation: {
      replacement: 'app.vitals.start.warm.value',
      reason:
        'Replaced by app.vitals.start.warm.value to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.start.warm.value'],
    changelog: [
      { version: '0.5.0', prs: [323], description: 'Added and deprecated in favor of app.vitals.start.warm.value' },
    ],
  },
  'app.version': {
    brief: 'Human readable application version, as it appears on the platform.',
    type: 'string',
    keys: ['app.version', 'app.app_version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0.0',
    aliases: ['app.app_version'],
    changelog: [{ version: '0.5.0', prs: [296], description: 'Added app.version attribute' }],
  },
  'app.vitals.frames.delay.value': {
    brief:
      'The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).',
    type: 'integer',
    keys: ['app.vitals.frames.delay.value', 'frames.delay', 'mobile.frames_delay'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 5,
    aliases: ['frames.delay'],
    changelog: [
      { version: '0.5.0', prs: [313], description: 'Added app.vitals.frames.delay.value to replace frames.delay' },
    ],
  },
  'app.vitals.frames.frozen.count': {
    brief: 'The number of frozen frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.frozen.count', 'frames.frozen', 'mobile.frozen_frames', 'sentry.frames.frozen'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3,
    aliases: ['frames.frozen', 'sentry.frames.frozen'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.frozen as an alias' },
      { version: '0.5.0', prs: [313], description: 'Added app.vitals.frames.frozen.count to replace frames.frozen' },
    ],
  },
  'app.vitals.frames.frozen.rate': {
    brief:
      'The fraction of rendered frames that were frozen, calculated as `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.frames.frozen.rate', 'frames_frozen_rate'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    aliases: ['frames_frozen_rate'],
    changelog: [{ version: '0.19.0', prs: [493], description: 'Added app.vitals.frames.frozen.rate attribute' }],
  },
  'app.vitals.frames.slow.count': {
    brief: 'The number of slow frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.slow.count', 'frames.slow', 'mobile.slow_frames', 'sentry.frames.slow'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    aliases: ['frames.slow', 'sentry.frames.slow'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.slow as an alias' },
      { version: '0.5.0', prs: [313], description: 'Added app.vitals.frames.slow.count to replace frames.slow' },
    ],
  },
  'app.vitals.frames.slow.rate': {
    brief:
      'The fraction of rendered frames that were slow, calculated as `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.frames.slow.rate', 'frames_slow_rate'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.25,
    aliases: ['frames_slow_rate'],
    changelog: [{ version: '0.19.0', prs: [493], description: 'Added app.vitals.frames.slow.rate attribute' }],
  },
  'app.vitals.frames.total.count': {
    brief: 'The number of total frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.total.count', 'frames.total', 'mobile.total_frames', 'sentry.frames.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 60,
    aliases: ['frames.total', 'sentry.frames.total'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.total as an alias' },
      { version: '0.5.0', prs: [313], description: 'Added app.vitals.frames.total.count to replace frames.total' },
    ],
  },
  'app.vitals.stall.duration': {
    brief:
      'The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.stall.duration', 'stall_total_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 4000,
    aliases: ['stall_total_time'],
    changelog: [{ version: '0.19.0', prs: [493], description: 'Added app.vitals.stall.duration attribute' }],
  },
  'app.vitals.stall.percentage': {
    brief:
      'The fraction of transaction duration during which the app was stalled, between 0.0 and 1.0. For example, 0.8 represents 80%. Only applies to React Native. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.stall.percentage', 'stall_percentage'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.8,
    aliases: ['stall_percentage'],
    changelog: [{ version: '0.19.0', prs: [493], description: 'Added app.vitals.stall.percentage attribute' }],
  },
  'app.vitals.start.cold.value': {
    brief: 'The duration of a cold app start in milliseconds',
    type: 'double',
    keys: ['app.vitals.start.cold.value', 'app_start_cold'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    aliases: ['app_start_cold'],
    changelog: [{ version: '0.5.0', prs: [313], description: 'Added app.vitals.start.cold.value attribute' }],
  },
  'app.vitals.start.prewarmed': {
    brief: 'Whether the app start was prewarmed.',
    type: 'boolean',
    keys: ['app.vitals.start.prewarmed'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.11.0', prs: [379], description: 'Added app.vitals.start.prewarmed attribute' }],
  },
  'app.vitals.start.reason': {
    brief: 'The reason that triggered the app start.',
    type: 'string',
    keys: ['app.vitals.start.reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'push',
    changelog: [{ version: '0.7.0', prs: [353], description: 'Added app.vitals.start.reason attribute' }],
  },
  'app.vitals.start.screen': {
    brief:
      'The screen that is rendered when the app start is complete. This is the screen the user first sees and can interact with after launch. The absence of this attribute on the app start span indicates a background app start where no UI was rendered.',
    type: 'string',
    keys: ['app.vitals.start.screen'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'MainActivity',
    changelog: [{ version: '0.7.0', prs: [353], description: 'Added app.vitals.start.screen attribute' }],
  },
  'app.vitals.start.type': {
    brief: 'The type of app start, for example `cold` or `warm`',
    type: 'string',
    keys: ['app.vitals.start.type', 'app_start_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'cold',
    aliases: ['app_start_type'],
    changelog: [{ version: '0.5.0', prs: [313], description: 'Added app.vitals.start.type attribute' }],
  },
  'app.vitals.start.warm.value': {
    brief: 'The duration of a warm app start in milliseconds',
    type: 'double',
    keys: ['app.vitals.start.warm.value', 'app_start_warm'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    aliases: ['app_start_warm'],
    changelog: [{ version: '0.5.0', prs: [313], description: 'Added app.vitals.start.warm.value attribute' }],
  },
  'app.vitals.ttfd.value': {
    brief: 'The duration of time to full display in milliseconds',
    type: 'double',
    keys: ['app.vitals.ttfd.value', 'time_to_full_display'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    aliases: ['time_to_full_display'],
    changelog: [{ version: '0.5.0', prs: [313], description: 'Added app.vitals.ttfd.value attribute' }],
  },
  'app.vitals.ttid.value': {
    brief: 'The duration of time to initial display in milliseconds',
    type: 'double',
    keys: ['app.vitals.ttid.value', 'time_to_initial_display'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    aliases: ['time_to_initial_display'],
    changelog: [{ version: '0.5.0', prs: [313], description: 'Added app.vitals.ttid.value attribute' }],
  },
  'art.gc.blocking_count': {
    brief: 'Total number of blocking (stop-the-world) garbage collections performed by the Android Runtime',
    type: 'integer',
    keys: ['art.gc.blocking_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.blocking_count attribute' }],
  },
  'art.gc.blocking_time': {
    brief: 'Total time spent in blocking (stop-the-world) garbage collections by the Android Runtime, in milliseconds',
    type: 'double',
    keys: ['art.gc.blocking_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 11.873,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.blocking_time attribute' }],
  },
  'art.gc.pre_oome_count': {
    brief:
      'Total number of garbage collections triggered as a last resort before an OutOfMemoryError by the Android Runtime',
    type: 'integer',
    keys: ['art.gc.pre_oome_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.pre_oome_count attribute' }],
  },
  'art.gc.total_count': {
    brief: 'Total number of garbage collections performed by the Android Runtime',
    type: 'integer',
    keys: ['art.gc.total_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.total_count attribute' }],
  },
  'art.gc.total_time': {
    brief: 'Total time spent in garbage collection by the Android Runtime, in milliseconds',
    type: 'double',
    keys: ['art.gc.total_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 11.807,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.total_time attribute' }],
  },
  'art.gc.waiting_time': {
    brief:
      'Total time threads spent waiting for garbage collection to complete in the Android Runtime, in milliseconds',
    type: 'double',
    keys: ['art.gc.waiting_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 8.054,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.gc.waiting_time attribute' }],
  },
  'art.memory.free': {
    brief: 'Free memory available to the process as reported by the Android Runtime, in bytes',
    type: 'integer',
    keys: ['art.memory.free'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3181568,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.memory.free attribute' }],
  },
  'art.memory.free_until_gc': {
    brief: 'Free memory available before a garbage collection would be triggered by the Android Runtime, in bytes',
    type: 'integer',
    keys: ['art.memory.free_until_gc'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3181568,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.memory.free_until_gc attribute' }],
  },
  'art.memory.free_until_oome': {
    brief: 'Free memory available before an OutOfMemoryError would be thrown by the Android Runtime, in bytes',
    type: 'integer',
    keys: ['art.memory.free_until_oome'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 196083712,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.memory.free_until_oome attribute' }],
  },
  'art.memory.max': {
    brief: 'Maximum memory the process is allowed to use as reported by the Android Runtime, in bytes',
    type: 'integer',
    keys: ['art.memory.max'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 201326592,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.memory.max attribute' }],
  },
  'art.memory.total': {
    brief: 'Total memory currently allocated to the process by the Android Runtime, in bytes',
    type: 'integer',
    keys: ['art.memory.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 7774208,
    changelog: [{ version: '0.11.0', prs: [382], description: 'Added art.memory.total attribute' }],
  },
  'aws.cloudwatch.logs.log_group': {
    brief: 'The name of the CloudWatch Logs log group',
    type: 'string',
    keys: ['aws.cloudwatch.logs.log_group'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/aws/lambda/my-function',
    changelog: [{ version: '0.7.0', prs: [369], description: 'Added aws.cloudwatch.logs.log_group attribute' }],
  },
  'aws.cloudwatch.logs.log_stream': {
    brief: 'The name of the CloudWatch Logs log stream',
    type: 'string',
    keys: ['aws.cloudwatch.logs.log_stream'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2024/01/01/[$LATEST]abcdef1234567890',
    changelog: [{ version: '0.7.0', prs: [369], description: 'Added aws.cloudwatch.logs.log_stream attribute' }],
  },
  'aws.cloudwatch.logs.url': {
    brief: 'The URL to the CloudWatch Logs log group',
    type: 'string',
    keys: ['aws.cloudwatch.logs.url'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://console.aws.amazon.com/cloudwatch/home?region=us-east-1#logsV2:log-groups/log-group/my-log-group',
    changelog: [{ version: '0.7.0', prs: [369], description: 'Added aws.cloudwatch.logs.url attribute' }],
  },
  'aws.dynamodb.attributes_to_get': {
    brief: 'The value of the `AttributesToGet` request parameter.',
    type: 'string[]',
    keys: ['aws.dynamodb.attributes_to_get'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['lives', 'id'],
    examples: [['lives', 'id']],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.dynamodb.attributes_to_get attribute' }],
  },
  'aws.dynamodb.attribute_definitions': {
    brief: 'The JSON-serialized value of each item in the `AttributeDefinitions` request field.',
    type: 'string[]',
    keys: ['aws.dynamodb.attribute_definitions'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['{ "AttributeName": "string", "AttributeType": "string" }'],
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.attribute_definitions attribute' }],
  },
  'aws.dynamodb.consistent_read': {
    brief: 'The value of the `ConsistentRead` request parameter.',
    type: 'boolean',
    keys: ['aws.dynamodb.consistent_read'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.consistent_read attribute' }],
  },
  'aws.dynamodb.consumed_capacity': {
    brief: 'The JSON-serialized value of each item in the `ConsumedCapacity` response field.',
    type: 'string[]',
    keys: ['aws.dynamodb.consumed_capacity'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: [
      '{ "CapacityUnits": number, "GlobalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "LocalSecondaryIndexes": { "string" : { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number } }, "ReadCapacityUnits": number, "Table": { "CapacityUnits": number, "ReadCapacityUnits": number, "WriteCapacityUnits": number }, "TableName": "string", "WriteCapacityUnits": number }',
    ],
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.consumed_capacity attribute' }],
  },
  'aws.dynamodb.count': {
    brief: 'The value of the `Count` response parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.count attribute' }],
  },
  'aws.dynamodb.exclusive_start_table': {
    brief: 'The value of the `ExclusiveStartTableName` request parameter.',
    type: 'string',
    keys: ['aws.dynamodb.exclusive_start_table'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Users',
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.exclusive_start_table attribute' }],
  },
  'aws.dynamodb.global_secondary_indexes': {
    brief: 'The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.',
    type: 'string[]',
    keys: ['aws.dynamodb.global_secondary_indexes'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: [
      '{ "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }',
    ],
    changelog: [
      { version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.global_secondary_indexes attribute' },
    ],
  },
  'aws.dynamodb.global_secondary_index_updates': {
    brief: 'The JSON-serialized value of each item in the `GlobalSecondaryIndexUpdates` request field.',
    type: 'string[]',
    keys: ['aws.dynamodb.global_secondary_index_updates'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: [
      '{ "Create": { "IndexName": "string", "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" }, "ProvisionedThroughput": { "ReadCapacityUnits": number, "WriteCapacityUnits": number } }',
    ],
    changelog: [
      { version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.global_secondary_index_updates attribute' },
    ],
  },
  'aws.dynamodb.index_name': {
    brief: 'The value of the `IndexName` request parameter.',
    type: 'string',
    keys: ['aws.dynamodb.index_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'name_to_group',
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.index_name attribute' }],
  },
  'aws.dynamodb.item_collection_metrics': {
    brief: 'The JSON-serialized value of the `ItemCollectionMetrics` response field.',
    type: 'string',
    keys: ['aws.dynamodb.item_collection_metrics'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      '{ "string" : [ { "ItemCollectionKey": { "string" : { "B": blob, "BOOL": boolean, "BS": [ blob ], "L": [ "AttributeValue" ], "M": { "string" : "AttributeValue" }, "N": "string", "NS": [ "string" ], "NULL": boolean, "S": "string", "SS": [ "string" ] } }, "SizeEstimateRangeGB": [ number ] } ] }',
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.item_collection_metrics attribute' }],
  },
  'aws.dynamodb.limit': {
    brief: 'The value of the `Limit` request parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.limit'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.limit attribute' }],
  },
  'aws.dynamodb.local_secondary_indexes': {
    brief: 'The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.',
    type: 'string[]',
    keys: ['aws.dynamodb.local_secondary_indexes'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: [
      '{ "IndexArn": "string", "IndexName": "string", "IndexSizeBytes": number, "ItemCount": number, "KeySchema": [ { "AttributeName": "string", "KeyType": "string" } ], "Projection": { "NonKeyAttributes": [ "string" ], "ProjectionType": "string" } }',
    ],
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.local_secondary_indexes attribute' }],
  },
  'aws.dynamodb.projection': {
    brief: 'The value of the `ProjectionExpression` request parameter.',
    type: 'string',
    keys: ['aws.dynamodb.projection'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Title, Price, Color',
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.projection attribute' }],
  },
  'aws.dynamodb.provisioned_read_capacity': {
    brief: 'The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.',
    type: 'double',
    keys: ['aws.dynamodb.provisioned_read_capacity'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1,
    changelog: [
      { version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.provisioned_read_capacity attribute' },
    ],
  },
  'aws.dynamodb.provisioned_write_capacity': {
    brief: 'The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.',
    type: 'double',
    keys: ['aws.dynamodb.provisioned_write_capacity'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 2,
    changelog: [
      { version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.provisioned_write_capacity attribute' },
    ],
  },
  'aws.dynamodb.scanned_count': {
    brief: 'The value of the `ScannedCount` response parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.scanned_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 50,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.scanned_count attribute' }],
  },
  'aws.dynamodb.scan_forward': {
    brief: 'The value of the `ScanIndexForward` request parameter.',
    type: 'boolean',
    keys: ['aws.dynamodb.scan_forward'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.scan_forward attribute' }],
  },
  'aws.dynamodb.segment': {
    brief: 'The value of the `Segment` request parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.segment'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.segment attribute' }],
  },
  'aws.dynamodb.select': {
    brief: 'The value of the `Select` request parameter.',
    type: 'string',
    keys: ['aws.dynamodb.select'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ALL_ATTRIBUTES',
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.select attribute' }],
  },
  'aws.dynamodb.table_count': {
    brief: 'The number of items in the `TableNames` response parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.table_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 20,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.table_count attribute' }],
  },
  'aws.dynamodb.table_names': {
    brief: 'The keys in the `RequestItems` object field.',
    type: 'string[]',
    keys: ['aws.dynamodb.table_names'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['Users', 'Cats'],
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.table_names attribute' }],
  },
  'aws.dynamodb.total_segments': {
    brief: 'The value of the `TotalSegments` request parameter.',
    type: 'integer',
    keys: ['aws.dynamodb.total_segments'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 100,
    changelog: [{ version: '0.16.0', prs: [479], description: 'Added aws.dynamodb.total_segments attribute' }],
  },
  'aws.extended_request_id': {
    brief: 'The AWS extended request ID as returned in the response headers.',
    type: 'string',
    keys: ['aws.extended_request_id', 'aws.request.extended_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=',
    aliases: ['aws.request.extended_id'],
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.extended_request_id attribute' }],
  },
  'aws.kinesis.stream_name': {
    brief: 'The name of the AWS Kinesis stream the request refers to.',
    type: 'string',
    keys: ['aws.kinesis.stream_name', 'aws.kinesis.stream.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'some-stream-name',
    aliases: ['aws.kinesis.stream.name'],
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.kinesis.stream_name attribute' }],
  },
  'aws.kinesis.stream.name': {
    brief: 'The name of the AWS Kinesis stream the request refers to.',
    type: 'string',
    keys: ['aws.kinesis.stream_name', 'aws.kinesis.stream.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'some-stream-name',
    deprecation: {
      replacement: 'aws.kinesis.stream_name',
      reason:
        'This attribute is being deprecated in favor of aws.kinesis.stream_name, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['aws.kinesis.stream_name'],
    changelog: [
      {
        version: '0.16.0',
        prs: [480],
        description: 'Added aws.kinesis.stream.name attribute, deprecated in favor of aws.kinesis.stream_name',
      },
    ],
  },
  'aws.lambda.aws_request_id': {
    brief: 'The AWS request ID as received by the Lambda function runtime',
    type: 'string',
    keys: ['faas.invocation_id', 'aws.lambda.aws_request_id', 'faas.execution'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '8476a536-e9f4-11e8-9739-2dfe598c3fcd',
    deprecation: {
      replacement: 'faas.invocation_id',
      reason: 'This attribute is being deprecated in favor of faas.invocation_id',
      status: 'backfill',
    },
    aliases: ['faas.invocation_id', 'faas.execution'],
    changelog: [
      { version: '0.16.0', prs: [473], description: 'Added faas.execution as an alias' },
      {
        version: '0.11.1',
        prs: [414, 424],
        description: 'Deprecated aws.lambda.aws_request_id in favor of faas.invocation_id',
      },
      { version: '0.7.0', prs: [369], description: 'Added aws.lambda.aws_request_id attribute' },
    ],
  },
  'aws.lambda.execution_duration_in_millis': {
    brief: 'The execution duration of the Lambda function invocation in milliseconds',
    type: 'double',
    keys: ['aws.lambda.execution_duration_in_millis'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    changelog: [
      { version: '0.7.0', prs: [369], description: 'Added aws.lambda.execution_duration_in_millis attribute' },
    ],
  },
  'aws.lambda.function_name': {
    brief: 'The name of the Lambda function',
    type: 'string',
    keys: ['faas.name', 'aws.lambda.function_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-function',
    deprecation: {
      replacement: 'faas.name',
      reason: 'Use the OTel-aligned faas.name attribute instead',
      status: 'backfill',
    },
    aliases: ['faas.name'],
    changelog: [
      { version: '0.11.1', prs: [414], description: 'Deprecated aws.lambda.function_name in favor of faas.name' },
      { version: '0.7.0', prs: [369], description: 'Added aws.lambda.function_name attribute' },
    ],
  },
  'aws.lambda.function_version': {
    brief: 'The version of the Lambda function',
    type: 'string',
    keys: ['faas.version', 'aws.lambda.function_version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '$LATEST',
    deprecation: {
      replacement: 'faas.version',
      reason: 'Use the OTel-aligned faas.version attribute instead',
      status: 'backfill',
    },
    aliases: ['faas.version'],
    changelog: [
      {
        version: '0.11.1',
        prs: [414, 424],
        description: 'Deprecated aws.lambda.function_version in favor of faas.version',
      },
      { version: '0.7.0', prs: [369], description: 'Added aws.lambda.function_version attribute' },
    ],
  },
  'aws.lambda.invoked_arn': {
    brief: 'The full ARN of the Lambda function that was invoked',
    type: 'string',
    keys: ['aws.lambda.invoked_arn', 'aws.lambda.invoked_function_arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:lambda:us-east-1:123456789012:function:my-function',
    aliases: ['aws.lambda.invoked_function_arn'],
    changelog: [{ version: '0.11.1', prs: [414] }],
  },
  'aws.lambda.invoked_function_arn': {
    brief: 'The full ARN of the Lambda function that was invoked',
    type: 'string',
    keys: ['aws.lambda.invoked_arn', 'aws.lambda.invoked_function_arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'arn:aws:lambda:us-east-1:123456789012:function:my-function',
    deprecation: {
      replacement: 'aws.lambda.invoked_arn',
      reason: 'This attribute is being deprecated in favor of aws.lambda.invoked_arn',
      status: 'backfill',
    },
    aliases: ['aws.lambda.invoked_arn'],
    changelog: [
      {
        version: '0.11.1',
        prs: [414],
        description: 'Deprecated aws.lambda.invoked_function_arn in favor of aws.lambda.invoked_arn',
      },
      { version: '0.7.0', prs: [369], description: 'Added aws.lambda.invoked_function_arn attribute' },
    ],
  },
  'aws.lambda.remaining_time_in_millis': {
    brief: 'The remaining time in milliseconds before the Lambda function times out',
    type: 'double',
    keys: ['aws.lambda.remaining_time_in_millis'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 5000,
    changelog: [{ version: '0.7.0', prs: [369], description: 'Added aws.lambda.remaining_time_in_millis attribute' }],
  },
  'aws.log.group.names': {
    brief: 'The name(s) of the AWS log group(s) an application is writing to.',
    type: 'string[]',
    keys: ['aws.log.group.names'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['/aws/lambda/my-function', 'opentelemetry-service'],
    changelog: [{ version: '0.11.1', prs: [414] }],
  },
  'aws.log.stream.names': {
    brief: 'The name(s) of the AWS log stream(s) an application is writing to.',
    type: 'string[]',
    keys: ['aws.log.stream.names'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['logs/main/10838bed-421f-43ef-870a-f43feacbbb5b'],
    changelog: [{ version: '0.11.1', prs: [414] }],
  },
  'aws.operation_name': {
    brief: 'The name of the API operation invoked on an AWS service.',
    type: 'string',
    keys: ['rpc.method', 'aws.operation_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'PutObject',
    examples: ['PutObject'],
    deprecation: {
      replacement: 'rpc.method',
      reason: 'This attribute is being deprecated in favor of rpc.method, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['rpc.method'],
    changelog: [{ version: '0.19.0', prs: [536], description: 'Added aws.operation_name attribute' }],
  },
  aws_region: {
    brief: 'The geographical region the AWS resource is running',
    type: 'string',
    keys: ['cloud.region', 'aws_region', 'gcp_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'us-east-1',
    examples: ['us-east-1'],
    deprecation: {
      replacement: 'cloud.region',
      status: 'backfill',
    },
    aliases: ['cloud.region', 'gcp_region'],
    changelog: [{ version: '0.19.0', prs: [537], description: 'Added aws_region attribute' }],
  },
  'aws.request.extended_id': {
    brief: 'The AWS extended request ID as returned in the response headers.',
    type: 'string',
    keys: ['aws.extended_request_id', 'aws.request.extended_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'wzHcyEWfmOGDIE5QOhTAqFDoDWP3y8IUvpNINCwL9N4TEHbUw0/gZJ+VZTmCNCWR7fezEN3eCiQ=',
    deprecation: {
      replacement: 'aws.extended_request_id',
      reason:
        'This attribute is being deprecated in favor of aws.extended_request_id, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['aws.extended_request_id'],
    changelog: [
      {
        version: '0.16.0',
        prs: [480],
        description: 'Added aws.request.extended_id attribute, deprecated in favor of aws.extended_request_id',
      },
    ],
  },
  'aws.request_id': {
    brief: 'The AWS request ID as returned in the response headers.',
    type: 'string',
    keys: ['aws.request_id', 'aws.request.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '79b9da39-b7ae-508a-a6bc-864b2829c622',
    aliases: ['aws.request.id'],
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.request_id attribute' }],
  },
  'aws.request.id': {
    brief: 'The AWS request ID as returned in the response headers.',
    type: 'string',
    keys: ['aws.request_id', 'aws.request.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '79b9da39-b7ae-508a-a6bc-864b2829c622',
    deprecation: {
      replacement: 'aws.request_id',
      reason: 'This attribute is being deprecated in favor of aws.request_id, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['aws.request_id'],
    changelog: [
      {
        version: '0.16.0',
        prs: [480],
        description: 'Added aws.request.id attribute, deprecated in favor of aws.request_id',
      },
    ],
  },
  'aws.request.url': {
    brief: 'The URL of the AWS API request.',
    type: 'string',
    keys: ['url.full', 'aws.request.url', 'http.url', 'messaging.url', 'url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://sqs.us-east-1.amazonaws.com/123456789/my-queue',
    deprecation: {
      replacement: 'url.full',
      reason: 'This attribute is being deprecated in favor of url.full, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['url.full', 'http.url', 'url', 'messaging.url'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.url as an alias' },
      {
        version: '0.19.0',
        prs: [488],
        description: 'Added aws.request.url attribute, deprecated in favor of url.full',
      },
    ],
  },
  'aws.s3.bucket': {
    brief: 'The S3 bucket name the request refers to.',
    type: 'string',
    keys: ['aws.s3.bucket'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ot-demo-test',
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.s3.bucket attribute' }],
  },
  'aws.s3.copy_source': {
    brief: 'The source object (in the form bucket/key) for the copy operation.',
    type: 'string',
    keys: ['aws.s3.copy_source'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'someFile.yml',
    examples: ['someFile.yml'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.s3.copy_source attribute' }],
    additionalContext: [
      'Applicable to the copy-object and upload-part-copy operations, corresponding to the CopySource parameter.',
    ],
  },
  'aws.s3.delete': {
    brief: 'The delete request container that specifies the objects to be deleted.',
    type: 'string',
    keys: ['aws.s3.delete'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Objects=[{Key=string,VersionId=string},{Key=string,VersionId=string}],Quiet=boolean',
    examples: ['Objects=[{Key=string,VersionId=string},{Key=string,VersionId=string}],Quiet=boolean'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.s3.delete attribute' }],
    additionalContext: ['Applicable only to the delete-objects operation, corresponding to its Delete parameter.'],
  },
  'aws.s3.key': {
    brief: 'The S3 object key the request refers to. Corresponds to the --key parameter of the S3 API operations.',
    type: 'string',
    keys: ['aws.s3.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'someFile.yml',
    examples: ['someFile.yml'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.s3.key attribute' }],
  },
  'aws.s3.part_number': {
    brief:
      'The part number of the part being uploaded in a multipart-upload operation. This is a positive integer between 1 and 10,000.',
    type: 'integer',
    keys: ['aws.s3.part_number'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 3456,
    examples: [3456],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.s3.part_number attribute' }],
    additionalContext: ['Applicable only to the upload-part and upload-part-copy operations.'],
  },
  'aws.s3.upload_id': {
    brief: 'Upload ID that identifies the multipart upload.',
    type: 'string',
    keys: ['aws.s3.upload_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'dfRtDYWFbkRONycy.Yxwh66Yjlx.cph0gtNBtJ',
    examples: ['dfRtDYWFbkRONycy.Yxwh66Yjlx.cph0gtNBtJ'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.s3.upload_id attribute' }],
  },
  'aws.secretsmanager.secret.arn': {
    brief: 'The ARN of the Secret stored in Secrets Manager.',
    type: 'string',
    keys: ['aws.secretsmanager.secret.arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:secretsmanager:us-east-1:123456789012:secret:SecretName-6RandomCharacters',
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.secretsmanager.secret.arn attribute' }],
  },
  'aws.sns.topic.arn': {
    brief:
      'The ARN of the AWS SNS Topic. An Amazon SNS topic is a logical access point that acts as a communication channel.',
    type: 'string',
    keys: ['aws.sns.topic.arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:sns:us-east-1:123456789012:mystack-mytopic-NZJ5JSMVGFIE',
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.sns.topic.arn attribute' }],
  },
  'aws.sqs.queue.url': {
    brief:
      'The URL of the AWS SQS Queue. It’s a unique identifier for a queue in Amazon Simple Queue Service (SQS) and is used to access the queue and perform actions on it.',
    type: 'string',
    keys: ['aws.sqs.queue.url'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'https://sqs.us-east-1.amazonaws.com/123456789012/MyQueue',
    examples: ['https://sqs.us-east-1.amazonaws.com/123456789012/MyQueue'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.sqs.queue.url attribute' }],
  },
  'aws.step_functions.activity.arn': {
    brief: 'The ARN of the AWS Step Functions Activity.',
    type: 'string',
    keys: ['aws.step_functions.activity.arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:states:us-east-1:123456789012:activity:get-greeting',
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.step_functions.activity.arn attribute' }],
  },
  'aws.step_functions.execution.arn': {
    brief: 'The ARN of the AWS Step Functions Execution.',
    type: 'string',
    keys: ['aws.step_functions.execution.arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'arn:aws:states:us-east-1:123456789012:execution:myStateMachine:myExecution',
    examples: ['arn:aws:states:us-east-1:123456789012:execution:myStateMachine:myExecution'],
    changelog: [{ version: '0.27.0', prs: [672], description: 'Added aws.step_functions.execution.arn attribute' }],
  },
  'aws.step_functions.state_machine.arn': {
    brief: 'The ARN of the AWS Step Functions State Machine.',
    type: 'string',
    keys: ['aws.step_functions.state_machine.arn'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:states:us-east-1:123456789012:stateMachine:myStateMachine:1',
    changelog: [{ version: '0.16.0', prs: [480], description: 'Added aws.step_functions.state_machine.arn attribute' }],
  },
  blocked_main_thread: {
    brief: 'Whether the main thread was blocked by the span.',
    type: 'boolean',
    keys: ['blocked_main_thread'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'browser.bfcache.frame': {
    brief:
      "Which frame in the page's frame tree a back/forward cache not-restored reason originated from: the top document or a child frame.",
    type: 'string',
    keys: ['browser.bfcache.frame'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'top',
    examples: ['top', 'child'],
    changelog: [{ version: '0.19.0', prs: [513], description: 'Added browser.bfcache.frame attribute' }],
  },
  'browser.bfcache.not_restored_reason_count': {
    brief:
      'The number of reported reasons a page was not restored from the back/forward cache on a back/forward navigation. 0 when the browser reported no reasons (e.g. non-Chromium browsers).',
    type: 'integer',
    keys: ['browser.bfcache.not_restored_reason_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    examples: [2],
    changelog: [
      { version: '0.19.0', prs: [513], description: 'Added browser.bfcache.not_restored_reason_count attribute' },
    ],
  },
  'browser.bfcache.outcome': {
    brief:
      "Whether a back/forward navigation was restored from the browser's back/forward cache (bfcache). 'hit' means the page was restored; 'miss' means it was reloaded.",
    type: 'string',
    keys: ['browser.bfcache.outcome'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'hit',
    examples: ['hit', 'miss'],
    changelog: [{ version: '0.19.0', prs: [513], description: 'Added browser.bfcache.outcome attribute' }],
  },
  'browser.bfcache.reason': {
    brief:
      'A browser-reported reason a page was not restored from the back/forward cache on a back/forward navigation, taken from the notRestoredReasons API. Reported per reason (a single miss can have several). Currently Chromium-only.',
    type: 'string',
    keys: ['browser.bfcache.reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'unload-listener',
    examples: ['unload-listener', 'websocket', 'idbversionchangeevent', 'response-cache-control-no-store'],
    changelog: [{ version: '0.19.0', prs: [513], description: 'Added browser.bfcache.reason attribute' }],
  },
  'browser.name': {
    brief: 'The name of the browser.',
    type: 'string',
    keys: ['browser.name', 'sentry.browser.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Chrome',
    aliases: ['sentry.browser.name'],
    changelog: [{ version: '0.1.0', prs: [127, 139] }, { version: '0.0.0' }],
  },
  'browser.navigation.id': {
    brief:
      "The identifier of the navigation the measurement belongs to, incremented by the browser for each navigation within a page's lifetime.",
    type: 'integer',
    keys: ['browser.navigation.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    examples: [1, 3, 0],
    changelog: [
      {
        version: '0.24.0',
        prs: [640],
        description: 'Document 0 as the fallback value when the browser does not support `navigationId`',
      },
      { version: '0.22.0', prs: [634], description: 'Added browser.navigation.id attribute' },
    ],
    additionalContext: [
      'Sourced from `PerformanceEntry.navigationId`, defined by the Soft Navigations spec. Despite its origin it is not soft-navigation specific: the field is set on the `PerformanceNavigationTiming` entry of a hard navigation too.',
      'The value starts at 1 for the initial page load and increments for each subsequent navigation. It is only unique within a single page lifetime, not globally.',
      'A value of 0 is a fallback rather than a real navigation id: web-vitals reports 0 when the browser does not expose `PerformanceEntry.navigationId`, so 0 means the id is unknown.',
      'Pairs with `browser.navigation.type`: the type says how the browser arrived at the page, the id says which navigation of that page a measurement belongs to.',
      "Not to be confused with the Navigation API's `NavigationHistoryEntry.id`, which is an opaque string identifying a history entry rather than a counter, and is not interchangeable with this value.",
      "Also distinct from the `router.navigation.*` attributes, which describe the client-side router's own view of a navigation. Those come from the framework, this one comes from the browser, and both can be set on the same span.",
    ],
  },
  'browser.navigation.type': {
    brief: 'The type of navigation the browser performed to arrive at the page the metrics were measured on.',
    type: 'string',
    keys: ['browser.navigation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'navigate',
    examples: ['navigate', 'reload', 'back-forward', 'back-forward-cache', 'prerender', 'restore', 'soft-navigation'],
    changelog: [
      {
        version: '0.24.0',
        prs: [640],
        description:
          'Use the web-vitals navigation types as-is: `bfcache` is now `back-forward-cache`, and `back-forward` and `restore` are no longer reported as `navigate`',
      },
      { version: '0.22.0', prs: [600], description: 'Added browser.navigation.type attribute' },
    ],
    additionalContext: [
      'Carries the `navigationType` value reported by the web-vitals library verbatim. web-vitals hyphenates the Navigation Timing `PerformanceNavigationTiming.type` value (`back_forward` becomes `back-forward`) and adds states that API does not cover: `back-forward-cache` for a restore from the back/forward cache, `prerender`, `restore` for a discarded tab being reloaded, and `soft-navigation`.',
      '`back-forward-cache` is only set when the page was actually restored from the back/forward cache. A back/forward navigation that missed the cache is a full document load and reports `back-forward`. Use the `browser.bfcache.*` attributes to diagnose misses.',
      '`prerender` pages finish painting before activation, so their paint timings are offset by `browser.performance.navigation.activation_start`. Keep them separate when aggregating web vitals.',
      "Not to be confused with `router.navigation.type`, which holds the client-side router's own vocabulary (`link`, `goto`, `router.push`). The two are independent and can both be set on the same span.",
    ],
  },
  'browser.paint.type': {
    brief: 'The type of paint timing entry reported by the browser.',
    type: 'string',
    keys: ['browser.paint.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'first-paint',
    examples: ['first-paint', 'first-contentful-paint'],
    changelog: [{ version: '0.22.0', prs: [606], description: 'Added browser.paint.type attribute' }],
  },
  'browser.performance.navigation.activation_start': {
    brief: 'The time between initiating a navigation to a page and the browser activating the page',
    type: 'double',
    keys: ['browser.performance.navigation.activation_start', 'performance.activationStart'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1.983,
    aliases: ['performance.activationStart'],
    changelog: [
      { version: '0.5.0', prs: [321], description: 'Added browser.performance.navigation.activation_start attribute' },
    ],
  },
  'browser.performance.time_origin': {
    brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
    type: 'double',
    keys: ['browser.performance.time_origin', 'performance.timeOrigin'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1776185678.886,
    aliases: ['performance.timeOrigin'],
    changelog: [
      { version: '0.5.0', prs: [321], description: 'Added browser.performance.time_origin attribute attribute' },
    ],
  },
  'browser.report.type': {
    brief: 'A browser report sent via reporting API..',
    type: 'string',
    keys: ['browser.report.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'network-error',
    changelog: [{ version: '0.1.0', prs: [68, 127] }],
  },
  'browser.script.invoker': {
    brief: 'How a script was called in the browser.',
    type: 'string',
    keys: ['browser.script.invoker'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Window.requestAnimationFrame',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'browser.script.invoker_type': {
    brief: 'Browser script entry point type.',
    type: 'string',
    keys: ['browser.script.invoker_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'event-listener',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'browser.script.source_char_position': {
    brief: 'A number representing the script character position of the script.',
    type: 'integer',
    keys: ['browser.script.source_char_position'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 678,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'browser.version': {
    brief: 'The version of the browser.',
    type: 'string',
    keys: ['browser.version', 'sentry.browser.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '120.0.6099.130',
    aliases: ['sentry.browser.version'],
    changelog: [{ version: '0.1.0', prs: [59, 127, 139] }],
  },
  'browser.web_vital.cls.report_event': {
    brief: 'The event that caused the SDK to report CLS (pagehide or navigation)',
    type: 'string',
    keys: ['browser.web_vital.cls.report_event'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'navigation',
    deprecation: {
      reason:
        'The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the CLS value is final, so there is no report event to record. No replacement.',
    },
    changelog: [
      {
        version: '0.24.0',
        prs: [642],
        description: 'Deprecated browser.web_vital.cls.report_event, which has no replacement',
      },
      { version: '0.5.0', prs: [319], description: 'Added browser.web_vital.cls.report_event attribute' },
    ],
  },
  'browser.web_vital.cls.source.<key>': {
    brief: 'The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N',
    type: 'string',
    keys: ['browser.web_vital.cls.source.<key>', 'cls.source.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'body > div#app',
    aliases: ['cls.source.<key>'],
    changelog: [{ version: '0.5.0', prs: [234] }],
  },
  'browser.web_vital.cls.value': {
    brief: 'The value of the recorded Cumulative Layout Shift (CLS) web vital',
    type: 'double',
    keys: ['browser.web_vital.cls.value', 'cls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.2361,
    aliases: ['cls'],
    changelog: [{ version: '0.5.0', prs: [229], description: 'Added browser.web_vital.cls.value attribute' }],
  },
  'browser.web_vital.fcp.value': {
    brief: 'The time it takes for the browser to render the first piece of meaningful content on the screen',
    type: 'double',
    keys: ['browser.web_vital.fcp.value', 'fcp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 547.6951,
    aliases: ['fcp'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'browser.web_vital.fp.value': {
    brief: 'The time in milliseconds it takes for the browser to render the first pixel on the screen',
    type: 'double',
    keys: ['browser.web_vital.fp.value', 'fp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 477.1926,
    aliases: ['fp'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'browser.web_vital.inp.interaction_type': {
    brief: 'The kind of user interaction INP was reported on',
    type: 'string',
    keys: ['browser.web_vital.inp.interaction_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'click',
    examples: ['click', 'hover', 'drag', 'press'],
    changelog: [
      { version: '0.24.0', prs: [641], description: 'Added browser.web_vital.inp.interaction_type attribute' },
    ],
    additionalContext: [
      "One of `click`, `hover`, `drag` or `press`, derived from the DOM event name of the Event Timing entry: pointer, mouse and touch events map to `click`, `mouseover` and similar to `hover`, drag and drop events to `drag`, and keyboard and `input` events to `press`. The same value forms the suffix of the span's `ui.interaction.*` op.",
      'Not to be confused with the `interactionType` of the web-vitals attribution build, which only distinguishes `pointer` and `keyboard`.',
      'Omitted when INP is reported without an interaction to attribute it to, see `browser.web_vital.inp.target`. The op of such a span still falls into `ui.interaction.click` so that it stays within the interaction span family, which makes this attribute, not the op, the way to tell a real click from a value with no interaction.',
    ],
  },
  'browser.web_vital.inp.target': {
    brief:
      'The HTML element selector or component name of the element the user interacted with, for the interaction INP was reported on',
    type: 'string',
    keys: ['browser.web_vital.inp.target'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'body > div#app > button.submit',
    examples: ['body > div#app > button.submit', 'SubmitButton'],
    changelog: [{ version: '0.24.0', prs: [641], description: 'Added browser.web_vital.inp.target attribute' }],
    additionalContext: [
      'Named after `PerformanceEventTiming.target`, the way `browser.web_vital.lcp.element` is named after `LargestContentfulPaint.element`. The value uses the same format as that attribute.',
      'Omitted when INP is reported without an interaction to attribute it to. web-vitals reports such a value for a soft navigation whose interactions all stayed below the Event Timing duration threshold, so there is no element to name. The span is still named and still carries `browser.web_vital.inp.value`.',
    ],
  },
  'browser.web_vital.inp.value': {
    brief: 'The value of the recorded Interaction to Next Paint (INP) web vital',
    type: 'double',
    keys: ['browser.web_vital.inp.value', 'inp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 200,
    aliases: ['inp'],
    changelog: [{ version: '0.5.0', prs: [229], description: 'Added browser.web_vital.inp.value attribute' }],
  },
  'browser.web_vital.lcp.element': {
    brief: 'The HTML element selector or component name for which LCP was reported',
    type: 'string',
    keys: ['browser.web_vital.lcp.element', 'lcp.element'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'body > div#app > div#container > div',
    aliases: ['lcp.element'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.id': {
    brief: 'The id of the dom element responsible for the largest contentful paint',
    type: 'string',
    keys: ['browser.web_vital.lcp.id', 'lcp.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '#gero',
    aliases: ['lcp.id'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.load_time': {
    brief: 'The time it took for the LCP element to be loaded',
    type: 'integer',
    keys: ['browser.web_vital.lcp.load_time', 'lcp.loadTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1402,
    aliases: ['lcp.loadTime'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.render_time': {
    brief: 'The time it took for the LCP element to be rendered',
    type: 'integer',
    keys: ['browser.web_vital.lcp.render_time', 'lcp.renderTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1685,
    aliases: ['lcp.renderTime'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.report_event': {
    brief: 'The event that caused the SDK to report LCP (pagehide or navigation)',
    type: 'string',
    keys: ['browser.web_vital.lcp.report_event'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'pagehide',
    deprecation: {
      reason:
        'The JavaScript SDK stopped setting this in v11. With per-navigation web vitals, web-vitals decides when the LCP value is final, so there is no report event to record. No replacement.',
    },
    changelog: [
      {
        version: '0.24.0',
        prs: [642],
        description: 'Deprecated browser.web_vital.lcp.report_event, which has no replacement',
      },
      { version: '0.5.0', prs: [319], description: 'Added browser.web_vital.lcp.report_event attribute' },
    ],
  },
  'browser.web_vital.lcp.size': {
    brief: 'The size of the largest contentful paint element',
    type: 'integer',
    keys: ['browser.web_vital.lcp.size', 'lcp.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1024,
    aliases: ['lcp.size'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.url': {
    brief: 'The url of the dom element responsible for the largest contentful paint',
    type: 'string',
    keys: ['browser.web_vital.lcp.url', 'lcp.url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com/static/img.png',
    aliases: ['lcp.url'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'browser.web_vital.lcp.value': {
    brief: 'The value of the recorded Largest Contentful Paint (LCP) web vital',
    type: 'double',
    keys: ['browser.web_vital.lcp.value', 'lcp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2500,
    aliases: ['lcp'],
    changelog: [{ version: '0.5.0', prs: [229], description: 'Added browser.web_vital.lcp.value attribute' }],
  },
  'browser.web_vital.ttfb.request_time': {
    brief:
      "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
    type: 'double',
    keys: ['browser.web_vital.ttfb.request_time', 'ttfb.requestTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1554.5814,
    aliases: ['ttfb.requestTime'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'browser.web_vital.ttfb.value': {
    brief: 'The value of the recorded Time To First Byte (TTFB) web vital in Milliseconds',
    type: 'double',
    keys: ['browser.web_vital.ttfb.value', 'ttfb'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 194.3322,
    aliases: ['ttfb'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'cache.hit': {
    brief: 'If the cache was hit during this span.',
    type: 'boolean',
    keys: ['cache.hit'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'cache.item_age': {
    brief: 'The age of the cache entry in seconds, measured at read time.',
    type: 'integer',
    keys: ['cache.item_age'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 5,
    examples: [5, 3600],
    changelog: [{ version: '0.23.0', prs: [637], description: 'Added cache.item_age attribute' }],
    additionalContext: [
      'Set on reads that return an entry. Absent on a miss, or when the cache does not report a write time.',
      "Clamped to 0. On a shared cache, the writer's clock and the reader's clock can drift far enough to make the age negative.",
      'Can exceed `cache.ttl`. A cache that discards an expired entry on read still reports the age of that entry, with `cache.hit: false`.',
    ],
    searchAlias: {
      name: 'cache.item_age',
      type: 'second',
    },
  },
  'cache.item_size': {
    brief: 'The size of the requested item in the cache. In bytes.',
    type: 'integer',
    keys: ['cache.item_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 58,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'cache.item_size',
      type: 'byte',
    },
  },
  'cache.key': {
    brief: 'The key of the cache accessed.',
    type: 'string[]',
    keys: ['cache.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['my-cache-key', 'my-other-cache-key'],
    changelog: [{ version: '0.0.0' }],
  },
  'cache.operation': {
    brief: 'The operation being performed on the cache.',
    type: 'string',
    keys: ['cache.operation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'get',
    examples: ['get', 'put', 'remove'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'cache.tags': {
    brief: 'The tags attached to the cache entry. Tags group entries so a cache can invalidate them together.',
    type: 'string[]',
    keys: ['cache.tags'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Applications pick tag values freely and often build them from record identifiers such as a user id.',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['blog-posts', 'post-42'],
    examples: [['blog-posts', 'post-42'], ['products']],
    changelog: [{ version: '0.23.0', prs: [637], description: 'Added cache.tags attribute' }],
    additionalContext: [
      'Cache library examples that support tags: Next.js `cacheTag()`, Symfony `ItemInterface::tag()`, Laravel `Cache::tags()`.',
      'HTTP caches take tags from a response header. Cloudflare reads `Cache-Tag`, Fastly reads `Surrogate-Key`.',
      'Record only the tags the application declared. Leave out implicit tags that the framework adds itself, for example one tag per route.',
      'The tags describe the entry, not the operation. Take them from the entry the cache returned or stored.',
    ],
  },
  'cache.ttl': {
    brief: 'The ttl (maximum lifetime) of the cache in seconds',
    type: 'integer',
    keys: ['cache.ttl'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 120,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'cache.write': {
    brief: 'If the cache operation resulted in a write to the cache.',
    type: 'boolean',
    keys: ['cache.write'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0' }],
  },
  channel: {
    brief: 'The channel name that is being used.',
    type: 'string',
    keys: ['channel'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'mail',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'client.address': {
    brief:
      'Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.',
    type: 'string',
    keys: ['client.address', 'http.client_ip'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    aliases: ['http.client_ip'],
    changelog: [{ version: '0.1.0', prs: [106, 127] }, { version: '0.0.0' }],
  },
  'client.port': {
    brief: 'Client port number.',
    type: 'integer',
    keys: ['client.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 5432,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'cloudflare.d1.duration': {
    brief: 'The duration of a Cloudflare D1 operation.',
    type: 'integer',
    keys: ['cloudflare.d1.duration'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 543,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'cloudflare.d1.query_type': {
    brief: 'The type of query executed in a Cloudflare D1 operation',
    type: 'string',
    keys: ['db.operation.name', 'cloudflare.d1.query_type', 'db.operation', 'redis.command'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'run',
    deprecation: {
      replacement: 'db.operation.name',
      status: 'backfill',
    },
    aliases: ['db.operation.name', 'db.operation', 'redis.command'],
    changelog: [
      { version: '0.19.0', prs: [531], description: 'Added redis.command as an alias' },
      { version: '0.11.0', prs: [392], description: 'Added cloudflare.d1.query_type attribute' },
    ],
  },
  'cloudflare.d1.rows_read': {
    brief: 'The number of rows read in a Cloudflare D1 operation.',
    type: 'integer',
    keys: ['cloudflare.d1.rows_read'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'cloudflare.d1.rows_written': {
    brief: 'The number of rows written in a Cloudflare D1 operation.',
    type: 'integer',
    keys: ['cloudflare.d1.rows_written'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'cloudflare.durable_object.query.bindings': {
    brief: 'The number of bound parameters passed to the SQL exec call.',
    type: 'integer',
    keys: ['cloudflare.durable_object.query.bindings'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    changelog: [
      { version: '0.13.0', prs: [435], description: 'Added cloudflare.durable_object.query.bindings attribute' },
    ],
  },
  'cloudflare.durable_object.response.rows_read': {
    brief: 'The number of rows read by a Cloudflare Durable Object SQL operation.',
    type: 'integer',
    keys: ['cloudflare.durable_object.response.rows_read'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12,
    changelog: [
      { version: '0.13.0', prs: [435], description: 'Added cloudflare.durable_object.response.rows_read attribute' },
    ],
  },
  'cloudflare.durable_object.response.rows_written': {
    brief: 'The number of rows written by a Cloudflare Durable Object SQL operation.',
    type: 'integer',
    keys: ['cloudflare.durable_object.response.rows_written'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    changelog: [
      { version: '0.13.0', prs: [435], description: 'Added cloudflare.durable_object.response.rows_written attribute' },
    ],
  },
  'cloudflare.r2.bucket': {
    brief: 'The name of the Cloudflare R2 bucket binding',
    type: 'string',
    keys: ['cloudflare.r2.bucket'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'MY_BUCKET',
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.bucket attribute' }],
  },
  'cloudflare.r2.operation': {
    brief: 'The R2 API operation being performed',
    type: 'string',
    keys: ['cloudflare.r2.operation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GetObject',
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.operation attribute' }],
  },
  'cloudflare.r2.request.delimiter': {
    brief: 'The delimiter used to group objects in an R2 list operation',
    type: 'string',
    keys: ['cloudflare.r2.request.delimiter'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/',
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.request.delimiter attribute' }],
  },
  'cloudflare.r2.request.key': {
    brief: 'The object key used in the R2 operation',
    type: 'string',
    keys: ['cloudflare.r2.request.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-file.txt',
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.request.key attribute' }],
  },
  'cloudflare.r2.request.part_number': {
    brief: 'The part number in a multipart upload operation',
    type: 'integer',
    keys: ['cloudflare.r2.request.part_number'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.request.part_number attribute' }],
  },
  'cloudflare.r2.request.prefix': {
    brief: 'The prefix used to filter objects in an R2 list operation',
    type: 'string',
    keys: ['cloudflare.r2.request.prefix'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'images/',
    changelog: [{ version: '0.11.1', prs: [413], description: 'Added cloudflare.r2.request.prefix attribute' }],
  },
  'cloudflare.workflow.attempt': {
    brief: 'The current attempt number for a Cloudflare Workflow step',
    type: 'integer',
    keys: ['cloudflare.workflow.attempt'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    changelog: [{ version: '0.11.0', prs: [392], description: 'Added cloudflare.workflow.attempt attribute' }],
  },
  'cloudflare.workflow.retries.backoff': {
    brief: 'The backoff strategy for Cloudflare Workflow step retries',
    type: 'string',
    keys: ['cloudflare.workflow.retries.backoff'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'exponential',
    changelog: [{ version: '0.11.0', prs: [392], description: 'Added cloudflare.workflow.retries.backoff attribute' }],
  },
  'cloudflare.workflow.retries.delay': {
    brief: 'The delay between Cloudflare Workflow step retries',
    type: 'string',
    keys: ['cloudflare.workflow.retries.delay'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '5 seconds',
    changelog: [{ version: '0.11.0', prs: [392], description: 'Added cloudflare.workflow.retries.delay attribute' }],
  },
  'cloudflare.workflow.retries.limit': {
    brief: 'The maximum number of retries for a Cloudflare Workflow step',
    type: 'integer',
    keys: ['cloudflare.workflow.retries.limit'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3,
    changelog: [{ version: '0.11.0', prs: [392], description: 'Added cloudflare.workflow.retries.limit attribute' }],
  },
  'cloudflare.workflow.timeout': {
    brief: 'The timeout duration for a Cloudflare Workflow step',
    type: 'string',
    keys: ['cloudflare.workflow.timeout'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1 minute',
    changelog: [{ version: '0.11.0', prs: [392], description: 'Added cloudflare.workflow.timeout attribute' }],
  },
  'cloud.account.id': {
    brief: 'The cloud account ID the resource is assigned to',
    type: 'string',
    keys: ['cloud.account.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '123456789012',
    changelog: [{ version: '0.7.0', prs: [364], description: 'Added cloud.account.id attribute' }],
  },
  'cloud.availability_zone': {
    brief: 'Cloud regions often have multiple, isolated locations known as zones to increase availability',
    type: 'string',
    keys: ['cloud.availability_zone'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'us-east-1c',
    changelog: [{ version: '0.7.0', prs: [364], description: 'Added cloud.availability_zone attribute' }],
  },
  'cloud.platform': {
    brief: 'The cloud platform in use',
    type: 'string',
    keys: ['cloud.platform'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'aws_lambda',
    changelog: [{ version: '0.7.0', prs: [364], description: 'Added cloud.platform attribute' }],
  },
  'cloud.provider': {
    brief: 'Name of the cloud provider',
    type: 'string',
    keys: ['cloud.provider'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'aws',
    changelog: [{ version: '0.7.0', prs: [364], description: 'Added cloud.provider attribute' }],
  },
  'cloud.region': {
    brief: 'The geographical region the resource is running',
    type: 'string',
    keys: ['cloud.region', 'aws_region', 'gcp_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'us-east-1',
    aliases: ['aws_region', 'gcp_region'],
    changelog: [
      { version: '0.19.0', prs: [535, 537], description: 'Added aws_region and gcp_region as aliases' },
      { version: '0.7.0', prs: [364], description: 'Added cloud.region attribute' },
    ],
  },
  'cloud.resource_id': {
    brief: 'Cloud provider-specific native identifier of the monitored cloud resource',
    type: 'string',
    keys: ['cloud.resource_id', 'faas.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function',
    aliases: ['faas.id'],
    changelog: [
      { version: '0.16.0', prs: [475], description: 'Added faas.id as an alias' },
      { version: '0.11.1', prs: [414] },
    ],
    additionalContext: [
      'This can be an identifier for a resource in AWS, GCP, or Azure. There may be some overlap in values found here with other attributes. For instance, an AWS lambda ARN may be found here as well as in `aws.lambda.invoked_arn`. OTEL recommends setting them alongside each other.',
    ],
  },
  cls: {
    brief: 'The value of the recorded Cumulative Layout Shift (CLS) web vital',
    type: 'double',
    keys: ['browser.web_vital.cls.value', 'cls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.2361,
    deprecation: {
      replacement: 'browser.web_vital.cls.value',
      reason: 'The CLS web vital is now recorded as a browser.web_vital.cls.value attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.cls.value'],
    changelog: [
      {
        version: '0.5.0',
        prs: [229],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'cls.source.<key>': {
    brief: 'The HTML elements or components responsible for the layout shift. <key> is a numeric index from 1 to N',
    type: 'string',
    keys: ['browser.web_vital.cls.source.<key>', 'cls.source.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'body > div#app',
    deprecation: {
      replacement: 'browser.web_vital.cls.source.<key>',
      reason: 'The CLS source is now recorded as a browser.web_vital.cls.source.<key> attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.cls.source.<key>'],
    changelog: [{ version: '0.5.0', prs: [234] }],
  },
  code: {
    brief: 'Status code of the RPC returned by the RPC server or generated by the client.',
    type: 'string',
    keys: ['rpc.response.status_code', 'code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'DEADLINE_EXCEEDED',
    examples: ['DEADLINE_EXCEEDED'],
    deprecation: {
      replacement: 'rpc.response.status_code',
      status: 'backfill',
    },
    aliases: ['rpc.grpc.status_code', 'rpc.response.status_code'],
    changelog: [{ version: '0.19.0', prs: [533], description: 'Added code attribute' }],
  },
  'code.filepath': {
    brief:
      'The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).',
    type: 'string',
    keys: ['code.file.path', 'sveltekit.load.node_id', 'code.filepath'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/app/myapplication/http/handler/server.py',
    deprecation: {
      replacement: 'code.file.path',
      status: 'backfill',
    },
    aliases: ['code.file.path', 'sveltekit.load.node_id'],
    changelog: [
      { version: '0.22.0', prs: [611], description: 'Added sveltekit.load.node_id as an alias' },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'code.file.path': {
    brief:
      'The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).',
    type: 'string',
    keys: ['code.file.path', 'sveltekit.load.node_id', 'code.filepath'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/app/myapplication/http/handler/server.py',
    aliases: ['code.filepath', 'sveltekit.load.node_id'],
    changelog: [
      { version: '0.22.0', prs: [611], description: 'Added sveltekit.load.node_id as an alias' },
      { version: '0.0.0' },
    ],
  },
  'code.function': {
    brief: "The method or function name, or equivalent (usually rightmost part of the code unit's name).",
    type: 'string',
    keys: ['code.function', 'code.function.name', 'django.function_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'server_request',
    aliases: ['code.function.name', 'django.function_name'],
    changelog: [
      { version: '0.19.0', prs: [538], description: 'Added django.function_name as an alias' },
      { version: '0.1.0', prs: [61, 74] },
      { version: '0.0.0' },
    ],
  },
  'code.function.name': {
    brief: 'The method or function fully-qualified name without arguments.',
    type: 'string',
    keys: ['code.function.name', 'code.function', 'django.function_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'server_request',
    aliases: ['code.function', 'django.function_name'],
    changelog: [
      { version: '0.19.0', prs: [538], description: 'Added django.function_name as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'code.lineno': {
    brief:
      'The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function',
    type: 'integer',
    keys: ['code.line.number', 'code.lineno'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 42,
    deprecation: {
      replacement: 'code.line.number',
      status: 'backfill',
    },
    aliases: ['code.line.number'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61, 108] }, { version: '0.0.0' }],
  },
  'code.line.number': {
    brief:
      'The line number in code.filepath best representing the operation. It SHOULD point within the code unit named in code.function',
    type: 'integer',
    keys: ['code.line.number', 'code.lineno'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 42,
    aliases: ['code.lineno'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'code.namespace': {
    brief:
      "The 'namespace' within which code.function is defined. Usually the qualified class or module name, such that code.namespace + some separator + code.function form a unique identifier for the code unit.",
    type: 'string',
    keys: ['code.namespace'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'http.handler',
    changelog: [{ version: '0.1.0', prs: [61, 74] }, { version: '0.0.0' }],
  },
  connectionType: {
    brief: 'Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).',
    type: 'string',
    keys: ['network.connection.type', 'connectionType', 'device.connection_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'wifi',
    deprecation: {
      replacement: 'network.connection.type',
      reason: 'Old namespace-less attribute, to be replaced with network.connection.type for span-first future',
      status: 'backfill',
    },
    aliases: ['network.connection.type', 'device.connection_type'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'connection.rtt': {
    brief: 'Specifies the estimated effective round-trip time of the current connection, in milliseconds.',
    type: 'integer',
    keys: ['network.connection.rtt', 'connection.rtt'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    deprecation: {
      replacement: 'network.connection.rtt',
      reason:
        'Old attribute name (no official namespace), to be replaced with network.connection.rtt for span-first future',
      status: 'backfill',
    },
    aliases: ['network.connection.rtt'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'culture.calendar': {
    brief: 'The calendar system used by the culture.',
    type: 'string',
    keys: ['culture.calendar'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GregorianCalendar',
    changelog: [{ version: '0.4.0', prs: [243] }],
  },
  'culture.display_name': {
    brief: 'Human readable name of the culture.',
    type: 'string',
    keys: ['culture.display_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'English (United States)',
    changelog: [{ version: '0.4.0', prs: [243] }],
  },
  'culture.is_24_hour_format': {
    brief: 'Whether the culture uses 24-hour time format.',
    type: 'boolean',
    keys: ['culture.is_24_hour_format'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.4.0', prs: [243] }],
  },
  'culture.locale': {
    brief: 'The locale identifier following RFC 4646.',
    type: 'string',
    keys: ['culture.locale'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'en-US',
    changelog: [{ version: '0.4.0', prs: [243] }],
  },
  'culture.timezone': {
    brief: 'The timezone of the culture, as a geographic timezone identifier.',
    type: 'string',
    keys: ['culture.timezone'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Europe/Vienna',
    changelog: [{ version: '0.4.0', prs: [243] }],
  },
  'db.collection.name': {
    brief: 'The name of a collection (table, container) within the database.',
    type: 'string',
    keys: ['db.collection.name', 'db.mongodb.collection'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'users',
    aliases: ['db.mongodb.collection'],
    changelog: [
      { version: '0.19.0', prs: [483], description: 'Added db.mongodb.collection as an alias' },
      { version: '0.1.0', prs: [106, 127] },
      { version: '0.0.0' },
    ],
  },
  'db.connection_string': {
    brief: 'The connection string used to connect to the database.',
    type: 'string',
    keys: ['db.connection_string'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'redis://localhost:6379',
    examples: ['redis://localhost:6379'],
    deprecation: {
      reason:
        'This attribute is deprecated. The connection is described by server.address and server.port instead, so the value cannot be copied to a single replacement attribute.',
    },
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added db.connection_string attribute' }],
  },
  'db.driver.name': {
    brief: 'The name of the driver used for the database connection.',
    type: 'string',
    keys: ['db.driver.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'psycopg2',
    changelog: [{ version: '0.5.0', prs: [297], description: 'Added db.driver.name attribute' }],
  },
  'db.mongodb.collection': {
    brief: 'The MongoDB collection being accessed.',
    type: 'string',
    keys: ['db.collection.name', 'db.mongodb.collection'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'users',
    deprecation: {
      replacement: 'db.collection.name',
      reason:
        'This attribute is being deprecated in favor of db.collection.name, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['db.collection.name'],
    changelog: [
      {
        version: '0.19.0',
        prs: [483],
        description: 'Added db.mongodb.collection attribute, deprecated in favor of db.collection.name',
      },
    ],
  },
  'db.name': {
    brief: 'The name of the database being accessed.',
    type: 'string',
    keys: ['db.namespace', 'db.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'customers',
    deprecation: {
      replacement: 'db.namespace',
      status: 'backfill',
    },
    aliases: ['db.namespace'],
    changelog: [{ version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
  },
  'db.namespace': {
    brief: 'The name of the database being accessed.',
    type: 'string',
    keys: ['db.namespace', 'db.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'customers',
    aliases: ['db.name'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'db.operation': {
    brief: 'The name of the operation being executed.',
    type: 'string',
    keys: ['db.operation.name', 'cloudflare.d1.query_type', 'db.operation', 'redis.command'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'SELECT',
    deprecation: {
      replacement: 'db.operation.name',
      status: 'normalize',
    },
    aliases: ['db.operation.name', 'cloudflare.d1.query_type', 'redis.command'],
    changelog: [
      { version: '0.19.0', prs: [531], description: 'Added redis.command as an alias' },
      { version: '0.4.0', prs: [199] },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'db.operation.batch.size': {
    brief:
      'The number of queries included in a batch operation. Operations are only considered batches when they contain two or more operations, and so db.operation.batch.size SHOULD never be 1.',
    type: 'integer',
    keys: ['db.operation.batch.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 3,
    changelog: [{ version: '0.11.0', prs: [407], description: 'Added db.operation.batch.size attribute' }],
  },
  'db.operation.name': {
    brief: 'The name of the operation being executed.',
    type: 'string',
    keys: ['db.operation.name', 'cloudflare.d1.query_type', 'db.operation', 'redis.command'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'SELECT',
    aliases: ['db.operation', 'cloudflare.d1.query_type', 'redis.command'],
    changelog: [
      { version: '0.19.0', prs: [531], description: 'Added redis.command as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'db.params': {
    brief: 'The query bindings for a database request.',
    type: 'string',
    keys: ['db.params'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"x": 100}]',
    examples: ['[{"x": 100}]'],
    deprecation: {
      replacement: 'db.query.parameter.<key>',
      reason:
        'Instead of adding every binding in the db.params attribute, add them as individual entries with db.query.parameter.<key>.',
    },
    changelog: [{ version: '0.19.0', prs: [529], description: 'Added db.params attribute' }],
  },
  'db.query.parameter.<key>': {
    brief:
      'A query parameter used in db.query.text, with <key> being the parameter name, and the attribute value being a string representation of the parameter value.',
    type: 'string',
    keys: ['db.query.parameter.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "db.query.parameter.foo='123'",
    changelog: [{ version: '0.1.0', prs: [103, 127] }],
  },
  'db.query.summary': {
    brief:
      'A shortened representation of operation(s) in the full query. This attribute must be low-cardinality and should only contain the operation table names.',
    type: 'string',
    keys: ['db.query.summary'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'SELECT users',
    examples: ['SELECT users', 'INSERT products; UPDATE orders'],
    changelog: [
      { version: '0.19.0', prs: [505], description: 'Added multiple examples' },
      { version: '0.4.0', prs: [208] },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'db.query.text': {
    brief:
      'The database parameterized query being executed. Any parameter values (filters, insertion values, etc) should be replaced with parameter placeholders. If applicable, use `db.query.parameter.<key>` to add the parameter value.',
    type: 'string',
    keys: ['db.query.text', 'db.statement', 'query'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'SELECT * FROM users WHERE id = $1',
    aliases: ['db.statement', 'query'],
    changelog: [
      { version: '0.19.0', prs: [530], description: 'Added query as an alias' },
      { version: '0.4.0', prs: [208] },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'db.redis.connection': {
    brief: 'The redis connection name.',
    type: 'string',
    keys: ['db.redis.connection'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-redis-instance',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'db.redis.key': {
    brief: 'The key the Redis command is operating on.',
    type: 'string',
    keys: ['db.redis.key', 'redis.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user:2047:city',
    aliases: ['redis.key'],
    changelog: [
      { version: '0.19.0', prs: [484], description: 'Added redis.key as an alias' },
      { version: '0.6.0', prs: [326], description: 'Added db.redis.key attribute' },
    ],
  },
  'db.redis.parameters': {
    brief: 'The array of command parameters given to a redis command.',
    type: 'string[]',
    keys: ['db.redis.parameters'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['test', '*'],
    changelog: [{ version: '0.0.0' }],
  },
  'db.response.status_code': {
    brief:
      'Database response status code. The status code returned by the database. Usually it represents an error code, but may also represent partial success, warning, or differentiate between various types of successful outcomes.',
    type: 'string',
    keys: ['db.response.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ORA-17002',
    changelog: [{ version: '0.16.0', prs: [462], description: 'Added db.response.status_code attribute' }],
  },
  'db.sql.bindings': {
    brief: 'The array of query bindings.',
    type: 'string[]',
    keys: ['db.sql.bindings'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['1', 'foo'],
    deprecation: {
      replacement: 'db.query.parameter.<key>',
      reason:
        'Instead of adding every binding in the db.sql.bindings attribute, add them as individual entires with db.query.parameter.<key>.',
    },
    changelog: [{ version: '0.1.0', prs: [61] }, { version: '0.0.0' }],
  },
  'db.statement': {
    brief: 'The database statement being executed.',
    type: 'string',
    keys: ['db.query.text', 'db.statement', 'query'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'SELECT * FROM users WHERE id = $1',
    deprecation: {
      replacement: 'db.query.text',
      reason:
        'While this attribute never specifically required parameterization, the replacement, db.query.text, does.',
      status: 'normalize',
    },
    aliases: ['db.query.text', 'query'],
    changelog: [
      {
        version: '0.19.0',
        prs: [501],
        description: 'Improved example, added deprecation reason, and added query as an alias',
      },
      { version: '0.4.0', prs: [199] },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'db.stored_procedure.name': {
    brief: 'The name of a stored procedure being called.',
    type: 'string',
    keys: ['db.stored_procedure.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'GetUserById',
    changelog: [{ version: '0.11.0', prs: [398] }],
  },
  'db.system': {
    brief:
      'An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.',
    type: 'string',
    keys: ['db.system.name', 'db.system', 'span.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'postgresql',
    deprecation: {
      replacement: 'db.system.name',
      status: 'backfill',
    },
    aliases: ['db.system.name'],
    changelog: [{ version: '0.4.0', prs: [199, 224] }, { version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'db.system',
      deprecatedAliases: ['span.system'],
    },
  },
  'db.system.name': {
    brief:
      'An identifier for the database management system (DBMS) product being used. See [OpenTelemetry docs](https://github.com/open-telemetry/semantic-conventions/blob/main/docs/database/database-spans.md#notes-and-well-known-identifiers-for-dbsystem) for a list of well-known identifiers.',
    type: 'string',
    keys: ['db.system.name', 'db.system', 'span.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'postgresql',
    aliases: ['db.system'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'db.user': {
    brief: 'The database user.',
    type: 'string',
    keys: ['db.user'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'fancy_user',
    changelog: [{ version: '0.0.0' }],
  },
  deviceMemory: {
    brief: 'The estimated total memory capacity of the device, only a rough estimation in gigabytes.',
    type: 'string',
    keys: ['device.memory.estimated_capacity', 'deviceMemory'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '8 GB',
    deprecation: {
      replacement: 'device.memory.estimated_capacity',
      reason:
        'Old namespace-less attribute, to be replaced with device.memory.estimated_capacity for span-first future',
      status: 'backfill',
    },
    aliases: ['device.memory.estimated_capacity'],
    changelog: [
      {
        version: '0.5.0',
        prs: [281],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'device.archs': {
    brief: 'The CPU architectures of the device.',
    type: 'string[]',
    keys: ['device.archs'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['arm64-v8a', 'armeabi-v7a', 'armeabi'],
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.archs attribute' }],
  },
  'device.battery_level': {
    brief: 'The battery level of the device as a percentage (0-100).',
    type: 'double',
    keys: ['device.battery_level'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.battery_level attribute' }],
  },
  'device.battery_temperature': {
    brief: 'The battery temperature of the device in Celsius.',
    type: 'double',
    keys: ['device.battery_temperature'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 25,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.battery_temperature attribute' }],
  },
  'device.boot_time': {
    brief: 'A formatted UTC timestamp when the system was booted.',
    type: 'string',
    keys: ['device.boot_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2018-02-08T12:52:12Z',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.boot_time attribute' }],
  },
  'device.brand': {
    brief: 'The brand of the device.',
    type: 'string',
    keys: ['device.brand'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Apple',
    changelog: [{ version: '0.1.0', prs: [116, 127] }],
  },
  'device.charging': {
    brief: 'Whether the device was charging or not.',
    type: 'boolean',
    keys: ['device.charging'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: false,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.charging attribute' }],
  },
  'device.chipset': {
    brief: 'The chipset of the device.',
    type: 'string',
    keys: ['device.chipset'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Qualcomm SM8550',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.chipset attribute' }],
  },
  'device.class': {
    brief:
      'The classification of the device. For example, `low`, `medium`, or `high`. Typically inferred by Relay - SDKs generally do not need to set this directly.',
    type: 'string',
    keys: ['device.class'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'medium',
    changelog: [{ version: '0.5.0', prs: [300], description: 'Added device.class attribute' }],
  },
  'device.connection_type': {
    brief: 'The internet connection type currently being used by the device.',
    type: 'string',
    keys: ['network.connection.type', 'connectionType', 'device.connection_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'wifi',
    deprecation: {
      replacement: 'network.connection.type',
      reason: 'This attribute is being deprecated in favor of network.connection.type',
      status: 'backfill',
    },
    aliases: ['network.connection.type', 'connectionType'],
    changelog: [
      {
        version: '0.5.0',
        prs: [303],
        description: 'Added and deprecated device.connection_type in favor of network.connection.type',
      },
    ],
  },
  'device.cpu_description': {
    brief: 'A description of the CPU of the device.',
    type: 'string',
    keys: ['device.cpu_description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Intel(R) Core(TM)2 Quad CPU Q6600 @ 2.40GHz',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.cpu_description attribute' }],
  },
  'device.external_free_storage': {
    brief: 'External storage free size in bytes.',
    type: 'integer',
    keys: ['device.external_free_storage'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 67108864000,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.external_free_storage attribute' }],
  },
  'device.external_storage_size': {
    brief: 'External storage total size in bytes.',
    type: 'integer',
    keys: ['device.external_storage_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 134217728000,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.external_storage_size attribute' }],
  },
  'device.family': {
    brief: 'The family of the device.',
    type: 'string',
    keys: ['device.family'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'iPhone',
    changelog: [{ version: '0.1.0', prs: [116, 127] }],
  },
  'device.free_memory': {
    brief: 'Free system memory in bytes.',
    type: 'integer',
    keys: ['device.free_memory'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2147483648,
    changelog: [{ version: '0.5.0', prs: [300], description: 'Added device.free_memory attribute' }],
  },
  'device.free_storage': {
    brief: 'Free device storage in bytes.',
    type: 'integer',
    keys: ['device.free_storage'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 107374182400,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.free_storage attribute' }],
  },
  'device.id': {
    brief: 'Unique device identifier.',
    type: 'string',
    keys: ['device.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.id attribute' }],
  },
  'device.locale': {
    brief: 'The locale of the device.',
    type: 'string',
    keys: ['device.locale'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'en-US',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.locale attribute' }],
  },
  'device.low_memory': {
    brief: 'Whether the device was low on memory.',
    type: 'boolean',
    keys: ['device.low_memory'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: false,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.low_memory attribute' }],
  },
  'device.low_power_mode': {
    brief: 'Whether the device is in Low Power Mode.',
    type: 'boolean',
    keys: ['device.low_power_mode'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.6.0', prs: [314], description: 'Added device.low_power_mode attribute' }],
  },
  'device.manufacturer': {
    brief: 'The manufacturer of the device.',
    type: 'string',
    keys: ['device.manufacturer'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Google',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.manufacturer attribute' }],
  },
  'device.memory.estimated_capacity': {
    brief:
      'The estimated total memory capacity of the device, only a rough estimation in gigabytes. Browsers report estimations in buckets of powers of 2, mostly capped at 8 GB',
    type: 'integer',
    keys: ['device.memory.estimated_capacity', 'deviceMemory'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 8,
    aliases: ['deviceMemory'],
    changelog: [
      {
        version: '0.5.0',
        prs: [281],
        description: 'Added attribute device.memory.estimated_capacity to be used instead of deviceMemory',
      },
    ],
  },
  'device.memory_size': {
    brief: 'Total system memory available in bytes.',
    type: 'integer',
    keys: ['device.memory_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 17179869184,
    changelog: [{ version: '0.5.0', prs: [300], description: 'Added device.memory_size attribute' }],
  },
  'device.model': {
    brief: 'The model of the device.',
    type: 'string',
    keys: ['device.model'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'iPhone 15 Pro Max',
    changelog: [{ version: '0.1.0', prs: [116, 127] }],
  },
  'device.model_id': {
    brief: 'An internal hardware revision to identify the device exactly.',
    type: 'string',
    keys: ['device.model_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'N861AP',
    changelog: [{ version: '0.5.0', prs: [300], description: 'Added device.model_id attribute' }],
  },
  'device.name': {
    brief: 'The user-assigned name of the mobile device.',
    type: 'string',
    keys: ['device.name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'localhost',
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Limit brief to mobile attributes and remove server_name alias' },
      { version: '0.21.0', prs: [602], description: 'Added server_name as an alias' },
      { version: '0.5.0', prs: [303], description: 'Added device.name attribute' },
    ],
  },
  'device.online': {
    brief: 'Whether the device was online or not.',
    type: 'boolean',
    keys: ['device.online'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.online attribute' }],
  },
  'device.orientation': {
    brief: 'The orientation of the device, either "portrait" or "landscape".',
    type: 'string',
    keys: ['device.orientation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'portrait',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.orientation attribute' }],
  },
  'device.processor_count': {
    brief: 'Number of "logical processors".',
    type: 'integer',
    keys: ['device.processor_count', 'hardwareConcurrency'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 8,
    aliases: ['hardwareConcurrency'],
    changelog: [
      {
        version: '0.5.0',
        prs: [300],
        description: 'Added and deprecated attribute device.processor_count in favor of device.cpu.logical_core_count',
      },
    ],
  },
  'device.processor_frequency': {
    brief: 'Processor frequency in MHz.',
    type: 'double',
    keys: ['device.processor_frequency'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2400,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.processor_frequency attribute' }],
  },
  'device.screen_density': {
    brief: 'The screen density of the device.',
    type: 'double',
    keys: ['device.screen_density'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2.625,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.screen_density attribute' }],
  },
  'device.screen_dpi': {
    brief: 'The screen density in dots-per-inch (DPI) of the device.',
    type: 'integer',
    keys: ['device.screen_dpi'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 420,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.screen_dpi attribute' }],
  },
  'device.screen_height_pixels': {
    brief: 'The height of the device screen in pixels.',
    type: 'integer',
    keys: ['device.screen_height_pixels'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2400,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.screen_height_pixels attribute' }],
  },
  'device.screen_width_pixels': {
    brief: 'The width of the device screen in pixels.',
    type: 'integer',
    keys: ['device.screen_width_pixels'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1080,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.screen_width_pixels attribute' }],
  },
  'device.simulator': {
    brief: 'Whether the device is a simulator or an actual device.',
    type: 'boolean',
    keys: ['device.simulator'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: false,
    changelog: [{ version: '0.5.0', prs: [300], description: 'Added device.simulator attribute' }],
  },
  'device.storage_size': {
    brief: 'Total device storage in bytes.',
    type: 'integer',
    keys: ['device.storage_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 274877906944,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.storage_size attribute' }],
  },
  'device.thermal_state': {
    brief: "The thermal state of the device. Based on Apple's `ProcessInfo.ThermalState` enum.",
    type: 'string',
    keys: ['device.thermal_state'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'nominal',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.thermal_state attribute' }],
  },
  'device.timezone': {
    brief: 'The timezone of the device.',
    type: 'string',
    keys: ['device.timezone'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Europe/Vienna',
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.timezone attribute' }],
  },
  'device.usable_memory': {
    brief: 'Memory usable for the app in bytes.',
    type: 'integer',
    keys: ['device.usable_memory'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2147483648,
    changelog: [{ version: '0.5.0', prs: [303], description: 'Added device.usable_memory attribute' }],
  },
  dist: {
    brief: 'The sentry dist.',
    type: 'string',
    keys: ['sentry.dist', 'dist'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0',
    deprecation: {
      replacement: 'sentry.dist',
      reason: 'This attribute is being deprecated in favor of sentry.dist.',
      status: 'backfill',
    },
    aliases: ['sentry.dist'],
    changelog: [{ version: '0.16.0', prs: [489], description: 'Added dist attribute' }],
  },
  'django.function_name': {
    brief: 'The fully qualified name of a function used in a Django context.',
    type: 'string',
    keys: ['code.function.name', 'code.function', 'django.function_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'django.contrib.sessions.middleware.SessionMiddleware',
    examples: ['django.contrib.sessions.middleware.SessionMiddleware'],
    deprecation: {
      replacement: 'code.function.name',
      reason:
        'This attribute is being deprecated in favor of code.function.name, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['code.function.name', 'code.function'],
    changelog: [{ version: '0.19.0', prs: [538], description: 'Added django.function_name attribute' }],
  },
  'django.middleware_name': {
    brief: 'The name of the Django middleware.',
    type: 'string',
    keys: [
      'middleware.name',
      'django.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
      'starlite.middleware_name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AuthenticationMiddleware',
    examples: ['AuthenticationMiddleware'],
    deprecation: {
      replacement: 'middleware.name',
      reason:
        'This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['middleware.name'],
    changelog: [{ version: '0.19.0', prs: [520], description: 'Added django.middleware_name attribute' }],
  },
  effectiveConnectionType: {
    brief: 'Specifies the estimated effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).',
    type: 'string',
    keys: ['network.connection.effective_type', 'effectiveConnectionType'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '4g',
    deprecation: {
      replacement: 'network.connection.effective_type',
      reason:
        'Old namespace-less attribute, to be replaced with network.connection.effective_type for span-first future',
      status: 'backfill',
    },
    aliases: ['network.connection.effective_type'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  environment: {
    brief: 'The sentry environment.',
    type: 'string',
    keys: [
      'sentry.environment',
      'environment',
      'resource.deployment.environment',
      'resource.deployment.environment.name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'production',
    deprecation: {
      replacement: 'sentry.environment',
      status: 'normalize',
    },
    aliases: ['sentry.environment'],
    changelog: [
      { version: '0.19.0', prs: [427], description: 'Configured normalization' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'error.type': {
    brief: 'Describes a class of error the operation ended with.',
    type: 'string',
    keys: ['error.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'timeout',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'event.id': {
    brief: 'The unique identifier for this event (log record)',
    type: 'integer',
    keys: ['event.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234567890,
    changelog: [{ version: '0.1.0', prs: [101] }],
  },
  'event.name': {
    brief: 'The name that uniquely identifies this event (log record)',
    type: 'string',
    keys: ['event.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Process Payload',
    changelog: [{ version: '0.1.0', prs: [101, 127] }],
  },
  'exception.escaped': {
    brief:
      'SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.',
    type: 'boolean',
    keys: ['exception.escaped'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'exception.message': {
    brief: 'The error message.',
    type: 'string',
    keys: ['exception.message'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ENOENT: no such file or directory',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'exception.stacktrace': {
    brief:
      'A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.',
    type: 'string',
    keys: ['exception.stacktrace'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      'Exception in thread "main" java.lang.RuntimeException: Test exception\n at com.example.GenerateTrace.methodB(GenerateTrace.java:13)\n at com.example.GenerateTrace.methodA(GenerateTrace.java:9)\n at com.example.GenerateTrace.main(GenerateTrace.java:5)',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'exception.type': {
    brief:
      'The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.',
    type: 'string',
    keys: ['exception.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'OSError',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'faas.coldstart': {
    brief: 'A boolean that is true if the serverless function is executed for the first time (aka cold-start).',
    type: 'boolean',
    keys: ['faas.coldstart'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'faas.cron': {
    brief: 'A string containing the schedule period as Cron Expression.',
    type: 'string',
    keys: ['faas.cron'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '0/5 * * * ? *',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'faas.duration_in_ms': {
    brief: 'The duration a function took to run, in milliseconds.',
    type: 'integer',
    keys: ['faas.duration_in_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 120,
    changelog: [{ version: '0.11.0', prs: [403] }],
  },
  'faas.entry_point': {
    brief: "The code that's run when the cloud provider invokes your function.",
    type: 'string',
    keys: ['faas.entry_point'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my_main_function',
    changelog: [{ version: '0.11.0', prs: [403, 415] }],
  },
  'faas.execution': {
    brief: 'The execution ID of the current function execution.',
    type: 'string',
    keys: ['faas.invocation_id', 'aws.lambda.aws_request_id', 'faas.execution'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'af9d5aa4-a685-4c5f-a22b-444f80b3cc28',
    deprecation: {
      replacement: 'faas.invocation_id',
      reason:
        'This attribute is being deprecated in favor of faas.invocation_id, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['faas.invocation_id', 'aws.lambda.aws_request_id'],
    changelog: [
      {
        version: '0.16.0',
        prs: [473],
        description: 'Added faas.execution attribute, deprecated in favor of faas.invocation_id',
      },
    ],
  },
  'faas.id': {
    brief: 'The unique ID of the single function that this runtime instance executes.',
    type: 'string',
    keys: ['cloud.resource_id', 'faas.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'arn:aws:lambda:REGION:ACCOUNT_ID:function:my-function',
    deprecation: {
      replacement: 'cloud.resource_id',
      reason:
        'This attribute is being deprecated in favor of cloud.resource_id, which is the OTel-aligned replacement (renamed in OTel semantic conventions v1.19.0).',
      status: 'backfill',
    },
    aliases: ['cloud.resource_id'],
    changelog: [
      {
        version: '0.16.0',
        prs: [475],
        description: 'Added faas.id attribute, deprecated in favor of cloud.resource_id',
      },
    ],
  },
  'faas.identity': {
    brief:
      'The Service Account (GCP), IAM Execution Role (AWS), or Managed Identity (Azure) used by the serverless function when interacting with other cloud services',
    type: 'string',
    keys: ['faas.identity'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example:
      'name@project.iam.gserviceaccount.com (GCP), arn:aws:iam::123456789012:role/role-name (AWS), 00000000-0000-0000-0000-000000000000 (Azure)',
    changelog: [{ version: '0.11.0', prs: [403] }],
  },
  'faas.invocation_id': {
    brief: 'The invocation ID of the current function invocation.',
    type: 'string',
    keys: ['faas.invocation_id', 'aws.lambda.aws_request_id', 'faas.execution'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'af9d5aa4-a685-4c5f-a22b-444f80b3cc28',
    aliases: ['aws.lambda.aws_request_id', 'faas.execution'],
    changelog: [
      { version: '0.16.0', prs: [473], description: 'Added faas.execution as an alias' },
      { version: '0.11.1', prs: [414, 424] },
    ],
  },
  'faas.invoked_name': {
    brief: 'The name of the invoked function.',
    type: 'string',
    keys: ['faas.invoked_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'my-function',
    changelog: [{ version: '0.16.0', prs: [481], description: 'Added faas.invoked_name attribute' }],
  },
  'faas.invoked_provider': {
    brief: 'The cloud provider of the invoked function.',
    type: 'string',
    keys: ['faas.invoked_provider'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'aws',
    changelog: [{ version: '0.16.0', prs: [481], description: 'Added faas.invoked_provider attribute' }],
  },
  'faas.invoked_region': {
    brief: 'The cloud region of the invoked function.',
    type: 'string',
    keys: ['faas.invoked_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'eu-central-1',
    changelog: [{ version: '0.16.0', prs: [481], description: 'Added faas.invoked_region attribute' }],
  },
  'faas.name': {
    brief: 'The name of the serverless function',
    type: 'string',
    keys: ['faas.name', 'aws.lambda.function_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'my_function',
    aliases: ['aws.lambda.function_name'],
    changelog: [{ version: '0.11.0', prs: [403, 415] }],
  },
  'faas.time': {
    brief: 'A string containing the function invocation time in the ISO 8601 format expressed in UTC.',
    type: 'string',
    keys: ['faas.time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '2020-01-23T13:47:06Z',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'faas.trigger': {
    brief: 'Type of the trigger which caused this function invocation.',
    type: 'string',
    keys: ['faas.trigger'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'timer',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'faas.version': {
    brief: 'The version of the function that was invoked',
    type: 'string',
    keys: ['faas.version', 'aws.lambda.function_version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '$LATEST',
    aliases: ['aws.lambda.function_version'],
    changelog: [{ version: '0.11.1', prs: [414, 424] }],
  },
  fcp: {
    brief: 'The time it takes for the browser to render the first piece of meaningful content on the screen',
    type: 'double',
    keys: ['browser.web_vital.fcp.value', 'fcp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 547.6951,
    deprecation: {
      replacement: 'browser.web_vital.fcp.value',
      reason: 'This attribute is being deprecated in favor of browser.web_vital.fcp.value',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.fcp.value'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'file.path': {
    brief: 'Path to the file.',
    type: 'string',
    keys: ['file.path'],
    applyScrubbing: {
      key: 'auto',
      reason: 'File paths can contain end-user paths (e.g. from stack traces) that may be sensitive.',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/home/user/example.txt',
    changelog: [{ version: '0.17.0', prs: [458], description: 'Added file.path attribute' }],
  },
  'file.size': {
    brief: 'File size in bytes.',
    type: 'integer',
    keys: ['file.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1024,
    changelog: [{ version: '0.17.0', prs: [458], description: 'Added file.size attribute' }],
  },
  'flag.evaluation.<key>': {
    brief:
      'An instance of a feature flag evaluation. The value of this attribute is the boolean representing the evaluation result. The <key> suffix is the name of the feature flag.',
    type: 'boolean',
    keys: ['flag.evaluation.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'flag.evaluation.is_new_ui=true',
    changelog: [{ version: '0.1.0', prs: [103] }],
  },
  fp: {
    brief: 'The time it takes for the browser to render the first pixel on the screen',
    type: 'double',
    keys: ['browser.web_vital.fp.value', 'fp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 477.1926,
    deprecation: {
      replacement: 'browser.web_vital.fp.value',
      reason: 'This attribute is being deprecated in favor of browser.web_vital.fp.value',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.fp.value'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'frames.delay': {
    brief:
      'The sum of all delayed frame durations in seconds during the lifetime of the span. For more information see [frames delay](https://develop.sentry.dev/sdk/performance/frames-delay/).',
    type: 'integer',
    keys: ['app.vitals.frames.delay.value', 'frames.delay', 'mobile.frames_delay'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 5,
    deprecation: {
      replacement: 'app.vitals.frames.delay.value',
      reason:
        'Replaced by app.vitals.frames.delay.value to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.delay.value'],
    changelog: [
      { version: '0.5.0', prs: [313], description: 'Deprecated in favor of app.vitals.frames.delay.value' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
    searchAlias: {
      name: 'mobile.frames_delay',
      type: 'second',
    },
  },
  'frames.frozen': {
    brief: 'The number of frozen frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.frozen.count', 'frames.frozen', 'mobile.frozen_frames', 'sentry.frames.frozen'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3,
    deprecation: {
      replacement: 'app.vitals.frames.frozen.count',
      reason:
        'Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.frozen.count', 'sentry.frames.frozen'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.frozen as an alias' },
      { version: '0.5.0', prs: [313], description: 'Deprecated in favor of app.vitals.frames.frozen.count' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
    searchAlias: {
      name: 'mobile.frozen_frames',
    },
  },
  frames_frozen_rate: {
    brief:
      'The rate of frozen frames, or `app.vitals.frames.frozen.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.frames.frozen.rate', 'frames_frozen_rate'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'app.vitals.frames.frozen.rate',
      reason:
        'Replaced by app.vitals.frames.frozen.rate to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.frozen.rate'],
    changelog: [
      { version: '0.19.0', prs: [493], description: 'Deprecated in favor of app.vitals.frames.frozen.rate' },
      { version: '0.7.0', prs: [362], description: 'Added frames_frozen_rate attribute' },
    ],
  },
  'frames.slow': {
    brief: 'The number of slow frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.slow.count', 'frames.slow', 'mobile.slow_frames', 'sentry.frames.slow'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    deprecation: {
      replacement: 'app.vitals.frames.slow.count',
      reason:
        'Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.slow.count', 'sentry.frames.slow'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.slow as an alias' },
      { version: '0.5.0', prs: [313], description: 'Deprecated in favor of app.vitals.frames.slow.count' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
    searchAlias: {
      name: 'mobile.slow_frames',
    },
  },
  frames_slow_rate: {
    brief:
      'The rate of slow frames, or `app.vitals.frames.slow.count` divided by `app.vitals.frames.total.count`. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.frames.slow.rate', 'frames_slow_rate'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'app.vitals.frames.slow.rate',
      reason:
        'Replaced by app.vitals.frames.slow.rate to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.slow.rate'],
    changelog: [
      { version: '0.19.0', prs: [493], description: 'Deprecated in favor of app.vitals.frames.slow.rate' },
      { version: '0.7.0', prs: [362], description: 'Added frames_slow_rate attribute' },
    ],
  },
  'frames.total': {
    brief: 'The number of total frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.total.count', 'frames.total', 'mobile.total_frames', 'sentry.frames.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 60,
    deprecation: {
      replacement: 'app.vitals.frames.total.count',
      reason:
        'Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.total.count', 'sentry.frames.total'],
    changelog: [
      { version: '0.19.0', prs: [500], description: 'Added sentry.frames.total as an alias' },
      { version: '0.5.0', prs: [313], description: 'Deprecated in favor of app.vitals.frames.total.count' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
    searchAlias: {
      name: 'mobile.total_frames',
    },
  },
  fs_error: {
    brief: 'The error message of a file system error.',
    type: 'string',
    keys: ['fs_error'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'ENOENT: no such file or directory',
    deprecation: {
      replacement: 'error.type',
      reason:
        'This attribute is not part of the OpenTelemetry specification and error.type fits much better. The value changes from the full error message to the syscall error code, so the old value cannot be copied over.',
    },
    changelog: [
      {
        version: '0.23.0',
        prs: [638],
        description: 'Remove unnecessary transformation and change deprecation status to null.',
      },
      { version: '0.22.0', prs: [589], description: 'Transform fs_error into error.type' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'gcp.function.context.event_id': {
    brief: 'The event ID from the legacy GCP Cloud Function context (1st gen)',
    type: 'string',
    keys: ['gcp.function.context.event_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1234567890',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.event_id attribute' }],
  },
  'gcp.function.context.event_type': {
    brief: 'The type of the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.event_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'google.pubsub.topic.publish',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.event_type attribute' }],
  },
  'gcp.function.context.id': {
    brief: 'The unique event ID from the GCP CloudEvents context (2nd gen Cloud Functions)',
    type: 'string',
    keys: ['gcp.function.context.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1234567890',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.id attribute' }],
  },
  'gcp.function.context.resource': {
    brief: 'The resource that triggered the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.resource'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'projects/my-project/topics/my-topic',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.resource attribute' }],
  },
  'gcp.function.context.source': {
    brief: 'The source of the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.source'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '//pubsub.googleapis.com/projects/my-project/topics/my-topic',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.source attribute' }],
  },
  'gcp.function.context.specversion': {
    brief: 'The CloudEvents specification version of the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.specversion'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.specversion attribute' }],
  },
  'gcp.function.context.time': {
    brief: 'The timestamp of the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2024-01-01T00:00:00.000Z',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.time attribute' }],
  },
  'gcp.function.context.timestamp': {
    brief: 'The legacy timestamp of the GCP Cloud Function event',
    type: 'string',
    keys: ['gcp.function.context.timestamp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '2024-01-01T00:00:00.000Z',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.timestamp attribute' }],
  },
  'gcp.function.context.type': {
    brief: 'The type of the GCP Cloud Function event context',
    type: 'string',
    keys: ['gcp.function.context.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'cloud_functions.context',
    changelog: [{ version: '0.7.0', prs: [371], description: 'Added gcp.function.context.type attribute' }],
  },
  'gcp.project.id': {
    brief: 'The ID of the project in GCP that this resource is associated with',
    type: 'string',
    keys: ['gcp.project.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-project-123',
    changelog: [{ version: '0.11.0', prs: [403] }],
  },
  gcp_region: {
    brief: 'The geographical region the GCP resource is running',
    type: 'string',
    keys: ['cloud.region', 'aws_region', 'gcp_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'us-east-1',
    examples: ['us-east-1'],
    deprecation: {
      replacement: 'cloud.region',
      status: 'backfill',
    },
    aliases: ['cloud.region', 'aws_region'],
    changelog: [{ version: '0.19.0', prs: [535], description: 'Added gcp_region attribute' }],
  },
  'gen_ai.agent.name': {
    brief: 'The name of the agent being used.',
    type: 'string',
    keys: ['gen_ai.agent.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ResearchAssistant',
    changelog: [{ version: '0.1.0', prs: [62, 127] }],
  },
  'gen_ai.context.utilization': {
    brief: 'The fraction of the model context window utilized by this generation.',
    type: 'double',
    keys: ['gen_ai.context.utilization'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.75,
    changelog: [{ version: '0.5.0', prs: [315], description: 'Added gen_ai.context.utilization attribute' }],
  },
  'gen_ai.context.window_size': {
    brief: 'The maximum context window size supported by the model for this generation.',
    type: 'integer',
    keys: ['gen_ai.context.window_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 128000,
    changelog: [{ version: '0.5.0', prs: [315], description: 'Added gen_ai.context.window_size attribute' }],
  },
  'gen_ai.conversation.id': {
    brief:
      'The unique identifier for a conversation (session, thread), used to store and correlate messages within this conversation.',
    type: 'string',
    keys: ['gen_ai.conversation.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'conv_5j66UpCpwteGg4YSxUnt7lPY',
    changelog: [{ version: '0.4.0', prs: [250] }],
  },
  'gen_ai.cost.cache_creation.input_tokens': {
    brief: 'The cost of input tokens written to cache in USD.',
    type: 'double',
    keys: ['gen_ai.cost.cache_creation.input_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12.34,
    changelog: [{ version: '0.16.0', description: 'Added gen_ai.cost.cache_creation.input_tokens attribute' }],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.cache_creation.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_creation.input_tokens.",
      'This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens — it is already included.',
    ],
  },
  'gen_ai.cost.cache_read.input_tokens': {
    brief: 'The cost of cached input tokens in USD.',
    type: 'double',
    keys: ['gen_ai.cost.cache_read.input_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12.34,
    changelog: [{ version: '0.16.0', description: 'Added gen_ai.cost.cache_read.input_tokens attribute' }],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.cache_read.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.cache_read.input_tokens.",
      'This is a subset of gen_ai.cost.input_tokens, not an independent cost. Do not sum this with gen_ai.cost.input_tokens — it is already included.',
    ],
  },
  'gen_ai.cost.input_tokens': {
    brief: 'The total cost of all input tokens in USD (includes cached and cache creation tokens).',
    type: 'double',
    keys: ['gen_ai.cost.input_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 123.45,
    changelog: [
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [112] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.input_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.input_tokens.",
      'This is the total cost of all input tokens, including cached and cache creation tokens at their respective rates. For the cached portion, see gen_ai.cost.cache_read.input_tokens. For the cache creation portion, see gen_ai.cost.cache_creation.input_tokens.',
    ],
  },
  'gen_ai.cost.output_tokens': {
    brief: 'The total cost of all output tokens in USD (includes reasoning tokens).',
    type: 'double',
    keys: ['gen_ai.cost.output_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 123.45,
    changelog: [
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [112] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.output_tokens.",
      'This is the total cost of all output tokens, including reasoning tokens at their respective rate. For the reasoning portion, see gen_ai.cost.reasoning.output_tokens.',
    ],
  },
  'gen_ai.cost.reasoning.output_tokens': {
    brief: 'The cost of reasoning output tokens in USD.',
    type: 'double',
    keys: ['gen_ai.cost.reasoning.output_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12.34,
    changelog: [{ version: '0.16.0', description: 'Added gen_ai.cost.reasoning.output_tokens attribute' }],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.reasoning.output_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.reasoning.output_tokens.",
      'This is a subset of gen_ai.cost.output_tokens, not an independent cost. Do not sum this with gen_ai.cost.output_tokens — it is already included.',
    ],
  },
  'gen_ai.cost.total_tokens': {
    brief: 'The total cost for the tokens used.',
    type: 'double',
    keys: ['gen_ai.cost.total_tokens', 'ai.total_cost'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12.34,
    aliases: ['ai.total_cost'],
    changelog: [
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.5.0', prs: [264] },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [126] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to calculate total cost, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      "Despite the name 'cost.total_tokens', this value is cost in USD, not a token count. For token counts, use gen_ai.usage.total_tokens.",
    ],
  },
  'gen_ai.embeddings.input': {
    brief: 'The input to the embeddings model.',
    type: 'string',
    keys: ['gen_ai.embeddings.input'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: "What's the weather in Paris?",
    changelog: [{ version: '0.3.1', prs: [195] }],
  },
  'gen_ai.function_id': {
    brief:
      'Framework-specific tracing label for the execution of a function or other unit of execution in a generative AI system.',
    type: 'string',
    keys: ['gen_ai.function_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-awesome-function',
    changelog: [{ version: '0.5.0', prs: [308], description: 'Added gen_ai.function_id attribute' }],
  },
  'gen_ai.input.messages': {
    brief:
      'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`. For `gen_ai.decide` operations, the array holds one object `{type: "evaluation", state: ..., questions: {...}}` with the evaluated state and the questions keyed by name, as the caller passed them.',
    type: 'string',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      '[{"role": "user", "parts": [{"type": "text", "content": "Weather in Paris?"}]}, {"role": "assistant", "parts": [{"type": "tool_call", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "name": "get_weather", "arguments": {"location": "Paris"}}]}, {"role": "tool", "parts": [{"type": "tool_call_response", "id": "call_VSPygqKTWdrhaFErNvMV18Yl", "result": "rainy, 57°F"}]}]',
    aliases: ['ai.texts', 'ai.prompt.messages', 'gen_ai.prompt', 'ai.prompt'],
    changelog: [
      { version: '0.26.0', prs: [650], description: 'Describe the evaluation message shape for gen_ai.evaluate' },
      { version: '0.21.0', prs: [583], description: 'Added ai.prompt as an alias' },
      { version: '0.5.0', prs: [264] },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.memory.query.text': {
    brief:
      "The search query used to retrieve memories. Only applicable to 'search_memory'. Opt-in: instrumentations SHOULD NOT capture this by default and SHOULD gate it behind explicit user opt-in, as it may contain sensitive information.",
    type: 'string',
    keys: ['gen_ai.memory.query.text'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'user dietary preferences',
    examples: ['user dietary preferences', 'past flight bookings'],
    changelog: [{ version: '0.27.0', prs: [653], description: 'Added gen_ai.memory.query.text attribute' }],
  },
  'gen_ai.memory.records': {
    brief:
      'The memory records stored or retrieved in a memory operation. Stringified JSON array; each element follows the OTel MemoryRecord schema: {content (required), id, metadata, score}. Opt-in: instrumentations SHOULD NOT capture this by default and SHOULD gate it behind explicit user opt-in, as it may contain sensitive information including user/PII data.',
    type: 'string',
    keys: ['gen_ai.memory.records'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      '[{"content": "User prefers dark mode", "id": "mem_123", "score": 0.95}, {"content": {"preference": "vegetarian meals", "confidence": 0.9}, "metadata": {"source": "profile"}}]',
    examples: [
      '[{"content": "User prefers dark mode", "id": "mem_123", "score": 0.95}, {"content": {"preference": "vegetarian meals", "confidence": 0.9}, "metadata": {"source": "profile"}}]',
    ],
    changelog: [{ version: '0.27.0', prs: [653], description: 'Added gen_ai.memory.records attribute' }],
  },
  'gen_ai.memory.record.count': {
    brief:
      "The number of memory records relevant to the operation. For 'search_memory' this is the number returned; for 'create_memory', 'update_memory', 'upsert_memory' and 'delete_memory' it is the number the operation attempted to create, modify, create-or-update, or delete respectively.",
    type: 'integer',
    keys: ['gen_ai.memory.record.count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 3,
    examples: [3],
    changelog: [{ version: '0.27.0', prs: [653], description: 'Added gen_ai.memory.record.count attribute' }],
  },
  'gen_ai.memory.record.id': {
    brief:
      "The unique identifier of the memory record. Set when the operation applies to a specific memory record. For 'delete_memory', its absence may indicate the operation intends to delete all memory records in the store.",
    type: 'string',
    keys: ['gen_ai.memory.record.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'mem_5j66UpCpwteGg4YSxUnt7lPY',
    examples: ['mem_5j66UpCpwteGg4YSxUnt7lPY'],
    changelog: [{ version: '0.27.0', prs: [653], description: 'Added gen_ai.memory.record.id attribute' }],
  },
  'gen_ai.memory.store.id': {
    brief:
      'The unique identifier of the memory store the operation targets. What this maps to is implementation-specific (e.g. a collection, namespace, or vector index) and SHOULD be documented per integration.',
    type: 'string',
    keys: ['gen_ai.memory.store.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ms_abc123',
    examples: ['ms_abc123', 'user-preferences-store', 'seer-knowledge'],
    changelog: [{ version: '0.27.0', prs: [653], description: 'Added gen_ai.memory.store.id attribute' }],
  },
  'gen_ai.operation.name': {
    brief: 'The name of the operation being performed.',
    type: 'string',
    keys: ['gen_ai.operation.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'chat',
    changelog: [
      {
        version: '0.27.0',
        prs: [653, 680],
        description:
          "Added memory operation values, 'evaluate', and 'decide' to the well-known values; deprecated 'evaluate' in favor of 'decide'",
      },
      { version: '0.4.0', prs: [225] },
      { version: '0.1.0', prs: [62, 127] },
    ],
  },
  'gen_ai.operation.type': {
    brief:
      'The type of AI operation. Added during ingestion based on span.op and gen_ai.operation.type. Used to filter and aggregate data in the UI',
    type: 'string',
    keys: ['gen_ai.operation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'tool',
    changelog: [
      { version: '0.27.0', prs: [653], description: "Added 'memory' value" },
      { version: '0.4.0', prs: [257] },
      { version: '0.1.0', prs: [113, 127] },
    ],
  },
  'gen_ai.output.messages': {
    brief:
      'The model\'s response messages. It has to be a stringified version of an array of message objects, which can include text responses and tool calls. For `gen_ai.decide` operations, the array holds one object `{type: "evaluation", answers: {...}}` with the answers keyed by question name, as the provider returned them.',
    type: 'string',
    keys: ['gen_ai.output.messages', 'ai.response.text', 'ai.response.toolCalls', 'ai.responses', 'ai.tool_calls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      '[{"role": "assistant", "parts": [{"type": "text", "content": "The weather in Paris is currently rainy with a temperature of 57°F."}], "finish_reason": "stop"}]',
    aliases: ['ai.response.toolCalls', 'ai.response.text'],
    changelog: [
      { version: '0.26.0', prs: [650], description: 'Describe the evaluation message shape for gen_ai.evaluate' },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.pipeline.name': {
    brief: 'Name of the AI pipeline or chain being executed.',
    type: 'string',
    keys: ['gen_ai.pipeline.name', 'ai.pipeline.name', 'langchain.chain.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Autofix Pipeline',
    aliases: ['ai.pipeline.name', 'langchain.chain.name'],
    changelog: [
      { version: '0.22.0', prs: [599], description: 'Added langchain.chain.name as an alias' },
      { version: '0.1.0', prs: [76, 127] },
    ],
  },
  'gen_ai.prompt': {
    brief: 'The input messages sent to the model',
    type: 'string',
    keys: [
      'gen_ai.input.messages',
      'ai.input_messages',
      'ai.prompt',
      'ai.prompt.messages',
      'ai.texts',
      'gen_ai.prompt',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '[{"role": "user", "message": "hello"}]',
    deprecation: {
      replacement: 'gen_ai.input.messages',
      reason: 'Deprecated from OTEL, use gen_ai.input.messages with the new format instead.',
      status: 'backfill',
    },
    aliases: ['gen_ai.input.messages', 'ai.texts', 'ai.prompt.messages', 'ai.prompt'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.prompt as an alias' },
      { version: '0.1.0', prs: [74, 108, 119] },
      { version: '0.0.0' },
    ],
  },
  'gen_ai.prompt.name': {
    brief: 'The name of the prompt that uniquely identifies it.',
    type: 'string',
    keys: ['gen_ai.prompt.name', 'mcp.prompt.name'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Prompt names may reveal user behavior patterns or sensitive operations',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'summarize_text',
    aliases: ['mcp.prompt.name'],
    changelog: [{ version: '0.12.0', prs: [420], description: 'Added gen_ai.prompt.name attribute' }],
  },
  'gen_ai.prompt.variable.<key>': {
    brief:
      'Variables supplied to the prompt template. The <key> is the variable name, and the value is the variable value serialized as a string.',
    type: 'string',
    keys: ['gen_ai.prompt.variable.<key>'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Prompt variables contain user input and may include sensitive information',
    },
    isInOtel: true,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "gen_ai.prompt.variable.language='French'",
    examples: ["gen_ai.prompt.variable.language='French'", "gen_ai.prompt.variable.topic='weather'"],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Added the OpenTelemetry convention for prompt variables' },
    ],
    additionalContext: [
      'Capture only when the user explicitly opts in to recording prompt inputs. In MCP, these values are the arguments supplied in prompts/get requests.',
    ],
  },
  'gen_ai.provider.name': {
    brief: 'The Generative AI provider as identified by the client or server instrumentation.',
    type: 'string',
    keys: ['gen_ai.provider.name', 'ai.model.provider', 'gen_ai.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'openai',
    aliases: ['ai.model.provider', 'gen_ai.system'],
    changelog: [{ version: '0.4.0', prs: [253] }],
  },
  'gen_ai.request.available_tools': {
    brief: 'The available tools for the model. It has to be a stringified version of an array of objects.',
    type: 'string',
    keys: ['gen_ai.tool.definitions', 'ai.prompt.tools', 'ai.tools', 'gen_ai.request.available_tools'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example:
      '[{"name": "get_weather", "description": "Get the weather for a given location"}, {"name": "get_news", "description": "Get the news for a given topic"}]',
    deprecation: {
      replacement: 'gen_ai.tool.definitions',
      status: 'normalize',
    },
    aliases: ['gen_ai.tool.definitions'],
    changelog: [
      { version: '0.22.0', prs: [595], description: 'Added gen_ai.tool.definitions as an alias' },
      { version: '0.4.0', prs: [221] },
      { version: '0.1.0', prs: [63, 127] },
    ],
  },
  'gen_ai.request.frequency_penalty': {
    brief:
      'Used to reduce repetitiveness of generated tokens. The higher the value, the stronger a penalty is applied to previously present tokens, proportional to how many times they have already appeared in the prompt or prior generation.',
    type: 'double',
    keys: ['gen_ai.request.frequency_penalty', 'ai.frequency_penalty'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 0.5,
    aliases: ['ai.frequency_penalty'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
  },
  'gen_ai.request.max_tokens': {
    brief: 'The maximum number of tokens to generate in the response.',
    type: 'integer',
    keys: ['gen_ai.request.max_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 2048,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [62] },
    ],
  },
  'gen_ai.request.messages': {
    brief:
      'The messages passed to the model. It has to be a stringified version of an array of objects. The `role` attribute of each object must be `"user"`, `"assistant"`, `"tool"`, or `"system"`. For messages of the role `"tool"`, the `content` can be a string or an arbitrary object with information about the tool call. For other messages the `content` can be either a string or a list of objects in the format `{type: "text", text:"..."}`.',
    type: 'string',
    keys: ['gen_ai.request.messages'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example:
      '[{"role": "system", "content": "Generate a random number."}, {"role": "user", "content": [{"text": "Generate a random number between 0 and 10.", "type": "text"}]}, {"role": "tool", "content": {"toolCallId": "1", "toolName": "Weather", "output": "rainy"}}]',
    deprecation: {
      replacement: 'gen_ai.input.messages',
      status: 'transform',
      transformation: 'gen_ai_request_messages_to_input_messages',
    },
    aliases: ['ai.input_messages'],
    changelog: [
      { version: '0.4.0', prs: [221] },
      { version: '0.1.0', prs: [63, 74, 108, 119, 122] },
    ],
  },
  'gen_ai.request.model': {
    brief: 'The model identifier being used for the request.',
    type: 'string',
    keys: ['gen_ai.request.model', 'ai.model.id', 'ai.model_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'gpt-4-turbo-preview',
    aliases: ['ai.model_id', 'ai.model.id'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.model.id as an alias' },
      { version: '0.1.0', prs: [62, 127] },
    ],
  },
  'gen_ai.request.presence_penalty': {
    brief:
      'Used to reduce repetitiveness of generated tokens. Similar to frequency_penalty, except that this penalty is applied equally to all tokens that have already appeared, regardless of their exact frequencies.',
    type: 'double',
    keys: ['gen_ai.request.presence_penalty', 'ai.presence_penalty'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 0.5,
    aliases: ['ai.presence_penalty'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
  },
  'gen_ai.request.reasoning.level': {
    brief: 'The reasoning or thinking effort level requested for a GenAI model.',
    type: 'string',
    keys: ['gen_ai.request.reasoning.level'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'high',
    changelog: [{ version: '0.17.0', prs: [502], description: 'Added gen_ai.request.reasoning.level attribute' }],
  },
  'gen_ai.request.schema': {
    brief: 'The stringified JSON schema the model output must conform to.',
    type: 'string',
    keys: ['gen_ai.request.schema'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"type":"object","properties":{"city":{"type":"string"}}}',
    examples: ['{"type":"object","properties":{"city":{"type":"string"}}}'],
    deprecation: {
      reason:
        'This attribute is deprecated. The Sentry conventions have no replacement for the requested output schema.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added gen_ai.request.schema attribute' }],
  },
  'gen_ai.request.seed': {
    brief: 'The seed, ideally models given the same seed and same other parameters will produce the exact same output.',
    type: 'string',
    keys: ['gen_ai.request.seed', 'ai.seed'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1234567890',
    aliases: ['ai.seed'],
    changelog: [{ version: '0.1.0', prs: [57, 127] }],
  },
  'gen_ai.request.stop_sequences': {
    brief: 'List of sequences that the model will use to stop generating further tokens.',
    type: 'string[]',
    keys: ['gen_ai.request.stop_sequences'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['forest', 'lived'],
    changelog: [{ version: '0.16.0', prs: [482], description: 'Added gen_ai.request.stop_sequences attribute' }],
  },
  'gen_ai.request.temperature': {
    brief:
      'For an AI model call, the temperature parameter. Temperature essentially means how random the output will be.',
    type: 'double',
    keys: ['gen_ai.request.temperature', 'ai.temperature'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 0.1,
    aliases: ['ai.temperature'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
  },
  'gen_ai.request.top_k': {
    brief:
      'Limits the model to only consider the K most likely next tokens, where K is an integer (e.g., top_k=20 means only the 20 highest probability tokens are considered).',
    type: 'integer',
    keys: ['gen_ai.request.top_k', 'ai.top_k'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 35,
    aliases: ['ai.top_k'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
  },
  'gen_ai.request.top_p': {
    brief:
      'Limits the model to only consider tokens whose cumulative probability mass adds up to p, where p is a float between 0 and 1 (e.g., top_p=0.7 means only tokens that sum up to 70% of the probability mass are considered).',
    type: 'double',
    keys: ['gen_ai.request.top_p', 'ai.top_p'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 0.7,
    aliases: ['ai.top_p'],
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
  },
  'gen_ai.response.finish_reason': {
    brief: 'The reason why the model stopped generating (singular form).',
    type: 'string',
    keys: ['gen_ai.response.finish_reasons', 'ai.finish_reason', 'gen_ai.response.finish_reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'COMPLETE',
    deprecation: {
      replacement: 'gen_ai.response.finish_reasons',
      status: 'normalize',
    },
    aliases: ['gen_ai.response.finish_reasons'],
    changelog: [{ version: '0.19.0', prs: [498], description: 'Added gen_ai.response.finish_reason attribute' }],
  },
  'gen_ai.response.finish_reasons': {
    brief: 'The reason why the model stopped generating.',
    type: 'string',
    keys: ['gen_ai.response.finish_reasons', 'ai.finish_reason', 'gen_ai.response.finish_reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'COMPLETE',
    aliases: ['ai.finish_reason', 'gen_ai.response.finish_reason'],
    changelog: [{ version: '0.1.0', prs: [57, 127] }],
  },
  'gen_ai.response.id': {
    brief: 'Unique identifier for the completion.',
    type: 'string',
    keys: ['gen_ai.response.id', 'ai.generation_id', 'ai.response.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'gen_123abc',
    aliases: ['ai.generation_id', 'ai.response.id'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.response.id as an alias' },
      { version: '0.1.0', prs: [57, 127] },
    ],
  },
  'gen_ai.response.model': {
    brief: 'The vendor-specific ID of the model used.',
    type: 'string',
    keys: ['gen_ai.response.model', 'ai.response.model'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'gpt-4',
    aliases: ['ai.response.model'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.response.model as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'gen_ai.response.object': {
    brief: 'The type of the object returned by the model.',
    type: 'string',
    keys: ['gen_ai.response.object'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'chat.completion',
    examples: ['chat.completion'],
    deprecation: {
      reason:
        'This attribute is deprecated. The Sentry conventions have no replacement for the raw response object type.',
    },
    changelog: [{ version: '0.21.0', prs: [583], description: 'Added gen_ai.response.object attribute' }],
  },
  'gen_ai.response.streaming': {
    brief: "Whether or not the AI model call's response was streamed back asynchronously",
    type: 'boolean',
    keys: ['gen_ai.response.streaming', 'ai.streaming'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    aliases: ['ai.streaming'],
    changelog: [{ version: '0.1.0', prs: [76] }],
  },
  'gen_ai.response.text': {
    brief:
      "The model's response text messages. It has to be a stringified version of an array of response text messages.",
    type: 'string',
    keys: ['gen_ai.response.text'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example:
      '["The weather in Paris is rainy and overcast, with temperatures around 57°F", "The weather in London is sunny and warm, with temperatures around 65°F"]',
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'transform',
      transformation: 'gen_ai_response_to_output_messages',
    },
    changelog: [
      { version: '0.4.0', prs: [221] },
      { version: '0.1.0', prs: [63, 74] },
    ],
  },
  'gen_ai.response.time_to_first_chunk': {
    brief: 'Time in seconds when the first response content chunk arrived in streaming responses.',
    type: 'double',
    keys: ['gen_ai.response.time_to_first_chunk', 'gen_ai.response.time_to_first_token'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 0.6853435,
    aliases: ['gen_ai.response.time_to_first_token'],
    changelog: [{ version: '0.11.0', prs: [418], description: 'Added gen_ai.response.time_to_first_chunk attribute' }],
  },
  'gen_ai.response.time_to_first_token': {
    brief: 'Time in seconds when the first response content chunk arrived in streaming responses.',
    type: 'double',
    keys: ['gen_ai.response.time_to_first_chunk', 'gen_ai.response.time_to_first_token'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.6853435,
    deprecation: {
      replacement: 'gen_ai.response.time_to_first_chunk',
      status: 'backfill',
    },
    aliases: ['gen_ai.response.time_to_first_chunk'],
    changelog: [
      { version: '0.11.0', prs: [418], description: 'Deprecate in favor of gen_ai.response.time_to_first_chunk' },
      { version: '0.4.0', prs: [227] },
    ],
  },
  'gen_ai.response.tokens_per_second': {
    brief: 'The total output tokens per seconds throughput',
    type: 'double',
    keys: ['gen_ai.response.tokens_per_second'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12345.67,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [66] },
    ],
  },
  'gen_ai.response.tool_calls': {
    brief: "The tool calls in the model's response. It has to be a stringified version of an array of objects.",
    type: 'string',
    keys: ['gen_ai.response.tool_calls'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"name": "get_weather", "arguments": {"location": "Paris"}}]',
    deprecation: {
      replacement: 'gen_ai.output.messages',
      status: 'transform',
      transformation: 'gen_ai_response_to_output_messages',
    },
    changelog: [
      { version: '0.4.0', prs: [221] },
      { version: '0.1.0', prs: [63, 74] },
    ],
  },
  'gen_ai.system': {
    brief: 'The provider of the model.',
    type: 'string',
    keys: ['gen_ai.provider.name', 'ai.model.provider', 'gen_ai.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'openai',
    deprecation: {
      replacement: 'gen_ai.provider.name',
      status: 'normalize',
    },
    aliases: ['ai.model.provider', 'gen_ai.provider.name'],
    changelog: [
      { version: '0.4.0', prs: [253] },
      { version: '0.1.0', prs: [57, 127] },
    ],
  },
  'gen_ai.system_instructions': {
    brief: 'The system instructions passed to the model.',
    type: 'string',
    keys: ['gen_ai.system_instructions', 'ai.preamble', 'gen_ai.system.message'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'You are a helpful assistant',
    aliases: ['ai.preamble'],
    changelog: [
      { version: '0.5.0', prs: [264] },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.system.message': {
    brief: 'The system instructions passed to the model.',
    type: 'string',
    keys: ['gen_ai.system_instructions', 'ai.preamble', 'gen_ai.system.message'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'You are a helpful assistant',
    deprecation: {
      replacement: 'gen_ai.system_instructions',
      status: 'backfill',
    },
    changelog: [
      { version: '0.4.0', prs: [221] },
      { version: '0.1.0', prs: [62] },
    ],
  },
  'gen_ai.tool.call.arguments': {
    brief: 'The arguments of the tool call. It has to be a stringified version of the arguments to the tool.',
    type: 'string',
    keys: ['gen_ai.tool.call.arguments', 'ai.toolCall.args', 'gen_ai.tool.input'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '{"location": "Paris"}',
    aliases: ['gen_ai.tool.input', 'ai.toolCall.args'],
    changelog: [
      { version: '0.5.0', prs: [265] },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.tool.call.result': {
    brief: 'The result of the tool call. It has to be a stringified version of the result of the tool.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'rainy, 57°F',
    aliases: [
      'gen_ai.tool.output',
      'gen_ai.tool.message',
      'mcp.tool.result.content',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
    ],
    changelog: [
      { version: '0.5.0', prs: [265] },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.tool.definitions': {
    brief: 'The list of source system tool definitions available to the GenAI agent or model.',
    type: 'string',
    keys: ['gen_ai.tool.definitions', 'ai.prompt.tools', 'ai.tools', 'gen_ai.request.available_tools'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      '[{"type": "function", "name": "get_current_weather", "description": "Get the current weather in a given location", "parameters": {"type": "object", "properties": {"location": {"type": "string", "description": "The city and state, e.g. San Francisco, CA"}, "unit": {"type": "string", "enum": ["celsius", "fahrenheit"]}}, "required": ["location", "unit"]}}]',
    aliases: ['gen_ai.request.available_tools'],
    changelog: [
      { version: '0.22.0', prs: [595], description: 'Added gen_ai.request.available_tools as an alias' },
      { version: '0.4.0', prs: [221] },
    ],
  },
  'gen_ai.tool.description': {
    brief: 'The description of the tool being used.',
    type: 'string',
    keys: ['gen_ai.tool.description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Searches the web for current information about a topic',
    changelog: [{ version: '0.1.0', prs: [62, 127] }],
  },
  'gen_ai.tool.input': {
    brief: 'The input of the tool being used. It has to be a stringified version of the input to the tool.',
    type: 'string',
    keys: ['gen_ai.tool.call.arguments', 'ai.toolCall.args', 'gen_ai.tool.input'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"location": "Paris"}',
    deprecation: {
      replacement: 'gen_ai.tool.call.arguments',
      status: 'normalize',
    },
    aliases: ['gen_ai.tool.call.arguments', 'ai.toolCall.args'],
    changelog: [
      { version: '0.5.0', prs: [265] },
      { version: '0.1.0', prs: [63, 74] },
    ],
  },
  'gen_ai.tool.message': {
    brief: 'The response from a tool or function call passed to the model.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'rainy, 57°F',
    deprecation: {
      replacement: 'gen_ai.tool.call.result',
      status: 'normalize',
    },
    aliases: [
      'gen_ai.tool.call.result',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
    ],
    changelog: [
      { version: '0.5.0', prs: [265] },
      { version: '0.1.0', prs: [62] },
    ],
  },
  'gen_ai.tool.name': {
    brief: 'Name of the tool utilized by the agent.',
    type: 'string',
    keys: ['gen_ai.tool.name', 'ai.function_call', 'mcp.tool.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Flights',
    aliases: ['ai.function_call', 'mcp.tool.name'],
    changelog: [{ version: '0.1.0', prs: [57, 127] }],
  },
  'gen_ai.tool.output': {
    brief: 'The output of the tool being used. It has to be a stringified version of the output of the tool.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'rainy, 57°F',
    deprecation: {
      replacement: 'gen_ai.tool.call.result',
      status: 'normalize',
    },
    aliases: [
      'gen_ai.tool.call.result',
      'gen_ai.tool.message',
      'mcp.tool.result.content',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
    ],
    changelog: [
      { version: '0.5.0', prs: [265] },
      { version: '0.1.0', prs: [63, 74] },
    ],
  },
  'gen_ai.tool.type': {
    brief: 'The type of tool being used.',
    type: 'string',
    keys: ['gen_ai.tool.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'function',
    deprecation: {
      reason: 'The gen_ai.tool.type attribute is deprecated and should no longer be set.',
    },
    changelog: [{ version: '0.1.0', prs: [62, 127] }],
  },
  'gen_ai.usage.cache_creation.input_tokens': {
    brief: 'The number of tokens written to the cache when processing the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_creation.input_tokens',
      'gen_ai.usage.cache_creation_input_tokens',
      'gen_ai.usage.input_tokens.cache_write',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 100,
    aliases: ['gen_ai.usage.input_tokens.cache_write', 'gen_ai.usage.cache_creation_input_tokens'],
    changelog: [
      { version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_creation_input_tokens as an alias' },
      { version: '0.11.0', prs: [418], description: 'Added gen_ai.usage.cache_creation.input_tokens attribute' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
    ],
  },
  'gen_ai.usage.cache_creation_input_tokens': {
    brief: 'The number of tokens written to the cache when processing the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_creation.input_tokens',
      'gen_ai.usage.cache_creation_input_tokens',
      'gen_ai.usage.input_tokens.cache_write',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    examples: [100],
    deprecation: {
      replacement: 'gen_ai.usage.cache_creation.input_tokens',
      reason: 'This attribute is being deprecated in favor of gen_ai.usage.cache_creation.input_tokens.',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.cache_creation.input_tokens', 'gen_ai.usage.input_tokens.cache_write'],
    changelog: [
      { version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_creation_input_tokens attribute' },
    ],
  },
  'gen_ai.usage.cache_read.input_tokens': {
    brief: 'The number of cached tokens used to process the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_read.input_tokens',
      'gen_ai.usage.cache_read_input_tokens',
      'gen_ai.usage.input_tokens.cached',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 50,
    aliases: ['gen_ai.usage.input_tokens.cached', 'gen_ai.usage.cache_read_input_tokens'],
    changelog: [
      { version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_read_input_tokens as an alias' },
      { version: '0.11.0', prs: [418], description: 'Added gen_ai.usage.cache_read.input_tokens attribute' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens — it is already included.',
    ],
  },
  'gen_ai.usage.cache_read_input_tokens': {
    brief: 'The number of cached tokens used to process the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_read.input_tokens',
      'gen_ai.usage.cache_read_input_tokens',
      'gen_ai.usage.input_tokens.cached',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 50,
    examples: [50],
    deprecation: {
      replacement: 'gen_ai.usage.cache_read.input_tokens',
      reason: 'This attribute is being deprecated in favor of gen_ai.usage.cache_read.input_tokens.',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.cache_read.input_tokens', 'gen_ai.usage.input_tokens.cached'],
    changelog: [{ version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_read_input_tokens attribute' }],
  },
  'gen_ai.usage.completion_tokens': {
    brief: 'The number of tokens used in the GenAI response (completion).',
    type: 'integer',
    keys: ['gen_ai.usage.output_tokens', 'ai.completion_tokens.used', 'gen_ai.usage.completion_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    deprecation: {
      replacement: 'gen_ai.usage.output_tokens',
      status: 'backfill',
    },
    aliases: ['ai.completion_tokens.used', 'gen_ai.usage.output_tokens'],
    changelog: [
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
    ],
  },
  'gen_ai.usage.input_tokens': {
    brief: 'The number of tokens used to process the AI input (prompt) including cached input tokens.',
    type: 'integer',
    keys: ['gen_ai.usage.input_tokens', 'ai.prompt_tokens.used', 'gen_ai.usage.prompt_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    aliases: ['ai.prompt_tokens.used', 'gen_ai.usage.prompt_tokens'],
    changelog: [
      {
        version: '0.11.0',
        prs: [418],
        description: 'Update additional_context to reference gen_ai.usage.cache_read.input_tokens',
      },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.5.0', prs: [261] },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [112] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This count includes cached input tokens. gen_ai.usage.cache_read.input_tokens is a subset of this value, not an independent count — do not sum them together.',
    ],
  },
  'gen_ai.usage.input_tokens.cached': {
    brief: 'The number of cached tokens used to process the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_read.input_tokens',
      'gen_ai.usage.cache_read_input_tokens',
      'gen_ai.usage.input_tokens.cached',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 50,
    deprecation: {
      replacement: 'gen_ai.usage.cache_read.input_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.cache_read.input_tokens', 'gen_ai.usage.cache_read_input_tokens'],
    changelog: [
      { version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_read_input_tokens as an alias' },
      { version: '0.11.0', prs: [418], description: 'Deprecate in favor of gen_ai.usage.cache_read.input_tokens' },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [62, 112] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This is a subset of gen_ai.usage.input_tokens, not an independent count. Do not sum this with gen_ai.usage.input_tokens — it is already included.',
    ],
  },
  'gen_ai.usage.input_tokens.cache_write': {
    brief: 'The number of tokens written to the cache when processing the AI input (prompt).',
    type: 'integer',
    keys: [
      'gen_ai.usage.cache_creation.input_tokens',
      'gen_ai.usage.cache_creation_input_tokens',
      'gen_ai.usage.input_tokens.cache_write',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    deprecation: {
      replacement: 'gen_ai.usage.cache_creation.input_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.cache_creation.input_tokens', 'gen_ai.usage.cache_creation_input_tokens'],
    changelog: [
      { version: '0.24.0', prs: [582], description: 'Added gen_ai.usage.cache_creation_input_tokens as an alias' },
      { version: '0.11.0', prs: [418], description: 'Deprecate in favor of gen_ai.usage.cache_creation.input_tokens' },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [217, 228] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
    ],
  },
  'gen_ai.usage.output_tokens': {
    brief: 'The number of tokens used for creating the AI output (including reasoning tokens).',
    type: 'integer',
    keys: ['gen_ai.usage.output_tokens', 'ai.completion_tokens.used', 'gen_ai.usage.completion_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    aliases: ['ai.completion_tokens.used', 'gen_ai.usage.completion_tokens'],
    changelog: [
      {
        version: '0.11.0',
        prs: [418],
        description: 'Update additional_context to reference gen_ai.usage.reasoning.output_tokens',
      },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.5.0', prs: [261] },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [112] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This count includes reasoning tokens. gen_ai.usage.reasoning.output_tokens is a subset of this value, not an independent count — do not sum them together.',
    ],
  },
  'gen_ai.usage.output_tokens.reasoning': {
    brief: 'The number of tokens used for reasoning to create the AI output.',
    type: 'integer',
    keys: ['gen_ai.usage.reasoning.output_tokens', 'gen_ai.usage.output_tokens.reasoning'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 75,
    deprecation: {
      replacement: 'gen_ai.usage.reasoning.output_tokens',
      status: 'backfill',
    },
    aliases: ['gen_ai.usage.reasoning.output_tokens'],
    changelog: [
      { version: '0.11.0', prs: [418], description: 'Deprecate in favor of gen_ai.usage.reasoning.output_tokens' },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [62, 112] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens — it is already included.',
    ],
  },
  'gen_ai.usage.prompt_tokens': {
    brief: 'The number of tokens used in the GenAI input (prompt).',
    type: 'integer',
    keys: ['gen_ai.usage.input_tokens', 'ai.prompt_tokens.used', 'gen_ai.usage.prompt_tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 20,
    deprecation: {
      replacement: 'gen_ai.usage.input_tokens',
      status: 'backfill',
    },
    aliases: ['ai.prompt_tokens.used', 'gen_ai.usage.input_tokens'],
    changelog: [
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
    ],
  },
  'gen_ai.usage.reasoning.output_tokens': {
    brief: 'The number of tokens used for reasoning to create the AI output.',
    type: 'integer',
    keys: ['gen_ai.usage.reasoning.output_tokens', 'gen_ai.usage.output_tokens.reasoning'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 75,
    aliases: ['gen_ai.usage.output_tokens.reasoning'],
    changelog: [{ version: '0.11.0', prs: [418], description: 'Added gen_ai.usage.reasoning.output_tokens attribute' }],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This is a subset of gen_ai.usage.output_tokens, not an independent count. Do not sum this with gen_ai.usage.output_tokens — it is already included.',
    ],
  },
  'gen_ai.usage.total_tokens': {
    brief: 'The total number of tokens used to process the prompt. (input tokens plus output todkens)',
    type: 'integer',
    keys: ['gen_ai.usage.total_tokens', 'ai.total_tokens.used', 'ai.usage.tokens'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 20,
    aliases: ['ai.total_tokens.used', 'ai.usage.tokens'],
    changelog: [
      { version: '0.21.0', prs: [583], description: 'Added ai.usage.tokens as an alias' },
      { version: '0.9.0', prs: [397], description: 'Add additional_context' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [57] },
    ],
    additionalContext: [
      'This attribute appears on both agent parent spans (aggregated totals) and LLM child spans (per-call values). When using sum() to count tokens, filter to gen_ai.operation.type:ai_client to avoid double-counting hierarchical spans.',
      'This is the sum of gen_ai.usage.input_tokens and gen_ai.usage.output_tokens. Do not sum this with either of them — they are already included.',
    ],
  },
  'graphql.document': {
    brief: 'The GraphQL document being executed.',
    type: 'string',
    keys: ['graphql.document', 'graphql.source'],
    applyScrubbing: {
      key: 'auto',
      reason:
        'The document may contain sensitive information in arguments or variables. Instrumentation should redact sensitive information when possible.',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'query findBookById { bookById(id: ?) { name } }',
    aliases: ['graphql.source'],
    changelog: [
      { version: '0.21.0', prs: [584], description: 'Added graphql.source as an alias' },
      {
        version: '0.7.0',
        description: 'Adds the `graphql.document` attribute to track the GraphQL document being executed.',
      },
    ],
  },
  'graphql.operation.name': {
    brief: 'The name of the operation being executed.',
    type: 'string',
    keys: ['graphql.operation.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'findBookById',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'graphql.operation.type': {
    brief: 'The type of the operation being executed.',
    type: 'string',
    keys: ['graphql.operation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'query',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'graphql.processing.type': {
    brief: 'The type of processing represented by this span.',
    type: 'string',
    keys: ['graphql.processing.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'parse',
    examples: ['parse', 'validate', 'execute', 'resolve'],
    changelog: [{ version: '0.21.0', prs: [572], description: 'Added graphql.processing.type attribute' }],
    additionalContext: [
      'Well-known values are request, parse, validate, variable_coercion, plan, execute, subscription_event, step_execute, resolve, dataloader_dispatch, dataloader_batch and _OTHER. Use one of these if it applies, otherwise a custom value.',
      'Not to be confused with graphql.operation.type, which holds the GraphQL operation type (query, mutation, subscription) and only applies to spans that run an operation.',
    ],
  },
  'graphql.source': {
    brief: 'The GraphQL document being executed.',
    type: 'string',
    keys: ['graphql.document', 'graphql.source'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'query findBookById { bookById(id: ?) { name } }',
    examples: ['query findBookById { bookById(id: ?) { name } }'],
    deprecation: {
      replacement: 'graphql.document',
      reason:
        'This attribute is being deprecated in favor of graphql.document, which is the OpenTelemetry name for the same value.',
      status: 'backfill',
    },
    aliases: ['graphql.document'],
    changelog: [{ version: '0.21.0', prs: [584], description: 'Added graphql.source attribute' }],
  },
  'grpc.error.bad_request.field_violations': {
    brief:
      'The individual field violations from a google.rpc.BadRequest error detail. Each entry is a JSON-encoded object with field, description, reason, and (optional) localized_message keys, mirroring google.rpc.BadRequest.FieldViolation.',
    type: 'string[]',
    keys: ['grpc.error.bad_request.field_violations'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: [
      '{"field":"email","description":"must be a valid email address","reason":"FIELD_INVALID","localized_message":{"locale":"en-US","message":"Must be a valid email address"}}',
    ],
    changelog: [
      { version: '0.17.0', prs: [460], description: 'Added grpc.error.bad_request.field_violations attribute' },
    ],
  },
  'grpc.error.debug_info.detail': {
    brief:
      'Additional debugging information, such as a server-side stack trace, from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.',
    type: 'string',
    keys: ['grpc.error.debug_info.detail'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'at com.example.Service.method(Service.java:42)',
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.debug_info.detail attribute' }],
  },
  'grpc.error.debug_info.stack_entries': {
    brief:
      'The server-side stack trace entries from a google.rpc.DebugInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.',
    type: 'string[]',
    keys: ['grpc.error.debug_info.stack_entries'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['com.example.Service.method(Service.java:42)', 'com.example.Server.handle(Server.java:100)'],
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.debug_info.stack_entries attribute' }],
  },
  'grpc.error.error_info.domain': {
    brief: 'The logical grouping to which the gRPC error reason belongs, from the google.rpc.ErrorInfo error detail.',
    type: 'string',
    keys: ['grpc.error.error_info.domain'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example.sentry.io',
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.error_info.domain attribute' }],
  },
  'grpc.error.error_info.metadata.<key>': {
    brief:
      'Additional structured metadata attached to a google.rpc.ErrorInfo error detail, with <key> being the metadata key name. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.',
    type: 'string',
    keys: ['grpc.error.error_info.metadata.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "grpc.error.error_info.metadata.user_id='123'",
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.error_info.metadata.<key> attribute' }],
  },
  'grpc.error.error_info.reason': {
    brief:
      'The reason for the gRPC error, as defined by the service that generated it, from the google.rpc.ErrorInfo error detail.',
    type: 'string',
    keys: ['grpc.error.error_info.reason'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'FIELD_INVALID',
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.error_info.reason attribute' }],
  },
  'grpc.error.precondition_failure.violations': {
    brief:
      'The individual precondition violations from a google.rpc.PreconditionFailure error detail. Each entry is a JSON-encoded object with type, subject, and description keys. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users.',
    type: 'string[]',
    keys: ['grpc.error.precondition_failure.violations'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['{"type":"TOS","subject":"example.com/user/123","description":"User must accept the terms of service"}'],
    changelog: [
      { version: '0.17.0', prs: [460], description: 'Added grpc.error.precondition_failure.violations attribute' },
    ],
  },
  'grpc.error.quota_failure.violations': {
    brief:
      'The individual quota violations from a google.rpc.QuotaFailure error detail. Each entry is a JSON-encoded object with subject, description, api_service, quota_metric, quota_id, quota_dimensions, quota_value, and (optional) future_quota_value keys, mirroring google.rpc.QuotaFailure.Violation. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly, since violation subjects may identify specific resources or users.',
    type: 'string[]',
    keys: ['grpc.error.quota_failure.violations'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: [
      '{"subject":"clientip:127.0.0.1","description":"Limit checks failed.","api_service":"example.googleapis.com","quota_metric":"example.googleapis.com/read_requests","quota_id":"ReadRequestsPerMinutePerProject","quota_dimensions":{"region":"us-central1"},"quota_value":1000}',
    ],
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.quota_failure.violations attribute' }],
  },
  'grpc.error.resource_info.description': {
    brief:
      'A description of the error that occurred while accessing the resource, from a google.rpc.ResourceInfo error detail.',
    type: 'string',
    keys: ['grpc.error.resource_info.description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Instance is not ready for the request.',
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.resource_info.description attribute' }],
  },
  'grpc.error.resource_info.owner': {
    brief:
      'The owner of the resource being accessed (e.g. project or account owning it), from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.',
    type: 'string',
    keys: ['grpc.error.resource_info.owner'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user@example.com',
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.resource_info.owner attribute' }],
  },
  'grpc.error.resource_info.resource_name': {
    brief:
      'The name of the resource being accessed, from a google.rpc.ResourceInfo error detail. SDKs should only send this attribute when sendDefaultPii is enabled or dataCollection is configured accordingly.',
    type: 'string',
    keys: ['grpc.error.resource_info.resource_name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'projects/example/instances/example-instance',
    changelog: [
      { version: '0.17.0', prs: [460], description: 'Added grpc.error.resource_info.resource_name attribute' },
    ],
  },
  'grpc.error.resource_info.resource_type': {
    brief: 'The type of resource being accessed, from a google.rpc.ResourceInfo error detail.',
    type: 'string',
    keys: ['grpc.error.resource_info.resource_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'database',
    changelog: [
      { version: '0.17.0', prs: [460], description: 'Added grpc.error.resource_info.resource_type attribute' },
    ],
  },
  'grpc.error.retry_info.retry_delay_ms': {
    brief:
      'How long the client should wait before retrying the gRPC call, in milliseconds, from the google.rpc.RetryInfo error detail.',
    type: 'integer',
    keys: ['grpc.error.retry_info.retry_delay_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 5000,
    changelog: [{ version: '0.17.0', prs: [460], description: 'Added grpc.error.retry_info.retry_delay_ms attribute' }],
  },
  hardwareConcurrency: {
    brief: 'The number of logical CPU cores available.',
    type: 'string',
    keys: ['device.processor_count', 'hardwareConcurrency'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '14',
    deprecation: {
      replacement: 'device.processor_count',
      reason: 'Old namespace-less attribute, to be replaced with device.processor_count for span-first future',
      status: 'backfill',
    },
    aliases: ['device.processor_count'],
    changelog: [
      {
        version: '0.5.0',
        prs: [281, 300],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'http.client_ip': {
    brief:
      'Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.',
    type: 'string',
    keys: ['client.address', 'http.client_ip'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'client.address',
      status: 'backfill',
    },
    aliases: ['client.address'],
    changelog: [{ version: '0.1.0', prs: [61, 106, 127] }, { version: '0.0.0' }],
  },
  'http.decoded_response_content_length': {
    brief: 'The decoded body size of the response (in bytes).',
    type: 'integer',
    keys: [
      'http.response.body.decoded_size',
      'http.decoded_response_content_length',
      'http.response_content_length_uncompressed',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 456,
    deprecation: {
      replacement: 'http.response.body.decoded_size',
      status: 'backfill',
    },
    aliases: ['http.response.body.decoded_size', 'http.response_content_length_uncompressed'],
    changelog: [
      { version: '0.21.0', prs: [574], description: 'Deprecated in favor of http.response.body.decoded_size' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
    searchAlias: {
      name: 'http.decoded_response_content_length',
      type: 'byte',
    },
  },
  'http.flavor': {
    brief: 'The actual version of the protocol used for network communication.',
    type: 'string',
    keys: ['network.protocol.version', 'http.flavor', 'messaging.protocol_version', 'net.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1.1',
    deprecation: {
      replacement: 'network.protocol.version',
      status: 'backfill',
    },
    aliases: ['network.protocol.version', 'net.protocol.version', 'messaging.protocol_version'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol_version as an alias' },
      { version: '0.1.0', prs: [61, 108, 127] },
      { version: '0.0.0' },
    ],
  },
  'http.fragment': {
    brief:
      'The fragments present in the URI. Note that this contains the leading # character, while the `url.fragment` attribute does not.',
    type: 'string',
    keys: ['http.fragment'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '#details',
    changelog: [{ version: '0.0.0' }],
  },
  'http.host': {
    brief: 'The domain name.',
    type: 'string',
    keys: ['http.host'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'server.address',
      reason: 'Deprecated, use one of `server.address` or `client.address`, depending on the usage',
    },
    aliases: [
      'address',
      'server.address',
      'client.address',
      'http.server_name',
      'net.host.name',
      'server_name',
      'net.peer.name',
    ],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Added server_name as an alias' },
      { version: '0.21.0', prs: [588, 602], description: 'Added net.peer.name as an alias' },
      { version: '0.19.0', prs: [534], description: 'Added address as an alias' },
      { version: '0.1.0', prs: [61, 108, 127] },
      { version: '0.0.0' },
    ],
  },
  'http.method': {
    brief: 'The HTTP method used.',
    type: 'string',
    keys: ['http.request.method', 'http.method', 'http.request_method', 'method'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'GET',
    deprecation: {
      replacement: 'http.request.method',
      status: 'backfill',
    },
    aliases: ['http.request.method', 'http.request_method', 'method'],
    changelog: [{ version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
  },
  'http.query': {
    brief:
      'The query string present in the URL. Note that this contains the leading ? character, while the `url.query` attribute does not.',
    type: 'string',
    keys: ['http.query'],
    applyScrubbing: {
      key: 'auto',
      reason:
        'Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information.',
    },
    isInOtel: false,
    visibility: 'public',
    example: '?foo=bar&bar=baz',
    changelog: [{ version: '0.0.0' }],
  },
  'http.request.body.data': {
    brief: 'HTTP request body data. Can be given as string or structural data of any format.',
    type: 'string',
    keys: ['http.request.body.data'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '[{"role": "user", "message": "hello"}]',
    changelog: [{ version: '0.6.0', prs: [336], description: 'Added http.request.body.data attribute' }],
  },
  'http.request.body.decoded_size': {
    brief: 'The decoded body size of the request (in bytes).',
    type: 'integer',
    keys: ['http.request.body.decoded_size', 'http.request_content_length_uncompressed'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 456,
    aliases: ['http.request_content_length_uncompressed'],
    changelog: [{ version: '0.21.0', prs: [574], description: 'Added http.request.body.decoded_size attribute' }],
    additionalContext: [
      'This is the size after content decoding. Set it only when the decoded size is actually known, for example by measuring a decompressed request stream.',
      'Do not derive this from the `content-length` header, which always carries the encoded size. Use `http.request.body.size` for that.',
    ],
  },
  'http.request.body.size': {
    brief: 'The encoded body size of the request (in bytes).',
    type: 'integer',
    keys: ['http.request.body.size', 'http.request_content_length'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 123,
    aliases: ['http.request_content_length'],
    changelog: [{ version: '0.21.0', prs: [574], description: 'Added http.request.body.size attribute' }],
    additionalContext: [
      'This is the on-the-wire (encoded) size. The `content-length` header always carries the encoded size, so set this attribute whenever `content-length` is known, regardless of whether `content-encoding` is present.',
    ],
  },
  'http.request.connection_end': {
    brief:
      'The UNIX timestamp representing the time immediately after the browser finishes establishing the connection to the server to retrieve the resource. The timestamp value includes the time interval to establish the transport connection, as well as other time intervals such as TLS handshake and SOCKS authentication.',
    type: 'double',
    keys: ['http.request.connection_end'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.15,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.connect_start': {
    brief:
      'The UNIX timestamp representing the time immediately before the user agent starts establishing the connection to the server to retrieve the resource.',
    type: 'double',
    keys: ['http.request.connect_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.111,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request_content_length': {
    brief: 'The encoded body size of the request (in bytes).',
    type: 'integer',
    keys: ['http.request.body.size', 'http.request_content_length'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 123,
    deprecation: {
      replacement: 'http.request.body.size',
      status: 'backfill',
    },
    aliases: ['http.request.body.size'],
    changelog: [
      {
        version: '0.21.0',
        prs: [574],
        description: 'Added http.request_content_length attribute, deprecated in favor of http.request.body.size',
      },
    ],
  },
  'http.request_content_length_uncompressed': {
    brief: 'The decoded body size of the request (in bytes).',
    type: 'integer',
    keys: ['http.request.body.decoded_size', 'http.request_content_length_uncompressed'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 456,
    deprecation: {
      replacement: 'http.request.body.decoded_size',
      status: 'backfill',
    },
    aliases: ['http.request.body.decoded_size'],
    changelog: [
      {
        version: '0.21.0',
        prs: [574],
        description:
          'Added http.request_content_length_uncompressed attribute, deprecated in favor of http.request.body.decoded_size',
      },
    ],
  },
  'http.request.domain_lookup_end': {
    brief:
      'The UNIX timestamp representing the time immediately after the browser finishes the domain-name lookup for the resource.',
    type: 'double',
    keys: ['http.request.domain_lookup_end'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.201,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.domain_lookup_start': {
    brief:
      'The UNIX timestamp representing the time immediately before the browser starts the domain name lookup for the resource.',
    type: 'double',
    keys: ['http.request.domain_lookup_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.322,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.fetch_start': {
    brief: 'The UNIX timestamp representing the time immediately before the browser starts to fetch the resource.',
    type: 'double',
    keys: ['http.request.fetch_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.389,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.header.<key>': {
    brief:
      'HTTP request headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values.',
    type: 'string[]',
    keys: ['http.request.header.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "http.request.header.custom-header=['foo', 'bar']",
    examples: ["http.request.header.custom-header=['foo', 'bar']", "http.request.header.content-length=['123']"],
    changelog: [
      { version: '0.4.0', prs: [201, 204] },
      { version: '0.1.0', prs: [103] },
    ],
  },
  'http.request.method': {
    brief: 'The HTTP method used.',
    type: 'string',
    keys: ['http.request.method', 'http.method', 'http.request_method', 'method'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'GET',
    aliases: ['method', 'http.method', 'http.request_method'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'http.request_method': {
    brief: 'The HTTP method used.',
    type: 'string',
    keys: ['http.request.method', 'http.method', 'http.request_method', 'method'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET',
    deprecation: {
      replacement: 'http.request.method',
      status: 'backfill',
    },
    aliases: ['method', 'http.method', 'http.request.method'],
    changelog: [{ version: '0.6.0', prs: [343], description: 'Added http.request_method attribute' }],
  },
  'http.request.redirect_end': {
    brief:
      'The UNIX timestamp representing the timestamp immediately after receiving the last byte of the response of the last redirect',
    type: 'double',
    keys: ['http.request.redirect_end'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829558.502,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [130, 134] },
    ],
  },
  'http.request.redirect_start': {
    brief: 'The UNIX timestamp representing the start time of the fetch which that initiates the redirect.',
    type: 'double',
    keys: ['http.request.redirect_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.495,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.request_start': {
    brief:
      'The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.',
    type: 'double',
    keys: ['http.request.request_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.51,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.resend_count': {
    brief: 'The ordinal number of request resending attempt (for any reason, including redirects).',
    type: 'integer',
    keys: ['http.request.resend_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'http.request.response_end': {
    brief:
      'The UNIX timestamp representing the time immediately after the browser receives the last byte of the resource or immediately before the transport connection is closed, whichever comes first.',
    type: 'double',
    keys: ['http.request.response_end'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.89,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.response_start': {
    brief:
      'The UNIX timestamp representing the time immediately before the browser starts requesting the resource from the server, cache, or local resource. If the transport connection fails and the browser retires the request, the value returned will be the start of the retry request.',
    type: 'double',
    keys: ['http.request.response_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.7,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.same_origin': {
    brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
    type: 'boolean',
    keys: ['http.request.same_origin', 'url.same_origin'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    aliases: ['url.same_origin'],
    changelog: [{ version: '0.16.0', prs: [456], description: 'Added http.request.same_origin attribute' }],
  },
  'http.request.secure_connection_start': {
    brief:
      'The UNIX timestamp representing the time immediately before the browser starts the handshake process to secure the current connection. If a secure connection is not used, the property returns zero.',
    type: 'double',
    keys: ['http.request.secure_connection_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829555.73,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [134] }, { version: '0.0.0' }],
  },
  'http.request.time_to_first_byte': {
    brief:
      "The time in seconds from the browser's timeorigin to when the first byte of the request's response was received. See https://web.dev/articles/ttfb#measure-resource-requests",
    type: 'double',
    keys: ['http.request.time_to_first_byte'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1.032,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [131] },
    ],
  },
  'http.request.worker_start': {
    brief:
      'The UNIX timestamp representing the timestamp immediately before dispatching the FetchEvent if a Service Worker thread is already running, or immediately before starting the Service Worker thread if it is not already running.',
    type: 'double',
    keys: ['http.request.worker_start'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732829553.68,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [130, 134] },
    ],
  },
  'http.response.body.decoded_size': {
    brief: 'The decoded body size of the response (in bytes).',
    type: 'integer',
    keys: [
      'http.response.body.decoded_size',
      'http.decoded_response_content_length',
      'http.response_content_length_uncompressed',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 456,
    aliases: ['http.decoded_response_content_length', 'http.response_content_length_uncompressed'],
    changelog: [{ version: '0.21.0', prs: [574], description: 'Added http.response.body.decoded_size attribute' }],
    additionalContext: [
      'This is the size after content decoding. Set it only when the decoded size is actually known, for example from the browser Resource Timing `decodedBodySize` or by measuring a decompressed response stream.',
      'Do not derive this from the `content-length` header, which always carries the encoded size. Use `http.response.body.size` for that.',
    ],
  },
  'http.response.body.size': {
    brief: 'The encoded body size of the response (in bytes).',
    type: 'integer',
    keys: ['http.response.body.size', 'http.response.header.content-length', 'http.response_content_length'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 123,
    aliases: ['http.response_content_length', 'http.response.header.content-length'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [106] }, { version: '0.0.0' }],
  },
  'http.response_content_length': {
    brief: 'The encoded body size of the response (in bytes).',
    type: 'integer',
    keys: ['http.response.body.size', 'http.response.header.content-length', 'http.response_content_length'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 123,
    deprecation: {
      replacement: 'http.response.body.size',
      status: 'backfill',
    },
    aliases: ['http.response.body.size', 'http.response.header.content-length'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61, 106] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'http.response_content_length',
      type: 'byte',
    },
  },
  'http.response_content_length_uncompressed': {
    brief: 'The decoded body size of the response (in bytes).',
    type: 'integer',
    keys: [
      'http.response.body.decoded_size',
      'http.decoded_response_content_length',
      'http.response_content_length_uncompressed',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 456,
    deprecation: {
      replacement: 'http.response.body.decoded_size',
      status: 'backfill',
    },
    aliases: ['http.response.body.decoded_size', 'http.decoded_response_content_length'],
    changelog: [
      {
        version: '0.21.0',
        prs: [574],
        description:
          'Added http.response_content_length_uncompressed attribute, deprecated in favor of http.response.body.decoded_size',
      },
    ],
  },
  'http.response.header.content-length': {
    brief: 'The size of the message body sent to the recipient (in bytes)',
    type: 'string',
    keys: ['http.response.header.content-length', 'http.response.body.size', 'http.response_content_length'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: "http.response.header.custom-header=['foo', 'bar']",
    aliases: ['http.response_content_length', 'http.response.body.size'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'http.response.header.<key>': {
    brief:
      'HTTP response headers, <key> being the lower-cased, but otherwise unchanged HTTP Header name, the value being the header values.',
    type: 'string[]',
    keys: ['http.response.header.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "http.response.header.custom-header=['foo', 'bar']",
    examples: ["http.response.header.custom-header=['foo', 'bar']", "http.response.header.content-length=['123']"],
    changelog: [
      { version: '0.4.0', prs: [201, 204] },
      { version: '0.1.0', prs: [103] },
    ],
  },
  'http.response.size': {
    brief: 'The transfer size of the response (in bytes).',
    type: 'integer',
    keys: ['http.response.size', 'http.response_transfer_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 456,
    aliases: ['http.response_transfer_size'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'http.response.status_code': {
    brief: 'The status code of the HTTP response.',
    type: 'integer',
    keys: ['http.response.status_code', 'http.response_status_code', 'http.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 404,
    aliases: ['http.status_code'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'http.response_status_code',
    },
  },
  'http.response.status_text': {
    brief: 'The reason phrase of the HTTP response.',
    type: 'string',
    keys: ['http.response.status_text', 'http.status_text'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'NOT FOUND',
    aliases: ['http.status_text'],
    changelog: [{ version: '0.21.0', prs: [574], description: 'Added http.response.status_text attribute' }],
    additionalContext: [
      'HTTP/2 and HTTP/3 do not carry a reason phrase. Do not set this attribute when the protocol provides none; use `http.response.status_code` instead.',
    ],
  },
  'http.response_transfer_size': {
    brief: 'The transfer size of the response (in bytes).',
    type: 'integer',
    keys: ['http.response.size', 'http.response_transfer_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 456,
    deprecation: {
      replacement: 'http.response.size',
      status: 'backfill',
    },
    aliases: ['http.response.size'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'http.response_transfer_size',
      type: 'byte',
    },
  },
  'http.route': {
    brief: 'The matched route, that is, the path template in the format used by the respective server framework.',
    type: 'string',
    keys: ['http.route'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/users/:id',
    examples: ['/users/:id', 'my-controller/my-action/{id}', '/posts'],
    aliases: ['route'],
    changelog: [
      {
        version: '0.19.0',
        prs: [505, 521],
        description: 'Added multiple examples, removed alias to `url.template`, added additional context',
      },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute should primarily be set by server-side instrumentation that captures the framework route of an incoming request.',
      'For `http.client` spans and client-side routing, use `url.template` instead.',
    ],
  },
  'http.scheme': {
    brief: 'The URI scheme component identifying the used protocol.',
    type: 'string',
    keys: ['url.scheme', 'http.scheme'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'https',
    deprecation: {
      replacement: 'url.scheme',
      status: 'backfill',
    },
    aliases: ['url.scheme'],
    changelog: [{ version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
  },
  'http.server_name': {
    brief: 'The server domain name',
    type: 'string',
    keys: ['server.address', 'address', 'http.server_name', 'net.host.name', 'server_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'server.address',
      status: 'backfill',
    },
    aliases: ['address', 'server.address', 'net.host.name', 'http.host', 'server_name', 'net.peer.name'],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Added server_name as an alias' },
      { version: '0.21.0', prs: [588, 602], description: 'Added net.peer.name as an alias' },
      { version: '0.19.0', prs: [534], description: 'Added address as an alias' },
      { version: '0.1.0', prs: [61, 108, 127] },
      { version: '0.0.0' },
    ],
  },
  'http.server.request.time_in_queue': {
    brief:
      'The time in milliseconds the request spent in the server queue before processing began. Measured from the X-Request-Start header set by reverse proxies (e.g., Nginx, HAProxy, Heroku) to when the application started handling the request.',
    type: 'double',
    keys: ['http.server.request.time_in_queue'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 50,
    changelog: [{ version: '0.5.0', prs: [267] }],
  },
  'http.status_code': {
    brief: 'The status code of the HTTP response.',
    type: 'integer',
    keys: ['http.response.status_code', 'http.response_status_code', 'http.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 404,
    deprecation: {
      replacement: 'http.response.status_code',
      status: 'backfill',
    },
    aliases: ['http.response.status_code'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61] }, { version: '0.0.0' }],
  },
  'http.status_text': {
    brief: 'The reason phrase of the HTTP response',
    type: 'string',
    keys: ['http.response.status_text', 'http.status_text'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'NOT FOUND',
    examples: ['NOT FOUND'],
    deprecation: {
      replacement: 'http.response.status_text',
      status: 'backfill',
    },
    aliases: ['http.response.status_text'],
    changelog: [
      {
        version: '0.21.0',
        prs: [574],
        description: 'Added http.status_text attribute, deprecated in favor of http.response.status_text',
      },
    ],
  },
  'http.target': {
    brief: 'The pathname and query string of the URL.',
    type: 'string',
    keys: ['http.target'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/test?foo=bar#buzz',
    deprecation: {
      reason:
        'This attribute is being deprecated in favor of url.path, url.query and url.fragment. The value holds all three parts at once, so it has no single replacement.',
    },
    changelog: [
      {
        version: '0.21.0',
        prs: [587],
        description: 'Documented url.path, url.query and url.fragment as the replacements for http.target',
      },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'http.url': {
    brief: 'The URL of the resource that was fetched.',
    type: 'string',
    keys: ['url.full', 'aws.request.url', 'http.url', 'messaging.url', 'url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'https://example.com/test?foo=bar#buzz',
    deprecation: {
      replacement: 'url.full',
      status: 'backfill',
    },
    aliases: ['url.full', 'url', 'aws.request.url', 'messaging.url'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.url as an alias' },
      { version: '0.1.0', prs: [61, 108] },
      { version: '0.0.0' },
    ],
  },
  'http.user_agent': {
    brief: 'Value of the HTTP User-Agent header sent by the client.',
    type: 'string',
    keys: ['user_agent.original', 'http.user_agent'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      'Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1',
    deprecation: {
      replacement: 'user_agent.original',
      status: 'backfill',
    },
    aliases: ['user_agent.original'],
    changelog: [{ version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
  },
  id: {
    brief: 'A unique identifier for the span.',
    type: 'string',
    keys: ['id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'f47ac10b58cc4372a5670e02b2c3d479',
    changelog: [{ version: '0.0.0' }],
  },
  inp: {
    brief: 'The value of the recorded Interaction to Next Paint (INP) web vital',
    type: 'double',
    keys: ['browser.web_vital.inp.value', 'inp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 200,
    deprecation: {
      replacement: 'browser.web_vital.inp.value',
      reason: 'The INP web vital is now recorded as a browser.web_vital.inp.value attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.inp.value'],
    changelog: [
      {
        version: '0.5.0',
        prs: [229],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'integrity.blocked_url': {
    brief: 'The URL of the resource blocked by the integrity policy.',
    type: 'string',
    keys: ['integrity.blocked_url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com/app.js',
    changelog: [{ version: '0.27.0', prs: [691] }],
  },
  'integrity.destination': {
    brief: 'The destination type of the resource affected by the integrity policy.',
    type: 'string',
    keys: ['integrity.destination'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'script',
    changelog: [{ version: '0.27.0', prs: [691] }],
  },
  'integrity.document_url': {
    brief: 'The URL of the document where the integrity violation occurred.',
    type: 'string',
    keys: ['integrity.document_url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com/index.html',
    changelog: [{ version: '0.27.0', prs: [691] }],
  },
  'integrity.report_only': {
    brief: 'Whether the integrity violation was generated by a report-only policy.',
    type: 'boolean',
    keys: ['integrity.report_only'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.27.0', prs: [691] }],
  },
  'jsonrpc.protocol.version': {
    brief: 'The version of the JSON-RPC protocol used.',
    type: 'string',
    keys: ['jsonrpc.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '2.0',
    changelog: [{ version: '0.12.0', prs: [420], description: 'Added jsonrpc.protocol.version attribute' }],
  },
  'jsonrpc.request.id': {
    brief: 'The JSON-RPC request identifier, used to correlate a request with its response.',
    type: 'string',
    keys: ['jsonrpc.request.id', 'mcp.request.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1',
    examples: ['1'],
    aliases: ['mcp.request.id'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Removed the session-scoped uniqueness requirement from the request identifier',
      },
      { version: '0.12.0', prs: [420], description: 'Added jsonrpc.request.id attribute' },
    ],
  },
  'jvm.gc.action': {
    brief: 'Name of the garbage collector action.',
    type: 'string',
    keys: ['jvm.gc.action'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'end of minor GC',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'jvm.gc.name': {
    brief: 'Name of the garbage collector.',
    type: 'string',
    keys: ['jvm.gc.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'G1 Young Generation',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'jvm.memory.pool.name': {
    brief: 'Name of the memory pool.',
    type: 'string',
    keys: ['jvm.memory.pool.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'G1 Old Gen',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'jvm.memory.type': {
    brief: 'Name of the memory pool.',
    type: 'string',
    keys: ['jvm.memory.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'G1 Old Gen',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'jvm.thread.daemon': {
    brief: 'Whether the thread is daemon or not.',
    type: 'boolean',
    keys: ['jvm.thread.daemon'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'jvm.thread.state': {
    brief: 'State of the thread.',
    type: 'string',
    keys: ['jvm.thread.state'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'blocked',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'koa.name': {
    brief: 'The name of the Koa middleware or matched route that handled the request.',
    type: 'string',
    keys: ['koa.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/users/:id',
    deprecation: {
      reason:
        'No single replacement. SDKs should use http.route for router layers and code.function.name for middleware layers instead.',
    },
    changelog: [{ version: '0.16.0', prs: [490], description: 'Added koa.name attribute as deprecated' }],
  },
  'koa.type': {
    brief: 'The type of the Koa layer that handled the request.',
    type: 'string',
    keys: ['koa.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'router',
    changelog: [{ version: '0.16.0', prs: [471], description: 'Added koa.type attribute' }],
  },
  'langchain.chain.name': {
    brief: 'The name of the LangChain chain being executed.',
    type: 'string',
    keys: ['gen_ai.pipeline.name', 'ai.pipeline.name', 'langchain.chain.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'format_prompt',
    examples: ['format_prompt', 'RunnableSequence'],
    deprecation: {
      replacement: 'gen_ai.pipeline.name',
      reason:
        'This attribute is being deprecated in favor of gen_ai.pipeline.name, which is the SDK-agnostic replacement for the name of the AI pipeline or chain being executed.',
      status: 'backfill',
    },
    aliases: ['gen_ai.pipeline.name', 'ai.pipeline.name'],
    changelog: [{ version: '0.22.0', prs: [599], description: 'Added langchain.chain.name attribute' }],
  },
  lcp: {
    brief: 'The value of the recorded Largest Contentful Paint (LCP) web vital',
    type: 'double',
    keys: ['browser.web_vital.lcp.value', 'lcp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2500,
    deprecation: {
      replacement: 'browser.web_vital.lcp.value',
      reason: 'The LCP web vital is now recorded as a browser.web_vital.lcp.value attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.value'],
    changelog: [
      {
        version: '0.5.0',
        prs: [229],
        description: "Added and deprecated attribute to document JS SDK's current behaviour",
      },
    ],
  },
  'lcp.element': {
    brief: 'The dom element responsible for the largest contentful paint.',
    type: 'string',
    keys: ['browser.web_vital.lcp.element', 'lcp.element'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'img',
    deprecation: {
      replacement: 'browser.web_vital.lcp.element',
      reason: 'The LCP element is now recorded as a browser.web_vital.lcp.element attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.element'],
    changelog: [{ version: '0.5.0', prs: [233] }, { version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'lcp.id': {
    brief: 'The id of the dom element responsible for the largest contentful paint.',
    type: 'string',
    keys: ['browser.web_vital.lcp.id', 'lcp.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '#hero',
    deprecation: {
      replacement: 'browser.web_vital.lcp.id',
      reason: 'The LCP id is now recorded as a browser.web_vital.lcp.id attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.id'],
    changelog: [{ version: '0.5.0', prs: [233] }, { version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'lcp.loadTime': {
    brief: 'The time it took for the LCP element to be loaded',
    type: 'integer',
    keys: ['browser.web_vital.lcp.load_time', 'lcp.loadTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1402,
    deprecation: {
      replacement: 'browser.web_vital.lcp.load_time',
      reason: 'The LCP load time is now recorded as a browser.web_vital.lcp.load_time attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.load_time'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'lcp.renderTime': {
    brief: 'The time it took for the LCP element to be rendered',
    type: 'integer',
    keys: ['browser.web_vital.lcp.render_time', 'lcp.renderTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1685,
    deprecation: {
      replacement: 'browser.web_vital.lcp.render_time',
      reason: 'The LCP render time is now recorded as a browser.web_vital.lcp.render_time attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.render_time'],
    changelog: [{ version: '0.5.0', prs: [233] }],
  },
  'lcp.size': {
    brief: 'The size of the largest contentful paint element.',
    type: 'integer',
    keys: ['browser.web_vital.lcp.size', 'lcp.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234,
    deprecation: {
      replacement: 'browser.web_vital.lcp.size',
      reason: 'The LCP size is now recorded as a browser.web_vital.lcp.size attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.size'],
    changelog: [{ version: '0.5.0', prs: [233] }, { version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'lcp.url': {
    brief: 'The url of the dom element responsible for the largest contentful paint.',
    type: 'string',
    keys: ['browser.web_vital.lcp.url', 'lcp.url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com',
    deprecation: {
      replacement: 'browser.web_vital.lcp.url',
      reason: 'The LCP url is now recorded as a browser.web_vital.lcp.url attribute.',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.lcp.url'],
    changelog: [{ version: '0.5.0', prs: [233] }, { version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'litestar.middleware_name': {
    brief: 'The name of the Litestar middleware.',
    type: 'string',
    keys: [
      'middleware.name',
      'django.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
      'starlite.middleware_name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AuthenticationMiddleware',
    deprecation: {
      replacement: 'middleware.name',
      reason:
        'This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['middleware.name'],
    changelog: [
      {
        version: '0.19.0',
        prs: [486],
        description: 'Added litestar.middleware_name attribute, deprecated in favor of middleware.name',
      },
    ],
  },
  'logger.name': {
    brief: 'The name of the logger that generated this event.',
    type: 'string',
    keys: ['logger.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'myLogger',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'mcp.auth.client.name': {
    brief:
      'Registered OAuth client application name associated with the authenticated MCP request. Taken from OAuth client registration metadata (client_name) made available by the authentication layer. This is distinct from the MCP implementation name in mcp.client.name; omit it when the OAuth client name is unavailable.',
    type: 'string',
    keys: ['mcp.auth.client.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Example Desktop',
    examples: ['Example Desktop', 'Example CLI'],
    changelog: [{ version: '0.27.0', prs: [671], description: 'Added mcp.auth.client.name attribute' }],
  },
  'mcp.cancelled.reason': {
    brief: 'Reason for the cancellation of an MCP operation.',
    type: 'string',
    keys: ['mcp.cancelled.reason'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Cancellation reasons may contain user-specific or sensitive information',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'User cancelled the request',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.cancelled.request_id': {
    brief: 'Request ID of the cancelled MCP operation.',
    type: 'string',
    keys: ['mcp.cancelled.request_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.client.name': {
    brief:
      'Name of the MCP client implementation, as declared in clientInfo. This is distinct from the registered OAuth application name in mcp.auth.client.name.',
    type: 'string',
    keys: ['mcp.client.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example-mcp-client',
    examples: ['example-mcp-client'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.client.title': {
    brief: 'Display title of the MCP client implementation, as declared in clientInfo.',
    type: 'string',
    keys: ['mcp.client.title'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Client titles may reveal user-specific application configurations or custom setups',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Example MCP Client',
    examples: ['Example MCP Client'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.client.version': {
    brief: 'Version of the MCP client implementation, as declared in clientInfo.',
    type: 'string',
    keys: ['mcp.client.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0.0',
    examples: ['1.0.0'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.lifecycle.phase': {
    brief: 'Lifecycle phase indicator for MCP operations.',
    type: 'string',
    keys: ['mcp.lifecycle.phase'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'initialization_complete',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.logging.data_type': {
    brief: 'Data type of the logged message content.',
    type: 'string',
    keys: ['mcp.logging.data_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'string',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.logging.level': {
    brief: 'Log level for MCP logging operations.',
    type: 'string',
    keys: ['mcp.logging.level'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'info',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.logging.logger': {
    brief: 'Logger name for MCP logging operations.',
    type: 'string',
    keys: ['mcp.logging.logger'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Logger names may be user-defined and could contain sensitive information',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'mcp_server',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.logging.message': {
    brief: 'Log message content from MCP logging operations.',
    type: 'string',
    keys: ['mcp.logging.message'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Log messages can contain user data',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Tool execution completed successfully',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.method.name': {
    brief: 'The name of the MCP request or notification method being called.',
    type: 'string',
    keys: ['mcp.method.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'tools/call',
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Set is_in_otel=true, attribute exists in OTel MCP registry' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.progress.current': {
    brief: 'Current progress value of an MCP operation.',
    type: 'double',
    keys: ['mcp.progress.current'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.2,
    examples: [0.2, 50],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Changed the type to double to support fractional MCP progress values',
      },
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.progress.message': {
    brief: 'Progress message describing the current state of an MCP operation.',
    type: 'string',
    keys: ['mcp.progress.message'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Progress messages may contain user-specific or sensitive information',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Processing 50 of 100 items',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.progress.percentage': {
    brief: 'Calculated progress percentage of an MCP operation. Computed from current/total * 100.',
    type: 'double',
    keys: ['mcp.progress.percentage'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 50,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.progress.token': {
    brief: 'Token for tracking progress of an MCP operation.',
    type: 'string',
    keys: ['mcp.progress.token'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'progress-token-123',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.progress.total': {
    brief: 'Total progress target value of an MCP operation.',
    type: 'double',
    keys: ['mcp.progress.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    examples: [1, 100],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Changed the type to double to support fractional MCP progress values',
      },
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.prompt.name': {
    brief: 'Name of the MCP prompt template being used.',
    type: 'string',
    keys: ['gen_ai.prompt.name', 'mcp.prompt.name'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Prompt names may reveal user behavior patterns or sensitive operations',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'summarize',
    deprecation: {
      replacement: 'gen_ai.prompt.name',
      reason: 'OTel uses gen_ai.prompt.name for MCP prompt names',
      status: 'backfill',
    },
    aliases: ['gen_ai.prompt.name'],
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of gen_ai.prompt.name' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.prompt.result.description': {
    brief: 'Description of the prompt result.',
    type: 'string',
    keys: ['mcp.prompt.result.description'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'A summary of the requested information',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.prompt.result.<key>.content': {
    brief: 'Legacy text content of an indexed message in a multi-message MCP prompt result.',
    type: 'string',
    keys: ['mcp.prompt.result.<key>.content'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Summarize the document.',
    examples: ['Summarize the document.'],
    changelog: [
      { version: '0.27.0', prs: [689], description: 'Register an existing JavaScript SDK MCP result attribute.' },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple messages. <key> is the zero-based position in the original messages array; absent fields do not renumber later messages.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.prompt.result.<key>.role': {
    brief: 'Legacy role of an indexed message in a multi-message MCP prompt result.',
    type: 'string',
    keys: ['mcp.prompt.result.<key>.role'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user',
    examples: ['user', 'assistant'],
    changelog: [
      { version: '0.27.0', prs: [689], description: 'Register an existing JavaScript SDK MCP result attribute.' },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple messages. <key> is the zero-based position in the original messages array; absent fields do not renumber later messages.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.prompt.result.message_content': {
    brief: 'Content of the message in the prompt result. Used for single message results only.',
    type: 'string',
    keys: ['mcp.prompt.result.message_content'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Please provide a summary of the document',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.prompt.result.message_count': {
    brief: 'Number of messages in the prompt result.',
    type: 'integer',
    keys: ['mcp.prompt.result.message_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.prompt.result.message_role': {
    brief: 'Role of the message in the prompt result. Used for single message results only.',
    type: 'string',
    keys: ['mcp.prompt.result.message_role'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.protocol.ready': {
    brief:
      'Readiness indicator for the legacy MCP initialization handshake. A non-zero value indicates that notifications/initialized has completed initialization. Omit for protocol versions without this handshake.',
    type: 'integer',
    keys: ['mcp.protocol.ready'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    examples: [1],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that readiness describes the legacy MCP initialization handshake',
      },
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.protocol.version': {
    brief: 'Version of the Model Context Protocol used for the operation.',
    type: 'string',
    keys: ['mcp.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '2024-11-05',
    examples: ['2024-11-05'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the protocol version applies to an operation without requiring a session',
      },
      { version: '0.12.0', prs: [420], description: 'Set is_in_otel=true, attribute exists in OTel MCP registry' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.request.argument.<key>': {
    brief:
      'MCP request argument with dynamic key suffix. The <key> is replaced with the actual argument name. The value is a JSON-stringified representation of the argument value.',
    type: 'string',
    keys: ['mcp.request.argument.<key>'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Arguments contain user input',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "mcp.request.argument.query='weather in Paris'",
    changelog: [{ version: '0.3.0', prs: [176] }],
  },
  'mcp.request.argument.name': {
    brief: 'Name argument from prompts/get MCP request.',
    type: 'string',
    keys: ['mcp.request.argument.name'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Prompt names can contain user input',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'summarize',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.request.argument.uri': {
    brief: 'URI argument from resources/read MCP request.',
    type: 'string',
    keys: ['mcp.request.argument.uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'URIs can contain user file paths',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file:///path/to/resource',
    changelog: [{ version: '0.3.0', prs: [171] }],
  },
  'mcp.request.id': {
    brief: 'JSON-RPC request identifier for the MCP request, used to correlate the request with its response.',
    type: 'string',
    keys: ['jsonrpc.request.id', 'mcp.request.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1',
    examples: ['1'],
    deprecation: {
      replacement: 'jsonrpc.request.id',
      reason: 'OTel models MCP as JSON-RPC, uses jsonrpc.request.id',
      status: 'backfill',
    },
    aliases: ['jsonrpc.request.id'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Removed the session-scoped uniqueness requirement from the request identifier',
      },
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of jsonrpc.request.id' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.resource.protocol': {
    brief:
      'URI scheme of the MCP resource being accessed, extracted from its URI. This is distinct from the network protocol used to communicate with the MCP server.',
    type: 'string',
    keys: ['mcp.resource.protocol'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file',
    examples: ['file', 'postgres'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description:
          'Clarified Sentry-specific semantics and removed the incorrect network attribute alias and deprecation',
      },
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol as an alias' },
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of network.protocol.name' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.resource.uri': {
    brief: 'The resource URI being accessed in an MCP operation.',
    type: 'string',
    keys: ['mcp.resource.uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'URIs can contain sensitive file paths',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'file:///path/to/file.txt',
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Set is_in_otel=true, attribute exists in OTel MCP registry' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.server.name': {
    brief: 'Name of the MCP server implementation, as declared in serverInfo.',
    type: 'string',
    keys: ['mcp.server.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example-mcp-server',
    examples: ['example-mcp-server'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.server.title': {
    brief: 'Display title of the MCP server implementation, as declared in serverInfo.',
    type: 'string',
    keys: ['mcp.server.title'],
    applyScrubbing: {
      key: 'manual',
      reason: 'Server titles may reveal user-specific application configurations or custom setups',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Example MCP Server',
    examples: ['Example MCP Server'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.server.version': {
    brief: 'Version of the MCP server implementation, as declared in serverInfo.',
    type: 'string',
    keys: ['mcp.server.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '0.1.0',
    examples: ['0.1.0'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the attribute describes declared MCP implementation metadata',
      },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.session.id': {
    brief: 'Identifier for an MCP protocol session, when the operation belongs to a session.',
    type: 'string',
    keys: ['mcp.session.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '550e8400-e29b-41d4-a716-446655440000',
    examples: ['550e8400-e29b-41d4-a716-446655440000'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description: 'Clarified that the identifier requires a real MCP protocol session',
      },
      { version: '0.12.0', prs: [420], description: 'Set is_in_otel=true, attribute exists in OTel MCP registry' },
      { version: '0.3.0', prs: [171] },
    ],
    additionalContext: [
      'Applies to protocol versions and transports that provide MCP session management, including legacy Streamable HTTP sessions. Omit for operations without a protocol session; do not synthesize a session identifier from a request, connection, or conversation.',
    ],
  },
  'mcp.tool.name': {
    brief: 'Name of the MCP tool being called.',
    type: 'string',
    keys: ['gen_ai.tool.name', 'ai.function_call', 'mcp.tool.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'calculator',
    deprecation: {
      replacement: 'gen_ai.tool.name',
      reason: 'OTel uses gen_ai.tool.name for MCP tool names',
      status: 'backfill',
    },
    aliases: ['gen_ai.tool.name', 'ai.function_call'],
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of gen_ai.tool.name' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.tool.result.content': {
    brief: 'The content of the tool result.',
    type: 'string',
    keys: [
      'gen_ai.tool.call.result',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'mcp.tool.result.content',
    ],
    applyScrubbing: {
      key: 'auto',
      reason: 'Tool results can contain user data',
    },
    isInOtel: false,
    visibility: 'public',
    example: '{"output": "rainy", "toolCallId": "1"}',
    deprecation: {
      replacement: 'gen_ai.tool.call.result',
      reason: 'OTel uses gen_ai.tool.call.result for MCP tool results',
      status: 'backfill',
    },
    aliases: [
      'gen_ai.tool.call.result',
      'gen_ai.tool.message',
      'gen_ai.tool.output',
      'ai.toolCall.result',
      'anthropic.tool_result.content',
    ],
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of gen_ai.tool.call.result' },
      { version: '0.3.0', prs: [171] },
      { version: '0.2.0', prs: [164] },
    ],
  },
  'mcp.tool.result.content_count': {
    brief: 'Number of content items in the tool result.',
    type: 'integer',
    keys: ['mcp.tool.result.content_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    deprecation: {
      reason: 'A count can be calculcated from the value of the gen_ai.tool.call.result attribute.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [669],
        description: 'Deprecate the attribute since it is redundant given gen_ai.tool.call.result.',
      },
      { version: '0.4.0', prs: [228] },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.tool.result.content_type': {
    brief: 'Legacy content type of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.content_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'text',
    examples: ['text', 'image'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded even when output capture is disabled.',
    ],
  },
  'mcp.tool.result.data_size': {
    brief:
      'Legacy length of the data string in UTF-16 code units of the content item in a single-item MCP tool result.',
    type: 'integer',
    keys: ['mcp.tool.result.data_size'],
    applyScrubbing: {
      key: 'manual',
      reason: 'The length contains no result content.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 4,
    examples: [4, 1024],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
      'The JavaScript SDK records data.length. For base64-encoded image or audio data, this counts encoded characters, not decoded bytes.',
    ],
  },
  'mcp.tool.result.is_error': {
    brief: 'Whether a tool execution resulted in an error.',
    type: 'boolean',
    keys: ['mcp.tool.result.is_error'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: false,
    deprecation: {
      replacement: 'error.type',
      reason:
        "OTel uses error.type set to 'tool_error' when isError is true. Cannot be automatically backfilled due to type mismatch (boolean vs string).",
    },
    changelog: [
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of error.type' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mcp.tool.result.<key>.content': {
    brief: 'Legacy text content of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.content'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'The operation completed.',
    examples: ['The operation completed.'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
      "This is one item's text, not the complete tool result. It must not be aliased or directly backfilled to gen_ai.tool.call.result; reconstructing the complete result requires aggregation.",
    ],
  },
  'mcp.tool.result.<key>.content_type': {
    brief: 'Legacy content type of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.content_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'text',
    examples: ['text', 'image'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded even when output capture is disabled.',
    ],
  },
  'mcp.tool.result.<key>.data_size': {
    brief:
      'Legacy length of the data string in UTF-16 code units of an indexed content item in a multi-item MCP tool result.',
    type: 'integer',
    keys: ['mcp.tool.result.<key>.data_size'],
    applyScrubbing: {
      key: 'manual',
      reason: 'The length contains no result content.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 4,
    examples: [4, 1024],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
      'The JavaScript SDK records data.length. For base64-encoded image or audio data, this counts encoded characters, not decoded bytes.',
    ],
  },
  'mcp.tool.result.<key>.mime_type': {
    brief: 'Legacy MIME type of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.mime_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'image/png',
    examples: ['image/png', 'audio/wav'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.<key>.name': {
    brief: 'Legacy resource link name of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.name'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'report.txt',
    examples: ['report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.<key>.resource_mime_type': {
    brief: 'Legacy embedded resource MIME type of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.resource_mime_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'text/plain',
    examples: ['text/plain'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.<key>.resource_uri': {
    brief: 'Legacy embedded resource URI of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.resource_uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file:///project/report.txt',
    examples: ['file:///project/report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.<key>.uri': {
    brief: 'Legacy resource link URI of an indexed content item in a multi-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.<key>.uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file:///project/report.txt',
    examples: ['file:///project/report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted for results with multiple content items. <key> is the zero-based position in the original content array; absent fields do not renumber later items.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.mime_type': {
    brief: 'Legacy MIME type of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.mime_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'image/png',
    examples: ['image/png', 'audio/wav'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.name': {
    brief: 'Legacy resource link name of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.name'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'report.txt',
    examples: ['report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.resource_mime_type': {
    brief: 'Legacy embedded resource MIME type of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.resource_mime_type'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'text/plain',
    examples: ['text/plain'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.resource_uri': {
    brief: 'Legacy embedded resource URI of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.resource_uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file:///project/report.txt',
    examples: ['file:///project/report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.tool.result.uri': {
    brief: 'Legacy resource link URI of the content item in a single-item MCP tool result.',
    type: 'string',
    keys: ['mcp.tool.result.uri'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Preserve automatic scrubbing of server-provided result fields.',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'file:///project/report.txt',
    examples: ['file:///project/report.txt'],
    deprecation: {
      reason:
        'Capture the complete tool result in gen_ai.tool.call.result instead. This attribute describes only part of the result and cannot be directly backfilled.',
    },
    changelog: [
      {
        version: '0.27.0',
        prs: [689],
        description:
          'Register an existing JavaScript SDK MCP result attribute as deprecated in favor of gen_ai.tool.call.result, without backfill.',
      },
    ],
    additionalContext: [
      'Registers an existing Sentry JavaScript SDK attribute for compatibility.',
      'Emitted only when the result contains exactly one content item.',
      'Recorded only when output capture is enabled.',
    ],
  },
  'mcp.transport': {
    brief:
      'MCP transport implementation name, such as the transport class name. This identifies the implementation, not the network transport or application protocol.',
    type: 'string',
    keys: ['mcp.transport'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'StdioServerTransport',
    examples: ['StdioServerTransport', 'CustomHTTPTransport'],
    changelog: [
      {
        version: '0.27.0',
        prs: [671],
        description:
          'Clarified Sentry-specific semantics and removed the incorrect network attribute alias and deprecation',
      },
      { version: '0.12.0', prs: [420], description: 'Deprecated in favor of network.transport' },
      { version: '0.3.0', prs: [171] },
    ],
  },
  'mdc.<key>': {
    brief:
      "Attributes from the Mapped Diagnostic Context (MDC) present at the moment the log record was created. The MDC is supported by all the most popular logging solutions in the Java ecosystem, and it's usually implemented as a thread-local map that stores context for e.g. a specific request.",
    type: 'string',
    keys: ['mdc.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "mdc.some_key='some_value'",
    changelog: [{ version: '0.3.0', prs: [176] }],
  },
  'messaging.batch.message_count': {
    brief: 'The number of messages sent, received, or processed in the scope of the batching operation.',
    type: 'integer',
    keys: ['messaging.batch.message_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 10,
    changelog: [{ version: '0.6.0', prs: [341], description: 'Added messaging.batch.message_count attribute' }],
  },
  'messaging.conversation_id': {
    brief:
      'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
    type: 'string',
    keys: ['messaging.message.conversation_id', 'messaging.conversation_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'MyConversationId',
    examples: ['MyConversationId'],
    deprecation: {
      replacement: 'messaging.message.conversation_id',
      reason: 'This attribute is being deprecated in favor of messaging.message.conversation_id.',
      status: 'backfill',
    },
    aliases: ['messaging.message.conversation_id'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.conversation_id attribute' }],
  },
  'messaging.destination': {
    brief: 'The message destination name.',
    type: 'string',
    keys: ['messaging.destination.name', 'messaging.destination'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'BestTopic',
    deprecation: {
      replacement: 'messaging.destination.name',
      reason:
        'This attribute is being deprecated in favor of messaging.destination.name, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['messaging.destination.name'],
    changelog: [
      {
        version: '0.16.0',
        prs: [482],
        description: 'Added messaging.destination attribute, deprecated in favor of messaging.destination.name',
      },
    ],
  },
  'messaging.destination.connection': {
    brief: 'The message destination connection.',
    type: 'string',
    keys: ['messaging.destination.connection'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'BestTopic',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'messaging.destination_kind': {
    brief: 'The kind of message destination.',
    type: 'string',
    keys: ['messaging.destination_kind'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'topic',
    deprecation: {
      reason:
        'Deprecated from OTEL, which now models the destination kind via messaging.operation.type and messaging.destination.name.',
    },
    changelog: [
      {
        version: '0.19.0',
        prs: [509],
        description:
          'Added deprecated messaging.destination_kind attribute for parity with legacy OTel instrumentations.',
      },
    ],
  },
  'messaging.destination.name': {
    brief: 'The message destination name.',
    type: 'string',
    keys: ['messaging.destination.name', 'messaging.destination'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'BestTopic',
    aliases: ['messaging.destination'],
    changelog: [
      { version: '0.16.0', prs: [482], description: 'Added messaging.destination as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'messaging.destination.partition.id': {
    brief:
      'The identifier of the partition messages are sent to or received from, unique within the messaging.destination.name.',
    type: 'string',
    keys: ['messaging.destination.partition.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1',
    changelog: [{ version: '0.19.0', prs: [474], description: 'Added messaging.destination.partition.id attribute' }],
  },
  'messaging.kafka.message.key': {
    brief:
      "Message keys in Kafka are used for grouping alike messages to ensure they're processed on the same partition. They differ from messaging.message.id in that they're not unique. If the key is null, the attribute MUST NOT be set.",
    type: 'string',
    keys: ['messaging.kafka.message.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'myKey',
    changelog: [{ version: '0.19.0', prs: [474], description: 'Added messaging.kafka.message.key attribute' }],
  },
  'messaging.kafka.message.tombstone': {
    brief: 'A boolean that is true if the message is a tombstone.',
    type: 'boolean',
    keys: ['messaging.kafka.message.tombstone'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.19.0', prs: [474], description: 'Added messaging.kafka.message.tombstone attribute' }],
  },
  'messaging.kafka.offset': {
    brief: 'The offset of a record in the corresponding Kafka partition.',
    type: 'integer',
    keys: ['messaging.kafka.offset'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 42,
    changelog: [{ version: '0.19.0', prs: [474], description: 'Added messaging.kafka.offset attribute' }],
  },
  'messaging.message.body.size': {
    brief: 'The size of the message body in bytes.',
    type: 'integer',
    keys: ['messaging.message.body.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 839,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'messaging.message.body.size',
      type: 'byte',
    },
  },
  'messaging.message.conversation_id': {
    brief:
      'The conversation ID identifying the conversation to which the message belongs, represented as a string. Sometimes called "Correlation ID".',
    type: 'string',
    keys: ['messaging.message.conversation_id', 'messaging.conversation_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'MyConversationId',
    aliases: ['messaging.conversation_id'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.conversation_id as an alias' },
      { version: '0.16.0', prs: [468], description: 'Added messaging.message.conversation_id attribute' },
    ],
  },
  'messaging.message.envelope.size': {
    brief: 'The size of the message body and metadata in bytes.',
    type: 'integer',
    keys: ['messaging.message.envelope.size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1045,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'messaging.message.id': {
    brief: 'A value used by the messaging system as an identifier for the message, represented as a string.',
    type: 'string',
    keys: ['messaging.message.id', 'messaging.message_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'f47ac10b58cc4372a5670e02b2c3d479',
    aliases: ['messaging.message_id'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.message_id as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'messaging.message_id': {
    brief: 'A value used by the messaging system as an identifier for the message, represented as a string.',
    type: 'string',
    keys: ['messaging.message.id', 'messaging.message_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '452a7c7c7c7048c2f887f0e7',
    examples: ['452a7c7c7c7048c2f887f0e7'],
    deprecation: {
      replacement: 'messaging.message.id',
      reason: 'This attribute is being deprecated in favor of messaging.message.id.',
      status: 'backfill',
    },
    aliases: ['messaging.message.id'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.message_id attribute' }],
  },
  'messaging.message.receive.latency': {
    brief: 'The latency between when the message was published and received.',
    type: 'integer',
    keys: ['messaging.message.receive.latency'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1732847252,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'messaging.message.receive.latency',
      type: 'millisecond',
    },
  },
  'messaging.message.retry.count': {
    brief: 'The amount of attempts to send the message.',
    type: 'integer',
    keys: ['messaging.message.retry.count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'messaging.operation': {
    brief: 'The name of the messaging operation being performed.',
    type: 'string',
    keys: ['messaging.operation.name', 'messaging.operation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'publish',
    examples: ['publish'],
    deprecation: {
      replacement: 'messaging.operation.name',
      reason: 'This attribute is being deprecated in favor of messaging.operation.name.',
      status: 'backfill',
    },
    aliases: ['messaging.operation.name'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.operation attribute' }],
  },
  'messaging.operation.name': {
    brief: 'The name of the messaging operation being performed',
    type: 'string',
    keys: ['messaging.operation.name', 'messaging.operation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'send',
    aliases: ['messaging.operation'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.operation as an alias' },
      { version: '0.11.0', prs: [392], description: 'Added messaging.operation.name attribute' },
    ],
  },
  'messaging.operation.type': {
    brief: 'A string identifying the type of the messaging operation',
    type: 'string',
    keys: ['messaging.operation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'create',
    changelog: [{ version: '0.1.0', prs: [51, 127] }],
  },
  'messaging.protocol': {
    brief: 'OSI application layer or non-OSI equivalent.',
    type: 'string',
    keys: ['network.protocol.name', 'messaging.protocol', 'net.protocol.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AMQP',
    examples: ['AMQP'],
    deprecation: {
      replacement: 'network.protocol.name',
      reason: 'This attribute is being deprecated in favor of network.protocol.name.',
      status: 'backfill',
    },
    aliases: ['network.protocol.name', 'net.protocol.name'],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Removed the semantically distinct mcp.resource.protocol alias' },
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol attribute' },
    ],
  },
  'messaging.protocol_version': {
    brief: 'The actual version of the protocol used for network communication.',
    type: 'string',
    keys: ['network.protocol.version', 'http.flavor', 'messaging.protocol_version', 'net.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '0.9.1',
    examples: ['0.9.1'],
    deprecation: {
      replacement: 'network.protocol.version',
      reason: 'This attribute is being deprecated in favor of network.protocol.version.',
      status: 'backfill',
    },
    aliases: ['network.protocol.version', 'http.flavor', 'net.protocol.version'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.protocol_version attribute' }],
  },
  'messaging.rabbitmq.destination.routing_key': {
    brief: 'RabbitMQ message routing key.',
    type: 'string',
    keys: ['messaging.rabbitmq.destination.routing_key', 'messaging.rabbitmq.routing_key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'myKey',
    aliases: ['messaging.rabbitmq.routing_key'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.rabbitmq.routing_key as an alias' },
      { version: '0.16.0', prs: [468], description: 'Added messaging.rabbitmq.destination.routing_key attribute' },
    ],
  },
  'messaging.rabbitmq.routing_key': {
    brief: 'RabbitMQ message routing key.',
    type: 'string',
    keys: ['messaging.rabbitmq.destination.routing_key', 'messaging.rabbitmq.routing_key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'myKey',
    examples: ['myKey'],
    deprecation: {
      replacement: 'messaging.rabbitmq.destination.routing_key',
      reason: 'This attribute is being deprecated in favor of messaging.rabbitmq.destination.routing_key.',
      status: 'backfill',
    },
    aliases: ['messaging.rabbitmq.destination.routing_key'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.rabbitmq.routing_key attribute' }],
  },
  'messaging.system': {
    brief: 'The messaging system as identified by the client instrumentation.',
    type: 'string',
    keys: ['messaging.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'activemq',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'messaging.url': {
    brief: 'The connection string of the messaging broker.',
    type: 'string',
    keys: ['url.full', 'aws.request.url', 'http.url', 'messaging.url', 'url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'amqp://guest:guest@localhost:5672',
    examples: ['amqp://guest:guest@localhost:5672'],
    deprecation: {
      replacement: 'url.full',
      reason: 'This attribute is being deprecated in favor of url.full.',
      status: 'backfill',
    },
    aliases: ['url.full', 'http.url', 'url', 'aws.request.url'],
    changelog: [{ version: '0.21.0', prs: [581], description: 'Added messaging.url attribute' }],
  },
  method: {
    brief: 'The HTTP method used.',
    type: 'string',
    keys: ['http.request.method', 'http.method', 'http.request_method', 'method'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET',
    deprecation: {
      replacement: 'http.request.method',
      status: 'normalize',
    },
    aliases: ['http.request.method', 'http.request_method', 'http.method'],
    changelog: [
      { version: '0.19.0', prs: [497], description: 'Configured normalization' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'middleware.name': {
    brief: 'The name of the middleware.',
    type: 'string',
    keys: [
      'middleware.name',
      'django.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
      'starlite.middleware_name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AuthenticationMiddleware',
    aliases: [
      'django.middleware_name',
      'starlite.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
    ],
    changelog: [
      {
        version: '0.19.0',
        prs: [485, 486, 519, 520],
        description:
          'Added django.middleware_name, starlite.middleware_name, litestar.middleware_name and starlette.middleware_name as aliases',
      },
      { version: '0.6.0', prs: [336], description: 'Added middleware.name attribute' },
    ],
  },
  'navigation.origin': {
    brief:
      'The origin of the navigation (usually client side router navigations). Should preferrably parameterized template (like url.template) or a URL path otherwise.',
    type: 'string',
    keys: ['router.navigation.origin', 'navigation.origin', 'sentry.sveltekit.navigation.from'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/users/:id',
    deprecation: {
      replacement: 'router.navigation.origin',
      reason: 'Moved to the router.* namespace to separate client-side router navigations from browser navigations.',
      status: 'backfill',
    },
    aliases: ['router.navigation.origin', 'sentry.sveltekit.navigation.from'],
    changelog: [
      { version: '0.22.0', prs: [600], description: 'Deprecated in favor of router.navigation.origin' },
      { version: '0.16.0', prs: [467], description: 'Added navigation.origin attribute' },
    ],
  },
  'navigation.route.id': {
    brief:
      'The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).',
    type: 'string',
    keys: ['router.navigation.route.id', 'navigation.route.id'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AboutView',
    deprecation: {
      replacement: 'router.navigation.route.id',
      reason: 'Moved to the router.* namespace to separate client-side router navigations from browser navigations.',
      status: 'backfill',
    },
    aliases: ['router.navigation.route.id'],
    changelog: [
      { version: '0.22.0', prs: [600], description: 'Deprecated in favor of router.navigation.route.id' },
      { version: '0.16.0', prs: [468], description: 'Added navigation.route.id attribute' },
    ],
  },
  'navigation.type': {
    brief: 'The type of navigation done by a client-side router.',
    type: 'string',
    keys: ['router.navigation.type', 'navigation.type', 'sentry.sveltekit.navigation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'router.push',
    deprecation: {
      replacement: 'router.navigation.type',
      reason: 'Moved to the router.* namespace to separate client-side router navigations from browser navigations.',
      status: 'backfill',
    },
    aliases: ['router.navigation.type', 'sentry.sveltekit.navigation.type'],
    changelog: [
      { version: '0.22.0', prs: [600], description: 'Deprecated in favor of router.navigation.type' },
      { version: '0.16.0', prs: [467], description: 'Added new deprecated alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'nel.elapsed_time': {
    brief:
      'The elapsed number of milliseconds between the start of the resource fetch and when it was completed or aborted by the user agent.',
    type: 'integer',
    keys: ['nel.elapsed_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [68] },
    ],
  },
  'nel.phase': {
    brief: 'If request failed, the phase of its network error. If request succeeded, "application".',
    type: 'string',
    keys: ['nel.phase'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'application',
    changelog: [{ version: '0.1.0', prs: [68, 127] }],
  },
  'nel.referrer': {
    brief: "request's referrer, as determined by the referrer policy associated with its client.",
    type: 'string',
    keys: ['nel.referrer'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com/foo?bar=baz',
    changelog: [{ version: '0.1.0', prs: [68, 127] }],
  },
  'nel.sampling_fraction': {
    brief: 'The sampling fraction used to determine if the request should be sampled.',
    type: 'double',
    keys: ['nel.sampling_fraction', 'nel.sampling_function'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    examples: [0.5],
    aliases: ['nel.sampling_function'],
    changelog: [{ version: '0.26.0', prs: [668], description: 'Added nel.sampling_fraction attribute' }],
  },
  'nel.sampling_function': {
    brief: 'The sampling function used to determine if the request should be sampled.',
    type: 'double',
    keys: ['nel.sampling_fraction', 'nel.sampling_function'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    deprecation: {
      replacement: 'nel.sampling_fraction',
      reason: 'The correct name of this attribute is nel.sampling_fraction',
      status: 'backfill',
    },
    aliases: ['nel.sampling_fraction'],
    changelog: [
      { version: '0.26.0', prs: [668], description: 'Deprecated in favor of nel.sampling_fraction' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [68] },
    ],
  },
  'nel.type': {
    brief: 'If request failed, the type of its network error. If request succeeded, "ok".',
    type: 'string',
    keys: ['nel.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'dns.unreachable',
    changelog: [{ version: '0.1.0', prs: [68, 127] }],
  },
  'network.connection.effective_type': {
    brief: 'Specifies the effective type of the current connection (e.g. slow-2g, 2g, 3g, 4g).',
    type: 'string',
    keys: ['network.connection.effective_type', 'effectiveConnectionType'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '4g',
    aliases: ['effectiveConnectionType'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: 'Added attribute network.connection.effective_type to be used instead of effectiveConnectionType',
      },
    ],
  },
  'network.connection.rtt': {
    brief: 'Specifies the estimated effective round-trip time of the current connection, in milliseconds.',
    type: 'integer',
    keys: ['network.connection.rtt', 'connection.rtt'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 100,
    aliases: ['connection.rtt'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: 'Added attribute network.connection.rtt to be used instead of connection.rtt',
      },
    ],
  },
  'network.connection.type': {
    brief: 'Specifies the type of the current connection (e.g. wifi, ethernet, cellular , etc).',
    type: 'string',
    keys: ['network.connection.type', 'connectionType', 'device.connection_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'wifi',
    aliases: ['device.connection_type', 'connectionType'],
    changelog: [
      {
        version: '0.5.0',
        prs: [279],
        description: 'Added attribute network.connection.type to be used instead of connectionType',
      },
    ],
  },
  'network.local.address': {
    brief: 'Local address of the network connection - IP address or Unix domain socket name.',
    type: 'string',
    keys: ['network.local.address', 'net.host.ip', 'net.sock.host.addr'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '10.1.2.80',
    examples: ['10.1.2.80', '/var/run/my.sock'],
    aliases: ['net.host.ip', 'net.sock.host.addr'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'network.local.port': {
    brief: 'Local port number of the network connection.',
    type: 'integer',
    keys: ['network.local.port', 'net.sock.host.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 65400,
    aliases: ['net.sock.host.port'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'network.peer.address': {
    brief: 'Peer address of the network connection - IP address or Unix domain socket name.',
    type: 'string',
    keys: ['network.peer.address', 'net.peer.ip', 'net.sock.peer.addr'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '10.1.2.80',
    aliases: ['net.peer.ip', 'net.sock.peer.addr'],
    changelog: [{ version: '0.1.0', prs: [108, 127] }, { version: '0.0.0' }],
  },
  'network.peer.port': {
    brief: 'Peer port number of the network connection.',
    type: 'integer',
    keys: ['network.peer.port', 'net.sock.peer.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 65400,
    aliases: ['net.sock.peer.port'],
    changelog: [
      { version: '0.21.0', prs: [588], description: 'Added net.sock.peer.port as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
  },
  'network.protocol.name': {
    brief: 'OSI application layer or non-OSI equivalent.',
    type: 'string',
    keys: ['network.protocol.name', 'messaging.protocol', 'net.protocol.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'http',
    examples: ['http'],
    aliases: ['net.protocol.name', 'messaging.protocol'],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Removed the semantically distinct mcp.resource.protocol alias' },
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'network.protocol.version': {
    brief: 'The actual version of the protocol used for network communication.',
    type: 'string',
    keys: ['network.protocol.version', 'http.flavor', 'messaging.protocol_version', 'net.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1.1',
    aliases: ['http.flavor', 'net.protocol.version', 'messaging.protocol_version'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol_version as an alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'network.transport': {
    brief: 'OSI transport layer or inter-process communication method.',
    type: 'string',
    keys: ['network.transport'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'tcp',
    examples: ['tcp'],
    aliases: ['net.transport'],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Removed the semantically distinct mcp.transport alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'network.type': {
    brief: 'OSI network layer or non-OSI equivalent.',
    type: 'string',
    keys: ['network.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'ipv4',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'net.host.ip': {
    brief: 'Local address of the network connection - IP address or Unix domain socket name.',
    type: 'string',
    keys: ['network.local.address', 'net.host.ip', 'net.sock.host.addr'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '192.168.0.1',
    deprecation: {
      replacement: 'network.local.address',
      status: 'backfill',
    },
    aliases: ['network.local.address', 'net.sock.host.addr'],
    changelog: [{ version: '0.1.0', prs: [61, 108, 127] }, { version: '0.0.0' }],
  },
  'net.host.name': {
    brief:
      'Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.',
    type: 'string',
    keys: ['server.address', 'address', 'http.server_name', 'net.host.name', 'server_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'server.address',
      status: 'backfill',
    },
    aliases: ['address', 'server.address', 'http.server_name', 'http.host', 'server_name', 'net.peer.name'],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Added server_name as an alias' },
      { version: '0.21.0', prs: [588, 602], description: 'Added net.peer.name as an alias' },
      { version: '0.19.0', prs: [534], description: 'Added address as an alias' },
      { version: '0.1.0', prs: [61, 108, 127] },
      { version: '0.0.0' },
    ],
  },
  'net.host.port': {
    brief: 'Server port number.',
    type: 'integer',
    keys: ['server.port', 'net.host.port', 'port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1337,
    deprecation: {
      replacement: 'server.port',
      status: 'backfill',
    },
    aliases: ['server.port', 'port'],
    changelog: [
      { version: '0.19.0', prs: [532], description: 'Added port as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'net.peer.ip': {
    brief: 'Peer address of the network connection - IP address or Unix domain socket name.',
    type: 'string',
    keys: ['network.peer.address', 'net.peer.ip', 'net.sock.peer.addr'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '192.168.0.1',
    deprecation: {
      replacement: 'network.peer.address',
      status: 'backfill',
    },
    aliases: ['network.peer.address', 'net.sock.peer.addr'],
    changelog: [{ version: '0.1.0', prs: [61, 108, 127] }, { version: '0.0.0' }],
  },
  'net.peer.name': {
    brief:
      'Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.',
    type: 'string',
    keys: ['net.peer.name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'server.address',
      reason: 'Deprecated, use server.address on client spans and client.address on server spans.',
    },
    aliases: ['address', 'server.address', 'http.server_name', 'net.host.name', 'http.host', 'server_name'],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Added server_name as an alias' },
      { version: '0.21.0', prs: [588, 602], description: 'Added the server.address alias group to net.peer.name' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'net.peer.port': {
    brief: 'Peer port number.',
    type: 'integer',
    keys: ['net.peer.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1337,
    deprecation: {
      replacement: 'server.port',
      reason: 'Deprecated, use server.port on client spans and client.port on server spans.',
    },
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61] }, { version: '0.0.0' }],
  },
  'net.protocol.name': {
    brief: 'OSI application layer or non-OSI equivalent.',
    type: 'string',
    keys: ['network.protocol.name', 'messaging.protocol', 'net.protocol.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'http',
    examples: ['http'],
    deprecation: {
      replacement: 'network.protocol.name',
      status: 'backfill',
    },
    aliases: ['network.protocol.name', 'messaging.protocol'],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Removed the semantically distinct mcp.resource.protocol alias' },
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol as an alias' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'net.protocol.version': {
    brief: 'The actual version of the protocol used for network communication.',
    type: 'string',
    keys: ['network.protocol.version', 'http.flavor', 'messaging.protocol_version', 'net.protocol.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1.1',
    deprecation: {
      replacement: 'network.protocol.version',
      status: 'backfill',
    },
    aliases: ['network.protocol.version', 'http.flavor', 'messaging.protocol_version'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.protocol_version as an alias' },
      { version: '0.1.0', prs: [61, 108, 127] },
      { version: '0.0.0' },
    ],
  },
  'net.sock.family': {
    brief: 'OSI transport and network layer',
    type: 'string',
    keys: ['net.sock.family'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'inet',
    deprecation: {
      replacement: 'network.transport',
      reason: 'Deprecated, use network.transport and network.type.',
    },
    changelog: [{ version: '0.1.0', prs: [61, 127] }, { version: '0.0.0' }],
  },
  'net.sock.host.addr': {
    brief: 'Local address of the network connection mapping to Unix domain socket name.',
    type: 'string',
    keys: ['network.local.address', 'net.host.ip', 'net.sock.host.addr'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/var/my.sock',
    deprecation: {
      replacement: 'network.local.address',
      status: 'backfill',
    },
    aliases: ['network.local.address', 'net.host.ip'],
    changelog: [{ version: '0.1.0', prs: [61, 108, 127] }, { version: '0.0.0' }],
  },
  'net.sock.host.port': {
    brief: 'Local port number of the network connection.',
    type: 'integer',
    keys: ['network.local.port', 'net.sock.host.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 8080,
    deprecation: {
      replacement: 'network.local.port',
      status: 'backfill',
    },
    aliases: ['network.local.port'],
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.1.0', prs: [61] }, { version: '0.0.0' }],
  },
  'net.sock.peer.addr': {
    brief: 'Peer address of the network connection - IP address',
    type: 'string',
    keys: ['network.peer.address', 'net.peer.ip', 'net.sock.peer.addr'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '192.168.0.1',
    deprecation: {
      replacement: 'network.peer.address',
      status: 'backfill',
    },
    aliases: ['network.peer.address', 'net.peer.ip'],
    changelog: [{ version: '0.1.0', prs: [61, 108, 127] }, { version: '0.0.0' }],
  },
  'net.sock.peer.name': {
    brief: 'Peer address of the network connection - Unix domain socket name',
    type: 'string',
    keys: ['net.sock.peer.name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/var/my.sock',
    deprecation: {
      reason: 'Deprecated from OTEL, no replacement at this time',
    },
    changelog: [{ version: '0.1.0', prs: [61, 119, 127] }, { version: '0.0.0' }],
  },
  'net.sock.peer.port': {
    brief: 'Peer port number of the network connection.',
    type: 'integer',
    keys: ['network.peer.port', 'net.sock.peer.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 8080,
    deprecation: {
      replacement: 'network.peer.port',
      status: 'backfill',
    },
    aliases: ['network.peer.port'],
    changelog: [
      { version: '0.21.0', prs: [588], description: 'Added network.peer.port as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'net.transport': {
    brief: 'OSI transport layer or inter-process communication method.',
    type: 'string',
    keys: ['net.transport'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'tcp',
    examples: ['tcp'],
    deprecation: {
      replacement: 'network.transport',
      reason:
        'This attribute is being deprecated in favor of network.transport. The values change from ip_tcp and ip_udp to tcp and udp, so the old value cannot be copied over.',
    },
    aliases: ['network.transport'],
    changelog: [
      { version: '0.27.0', prs: [671], description: 'Removed the semantically distinct mcp.transport alias' },
      {
        version: '0.21.0',
        prs: [588],
        description: 'Set net.transport to _status null, because its values change on the replacement',
      },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'os.build': {
    brief: 'The build ID of the operating system.',
    type: 'string',
    keys: ['os.build_id', 'os.build'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1234567890',
    deprecation: {
      replacement: 'os.build_id',
      status: 'backfill',
    },
    aliases: ['os.build_id'],
    changelog: [
      { version: '0.5.0', prs: [301], description: 'Added os.build attribute, deprecated in favor of os.build_id' },
    ],
  },
  'os.build_id': {
    brief: 'The build ID of the operating system.',
    type: 'string',
    keys: ['os.build_id', 'os.build'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '1234567890',
    aliases: ['os.build'],
    changelog: [
      { version: '0.5.0', prs: [301], description: 'Added os.build as alias' },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
  },
  'os.description': {
    brief:
      'Human readable (not intended to be parsed) OS version information, like e.g. reported by ver or lsb_release -a commands.',
    type: 'string',
    keys: ['os.description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Ubuntu 18.04.1 LTS',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'os.kernel_version': {
    brief: 'An independent kernel version string. Typically the entire output of the `uname` syscall.',
    type: 'string',
    keys: ['os.kernel_version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '20.2.0',
    changelog: [{ version: '0.5.0', prs: [301], description: 'Added os.kernel_version attribute' }],
  },
  'os.name': {
    brief: 'Human readable operating system name.',
    type: 'string',
    keys: ['os.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Ubuntu',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'os.raw_description': {
    brief:
      'An unprocessed description string obtained by the operating system. For some well-known runtimes, Sentry will attempt to parse `name` and `version` from this string, if they are not explicitly given.',
    type: 'string',
    keys: ['os.raw_description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Ubuntu 22.04.4 LTS (Jammy Jellyfish)',
    changelog: [{ version: '0.5.0', prs: [301], description: 'Added os.raw_description attribute' }],
  },
  'os.rooted': {
    brief: 'Whether the operating system has been jailbroken or rooted.',
    type: 'boolean',
    keys: ['os.rooted'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0', prs: [301], description: 'Added os.rooted attribute' }],
  },
  'os.theme': {
    brief: 'Whether the OS runs in dark mode or light mode.',
    type: 'string',
    keys: ['os.theme'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'dark',
    changelog: [{ version: '0.5.0', prs: [301], description: 'Added os.theme attribute' }],
  },
  'os.type': {
    brief: 'The operating system type.',
    type: 'string',
    keys: ['os.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'linux',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'os.version': {
    brief: 'The version of the operating system.',
    type: 'string',
    keys: ['os.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '18.04.2',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'otel.kind': {
    brief:
      'The span kind (https://opentelemetry.io/docs/concepts/signals/traces/#span-kind). Deprecated, use `sentry.kind` instead.',
    type: 'string',
    keys: ['sentry.kind', 'span.kind', 'otel.kind'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SERVER',
    deprecation: {
      replacement: 'sentry.kind',
      reason: 'Deprecated in favor of sentry.kind',
      status: 'backfill',
    },
    aliases: ['sentry.kind'],
    changelog: [{ version: '0.13.0', prs: [440], description: 'Added otel.kind attribute' }],
  },
  'otel.scope.name': {
    brief: 'The name of the instrumentation scope - (InstrumentationScope.Name in OTLP).',
    type: 'string',
    keys: ['otel.scope.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'io.opentelemetry.contrib.mongodb',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'otel.scope.version': {
    brief: 'The version of the instrumentation scope - (InstrumentationScope.Version in OTLP).',
    type: 'string',
    keys: ['otel.scope.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '2.4.5',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'otel.status_code': {
    brief: 'Name of the code, either “OK” or “ERROR”. MUST NOT be set if the status code is UNSET.',
    type: 'string',
    keys: ['otel.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'OK',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'otel.status_description': {
    brief: 'Description of the Status if it has a value, otherwise not set.',
    type: 'string',
    keys: ['otel.status_description'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'resource not found',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'params.<key>': {
    brief:
      'Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.',
    type: 'string',
    keys: ['params.<key>', 'url.path.parameter.<key>', 'url.path.params.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "params.id='123'",
    aliases: ['url.path.parameter.<key>', 'url.path.params.<key>'],
    changelog: [
      { version: '0.21.0', prs: [586], description: 'Added url.path.params.<key> as an alias' },
      { version: '0.1.0', prs: [103] },
    ],
  },
  'performance.activationStart': {
    brief: 'The time between initiating a navigation to a page and the browser activating the page',
    type: 'double',
    keys: ['browser.performance.navigation.activation_start', 'performance.activationStart'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1.983,
    deprecation: {
      replacement: 'browser.performance.navigation.activation_start',
      reason: 'The activationStart is now recorded as the browser.performance.navigation.activation_start attribute.',
      status: 'backfill',
    },
    aliases: ['browser.performance.navigation.activation_start'],
    changelog: [{ version: '0.5.0', prs: [321], description: 'Added performance.activationStart attribute' }],
  },
  'performance.timeOrigin': {
    brief: "The browser's performance.timeOrigin timestamp representing the time when the pageload was initiated",
    type: 'double',
    keys: ['browser.performance.time_origin', 'performance.timeOrigin'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1776185678.886,
    deprecation: {
      replacement: 'browser.performance.time_origin',
      reason: 'The timeOrigin is now recorded as the browser.performance.time_origin attribute.',
      status: 'backfill',
    },
    aliases: ['browser.performance.time_origin'],
    changelog: [{ version: '0.5.0', prs: [321], description: 'Added performance.timeOrigin attribute' }],
  },
  port: {
    brief: 'The destination port for a TCP connection.',
    type: 'integer',
    keys: ['server.port', 'net.host.port', 'port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1337,
    examples: [1337],
    deprecation: {
      replacement: 'server.port',
      reason: 'Old namespace-less attribute, to be replaced with server.port for span-first future',
      status: 'backfill',
    },
    aliases: ['server.port', 'net.host.port'],
    changelog: [{ version: '0.19.0', prs: [532], description: 'Added port attribute' }],
  },
  previous_route: {
    brief: 'Also used by mobile SDKs to indicate the previous route in the application.',
    type: 'string',
    keys: ['previous_route'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'HomeScreen',
    changelog: [{ version: '0.1.0', prs: [74] }, { version: '0.0.0' }],
  },
  'process.command_args': {
    brief: 'All the command arguments (including the command/executable itself) as received by the process.',
    type: 'string[]',
    keys: ['process.command_args'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['cmd/otecol', '--config=config.yaml'],
    changelog: [{ version: '0.6.0', prs: [327], description: 'Added process.command_args attribute' }],
  },
  'process.executable.name': {
    brief: 'The name of the executable that started the process.',
    type: 'string',
    keys: ['process.executable.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'getsentry',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'process.pid': {
    brief: 'The process ID of the running process.',
    type: 'integer',
    keys: ['process.pid', 'subprocess.pid'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 12345,
    aliases: ['subprocess.pid'],
    changelog: [
      { version: '0.19.0', prs: [487], description: 'Added subprocess.pid as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
  },
  'process.runtime.description': {
    brief:
      'An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment. Equivalent to `raw_description` in the Sentry runtime context.',
    type: 'string',
    keys: ['process.runtime.description', 'runtime.raw_description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'Eclipse OpenJ9 VM openj9-0.21.0',
    aliases: ['runtime.raw_description'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'process.runtime.engine.name': {
    brief: 'The name of the runtime engine.',
    type: 'string',
    keys: ['process.runtime.engine.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'v8',
    changelog: [{ version: '0.0.0' }],
  },
  'process.runtime.engine.version': {
    brief: 'The version of the runtime engine.',
    type: 'string',
    keys: ['process.runtime.engine.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '12.9.202.13-rusty',
    changelog: [{ version: '0.0.0' }],
  },
  'process.runtime.name': {
    brief: 'The name of the runtime. Equivalent to `name` in the Sentry runtime context.',
    type: 'string',
    keys: ['process.runtime.name', 'runtime.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'node',
    aliases: ['runtime.name'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'process.runtime.version': {
    brief:
      'The version of the runtime of this process, as returned by the runtime without modification. Equivalent to `version` in the Sentry runtime context.',
    type: 'string',
    keys: ['process.runtime.version', 'runtime.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '18.04.2',
    aliases: ['runtime.version'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  profile_id: {
    brief:
      'The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.',
    type: 'string',
    keys: ['sentry.profile_id', 'profile.id', 'profile_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123e4567e89b12d3a456426614174000',
    deprecation: {
      replacement: 'sentry.profile_id',
      status: 'normalize',
    },
    aliases: ['sentry.profile_id'],
    changelog: [{ version: '0.19.0', prs: [497], description: 'Added profile_id attribute' }],
  },
  query: {
    brief: 'The database query being executed.',
    type: 'string',
    keys: ['db.query.text', 'db.statement', 'query'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SELECT * FROM users WHERE id = $1',
    examples: ['SELECT * FROM users WHERE id = $1'],
    deprecation: {
      replacement: 'db.query.text',
      reason:
        'While this attribute never specifically required parameterization, the replacement, db.query.text, does.',
      status: 'backfill',
    },
    aliases: ['db.query.text', 'db.statement'],
    changelog: [{ version: '0.19.0', prs: [530], description: 'Added query attribute' }],
  },
  'query.<key>': {
    brief: 'An item in a query string. Usually added by client-side routing frameworks like vue-router.',
    type: 'string',
    keys: ['query.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "query.id='123'",
    deprecation: {
      replacement: 'url.query',
      reason: 'Instead of sending items individually in query.<key>, they should be sent all together with url.query.',
    },
    changelog: [{ version: '0.1.0', prs: [103] }],
  },
  'react_native.architecture': {
    brief:
      'The React Native architecture the app is running on. `new` for the New Architecture, where native modules are resolved as TurboModules through `TurboModuleRegistry`, `legacy` for the Old Architecture bridge.',
    type: 'string',
    keys: ['react_native.architecture', 'turbo_module.arch'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'new',
    examples: ['new', 'legacy'],
    aliases: ['turbo_module.arch'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.architecture attribute' }],
  },
  'react_native.module.call.count': {
    brief: 'The number of native module calls observed during the lifetime of the span.',
    type: 'integer',
    keys: ['react_native.module.call.count', 'turbo_module.total_call_count', 'turbo_modules.total_call_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 42,
    examples: [42],
    aliases: ['turbo_module.total_call_count', 'turbo_modules.total_call_count'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.call.count attribute' }],
  },
  'react_native.module.call.distinct_count': {
    brief:
      'The number of distinct native module and method pairs called during the lifetime of the span. Useful as a cardinality signal when the per-method breakdown has been truncated.',
    type: 'integer',
    keys: ['react_native.module.call.distinct_count', 'turbo_module.unique_methods', 'turbo_modules.unique_methods'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 7,
    examples: [7],
    aliases: ['turbo_module.unique_methods', 'turbo_modules.unique_methods'],
    changelog: [
      { version: '0.24.0', prs: [564], description: 'Added react_native.module.call.distinct_count attribute' },
    ],
  },
  'react_native.module.duration.max': {
    brief:
      'The duration of the slowest single native module call observed during the lifetime of the span, in milliseconds.',
    type: 'double',
    keys: ['react_native.module.duration.max'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 512.5,
    examples: [512.5],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.duration.max attribute' }],
  },
  'react_native.module.duration.total': {
    brief:
      'The combined wall-clock duration of all native module calls observed during the lifetime of the span, in milliseconds. Calls overlap, so this can exceed the span duration.',
    type: 'double',
    keys: ['react_native.module.duration.total', 'turbo_module.total_duration_ms', 'turbo_modules.total_duration_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 128.45,
    examples: [128.45],
    aliases: ['turbo_module.total_duration_ms', 'turbo_modules.total_duration_ms'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.duration.total attribute' }],
  },
  'react_native.module.error.count': {
    brief:
      'The number of native module calls that failed during the lifetime of the span. A call counts as failed when it threw, rejected, or — on the Old Architecture bridge only — invoked its failure callback.',
    type: 'integer',
    keys: ['react_native.module.error.count', 'turbo_module.total_error_count', 'turbo_modules.total_error_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    examples: [2],
    aliases: ['turbo_module.total_error_count', 'turbo_modules.total_error_count'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.error.count attribute' }],
  },
  'react_native.module.kind': {
    brief:
      'Whether the native module call completed synchronously or reported completion later through a Promise or a callback. One of `sync` or `async`.',
    type: 'string',
    keys: ['react_native.module.kind'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sync',
    examples: ['sync', 'async'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.kind attribute' }],
  },
  'react_native.module.method': {
    brief: 'The name of the native module method that was called.',
    type: 'string',
    keys: ['react_native.module.method', 'turbo_module.method'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'getUniqueId',
    examples: ['getUniqueId'],
    aliases: ['turbo_module.method'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.method attribute' }],
  },
  'react_native.module.name': {
    brief:
      'The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key.',
    type: 'string',
    keys: ['react_native.module.name', 'turbo_module.name'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'RNDeviceInfo',
    examples: ['RNDeviceInfo'],
    aliases: ['turbo_module.name'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.name attribute' }],
  },
  'react_native.module.top.duration': {
    brief: 'The total duration attributed to `react_native.module.top.name`, in milliseconds.',
    type: 'double',
    keys: ['react_native.module.top.duration', 'turbo_module.top_module_duration_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 87.25,
    examples: [87.25],
    aliases: ['turbo_module.top_module_duration_ms'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.top.duration attribute' }],
  },
  'react_native.module.top.name': {
    brief:
      'The native module and method that accounted for the most total duration during the lifetime of the span, formatted as `<module>.<method>`.',
    type: 'string',
    keys: ['react_native.module.top.name', 'turbo_module.top_module'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'RNDeviceInfo.getUniqueId',
    examples: ['RNDeviceInfo.getUniqueId'],
    aliases: ['turbo_module.top_module'],
    changelog: [{ version: '0.24.0', prs: [564], description: 'Added react_native.module.top.name attribute' }],
  },
  'react.version': {
    brief: 'The version of the React framework',
    type: 'string',
    keys: ['react.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '18.2.0',
    changelog: [{ version: '0.7.0', prs: [368], description: 'Added react.version attribute' }],
  },
  'redis.command': {
    brief: 'The name of the Redis operation being executed.',
    type: 'string',
    keys: ['db.operation.name', 'cloudflare.d1.query_type', 'db.operation', 'redis.command'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SELECT',
    examples: ['SELECT'],
    deprecation: {
      replacement: 'db.operation.name',
      status: 'backfill',
    },
    aliases: ['cloudflare.d1.query_type', 'db.operation.name', 'db.operation'],
    changelog: [{ version: '0.19.0', prs: [531], description: 'Added redis.command attribute' }],
  },
  'redis.key': {
    brief: 'The key the Redis command is operating on.',
    type: 'string',
    keys: ['db.redis.key', 'redis.key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user:2047:city',
    deprecation: {
      replacement: 'db.redis.key',
      reason: 'This attribute is being deprecated in favor of db.redis.key, which is the preferred replacement.',
      status: 'backfill',
    },
    aliases: ['db.redis.key'],
    changelog: [
      { version: '0.19.0', prs: [484], description: 'Added redis.key attribute, deprecated in favor of db.redis.key' },
    ],
  },
  release: {
    brief: 'The sentry release.',
    type: 'string',
    keys: ['sentry.release', 'release', 'service.version'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'production',
    deprecation: {
      replacement: 'sentry.release',
      status: 'normalize',
    },
    aliases: ['sentry.release'],
    changelog: [
      { version: '0.19.0', prs: [497], description: 'Configured normalization' },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'remix.action_form_data.<key>': {
    brief: 'Remix form data, <key> being the form data key, the value being the form data value.',
    type: 'string',
    keys: ['remix.action_form_data.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "http.response.header.text='test'",
    changelog: [{ version: '0.1.0', prs: [103] }],
  },
  replayId: {
    brief: 'The id of the sentry replay.',
    type: 'string',
    keys: ['replayId'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123e4567e89b12d3a456426614174000',
    deprecation: {
      replacement: 'sentry.replay_id',
    },
    aliases: ['sentry.replay_id'],
    changelog: [{ version: '0.24.0', prs: [401] }],
  },
  replay_id: {
    brief: 'The id of the sentry replay.',
    type: 'string',
    keys: ['sentry.replay_id', 'replay.id', 'replay_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123e4567e89b12d3a456426614174000',
    deprecation: {
      replacement: 'sentry.replay_id',
      status: 'normalize',
    },
    aliases: ['sentry.replay_id'],
    changelog: [
      { version: '0.19.0', prs: [497], description: 'Configured normalization' },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'resource.deployment.environment': {
    brief: 'The software deployment environment name.',
    type: 'string',
    keys: [
      'sentry.environment',
      'environment',
      'resource.deployment.environment',
      'resource.deployment.environment.name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'production',
    deprecation: {
      replacement: 'sentry.environment',
      status: 'backfill',
    },
    changelog: [{ version: '0.5.0', prs: [266] }],
  },
  'resource.deployment.environment.name': {
    brief: 'The software deployment environment name.',
    type: 'string',
    keys: [
      'sentry.environment',
      'environment',
      'resource.deployment.environment',
      'resource.deployment.environment.name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'production',
    deprecation: {
      replacement: 'sentry.environment',
      status: 'backfill',
    },
    changelog: [{ version: '0.3.1', prs: [196] }],
  },
  'resource.render_blocking_status': {
    brief: 'The render blocking status of the resource.',
    type: 'string',
    keys: ['resource.render_blocking_status'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'non-blocking',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  route: {
    brief:
      'The matched route, that is, the path template in the format used by the respective server framework. Also used by mobile SDKs to indicate the current route in the application.',
    type: 'string',
    keys: ['route'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'App\\Controller::indexAction',
    deprecation: {
      replacement: 'http.route',
    },
    aliases: ['http.route'],
    changelog: [{ version: '0.1.0', prs: [61, 74] }, { version: '0.0.0' }],
  },
  'router.navigation.origin': {
    brief:
      'The origin of the navigation (usually client side router navigations). Should preferably be a parameterized template (like url.template) or a URL path otherwise.',
    type: 'string',
    keys: ['router.navigation.origin', 'navigation.origin', 'sentry.sveltekit.navigation.from'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/users/:id',
    aliases: ['navigation.origin', 'sentry.sveltekit.navigation.from'],
    changelog: [
      {
        version: '0.22.0',
        prs: [600],
        description: 'Added router.navigation.origin attribute, replacing navigation.origin',
      },
    ],
  },
  'router.navigation.route.id': {
    brief:
      'The identifier of the matched client-side route, as assigned by the routing framework (e.g., vue-router name, react-router id).',
    type: 'string',
    keys: ['router.navigation.route.id', 'navigation.route.id'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AboutView',
    aliases: ['navigation.route.id'],
    changelog: [
      {
        version: '0.22.0',
        prs: [600],
        description: 'Added router.navigation.route.id attribute, replacing navigation.route.id',
      },
    ],
  },
  'router.navigation.type': {
    brief: 'The type of navigation done by a client-side router.',
    type: 'string',
    keys: ['router.navigation.type', 'navigation.type', 'sentry.sveltekit.navigation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'router.push',
    aliases: ['navigation.type', 'sentry.sveltekit.navigation.type'],
    changelog: [
      {
        version: '0.22.0',
        prs: [600],
        description: 'Added router.navigation.type attribute, replacing navigation.type',
      },
    ],
  },
  'rpc.grpc.status_code': {
    brief: 'The numeric status code of the gRPC request.',
    type: 'integer',
    keys: ['rpc.grpc.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 2,
    deprecation: {
      replacement: 'rpc.response.status_code',
      reason:
        'Cannot be automatically backfilled due to type mismatch (integer vs string); rpc.grpc.status_code is a numeric gRPC status code while rpc.response.status_code is the string status name.',
    },
    aliases: ['code', 'rpc.response.status_code'],
    changelog: [
      {
        version: '0.19.0',
        prs: [494, 533],
        description: 'Deprecated rpc.grpc.status_code in favor of rpc.response.status_code',
      },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
  },
  'rpc.method': {
    brief: 'The fully-qualified logical name of the method from the RPC interface perspective.',
    type: 'string',
    keys: ['rpc.method', 'aws.operation_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'com.example.ExampleService/exampleMethod',
    aliases: ['aws.operation_name'],
    changelog: [
      { version: '0.19.0', prs: [536], description: 'Added aws.operation_name as an alias' },
      { version: '0.7.0', prs: [351], description: 'Added rpc.method attribute' },
    ],
  },
  'rpc.response.status_code': {
    brief: 'Status code of the RPC returned by the RPC server or generated by the client.',
    type: 'string',
    keys: ['rpc.response.status_code', 'code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'DEADLINE_EXCEEDED',
    aliases: ['code', 'rpc.grpc.status_code'],
    changelog: [
      { version: '0.19.0', prs: [494, 533], description: 'Added code and rpc.grpc.status_code as aliases' },
      { version: '0.7.0', prs: [352], description: 'Added rpc.response.status_code attribute' },
    ],
  },
  'rpc.service': {
    brief: 'The full (logical) name of the service being called, including its package name, if applicable.',
    type: 'string',
    keys: ['rpc.service'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'myService.BestService',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'rpc.system': {
    brief: 'A string identifying the remoting system.',
    type: 'string',
    keys: ['rpc.system.name', 'rpc.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'aws-api',
    deprecation: {
      replacement: 'rpc.system.name',
      reason: 'This attribute is being deprecated in favor of rpc.system.name, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['rpc.system.name'],
    changelog: [
      {
        version: '0.16.0',
        prs: [482],
        description: 'Added rpc.system attribute, deprecated in favor of rpc.system.name',
      },
    ],
  },
  'rpc.system.name': {
    brief: 'A string identifying the remoting system.',
    type: 'string',
    keys: ['rpc.system.name', 'rpc.system'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'aws-api',
    aliases: ['rpc.system'],
    changelog: [{ version: '0.16.0', prs: [482], description: 'Added rpc.system.name attribute' }],
  },
  'runtime.build': {
    brief: 'The application build string, when it is separate from the version.',
    type: 'string',
    keys: ['runtime.build'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'stable',
    deprecation: {
      reason:
        'The runtime.* namespace is deprecated in favor of process.runtime.*. No direct OTel equivalent exists for this attribute.',
    },
    changelog: [{ version: '0.11.0', prs: [383], description: 'Added and deprecated runtime.build attribute' }],
  },
  'runtime.name': {
    brief: 'The name of the runtime. For example node, CPython, or rustc.',
    type: 'string',
    keys: ['process.runtime.name', 'runtime.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'node',
    deprecation: {
      replacement: 'process.runtime.name',
      reason: 'Prefer OTel-aligned process.runtime.name',
      status: 'backfill',
    },
    aliases: ['process.runtime.name'],
    changelog: [
      {
        version: '0.11.0',
        prs: [383],
        description: 'Added and deprecated runtime.name attribute in favor of process.runtime.name',
      },
    ],
  },
  'runtime.raw_description': {
    brief:
      'Unprocessed description string as obtained from the runtime. Used to extract name and version for well-known runtimes.',
    type: 'string',
    keys: ['process.runtime.description', 'runtime.raw_description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Eclipse OpenJ9 VM openj9-0.21.0',
    deprecation: {
      replacement: 'process.runtime.description',
      reason: 'Prefer OTel-aligned process.runtime.description',
      status: 'backfill',
    },
    aliases: ['process.runtime.description'],
    changelog: [
      {
        version: '0.11.0',
        prs: [383],
        description: 'Added and deprecated runtime.raw_description attribute in favor of process.runtime.description',
      },
    ],
  },
  'runtime.version': {
    brief: 'The version of the runtime.',
    type: 'string',
    keys: ['process.runtime.version', 'runtime.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '18.04.2',
    deprecation: {
      replacement: 'process.runtime.version',
      reason: 'Prefer OTel-aligned process.runtime.version',
      status: 'backfill',
    },
    aliases: ['process.runtime.version'],
    changelog: [
      {
        version: '0.11.0',
        prs: [383],
        description: 'Added and deprecated runtime.version attribute in favor of process.runtime.version',
      },
    ],
  },
  'score.<key>': {
    brief:
      'The weighted performance score for a web vital. This is defined as `score.weight.<key>` * `score.ratio.<key>`.',
    type: 'double',
    keys: ['score.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'score.cls=0.1723',
    changelog: [{ version: '0.7.0', prs: [355], description: 'Added score.<key> attribute' }],
  },
  'score.ratio.<key>': {
    brief: 'The score for a web vital, normalized to a number between 0 and 1.',
    type: 'double',
    keys: ['score.ratio.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'score.ratio.inp=0.7748',
    changelog: [{ version: '0.7.0', prs: [355], description: 'Added score.ratio.<key> attribute' }],
  },
  'score.total': {
    brief:
      'The total performance score of a span. This is the sum of individual weighted web vital scores (see `score.<key>`).',
    type: 'double',
    keys: ['score.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    changelog: [{ version: '0.7.0', prs: [355], description: 'Added score.total attribute' }],
  },
  'score.weight.<key>': {
    brief: "The relative weight of a web vital in a span's performance score.",
    type: 'double',
    keys: ['score.weight.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: 'score.weight.fcp=0.25',
    changelog: [{ version: '0.7.0', prs: [355], description: 'Added score.weight.<key> attribute' }],
  },
  'sentry.action': {
    brief:
      'Used as a generic attribute representing the action depending on the type of span. For instance, this is the database query operation for DB spans, and the request method for HTTP spans.',
    type: 'string',
    keys: ['sentry.action', 'span.action'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SELECT',
    changelog: [{ version: '0.4.0', prs: [212] }],
    searchAlias: {
      name: 'span.action',
    },
  },
  'sentry.browser.name': {
    brief: 'The name of the browser.',
    type: 'string',
    keys: ['browser.name', 'sentry.browser.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Chrome',
    deprecation: {
      replacement: 'browser.name',
      status: 'backfill',
    },
    aliases: ['browser.name'],
    changelog: [{ version: '0.1.0', prs: [139] }],
    searchAlias: {
      name: 'browser.name',
    },
  },
  'sentry.browser.version': {
    brief: 'The version of the browser.',
    type: 'string',
    keys: ['browser.version', 'sentry.browser.version'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '120.0.6099.130',
    deprecation: {
      replacement: 'browser.version',
      status: 'backfill',
    },
    aliases: ['browser.version'],
    changelog: [{ version: '0.1.0', prs: [139] }],
  },
  'sentry.cancellation_reason': {
    brief: 'The reason why a span ended early.',
    type: 'string',
    keys: ['sentry.cancellation_reason'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'document.hidden',
    changelog: [{ version: '0.0.0' }],
  },
  'sentry.category': {
    brief:
      'The high-level category of a span, derived from the span operation or span attributes. This categorizes spans by their general purpose (e.g., database, HTTP, UI).',
    type: 'string',
    keys: ['sentry.category', 'span.category'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'db',
    changelog: [{ version: '0.4.0', prs: [218] }],
    searchAlias: {
      name: 'span.category',
    },
  },
  'sentry.client_sample_rate': {
    brief: 'Rate at which a span was sampled in the SDK.',
    type: 'double',
    keys: ['sentry.client_sample_rate', 'client_sample_rate'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    changelog: [{ version: '0.1.0', prs: [102] }],
    searchAlias: {
      name: 'client_sample_rate',
    },
  },
  'sentry.description': {
    brief: 'The human-readable description of a span.',
    type: 'string',
    keys: ['sentry.description'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'index view query',
    changelog: [{ version: '0.1.0', prs: [135] }],
  },
  'sentry.dist': {
    brief: 'The sentry dist.',
    type: 'string',
    keys: ['sentry.dist', 'dist'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1.0',
    aliases: ['dist'],
    changelog: [{ version: '0.16.0', prs: [489], description: 'Added dist as an alias' }, { version: '0.0.0' }],
  },
  'sentry.domain': {
    brief:
      'Used as a generic attribute representing the domain depending on the type of span. For instance, this is the collection/table name for database spans, and the server address for HTTP spans.',
    type: 'string',
    keys: ['sentry.domain', 'span.domain'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example.com',
    changelog: [{ version: '0.4.0', prs: [212] }],
    searchAlias: {
      name: 'span.domain',
    },
  },
  'sentry.dsc.environment': {
    brief: 'The environment from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.environment'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'prod',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.project_id': {
    brief:
      'The ID of the project where the trace originated (i.e. the project of the SDK that started the trace). Propagated through the dynamic sampling context and set by Relay during ingestion.',
    type: 'string',
    keys: ['sentry.dsc.project_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: '12345',
    changelog: [{ version: '0.7.0', prs: [358], description: 'Add sentry.dsc.project_id as an attribute' }],
  },
  'sentry.dsc.public_key': {
    brief: 'The public key from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.public_key'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'c51734c603c4430eb57cb0a5728a479d',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.release': {
    brief: 'The release identifier from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.release'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'frontend@e8211be71b214afab5b85de4b4c54be3714952bb',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.sampled': {
    brief: 'Whether the event was sampled according to the dynamic sampling context.',
    type: 'boolean',
    keys: ['sentry.dsc.sampled'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: true,
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.sample_rate': {
    brief: 'The sample rate from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.sample_rate'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: '1.0',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.trace_id': {
    brief: 'The trace ID from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.trace_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: '047372980460430cbc78d9779df33a46',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.dsc.transaction': {
    brief: 'The transaction name from the dynamic sampling context.',
    type: 'string',
    keys: ['sentry.dsc.transaction'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    example: '/issues/errors-outages/',
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.environment': {
    brief: 'The sentry environment.',
    type: 'string',
    keys: [
      'sentry.environment',
      'environment',
      'resource.deployment.environment',
      'resource.deployment.environment.name',
    ],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'production',
    aliases: ['environment'],
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'environment',
    },
  },
  'sentry.event.serialized_breadcrumbs': {
    brief: 'JSON-serialized `breadcrumbs` property from a Sentry event.',
    type: 'string',
    keys: ['sentry.event.serialized_breadcrumbs'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    changelog: [{ version: '0.19.0', prs: [556] }],
  },
  'sentry.event.serialized_contexts': {
    brief: 'JSON-serialized `contexts` property from a Sentry event.',
    type: 'string',
    keys: ['sentry.event.serialized_contexts'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    changelog: [{ version: '0.19.0', prs: [556] }],
  },
  'sentry.event.serialized_extra': {
    brief: 'JSON-serialized `extra` property from a Sentry event.',
    type: 'string',
    keys: ['sentry.event.serialized_extra'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    changelog: [{ version: '0.19.0', prs: [556] }],
  },
  'sentry.event.serialized_meta': {
    brief: 'JSON-serialized `_meta` for the `sentry.event.serialized_*` properties from a Sentry event.',
    type: 'string',
    keys: ['sentry.event.serialized_meta'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'internal',
    changelog: [{ version: '0.20.0', prs: [566] }],
  },
  'sentry.exclusive_time': {
    brief: 'The exclusive time duration of the span in milliseconds.',
    type: 'double',
    keys: ['sentry.exclusive_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.3.0', prs: [160] }, { version: '0.0.0' }],
  },
  'sentry.frames.frozen': {
    brief: 'The number of frozen frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.frozen.count', 'frames.frozen', 'mobile.frozen_frames', 'sentry.frames.frozen'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 3,
    deprecation: {
      replacement: 'app.vitals.frames.frozen.count',
      reason:
        'Replaced by app.vitals.frames.frozen.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.frozen.count', 'frames.frozen'],
    changelog: [{ version: '0.19.0', prs: [500], description: 'Added sentry.frames.frozen attribute' }],
  },
  'sentry.frames.slow': {
    brief: 'The number of slow frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.slow.count', 'frames.slow', 'mobile.slow_frames', 'sentry.frames.slow'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1,
    deprecation: {
      replacement: 'app.vitals.frames.slow.count',
      reason:
        'Replaced by app.vitals.frames.slow.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.slow.count', 'frames.slow'],
    changelog: [{ version: '0.19.0', prs: [500], description: 'Added sentry.frames.slow attribute' }],
  },
  'sentry.frames.total': {
    brief: 'The number of total frames rendered during the lifetime of the span.',
    type: 'integer',
    keys: ['app.vitals.frames.total.count', 'frames.total', 'mobile.total_frames', 'sentry.frames.total'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 60,
    deprecation: {
      replacement: 'app.vitals.frames.total.count',
      reason:
        'Replaced by app.vitals.frames.total.count to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.frames.total.count', 'frames.total'],
    changelog: [{ version: '0.19.0', prs: [500], description: 'Added sentry.frames.total attribute' }],
  },
  'sentry.graphql.operation': {
    brief: 'Indicates the type of graphql operation, emitted by the Javascript SDK.',
    type: 'string',
    keys: ['sentry.graphql.operation'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'getUserById',
    changelog: [{ version: '0.3.1', prs: [190] }],
  },
  'sentry.group': {
    brief:
      'Stores the hash of `sentry.normalized_description`. This is primarily used for grouping spans in the product end.',
    type: 'string',
    keys: ['sentry.group', 'span.group'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    changelog: [{ version: '0.4.0', prs: [212] }],
    searchAlias: {
      name: 'span.group',
    },
  },
  'sentry.http.prefetch': {
    brief: 'If an http request was a prefetch request.',
    type: 'boolean',
    keys: ['sentry.http.prefetch'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'sentry.idle_span_finish_reason': {
    brief: 'The reason why an idle span ended early.',
    type: 'string',
    keys: ['sentry.idle_span_finish_reason'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'idleTimeout',
    changelog: [{ version: '0.0.0' }],
  },
  'sentry.is_localhost': {
    brief: 'Indicates whether a telemetry item was sent on a host, device or browser on a localhost URL or IP address.',
    type: 'boolean',
    keys: ['sentry.is_localhost'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'internal',
    example: true,
    examples: [true, false],
    changelog: [{ version: '0.24.0', prs: [646], description: 'Added sentry.is_localhost attribute' }],
    additionalContext: [
      'This attribute is used for the Sentry "Filter telemetry from localhost" inbound filter feature.',
      'SDKs must set this attribute on every span, as well as every other telemetry item supporting attribuztes.',
    ],
  },
  'sentry.is_remote': {
    brief: "Indicates whether a span's parent is remote.",
    type: 'boolean',
    keys: ['sentry.is_remote'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.3.1', prs: [190] }],
  },
  'sentry.kind': {
    brief:
      'Used to clarify the relationship between parents and children, or to distinguish between spans, e.g. a `server` and `client` span with the same name.',
    type: 'string',
    keys: ['sentry.kind', 'span.kind', 'otel.kind'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'client',
    examples: ['client', 'server', 'producer', 'consumer', 'internal'],
    aliases: ['otel.kind'],
    changelog: [
      { version: '0.19.0', prs: [517], description: 'Added more examples and additional_context to the attribute' },
      { version: '0.3.1', prs: [190] },
    ],
    additionalContext: ['Valid attribute values are: "client", "server", "producer", "consumer" and "internal"'],
    searchAlias: {
      name: 'span.kind',
    },
  },
  'sentry.link.type': {
    brief: 'Set on a span link. Describes the relationship between the span and the linked span.',
    type: 'string',
    keys: ['sentry.link.type', 'link.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'previous_trace',
    examples: ['previous_trace', 'next_trace', 'cache_origin'],
    changelog: [
      { version: '0.27.0', prs: [687], description: 'Added search alias link.type' },
      { version: '0.25.0', prs: [656], description: 'Added sentry.link.type attribute' },
    ],
    additionalContext: [
      'This attribute is exclusively set on span links.',
      'Sentry instrumentation setting span links, sets it to describe the relationship between the span and the linked span.',
      'For known values, see Examples. Add new values to Examples.',
    ],
    searchAlias: {
      name: 'link.type',
    },
  },
  'sentry.main_thread': {
    brief: 'Whether the span or event occurred on the main thread. Computed by Relay and should not be set by SDKs.',
    type: 'boolean',
    keys: ['sentry.main_thread'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0' }],
  },
  'sentry.message.parameter.<key>': {
    brief:
      "A parameter used in the message template. <key> can either be the number that represent the parameter's position in the template string (sentry.message.parameter.0, sentry.message.parameter.1, etc) or the parameter's name (sentry.message.parameter.item_id, sentry.message.parameter.user_id, etc)",
    type: 'string',
    keys: ['sentry.message.parameter.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: "sentry.message.parameter.0='123'",
    changelog: [{ version: '0.1.0', prs: [116] }],
  },
  'sentry.message.template': {
    brief: 'The parameterized template string.',
    type: 'string',
    keys: ['sentry.message.template'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Hello, {name}!',
    changelog: [{ version: '0.1.0', prs: [116] }],
  },
  'sentry.metric.source': {
    brief:
      'The provenance of a metric.  For example, this can be set to indicate if a metric was generated by Relay from a span.',
    type: 'string',
    keys: ['sentry.metric.source'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'span',
    changelog: [{ version: '0.16.0', prs: [476], description: 'Added sentry.metric.source attribute' }],
  },
  'sentry.mobile': {
    brief: 'Whether the application is using a mobile SDK. Computed by Relay and should not be set by SDKs.',
    type: 'boolean',
    keys: ['sentry.mobile'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.5.0' }],
  },
  'sentry.module.<key>': {
    brief: 'A module that was loaded in the process. The key is the name of the module.',
    type: 'string',
    keys: ['sentry.module.<key>'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "sentry.module.brianium/paratest='v7.7.0'",
    changelog: [{ version: '0.1.0', prs: [103] }],
  },
  'sentry.nextjs.ssr.function.route': {
    brief:
      'A parameterized route for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions when the file location of the function is known.',
    type: 'string',
    keys: ['sentry.nextjs.ssr.function.route'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/posts/[id]/layout',
    changelog: [{ version: '0.1.0', prs: [54, 106] }],
  },
  'sentry.nextjs.ssr.function.type': {
    brief:
      'A descriptor for a for a function in Next.js that contributes to Server-Side Rendering. Should be present on spans that track such functions.',
    type: 'string',
    keys: ['sentry.nextjs.ssr.function.type'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'generateMetadata',
    changelog: [{ version: '0.1.0', prs: [54, 106] }],
  },
  'sentry.normalized_db_query': {
    brief: 'The normalized version of `db.query.text`.',
    type: 'string',
    keys: ['sentry.normalized_db_query'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SELECT .. FROM sentry_project WHERE (project_id = %s)',
    changelog: [{ version: '0.3.1', prs: [194] }],
  },
  'sentry.normalized_db_query.hash': {
    brief: 'The hash of `sentry.normalized_db_query`.',
    type: 'string',
    keys: ['sentry.normalized_db_query.hash'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    changelog: [{ version: '0.4.0', prs: [200] }],
  },
  'sentry.normalized_description': {
    brief:
      'Used as a generic attribute representing the normalized `sentry.description`. This refers to the legacy use case of `sentry.description` where it holds relevant data depending on the type of span (e.g. database query, resource url, http request description, etc).',
    type: 'string',
    keys: ['sentry.normalized_description'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'SELECT .. FROM sentry_project WHERE (project_id = %s)',
    changelog: [{ version: '0.4.0', prs: [212] }],
  },
  'sentry.observed_timestamp_nanos': {
    brief: 'The timestamp at which an envelope was received by Relay, in nanoseconds.',
    type: 'string',
    keys: ['sentry.observed_timestamp_nanos'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1544712660300000000',
    changelog: [
      { version: '0.3.0', prs: [174] },
      { version: '0.2.0', prs: [137] },
    ],
  },
  'sentry.op': {
    brief: 'The operation of a span.',
    type: 'string',
    keys: ['sentry.op', 'span.op'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'http.client',
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'span.op',
    },
  },
  'sentry.origin': {
    brief: 'The origin of the instrumentation (e.g. span, log, etc.)',
    type: 'string',
    keys: ['sentry.origin', 'origin'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'auto.http.otel.fastify',
    changelog: [{ version: '0.1.0', prs: [68] }, { version: '0.0.0' }],
    searchAlias: {
      name: 'origin',
    },
  },
  'sentry.pageload.span_id': {
    brief: 'The id of the pageload span, set by web vital spans and metrics',
    type: 'string',
    keys: ['sentry.pageload.span_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'bf2c8d3df84524de',
    changelog: [{ version: '0.17.0', prs: [495], description: 'Added sentry.pageload.span_id attribute' }],
  },
  'sentry.platform': {
    brief: 'The sdk platform that generated the event.',
    type: 'string',
    keys: ['sentry.platform', 'platform'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'php',
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'platform',
    },
  },
  'sentry.profiler_id': {
    brief: 'The id of the currently running profiler (continuous profiling)',
    type: 'string',
    keys: ['sentry.profiler_id', 'profiler.id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '18779b64dd35d1a538e7ce2dd2d3fad3',
    changelog: [{ version: '0.4.0', prs: [242] }],
    searchAlias: {
      name: 'profiler.id',
    },
  },
  'sentry.profile_id': {
    brief:
      'The ID of the Sentry profile the span is associated with. This is only meaningful for transaction-based profiling.',
    type: 'string',
    keys: ['sentry.profile_id', 'profile.id', 'profile_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123e4567e89b12d3a456426614174000',
    aliases: ['profile_id'],
    changelog: [
      { version: '0.19.0', prs: [497], description: 'Added profile_id as an alias' },
      { version: '0.6.0', prs: [344], description: 'Added sentry.profile_id attribute' },
    ],
    searchAlias: {
      name: 'profile.id',
    },
  },
  'sentry.relay.ingress': {
    brief: 'How an item (span, log, &c.) entered Relay.',
    type: 'string',
    keys: ['sentry.relay.ingress'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'OTEL',
    changelog: [{ version: '0.17.0', prs: [491], description: 'Added sentry.relay.ingress attribute' }],
  },
  'sentry.relay.pipeline': {
    brief: 'An internal descriptor of which processing pipeline an item went through in Relay.',
    type: 'string',
    keys: ['sentry.relay.pipeline'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'span v2',
    changelog: [{ version: '0.17.0', prs: [491], description: 'Added sentry.relay.pipeline attribute' }],
  },
  'sentry.release': {
    brief: 'The sentry release.',
    type: 'string',
    keys: ['sentry.release', 'release', 'service.version'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '7.0.0',
    aliases: ['service.version', 'release'],
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'release',
    },
  },
  'sentry.replay_id': {
    brief: 'The id of the sentry replay.',
    type: 'string',
    keys: ['sentry.replay_id', 'replay.id', 'replay_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '123e4567e89b12d3a456426614174000',
    aliases: ['replay_id', 'replayId'],
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'replay.id',
      deprecatedAliases: ['replay_id'],
    },
  },
  'sentry.replay_is_buffering': {
    brief:
      'A sentinel attribute on log events indicating whether the current Session Replay is being buffered (onErrorSampleRate).',
    type: 'boolean',
    keys: ['sentry.replay_is_buffering'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.3.0', prs: [185] }],
  },
  'sentry.report_event': {
    brief: '(Deprecated) The event that caused the SDK to report CLS or LCP (pagehide or navigation)',
    type: 'string',
    keys: ['sentry.report_event'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'pagehide',
    deprecation: {
      reason:
        'The report event moved to browser.web_vital.lcp.report_event and browser.web_vital.cls.report_event, which are themselves deprecated without a replacement. No backfill required.',
    },
    changelog: [
      {
        version: '0.24.0',
        prs: [642],
        description:
          'Updated the deprecation reason now that the browser.web_vital.*.report_event attributes are deprecated',
      },
      { version: '0.5.0', prs: [320], description: 'Added sentry.report_event attribute' },
    ],
  },
  'sentry.sdk.integrations': {
    brief:
      'A list of names identifying enabled integrations. The list shouldhave all enabled integrations, including default integrations. Defaultintegrations are included because different SDK releases may contain differentdefault integrations.',
    type: 'string[]',
    keys: ['sentry.sdk.integrations'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['InboundFilters', 'FunctionToString', 'BrowserApiErrors', 'Breadcrumbs'],
    changelog: [{ version: '0.0.0', prs: [42] }],
  },
  'sentry.sdk.name': {
    brief: 'The sentry sdk name.',
    type: 'string',
    keys: ['sentry.sdk.name', 'sdk.name'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '@sentry/react',
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'sdk.name',
    },
  },
  'sentry.sdk.version': {
    brief: 'The sentry sdk version.',
    type: 'string',
    keys: ['sentry.sdk.version', 'sdk.version'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '7.0.0',
    changelog: [{ version: '0.0.0' }],
    searchAlias: {
      name: 'sdk.version',
    },
  },
  'sentry.segment.id': {
    brief: 'The segment ID of a span',
    type: 'string',
    keys: ['sentry.segment.id', 'sentry.segment_id', 'transaction.span_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '051581bf3cb55c13',
    aliases: ['sentry.segment_id'],
    changelog: [{ version: '0.1.0', prs: [107, 124] }],
  },
  'sentry.segment_id': {
    brief: 'The segment ID of a span',
    type: 'string',
    keys: ['sentry.segment.id', 'sentry.segment_id', 'transaction.span_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: '051581bf3cb55c13',
    deprecation: {
      replacement: 'sentry.segment.id',
      status: 'backfill',
    },
    aliases: ['sentry.segment.id'],
    changelog: [{ version: '0.1.0', prs: [124] }],
    searchAlias: {
      name: 'transaction.span_id',
    },
  },
  'sentry.segment.name': {
    brief: 'The segment name of a span',
    type: 'string',
    keys: ['sentry.segment.name', 'transaction', 'sentry.transaction'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET /user',
    aliases: ['sentry.transaction', 'transaction'],
    changelog: [
      { version: '0.6.0', prs: [345], description: 'Added sentry.transaction and transaction aliases' },
      { version: '0.1.0', prs: [104] },
    ],
    searchAlias: {
      name: 'transaction',
    },
  },
  'sentry.segment.name.source': {
    brief: 'The source of the segment span name. Should only be set on segment spans.',
    type: 'string',
    keys: ['sentry.segment.name.source'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'internal',
    example: 'route',
    examples: ['route', 'component', 'view', 'task', 'custom', 'url'],
    changelog: [{ version: '0.19.0', prs: [466], description: 'Added sentry.segment.name.source' }],
    additionalContext: [
      'This attribute is the replacement for `transaction_info.source` on transactions.',
      'Should we bring back clustering for segment names (like we do for transaction names), this attribute will be used to determine if a segment name should be clustered.',
    ],
  },
  'sentry.server_sample_rate': {
    brief: 'Rate at which a span was sampled in Relay.',
    type: 'double',
    keys: ['sentry.server_sample_rate', 'server_sample_rate'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0.5,
    changelog: [{ version: '0.1.0', prs: [102] }],
    searchAlias: {
      name: 'server_sample_rate',
    },
  },
  'sentry.source': {
    brief: 'The source of a span, also referred to as transaction source.',
    type: 'string',
    keys: ['sentry.source'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'route',
    deprecation: {
      reason:
        'This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans.',
    },
    changelog: [
      { version: '0.19.0', prs: [510], description: 'Removed the sentry.span.source replacement' },
      { version: '0.5.0' },
    ],
  },
  'sentry.span.source': {
    brief: 'The source of a span, also referred to as transaction source.',
    type: 'string',
    keys: ['sentry.span.source'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'route',
    deprecation: {
      reason:
        'This attribute is superseded by sentry.segment.name.source, which only needs to be set on segment spans.',
    },
    changelog: [
      {
        version: '0.19.0',
        prs: [510],
        description: 'Deprecated; superseded by sentry.segment.name.source on segment spans',
      },
      { version: '0.4.0', prs: [214] },
      { version: '0.0.0' },
    ],
  },
  'sentry.status': {
    brief:
      'The span\'s status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.',
    type: 'string',
    keys: ['sentry.status', 'span.status'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'ok',
    changelog: [{ version: '0.14.0', prs: [453] }],
    searchAlias: {
      name: 'span.status',
    },
  },
  'sentry.status_code': {
    brief:
      'The HTTP status code used in Sentry Insights. Typically set by Sentry during ingestion, rather than by clients.',
    type: 'integer',
    keys: ['sentry.status_code', 'span.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 200,
    changelog: [{ version: '0.4.0', prs: [223, 228] }],
    searchAlias: {
      name: 'span.status_code',
    },
  },
  'sentry.status.message': {
    brief: 'The from OTLP extracted status message.',
    type: 'string',
    keys: ['sentry.status.message', 'span.status.message'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'foobar',
    changelog: [{ version: '0.3.1', prs: [190] }],
    searchAlias: {
      name: 'span.status.message',
    },
  },
  'sentry.sveltekit.navigation.from': {
    brief: 'the navigation origin (sveltekit router)',
    type: 'string',
    keys: ['router.navigation.origin', 'navigation.origin', 'sentry.sveltekit.navigation.from'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/home',
    deprecation: {
      replacement: 'router.navigation.origin',
      reason: 'Use the more generic attribute instead',
      status: 'backfill',
    },
    aliases: ['navigation.origin', 'router.navigation.origin'],
    changelog: [
      {
        version: '0.22.0',
        prs: [600],
        description: 'Re-pointed deprecation from navigation.origin to router.navigation.origin',
      },
      { version: '0.16.0', prs: [467], description: 'Added sentry.sveltekit.navigation.from attribute' },
    ],
  },
  'sentry.sveltekit.navigation.to': {
    brief: 'the navigation destination',
    type: 'string',
    keys: ['sentry.sveltekit.navigation.to'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/users/:id',
    deprecation: {
      reason: 'the navigation destination is already covered by url.* attributes',
    },
    changelog: [{ version: '0.16.0', prs: [467], description: 'Added sentry.sveltekit.navigation.to attribute' }],
  },
  'sentry.sveltekit.navigation.type': {
    brief: 'The type of navigation event emitted from the sveltekit client router',
    type: 'string',
    keys: ['router.navigation.type', 'navigation.type', 'sentry.sveltekit.navigation.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'link',
    deprecation: {
      replacement: 'router.navigation.type',
      reason: 'Use the more generic attribute instead',
      status: 'backfill',
    },
    aliases: ['navigation.type', 'router.navigation.type'],
    changelog: [
      {
        version: '0.22.0',
        prs: [600],
        description: 'Re-pointed deprecation from navigation.type to router.navigation.type',
      },
      { version: '0.16.0', prs: [467], description: 'Added sentry.sveltekit.navigation.type attribute' },
    ],
  },
  'sentry.thread.id': {
    brief: 'Current "managed" thread ID.',
    type: 'integer',
    keys: ['thread.id', 'sentry.thread.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 56,
    deprecation: {
      replacement: 'thread.id',
      reason: 'This attribute is being deprecated in favor of the OTel-standard thread.id',
      status: 'backfill',
    },
    changelog: [{ version: '0.13.0', prs: [451] }],
    searchAlias: {
      name: 'thread.id',
    },
  },
  'sentry.timestamp.sequence': {
    brief:
      'A sequencing counter for deterministic ordering of logs or metrics when timestamps share the same integer millisecond. Starts at 0 on SDK initialization, increments by 1 for each captured item, and resets to 0 when the integer millisecond of the current item differs from the previous one.',
    type: 'integer',
    keys: ['sentry.timestamp.sequence'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 0,
    changelog: [{ version: '0.5.0', prs: [262] }],
  },
  'sentry.trace_lifecycle': {
    brief: 'Indicates the chosen trace lifecycle mode of the SDK (stream or static)',
    type: 'string',
    keys: ['sentry.trace_lifecycle', 'trace_lifecycle'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'stream',
    changelog: [{ version: '0.13.0', prs: [442], description: 'Added sentry.trace_lifecycle attribute' }],
    searchAlias: {
      name: 'trace_lifecycle',
    },
  },
  'sentry.trace.parent_span_id': {
    brief:
      'The span id of the span that was active when the log was collected. This should not be set if there was no active span.',
    type: 'string',
    keys: ['sentry.trace.parent_span_id'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'b0e6f15b45c36b12',
    deprecation: {},
    changelog: [
      { version: '0.5.0', prs: [287], description: 'Deprecate `sentry.trace.parent_span_id`' },
      { version: '0.1.0', prs: [116] },
    ],
  },
  'sentry.trace.status': {
    brief:
      'The segment\'s status (either "ok" or "error"). Older SDKs may set this to a more specific error, but this behaviour is deprecated.',
    type: 'string',
    keys: ['sentry.trace.status', 'trace.status'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'ok',
    changelog: [{ version: '0.14.0', prs: [453] }],
    searchAlias: {
      name: 'trace.status',
    },
  },
  'sentry.transaction': {
    brief: 'The sentry transaction (segment name).',
    type: 'string',
    keys: ['sentry.segment.name', 'transaction', 'sentry.transaction'],
    applyScrubbing: {
      key: 'never',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET /',
    deprecation: {
      replacement: 'sentry.segment.name',
      reason: 'This attribute is being deprecated in favor of sentry.segment.name',
      status: 'backfill',
    },
    aliases: ['sentry.segment.name', 'transaction'],
    changelog: [
      { version: '0.6.0', prs: [345], description: 'Deprecated sentry.transaction in favor of sentry.segment.name' },
      { version: '0.0.0' },
    ],
  },
  'sentry.user.email': {
    brief: 'User email address.',
    type: 'string',
    keys: ['user.email', 'sentry.user.email'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.email',
      status: 'backfill',
    },
    aliases: ['user.email'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.email',
    },
  },
  'sentry.user.geo.city': {
    brief: 'Human readable city name.',
    type: 'string',
    keys: ['user.geo.city', 'sentry.user.geo.city'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.geo.city',
      status: 'backfill',
    },
    aliases: ['user.geo.city'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.geo.city',
    },
  },
  'sentry.user.geo.country_code': {
    brief: 'Two-letter country code (ISO 3166-1 alpha-2).',
    type: 'string',
    keys: ['user.geo.country_code', 'sentry.user.geo.country_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.geo.country_code',
      status: 'backfill',
    },
    aliases: ['user.geo.country_code'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.geo.country_code',
    },
  },
  'sentry.user.geo.region': {
    brief: 'Human readable region name or code.',
    type: 'string',
    keys: ['user.geo.region', 'sentry.user.geo.region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.geo.region',
      status: 'backfill',
    },
    aliases: ['user.geo.region'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.geo.region',
    },
  },
  'sentry.user.geo.subdivision': {
    brief: 'Human readable subdivision name.',
    type: 'string',
    keys: ['user.geo.subdivision', 'sentry.user.geo.subdivision'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.geo.subdivision',
      status: 'backfill',
    },
    aliases: ['user.geo.subdivision'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.geo.subdivision',
    },
  },
  'sentry.user.id': {
    brief: 'Unique identifier of the user.',
    type: 'string',
    keys: ['user.id', 'sentry.user.id'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.id',
      status: 'backfill',
    },
    aliases: ['user.id'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.id',
    },
  },
  'sentry.user.ip': {
    brief: 'The IP address of the user.',
    type: 'string',
    keys: ['user.ip_address', 'sentry.user.ip', 'user.ip'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.ip_address',
      status: 'backfill',
    },
    aliases: ['user.ip_address'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.ip',
    },
  },
  'sentry.user.username': {
    brief: 'Short name or login/username of the user.',
    type: 'string',
    keys: ['user.name', 'sentry.user.username', 'user.username'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'user.name',
      status: 'backfill',
    },
    aliases: ['user.name'],
    changelog: [{ version: '0.10.0', prs: [406] }],
    searchAlias: {
      name: 'user.username',
    },
  },
  'server.address': {
    brief:
      'Preferably the server domain name if available without reverse DNS lookup, or an IP address or Unix domain socket name. For compatibility, it may contain what the hostname command returns on UNIX systems, the fully qualified hostname, or another name specified by the user.',
    type: 'string',
    keys: ['server.address', 'address', 'http.server_name', 'net.host.name', 'server_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    aliases: ['address', 'http.server_name', 'net.host.name', 'http.host', 'server_name', 'net.peer.name'],
    changelog: [
      { version: '0.24.0', prs: [645, 647], description: 'Broaden brief to allow hostnames' },
      { version: '0.21.0', prs: [588, 602], description: 'Added net.peer.name as an alias' },
      { version: '0.19.0', prs: [534], description: 'Added address as an alias' },
      { version: '0.1.0', prs: [108, 127] },
      { version: '0.0.0' },
    ],
  },
  server_name: {
    brief: 'The name of the device. On servers and desktops, this is typically the hostname.',
    type: 'string',
    keys: ['server.address', 'address', 'http.server_name', 'net.host.name', 'server_name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'example.com',
    deprecation: {
      replacement: 'server.address',
      reason: 'This attribute is being deprecated in favor of server.address.',
      status: 'backfill',
    },
    aliases: ['address', 'server.address', 'http.server_name', 'net.host.name', 'http.host', 'net.peer.name'],
    changelog: [
      { version: '0.24.0', prs: [647], description: 'Alias the server.address alias group' },
      {
        version: '0.21.0',
        prs: [588, 602],
        description: 'Alias device.name instead of the server.address alias group',
      },
      { version: '0.19.0', prs: [534], description: 'Added address as an alias' },
      {
        version: '0.16.0',
        prs: [477],
        description: 'Added server_name attribute, deprecated in favor of server.address',
      },
    ],
  },
  'server.port': {
    brief: 'Server port number.',
    type: 'integer',
    keys: ['server.port', 'net.host.port', 'port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1337,
    aliases: ['net.host.port', 'port'],
    changelog: [
      { version: '0.19.0', prs: [532], description: 'Added port as an alias' },
      { version: '0.4.0', prs: [228] },
      { version: '0.0.0' },
    ],
  },
  'service.name': {
    brief: 'Logical name of the service.',
    type: 'string',
    keys: ['service.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'omegastar',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'service.version': {
    brief: 'The version string of the service API or implementation. The format is not defined by these conventions.',
    type: 'string',
    keys: ['service.version', 'sentry.release', 'release'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '5.0.0',
    aliases: ['sentry.release'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'session.id': {
    brief: 'A unique id identifying the active session at the time of setting this attribute',
    type: 'string',
    keys: ['session.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '00112233-4455-6677-8899-aabbccddeeff',
    changelog: [{ version: '0.11.0', prs: [412], description: 'Added session.id attribute' }],
  },
  stall_percentage: {
    brief: 'The fraction of time the app was stalled. Only applies to React Native. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.stall.percentage', 'stall_percentage'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'app.vitals.stall.percentage',
      reason:
        'Replaced by app.vitals.stall.percentage to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.stall.percentage'],
    changelog: [
      { version: '0.19.0', prs: [493], description: 'Deprecated in favor of app.vitals.stall.percentage' },
      { version: '0.7.0', prs: [362], description: 'Added stall_percentage attribute' },
    ],
  },
  stall_total_time: {
    brief:
      'The combined duration of all stalls in milliseconds. Only applies to React Native. This is computed by Relay.',
    type: 'double',
    keys: ['app.vitals.stall.duration', 'stall_total_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    deprecation: {
      replacement: 'app.vitals.stall.duration',
      reason:
        'Replaced by app.vitals.stall.duration to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.stall.duration'],
    changelog: [
      { version: '0.19.0', prs: [493], description: 'Deprecated in favor of app.vitals.stall.duration' },
      { version: '0.7.0', prs: [362], description: 'Added stall_total_time attribute' },
    ],
  },
  'starlette.middleware_name': {
    brief: 'The name of the Starlette middleware.',
    type: 'string',
    keys: [
      'middleware.name',
      'django.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
      'starlite.middleware_name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AuthenticationMiddleware',
    deprecation: {
      replacement: 'middleware.name',
      reason:
        'This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['middleware.name'],
    changelog: [
      {
        version: '0.19.0',
        prs: [485],
        description: 'Added starlette.middleware_name attribute, deprecated in favor of middleware.name',
      },
    ],
  },
  'starlite.middleware_name': {
    brief: 'The name of the Starlite middleware.',
    type: 'string',
    keys: [
      'middleware.name',
      'django.middleware_name',
      'litestar.middleware_name',
      'starlette.middleware_name',
      'starlite.middleware_name',
    ],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'AuthenticationMiddleware',
    examples: ['AuthenticationMiddleware'],
    deprecation: {
      replacement: 'middleware.name',
      reason:
        'This attribute is being deprecated in favor of middleware.name, which is the framework-agnostic replacement.',
      status: 'backfill',
    },
    aliases: ['middleware.name'],
    changelog: [{ version: '0.19.0', prs: [519], description: 'Added starlite.middleware_name attribute' }],
  },
  'state.type': {
    brief: 'The type of state management library',
    type: 'string',
    keys: ['state.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'redux',
    changelog: [{ version: '0.7.0', prs: [365], description: 'Added state.type attribute' }],
  },
  'subprocess.pid': {
    brief: 'The process ID of a subprocess.',
    type: 'integer',
    keys: ['process.pid', 'subprocess.pid'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 12345,
    deprecation: {
      replacement: 'process.pid',
      reason: 'This attribute is being deprecated in favor of process.pid, which is the OTel-aligned replacement.',
      status: 'backfill',
    },
    aliases: ['process.pid'],
    changelog: [
      {
        version: '0.19.0',
        prs: [487],
        description: 'Added subprocess.pid attribute, deprecated in favor of process.pid',
      },
    ],
  },
  'sveltekit.load.environment': {
    brief:
      "The runtime environment in which the SvelteKit load function was executed. Known values are `'server'` and `'client'`.",
    type: 'string',
    keys: ['sveltekit.load.environment'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'server',
    examples: ['server', 'client'],
    changelog: [{ version: '0.22.0', prs: [611], description: 'Added sveltekit.load.environment attribute' }],
    additionalContext: [
      'Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry.',
    ],
  },
  'sveltekit.load.node_id': {
    brief: 'The path to the SvelteKit load function.',
    type: 'string',
    keys: ['sveltekit.load.node_id', 'code.file.path', 'code.filepath'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'src/routes/users/:id/+page.server.ts',
    examples: ['src/routes/users/:id/+page.server.ts'],
    aliases: ['code.file.path', 'code.filepath'],
    changelog: [{ version: '0.22.0', prs: [611], description: 'Added sveltekit.load.node_id attribute' }],
    additionalContext: [
      'Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry.',
    ],
  },
  'sveltekit.load.node_type': {
    brief:
      'The kind of SvelteKit load function that was executed, distinguishing page from layout and universal from server load functions.',
    type: 'string',
    keys: ['sveltekit.load.node_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '+page.server',
    examples: ['+page.server', '+layout', '+layout.server'],
    changelog: [{ version: '0.22.0', prs: [611], description: 'Added sveltekit.load.node_type attribute' }],
    additionalContext: [
      'Added by the SvelteKit framework itself. The Sentry SDK only forwards the attribute to Sentry.',
    ],
  },
  'sveltekit.tracing.original_name': {
    brief: 'The original span name as emitted by SvelteKit.',
    type: 'string',
    keys: ['sveltekit.tracing.original_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sveltekit.handle.root',
    examples: ['sveltekit.handle.root'],
    changelog: [{ version: '0.22.0', prs: [611], description: 'Added sveltekit.tracing.original_name attribute' }],
    additionalContext: [
      "The Sentry SDK renames SvelteKit-emitted spans to match Sentry's span name semantics, and preserves the name SvelteKit originally set in this attribute.",
    ],
  },
  'thread.id': {
    brief: 'Current “managed” thread ID.',
    type: 'integer',
    keys: ['thread.id', 'sentry.thread.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 56,
    changelog: [{ version: '0.0.0' }],
  },
  'thread.name': {
    brief: 'Current thread name.',
    type: 'string',
    keys: ['thread.name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'main',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'timber.tag': {
    brief: 'The log tag provided by the timber logging framework.',
    type: 'string',
    keys: ['timber.tag'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'MyTag',
    changelog: [{ version: '0.3.0', prs: [183] }],
  },
  time_to_full_display: {
    brief: 'The duration of time to full display in milliseconds',
    type: 'double',
    keys: ['app.vitals.ttfd.value', 'time_to_full_display'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    deprecation: {
      replacement: 'app.vitals.ttfd.value',
      reason:
        'Replaced by app.vitals.ttfd.value to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.ttfd.value'],
    changelog: [
      { version: '0.5.0', prs: [313], description: 'Added and deprecated in favor of app.vitals.ttfd.value' },
    ],
  },
  time_to_initial_display: {
    brief: 'The duration of time to initial display in milliseconds',
    type: 'double',
    keys: ['app.vitals.ttid.value', 'time_to_initial_display'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1234.56,
    deprecation: {
      replacement: 'app.vitals.ttid.value',
      reason:
        'Replaced by app.vitals.ttid.value to align with the app.vitals.* namespace for mobile performance attributes',
      status: 'backfill',
    },
    aliases: ['app.vitals.ttid.value'],
    changelog: [
      { version: '0.5.0', prs: [313], description: 'Added and deprecated in favor of app.vitals.ttid.value' },
    ],
  },
  transaction: {
    brief: 'The sentry transaction (segment name).',
    type: 'string',
    keys: ['sentry.segment.name', 'transaction', 'sentry.transaction'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET /',
    deprecation: {
      replacement: 'sentry.segment.name',
      status: 'normalize',
    },
    aliases: ['sentry.segment.name', 'sentry.transaction'],
    changelog: [
      { version: '0.19.0', prs: [497], description: 'Change deprecation from backfill to normalize' },
      {
        version: '0.6.0',
        prs: [345],
        description: 'Updated transaction deprecation replacement to sentry.segment.name',
      },
      { version: '0.1.0', prs: [61, 127] },
      { version: '0.0.0' },
    ],
  },
  'trpc.procedure_path': {
    brief: 'The path of the tRPC procedure being called',
    type: 'string',
    keys: ['trpc.procedure_path'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'user.getById',
    changelog: [{ version: '0.7.0', prs: [370], description: 'Added trpc.procedure_path attribute' }],
  },
  'trpc.procedure_type': {
    brief: 'The type of the tRPC procedure',
    type: 'string',
    keys: ['trpc.procedure_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'query',
    changelog: [{ version: '0.7.0', prs: [370], description: 'Added trpc.procedure_type attribute' }],
  },
  ttfb: {
    brief: 'The value of the recorded Time To First Byte (TTFB) web vital in milliseconds',
    type: 'double',
    keys: ['browser.web_vital.ttfb.value', 'ttfb'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 194,
    deprecation: {
      replacement: 'browser.web_vital.ttfb.value',
      reason: 'This attribute is being deprecated in favor of browser.web_vital.ttfb.value',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.ttfb.value'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'ttfb.requestTime': {
    brief:
      "The time it takes for the server to process the initial request and send the first byte of a response to the user's browser",
    type: 'double',
    keys: ['browser.web_vital.ttfb.request_time', 'ttfb.requestTime'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1554.5814,
    deprecation: {
      replacement: 'browser.web_vital.ttfb.request_time',
      reason: 'This attribute is being deprecated in favor of browser.web_vital.ttfb.request_time',
      status: 'backfill',
    },
    aliases: ['browser.web_vital.ttfb.request_time'],
    changelog: [{ version: '0.5.0', prs: [235] }],
  },
  'turbo_modules.total_call_count': {
    brief: 'The number of native module calls in the flushed call aggregate. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.call.count', 'turbo_module.total_call_count', 'turbo_modules.total_call_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 42,
    examples: [42],
    deprecation: {
      replacement: 'react_native.module.call.count',
      reason:
        'Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix',
      status: 'backfill',
    },
    aliases: ['react_native.module.call.count', 'turbo_module.total_call_count'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_modules.total_call_count and deprecated it in favor of react_native.module.call.count',
      },
    ],
  },
  'turbo_modules.total_duration_ms': {
    brief:
      'The combined duration of all native module calls in the flushed call aggregate, in milliseconds. Only applies to React Native.',
    type: 'double',
    keys: ['react_native.module.duration.total', 'turbo_module.total_duration_ms', 'turbo_modules.total_duration_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 128.45,
    examples: [128.45],
    deprecation: {
      replacement: 'react_native.module.duration.total',
      reason:
        'Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix',
      status: 'backfill',
    },
    aliases: ['react_native.module.duration.total', 'turbo_module.total_duration_ms'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_modules.total_duration_ms and deprecated it in favor of react_native.module.duration.total',
      },
    ],
  },
  'turbo_modules.total_error_count': {
    brief: 'The number of failed native module calls in the flushed call aggregate. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.error.count', 'turbo_module.total_error_count', 'turbo_modules.total_error_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    examples: [2],
    deprecation: {
      replacement: 'react_native.module.error.count',
      reason:
        'Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix',
      status: 'backfill',
    },
    aliases: ['react_native.module.error.count', 'turbo_module.total_error_count'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_modules.total_error_count and deprecated it in favor of react_native.module.error.count',
      },
    ],
  },
  'turbo_modules.unique_methods': {
    brief:
      'The number of distinct native module and method pairs in the flushed call aggregate. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.call.distinct_count', 'turbo_module.unique_methods', 'turbo_modules.unique_methods'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 7,
    examples: [7],
    deprecation: {
      replacement: 'react_native.module.call.distinct_count',
      reason:
        'Replaced by the `react_native.module.*` namespace; the SDK emitted the same values under both a singular `turbo_module.*` and a plural `turbo_modules.*` prefix',
      status: 'backfill',
    },
    aliases: ['react_native.module.call.distinct_count', 'turbo_module.unique_methods'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_modules.unique_methods and deprecated it in favor of react_native.module.call.distinct_count',
      },
    ],
  },
  'turbo_module.arch': {
    brief:
      'The React Native architecture the call was observed on. `new` for a TurboModule resolved through `TurboModuleRegistry`, `legacy` for a module reached over the Old Architecture bridge. Only applies to React Native.',
    type: 'string',
    keys: ['react_native.architecture', 'turbo_module.arch'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'new',
    examples: ['new', 'legacy'],
    deprecation: {
      replacement: 'react_native.architecture',
      reason:
        'Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules',
      status: 'backfill',
    },
    aliases: ['react_native.architecture'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description: 'Added turbo_module.arch and deprecated it in favor of react_native.architecture',
      },
    ],
  },
  'turbo_module.method': {
    brief: 'The name of the native module method that was called. Only applies to React Native.',
    type: 'string',
    keys: ['react_native.module.method', 'turbo_module.method'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'getUniqueId',
    examples: ['getUniqueId'],
    deprecation: {
      replacement: 'react_native.module.method',
      reason:
        'Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules',
      status: 'backfill',
    },
    aliases: ['react_native.module.method'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description: 'Added turbo_module.method and deprecated it in favor of react_native.module.method',
      },
    ],
  },
  'turbo_module.name': {
    brief:
      'The name of the native module the call was dispatched to. On the New Architecture this is the TurboModule name, on the Old Architecture the `NativeModules` key. Only applies to React Native.',
    type: 'string',
    keys: ['react_native.module.name', 'turbo_module.name'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'RNDeviceInfo',
    examples: ['RNDeviceInfo'],
    deprecation: {
      replacement: 'react_native.module.name',
      reason:
        'Replaced by the `react_native.*` namespace, which also covers native module calls made over the Old Architecture bridge, which are not TurboModules',
      status: 'backfill',
    },
    aliases: ['react_native.module.name'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description: 'Added turbo_module.name and deprecated it in favor of react_native.module.name',
      },
    ],
  },
  'turbo_module.top_module': {
    brief:
      'The native module and method that accounted for the most total duration during the lifetime of the span. Only applies to React Native.',
    type: 'string',
    keys: ['react_native.module.top.name', 'turbo_module.top_module'],
    applyScrubbing: {
      key: 'manual',
      reason:
        'Native module and method names are app-defined identifiers, but scrubbing them would make the call attribution unusable',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'RNDeviceInfo.getUniqueId',
    examples: ['RNDeviceInfo.getUniqueId'],
    deprecation: {
      replacement: 'react_native.module.top.name',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.top.name'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description: 'Added turbo_module.top_module and deprecated it in favor of react_native.module.top.name',
      },
    ],
  },
  'turbo_module.top_module_duration_ms': {
    brief:
      'The total duration attributed to the top native module method, in milliseconds. Only applies to React Native.',
    type: 'double',
    keys: ['react_native.module.top.duration', 'turbo_module.top_module_duration_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 87.25,
    examples: [87.25],
    deprecation: {
      replacement: 'react_native.module.top.duration',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.top.duration'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_module.top_module_duration_ms and deprecated it in favor of react_native.module.top.duration',
      },
    ],
  },
  'turbo_module.total_call_count': {
    brief: 'The number of native module calls observed during the lifetime of the span. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.call.count', 'turbo_module.total_call_count', 'turbo_modules.total_call_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 42,
    examples: [42],
    deprecation: {
      replacement: 'react_native.module.call.count',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.call.count', 'turbo_modules.total_call_count'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description: 'Added turbo_module.total_call_count and deprecated it in favor of react_native.module.call.count',
      },
    ],
  },
  'turbo_module.total_duration_ms': {
    brief:
      'The combined duration of all native module calls observed during the lifetime of the span, in milliseconds. Only applies to React Native.',
    type: 'double',
    keys: ['react_native.module.duration.total', 'turbo_module.total_duration_ms', 'turbo_modules.total_duration_ms'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 128.45,
    examples: [128.45],
    deprecation: {
      replacement: 'react_native.module.duration.total',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.duration.total', 'turbo_modules.total_duration_ms'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_module.total_duration_ms and deprecated it in favor of react_native.module.duration.total',
      },
    ],
  },
  'turbo_module.total_error_count': {
    brief:
      'The number of native module calls that failed during the lifetime of the span. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.error.count', 'turbo_module.total_error_count', 'turbo_modules.total_error_count'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 2,
    examples: [2],
    deprecation: {
      replacement: 'react_native.module.error.count',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.error.count', 'turbo_modules.total_error_count'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_module.total_error_count and deprecated it in favor of react_native.module.error.count',
      },
    ],
  },
  'turbo_module.unique_methods': {
    brief:
      'The number of distinct native module and method pairs called during the lifetime of the span. Only applies to React Native.',
    type: 'integer',
    keys: ['react_native.module.call.distinct_count', 'turbo_module.unique_methods', 'turbo_modules.unique_methods'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 7,
    examples: [7],
    deprecation: {
      replacement: 'react_native.module.call.distinct_count',
      reason:
        'Replaced by the `react_native.module.*` namespace, which also covers native module calls made over the Old Architecture bridge, and which drops the `total_` prefix and `_ms` suffix in favor of dot-separated logical grouping',
      status: 'backfill',
    },
    aliases: ['react_native.module.call.distinct_count', 'turbo_modules.unique_methods'],
    changelog: [
      {
        version: '0.24.0',
        prs: [564],
        description:
          'Added turbo_module.unique_methods and deprecated it in favor of react_native.module.call.distinct_count',
      },
    ],
  },
  type: {
    brief: 'More granular type of the operation happening.',
    type: 'string',
    keys: ['type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'fetch',
    changelog: [{ version: '0.0.0' }],
  },
  'ui.component_name': {
    brief: 'The name of the associated component.',
    type: 'string',
    keys: ['ui.component_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'HomeButton',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'ui.contributes_to_ttfd': {
    brief: 'Whether the span execution contributed to the TTFD (time to fully drawn) metric.',
    type: 'boolean',
    keys: ['ui.contributes_to_ttfd'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'ui.contributes_to_ttid': {
    brief: 'Whether the span execution contributed to the TTID (time to initial display) metric.',
    type: 'boolean',
    keys: ['ui.contributes_to_ttid'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    changelog: [{ version: '0.0.0' }],
  },
  'ui.element.height': {
    brief: 'The height of the UI element (for Html in pixels)',
    type: 'integer',
    keys: ['ui.element.height'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 256,
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.height attribute' }],
  },
  'ui.element.id': {
    brief: 'The id of the UI element',
    type: 'string',
    keys: ['ui.element.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'btn-login',
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.id attribute' }],
  },
  'ui.element.identifier': {
    brief: 'The identifier used to measure the UI element timing',
    type: 'string',
    keys: ['ui.element.identifier'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'heroImage',
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.identifier attribute' }],
  },
  'ui.element.load_time': {
    brief: 'The loading time of a UI element (from time origin to finished loading)',
    type: 'double',
    keys: ['ui.element.load_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 998.2234,
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.load_time attribute' }],
  },
  'ui.element.paint_type': {
    brief: "The type of element paint. Can either be 'image-paint' or 'text-paint'",
    type: 'string',
    keys: ['ui.element.paint_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'image-paint',
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.paint_type attribute' }],
  },
  'ui.element.render_time': {
    brief: 'The rendering time of the UI element (from time origin to finished rendering)',
    type: 'double',
    keys: ['ui.element.render_time'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1023.1124,
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.render_time attribute' }],
  },
  'ui.element.type': {
    brief: 'type of the UI element',
    type: 'string',
    keys: ['ui.element.type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'img',
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.type attribute' }],
  },
  'ui.element.url': {
    brief: 'The URL of the UI element (e.g. an img src)',
    type: 'string',
    keys: ['ui.element.url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://assets.myapp.com/hero.png',
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.url attribute' }],
  },
  'ui.element.width': {
    brief: 'The width of the UI element (for HTML in pixels)',
    type: 'integer',
    keys: ['ui.element.width'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 512,
    changelog: [{ version: '0.5.0', prs: [284], description: 'Added ui.element.width attribute' }],
  },
  url: {
    brief: 'The URL of the resource that was fetched.',
    type: 'string',
    keys: ['url.full', 'aws.request.url', 'http.url', 'messaging.url', 'url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://example.com/test?foo=bar#buzz',
    deprecation: {
      replacement: 'url.full',
      status: 'backfill',
    },
    aliases: ['url.full', 'http.url', 'aws.request.url', 'messaging.url'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.url as an alias' },
      { version: '0.1.0', prs: [61] },
      { version: '0.0.0' },
    ],
  },
  'url.domain': {
    brief:
      'Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.',
    type: 'string',
    keys: ['url.domain'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'example.com',
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'url.fragment': {
    brief:
      'The fragments present in the URI. Note that this does not contain the leading # character, while the `http.fragment` attribute does.',
    type: 'string',
    keys: ['url.fragment'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'details',
    changelog: [{ version: '0.0.0' }],
  },
  'url.full': {
    brief: 'The URL of the resource that was fetched.',
    type: 'string',
    keys: ['url.full', 'aws.request.url', 'http.url', 'messaging.url', 'url'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'https://example.com/test?foo=bar#buzz',
    aliases: ['http.url', 'url', 'aws.request.url', 'messaging.url'],
    changelog: [
      { version: '0.21.0', prs: [581], description: 'Added messaging.url as an alias' },
      { version: '0.19.0', prs: [488], description: 'Added aws.request.url as an alias' },
      { version: '0.1.0', prs: [108] },
      { version: '0.0.0' },
    ],
  },
  'url.path': {
    brief: 'The URI path component.',
    type: 'string',
    keys: ['url.path'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/foo',
    changelog: [{ version: '0.0.0' }],
  },
  'url.path.parameter.<key>': {
    brief:
      'Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.',
    type: 'string',
    keys: ['url.path.parameter.<key>', 'params.<key>', 'url.path.params.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "url.path.parameter.id='123'",
    aliases: ['params.<key>', 'url.path.params.<key>'],
    changelog: [
      { version: '0.21.0', prs: [586], description: 'Added url.path.params.<key> as an alias' },
      { version: '0.1.0', prs: [103] },
    ],
  },
  'url.path.params.<key>': {
    brief:
      'Decoded parameters extracted from a URL path. Usually added by client-side routing frameworks like vue-router.',
    type: 'string',
    keys: ['url.path.parameter.<key>', 'params.<key>', 'url.path.params.<key>'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "url.path.params.id='123'",
    examples: ["url.path.params.id='123'"],
    deprecation: {
      replacement: 'url.path.parameter.<key>',
      reason: 'This attribute is being deprecated in favor of url.path.parameter.<key>.',
      status: 'backfill',
    },
    aliases: ['url.path.parameter.<key>', 'params.<key>'],
    changelog: [{ version: '0.21.0', prs: [586], description: 'Added url.path.params.<key> attribute' }],
  },
  'url.port': {
    brief: 'Server port number.',
    type: 'integer',
    keys: ['url.port'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 1337,
    changelog: [{ version: '0.4.0', prs: [228] }, { version: '0.0.0' }],
  },
  'url.query': {
    brief:
      'The query string present in the URL. Note that this does not contain the leading ? character, while the `http.query` attribute does.',
    type: 'string',
    keys: ['url.query'],
    applyScrubbing: {
      key: 'auto',
      reason:
        'Query string values can contain sensitive information. Clients should attempt to scrub parameters that might contain sensitive information.',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'foo=bar&bar=baz',
    changelog: [{ version: '0.0.0' }],
  },
  'url.same_origin': {
    brief: "Indicates that a URL has the same origin as the current page's origin in the browser.",
    type: 'boolean',
    keys: ['http.request.same_origin', 'url.same_origin'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: true,
    deprecation: {
      replacement: 'http.request.same_origin',
      reason: 'This attribute is being deprecated in favor of http.request.same_origin.',
      status: 'backfill',
    },
    aliases: ['http.request.same_origin'],
    changelog: [
      {
        version: '0.16.0',
        prs: [456],
        description: 'Added url.same_origin attribute, deprecated in favor of http.request.same_origin',
      },
    ],
  },
  'url.scheme': {
    brief: 'The URI scheme component identifying the used protocol.',
    type: 'string',
    keys: ['url.scheme', 'http.scheme'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'https',
    aliases: ['http.scheme'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'url.template': {
    brief: 'The low-cardinality template of an absolute URL path reference.',
    type: 'string',
    keys: ['url.template'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example: '/users/{id}',
    examples: ['/users/{id}', '/users/:id', '/about'],
    changelog: [
      {
        version: '0.19.0',
        prs: [505, 521],
        description: 'Added multiple examples, removed alias to `http.route`, added additional context',
      },
      { version: '0.1.0', prs: [127] },
      { version: '0.0.0' },
    ],
    additionalContext: [
      'This attribute should primarily be set by client-side routing instrumentation, or `http.client` spans (if applicable).',
      'Use `http.route` for server-side instrumentation that captures the framework route of an incoming request.',
    ],
  },
  'user_agent.original': {
    brief: 'Value of the HTTP User-Agent header sent by the client.',
    type: 'string',
    keys: ['user_agent.original', 'http.user_agent'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: true,
    visibility: 'public',
    example:
      'Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1',
    aliases: ['http.user_agent'],
    changelog: [{ version: '0.1.0', prs: [127] }, { version: '0.0.0' }],
  },
  'user.email': {
    brief: 'User email address.',
    type: 'string',
    keys: ['user.email', 'sentry.user.email'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'test@example.com',
    aliases: ['sentry.user.email'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.full_name': {
    brief: "User's full name.",
    type: 'string',
    keys: ['user.full_name'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'John Smith',
    changelog: [{ version: '0.0.0' }],
  },
  'user.geo.city': {
    brief: 'Human readable city name.',
    type: 'string',
    keys: ['user.geo.city', 'sentry.user.geo.city'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Toronto',
    aliases: ['sentry.user.geo.city'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.geo.country_code': {
    brief: 'Two-letter country code (ISO 3166-1 alpha-2).',
    type: 'string',
    keys: ['user.geo.country_code', 'sentry.user.geo.country_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'CA',
    aliases: ['sentry.user.geo.country_code'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.geo.region': {
    brief: 'Human readable region name or code.',
    type: 'string',
    keys: ['user.geo.region', 'sentry.user.geo.region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Canada',
    aliases: ['sentry.user.geo.region'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.geo.subdivision': {
    brief: 'Human readable subdivision name.',
    type: 'string',
    keys: ['user.geo.subdivision', 'sentry.user.geo.subdivision'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'Ontario',
    aliases: ['sentry.user.geo.subdivision'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.hash': {
    brief: 'Unique user hash to correlate information for a user in anonymized form.',
    type: 'string',
    keys: ['user.hash'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: '8ae4c2993e0f4f3b8b2d1b1f3b5e8f4d',
    changelog: [{ version: '0.0.0' }],
  },
  'user.id': {
    brief: 'Unique identifier of the user.',
    type: 'string',
    keys: ['user.id', 'sentry.user.id'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'S-1-5-21-202424912787-2692429404-2351956786-1000',
    aliases: ['sentry.user.id'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.ip_address': {
    brief: 'The IP address of the user.',
    type: 'string',
    keys: ['user.ip_address', 'sentry.user.ip', 'user.ip'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '192.168.1.1',
    aliases: ['sentry.user.ip'],
    changelog: [{ version: '0.1.0', prs: [75] }],
  },
  'user.name': {
    brief: 'Short name or login/username of the user.',
    type: 'string',
    keys: ['user.name', 'sentry.user.username', 'user.username'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: 'j.smith',
    aliases: ['sentry.user.username'],
    changelog: [{ version: '0.0.0' }],
  },
  'user.roles': {
    brief: 'Array of user roles at the time of the event.',
    type: 'string[]',
    keys: ['user.roles'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: true,
    visibility: 'public',
    example: ['admin', 'editor'],
    changelog: [{ version: '0.0.0' }],
  },
  'vercel.ai.telemetry.metadata.<key>': {
    brief:
      'Metadata passed to a Vercel AI SDK call through `experimental_telemetry.metadata`, with <key> being the metadata key name.',
    type: 'string',
    keys: ['vercel.ai.telemetry.metadata.<key>'],
    applyScrubbing: {
      key: 'auto',
      reason: 'Metadata is user-defined and can contain user data',
    },
    isInOtel: false,
    visibility: 'public',
    hasDynamicSuffix: true,
    example: "vercel.ai.telemetry.metadata.tenantId='acme'",
    examples: ["vercel.ai.telemetry.metadata.tenantId='acme'"],
    changelog: [{ version: '0.26.0', prs: [662], description: 'Added vercel.ai.telemetry.metadata.<key> attribute' }],
    additionalContext: [
      'Set on `gen_ai` spans for `invoke_agent`, `generate_content` and `embeddings` operations. Not set on `execute_tool` spans.',
      "The Vercel AI SDK's own OpenTelemetry spans emit the same data as `ai.telemetry.metadata.<key>`.",
      'The Vercel AI SDK also allows numbers, booleans and arrays as metadata values. SDKs MUST convert these values to strings.',
      'This attribute is open-ended on purpose. The Vercel AI SDK does not define the metadata keys. If Vercel defines a stricter spec for this metadata, consider moving it into `gen_ai.*` attributes.',
    ],
  },
  'vercel.branch': {
    brief: 'Git branch name for Vercel project',
    type: 'string',
    keys: ['vercel.branch'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'main',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.build_id': {
    brief: 'Identifier for the Vercel build (only present on build logs)',
    type: 'string',
    keys: ['vercel.build_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'bld_cotnkcr76',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.deployment_id': {
    brief: 'Identifier for the Vercel deployment',
    type: 'string',
    keys: ['vercel.deployment_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'dpl_233NRGRjVZX1caZrXWtz5g1TAksD',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.destination': {
    brief: 'Origin of the external content in Vercel (only on external logs)',
    type: 'string',
    keys: ['vercel.destination'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https://vitals.vercel-insights.com/v1',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.edge_type': {
    brief: 'Type of edge runtime in Vercel',
    type: 'string',
    keys: ['vercel.edge_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'edge-function',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.entrypoint': {
    brief: 'Entrypoint for the request in Vercel',
    type: 'string',
    keys: ['vercel.entrypoint'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'api/index.js',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.execution_region': {
    brief: 'Region where the request is executed',
    type: 'string',
    keys: ['vercel.execution_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sfo1',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.id': {
    brief: 'Unique identifier for the log entry in Vercel',
    type: 'string',
    keys: ['vercel.id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '1573817187330377061717300000',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.ja3_digest': {
    brief: 'JA3 fingerprint digest of Vercel request',
    type: 'string',
    keys: ['vercel.ja3_digest'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '769,47-53-5-10-49161-49162-49171-49172-50-56-19-4,0-10-11,23-24-25,0',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.ja4_digest': {
    brief: 'JA4 fingerprint digest',
    type: 'string',
    keys: ['vercel.ja4_digest'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: 't13d1516h2_8daaf6152771_02713d6af862',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.log_type': {
    brief: 'Vercel log output type',
    type: 'string',
    keys: ['vercel.log_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'stdout',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.path': {
    brief: 'Function or dynamic path of the request in Vercel.',
    type: 'string',
    keys: ['vercel.path'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/dynamic/[route].json',
    changelog: [{ version: '0.6.0', prs: [349], description: 'Added vercel.path attribute' }],
  },
  'vercel.project_id': {
    brief: 'Identifier for the Vercel project',
    type: 'string',
    keys: ['vercel.project_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'gdufoJxB6b9b1fEqr1jUtFkyavUU',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.project_name': {
    brief: 'Name of the Vercel project',
    type: 'string',
    keys: ['vercel.project_name'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'my-app',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.cache_id': {
    brief: 'Original request ID when request is served from cache',
    type: 'string',
    keys: ['vercel.proxy.cache_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'pdx1::v8g4b-1744143786684-93dafbc0f70d',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.client_ip': {
    brief: 'Client IP address',
    type: 'string',
    keys: ['vercel.proxy.client_ip'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '120.75.16.101',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.host': {
    brief: 'Hostname of the request',
    type: 'string',
    keys: ['vercel.proxy.host'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'test.vercel.app',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.lambda_region': {
    brief: 'Region where lambda function executed',
    type: 'string',
    keys: ['vercel.proxy.lambda_region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sfo1',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.method': {
    brief: 'HTTP method of the request',
    type: 'string',
    keys: ['vercel.proxy.method'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'GET',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.path': {
    brief: 'Request path with query parameters',
    type: 'string',
    keys: ['vercel.proxy.path'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '/dynamic/some-value.json?route=some-value',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.path_type': {
    brief: 'How the request was served based on its path and project configuration',
    type: 'string',
    keys: ['vercel.proxy.path_type'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'func',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.path_type_variant': {
    brief: 'Variant of the path type',
    type: 'string',
    keys: ['vercel.proxy.path_type_variant'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'api',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.referer': {
    brief: 'Referer of the request',
    type: 'string',
    keys: ['vercel.proxy.referer'],
    applyScrubbing: {
      key: 'auto',
    },
    isInOtel: false,
    visibility: 'public',
    example: '*.vercel.app',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.region': {
    brief: 'Region where the request is processed',
    type: 'string',
    keys: ['vercel.proxy.region'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sfo1',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.response_byte_size': {
    brief: 'Size of the response in bytes',
    type: 'integer',
    keys: ['vercel.proxy.response_byte_size'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1024,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.2.0', prs: [163] },
    ],
  },
  'vercel.proxy.scheme': {
    brief: 'Protocol of the request',
    type: 'string',
    keys: ['vercel.proxy.scheme'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'https',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.status_code': {
    brief: 'HTTP status code of the proxy request',
    type: 'integer',
    keys: ['vercel.proxy.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 200,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.2.0', prs: [163] },
    ],
  },
  'vercel.proxy.timestamp': {
    brief: 'Unix timestamp when the proxy request was made',
    type: 'integer',
    keys: ['vercel.proxy.timestamp'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 1573817250172,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.2.0', prs: [163] },
    ],
  },
  'vercel.proxy.user_agent': {
    brief: 'User agent strings of the request',
    type: 'string[]',
    keys: ['vercel.proxy.user_agent'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: ['Mozilla/5.0...'],
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.vercel_cache': {
    brief: 'Cache status sent to the browser',
    type: 'string',
    keys: ['vercel.proxy.vercel_cache'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'REVALIDATED',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.vercel_id': {
    brief: 'Vercel-specific identifier',
    type: 'string',
    keys: ['vercel.proxy.vercel_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'sfo1::abc123',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.waf_action': {
    brief: 'Action taken by firewall rules',
    type: 'string',
    keys: ['vercel.proxy.waf_action'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'deny',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.proxy.waf_rule_id': {
    brief: 'ID of the firewall rule that matched',
    type: 'string',
    keys: ['vercel.proxy.waf_rule_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'rule_gAHz8jtSB1Gy',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.request_id': {
    brief: 'Identifier of the Vercel request',
    type: 'string',
    keys: ['vercel.request_id'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: '643af4e3-975a-4cc7-9e7a-1eda11539d90',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.source': {
    brief: 'Origin of the Vercel log (build, edge, lambda, static, external, or firewall)',
    type: 'string',
    keys: ['vercel.source'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 'build',
    changelog: [{ version: '0.2.0', prs: [163] }],
  },
  'vercel.status_code': {
    brief: 'HTTP status code of the request (-1 means no response returned and the lambda crashed)',
    type: 'integer',
    keys: ['vercel.status_code'],
    applyScrubbing: {
      key: 'manual',
    },
    isInOtel: false,
    visibility: 'public',
    example: 200,
    changelog: [
      { version: '0.4.0', prs: [228] },
      { version: '0.2.0', prs: [163] },
    ],
  },
};

export type AttributeValue = string | number | boolean | Array<string> | Array<number> | Array<boolean>;

export type Attributes = {
  [ADDRESS]?: ADDRESS_TYPE;
  [AI_CITATIONS]?: AI_CITATIONS_TYPE;
  [AI_COMPLETION_TOKENS_USED]?: AI_COMPLETION_TOKENS_USED_TYPE;
  [AI_DOCUMENTS]?: AI_DOCUMENTS_TYPE;
  [AI_FINISH_REASON]?: AI_FINISH_REASON_TYPE;
  [AI_FREQUENCY_PENALTY]?: AI_FREQUENCY_PENALTY_TYPE;
  [AI_FUNCTION_CALL]?: AI_FUNCTION_CALL_TYPE;
  [AI_GENERATION_ID]?: AI_GENERATION_ID_TYPE;
  [AI_INPUT_MESSAGES]?: AI_INPUT_MESSAGES_TYPE;
  [AI_IS_SEARCH_REQUIRED]?: AI_IS_SEARCH_REQUIRED_TYPE;
  [AI_METADATA]?: AI_METADATA_TYPE;
  [AI_MODEL_ID]?: AI_MODEL_ID_TYPE;
  [_AI_MODEL_ID]?: _AI_MODEL_ID_TYPE;
  [AI_MODEL_PROVIDER]?: AI_MODEL_PROVIDER_TYPE;
  [AI_PIPELINE_NAME]?: AI_PIPELINE_NAME_TYPE;
  [AI_PREAMBLE]?: AI_PREAMBLE_TYPE;
  [AI_PRESENCE_PENALTY]?: AI_PRESENCE_PENALTY_TYPE;
  [AI_PROMPT]?: AI_PROMPT_TYPE;
  [AI_PROMPT_MESSAGES]?: AI_PROMPT_MESSAGES_TYPE;
  [AI_PROMPT_TOKENS_USED]?: AI_PROMPT_TOKENS_USED_TYPE;
  [AI_PROMPT_TOOLS]?: AI_PROMPT_TOOLS_TYPE;
  [AI_RAW_PROMPTING]?: AI_RAW_PROMPTING_TYPE;
  [AI_RESPONSES]?: AI_RESPONSES_TYPE;
  [AI_RESPONSE_FORMAT]?: AI_RESPONSE_FORMAT_TYPE;
  [AI_RESPONSE_ID]?: AI_RESPONSE_ID_TYPE;
  [AI_RESPONSE_MODEL]?: AI_RESPONSE_MODEL_TYPE;
  [AI_RESPONSE_OBJECT]?: AI_RESPONSE_OBJECT_TYPE;
  [AI_RESPONSE_TEXT]?: AI_RESPONSE_TEXT_TYPE;
  [AI_RESPONSE_TIMESTAMP]?: AI_RESPONSE_TIMESTAMP_TYPE;
  [AI_RESPONSE_TOOLCALLS]?: AI_RESPONSE_TOOLCALLS_TYPE;
  [AI_SCHEMA]?: AI_SCHEMA_TYPE;
  [AI_SEARCH_QUERIES]?: AI_SEARCH_QUERIES_TYPE;
  [AI_SEARCH_RESULTS]?: AI_SEARCH_RESULTS_TYPE;
  [AI_SEED]?: AI_SEED_TYPE;
  [AI_STREAMING]?: AI_STREAMING_TYPE;
  [AI_TAGS]?: AI_TAGS_TYPE;
  [AI_TEMPERATURE]?: AI_TEMPERATURE_TYPE;
  [AI_TEXTS]?: AI_TEXTS_TYPE;
  [AI_TOOLCALL_ARGS]?: AI_TOOLCALL_ARGS_TYPE;
  [AI_TOOLCALL_RESULT]?: AI_TOOLCALL_RESULT_TYPE;
  [AI_TOOLS]?: AI_TOOLS_TYPE;
  [AI_TOOL_CALLS]?: AI_TOOL_CALLS_TYPE;
  [AI_TOP_K]?: AI_TOP_K_TYPE;
  [AI_TOP_P]?: AI_TOP_P_TYPE;
  [AI_TOTAL_COST]?: AI_TOTAL_COST_TYPE;
  [AI_TOTAL_TOKENS_USED]?: AI_TOTAL_TOKENS_USED_TYPE;
  [AI_USAGE_TOKENS]?: AI_USAGE_TOKENS_TYPE;
  [AI_VALUES]?: AI_VALUES_TYPE;
  [AI_WARNINGS]?: AI_WARNINGS_TYPE;
  [ANGULAR_VERSION]?: ANGULAR_VERSION_TYPE;
  [ANTHROPIC_TOOL_RESULT_CONTENT]?: ANTHROPIC_TOOL_RESULT_CONTENT_TYPE;
  [APP_APP_BUILD]?: APP_APP_BUILD_TYPE;
  [APP_APP_IDENTIFIER]?: APP_APP_IDENTIFIER_TYPE;
  [APP_APP_NAME]?: APP_APP_NAME_TYPE;
  [APP_APP_START_TIME]?: APP_APP_START_TIME_TYPE;
  [APP_APP_VERSION]?: APP_APP_VERSION_TYPE;
  [APP_BUILD]?: APP_BUILD_TYPE;
  [APP_IDENTIFIER]?: APP_IDENTIFIER_TYPE;
  [APP_IN_FOREGROUND]?: APP_IN_FOREGROUND_TYPE;
  [APP_NAME]?: APP_NAME_TYPE;
  [APP_START_COLD]?: APP_START_COLD_TYPE;
  [APP_START_TIME]?: APP_START_TIME_TYPE;
  [APP_START_TYPE]?: APP_START_TYPE_TYPE;
  [APP_START_WARM]?: APP_START_WARM_TYPE;
  [APP_VERSION]?: APP_VERSION_TYPE;
  [APP_VITALS_FRAMES_DELAY_VALUE]?: APP_VITALS_FRAMES_DELAY_VALUE_TYPE;
  [APP_VITALS_FRAMES_FROZEN_COUNT]?: APP_VITALS_FRAMES_FROZEN_COUNT_TYPE;
  [APP_VITALS_FRAMES_FROZEN_RATE]?: APP_VITALS_FRAMES_FROZEN_RATE_TYPE;
  [APP_VITALS_FRAMES_SLOW_COUNT]?: APP_VITALS_FRAMES_SLOW_COUNT_TYPE;
  [APP_VITALS_FRAMES_SLOW_RATE]?: APP_VITALS_FRAMES_SLOW_RATE_TYPE;
  [APP_VITALS_FRAMES_TOTAL_COUNT]?: APP_VITALS_FRAMES_TOTAL_COUNT_TYPE;
  [APP_VITALS_STALL_DURATION]?: APP_VITALS_STALL_DURATION_TYPE;
  [APP_VITALS_STALL_PERCENTAGE]?: APP_VITALS_STALL_PERCENTAGE_TYPE;
  [APP_VITALS_START_COLD_VALUE]?: APP_VITALS_START_COLD_VALUE_TYPE;
  [APP_VITALS_START_PREWARMED]?: APP_VITALS_START_PREWARMED_TYPE;
  [APP_VITALS_START_REASON]?: APP_VITALS_START_REASON_TYPE;
  [APP_VITALS_START_SCREEN]?: APP_VITALS_START_SCREEN_TYPE;
  [APP_VITALS_START_TYPE]?: APP_VITALS_START_TYPE_TYPE;
  [APP_VITALS_START_WARM_VALUE]?: APP_VITALS_START_WARM_VALUE_TYPE;
  [APP_VITALS_TTFD_VALUE]?: APP_VITALS_TTFD_VALUE_TYPE;
  [APP_VITALS_TTID_VALUE]?: APP_VITALS_TTID_VALUE_TYPE;
  [ART_GC_BLOCKING_COUNT]?: ART_GC_BLOCKING_COUNT_TYPE;
  [ART_GC_BLOCKING_TIME]?: ART_GC_BLOCKING_TIME_TYPE;
  [ART_GC_PRE_OOME_COUNT]?: ART_GC_PRE_OOME_COUNT_TYPE;
  [ART_GC_TOTAL_COUNT]?: ART_GC_TOTAL_COUNT_TYPE;
  [ART_GC_TOTAL_TIME]?: ART_GC_TOTAL_TIME_TYPE;
  [ART_GC_WAITING_TIME]?: ART_GC_WAITING_TIME_TYPE;
  [ART_MEMORY_FREE]?: ART_MEMORY_FREE_TYPE;
  [ART_MEMORY_FREE_UNTIL_GC]?: ART_MEMORY_FREE_UNTIL_GC_TYPE;
  [ART_MEMORY_FREE_UNTIL_OOME]?: ART_MEMORY_FREE_UNTIL_OOME_TYPE;
  [ART_MEMORY_MAX]?: ART_MEMORY_MAX_TYPE;
  [ART_MEMORY_TOTAL]?: ART_MEMORY_TOTAL_TYPE;
  [AWS_CLOUDWATCH_LOGS_LOG_GROUP]?: AWS_CLOUDWATCH_LOGS_LOG_GROUP_TYPE;
  [AWS_CLOUDWATCH_LOGS_LOG_STREAM]?: AWS_CLOUDWATCH_LOGS_LOG_STREAM_TYPE;
  [AWS_CLOUDWATCH_LOGS_URL]?: AWS_CLOUDWATCH_LOGS_URL_TYPE;
  [AWS_DYNAMODB_ATTRIBUTES_TO_GET]?: AWS_DYNAMODB_ATTRIBUTES_TO_GET_TYPE;
  [AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS]?: AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS_TYPE;
  [AWS_DYNAMODB_CONSISTENT_READ]?: AWS_DYNAMODB_CONSISTENT_READ_TYPE;
  [AWS_DYNAMODB_CONSUMED_CAPACITY]?: AWS_DYNAMODB_CONSUMED_CAPACITY_TYPE;
  [AWS_DYNAMODB_COUNT]?: AWS_DYNAMODB_COUNT_TYPE;
  [AWS_DYNAMODB_EXCLUSIVE_START_TABLE]?: AWS_DYNAMODB_EXCLUSIVE_START_TABLE_TYPE;
  [AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES]?: AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES_TYPE;
  [AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES]?: AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES_TYPE;
  [AWS_DYNAMODB_INDEX_NAME]?: AWS_DYNAMODB_INDEX_NAME_TYPE;
  [AWS_DYNAMODB_ITEM_COLLECTION_METRICS]?: AWS_DYNAMODB_ITEM_COLLECTION_METRICS_TYPE;
  [AWS_DYNAMODB_LIMIT]?: AWS_DYNAMODB_LIMIT_TYPE;
  [AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES]?: AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES_TYPE;
  [AWS_DYNAMODB_PROJECTION]?: AWS_DYNAMODB_PROJECTION_TYPE;
  [AWS_DYNAMODB_PROVISIONED_READ_CAPACITY]?: AWS_DYNAMODB_PROVISIONED_READ_CAPACITY_TYPE;
  [AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY]?: AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY_TYPE;
  [AWS_DYNAMODB_SCANNED_COUNT]?: AWS_DYNAMODB_SCANNED_COUNT_TYPE;
  [AWS_DYNAMODB_SCAN_FORWARD]?: AWS_DYNAMODB_SCAN_FORWARD_TYPE;
  [AWS_DYNAMODB_SEGMENT]?: AWS_DYNAMODB_SEGMENT_TYPE;
  [AWS_DYNAMODB_SELECT]?: AWS_DYNAMODB_SELECT_TYPE;
  [AWS_DYNAMODB_TABLE_COUNT]?: AWS_DYNAMODB_TABLE_COUNT_TYPE;
  [AWS_DYNAMODB_TABLE_NAMES]?: AWS_DYNAMODB_TABLE_NAMES_TYPE;
  [AWS_DYNAMODB_TOTAL_SEGMENTS]?: AWS_DYNAMODB_TOTAL_SEGMENTS_TYPE;
  [AWS_EXTENDED_REQUEST_ID]?: AWS_EXTENDED_REQUEST_ID_TYPE;
  [AWS_KINESIS_STREAM_NAME]?: AWS_KINESIS_STREAM_NAME_TYPE;
  [_AWS_KINESIS_STREAM_NAME]?: _AWS_KINESIS_STREAM_NAME_TYPE;
  [AWS_LAMBDA_AWS_REQUEST_ID]?: AWS_LAMBDA_AWS_REQUEST_ID_TYPE;
  [AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS]?: AWS_LAMBDA_EXECUTION_DURATION_IN_MILLIS_TYPE;
  [AWS_LAMBDA_FUNCTION_NAME]?: AWS_LAMBDA_FUNCTION_NAME_TYPE;
  [AWS_LAMBDA_FUNCTION_VERSION]?: AWS_LAMBDA_FUNCTION_VERSION_TYPE;
  [AWS_LAMBDA_INVOKED_ARN]?: AWS_LAMBDA_INVOKED_ARN_TYPE;
  [AWS_LAMBDA_INVOKED_FUNCTION_ARN]?: AWS_LAMBDA_INVOKED_FUNCTION_ARN_TYPE;
  [AWS_LAMBDA_REMAINING_TIME_IN_MILLIS]?: AWS_LAMBDA_REMAINING_TIME_IN_MILLIS_TYPE;
  [AWS_LOG_GROUP_NAMES]?: AWS_LOG_GROUP_NAMES_TYPE;
  [AWS_LOG_STREAM_NAMES]?: AWS_LOG_STREAM_NAMES_TYPE;
  [AWS_OPERATION_NAME]?: AWS_OPERATION_NAME_TYPE;
  [AWS_REGION]?: AWS_REGION_TYPE;
  [AWS_REQUEST_EXTENDED_ID]?: AWS_REQUEST_EXTENDED_ID_TYPE;
  [AWS_REQUEST_ID]?: AWS_REQUEST_ID_TYPE;
  [_AWS_REQUEST_ID]?: _AWS_REQUEST_ID_TYPE;
  [AWS_REQUEST_URL]?: AWS_REQUEST_URL_TYPE;
  [AWS_S3_BUCKET]?: AWS_S3_BUCKET_TYPE;
  [AWS_S3_COPY_SOURCE]?: AWS_S3_COPY_SOURCE_TYPE;
  [AWS_S3_DELETE]?: AWS_S3_DELETE_TYPE;
  [AWS_S3_KEY]?: AWS_S3_KEY_TYPE;
  [AWS_S3_PART_NUMBER]?: AWS_S3_PART_NUMBER_TYPE;
  [AWS_S3_UPLOAD_ID]?: AWS_S3_UPLOAD_ID_TYPE;
  [AWS_SECRETSMANAGER_SECRET_ARN]?: AWS_SECRETSMANAGER_SECRET_ARN_TYPE;
  [AWS_SNS_TOPIC_ARN]?: AWS_SNS_TOPIC_ARN_TYPE;
  [AWS_SQS_QUEUE_URL]?: AWS_SQS_QUEUE_URL_TYPE;
  [AWS_STEP_FUNCTIONS_ACTIVITY_ARN]?: AWS_STEP_FUNCTIONS_ACTIVITY_ARN_TYPE;
  [AWS_STEP_FUNCTIONS_EXECUTION_ARN]?: AWS_STEP_FUNCTIONS_EXECUTION_ARN_TYPE;
  [AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN]?: AWS_STEP_FUNCTIONS_STATE_MACHINE_ARN_TYPE;
  [BLOCKED_MAIN_THREAD]?: BLOCKED_MAIN_THREAD_TYPE;
  [BROWSER_BFCACHE_FRAME]?: BROWSER_BFCACHE_FRAME_TYPE;
  [BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT]?: BROWSER_BFCACHE_NOT_RESTORED_REASON_COUNT_TYPE;
  [BROWSER_BFCACHE_OUTCOME]?: BROWSER_BFCACHE_OUTCOME_TYPE;
  [BROWSER_BFCACHE_REASON]?: BROWSER_BFCACHE_REASON_TYPE;
  [BROWSER_NAME]?: BROWSER_NAME_TYPE;
  [BROWSER_NAVIGATION_ID]?: BROWSER_NAVIGATION_ID_TYPE;
  [BROWSER_NAVIGATION_TYPE]?: BROWSER_NAVIGATION_TYPE_TYPE;
  [BROWSER_PAINT_TYPE]?: BROWSER_PAINT_TYPE_TYPE;
  [BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START]?: BROWSER_PERFORMANCE_NAVIGATION_ACTIVATION_START_TYPE;
  [BROWSER_PERFORMANCE_TIME_ORIGIN]?: BROWSER_PERFORMANCE_TIME_ORIGIN_TYPE;
  [BROWSER_REPORT_TYPE]?: BROWSER_REPORT_TYPE_TYPE;
  [BROWSER_SCRIPT_INVOKER]?: BROWSER_SCRIPT_INVOKER_TYPE;
  [BROWSER_SCRIPT_INVOKER_TYPE]?: BROWSER_SCRIPT_INVOKER_TYPE_TYPE;
  [BROWSER_SCRIPT_SOURCE_CHAR_POSITION]?: BROWSER_SCRIPT_SOURCE_CHAR_POSITION_TYPE;
  [BROWSER_VERSION]?: BROWSER_VERSION_TYPE;
  [BROWSER_WEB_VITAL_CLS_REPORT_EVENT]?: BROWSER_WEB_VITAL_CLS_REPORT_EVENT_TYPE;
  [BROWSER_WEB_VITAL_CLS_SOURCE_KEY]?: BROWSER_WEB_VITAL_CLS_SOURCE_KEY_TYPE;
  [BROWSER_WEB_VITAL_CLS_VALUE]?: BROWSER_WEB_VITAL_CLS_VALUE_TYPE;
  [BROWSER_WEB_VITAL_FCP_VALUE]?: BROWSER_WEB_VITAL_FCP_VALUE_TYPE;
  [BROWSER_WEB_VITAL_FP_VALUE]?: BROWSER_WEB_VITAL_FP_VALUE_TYPE;
  [BROWSER_WEB_VITAL_INP_INTERACTION_TYPE]?: BROWSER_WEB_VITAL_INP_INTERACTION_TYPE_TYPE;
  [BROWSER_WEB_VITAL_INP_TARGET]?: BROWSER_WEB_VITAL_INP_TARGET_TYPE;
  [BROWSER_WEB_VITAL_INP_VALUE]?: BROWSER_WEB_VITAL_INP_VALUE_TYPE;
  [BROWSER_WEB_VITAL_LCP_ELEMENT]?: BROWSER_WEB_VITAL_LCP_ELEMENT_TYPE;
  [BROWSER_WEB_VITAL_LCP_ID]?: BROWSER_WEB_VITAL_LCP_ID_TYPE;
  [BROWSER_WEB_VITAL_LCP_LOAD_TIME]?: BROWSER_WEB_VITAL_LCP_LOAD_TIME_TYPE;
  [BROWSER_WEB_VITAL_LCP_RENDER_TIME]?: BROWSER_WEB_VITAL_LCP_RENDER_TIME_TYPE;
  [BROWSER_WEB_VITAL_LCP_REPORT_EVENT]?: BROWSER_WEB_VITAL_LCP_REPORT_EVENT_TYPE;
  [BROWSER_WEB_VITAL_LCP_SIZE]?: BROWSER_WEB_VITAL_LCP_SIZE_TYPE;
  [BROWSER_WEB_VITAL_LCP_URL]?: BROWSER_WEB_VITAL_LCP_URL_TYPE;
  [BROWSER_WEB_VITAL_LCP_VALUE]?: BROWSER_WEB_VITAL_LCP_VALUE_TYPE;
  [BROWSER_WEB_VITAL_TTFB_REQUEST_TIME]?: BROWSER_WEB_VITAL_TTFB_REQUEST_TIME_TYPE;
  [BROWSER_WEB_VITAL_TTFB_VALUE]?: BROWSER_WEB_VITAL_TTFB_VALUE_TYPE;
  [CACHE_HIT]?: CACHE_HIT_TYPE;
  [CACHE_ITEM_AGE]?: CACHE_ITEM_AGE_TYPE;
  [CACHE_ITEM_SIZE]?: CACHE_ITEM_SIZE_TYPE;
  [CACHE_KEY]?: CACHE_KEY_TYPE;
  [CACHE_OPERATION]?: CACHE_OPERATION_TYPE;
  [CACHE_TAGS]?: CACHE_TAGS_TYPE;
  [CACHE_TTL]?: CACHE_TTL_TYPE;
  [CACHE_WRITE]?: CACHE_WRITE_TYPE;
  [CHANNEL]?: CHANNEL_TYPE;
  [CLIENT_ADDRESS]?: CLIENT_ADDRESS_TYPE;
  [CLIENT_PORT]?: CLIENT_PORT_TYPE;
  [CLOUDFLARE_D1_DURATION]?: CLOUDFLARE_D1_DURATION_TYPE;
  [CLOUDFLARE_D1_QUERY_TYPE]?: CLOUDFLARE_D1_QUERY_TYPE_TYPE;
  [CLOUDFLARE_D1_ROWS_READ]?: CLOUDFLARE_D1_ROWS_READ_TYPE;
  [CLOUDFLARE_D1_ROWS_WRITTEN]?: CLOUDFLARE_D1_ROWS_WRITTEN_TYPE;
  [CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS]?: CLOUDFLARE_DURABLE_OBJECT_QUERY_BINDINGS_TYPE;
  [CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ]?: CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_READ_TYPE;
  [CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN]?: CLOUDFLARE_DURABLE_OBJECT_RESPONSE_ROWS_WRITTEN_TYPE;
  [CLOUDFLARE_R2_BUCKET]?: CLOUDFLARE_R2_BUCKET_TYPE;
  [CLOUDFLARE_R2_OPERATION]?: CLOUDFLARE_R2_OPERATION_TYPE;
  [CLOUDFLARE_R2_REQUEST_DELIMITER]?: CLOUDFLARE_R2_REQUEST_DELIMITER_TYPE;
  [CLOUDFLARE_R2_REQUEST_KEY]?: CLOUDFLARE_R2_REQUEST_KEY_TYPE;
  [CLOUDFLARE_R2_REQUEST_PART_NUMBER]?: CLOUDFLARE_R2_REQUEST_PART_NUMBER_TYPE;
  [CLOUDFLARE_R2_REQUEST_PREFIX]?: CLOUDFLARE_R2_REQUEST_PREFIX_TYPE;
  [CLOUDFLARE_WORKFLOW_ATTEMPT]?: CLOUDFLARE_WORKFLOW_ATTEMPT_TYPE;
  [CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF]?: CLOUDFLARE_WORKFLOW_RETRIES_BACKOFF_TYPE;
  [CLOUDFLARE_WORKFLOW_RETRIES_DELAY]?: CLOUDFLARE_WORKFLOW_RETRIES_DELAY_TYPE;
  [CLOUDFLARE_WORKFLOW_RETRIES_LIMIT]?: CLOUDFLARE_WORKFLOW_RETRIES_LIMIT_TYPE;
  [CLOUDFLARE_WORKFLOW_TIMEOUT]?: CLOUDFLARE_WORKFLOW_TIMEOUT_TYPE;
  [CLOUD_ACCOUNT_ID]?: CLOUD_ACCOUNT_ID_TYPE;
  [CLOUD_AVAILABILITY_ZONE]?: CLOUD_AVAILABILITY_ZONE_TYPE;
  [CLOUD_PLATFORM]?: CLOUD_PLATFORM_TYPE;
  [CLOUD_PROVIDER]?: CLOUD_PROVIDER_TYPE;
  [CLOUD_REGION]?: CLOUD_REGION_TYPE;
  [CLOUD_RESOURCE_ID]?: CLOUD_RESOURCE_ID_TYPE;
  [CLS]?: CLS_TYPE;
  [CLS_SOURCE_KEY]?: CLS_SOURCE_KEY_TYPE;
  [CODE]?: CODE_TYPE;
  [CODE_FILEPATH]?: CODE_FILEPATH_TYPE;
  [CODE_FILE_PATH]?: CODE_FILE_PATH_TYPE;
  [CODE_FUNCTION]?: CODE_FUNCTION_TYPE;
  [CODE_FUNCTION_NAME]?: CODE_FUNCTION_NAME_TYPE;
  [CODE_LINENO]?: CODE_LINENO_TYPE;
  [CODE_LINE_NUMBER]?: CODE_LINE_NUMBER_TYPE;
  [CODE_NAMESPACE]?: CODE_NAMESPACE_TYPE;
  [CONNECTIONTYPE]?: CONNECTIONTYPE_TYPE;
  [CONNECTION_RTT]?: CONNECTION_RTT_TYPE;
  [CULTURE_CALENDAR]?: CULTURE_CALENDAR_TYPE;
  [CULTURE_DISPLAY_NAME]?: CULTURE_DISPLAY_NAME_TYPE;
  [CULTURE_IS_24_HOUR_FORMAT]?: CULTURE_IS_24_HOUR_FORMAT_TYPE;
  [CULTURE_LOCALE]?: CULTURE_LOCALE_TYPE;
  [CULTURE_TIMEZONE]?: CULTURE_TIMEZONE_TYPE;
  [DB_COLLECTION_NAME]?: DB_COLLECTION_NAME_TYPE;
  [DB_CONNECTION_STRING]?: DB_CONNECTION_STRING_TYPE;
  [DB_DRIVER_NAME]?: DB_DRIVER_NAME_TYPE;
  [DB_MONGODB_COLLECTION]?: DB_MONGODB_COLLECTION_TYPE;
  [DB_NAME]?: DB_NAME_TYPE;
  [DB_NAMESPACE]?: DB_NAMESPACE_TYPE;
  [DB_OPERATION]?: DB_OPERATION_TYPE;
  [DB_OPERATION_BATCH_SIZE]?: DB_OPERATION_BATCH_SIZE_TYPE;
  [DB_OPERATION_NAME]?: DB_OPERATION_NAME_TYPE;
  [DB_PARAMS]?: DB_PARAMS_TYPE;
  [DB_QUERY_PARAMETER_KEY]?: DB_QUERY_PARAMETER_KEY_TYPE;
  [DB_QUERY_SUMMARY]?: DB_QUERY_SUMMARY_TYPE;
  [DB_QUERY_TEXT]?: DB_QUERY_TEXT_TYPE;
  [DB_REDIS_CONNECTION]?: DB_REDIS_CONNECTION_TYPE;
  [DB_REDIS_KEY]?: DB_REDIS_KEY_TYPE;
  [DB_REDIS_PARAMETERS]?: DB_REDIS_PARAMETERS_TYPE;
  [DB_RESPONSE_STATUS_CODE]?: DB_RESPONSE_STATUS_CODE_TYPE;
  [DB_SQL_BINDINGS]?: DB_SQL_BINDINGS_TYPE;
  [DB_STATEMENT]?: DB_STATEMENT_TYPE;
  [DB_STORED_PROCEDURE_NAME]?: DB_STORED_PROCEDURE_NAME_TYPE;
  [DB_SYSTEM]?: DB_SYSTEM_TYPE;
  [DB_SYSTEM_NAME]?: DB_SYSTEM_NAME_TYPE;
  [DB_USER]?: DB_USER_TYPE;
  [DEVICEMEMORY]?: DEVICEMEMORY_TYPE;
  [DEVICE_ARCHS]?: DEVICE_ARCHS_TYPE;
  [DEVICE_BATTERY_LEVEL]?: DEVICE_BATTERY_LEVEL_TYPE;
  [DEVICE_BATTERY_TEMPERATURE]?: DEVICE_BATTERY_TEMPERATURE_TYPE;
  [DEVICE_BOOT_TIME]?: DEVICE_BOOT_TIME_TYPE;
  [DEVICE_BRAND]?: DEVICE_BRAND_TYPE;
  [DEVICE_CHARGING]?: DEVICE_CHARGING_TYPE;
  [DEVICE_CHIPSET]?: DEVICE_CHIPSET_TYPE;
  [DEVICE_CLASS]?: DEVICE_CLASS_TYPE;
  [DEVICE_CONNECTION_TYPE]?: DEVICE_CONNECTION_TYPE_TYPE;
  [DEVICE_CPU_DESCRIPTION]?: DEVICE_CPU_DESCRIPTION_TYPE;
  [DEVICE_EXTERNAL_FREE_STORAGE]?: DEVICE_EXTERNAL_FREE_STORAGE_TYPE;
  [DEVICE_EXTERNAL_STORAGE_SIZE]?: DEVICE_EXTERNAL_STORAGE_SIZE_TYPE;
  [DEVICE_FAMILY]?: DEVICE_FAMILY_TYPE;
  [DEVICE_FREE_MEMORY]?: DEVICE_FREE_MEMORY_TYPE;
  [DEVICE_FREE_STORAGE]?: DEVICE_FREE_STORAGE_TYPE;
  [DEVICE_ID]?: DEVICE_ID_TYPE;
  [DEVICE_LOCALE]?: DEVICE_LOCALE_TYPE;
  [DEVICE_LOW_MEMORY]?: DEVICE_LOW_MEMORY_TYPE;
  [DEVICE_LOW_POWER_MODE]?: DEVICE_LOW_POWER_MODE_TYPE;
  [DEVICE_MANUFACTURER]?: DEVICE_MANUFACTURER_TYPE;
  [DEVICE_MEMORY_ESTIMATED_CAPACITY]?: DEVICE_MEMORY_ESTIMATED_CAPACITY_TYPE;
  [DEVICE_MEMORY_SIZE]?: DEVICE_MEMORY_SIZE_TYPE;
  [DEVICE_MODEL]?: DEVICE_MODEL_TYPE;
  [DEVICE_MODEL_ID]?: DEVICE_MODEL_ID_TYPE;
  [DEVICE_NAME]?: DEVICE_NAME_TYPE;
  [DEVICE_ONLINE]?: DEVICE_ONLINE_TYPE;
  [DEVICE_ORIENTATION]?: DEVICE_ORIENTATION_TYPE;
  [DEVICE_PROCESSOR_COUNT]?: DEVICE_PROCESSOR_COUNT_TYPE;
  [DEVICE_PROCESSOR_FREQUENCY]?: DEVICE_PROCESSOR_FREQUENCY_TYPE;
  [DEVICE_SCREEN_DENSITY]?: DEVICE_SCREEN_DENSITY_TYPE;
  [DEVICE_SCREEN_DPI]?: DEVICE_SCREEN_DPI_TYPE;
  [DEVICE_SCREEN_HEIGHT_PIXELS]?: DEVICE_SCREEN_HEIGHT_PIXELS_TYPE;
  [DEVICE_SCREEN_WIDTH_PIXELS]?: DEVICE_SCREEN_WIDTH_PIXELS_TYPE;
  [DEVICE_SIMULATOR]?: DEVICE_SIMULATOR_TYPE;
  [DEVICE_STORAGE_SIZE]?: DEVICE_STORAGE_SIZE_TYPE;
  [DEVICE_THERMAL_STATE]?: DEVICE_THERMAL_STATE_TYPE;
  [DEVICE_TIMEZONE]?: DEVICE_TIMEZONE_TYPE;
  [DEVICE_USABLE_MEMORY]?: DEVICE_USABLE_MEMORY_TYPE;
  [DIST]?: DIST_TYPE;
  [DJANGO_FUNCTION_NAME]?: DJANGO_FUNCTION_NAME_TYPE;
  [DJANGO_MIDDLEWARE_NAME]?: DJANGO_MIDDLEWARE_NAME_TYPE;
  [EFFECTIVECONNECTIONTYPE]?: EFFECTIVECONNECTIONTYPE_TYPE;
  [ENVIRONMENT]?: ENVIRONMENT_TYPE;
  [ERROR_TYPE]?: ERROR_TYPE_TYPE;
  [EVENT_ID]?: EVENT_ID_TYPE;
  [EVENT_NAME]?: EVENT_NAME_TYPE;
  [EXCEPTION_ESCAPED]?: EXCEPTION_ESCAPED_TYPE;
  [EXCEPTION_MESSAGE]?: EXCEPTION_MESSAGE_TYPE;
  [EXCEPTION_STACKTRACE]?: EXCEPTION_STACKTRACE_TYPE;
  [EXCEPTION_TYPE]?: EXCEPTION_TYPE_TYPE;
  [FAAS_COLDSTART]?: FAAS_COLDSTART_TYPE;
  [FAAS_CRON]?: FAAS_CRON_TYPE;
  [FAAS_DURATION_IN_MS]?: FAAS_DURATION_IN_MS_TYPE;
  [FAAS_ENTRY_POINT]?: FAAS_ENTRY_POINT_TYPE;
  [FAAS_EXECUTION]?: FAAS_EXECUTION_TYPE;
  [FAAS_ID]?: FAAS_ID_TYPE;
  [FAAS_IDENTITY]?: FAAS_IDENTITY_TYPE;
  [FAAS_INVOCATION_ID]?: FAAS_INVOCATION_ID_TYPE;
  [FAAS_INVOKED_NAME]?: FAAS_INVOKED_NAME_TYPE;
  [FAAS_INVOKED_PROVIDER]?: FAAS_INVOKED_PROVIDER_TYPE;
  [FAAS_INVOKED_REGION]?: FAAS_INVOKED_REGION_TYPE;
  [FAAS_NAME]?: FAAS_NAME_TYPE;
  [FAAS_TIME]?: FAAS_TIME_TYPE;
  [FAAS_TRIGGER]?: FAAS_TRIGGER_TYPE;
  [FAAS_VERSION]?: FAAS_VERSION_TYPE;
  [FCP]?: FCP_TYPE;
  [FILE_PATH]?: FILE_PATH_TYPE;
  [FILE_SIZE]?: FILE_SIZE_TYPE;
  [FLAG_EVALUATION_KEY]?: FLAG_EVALUATION_KEY_TYPE;
  [FP]?: FP_TYPE;
  [FRAMES_DELAY]?: FRAMES_DELAY_TYPE;
  [FRAMES_FROZEN]?: FRAMES_FROZEN_TYPE;
  [FRAMES_FROZEN_RATE]?: FRAMES_FROZEN_RATE_TYPE;
  [FRAMES_SLOW]?: FRAMES_SLOW_TYPE;
  [FRAMES_SLOW_RATE]?: FRAMES_SLOW_RATE_TYPE;
  [FRAMES_TOTAL]?: FRAMES_TOTAL_TYPE;
  [FS_ERROR]?: FS_ERROR_TYPE;
  [GCP_FUNCTION_CONTEXT_EVENT_ID]?: GCP_FUNCTION_CONTEXT_EVENT_ID_TYPE;
  [GCP_FUNCTION_CONTEXT_EVENT_TYPE]?: GCP_FUNCTION_CONTEXT_EVENT_TYPE_TYPE;
  [GCP_FUNCTION_CONTEXT_ID]?: GCP_FUNCTION_CONTEXT_ID_TYPE;
  [GCP_FUNCTION_CONTEXT_RESOURCE]?: GCP_FUNCTION_CONTEXT_RESOURCE_TYPE;
  [GCP_FUNCTION_CONTEXT_SOURCE]?: GCP_FUNCTION_CONTEXT_SOURCE_TYPE;
  [GCP_FUNCTION_CONTEXT_SPECVERSION]?: GCP_FUNCTION_CONTEXT_SPECVERSION_TYPE;
  [GCP_FUNCTION_CONTEXT_TIME]?: GCP_FUNCTION_CONTEXT_TIME_TYPE;
  [GCP_FUNCTION_CONTEXT_TIMESTAMP]?: GCP_FUNCTION_CONTEXT_TIMESTAMP_TYPE;
  [GCP_FUNCTION_CONTEXT_TYPE]?: GCP_FUNCTION_CONTEXT_TYPE_TYPE;
  [GCP_PROJECT_ID]?: GCP_PROJECT_ID_TYPE;
  [GCP_REGION]?: GCP_REGION_TYPE;
  [GEN_AI_AGENT_NAME]?: GEN_AI_AGENT_NAME_TYPE;
  [GEN_AI_CONTEXT_UTILIZATION]?: GEN_AI_CONTEXT_UTILIZATION_TYPE;
  [GEN_AI_CONTEXT_WINDOW_SIZE]?: GEN_AI_CONTEXT_WINDOW_SIZE_TYPE;
  [GEN_AI_CONVERSATION_ID]?: GEN_AI_CONVERSATION_ID_TYPE;
  [GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS]?: GEN_AI_COST_CACHE_CREATION_INPUT_TOKENS_TYPE;
  [GEN_AI_COST_CACHE_READ_INPUT_TOKENS]?: GEN_AI_COST_CACHE_READ_INPUT_TOKENS_TYPE;
  [GEN_AI_COST_INPUT_TOKENS]?: GEN_AI_COST_INPUT_TOKENS_TYPE;
  [GEN_AI_COST_OUTPUT_TOKENS]?: GEN_AI_COST_OUTPUT_TOKENS_TYPE;
  [GEN_AI_COST_REASONING_OUTPUT_TOKENS]?: GEN_AI_COST_REASONING_OUTPUT_TOKENS_TYPE;
  [GEN_AI_COST_TOTAL_TOKENS]?: GEN_AI_COST_TOTAL_TOKENS_TYPE;
  [GEN_AI_EMBEDDINGS_INPUT]?: GEN_AI_EMBEDDINGS_INPUT_TYPE;
  [GEN_AI_FUNCTION_ID]?: GEN_AI_FUNCTION_ID_TYPE;
  [GEN_AI_INPUT_MESSAGES]?: GEN_AI_INPUT_MESSAGES_TYPE;
  [GEN_AI_MEMORY_QUERY_TEXT]?: GEN_AI_MEMORY_QUERY_TEXT_TYPE;
  [GEN_AI_MEMORY_RECORDS]?: GEN_AI_MEMORY_RECORDS_TYPE;
  [GEN_AI_MEMORY_RECORD_COUNT]?: GEN_AI_MEMORY_RECORD_COUNT_TYPE;
  [GEN_AI_MEMORY_RECORD_ID]?: GEN_AI_MEMORY_RECORD_ID_TYPE;
  [GEN_AI_MEMORY_STORE_ID]?: GEN_AI_MEMORY_STORE_ID_TYPE;
  [GEN_AI_OPERATION_NAME]?: GEN_AI_OPERATION_NAME_TYPE;
  [GEN_AI_OPERATION_TYPE]?: GEN_AI_OPERATION_TYPE_TYPE;
  [GEN_AI_OUTPUT_MESSAGES]?: GEN_AI_OUTPUT_MESSAGES_TYPE;
  [GEN_AI_PIPELINE_NAME]?: GEN_AI_PIPELINE_NAME_TYPE;
  [GEN_AI_PROMPT]?: GEN_AI_PROMPT_TYPE;
  [GEN_AI_PROMPT_NAME]?: GEN_AI_PROMPT_NAME_TYPE;
  [GEN_AI_PROMPT_VARIABLE_KEY]?: GEN_AI_PROMPT_VARIABLE_KEY_TYPE;
  [GEN_AI_PROVIDER_NAME]?: GEN_AI_PROVIDER_NAME_TYPE;
  [GEN_AI_REQUEST_AVAILABLE_TOOLS]?: GEN_AI_REQUEST_AVAILABLE_TOOLS_TYPE;
  [GEN_AI_REQUEST_FREQUENCY_PENALTY]?: GEN_AI_REQUEST_FREQUENCY_PENALTY_TYPE;
  [GEN_AI_REQUEST_MAX_TOKENS]?: GEN_AI_REQUEST_MAX_TOKENS_TYPE;
  [GEN_AI_REQUEST_MESSAGES]?: GEN_AI_REQUEST_MESSAGES_TYPE;
  [GEN_AI_REQUEST_MODEL]?: GEN_AI_REQUEST_MODEL_TYPE;
  [GEN_AI_REQUEST_PRESENCE_PENALTY]?: GEN_AI_REQUEST_PRESENCE_PENALTY_TYPE;
  [GEN_AI_REQUEST_REASONING_LEVEL]?: GEN_AI_REQUEST_REASONING_LEVEL_TYPE;
  [GEN_AI_REQUEST_SCHEMA]?: GEN_AI_REQUEST_SCHEMA_TYPE;
  [GEN_AI_REQUEST_SEED]?: GEN_AI_REQUEST_SEED_TYPE;
  [GEN_AI_REQUEST_STOP_SEQUENCES]?: GEN_AI_REQUEST_STOP_SEQUENCES_TYPE;
  [GEN_AI_REQUEST_TEMPERATURE]?: GEN_AI_REQUEST_TEMPERATURE_TYPE;
  [GEN_AI_REQUEST_TOP_K]?: GEN_AI_REQUEST_TOP_K_TYPE;
  [GEN_AI_REQUEST_TOP_P]?: GEN_AI_REQUEST_TOP_P_TYPE;
  [GEN_AI_RESPONSE_FINISH_REASON]?: GEN_AI_RESPONSE_FINISH_REASON_TYPE;
  [GEN_AI_RESPONSE_FINISH_REASONS]?: GEN_AI_RESPONSE_FINISH_REASONS_TYPE;
  [GEN_AI_RESPONSE_ID]?: GEN_AI_RESPONSE_ID_TYPE;
  [GEN_AI_RESPONSE_MODEL]?: GEN_AI_RESPONSE_MODEL_TYPE;
  [GEN_AI_RESPONSE_OBJECT]?: GEN_AI_RESPONSE_OBJECT_TYPE;
  [GEN_AI_RESPONSE_STREAMING]?: GEN_AI_RESPONSE_STREAMING_TYPE;
  [GEN_AI_RESPONSE_TEXT]?: GEN_AI_RESPONSE_TEXT_TYPE;
  [GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK]?: GEN_AI_RESPONSE_TIME_TO_FIRST_CHUNK_TYPE;
  [GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN]?: GEN_AI_RESPONSE_TIME_TO_FIRST_TOKEN_TYPE;
  [GEN_AI_RESPONSE_TOKENS_PER_SECOND]?: GEN_AI_RESPONSE_TOKENS_PER_SECOND_TYPE;
  [GEN_AI_RESPONSE_TOOL_CALLS]?: GEN_AI_RESPONSE_TOOL_CALLS_TYPE;
  [GEN_AI_SYSTEM]?: GEN_AI_SYSTEM_TYPE;
  [GEN_AI_SYSTEM_INSTRUCTIONS]?: GEN_AI_SYSTEM_INSTRUCTIONS_TYPE;
  [GEN_AI_SYSTEM_MESSAGE]?: GEN_AI_SYSTEM_MESSAGE_TYPE;
  [GEN_AI_TOOL_CALL_ARGUMENTS]?: GEN_AI_TOOL_CALL_ARGUMENTS_TYPE;
  [GEN_AI_TOOL_CALL_RESULT]?: GEN_AI_TOOL_CALL_RESULT_TYPE;
  [GEN_AI_TOOL_DEFINITIONS]?: GEN_AI_TOOL_DEFINITIONS_TYPE;
  [GEN_AI_TOOL_DESCRIPTION]?: GEN_AI_TOOL_DESCRIPTION_TYPE;
  [GEN_AI_TOOL_INPUT]?: GEN_AI_TOOL_INPUT_TYPE;
  [GEN_AI_TOOL_MESSAGE]?: GEN_AI_TOOL_MESSAGE_TYPE;
  [GEN_AI_TOOL_NAME]?: GEN_AI_TOOL_NAME_TYPE;
  [GEN_AI_TOOL_OUTPUT]?: GEN_AI_TOOL_OUTPUT_TYPE;
  [GEN_AI_TOOL_TYPE]?: GEN_AI_TOOL_TYPE_TYPE;
  [GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS]?: GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE;
  [_GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS]?: _GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_TYPE;
  [GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS]?: GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE;
  [_GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS]?: _GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_TYPE;
  [GEN_AI_USAGE_COMPLETION_TOKENS]?: GEN_AI_USAGE_COMPLETION_TOKENS_TYPE;
  [GEN_AI_USAGE_INPUT_TOKENS]?: GEN_AI_USAGE_INPUT_TOKENS_TYPE;
  [GEN_AI_USAGE_INPUT_TOKENS_CACHED]?: GEN_AI_USAGE_INPUT_TOKENS_CACHED_TYPE;
  [GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE]?: GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_TYPE;
  [GEN_AI_USAGE_OUTPUT_TOKENS]?: GEN_AI_USAGE_OUTPUT_TOKENS_TYPE;
  [GEN_AI_USAGE_OUTPUT_TOKENS_REASONING]?: GEN_AI_USAGE_OUTPUT_TOKENS_REASONING_TYPE;
  [GEN_AI_USAGE_PROMPT_TOKENS]?: GEN_AI_USAGE_PROMPT_TOKENS_TYPE;
  [GEN_AI_USAGE_REASONING_OUTPUT_TOKENS]?: GEN_AI_USAGE_REASONING_OUTPUT_TOKENS_TYPE;
  [GEN_AI_USAGE_TOTAL_TOKENS]?: GEN_AI_USAGE_TOTAL_TOKENS_TYPE;
  [GRAPHQL_DOCUMENT]?: GRAPHQL_DOCUMENT_TYPE;
  [GRAPHQL_OPERATION_NAME]?: GRAPHQL_OPERATION_NAME_TYPE;
  [GRAPHQL_OPERATION_TYPE]?: GRAPHQL_OPERATION_TYPE_TYPE;
  [GRAPHQL_PROCESSING_TYPE]?: GRAPHQL_PROCESSING_TYPE_TYPE;
  [GRAPHQL_SOURCE]?: GRAPHQL_SOURCE_TYPE;
  [GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS]?: GRPC_ERROR_BAD_REQUEST_FIELD_VIOLATIONS_TYPE;
  [GRPC_ERROR_DEBUG_INFO_DETAIL]?: GRPC_ERROR_DEBUG_INFO_DETAIL_TYPE;
  [GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES]?: GRPC_ERROR_DEBUG_INFO_STACK_ENTRIES_TYPE;
  [GRPC_ERROR_ERROR_INFO_DOMAIN]?: GRPC_ERROR_ERROR_INFO_DOMAIN_TYPE;
  [GRPC_ERROR_ERROR_INFO_METADATA_KEY]?: GRPC_ERROR_ERROR_INFO_METADATA_KEY_TYPE;
  [GRPC_ERROR_ERROR_INFO_REASON]?: GRPC_ERROR_ERROR_INFO_REASON_TYPE;
  [GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS]?: GRPC_ERROR_PRECONDITION_FAILURE_VIOLATIONS_TYPE;
  [GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS]?: GRPC_ERROR_QUOTA_FAILURE_VIOLATIONS_TYPE;
  [GRPC_ERROR_RESOURCE_INFO_DESCRIPTION]?: GRPC_ERROR_RESOURCE_INFO_DESCRIPTION_TYPE;
  [GRPC_ERROR_RESOURCE_INFO_OWNER]?: GRPC_ERROR_RESOURCE_INFO_OWNER_TYPE;
  [GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME]?: GRPC_ERROR_RESOURCE_INFO_RESOURCE_NAME_TYPE;
  [GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE]?: GRPC_ERROR_RESOURCE_INFO_RESOURCE_TYPE_TYPE;
  [GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS]?: GRPC_ERROR_RETRY_INFO_RETRY_DELAY_MS_TYPE;
  [HARDWARECONCURRENCY]?: HARDWARECONCURRENCY_TYPE;
  [HTTP_CLIENT_IP]?: HTTP_CLIENT_IP_TYPE;
  [HTTP_DECODED_RESPONSE_CONTENT_LENGTH]?: HTTP_DECODED_RESPONSE_CONTENT_LENGTH_TYPE;
  [HTTP_FLAVOR]?: HTTP_FLAVOR_TYPE;
  [HTTP_FRAGMENT]?: HTTP_FRAGMENT_TYPE;
  [HTTP_HOST]?: HTTP_HOST_TYPE;
  [HTTP_METHOD]?: HTTP_METHOD_TYPE;
  [HTTP_QUERY]?: HTTP_QUERY_TYPE;
  [HTTP_REQUEST_BODY_DATA]?: HTTP_REQUEST_BODY_DATA_TYPE;
  [HTTP_REQUEST_BODY_DECODED_SIZE]?: HTTP_REQUEST_BODY_DECODED_SIZE_TYPE;
  [HTTP_REQUEST_BODY_SIZE]?: HTTP_REQUEST_BODY_SIZE_TYPE;
  [HTTP_REQUEST_CONNECTION_END]?: HTTP_REQUEST_CONNECTION_END_TYPE;
  [HTTP_REQUEST_CONNECT_START]?: HTTP_REQUEST_CONNECT_START_TYPE;
  [HTTP_REQUEST_CONTENT_LENGTH]?: HTTP_REQUEST_CONTENT_LENGTH_TYPE;
  [HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED]?: HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED_TYPE;
  [HTTP_REQUEST_DOMAIN_LOOKUP_END]?: HTTP_REQUEST_DOMAIN_LOOKUP_END_TYPE;
  [HTTP_REQUEST_DOMAIN_LOOKUP_START]?: HTTP_REQUEST_DOMAIN_LOOKUP_START_TYPE;
  [HTTP_REQUEST_FETCH_START]?: HTTP_REQUEST_FETCH_START_TYPE;
  [HTTP_REQUEST_HEADER_KEY]?: HTTP_REQUEST_HEADER_KEY_TYPE;
  [HTTP_REQUEST_METHOD]?: HTTP_REQUEST_METHOD_TYPE;
  [_HTTP_REQUEST_METHOD]?: _HTTP_REQUEST_METHOD_TYPE;
  [HTTP_REQUEST_REDIRECT_END]?: HTTP_REQUEST_REDIRECT_END_TYPE;
  [HTTP_REQUEST_REDIRECT_START]?: HTTP_REQUEST_REDIRECT_START_TYPE;
  [HTTP_REQUEST_REQUEST_START]?: HTTP_REQUEST_REQUEST_START_TYPE;
  [HTTP_REQUEST_RESEND_COUNT]?: HTTP_REQUEST_RESEND_COUNT_TYPE;
  [HTTP_REQUEST_RESPONSE_END]?: HTTP_REQUEST_RESPONSE_END_TYPE;
  [HTTP_REQUEST_RESPONSE_START]?: HTTP_REQUEST_RESPONSE_START_TYPE;
  [HTTP_REQUEST_SAME_ORIGIN]?: HTTP_REQUEST_SAME_ORIGIN_TYPE;
  [HTTP_REQUEST_SECURE_CONNECTION_START]?: HTTP_REQUEST_SECURE_CONNECTION_START_TYPE;
  [HTTP_REQUEST_TIME_TO_FIRST_BYTE]?: HTTP_REQUEST_TIME_TO_FIRST_BYTE_TYPE;
  [HTTP_REQUEST_WORKER_START]?: HTTP_REQUEST_WORKER_START_TYPE;
  [HTTP_RESPONSE_BODY_DECODED_SIZE]?: HTTP_RESPONSE_BODY_DECODED_SIZE_TYPE;
  [HTTP_RESPONSE_BODY_SIZE]?: HTTP_RESPONSE_BODY_SIZE_TYPE;
  [HTTP_RESPONSE_CONTENT_LENGTH]?: HTTP_RESPONSE_CONTENT_LENGTH_TYPE;
  [HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED]?: HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED_TYPE;
  [HTTP_RESPONSE_HEADER_CONTENT_LENGTH]?: HTTP_RESPONSE_HEADER_CONTENT_LENGTH_TYPE;
  [HTTP_RESPONSE_HEADER_KEY]?: HTTP_RESPONSE_HEADER_KEY_TYPE;
  [HTTP_RESPONSE_SIZE]?: HTTP_RESPONSE_SIZE_TYPE;
  [HTTP_RESPONSE_STATUS_CODE]?: HTTP_RESPONSE_STATUS_CODE_TYPE;
  [HTTP_RESPONSE_STATUS_TEXT]?: HTTP_RESPONSE_STATUS_TEXT_TYPE;
  [HTTP_RESPONSE_TRANSFER_SIZE]?: HTTP_RESPONSE_TRANSFER_SIZE_TYPE;
  [HTTP_ROUTE]?: HTTP_ROUTE_TYPE;
  [HTTP_SCHEME]?: HTTP_SCHEME_TYPE;
  [HTTP_SERVER_NAME]?: HTTP_SERVER_NAME_TYPE;
  [HTTP_SERVER_REQUEST_TIME_IN_QUEUE]?: HTTP_SERVER_REQUEST_TIME_IN_QUEUE_TYPE;
  [HTTP_STATUS_CODE]?: HTTP_STATUS_CODE_TYPE;
  [HTTP_STATUS_TEXT]?: HTTP_STATUS_TEXT_TYPE;
  [HTTP_TARGET]?: HTTP_TARGET_TYPE;
  [HTTP_URL]?: HTTP_URL_TYPE;
  [HTTP_USER_AGENT]?: HTTP_USER_AGENT_TYPE;
  [ID]?: ID_TYPE;
  [INP]?: INP_TYPE;
  [INTEGRITY_BLOCKED_URL]?: INTEGRITY_BLOCKED_URL_TYPE;
  [INTEGRITY_DESTINATION]?: INTEGRITY_DESTINATION_TYPE;
  [INTEGRITY_DOCUMENT_URL]?: INTEGRITY_DOCUMENT_URL_TYPE;
  [INTEGRITY_REPORT_ONLY]?: INTEGRITY_REPORT_ONLY_TYPE;
  [JSONRPC_PROTOCOL_VERSION]?: JSONRPC_PROTOCOL_VERSION_TYPE;
  [JSONRPC_REQUEST_ID]?: JSONRPC_REQUEST_ID_TYPE;
  [JVM_GC_ACTION]?: JVM_GC_ACTION_TYPE;
  [JVM_GC_NAME]?: JVM_GC_NAME_TYPE;
  [JVM_MEMORY_POOL_NAME]?: JVM_MEMORY_POOL_NAME_TYPE;
  [JVM_MEMORY_TYPE]?: JVM_MEMORY_TYPE_TYPE;
  [JVM_THREAD_DAEMON]?: JVM_THREAD_DAEMON_TYPE;
  [JVM_THREAD_STATE]?: JVM_THREAD_STATE_TYPE;
  [KOA_NAME]?: KOA_NAME_TYPE;
  [KOA_TYPE]?: KOA_TYPE_TYPE;
  [LANGCHAIN_CHAIN_NAME]?: LANGCHAIN_CHAIN_NAME_TYPE;
  [LCP]?: LCP_TYPE;
  [LCP_ELEMENT]?: LCP_ELEMENT_TYPE;
  [LCP_ID]?: LCP_ID_TYPE;
  [LCP_LOADTIME]?: LCP_LOADTIME_TYPE;
  [LCP_RENDERTIME]?: LCP_RENDERTIME_TYPE;
  [LCP_SIZE]?: LCP_SIZE_TYPE;
  [LCP_URL]?: LCP_URL_TYPE;
  [LITESTAR_MIDDLEWARE_NAME]?: LITESTAR_MIDDLEWARE_NAME_TYPE;
  [LOGGER_NAME]?: LOGGER_NAME_TYPE;
  [MCP_AUTH_CLIENT_NAME]?: MCP_AUTH_CLIENT_NAME_TYPE;
  [MCP_CANCELLED_REASON]?: MCP_CANCELLED_REASON_TYPE;
  [MCP_CANCELLED_REQUEST_ID]?: MCP_CANCELLED_REQUEST_ID_TYPE;
  [MCP_CLIENT_NAME]?: MCP_CLIENT_NAME_TYPE;
  [MCP_CLIENT_TITLE]?: MCP_CLIENT_TITLE_TYPE;
  [MCP_CLIENT_VERSION]?: MCP_CLIENT_VERSION_TYPE;
  [MCP_LIFECYCLE_PHASE]?: MCP_LIFECYCLE_PHASE_TYPE;
  [MCP_LOGGING_DATA_TYPE]?: MCP_LOGGING_DATA_TYPE_TYPE;
  [MCP_LOGGING_LEVEL]?: MCP_LOGGING_LEVEL_TYPE;
  [MCP_LOGGING_LOGGER]?: MCP_LOGGING_LOGGER_TYPE;
  [MCP_LOGGING_MESSAGE]?: MCP_LOGGING_MESSAGE_TYPE;
  [MCP_METHOD_NAME]?: MCP_METHOD_NAME_TYPE;
  [MCP_PROGRESS_CURRENT]?: MCP_PROGRESS_CURRENT_TYPE;
  [MCP_PROGRESS_MESSAGE]?: MCP_PROGRESS_MESSAGE_TYPE;
  [MCP_PROGRESS_PERCENTAGE]?: MCP_PROGRESS_PERCENTAGE_TYPE;
  [MCP_PROGRESS_TOKEN]?: MCP_PROGRESS_TOKEN_TYPE;
  [MCP_PROGRESS_TOTAL]?: MCP_PROGRESS_TOTAL_TYPE;
  [MCP_PROMPT_NAME]?: MCP_PROMPT_NAME_TYPE;
  [MCP_PROMPT_RESULT_DESCRIPTION]?: MCP_PROMPT_RESULT_DESCRIPTION_TYPE;
  [MCP_PROMPT_RESULT_KEY_CONTENT]?: MCP_PROMPT_RESULT_KEY_CONTENT_TYPE;
  [MCP_PROMPT_RESULT_KEY_ROLE]?: MCP_PROMPT_RESULT_KEY_ROLE_TYPE;
  [MCP_PROMPT_RESULT_MESSAGE_CONTENT]?: MCP_PROMPT_RESULT_MESSAGE_CONTENT_TYPE;
  [MCP_PROMPT_RESULT_MESSAGE_COUNT]?: MCP_PROMPT_RESULT_MESSAGE_COUNT_TYPE;
  [MCP_PROMPT_RESULT_MESSAGE_ROLE]?: MCP_PROMPT_RESULT_MESSAGE_ROLE_TYPE;
  [MCP_PROTOCOL_READY]?: MCP_PROTOCOL_READY_TYPE;
  [MCP_PROTOCOL_VERSION]?: MCP_PROTOCOL_VERSION_TYPE;
  [MCP_REQUEST_ARGUMENT_KEY]?: MCP_REQUEST_ARGUMENT_KEY_TYPE;
  [MCP_REQUEST_ARGUMENT_NAME]?: MCP_REQUEST_ARGUMENT_NAME_TYPE;
  [MCP_REQUEST_ARGUMENT_URI]?: MCP_REQUEST_ARGUMENT_URI_TYPE;
  [MCP_REQUEST_ID]?: MCP_REQUEST_ID_TYPE;
  [MCP_RESOURCE_PROTOCOL]?: MCP_RESOURCE_PROTOCOL_TYPE;
  [MCP_RESOURCE_URI]?: MCP_RESOURCE_URI_TYPE;
  [MCP_SERVER_NAME]?: MCP_SERVER_NAME_TYPE;
  [MCP_SERVER_TITLE]?: MCP_SERVER_TITLE_TYPE;
  [MCP_SERVER_VERSION]?: MCP_SERVER_VERSION_TYPE;
  [MCP_SESSION_ID]?: MCP_SESSION_ID_TYPE;
  [MCP_TOOL_NAME]?: MCP_TOOL_NAME_TYPE;
  [MCP_TOOL_RESULT_CONTENT]?: MCP_TOOL_RESULT_CONTENT_TYPE;
  [MCP_TOOL_RESULT_CONTENT_COUNT]?: MCP_TOOL_RESULT_CONTENT_COUNT_TYPE;
  [MCP_TOOL_RESULT_CONTENT_TYPE]?: MCP_TOOL_RESULT_CONTENT_TYPE_TYPE;
  [MCP_TOOL_RESULT_DATA_SIZE]?: MCP_TOOL_RESULT_DATA_SIZE_TYPE;
  [MCP_TOOL_RESULT_IS_ERROR]?: MCP_TOOL_RESULT_IS_ERROR_TYPE;
  [MCP_TOOL_RESULT_KEY_CONTENT]?: MCP_TOOL_RESULT_KEY_CONTENT_TYPE;
  [MCP_TOOL_RESULT_KEY_CONTENT_TYPE]?: MCP_TOOL_RESULT_KEY_CONTENT_TYPE_TYPE;
  [MCP_TOOL_RESULT_KEY_DATA_SIZE]?: MCP_TOOL_RESULT_KEY_DATA_SIZE_TYPE;
  [MCP_TOOL_RESULT_KEY_MIME_TYPE]?: MCP_TOOL_RESULT_KEY_MIME_TYPE_TYPE;
  [MCP_TOOL_RESULT_KEY_NAME]?: MCP_TOOL_RESULT_KEY_NAME_TYPE;
  [MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE]?: MCP_TOOL_RESULT_KEY_RESOURCE_MIME_TYPE_TYPE;
  [MCP_TOOL_RESULT_KEY_RESOURCE_URI]?: MCP_TOOL_RESULT_KEY_RESOURCE_URI_TYPE;
  [MCP_TOOL_RESULT_KEY_URI]?: MCP_TOOL_RESULT_KEY_URI_TYPE;
  [MCP_TOOL_RESULT_MIME_TYPE]?: MCP_TOOL_RESULT_MIME_TYPE_TYPE;
  [MCP_TOOL_RESULT_NAME]?: MCP_TOOL_RESULT_NAME_TYPE;
  [MCP_TOOL_RESULT_RESOURCE_MIME_TYPE]?: MCP_TOOL_RESULT_RESOURCE_MIME_TYPE_TYPE;
  [MCP_TOOL_RESULT_RESOURCE_URI]?: MCP_TOOL_RESULT_RESOURCE_URI_TYPE;
  [MCP_TOOL_RESULT_URI]?: MCP_TOOL_RESULT_URI_TYPE;
  [MCP_TRANSPORT]?: MCP_TRANSPORT_TYPE;
  [MDC_KEY]?: MDC_KEY_TYPE;
  [MESSAGING_BATCH_MESSAGE_COUNT]?: MESSAGING_BATCH_MESSAGE_COUNT_TYPE;
  [MESSAGING_CONVERSATION_ID]?: MESSAGING_CONVERSATION_ID_TYPE;
  [MESSAGING_DESTINATION]?: MESSAGING_DESTINATION_TYPE;
  [MESSAGING_DESTINATION_CONNECTION]?: MESSAGING_DESTINATION_CONNECTION_TYPE;
  [MESSAGING_DESTINATION_KIND]?: MESSAGING_DESTINATION_KIND_TYPE;
  [MESSAGING_DESTINATION_NAME]?: MESSAGING_DESTINATION_NAME_TYPE;
  [MESSAGING_DESTINATION_PARTITION_ID]?: MESSAGING_DESTINATION_PARTITION_ID_TYPE;
  [MESSAGING_KAFKA_MESSAGE_KEY]?: MESSAGING_KAFKA_MESSAGE_KEY_TYPE;
  [MESSAGING_KAFKA_MESSAGE_TOMBSTONE]?: MESSAGING_KAFKA_MESSAGE_TOMBSTONE_TYPE;
  [MESSAGING_KAFKA_OFFSET]?: MESSAGING_KAFKA_OFFSET_TYPE;
  [MESSAGING_MESSAGE_BODY_SIZE]?: MESSAGING_MESSAGE_BODY_SIZE_TYPE;
  [MESSAGING_MESSAGE_CONVERSATION_ID]?: MESSAGING_MESSAGE_CONVERSATION_ID_TYPE;
  [MESSAGING_MESSAGE_ENVELOPE_SIZE]?: MESSAGING_MESSAGE_ENVELOPE_SIZE_TYPE;
  [MESSAGING_MESSAGE_ID]?: MESSAGING_MESSAGE_ID_TYPE;
  [_MESSAGING_MESSAGE_ID]?: _MESSAGING_MESSAGE_ID_TYPE;
  [MESSAGING_MESSAGE_RECEIVE_LATENCY]?: MESSAGING_MESSAGE_RECEIVE_LATENCY_TYPE;
  [MESSAGING_MESSAGE_RETRY_COUNT]?: MESSAGING_MESSAGE_RETRY_COUNT_TYPE;
  [MESSAGING_OPERATION]?: MESSAGING_OPERATION_TYPE;
  [MESSAGING_OPERATION_NAME]?: MESSAGING_OPERATION_NAME_TYPE;
  [MESSAGING_OPERATION_TYPE]?: MESSAGING_OPERATION_TYPE_TYPE;
  [MESSAGING_PROTOCOL]?: MESSAGING_PROTOCOL_TYPE;
  [MESSAGING_PROTOCOL_VERSION]?: MESSAGING_PROTOCOL_VERSION_TYPE;
  [MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY]?: MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY_TYPE;
  [MESSAGING_RABBITMQ_ROUTING_KEY]?: MESSAGING_RABBITMQ_ROUTING_KEY_TYPE;
  [MESSAGING_SYSTEM]?: MESSAGING_SYSTEM_TYPE;
  [MESSAGING_URL]?: MESSAGING_URL_TYPE;
  [METHOD]?: METHOD_TYPE;
  [MIDDLEWARE_NAME]?: MIDDLEWARE_NAME_TYPE;
  [NAVIGATION_ORIGIN]?: NAVIGATION_ORIGIN_TYPE;
  [NAVIGATION_ROUTE_ID]?: NAVIGATION_ROUTE_ID_TYPE;
  [NAVIGATION_TYPE]?: NAVIGATION_TYPE_TYPE;
  [NEL_ELAPSED_TIME]?: NEL_ELAPSED_TIME_TYPE;
  [NEL_PHASE]?: NEL_PHASE_TYPE;
  [NEL_REFERRER]?: NEL_REFERRER_TYPE;
  [NEL_SAMPLING_FRACTION]?: NEL_SAMPLING_FRACTION_TYPE;
  [NEL_SAMPLING_FUNCTION]?: NEL_SAMPLING_FUNCTION_TYPE;
  [NEL_TYPE]?: NEL_TYPE_TYPE;
  [NETWORK_CONNECTION_EFFECTIVE_TYPE]?: NETWORK_CONNECTION_EFFECTIVE_TYPE_TYPE;
  [NETWORK_CONNECTION_RTT]?: NETWORK_CONNECTION_RTT_TYPE;
  [NETWORK_CONNECTION_TYPE]?: NETWORK_CONNECTION_TYPE_TYPE;
  [NETWORK_LOCAL_ADDRESS]?: NETWORK_LOCAL_ADDRESS_TYPE;
  [NETWORK_LOCAL_PORT]?: NETWORK_LOCAL_PORT_TYPE;
  [NETWORK_PEER_ADDRESS]?: NETWORK_PEER_ADDRESS_TYPE;
  [NETWORK_PEER_PORT]?: NETWORK_PEER_PORT_TYPE;
  [NETWORK_PROTOCOL_NAME]?: NETWORK_PROTOCOL_NAME_TYPE;
  [NETWORK_PROTOCOL_VERSION]?: NETWORK_PROTOCOL_VERSION_TYPE;
  [NETWORK_TRANSPORT]?: NETWORK_TRANSPORT_TYPE;
  [NETWORK_TYPE]?: NETWORK_TYPE_TYPE;
  [NET_HOST_IP]?: NET_HOST_IP_TYPE;
  [NET_HOST_NAME]?: NET_HOST_NAME_TYPE;
  [NET_HOST_PORT]?: NET_HOST_PORT_TYPE;
  [NET_PEER_IP]?: NET_PEER_IP_TYPE;
  [NET_PEER_NAME]?: NET_PEER_NAME_TYPE;
  [NET_PEER_PORT]?: NET_PEER_PORT_TYPE;
  [NET_PROTOCOL_NAME]?: NET_PROTOCOL_NAME_TYPE;
  [NET_PROTOCOL_VERSION]?: NET_PROTOCOL_VERSION_TYPE;
  [NET_SOCK_FAMILY]?: NET_SOCK_FAMILY_TYPE;
  [NET_SOCK_HOST_ADDR]?: NET_SOCK_HOST_ADDR_TYPE;
  [NET_SOCK_HOST_PORT]?: NET_SOCK_HOST_PORT_TYPE;
  [NET_SOCK_PEER_ADDR]?: NET_SOCK_PEER_ADDR_TYPE;
  [NET_SOCK_PEER_NAME]?: NET_SOCK_PEER_NAME_TYPE;
  [NET_SOCK_PEER_PORT]?: NET_SOCK_PEER_PORT_TYPE;
  [NET_TRANSPORT]?: NET_TRANSPORT_TYPE;
  [OS_BUILD]?: OS_BUILD_TYPE;
  [OS_BUILD_ID]?: OS_BUILD_ID_TYPE;
  [OS_DESCRIPTION]?: OS_DESCRIPTION_TYPE;
  [OS_KERNEL_VERSION]?: OS_KERNEL_VERSION_TYPE;
  [OS_NAME]?: OS_NAME_TYPE;
  [OS_RAW_DESCRIPTION]?: OS_RAW_DESCRIPTION_TYPE;
  [OS_ROOTED]?: OS_ROOTED_TYPE;
  [OS_THEME]?: OS_THEME_TYPE;
  [OS_TYPE]?: OS_TYPE_TYPE;
  [OS_VERSION]?: OS_VERSION_TYPE;
  [OTEL_KIND]?: OTEL_KIND_TYPE;
  [OTEL_SCOPE_NAME]?: OTEL_SCOPE_NAME_TYPE;
  [OTEL_SCOPE_VERSION]?: OTEL_SCOPE_VERSION_TYPE;
  [OTEL_STATUS_CODE]?: OTEL_STATUS_CODE_TYPE;
  [OTEL_STATUS_DESCRIPTION]?: OTEL_STATUS_DESCRIPTION_TYPE;
  [PARAMS_KEY]?: PARAMS_KEY_TYPE;
  [PERFORMANCE_ACTIVATIONSTART]?: PERFORMANCE_ACTIVATIONSTART_TYPE;
  [PERFORMANCE_TIMEORIGIN]?: PERFORMANCE_TIMEORIGIN_TYPE;
  [PORT]?: PORT_TYPE;
  [PREVIOUS_ROUTE]?: PREVIOUS_ROUTE_TYPE;
  [PROCESS_COMMAND_ARGS]?: PROCESS_COMMAND_ARGS_TYPE;
  [PROCESS_EXECUTABLE_NAME]?: PROCESS_EXECUTABLE_NAME_TYPE;
  [PROCESS_PID]?: PROCESS_PID_TYPE;
  [PROCESS_RUNTIME_DESCRIPTION]?: PROCESS_RUNTIME_DESCRIPTION_TYPE;
  [PROCESS_RUNTIME_ENGINE_NAME]?: PROCESS_RUNTIME_ENGINE_NAME_TYPE;
  [PROCESS_RUNTIME_ENGINE_VERSION]?: PROCESS_RUNTIME_ENGINE_VERSION_TYPE;
  [PROCESS_RUNTIME_NAME]?: PROCESS_RUNTIME_NAME_TYPE;
  [PROCESS_RUNTIME_VERSION]?: PROCESS_RUNTIME_VERSION_TYPE;
  [PROFILE_ID]?: PROFILE_ID_TYPE;
  [QUERY]?: QUERY_TYPE;
  [QUERY_KEY]?: QUERY_KEY_TYPE;
  [REACT_NATIVE_ARCHITECTURE]?: REACT_NATIVE_ARCHITECTURE_TYPE;
  [REACT_NATIVE_MODULE_CALL_COUNT]?: REACT_NATIVE_MODULE_CALL_COUNT_TYPE;
  [REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT]?: REACT_NATIVE_MODULE_CALL_DISTINCT_COUNT_TYPE;
  [REACT_NATIVE_MODULE_DURATION_MAX]?: REACT_NATIVE_MODULE_DURATION_MAX_TYPE;
  [REACT_NATIVE_MODULE_DURATION_TOTAL]?: REACT_NATIVE_MODULE_DURATION_TOTAL_TYPE;
  [REACT_NATIVE_MODULE_ERROR_COUNT]?: REACT_NATIVE_MODULE_ERROR_COUNT_TYPE;
  [REACT_NATIVE_MODULE_KIND]?: REACT_NATIVE_MODULE_KIND_TYPE;
  [REACT_NATIVE_MODULE_METHOD]?: REACT_NATIVE_MODULE_METHOD_TYPE;
  [REACT_NATIVE_MODULE_NAME]?: REACT_NATIVE_MODULE_NAME_TYPE;
  [REACT_NATIVE_MODULE_TOP_DURATION]?: REACT_NATIVE_MODULE_TOP_DURATION_TYPE;
  [REACT_NATIVE_MODULE_TOP_NAME]?: REACT_NATIVE_MODULE_TOP_NAME_TYPE;
  [REACT_VERSION]?: REACT_VERSION_TYPE;
  [REDIS_COMMAND]?: REDIS_COMMAND_TYPE;
  [REDIS_KEY]?: REDIS_KEY_TYPE;
  [RELEASE]?: RELEASE_TYPE;
  [REMIX_ACTION_FORM_DATA_KEY]?: REMIX_ACTION_FORM_DATA_KEY_TYPE;
  [REPLAYID]?: REPLAYID_TYPE;
  [REPLAY_ID]?: REPLAY_ID_TYPE;
  [RESOURCE_DEPLOYMENT_ENVIRONMENT]?: RESOURCE_DEPLOYMENT_ENVIRONMENT_TYPE;
  [RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME]?: RESOURCE_DEPLOYMENT_ENVIRONMENT_NAME_TYPE;
  [RESOURCE_RENDER_BLOCKING_STATUS]?: RESOURCE_RENDER_BLOCKING_STATUS_TYPE;
  [ROUTE]?: ROUTE_TYPE;
  [ROUTER_NAVIGATION_ORIGIN]?: ROUTER_NAVIGATION_ORIGIN_TYPE;
  [ROUTER_NAVIGATION_ROUTE_ID]?: ROUTER_NAVIGATION_ROUTE_ID_TYPE;
  [ROUTER_NAVIGATION_TYPE]?: ROUTER_NAVIGATION_TYPE_TYPE;
  [RPC_GRPC_STATUS_CODE]?: RPC_GRPC_STATUS_CODE_TYPE;
  [RPC_METHOD]?: RPC_METHOD_TYPE;
  [RPC_RESPONSE_STATUS_CODE]?: RPC_RESPONSE_STATUS_CODE_TYPE;
  [RPC_SERVICE]?: RPC_SERVICE_TYPE;
  [RPC_SYSTEM]?: RPC_SYSTEM_TYPE;
  [RPC_SYSTEM_NAME]?: RPC_SYSTEM_NAME_TYPE;
  [RUNTIME_BUILD]?: RUNTIME_BUILD_TYPE;
  [RUNTIME_NAME]?: RUNTIME_NAME_TYPE;
  [RUNTIME_RAW_DESCRIPTION]?: RUNTIME_RAW_DESCRIPTION_TYPE;
  [RUNTIME_VERSION]?: RUNTIME_VERSION_TYPE;
  [SCORE_KEY]?: SCORE_KEY_TYPE;
  [SCORE_RATIO_KEY]?: SCORE_RATIO_KEY_TYPE;
  [SCORE_TOTAL]?: SCORE_TOTAL_TYPE;
  [SCORE_WEIGHT_KEY]?: SCORE_WEIGHT_KEY_TYPE;
  [SENTRY_ACTION]?: SENTRY_ACTION_TYPE;
  [SENTRY_BROWSER_NAME]?: SENTRY_BROWSER_NAME_TYPE;
  [SENTRY_BROWSER_VERSION]?: SENTRY_BROWSER_VERSION_TYPE;
  [SENTRY_CANCELLATION_REASON]?: SENTRY_CANCELLATION_REASON_TYPE;
  [SENTRY_CATEGORY]?: SENTRY_CATEGORY_TYPE;
  [SENTRY_CLIENT_SAMPLE_RATE]?: SENTRY_CLIENT_SAMPLE_RATE_TYPE;
  [SENTRY_DESCRIPTION]?: SENTRY_DESCRIPTION_TYPE;
  [SENTRY_DIST]?: SENTRY_DIST_TYPE;
  [SENTRY_DOMAIN]?: SENTRY_DOMAIN_TYPE;
  [SENTRY_DSC_ENVIRONMENT]?: SENTRY_DSC_ENVIRONMENT_TYPE;
  [SENTRY_DSC_PROJECT_ID]?: SENTRY_DSC_PROJECT_ID_TYPE;
  [SENTRY_DSC_PUBLIC_KEY]?: SENTRY_DSC_PUBLIC_KEY_TYPE;
  [SENTRY_DSC_RELEASE]?: SENTRY_DSC_RELEASE_TYPE;
  [SENTRY_DSC_SAMPLED]?: SENTRY_DSC_SAMPLED_TYPE;
  [SENTRY_DSC_SAMPLE_RATE]?: SENTRY_DSC_SAMPLE_RATE_TYPE;
  [SENTRY_DSC_TRACE_ID]?: SENTRY_DSC_TRACE_ID_TYPE;
  [SENTRY_DSC_TRANSACTION]?: SENTRY_DSC_TRANSACTION_TYPE;
  [SENTRY_ENVIRONMENT]?: SENTRY_ENVIRONMENT_TYPE;
  [SENTRY_EVENT_SERIALIZED_BREADCRUMBS]?: SENTRY_EVENT_SERIALIZED_BREADCRUMBS_TYPE;
  [SENTRY_EVENT_SERIALIZED_CONTEXTS]?: SENTRY_EVENT_SERIALIZED_CONTEXTS_TYPE;
  [SENTRY_EVENT_SERIALIZED_EXTRA]?: SENTRY_EVENT_SERIALIZED_EXTRA_TYPE;
  [SENTRY_EVENT_SERIALIZED_META]?: SENTRY_EVENT_SERIALIZED_META_TYPE;
  [SENTRY_EXCLUSIVE_TIME]?: SENTRY_EXCLUSIVE_TIME_TYPE;
  [SENTRY_FRAMES_FROZEN]?: SENTRY_FRAMES_FROZEN_TYPE;
  [SENTRY_FRAMES_SLOW]?: SENTRY_FRAMES_SLOW_TYPE;
  [SENTRY_FRAMES_TOTAL]?: SENTRY_FRAMES_TOTAL_TYPE;
  [SENTRY_GRAPHQL_OPERATION]?: SENTRY_GRAPHQL_OPERATION_TYPE;
  [SENTRY_GROUP]?: SENTRY_GROUP_TYPE;
  [SENTRY_HTTP_PREFETCH]?: SENTRY_HTTP_PREFETCH_TYPE;
  [SENTRY_IDLE_SPAN_FINISH_REASON]?: SENTRY_IDLE_SPAN_FINISH_REASON_TYPE;
  [SENTRY_IS_LOCALHOST]?: SENTRY_IS_LOCALHOST_TYPE;
  [SENTRY_IS_REMOTE]?: SENTRY_IS_REMOTE_TYPE;
  [SENTRY_KIND]?: SENTRY_KIND_TYPE;
  [SENTRY_LINK_TYPE]?: SENTRY_LINK_TYPE_TYPE;
  [SENTRY_MAIN_THREAD]?: SENTRY_MAIN_THREAD_TYPE;
  [SENTRY_MESSAGE_PARAMETER_KEY]?: SENTRY_MESSAGE_PARAMETER_KEY_TYPE;
  [SENTRY_MESSAGE_TEMPLATE]?: SENTRY_MESSAGE_TEMPLATE_TYPE;
  [SENTRY_METRIC_SOURCE]?: SENTRY_METRIC_SOURCE_TYPE;
  [SENTRY_MOBILE]?: SENTRY_MOBILE_TYPE;
  [SENTRY_MODULE_KEY]?: SENTRY_MODULE_KEY_TYPE;
  [SENTRY_NEXTJS_SSR_FUNCTION_ROUTE]?: SENTRY_NEXTJS_SSR_FUNCTION_ROUTE_TYPE;
  [SENTRY_NEXTJS_SSR_FUNCTION_TYPE]?: SENTRY_NEXTJS_SSR_FUNCTION_TYPE_TYPE;
  [SENTRY_NORMALIZED_DB_QUERY]?: SENTRY_NORMALIZED_DB_QUERY_TYPE;
  [SENTRY_NORMALIZED_DB_QUERY_HASH]?: SENTRY_NORMALIZED_DB_QUERY_HASH_TYPE;
  [SENTRY_NORMALIZED_DESCRIPTION]?: SENTRY_NORMALIZED_DESCRIPTION_TYPE;
  [SENTRY_OBSERVED_TIMESTAMP_NANOS]?: SENTRY_OBSERVED_TIMESTAMP_NANOS_TYPE;
  [SENTRY_OP]?: SENTRY_OP_TYPE;
  [SENTRY_ORIGIN]?: SENTRY_ORIGIN_TYPE;
  [SENTRY_PAGELOAD_SPAN_ID]?: SENTRY_PAGELOAD_SPAN_ID_TYPE;
  [SENTRY_PLATFORM]?: SENTRY_PLATFORM_TYPE;
  [SENTRY_PROFILER_ID]?: SENTRY_PROFILER_ID_TYPE;
  [SENTRY_PROFILE_ID]?: SENTRY_PROFILE_ID_TYPE;
  [SENTRY_RELAY_INGRESS]?: SENTRY_RELAY_INGRESS_TYPE;
  [SENTRY_RELAY_PIPELINE]?: SENTRY_RELAY_PIPELINE_TYPE;
  [SENTRY_RELEASE]?: SENTRY_RELEASE_TYPE;
  [SENTRY_REPLAY_ID]?: SENTRY_REPLAY_ID_TYPE;
  [SENTRY_REPLAY_IS_BUFFERING]?: SENTRY_REPLAY_IS_BUFFERING_TYPE;
  [SENTRY_REPORT_EVENT]?: SENTRY_REPORT_EVENT_TYPE;
  [SENTRY_SDK_INTEGRATIONS]?: SENTRY_SDK_INTEGRATIONS_TYPE;
  [SENTRY_SDK_NAME]?: SENTRY_SDK_NAME_TYPE;
  [SENTRY_SDK_VERSION]?: SENTRY_SDK_VERSION_TYPE;
  [SENTRY_SEGMENT_ID]?: SENTRY_SEGMENT_ID_TYPE;
  [_SENTRY_SEGMENT_ID]?: _SENTRY_SEGMENT_ID_TYPE;
  [SENTRY_SEGMENT_NAME]?: SENTRY_SEGMENT_NAME_TYPE;
  [SENTRY_SEGMENT_NAME_SOURCE]?: SENTRY_SEGMENT_NAME_SOURCE_TYPE;
  [SENTRY_SERVER_SAMPLE_RATE]?: SENTRY_SERVER_SAMPLE_RATE_TYPE;
  [SENTRY_SOURCE]?: SENTRY_SOURCE_TYPE;
  [SENTRY_SPAN_SOURCE]?: SENTRY_SPAN_SOURCE_TYPE;
  [SENTRY_STATUS]?: SENTRY_STATUS_TYPE;
  [SENTRY_STATUS_CODE]?: SENTRY_STATUS_CODE_TYPE;
  [SENTRY_STATUS_MESSAGE]?: SENTRY_STATUS_MESSAGE_TYPE;
  [SENTRY_SVELTEKIT_NAVIGATION_FROM]?: SENTRY_SVELTEKIT_NAVIGATION_FROM_TYPE;
  [SENTRY_SVELTEKIT_NAVIGATION_TO]?: SENTRY_SVELTEKIT_NAVIGATION_TO_TYPE;
  [SENTRY_SVELTEKIT_NAVIGATION_TYPE]?: SENTRY_SVELTEKIT_NAVIGATION_TYPE_TYPE;
  [SENTRY_THREAD_ID]?: SENTRY_THREAD_ID_TYPE;
  [SENTRY_TIMESTAMP_SEQUENCE]?: SENTRY_TIMESTAMP_SEQUENCE_TYPE;
  [SENTRY_TRACE_LIFECYCLE]?: SENTRY_TRACE_LIFECYCLE_TYPE;
  [SENTRY_TRACE_PARENT_SPAN_ID]?: SENTRY_TRACE_PARENT_SPAN_ID_TYPE;
  [SENTRY_TRACE_STATUS]?: SENTRY_TRACE_STATUS_TYPE;
  [SENTRY_TRANSACTION]?: SENTRY_TRANSACTION_TYPE;
  [SENTRY_USER_EMAIL]?: SENTRY_USER_EMAIL_TYPE;
  [SENTRY_USER_GEO_CITY]?: SENTRY_USER_GEO_CITY_TYPE;
  [SENTRY_USER_GEO_COUNTRY_CODE]?: SENTRY_USER_GEO_COUNTRY_CODE_TYPE;
  [SENTRY_USER_GEO_REGION]?: SENTRY_USER_GEO_REGION_TYPE;
  [SENTRY_USER_GEO_SUBDIVISION]?: SENTRY_USER_GEO_SUBDIVISION_TYPE;
  [SENTRY_USER_ID]?: SENTRY_USER_ID_TYPE;
  [SENTRY_USER_IP]?: SENTRY_USER_IP_TYPE;
  [SENTRY_USER_USERNAME]?: SENTRY_USER_USERNAME_TYPE;
  [SERVER_ADDRESS]?: SERVER_ADDRESS_TYPE;
  [SERVER_NAME]?: SERVER_NAME_TYPE;
  [SERVER_PORT]?: SERVER_PORT_TYPE;
  [SERVICE_NAME]?: SERVICE_NAME_TYPE;
  [SERVICE_VERSION]?: SERVICE_VERSION_TYPE;
  [SESSION_ID]?: SESSION_ID_TYPE;
  [STALL_PERCENTAGE]?: STALL_PERCENTAGE_TYPE;
  [STALL_TOTAL_TIME]?: STALL_TOTAL_TIME_TYPE;
  [STARLETTE_MIDDLEWARE_NAME]?: STARLETTE_MIDDLEWARE_NAME_TYPE;
  [STARLITE_MIDDLEWARE_NAME]?: STARLITE_MIDDLEWARE_NAME_TYPE;
  [STATE_TYPE]?: STATE_TYPE_TYPE;
  [SUBPROCESS_PID]?: SUBPROCESS_PID_TYPE;
  [SVELTEKIT_LOAD_ENVIRONMENT]?: SVELTEKIT_LOAD_ENVIRONMENT_TYPE;
  [SVELTEKIT_LOAD_NODE_ID]?: SVELTEKIT_LOAD_NODE_ID_TYPE;
  [SVELTEKIT_LOAD_NODE_TYPE]?: SVELTEKIT_LOAD_NODE_TYPE_TYPE;
  [SVELTEKIT_TRACING_ORIGINAL_NAME]?: SVELTEKIT_TRACING_ORIGINAL_NAME_TYPE;
  [THREAD_ID]?: THREAD_ID_TYPE;
  [THREAD_NAME]?: THREAD_NAME_TYPE;
  [TIMBER_TAG]?: TIMBER_TAG_TYPE;
  [TIME_TO_FULL_DISPLAY]?: TIME_TO_FULL_DISPLAY_TYPE;
  [TIME_TO_INITIAL_DISPLAY]?: TIME_TO_INITIAL_DISPLAY_TYPE;
  [TRANSACTION]?: TRANSACTION_TYPE;
  [TRPC_PROCEDURE_PATH]?: TRPC_PROCEDURE_PATH_TYPE;
  [TRPC_PROCEDURE_TYPE]?: TRPC_PROCEDURE_TYPE_TYPE;
  [TTFB]?: TTFB_TYPE;
  [TTFB_REQUESTTIME]?: TTFB_REQUESTTIME_TYPE;
  [TURBO_MODULES_TOTAL_CALL_COUNT]?: TURBO_MODULES_TOTAL_CALL_COUNT_TYPE;
  [TURBO_MODULES_TOTAL_DURATION_MS]?: TURBO_MODULES_TOTAL_DURATION_MS_TYPE;
  [TURBO_MODULES_TOTAL_ERROR_COUNT]?: TURBO_MODULES_TOTAL_ERROR_COUNT_TYPE;
  [TURBO_MODULES_UNIQUE_METHODS]?: TURBO_MODULES_UNIQUE_METHODS_TYPE;
  [TURBO_MODULE_ARCH]?: TURBO_MODULE_ARCH_TYPE;
  [TURBO_MODULE_METHOD]?: TURBO_MODULE_METHOD_TYPE;
  [TURBO_MODULE_NAME]?: TURBO_MODULE_NAME_TYPE;
  [TURBO_MODULE_TOP_MODULE]?: TURBO_MODULE_TOP_MODULE_TYPE;
  [TURBO_MODULE_TOP_MODULE_DURATION_MS]?: TURBO_MODULE_TOP_MODULE_DURATION_MS_TYPE;
  [TURBO_MODULE_TOTAL_CALL_COUNT]?: TURBO_MODULE_TOTAL_CALL_COUNT_TYPE;
  [TURBO_MODULE_TOTAL_DURATION_MS]?: TURBO_MODULE_TOTAL_DURATION_MS_TYPE;
  [TURBO_MODULE_TOTAL_ERROR_COUNT]?: TURBO_MODULE_TOTAL_ERROR_COUNT_TYPE;
  [TURBO_MODULE_UNIQUE_METHODS]?: TURBO_MODULE_UNIQUE_METHODS_TYPE;
  [TYPE]?: TYPE_TYPE;
  [UI_COMPONENT_NAME]?: UI_COMPONENT_NAME_TYPE;
  [UI_CONTRIBUTES_TO_TTFD]?: UI_CONTRIBUTES_TO_TTFD_TYPE;
  [UI_CONTRIBUTES_TO_TTID]?: UI_CONTRIBUTES_TO_TTID_TYPE;
  [UI_ELEMENT_HEIGHT]?: UI_ELEMENT_HEIGHT_TYPE;
  [UI_ELEMENT_ID]?: UI_ELEMENT_ID_TYPE;
  [UI_ELEMENT_IDENTIFIER]?: UI_ELEMENT_IDENTIFIER_TYPE;
  [UI_ELEMENT_LOAD_TIME]?: UI_ELEMENT_LOAD_TIME_TYPE;
  [UI_ELEMENT_PAINT_TYPE]?: UI_ELEMENT_PAINT_TYPE_TYPE;
  [UI_ELEMENT_RENDER_TIME]?: UI_ELEMENT_RENDER_TIME_TYPE;
  [UI_ELEMENT_TYPE]?: UI_ELEMENT_TYPE_TYPE;
  [UI_ELEMENT_URL]?: UI_ELEMENT_URL_TYPE;
  [UI_ELEMENT_WIDTH]?: UI_ELEMENT_WIDTH_TYPE;
  [URL]?: URL_TYPE;
  [URL_DOMAIN]?: URL_DOMAIN_TYPE;
  [URL_FRAGMENT]?: URL_FRAGMENT_TYPE;
  [URL_FULL]?: URL_FULL_TYPE;
  [URL_PATH]?: URL_PATH_TYPE;
  [URL_PATH_PARAMETER_KEY]?: URL_PATH_PARAMETER_KEY_TYPE;
  [URL_PATH_PARAMS_KEY]?: URL_PATH_PARAMS_KEY_TYPE;
  [URL_PORT]?: URL_PORT_TYPE;
  [URL_QUERY]?: URL_QUERY_TYPE;
  [URL_SAME_ORIGIN]?: URL_SAME_ORIGIN_TYPE;
  [URL_SCHEME]?: URL_SCHEME_TYPE;
  [URL_TEMPLATE]?: URL_TEMPLATE_TYPE;
  [USER_AGENT_ORIGINAL]?: USER_AGENT_ORIGINAL_TYPE;
  [USER_EMAIL]?: USER_EMAIL_TYPE;
  [USER_FULL_NAME]?: USER_FULL_NAME_TYPE;
  [USER_GEO_CITY]?: USER_GEO_CITY_TYPE;
  [USER_GEO_COUNTRY_CODE]?: USER_GEO_COUNTRY_CODE_TYPE;
  [USER_GEO_REGION]?: USER_GEO_REGION_TYPE;
  [USER_GEO_SUBDIVISION]?: USER_GEO_SUBDIVISION_TYPE;
  [USER_HASH]?: USER_HASH_TYPE;
  [USER_ID]?: USER_ID_TYPE;
  [USER_IP_ADDRESS]?: USER_IP_ADDRESS_TYPE;
  [USER_NAME]?: USER_NAME_TYPE;
  [USER_ROLES]?: USER_ROLES_TYPE;
  [VERCEL_AI_TELEMETRY_METADATA_KEY]?: VERCEL_AI_TELEMETRY_METADATA_KEY_TYPE;
  [VERCEL_BRANCH]?: VERCEL_BRANCH_TYPE;
  [VERCEL_BUILD_ID]?: VERCEL_BUILD_ID_TYPE;
  [VERCEL_DEPLOYMENT_ID]?: VERCEL_DEPLOYMENT_ID_TYPE;
  [VERCEL_DESTINATION]?: VERCEL_DESTINATION_TYPE;
  [VERCEL_EDGE_TYPE]?: VERCEL_EDGE_TYPE_TYPE;
  [VERCEL_ENTRYPOINT]?: VERCEL_ENTRYPOINT_TYPE;
  [VERCEL_EXECUTION_REGION]?: VERCEL_EXECUTION_REGION_TYPE;
  [VERCEL_ID]?: VERCEL_ID_TYPE;
  [VERCEL_JA3_DIGEST]?: VERCEL_JA3_DIGEST_TYPE;
  [VERCEL_JA4_DIGEST]?: VERCEL_JA4_DIGEST_TYPE;
  [VERCEL_LOG_TYPE]?: VERCEL_LOG_TYPE_TYPE;
  [VERCEL_PATH]?: VERCEL_PATH_TYPE;
  [VERCEL_PROJECT_ID]?: VERCEL_PROJECT_ID_TYPE;
  [VERCEL_PROJECT_NAME]?: VERCEL_PROJECT_NAME_TYPE;
  [VERCEL_PROXY_CACHE_ID]?: VERCEL_PROXY_CACHE_ID_TYPE;
  [VERCEL_PROXY_CLIENT_IP]?: VERCEL_PROXY_CLIENT_IP_TYPE;
  [VERCEL_PROXY_HOST]?: VERCEL_PROXY_HOST_TYPE;
  [VERCEL_PROXY_LAMBDA_REGION]?: VERCEL_PROXY_LAMBDA_REGION_TYPE;
  [VERCEL_PROXY_METHOD]?: VERCEL_PROXY_METHOD_TYPE;
  [VERCEL_PROXY_PATH]?: VERCEL_PROXY_PATH_TYPE;
  [VERCEL_PROXY_PATH_TYPE]?: VERCEL_PROXY_PATH_TYPE_TYPE;
  [VERCEL_PROXY_PATH_TYPE_VARIANT]?: VERCEL_PROXY_PATH_TYPE_VARIANT_TYPE;
  [VERCEL_PROXY_REFERER]?: VERCEL_PROXY_REFERER_TYPE;
  [VERCEL_PROXY_REGION]?: VERCEL_PROXY_REGION_TYPE;
  [VERCEL_PROXY_RESPONSE_BYTE_SIZE]?: VERCEL_PROXY_RESPONSE_BYTE_SIZE_TYPE;
  [VERCEL_PROXY_SCHEME]?: VERCEL_PROXY_SCHEME_TYPE;
  [VERCEL_PROXY_STATUS_CODE]?: VERCEL_PROXY_STATUS_CODE_TYPE;
  [VERCEL_PROXY_TIMESTAMP]?: VERCEL_PROXY_TIMESTAMP_TYPE;
  [VERCEL_PROXY_USER_AGENT]?: VERCEL_PROXY_USER_AGENT_TYPE;
  [VERCEL_PROXY_VERCEL_CACHE]?: VERCEL_PROXY_VERCEL_CACHE_TYPE;
  [VERCEL_PROXY_VERCEL_ID]?: VERCEL_PROXY_VERCEL_ID_TYPE;
  [VERCEL_PROXY_WAF_ACTION]?: VERCEL_PROXY_WAF_ACTION_TYPE;
  [VERCEL_PROXY_WAF_RULE_ID]?: VERCEL_PROXY_WAF_RULE_ID_TYPE;
  [VERCEL_REQUEST_ID]?: VERCEL_REQUEST_ID_TYPE;
  [VERCEL_SOURCE]?: VERCEL_SOURCE_TYPE;
  [VERCEL_STATUS_CODE]?: VERCEL_STATUS_CODE_TYPE;
} & Record<string, AttributeValue | undefined>;
